var _defineProperty = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _get = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");
var _assertThisInitialized = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
var _construct = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");
var _slicedToArray = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/Users/sdm-mac-002/Imad/bo/bo-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e345) { throw _e345; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e346) { didErr = true; err = _e346; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
/*!
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function (t) {
  var e = t["en"] = t["en"] || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "%0 of %1": "%0 of %1",
    "Block quote": "Block quote",
    Bold: "Bold",
    "Bulleted List": "Bulleted List",
    Cancel: "Cancel",
    "Cannot upload file:": "Cannot upload file:",
    "Centered image": "Centered image",
    "Change image text alternative": "Change image text alternative",
    "Choose heading": "Choose heading",
    Column: "Column",
    "Could not insert image at the current position.": "Could not insert image at the current position.",
    "Could not obtain resized image URL.": "Could not obtain resized image URL.",
    "Decrease indent": "Decrease indent",
    "Delete column": "Delete column",
    "Delete row": "Delete row",
    Downloadable: "Downloadable",
    "Dropdown toolbar": "Dropdown toolbar",
    "Edit link": "Edit link",
    "Editor toolbar": "Editor toolbar",
    "Enter image caption": "Enter image caption",
    "Full size image": "Full size image",
    "Header column": "Header column",
    "Header row": "Header row",
    Heading: "Heading",
    "Heading 1": "Heading 1",
    "Heading 2": "Heading 2",
    "Heading 3": "Heading 3",
    "Heading 4": "Heading 4",
    "Heading 5": "Heading 5",
    "Heading 6": "Heading 6",
    "Image resize list": "Image resize list",
    "Image toolbar": "Image toolbar",
    "image widget": "image widget",
    "Increase indent": "Increase indent",
    "Insert column left": "Insert column left",
    "Insert column right": "Insert column right",
    "Insert image": "Insert image",
    "Insert image or file": "Insert image or file",
    "Insert media": "Insert media",
    "Insert paragraph after block": "Insert paragraph after block",
    "Insert paragraph before block": "Insert paragraph before block",
    "Insert row above": "Insert row above",
    "Insert row below": "Insert row below",
    "Insert table": "Insert table",
    "Inserting image failed": "Inserting image failed",
    Italic: "Italic",
    "Left aligned image": "Left aligned image",
    Link: "Link",
    "Link URL": "Link URL",
    "Media URL": "Media URL",
    "media widget": "media widget",
    "Merge cell down": "Merge cell down",
    "Merge cell left": "Merge cell left",
    "Merge cell right": "Merge cell right",
    "Merge cell up": "Merge cell up",
    "Merge cells": "Merge cells",
    Next: "Next",
    "Numbered List": "Numbered List",
    "Open in a new tab": "Open in a new tab",
    "Open link in new tab": "Open link in new tab",
    Original: "Original",
    Paragraph: "Paragraph",
    "Paste the media URL in the input.": "Paste the media URL in the input.",
    Previous: "Previous",
    Redo: "Redo",
    "Resize image": "Resize image",
    "Resize image to %0": "Resize image to %0",
    "Resize image to the original size": "Resize image to the original size",
    "Rich Text Editor": "Rich Text Editor",
    "Rich Text Editor, %0": "Rich Text Editor, %0",
    "Right aligned image": "Right aligned image",
    Row: "Row",
    Save: "Save",
    "Select all": "Select all",
    "Select column": "Select column",
    "Select row": "Select row",
    "Selecting resized image failed": "Selecting resized image failed",
    "Show more items": "Show more items",
    "Side image": "Side image",
    "Split cell horizontally": "Split cell horizontally",
    "Split cell vertically": "Split cell vertically",
    "Table toolbar": "Table toolbar",
    "Text alternative": "Text alternative",
    "The URL must not be empty.": "The URL must not be empty.",
    "This link has no URL": "This link has no URL",
    "This media URL is not supported.": "This media URL is not supported.",
    "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.",
    Undo: "Undo",
    Unlink: "Unlink",
    "Upload failed": "Upload failed",
    "Upload in progress": "Upload in progress",
    "Widget toolbar": "Widget toolbar"
  });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));
(function t(e, n) {
  if (typeof exports === "object" && typeof module === "object") module.exports = n();else if (typeof define === "function" && define.amd) define([], n);else if (typeof exports === "object") exports["ClassicEditor"] = n();else e["ClassicEditor"] = n();
})(window, function () {
  return function (t) {
    var e = {};
    function n(o) {
      if (e[o]) {
        return e[o].exports;
      }
      var i = e[o] = {
        i: o,
        l: false,
        exports: {}
      };
      t[o].call(i.exports, i, i.exports, n);
      i.l = true;
      return i.exports;
    }
    n.m = t;
    n.c = e;
    n.d = function (t, e, o) {
      if (!n.o(t, e)) {
        Object.defineProperty(t, e, {
          enumerable: true,
          get: o
        });
      }
    };
    n.r = function (t) {
      if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        });
      }
      Object.defineProperty(t, "__esModule", {
        value: true
      });
    };
    n.t = function (t, e) {
      if (e & 1) t = n(t);
      if (e & 8) return t;
      if (e & 4 && typeof t === "object" && t && t.__esModule) return t;
      var o = Object.create(null);
      n.r(o);
      Object.defineProperty(o, "default", {
        enumerable: true,
        value: t
      });
      if (e & 2 && typeof t != "string") for (var i in t) n.d(o, i, function (e) {
        return t[e];
      }.bind(null, i));
      return o;
    };
    n.n = function (t) {
      var e = t && t.__esModule ? function e() {
        return t["default"];
      } : function e() {
        return t;
      };
      n.d(e, "a", e);
      return e;
    };
    n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    };
    n.p = "";
    return n(n.s = 59);
  }([function (t, e, n) {
    "use strict";

    n.d(e, "a", function () {
      return i;
    });
    n.d(e, "c", function () {
      return r;
    });
    n.d(e, "b", function () {
      return s;
    });
    var o = "https://ckeditor.com/docs/ckeditor5/latest/framework/guides/support/error-codes.html";
    var i = /*#__PURE__*/function (_Error) {
      _inherits(i, _Error);
      function i(t, e, n) {
        var _this;
        _classCallCheck(this, i);
        var o = "".concat(t).concat(n ? " ".concat(JSON.stringify(n)) : "").concat(a(t));
        _this = _possibleConstructorReturn(this, _getPrototypeOf(i).call(this, o));
        _this.name = "CKEditorError";
        _this.context = e;
        _this.data = n;
        return _this;
      }
      _createClass(i, [{
        key: "is",
        value: function is(t) {
          return t === "CKEditorError";
        }
      }], [{
        key: "rethrowUnexpectedError",
        value: function rethrowUnexpectedError(t, e) {
          if (t.is && t.is("CKEditorError")) {
            throw t;
          }
          var n = new i(t.message, e);
          n.stack = t.stack;
          throw n;
        }
      }]);
      return i;
    }(_wrapNativeSuper(Error));
    function r(t, e) {
      var _console;
      (_console = console).warn.apply(_console, _toConsumableArray(c(t, e)));
    }
    function s(t, e) {
      var _console2;
      (_console2 = console).error.apply(_console2, _toConsumableArray(c(t, e)));
    }
    function a(t) {
      return "\nRead more: ".concat(o, "#error-").concat(t);
    }
    function c(t, e) {
      var n = a(t);
      return e ? [t, e, n] : [t, n];
    }
  }, function (t, e, n) {
    "use strict";

    var o = function t() {
      var e;
      return function t() {
        if (typeof e === "undefined") {
          e = Boolean(window && document && document.all && !window.atob);
        }
        return e;
      };
    }();
    var i = function t() {
      var e = {};
      return function t(n) {
        if (typeof e[n] === "undefined") {
          var o = document.querySelector(n);
          if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) {
            try {
              o = o.contentDocument.head;
            } catch (t) {
              o = null;
            }
          }
          e[n] = o;
        }
        return e[n];
      };
    }();
    var r = [];
    function s(t) {
      var e = -1;
      for (var n = 0; n < r.length; n++) {
        if (r[n].identifier === t) {
          e = n;
          break;
        }
      }
      return e;
    }
    function a(t, e) {
      var n = {};
      var o = [];
      for (var i = 0; i < t.length; i++) {
        var a = t[i];
        var c = e.base ? a[0] + e.base : a[0];
        var l = n[c] || 0;
        var d = "".concat(c, " ").concat(l);
        n[c] = l + 1;
        var u = s(d);
        var h = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        if (u !== -1) {
          r[u].references++;
          r[u].updater(h);
        } else {
          r.push({
            identifier: d,
            updater: g(h, e),
            references: 1
          });
        }
        o.push(d);
      }
      return o;
    }
    function c(t) {
      var e = document.createElement("style");
      var o = t.attributes || {};
      if (typeof o.nonce === "undefined") {
        var r = true ? n.nc : undefined;
        if (r) {
          o.nonce = r;
        }
      }
      Object.keys(o).forEach(function (t) {
        e.setAttribute(t, o[t]);
      });
      if (typeof t.insert === "function") {
        t.insert(e);
      } else {
        var s = i(t.insert || "head");
        if (!s) {
          throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        }
        s.appendChild(e);
      }
      return e;
    }
    function l(t) {
      if (t.parentNode === null) {
        return false;
      }
      t.parentNode.removeChild(t);
    }
    var d = function t() {
      var e = [];
      return function t(n, o) {
        e[n] = o;
        return e.filter(Boolean).join("\n");
      };
    }();
    function u(t, e, n, o) {
      var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
      if (t.styleSheet) {
        t.styleSheet.cssText = d(e, i);
      } else {
        var r = document.createTextNode(i);
        var s = t.childNodes;
        if (s[e]) {
          t.removeChild(s[e]);
        }
        if (s.length) {
          t.insertBefore(r, s[e]);
        } else {
          t.appendChild(r);
        }
      }
    }
    function h(t, e, n) {
      var o = n.css;
      var i = n.media;
      var r = n.sourceMap;
      if (i) {
        t.setAttribute("media", i);
      } else {
        t.removeAttribute("media");
      }
      if (r && typeof btoa !== "undefined") {
        o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */");
      }
      if (t.styleSheet) {
        t.styleSheet.cssText = o;
      } else {
        while (t.firstChild) {
          t.removeChild(t.firstChild);
        }
        t.appendChild(document.createTextNode(o));
      }
    }
    var f = null;
    var m = 0;
    function g(t, e) {
      var n;
      var o;
      var i;
      if (e.singleton) {
        var r = m++;
        n = f || (f = c(e));
        o = u.bind(null, n, r, false);
        i = u.bind(null, n, r, true);
      } else {
        n = c(e);
        o = h.bind(null, n, e);
        i = function t() {
          l(n);
        };
      }
      o(t);
      return function e(n) {
        if (n) {
          if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) {
            return;
          }
          o(t = n);
        } else {
          i();
        }
      };
    }
    t.exports = function (t, e) {
      e = e || {};
      if (!e.singleton && typeof e.singleton !== "boolean") {
        e.singleton = o();
      }
      t = t || [];
      var n = a(t, e);
      return function t(o) {
        o = o || [];
        if (Object.prototype.toString.call(o) !== "[object Array]") {
          return;
        }
        for (var i = 0; i < n.length; i++) {
          var c = n[i];
          var l = s(c);
          r[l].references--;
        }
        var d = a(o, e);
        for (var u = 0; u < n.length; u++) {
          var h = n[u];
          var f = s(h);
          if (r[f].references === 0) {
            r[f].updater();
            r.splice(f, 1);
          }
        }
        n = d;
      };
    };
  }, function (t, e, n) {
    "use strict";

    function o(t, e) {
      return c(t) || a(t, e) || r(t, e) || i();
    }
    function i() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function r(t, e) {
      if (!t) return;
      if (typeof t === "string") return s(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      if (n === "Object" && t.constructor) n = t.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(t);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(t, e);
    }
    function s(t, e) {
      if (e == null || e > t.length) e = t.length;
      for (var n = 0, o = new Array(e); n < e; n++) {
        o[n] = t[n];
      }
      return o;
    }
    function a(t, e) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(t))) return;
      var n = [];
      var o = true;
      var i = false;
      var r = undefined;
      try {
        for (var s = t[Symbol.iterator](), a; !(o = (a = s.next()).done); o = true) {
          n.push(a.value);
          if (e && n.length === e) break;
        }
      } catch (t) {
        i = true;
        r = t;
      } finally {
        try {
          if (!o && s["return"] != null) s["return"]();
        } finally {
          if (i) throw r;
        }
      }
      return n;
    }
    function c(t) {
      if (Array.isArray(t)) return t;
    }
    t.exports = function t(e) {
      var n = o(e, 4),
        i = n[1],
        r = n[3];
      if (typeof btoa === "function") {
        var s = btoa(unescape(encodeURIComponent(JSON.stringify(r))));
        var a = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s);
        var c = "/*# ".concat(a, " */");
        var l = r.sources.map(function (t) {
          return "/*# sourceURL=".concat(r.sourceRoot || "").concat(t, " */");
        });
        return [i].concat(l).concat([c]).join("\n");
      }
      return [i].join("\n");
    };
  }, function (t, e, n) {
    "use strict";

    t.exports = function (t) {
      var e = [];
      e.toString = function e() {
        return this.map(function (e) {
          var n = t(e);
          if (e[2]) {
            return "@media ".concat(e[2], " {").concat(n, "}");
          }
          return n;
        }).join("");
      };
      e.i = function (t, n, o) {
        if (typeof t === "string") {
          t = [[null, t, ""]];
        }
        var i = {};
        if (o) {
          for (var r = 0; r < this.length; r++) {
            var s = this[r][0];
            if (s != null) {
              i[s] = true;
            }
          }
        }
        for (var a = 0; a < t.length; a++) {
          var c = [].concat(t[a]);
          if (o && i[c[0]]) {
            continue;
          }
          if (n) {
            if (!c[2]) {
              c[2] = n;
            } else {
              c[2] = "".concat(n, " and ").concat(c[2]);
            }
          }
          e.push(c);
        }
      };
      return e;
    };
  },, function (t, e, n) {
    "use strict";

    var o = n(9);
    var i = typeof self == "object" && self && self.Object === Object && self;
    var r = o["a"] || i || Function("return this")();
    e["a"] = r;
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(5);
      var i = n(58);
      var r = typeof exports == "object" && exports && !exports.nodeType && exports;
      var s = r && typeof t == "object" && t && !t.nodeType && t;
      var a = s && s.exports === r;
      var c = a ? o["a"].Buffer : undefined;
      var l = c ? c.isBuffer : undefined;
      var d = l || i["a"];
      e["a"] = d;
    }).call(this, n(11)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(9);
      var i = typeof exports == "object" && exports && !exports.nodeType && exports;
      var r = i && typeof t == "object" && t && !t.nodeType && t;
      var s = r && r.exports === i;
      var a = s && o["a"].process;
      var c = function () {
        try {
          var t = r && r.require && r.require("util").types;
          if (t) {
            return t;
          }
          return a && a.binding && a.binding("util");
        } catch (t) {}
      }();
      e["a"] = c;
    }).call(this, n(11)(t));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var e = n(0);
      var o = "24.0.0";
      var i = typeof window === "object" ? window : t;
      if (i.CKEDITOR_VERSION) {
        throw new e["a"]("ckeditor-duplicated-modules", null);
      } else {
        i.CKEDITOR_VERSION = o;
      }
    }).call(this, n(57));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var n = typeof t == "object" && t && t.Object === Object && t;
      e["a"] = n;
    }).call(this, n(57));
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var o = n(5);
      var i = typeof exports == "object" && exports && !exports.nodeType && exports;
      var r = i && typeof t == "object" && t && !t.nodeType && t;
      var s = r && r.exports === i;
      var a = s ? o["a"].Buffer : undefined,
        c = a ? a.allocUnsafe : undefined;
      function l(t, e) {
        if (e) {
          return t.slice();
        }
        var n = t.length,
          o = c ? c(n) : new t.constructor(n);
        t.copy(o);
        return o;
      }
      e["a"] = l;
    }).call(this, n(11)(t));
  }, function (t, e) {
    t.exports = function (t) {
      if (!t.webpackPolyfill) {
        var e = Object.create(t);
        if (!e.children) e.children = [];
        Object.defineProperty(e, "loaded", {
          enumerable: true,
          get: function get() {
            return e.l;
          }
        });
        Object.defineProperty(e, "id", {
          enumerable: true,
          get: function get() {
            return e.i;
          }
        });
        Object.defineProperty(e, "exports", {
          enumerable: true
        });
        e.webpackPolyfill = 1;
      }
      return e;
    };
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-placeholder:before,.ck .ck-placeholder:before{content:attr(data-placeholder);pointer-events:none}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-placeholder:before,.ck .ck-placeholder:before{cursor:text;color:var(--ck-color-engine-placeholder-text)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"],
      names: [],
      mappings: "AAQC,qDACC,8BAA+B,CAG/B,mBACD,CAKA,wCACC,YACD,CCbA,qDACC,WAAY,CACZ,6CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\t&::before {\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-hidden{display:none!important}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{box-sizing:border-box;width:auto;height:auto;position:static}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#c4c4c4;--ck-color-base-action:#61b045;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#198cf0;--ck-color-base-active-focus:#0e7fe1;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:208,79%,51%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#bcdefb;--ck-color-focus-disabled-shadow:rgba(119,186,248,0.3);--ck-color-focus-error-shadow:rgba(255,64,31,0.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,0.15);--ck-color-shadow-drop-active:rgba(0,0,0,0.2);--ck-color-shadow-inner:rgba(0,0,0,0.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#e6e6e6;--ck-color-button-default-active-background:#d9d9d9;--ck-color-button-default-active-shadow:#bfbfbf;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#dedede;--ck-color-button-on-hover-background:#c4c4c4;--ck-color-button-on-active-background:#bababa;--ck-color-button-on-active-shadow:#a1a1a1;--ck-color-button-on-disabled-background:#dedede;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#579e3d;--ck-color-button-action-active-background:#53973b;--ck-color-button-action-active-shadow:#498433;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#b0b0b0;--ck-color-switch-button-off-hover-background:#a3a3a3;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#579e3d;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,0.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:#c7c7c7;--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:#c7c7c7;--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-base-active);--ck-color-list-button-on-background-focus:var(--ck-color-base-active-focus);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-foreground);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,177,255,0.1);--ck-color-link-fake-selection:rgba(31,177,255,0.3);--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck.ck-reset,.ck.ck-reset_all,.ck.ck-reset_all *{margin:0;padding:0;border:0;background:transparent;text-decoration:none;vertical-align:middle;transition:none;word-wrap:break-word}.ck.ck-reset_all,.ck.ck-reset_all *{border-collapse:collapse;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);color:var(--ck-color-text);text-align:left;white-space:nowrap;cursor:auto;float:none}.ck.ck-reset_all .ck-rtl *{text-align:right}.ck.ck-reset_all iframe{vertical-align:inherit}.ck.ck-reset_all textarea{white-space:pre-wrap}.ck.ck-reset_all input[type=password],.ck.ck-reset_all input[type=text],.ck.ck-reset_all textarea{cursor:text}.ck.ck-reset_all input[type=password][disabled],.ck.ck-reset_all input[type=text][disabled],.ck.ck-reset_all textarea[disabled]{cursor:default}.ck.ck-reset_all fieldset{padding:10px;border:2px groove #dfdee3}.ck.ck-reset_all button::-moz-focus-inner{padding:0;border:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"],
      names: [],
      mappings: "AAQA,WAGC,sBACD,CCPA,iDAGC,qBAAsB,CACtB,UAAW,CACX,WAAY,CACZ,eACD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAgD,CAChD,8BAAmD,CACnD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAmD,CACnD,oCAAuD,CACvD,6BAAkD,CAIlD,+CAAwD,CACxD,qEAA+E,CAC/E,qCAAwD,CACxD,sDAA8D,CAC9D,iDAAyD,CACzD,yCAAqD,CACrD,uCAAsD,CACtD,6CAA0D,CAC1D,uCAAsD,CAItD,gDAAuD,CACvD,kDAA+D,CAC/D,mDAAgE,CAChE,+CAA6D,CAC7D,yDAA8D,CAE9D,uCAAuD,CACvD,6CAA4D,CAC5D,8CAA4D,CAC5D,0CAAyD,CACzD,gDAA8D,CAE9D,+DAAsE,CACtE,iDAAkE,CAClE,kDAAkE,CAClE,8CAA+D,CAC/D,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA4D,CAC5D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAmE,CACnE,yEAA8E,CAC9E,qDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,+BAAiD,CACjD,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,wCAAwD,CACxD,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,gEAAuE,CACvE,4EAAiF,CACjF,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,wDAAmE,CACnE,mDAAgE,CCpGhE,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJoGD,CI9FA,iDAIC,QAAS,CACT,SAAU,CACV,QAAS,CACT,sBAAuB,CACvB,oBAAqB,CACrB,qBAAsB,CACtB,eAAgB,CAGhB,oBACD,CAKA,oCAGC,wBAAyB,CACzB,iGAAkG,CAClG,0BAA2B,CAC3B,eAAgB,CAChB,kBAAmB,CACnB,WAAY,CACZ,UACD,CAGC,2BACC,gBACD,CAEA,wBAEC,sBACD,CAEA,0BACC,oBACD,CAEA,kGAGC,WACD,CAEA,gIAGC,cACD,CAEA,0BACC,YAAa,CACb,yBACD,CAEA,0CAEC,SAAU,CACV,QACD,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 44%, 48%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(208, 88%, 52%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(208, 88%, 47%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t208, 79%, 51%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(207, 89%, 86%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 90%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 85%);\n\t--ck-color-button-default-active-shadow: \t\t\t\t\thsl(0, 0%, 75%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(0, 0%, 87%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(0, 0%, 77%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(0, 0%, 73%);\n\t--ck-color-button-on-active-shadow: \t\t\t\t\t\thsl(0, 0%, 63%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(0, 0%, 87%);\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 44%, 41%);\n\t--ck-color-button-action-active-shadow: \t\t\t\t\thsl(104, 44%, 36%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 69%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 64%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 44%, 43%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\thsl(0, 0%, 78%);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-base-active);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-base-active-focus);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-foreground);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck.ck-reset_all {\n\t& .ck-rtl * {\n\t\ttext-align: right;\n\t}\n\n\t& iframe {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea,\n\t& input[type="text"],\n\t& input[type="password"] {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled],\n\t& input[type="text"][disabled],\n\t& input[type="password"][disabled] {\n\t\tcursor: default;\n\t}\n\n\t& fieldset {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0}.ck.ck-editor__editable_inline{overflow:auto;padding:0 var(--ck-spacing-standard);border:1px solid transparent}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEERA,YAAa,CACb,2BAA2B,CCF3B,qCHYA,CAGD,+BACC,aAAc,CACd,oCAAqC,CACrC,4BAwBD,CAtBC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CACC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"],
      names: [],
      mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{z-index:var(--ck-z-modal);position:fixed;top:0}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{top:auto;position:absolute}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{box-shadow:var(--ck-drop-shadow),0 0;border-width:0 1px 1px;border-top-left-radius:0;border-top-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAMC,qDACC,yBAA0B,CAC1B,cAAe,CACf,KACD,CAEA,kEACC,QAAS,CACT,iBACD,CCPA,qDCCA,oCAA8B,CDE7B,sBAAuB,CACvB,wBAAyB,CACzB,yBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on .ck-tooltip{display:none}.ck.ck-dropdown .ck-dropdown__panel{-webkit-backface-visibility:hidden;display:none;z-index:var(--ck-z-modal);position:absolute}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{top:100%;bottom:auto}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{width:7em;overflow:hidden;text-overflow:ellipsis}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{box-shadow:var(--ck-drop-shadow),0 0;background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAOA,gBACC,oBAAqB,CACrB,iBAyDD,CAvDC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UAOD,CCcA,iEACC,YACD,CDdA,oCAGC,kCAAmC,CAEnC,YAAa,CACb,yBAA0B,CAE1B,iBA8BD,CA5BC,+DACC,oBACD,CAEA,oHAEC,WACD,CAEA,oHAMC,QAAS,CACT,WACD,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAQF,mCACC,mCACD,CEhEA,MACC,sDACD,CAEA,gBAEC,iBAiED,CA/DC,oCACC,mCACD,CAGC,8CACC,gCAAiC,CAGjC,sCACD,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEACC,SAAU,CACV,eAAgB,CAChB,sBACD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAIF,uBExEC,eFoGD,CA5BA,qFEpEE,qCFgGF,CA5BA,uBG1EC,oCAA8B,CH8E9B,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CAGT,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"../tooltip/mixins/_tooltip.css\";\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\n\t\t/* Disable main button's tooltip when the dropdown is open. Otherwise the panel may\n\t\tpartially cover the tooltip */\n\t\t&.ck-on {\n\t\t\t@mixin ck-tooltip_disabled;\n\t\t}\n\t}\n\n\t& .ck-dropdown__panel {\n\t\t/* This is to get rid of flickering when the tooltip is shown under the panel,\n\t\twhich looks like the panel moves vertically a pixel down and up. */\n\t\t-webkit-backface-visibility: hidden;\n\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{width:var(--ck-icon-size);height:var(--ck-icon-size);font-size:.8333350694em;will-change:transform}.ck.ck-icon,.ck.ck-icon *{color:inherit;cursor:inherit}.ck.ck-icon :not([fill]){fill:currentColor}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"],
      names: [],
      mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YACC,yBAA0B,CAC1B,0BAA2B,CAG3B,uBAAwB,CAQxB,qBAcD,CAZC,0BARA,aAAc,CAGd,cAgBA,CAJC,yBAEC,iBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\tcolor: inherit;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\n\t\t/* Allows dynamic coloring of the icons. */\n\t\tcolor: inherit;\n\n\t\t&:not([fill]) {\n\t\t\t/* Needed by FF. */\n\t\t\tfill: currentColor;\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck.ck-tooltip,.ck.ck-tooltip .ck-tooltip__text:after{position:absolute;pointer-events:none;-webkit-backface-visibility:hidden}.ck.ck-tooltip{visibility:hidden;opacity:0;display:none;z-index:var(--ck-z-modal)}.ck.ck-tooltip .ck-tooltip__text{display:inline-block}.ck.ck-tooltip .ck-tooltip__text:after{content:"";width:0;height:0}:root{--ck-tooltip-arrow-size:5px}.ck.ck-tooltip{left:50%;top:0;transition:opacity .2s ease-in-out .2s}.ck.ck-tooltip .ck-tooltip__text{border-radius:0}.ck-rounded-corners .ck.ck-tooltip .ck-tooltip__text,.ck.ck-tooltip .ck-tooltip__text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-tooltip .ck-tooltip__text{font-size:.9em;line-height:1.5;color:var(--ck-color-tooltip-text);padding:var(--ck-spacing-small) var(--ck-spacing-medium);background:var(--ck-color-tooltip-background);position:relative;left:-50%}.ck.ck-tooltip .ck-tooltip__text:after{transition:opacity .2s ease-in-out .2s;border-style:solid;left:50%}.ck.ck-tooltip.ck-tooltip_s,.ck.ck-tooltip.ck-tooltip_se,.ck.ck-tooltip.ck-tooltip_sw{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(100%)}.ck.ck-tooltip.ck-tooltip_s .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after,.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{top:calc(var(--ck-tooltip-arrow-size)*-1 + 1px);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:var(--ck-color-tooltip-background);border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:0}.ck.ck-tooltip.ck-tooltip_sw{right:50%;left:auto}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text{left:auto;right:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_sw .ck-tooltip__text:after{left:auto;right:0}.ck.ck-tooltip.ck-tooltip_se{left:50%;right:auto}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text{right:auto;left:calc(var(--ck-tooltip-arrow-size)*-2)}.ck.ck-tooltip.ck-tooltip_se .ck-tooltip__text:after{right:auto;left:0;transform:translateX(50%)}.ck.ck-tooltip.ck-tooltip_n{top:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateY(-100%)}.ck.ck-tooltip.ck-tooltip_n .ck-tooltip__text:after{bottom:calc(var(--ck-tooltip-arrow-size)*-1);transform:translateX(-50%);border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;border-top-color:var(--ck-color-tooltip-background);border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:0;border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_e{left:calc(100% + var(--ck-tooltip-arrow-size));top:50%}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_e .ck-tooltip__text:after{left:calc(var(--ck-tooltip-arrow-size)*-1);top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:transparent;border-bottom-color:transparent;border-right-color:var(--ck-color-tooltip-background);border-top-color:transparent;border-left-width:0;border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:var(--ck-tooltip-arrow-size);border-top-width:var(--ck-tooltip-arrow-size)}.ck.ck-tooltip.ck-tooltip_w{right:calc(100% + var(--ck-tooltip-arrow-size));left:auto;top:50%}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text{left:0;transform:translateY(-50%)}.ck.ck-tooltip.ck-tooltip_w .ck-tooltip__text:after{left:100%;top:calc(50% - var(--ck-tooltip-arrow-size)*1);border-left-color:var(--ck-color-tooltip-background);border-bottom-color:transparent;border-right-color:transparent;border-top-color:transparent;border-left-width:var(--ck-tooltip-arrow-size);border-bottom-width:var(--ck-tooltip-arrow-size);border-right-width:0;border-top-width:var(--ck-tooltip-arrow-size)}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAKA,sDAEC,iBAAkB,CAGlB,mBAAoB,CAIpB,kCACD,CAEA,eAEC,iBAAkB,CAClB,SAAU,CACV,YAAa,CACb,yBAWD,CATC,iCACC,oBAOD,CALC,uCACC,UAAW,CACX,OAAQ,CACR,QACD,CCxBF,MACC,2BACD,CAEA,eACC,QAAS,CAMT,KAAM,CAON,sCAwKD,CAtKC,iCChBA,eDqCA,CArBA,yGCZC,qCDiCD,CArBA,iCAGC,cAAe,CACf,eAAgB,CAChB,kCAAmC,CACnC,wDAAyD,CACzD,6CAA8C,CAC9C,iBAAkB,CAClB,SAYD,CAVC,uCAMC,sCAAuC,CACvC,kBAAmB,CACnB,QACD,CAYD,sFAGC,4CAA+C,CAC/C,0BASD,CAPC,8JAEC,+CAAkD,CAClD,0BAA6B,CAC7B,6BAAoF,CAApF,sDAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,kBACD,CAaD,6BACC,SAAU,CACV,SAWD,CATC,+CACC,SAAU,CACV,2CACD,CAEA,qDACC,SAAU,CACV,OACD,CAYD,6BACC,QAAS,CACT,UAYD,CAVC,+CACC,UAAW,CACX,0CACD,CAEA,qDACC,UAAW,CACX,MAAO,CACP,yBACD,CAYD,4BACC,yCAA4C,CAC5C,2BAQD,CANC,oDACC,4CAA+C,CAC/C,0BAA6B,CAC7B,6BAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,mDAAoF,CACpF,8CAAsG,CAAtG,qBAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAUD,4BACC,8CAA+C,CAC/C,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,0CAA6C,CAC7C,8CAAiD,CACjD,6BAAoF,CAApF,+BAAoF,CAApF,qDAAoF,CAApF,4BAAoF,CACpF,mBAAsG,CAAtG,gDAAsG,CAAtG,+CAAsG,CAAtG,6CACD,CAWF,4BACC,+CAAgD,CAChD,SAAU,CACV,OAaD,CAXC,8CACC,MAAO,CACP,0BAQD,CANC,oDACC,SAAU,CACV,8CAAiD,CACjD,oDAAoF,CAApF,+BAAoF,CAApF,8BAAoF,CAApF,4BAAoF,CACpF,8CAAsG,CAAtG,gDAAsG,CAAtG,oBAAsG,CAAtG,6CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-tooltip,\n.ck.ck-tooltip .ck-tooltip__text::after {\n\tposition: absolute;\n\n\t/* Without this, hovering the tooltip could keep it visible. */\n\tpointer-events: none;\n\n\t/* This is to get rid of flickering when transitioning opacity in Chrome.\n\tIt\'s weird but it works. */\n\t-webkit-backface-visibility: hidden;\n}\n\n.ck.ck-tooltip {\n\t/* Tooltip is hidden by default. */\n\tvisibility: hidden;\n\topacity: 0;\n\tdisplay: none;\n\tz-index: var(--ck-z-modal);\n\n\t& .ck-tooltip__text {\n\t\tdisplay: inline-block;\n\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n}\n', '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-tooltip-arrow-size: 5px;\n}\n\n.ck.ck-tooltip {\n\tleft: 50%;\n\n\t/*\n\t * Prevent blurry tooltips in LoDPI environments.\n\t * See https://github.com/ckeditor/ckeditor5/issues/1802.\n\t */\n\ttop: 0;\n\n\t/*\n\t * For the transition to work, the tooltip must be controlled\n\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t * i.e. when scanning the toolbar with mouse cursor.\n\t */\n\ttransition: opacity .2s ease-in-out .2s;\n\n\t& .ck-tooltip__text {\n\t\t@mixin ck-rounded-corners;\n\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t\tpadding: var(--ck-spacing-small) var(--ck-spacing-medium);\n\t\tbackground: var(--ck-color-tooltip-background);\n\t\tposition: relative;\n\t\tleft: -50%;\n\n\t\t&::after {\n\t\t\t/*\n\t\t\t * For the transition to work, the tooltip must be controlled\n\t\t\t * using visibility+opacity. A delay prevents a "tooltip avalanche"\n\t\t\t * i.e. when scanning the toolbar with mouse cursor.\n\t\t\t */\n\t\t\ttransition: opacity .2s ease-in-out .2s;\n\t\t\tborder-style: solid;\n\t\t\tleft: 50%;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south of the element.\n\t *\n\t *       [element]\n\t *           ^\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t */\n\t&.ck-tooltip_s,\n\t&.ck-tooltip_sw,\n\t&.ck-tooltip_se {\n\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( 100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\t/* 1px addresses gliches in rendering causing gap between the triangle and the text */\n\t\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size) + 1px);\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: transparent transparent var(--ck-color-tooltip-background) transparent;\n\t\t\tborder-width: 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-west of the element.\n\t *\n\t *        [element]\n\t *            ^\n\t *  +-----------+\n\t *  |  Tooltip  |\n\t *  +-----------+\n\t */\n\n\t&.ck-tooltip_sw {\n\t\tright: 50%;\n\t\tleft: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: auto;\n\t\t\tright: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tleft: auto;\n\t\t\tright: 0;\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip south-east of the element.\n\t *\n\t *  [element]\n\t *      ^\n\t *    +-----------+\n\t *    |  Tooltip  |\n\t *    +-----------+\n\t */\n\t&.ck-tooltip_se {\n\t\tleft: 50%;\n\t\tright: auto;\n\n\t\t& .ck-tooltip__text {\n\t\t\tright: auto;\n\t\t\tleft: calc( -2 * var(--ck-tooltip-arrow-size));\n\t\t}\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tright: auto;\n\t\t\tleft: 0;\n\t\t\ttransform: translateX( 50% );\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip north of the element.\n\t *\n\t *     +-----------+\n\t *     |  Tooltip  |\n\t *     +-----------+\n\t *           V\n\t *       [element]\n\t */\n\t&.ck-tooltip_n {\n\t\ttop: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\ttransform: translateY( -100% );\n\n\t\t& .ck-tooltip__text::after {\n\t\t\tbottom: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\ttransform: translateX( -50% );\n\t\t\tborder-color: var(--ck-color-tooltip-background) transparent transparent transparent;\n\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size);\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip east of the element.\n\t *\n\t *                +----------+\n\t *    [element] < |   east   |\n\t *                +----------+\n\t */\n\t&.ck-tooltip_e {\n\t\tleft: calc(100% + var(--ck-tooltip-arrow-size));\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: calc(-1 * var(--ck-tooltip-arrow-size));\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent var(--ck-color-tooltip-background) transparent transparent;\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size) 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t/**\n\t * A class that displays the tooltip west of the element.\n\t *\n\t *    +----------+\n\t *    |   west   | > [element]\n\t *    +----------+\n\t */\n\t&.ck-tooltip_w {\n\t\tright: calc(100% + var(--ck-tooltip-arrow-size));\n\t\tleft: auto;\n\t\ttop: 50%;\n\n\t\t& .ck-tooltip__text {\n\t\t\tleft: 0;\n\t\t\ttransform: translateY( -50% );\n\n\t\t\t&::after {\n\t\t\t\tleft: 100%;\n\t\t\t\ttop: calc(50% - 1 * var(--ck-tooltip-arrow-size));\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-color-tooltip-background);\n\t\t\t\tborder-width: var(--ck-tooltip-arrow-size) 0 var(--ck-tooltip-arrow-size) var(--ck-tooltip-arrow-size);\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-button,a.ck.ck-button{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:block}@media (hover:none){.ck.ck-button .ck-tooltip,a.ck.ck-button .ck-tooltip{display:none}}.ck.ck-button,a.ck.ck-button{position:relative;display:inline-flex;align-items:center;justify-content:left}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button:hover .ck-tooltip,a.ck.ck-button:hover .ck-tooltip{visibility:visible;opacity:1}.ck.ck-button:focus:not(:hover) .ck-tooltip,a.ck.ck-button:focus:not(:hover) .ck-tooltip{display:none}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-default-active-shadow)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{white-space:nowrap;cursor:default;vertical-align:middle;padding:var(--ck-spacing-tiny);text-align:center;min-width:var(--ck-ui-component-min-height);min-height:var(--ck-ui-component-min-height);line-height:1;font-size:inherit;border:1px solid transparent;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;-webkit-appearance:none}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{font-size:inherit;font-weight:inherit;color:inherit;cursor:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__icon{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-right:calc(var(--ck-spacing-small)*-1);margin-left:var(--ck-spacing-small)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-on-active-shadow)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background);box-shadow:inset 0 2px 2px var(--ck-color-button-action-active-shadow)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
      names: [],
      mappings: "AAQA,6BCCC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6BD,CE/BC,qDACC,aAqBD,CAHC,oBAnBD,qDAoBE,YAEF,CADC,CFvBF,6BAKC,iBAAkB,CAClB,mBAAoB,CACpB,kBAAmB,CACnB,oBAyBD,CAvBC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEkBA,iEACC,kBAAmB,CACnB,SACD,CAbA,yFACC,YACD,CC7BD,6BCAC,oDD0ID,CCvIE,6EACC,0DACD,CAEA,+EACC,2DAA4C,CAC5C,uEACD,CAID,qDACC,6DACD,CDhBD,6BEDC,eF2ID,CA1IA,wIEGE,qCFuIF,CA1IA,6BAKC,kBAAmB,CACnB,cAAe,CACf,qBAAsB,CACtB,8BAA+B,CAC/B,iBAAkB,CAGlB,2CAA4C,CAC5C,4CAA6C,CAI7C,aAAc,CAGd,iBAAkB,CAGlB,4BAA6B,CAG7B,4DAA8D,CAG9D,uBA6GD,CA3GC,oFGjCA,YAAa,CACb,2BAA2B,CCF3B,2CJsCA,CAIC,kJAEC,aACD,CAGD,iEAEC,iBAAkB,CAClB,mBAAoB,CACpB,aAAc,CACd,cAAe,CAIf,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAEA,uFK3FD,kCL6FC,CAGA,yFKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAOE,6CAAgD,CAChD,mCAEF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDiIA,CC9HC,yFACC,qDACD,CAEA,2FACC,sDAA4C,CAC5C,kEACD,CAID,iEACC,wDACD,CDmHA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC7IC,mDDkJD,CC/IE,2FACC,yDACD,CAEA,6FACC,0DAA4C,CAC5C,sEACD,CAID,mEACC,4DACD,CD6HD,2CAIC,wCACD,CAEA,uCAEC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\t@mixin ck-tooltip_enabled;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n\n\t&:hover {\n\t\t@mixin ck-tooltip_visible;\n\t}\n\n\t/* Get rid of the native focus outline around the tooltip when focused (but not :hover). */\n\t&:focus:not(:hover) {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t\tbox-shadow: inset 0 2px 2px var($(prefix)-active-shadow);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-list{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-direction:column}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{list-style-type:none;background:var(--ck-color-list-background)}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{min-height:unset;width:100%;text-align:left;border-radius:0;padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{height:1px;width:100%;background:var(--ck-color-base-border)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,YCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,qBAcD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAGC,oBAAqB,CACrB,0CACD,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BACC,gBAAiB,CACjB,UAAW,CACX,eAAgB,CAChB,eAAgB,CAKhB,mIAiCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,2DACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBACC,UAAW,CACX,UAAW,CACX,sCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:1.0769230769em;--ck-switch-button-toggle-spacing:1px;--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - var(--ck-switch-button-toggle-spacing)*2)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{transition:background .4s ease;width:var(--ck-switch-button-toggle-width);background:var(--ck-color-switch-button-off-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*0.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{margin:var(--ck-switch-button-toggle-spacing);width:var(--ck-switch-button-toggle-inner-size);height:var(--ck-switch-button-toggle-inner-size);background:var(--ck-color-switch-button-inner-background);transition:all .3s ease}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var(--ck-switch-button-translation))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var(--ck-switch-button-translation)*-1))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"],
      names: [],
      mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,mDAAoD,CACpD,qCAAsC,CACtC,gKAKD,CAGC,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDC3BA,eDoEA,CAzCA,yICvBC,qCDgED,CAzCA,2DAKE,gBAoCF,CAzCA,2DAUE,iBA+BF,CAzCA,iDAcC,8BAAiC,CAEjC,0CAA2C,CAC3C,uDAwBD,CAtBC,2EC9CD,eD2DC,CAbA,6LC1CA,qCAAsC,CD4CpC,+CAWF,CAbA,2EAMC,6CAA8C,CAC9C,+CAAgD,CAChD,gDAAiD,CACjD,yDAA0D,CAG1D,uBACD,CAEA,uDACC,6DAKD,CAHC,iFACC,+DACD,CAIF,6DExEA,kCF0EA,CAEA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,yDAMF,CAXA,2FASE,kEAEF",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: 1.0769230769em;\n\t--ck-switch-button-toggle-spacing: 1px;\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2 * var(--ck-switch-button-toggle-spacing)\n\t);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease;\n\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\t/* Leave some tiny bit of space around the inner part of the switch */\n\t\t\tmargin: var(--ck-switch-button-toggle-spacing);\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t&.ck-on .ck-button__toggle {\n\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t}\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t/*\n\t\t\t * Move the toggle switch to the right. It will be animated.\n\t\t\t */\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown .ck-dropdown__panel{width:max-content;max-width:var(--ck-toolbar-dropdown-max-width)}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"],
      names: [],
      mappings: "AAKA,MACC,oCACD,CAGC,4CAEC,iBAAkB,CAClB,8CAOD,CAJE,6DACC,qCACD,CCbH,oCACC,QACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown {\n\t& .ck-dropdown__panel {\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\t\twidth: max-content;\n\t\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t\t& .ck-button {\n\t\t\t&:focus {\n\t\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t\t}\n\t\t}\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDIpC,wBAAyB,CACzB,2BAA4B,CAC5B,4BAEF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-toolbar{-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;display:flex;flex-flow:row nowrap;align-items:center}.ck.ck-toolbar>.ck-toolbar__items{display:flex;flex-flow:row wrap;align-items:center;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);padding:0 var(--ck-spacing-small);border:1px solid var(--ck-color-toolbar-border)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;width:1px;min-width:1px;background:var(--ck-color-toolbar-border);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{width:100%;margin:0;border-radius:0;border:0}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=rtl].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ck.ck-toolbar[dir=ltr].ck-toolbar_compact>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr].ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child){margin-right:var(--ck-spacing-small)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,eCEC,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAgB,CDFhB,YAAa,CACb,oBAAqB,CACrB,kBA6CD,CA3CC,kCACC,YAAa,CACb,kBAAmB,CACnB,kBAAmB,CACnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eD0FD,CA7FA,qECOE,qCDsFF,CA7FA,eAGC,6CAA8C,CAC9C,iCAAkC,CAClC,+CAwFD,CAtFC,yCACC,kBAAmB,CACnB,SAAU,CACV,aAAc,CACd,yCAA0C,CAM1C,kCAAmC,CACnC,qCACD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAGC,kCAAmC,CACnC,qCACD,CAEA,mCAEC,SAgBD,CAbC,0DAEC,UAAW,CAGX,QAAS,CAGT,eAAgB,CAGhB,QACD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAvFF,qCA2FE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JACC,wBAAyB,CACzB,2BACD,CAGA,2JACC,yBAA0B,CAC1B,4BACD,CAID,qGACC,mCACD,CAGA,yLACC,mCACD,CAWA,qHACC,cACD,CAIC,6JACC,yBAA0B,CAC1B,4BACD,CAGA,2JACC,wBAAyB,CACzB,2BACD,CAID,qGACC,oCACD,CAGA,yLACC,oCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so any border is pointless. */\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content blockquote{overflow:hidden;padding-right:1.5em;padding-left:1.5em;margin-left:0;margin-right:0;font-style:italic;border-left:5px solid #ccc}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"],
      names: [],
      mappings: "AAKA,uBAEC,eAAgB,CAGhB,mBAAoB,CACpB,kBAAmB,CAEnB,aAAc,CACd,cAAe,CACf,iBAAkB,CAClB,0BACD,CAEA,gCACC,aAAc,CACd,2BACD",
      sourcesContent: ['/**\n * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{width:0;height:0;border-style:solid}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:var(--ck-balloon-arrow-height);border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:0}.ck.ck-balloon-panel[class*=arrow_n]:before{border-bottom-color:var(--ck-color-panel-border)}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-left-color:transparent;border-right-color:transparent;border-top-color:transparent}.ck.ck-balloon-panel[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background);margin-top:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-width:var(--ck-balloon-arrow-half-width);border-bottom-width:0;border-right-width:var(--ck-balloon-arrow-half-width);border-top-width:var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-top-color:var(--ck-color-panel-border);filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent}.ck.ck-balloon-panel[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background);margin-bottom:var(--ck-balloon-arrow-offset)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);bottom:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{right:25%;margin-right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCJC,eD4ID,CAxIA,iFCAE,qCDwIF,CAxIA,qBENC,oCAA8B,CFU9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAiID,CA9HE,+GAEC,OAAQ,CACR,QAAS,CACT,kBACD,CAIA,uFAEC,oDAAoH,CAApH,kDAAoH,CAApH,qDAAoH,CAApH,kBACD,CAEA,4CACC,gDACD,CAEA,uFAHC,6BAA8E,CAA9E,8BAA8E,CAA9E,4BAMD,CAHA,2CACC,oDAAkF,CAClF,yCACD,CAIA,uFAEC,oDAAoH,CAApH,qBAAoH,CAApH,qDAAoH,CAApH,+CACD,CAEA,4CACC,6CAAkE,CAClE,uDACD,CAEA,uFAJC,6BAAkE,CAAlE,+BAAkE,CAAlE,8BAOD,CAHA,2CACC,iDAAkF,CAClF,4CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,8CACD,CAIA,2GAEC,+CAAkD,CAClD,8CACD,CAIA,2GAEC,gDAAmD,CACnD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,8CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,8CACD,CAIA,6GAEC,SAAU,CACV,uDAA0D,CAC1D,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: var(--ck-balloon-arrow-offset);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{height:100%;border-right:1px solid var(--ck-color-base-text);margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"],
      names: [],
      mappings: "AAMA,sBACC,mDACD,CAMA,4BACC,8CACD,CAGA,sCACC,WAAY,CACZ,gDAAiD,CACjD,iBAAkB,CAClB,oCACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"],
      names: [],
      mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck .ck-widget .ck-widget__type-around__button{display:block;position:absolute;overflow:hidden;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{position:absolute;top:50%;left:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{top:calc(var(--ck-widget-outline-thickness)*-0.5);left:min(10%,30px);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-0.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;position:absolute;top:1px;left:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;position:absolute;left:0;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{top:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{width:var(--ck-widget-type-around-button-size);height:var(--ck-widget-type-around-button-size);background:var(--ck-color-widget-type-around-button);border-radius:100px;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);opacity:0;pointer-events:none}.ck .ck-widget .ck-widget__type-around__button svg{width:10px;height:8px;transform:translate(-50%,-50%);transition:transform .5s ease;margin-top:1px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{width:calc(var(--ck-widget-type-around-button-size) - 2px);height:calc(var(--ck-widget-type-around-button-size) - 2px);border-radius:100px;background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3))}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{pointer-events:none;height:1px;animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;outline:1px solid hsla(0,0%,100%,.5);background:var(--ck-color-base-text)}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"],
      names: [],
      mappings: "AASC,+CACC,aAAc,CACd,iBAAkB,CAClB,eAAgB,CAChB,2BAwBD,CAtBC,mDACC,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAEA,qFAEC,iDAAoD,CACpD,kBAAoB,CAEpB,0BACD,CAEA,oFAEC,oDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CACd,iBAAkB,CAClB,OAAQ,CACR,QAAS,CACT,qCACD,CAMD,2EACC,YAAa,CACb,iBAAkB,CAClB,MAAO,CACP,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHACC,qDAA0D,CAC1D,aACD,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CACC,8CAA+C,CAC/C,+CAAgD,CAChD,oDAAqD,CACrD,mBAAoB,CACpB,uMAAyM,CAb1M,SAAU,CACV,mBA0DA,CA1CC,mDACC,UAAW,CACX,UAAW,CACX,8BAA+B,CAC/B,6BAA8B,CAC9B,cAgBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLACC,0DAA2D,CAC3D,2DAA4D,CAC5D,mBAAoB,CACpB,uEACD,CAOD,8GACC,gBACD,CAKA,mDACC,mBAAoB,CACpB,UAAW,CACX,mFAAoF,CAMpF,oCAAwC,CACxC,oCACD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CASE,0jBACC,SACD,CASF,mPACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n', '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-resizer-size:10px;--ck-resizer-border-width:1px;--ck-resizer-border-radius:2px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-tooltip-offset:10px;--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);color:var(--ck-color-resizer-tooltip-text);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);font-size:var(--ck-font-size-tiny);display:block;padding:var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{top:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{top:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-width:var(--ck-widget-outline-thickness);outline-style:solid;outline-color:transparent;transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;background-color:var(--ck-color-widget-editable-focus-background)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{padding:4px;box-sizing:border-box;background-color:transparent;opacity:0;transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;transform:translateY(-100%);left:calc(0px - var(--ck-widget-outline-thickness))}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{width:var(--ck-widget-handler-icon-size);height:var(--ck-widget-handler-icon-size);color:var(--ck-color-widget-drag-handler-icon-color)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle{opacity:1;background-color:var(--ck-color-focus-border)}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle .ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,MACC,+CAAgD,CAChD,sBAAuB,CACvB,6BAA8B,CAC9B,8BAA+B,CAG/B,yDAAiE,CAEjE,gCAAiC,CACjC,6CAAsD,CACtD,uCACD,CAOA,8DAEC,iBAuBD,CArBC,4EACC,iBAOD,CALC,qFAGC,aACD,CAWD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CACtD,0CAA2C,CAC3C,qDAAsD,CACtD,6CAA8C,CAC9C,kCAAmC,CACnC,aAAc,CACd,+BA4BD,CA1BC,gLAIC,iBACD,CAEA,0CACC,oCAAuC,CACvC,qCACD,CAEA,2CACC,oCAAuC,CACvC,sCACD,CAEA,8CACC,uCAA0C,CAC1C,sCACD,CAEA,6CACC,uCAA0C,CAC1C,qCACD,CC7ED,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eACC,gDAAiD,CACjD,mBAAoB,CACpB,yBAA0B,CAC1B,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGC/BA,YAAa,CACb,2BAA2B,CCF3B,qCAA8B,CFqC7B,iEACD,CAIA,4EACC,WAAY,CACZ,qBAAsB,CAGtB,4BAA6B,CAC7B,SAAU,CAMV,6SAG6F,CAG7F,iEAAkE,CAGlE,2BAA4B,CAC5B,mDAqBD,CAnBC,qFAEC,wCAAyC,CACzC,yCAA0C,CAC1C,oDASD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFACC,SAAU,CACV,oDACD,CAKC,oMACC,SAAU,CACV,6CAMD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-resizer-size: 10px;\n\t--ck-resizer-border-width: 1px;\n\t--ck-resizer-border-radius: 2px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget. */\n\t&:hover {\n\t\t& .ck-widget__selection-handle {\n\t\t\tvisibility: visible;\n\t\t}\n\t}\n\n\t/* Show the selection handle when the widget is selected. */\n\t&.ck-widget_selected .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: var(--ck-spacing-small);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var( --ck-resizer-tooltip-offset );\n\t\tleft: var( --ck-resizer-tooltip-offset );\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var( --ck-resizer-tooltip-offset );\n\t\tright: var( --ck-resizer-tooltip-offset );\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var( --ck-resizer-tooltip-offset );\n\t\tright: var( --ck-resizer-tooltip-offset );\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var( --ck-resizer-tooltip-offset );\n\t\tleft: var( --ck-resizer-tooltip-offset );\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget. */\n\t&:hover .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& .ck-widget__selection-handle,\n\t\t\t& .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{pointer-events:none;transform-origin:0 0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);background:var(--ck-color-labeled-field-label-background);padding:0 calc(var(--ck-font-size-tiny)*0.5);line-height:normal;font-weight:400;text-overflow:ellipsis;overflow:hidden;max-width:100%;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-spacing-medium),calc(var(--ck-font-size-base)*0.6)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-spacing-medium)*-1),calc(var(--ck-font-size-base)*0.6)) scale(1)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));background:transparent;padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,yEACD,CAEA,0BCHC,eD4GD,CAzGA,2FCCE,qCDwGF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAWC,mBAAoB,CACpB,oBAAqB,CAGrB,6DAA+D,CAE/D,yDAA0D,CAC1D,4CAA8C,CAC9C,kBAAoB,CACpB,eAAmB,CAGnB,sBAAuB,CACvB,eAAgB,CAEhB,cAAe,CAEf,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,wSAGE,yFAYF,CAfA,wSAOE,kGAQF,CAfA,oRAWC,iEAAkE,CAElE,sBAAuB,CACvB,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-spacing-medium), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-spacing-medium)), calc(0.6 * var(--ck-font-size-base))) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-input-text-width:18em}.ck.ck-input-text{border-radius:0}.ck-rounded-corners .ck.ck-input-text,.ck.ck-input-text.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-text{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);min-width:var(--ck-input-text-width);min-height:var(--ck-ui-component-min-height);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input-text:focus{outline:none;border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-input-text[readonly]{border:1px solid var(--ck-color-input-disabled-border);background:var(--ck-color-input-disabled-background);color:var(--ck-color-input-disabled-text)}.ck.ck-input-text[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input-text.ck-error{border-color:var(--ck-color-input-error-border);animation:ck-text-input-shake .3s ease both}.ck.ck-input-text.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-text-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/inputtext/inputtext.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AASA,MACC,0BACD,CAEA,kBCFC,eDwCD,CAtCA,2ECEE,qCDoCF,CAtCA,kBAGC,2CAA4C,CAC5C,6CAA8C,CAC9C,6DAA8D,CAC9D,oCAAqC,CAGrC,4CAA6C,CAG7C,4DA0BD,CAxBC,wBEjBA,YAAa,CACb,2BAA2B,CCF3B,2CHqBA,CAEA,4BACC,sDAAuD,CACvD,oDAAqD,CACrD,yCAMD,CAJC,kCG5BD,oDH+BC,CAGD,2BACC,+CAAgD,CAChD,2CAKD,CAHC,iCGtCD,iDHwCC,CAIF,+BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-text-width: 18em;\n}\n\n.ck.ck-input-text {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-text-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-text-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-text-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
      names: [],
      mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck-vertical-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{content:"";width:0;position:absolute;right:-1px;top:var(--ck-spacing-small);bottom:var(--ck-spacing-small);z-index:1}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-text-width)*0.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){padding:var(--ck-spacing-standard);margin-top:var(--ck-spacing-large);border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after,[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"],
      names: [],
      mappings: "AAOA,mCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCTC,oCDaC,wCACC,UAAW,CACX,OAAQ,CACR,iBAAkB,CAClB,UAAW,CACX,2BAA4B,CAC5B,8BAA+B,CAC/B,SACD,CCnBD,CCAD,qDACC,kDACD,CAEA,uBACC,+BAkED,CAhEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,0CA6CF,CA3CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAID,iGAEC,kCAAmC,CACnC,kCAAmC,CAEnC,eAAgB,CAChB,QAAS,CACT,gDAaD,CApBA,0OAcE,aAMF,CAGC,yMACC,kDACD,CDpEF",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button::after {\n\tcontent: "";\n\twidth: 0;\n\tposition: absolute;\n\tright: -1px;\n\ttop: var(--ck-spacing-small);\n\tbottom: var(--ck-spacing-small);\n\tz-index: 1;\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button::after {\n\t\t\tcontent: "";\n\t\t\twidth: 0;\n\t\t\tposition: absolute;\n\t\t\tright: -1px;\n\t\t\ttop: var(--ck-spacing-small);\n\t\t\tbottom: var(--ck-spacing-small);\n\t\t\tz-index: 1;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-text-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\n\t\t\tborder-radius: 0;\n\t\t\tborder: 0;\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck .ck-balloon-rotator__navigation{display:flex;align-items:center;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);margin-bottom:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-right:var(--ck-spacing-standard);margin-left:var(--ck-spacing-small)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"],
      names: [],
      mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCACC,oCAAqC,CACrC,kCAAmC,CACnC,qCACD,CAGA,iEACC,uCAAwC,CAGxC,mCACD,CAMA,2DACC,eACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{box-shadow:var(--ck-drop-shadow),0 0;min-height:15px;background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);width:100%;height:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"],
      names: [],
      mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBCJC,oCAA8B,CDO9B,eAAgB,CAEhB,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CAEtC,UAAW,CACX,WACD,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content .image{display:table;clear:both;text-align:center;margin:1em auto}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:50px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css"],
      names: [],
      mappings: "AAKA,mBACC,aAAc,CACd,UAAW,CACX,iBAAkB,CAGlB,eAeD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image {\n\tdisplay: table;\n\tclear: both;\n\ttext-align: center;\n\n\t/* Make sure there is some space between the content and the image. Center image by default. */\n\tmargin: 1em auto;\n\n\t& img {\n\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\tdisplay: block;\n\n\t\t/* Center the image if its width is smaller than the content's width. */\n\t\tmargin: 0 auto;\n\n\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\tmax-width: 100%;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content .image>figcaption{display:table-caption;caption-side:bottom;word-break:break-word;color:#333;background-color:#f7f7f7;padding:.6em;font-size:.75em;outline-offset:-1px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css"],
      names: [],
      mappings: "AAKA,8BACC,qBAAsB,CACtB,mBAAoB,CACpB,qBAAsB,CACtB,UAAsB,CACtB,wBAAiC,CACjC,YAAa,CACb,eAAgB,CAChB,mBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: hsl(0, 0%, 20%);\n\tbackground-color: hsl(0, 0%, 97%);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;position:absolute;pointer-events:none;left:0;top:0;outline:1px solid var(--ck-color-resizer)}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{position:absolute;pointer-events:all;width:var(--ck-resizer-size);height:var(--ck-resizer-size);background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{top:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{top:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nesw-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset);cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset);cursor:nesw-resize}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css"],
      names: [],
      mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CACb,iBAAkB,CAGlB,mBAAoB,CAEpB,MAAO,CACP,KAAM,CAEN,yCACD,CAGC,2EACC,aACD,CAGD,gCACC,iBAAkB,CAGlB,kBAAmB,CAEnB,4BAA6B,CAC7B,6BAA8B,CAC9B,uCAAwC,CACxC,gDAA6D,CAC7D,6CAyBD,CAvBC,oEACC,4BAA+B,CAC/B,6BAAgC,CAChC,kBACD,CAEA,qEACC,4BAA+B,CAC/B,8BAAiC,CACjC,kBACD,CAEA,wEACC,+BAAkC,CAClC,8BAAiC,CACjC,kBACD,CAEA,uEACC,+BAAkC,CAClC,6BAAgC,CAChC,kBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var( --ck-resizer-offset );\n\t\tleft: var( --ck-resizer-offset );\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var( --ck-resizer-offset );\n\t\tright: var( --ck-resizer-offset );\n\t\tcursor: nesw-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var( --ck-resizer-offset );\n\t\tright: var( --ck-resizer-offset );\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var( --ck-resizer-offset );\n\t\tleft: var( --ck-resizer-offset );\n\t\tcursor: nesw-resize;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content .image.image_resized{max-width:100%;display:block;box-sizing:border-box}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageresize.css"],
      names: [],
      mappings: "AAKA,iCACC,cAAe,CAMf,aAAc,CACd,qBAWD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAGD,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .image.image_resized {\n\tmax-width: 100%;\n\t/*\n\tThe `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n\tSee https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n\tFortunately, since we control the width, there is no risk that the image will look bad.\n\t*/\n\tdisplay: block;\n\tbox-sizing: border-box;\n\n\t& img {\n\t\t/* For resized images it is the `<figure>` element that determines the image width. */\n\t\twidth: 100%;\n\t}\n\n\t& > figcaption {\n\t\t/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n\t\tdisplay: block;\n\t}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n\tmargin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n\twidth: 4em;\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-image-style-spacing:1.5em}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css"],
      names: [],
      mappings: "AAKA,MACC,8BACD,CAGC,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n}\n\n.ck-content {\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-editor__editable .image{position:relative}.ck.ck-editor__editable .image .ck-progress-bar{position:absolute;top:0;left:0}.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar{height:2px;width:0;background:var(--ck-color-upload-bar-background);transition:width .1s}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"],
      names: [],
      mappings: "AAKA,+BACC,iBACD,CAGA,gDACC,iBAAkB,CAClB,KAAM,CACN,MACD,CCPC,yCACC,oBACD,CAID,gDACC,UAAW,CACX,OAAQ,CACR,gDAAiD,CACjD,oBACD,CAEA,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable .image {\n\tposition: relative;\n}\n\n/* Upload progress bar. */\n.ck.ck-editor__editable .image .ck-progress-bar {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable .image {\n\t/* Showing animation. */\n\t&.ck-appear {\n\t\tanimation: fadeIn 700ms;\n\t}\n}\n\n/* Upload progress bar. */\n.ck.ck-editor__editable .image .ck-progress-bar {\n\theight: 2px;\n\twidth: 0;\n\tbackground: var(--ck-color-upload-bar-background);\n\ttransition: width 100ms;\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck-image-upload-complete-icon{display:block;position:absolute;top:10px;right:10px;border-radius:50%}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20px;--ck-image-upload-icon-width:2px}.ck-image-upload-complete-icon{width:var(--ck-image-upload-icon-size);height:var(--ck-image-upload-icon-size);opacity:0;background:var(--ck-color-image-upload-icon-background);animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;animation-fill-mode:forwards,forwards;animation-duration:.5s,.5s;font-size:var(--ck-image-upload-icon-size);animation-delay:0ms,3s}.ck-image-upload-complete-icon:after{left:25%;top:50%;opacity:0;height:0;width:0;transform:scaleX(-1) rotate(135deg);transform-origin:left top;border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);animation-name:ck-upload-complete-icon-check;animation-duration:.5s;animation-delay:.5s;animation-fill-mode:forwards;box-sizing:border-box}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{opacity:1;width:0;height:0}33%{width:.3em;height:0}to{opacity:1;width:.3em;height:.45em}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"],
      names: [],
      mappings: "AAKA,+BACC,aAAc,CACd,iBAAkB,CAClB,QAAS,CACT,UAAW,CACX,iBAMD,CAJC,qCACC,UAAW,CACX,iBACD,CCVD,MACC,iCAA8C,CAC9C,+CAA4D,CAE5D,gCAAiC,CACjC,gCACD,CAEA,+BACC,sCAAuC,CACvC,uCAAwC,CACxC,SAAU,CACV,uDAAwD,CACxD,wEAA0E,CAC1E,qCAAuC,CACvC,0BAAgC,CAGhC,0CAA2C,CAG3C,sBAyBD,CAtBC,qCAEC,QAAS,CAET,OAAQ,CACR,SAAU,CACV,QAAS,CACT,OAAQ,CAER,mCAAoC,CACpC,yBAA0B,CAC1B,oFAAqF,CACrF,sFAAuF,CAEvF,4CAA6C,CAC7C,sBAAyB,CACzB,mBAAsB,CACtB,4BAA6B,CAG7B,qBACD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GACC,SAAU,CACV,OAAQ,CACR,QACD,CACA,IACC,UAAY,CACZ,QACD,CACA,GACC,SAAU,CACV,UAAY,CACZ,YACD,CACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n\tborder-radius: 50%;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n', '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t--ck-image-upload-icon-size: 20px;\n\t--ck-image-upload-icon-width: 2px;\n}\n\n.ck-image-upload-complete-icon {\n\twidth: var(--ck-image-upload-icon-size);\n\theight: var(--ck-image-upload-icon-size);\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: var(--ck-image-upload-icon-size);\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck .ck-upload-placeholder-loader{position:absolute;display:flex;align-items:center;justify-content:center;top:0;left:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px}.ck .ck-image-upload-placeholder{width:100%;margin:0}.ck .ck-upload-placeholder-loader{width:100%;height:100%}.ck .ck-upload-placeholder-loader:before{width:var(--ck-upload-placeholder-loader-size);height:var(--ck-upload-placeholder-loader-size);border-radius:50%;border-top:3px solid var(--ck-color-upload-placeholder-loader);border-right:2px solid transparent;animation:ck-upload-placeholder-loader 1s linear infinite}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"],
      names: [],
      mappings: "AAKA,kCACC,iBAAkB,CAClB,YAAa,CACb,kBAAmB,CACnB,sBAAuB,CACvB,KAAM,CACN,MAMD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCACD,CAEA,iCAEC,UAAW,CACX,QACD,CAEA,kCACC,UAAW,CACX,WAUD,CARC,yCACC,8CAA+C,CAC/C,+CAAgD,CAChD,iBAAkB,CAClB,8DAA+D,CAC/D,kCAAmC,CACnC,yDACD,CAGD,wCACC,GACC,uBACD,CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{padding:0;min-width:var(--ck-input-text-width)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical .ck-button{padding:var(--ck-spacing-standard);margin:0;border-radius:0;border:0;border-top:1px solid var(--ck-color-base-border);width:50%}[dir=ltr] .ck.ck-link-form_layout-vertical .ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical .ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{border:0;padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"],
      names: [],
      mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCACC,SAAU,CACV,oCA8CD,CA5CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CACC,kCAAmC,CACnC,QAAS,CACT,eAAgB,CAChB,QAAS,CACT,gDAAiD,CACjD,SAaD,CAnBA,4GAaE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAWD,CATC,wEACC,QAAS,CACT,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-text-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\tborder-radius: 0;\n\t\tborder: 0;\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\twidth: 50%;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tborder: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{padding:0 var(--ck-spacing-medium);color:var(--ck-color-link-default);text-overflow:ellipsis;cursor:pointer;max-width:var(--ck-input-text-width);min-width:3em;text-align:center}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{min-width:0;max-width:100%}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"],
      names: [],
      mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCKA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EACC,kCAAmC,CACnC,kCAAmC,CACnC,sBAAuB,CACvB,cAAe,CAIf,oCAAqC,CACrC,aAAc,CACd,iBAKD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDvDD,oCC2DC,wDACC,8DAMD,CAJC,0EACC,WAAY,CACZ,cACD,CAGD,gJAME,aAEF,CD1ED",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-text-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, '.ck-media__wrapper .ck-media__placeholder{display:flex;flex-direction:column;align-items:center}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:block}@media (hover:none){.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-tooltip{display:none}}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url:hover .ck-tooltip{visibility:visible;opacity:1}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{overflow:hidden;display:block}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{padding:calc(var(--ck-spacing-standard)*3);background:var(--ck-color-base-foreground)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{min-width:var(--ck-media-embed-placeholder-icon-size);height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);background-position:50%;background-size:cover}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{width:100%;height:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);white-space:nowrap;text-align:center;font-style:italic;text-overflow:ellipsis}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-width:300px;max-height:380px}.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIGZpbGw9IiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"],
      names: [],
      mappings: "AAQC,0CACC,YAAa,CACb,qBAAsB,CACtB,kBAmBD,CCpBA,kFACC,aAqBD,CAHC,oBAnBD,kFAoBE,YAEF,CADC,CDlBA,sEAIC,cAAe,CAEf,iBAUD,CCoBD,wFACC,kBAAmB,CACnB,SACD,CD3BE,wGACC,eAAgB,CAChB,aACD,CAQD,+UACC,YACD,CAYF,2LACC,mBACD,CE/CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA4FD,CA1FC,0CACC,0CAA+C,CAC/C,0CA4BD,CA1BC,uEACC,qDAAsD,CACtD,kDAAmD,CACnD,qCAAsC,CACtC,uBAA2B,CAC3B,qBAMD,CAJC,gFACC,UAAW,CACX,WACD,CAGD,4EACC,sDAAuD,CACvD,kBAAmB,CACnB,iBAAkB,CAClB,iBAAkB,CAClB,sBAOD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDACC,eAAgB,CAChB,gBACD,CAEA,oFACC,gvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,48BACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css";\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t@mixin ck-tooltip_enabled;\n\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t&:hover {\n\t\t\t\t@mixin ck-tooltip_visible;\n\t\t\t}\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI1MDRweCIgaGVpZ2h0PSI1MDRweCIgdmlld0JveD0iMCAwIDUwNCA1MDQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+Z2x5cGgtbG9nb19NYXkyMDE2PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMSIgcG9pbnRzPSIwIDAuMTU5IDUwMy44NDEgMC4xNTkgNTAzLjg0MSA1MDMuOTQgMCA1MDMuOTQiPjwvcG9seWdvbj4gICAgPC9kZWZzPiAgICA8ZyBpZD0iZ2x5cGgtbG9nb19NYXkyMDE2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJHcm91cC0zIj4gICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+ICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+ICAgICAgICAgICAgPC9tYXNrPiAgICAgICAgICAgIDxnIGlkPSJDbGlwLTIiPjwvZz4gICAgICAgICAgICA8cGF0aCBkPSJNMjUxLjkyMSwwLjE1OSBDMTgzLjUwMywwLjE1OSAxNzQuOTI0LDAuNDQ5IDE0OC4wNTQsMS42NzUgQzEyMS4yNCwyLjg5OCAxMDIuOTI3LDcuMTU3IDg2LjkwMywxMy4zODUgQzcwLjMzNywxOS44MjIgNTYuMjg4LDI4LjQzNiA0Mi4yODIsNDIuNDQxIEMyOC4yNzcsNTYuNDQ3IDE5LjY2Myw3MC40OTYgMTMuMjI2LDg3LjA2MiBDNi45OTgsMTAzLjA4NiAyLjczOSwxMjEuMzk5IDEuNTE2LDE0OC4yMTMgQzAuMjksMTc1LjA4MyAwLDE4My42NjIgMCwyNTIuMDggQzAsMzIwLjQ5NyAwLjI5LDMyOS4wNzYgMS41MTYsMzU1Ljk0NiBDMi43MzksMzgyLjc2IDYuOTk4LDQwMS4wNzMgMTMuMjI2LDQxNy4wOTcgQzE5LjY2Myw0MzMuNjYzIDI4LjI3Nyw0NDcuNzEyIDQyLjI4Miw0NjEuNzE4IEM1Ni4yODgsNDc1LjcyMyA3MC4zMzcsNDg0LjMzNyA4Ni45MDMsNDkwLjc3NSBDMTAyLjkyNyw0OTcuMDAyIDEyMS4yNCw1MDEuMjYxIDE0OC4wNTQsNTAyLjQ4NCBDMTc0LjkyNCw1MDMuNzEgMTgzLjUwMyw1MDQgMjUxLjkyMSw1MDQgQzMyMC4zMzgsNTA0IDMyOC45MTcsNTAzLjcxIDM1NS43ODcsNTAyLjQ4NCBDMzgyLjYwMSw1MDEuMjYxIDQwMC45MTQsNDk3LjAwMiA0MTYuOTM4LDQ5MC43NzUgQzQzMy41MDQsNDg0LjMzNyA0NDcuNTUzLDQ3NS43MjMgNDYxLjU1OSw0NjEuNzE4IEM0NzUuNTY0LDQ0Ny43MTIgNDg0LjE3OCw0MzMuNjYzIDQ5MC42MTYsNDE3LjA5NyBDNDk2Ljg0Myw0MDEuMDczIDUwMS4xMDIsMzgyLjc2IDUwMi4zMjUsMzU1Ljk0NiBDNTAzLjU1MSwzMjkuMDc2IDUwMy44NDEsMzIwLjQ5NyA1MDMuODQxLDI1Mi4wOCBDNTAzLjg0MSwxODMuNjYyIDUwMy41NTEsMTc1LjA4MyA1MDIuMzI1LDE0OC4yMTMgQzUwMS4xMDIsMTIxLjM5OSA0OTYuODQzLDEwMy4wODYgNDkwLjYxNiw4Ny4wNjIgQzQ4NC4xNzgsNzAuNDk2IDQ3NS41NjQsNTYuNDQ3IDQ2MS41NTksNDIuNDQxIEM0NDcuNTUzLDI4LjQzNiA0MzMuNTA0LDE5LjgyMiA0MTYuOTM4LDEzLjM4NSBDNDAwLjkxNCw3LjE1NyAzODIuNjAxLDIuODk4IDM1NS43ODcsMS42NzUgQzMyOC45MTcsMC40NDkgMzIwLjMzOCwwLjE1OSAyNTEuOTIxLDAuMTU5IFogTTI1MS45MjEsNDUuNTUgQzMxOS4xODYsNDUuNTUgMzI3LjE1NCw0NS44MDcgMzUzLjcxOCw0Ny4wMTkgQzM3OC4yOCw0OC4xMzkgMzkxLjYxOSw1Mi4yNDMgNDAwLjQ5Niw1NS42OTMgQzQxMi4yNTUsNjAuMjYzIDQyMC42NDcsNjUuNzIyIDQyOS40NjIsNzQuNTM4IEM0MzguMjc4LDgzLjM1MyA0NDMuNzM3LDkxLjc0NSA0NDguMzA3LDEwMy41MDQgQzQ1MS43NTcsMTEyLjM4MSA0NTUuODYxLDEyNS43MiA0NTYuOTgxLDE1MC4yODIgQzQ1OC4xOTMsMTc2Ljg0NiA0NTguNDUsMTg0LjgxNCA0NTguNDUsMjUyLjA4IEM0NTguNDUsMzE5LjM0NSA0NTguMTkzLDMyNy4zMTMgNDU2Ljk4MSwzNTMuODc3IEM0NTUuODYxLDM3OC40MzkgNDUxLjc1NywzOTEuNzc4IDQ0OC4zMDcsNDAwLjY1NSBDNDQzLjczNyw0MTIuNDE0IDQzOC4yNzgsNDIwLjgwNiA0MjkuNDYyLDQyOS42MjEgQzQyMC42NDcsNDM4LjQzNyA0MTIuMjU1LDQ0My44OTYgNDAwLjQ5Niw0NDguNDY2IEMzOTEuNjE5LDQ1MS45MTYgMzc4LjI4LDQ1Ni4wMiAzNTMuNzE4LDQ1Ny4xNCBDMzI3LjE1OCw0NTguMzUyIDMxOS4xOTEsNDU4LjYwOSAyNTEuOTIxLDQ1OC42MDkgQzE4NC42NSw0NTguNjA5IDE3Ni42ODQsNDU4LjM1MiAxNTAuMTIzLDQ1Ny4xNCBDMTI1LjU2MSw0NTYuMDIgMTEyLjIyMiw0NTEuOTE2IDEwMy4zNDUsNDQ4LjQ2NiBDOTEuNTg2LDQ0My44OTYgODMuMTk0LDQzOC40MzcgNzQuMzc5LDQyOS42MjEgQzY1LjU2NCw0MjAuODA2IDYwLjEwNCw0MTIuNDE0IDU1LjUzNCw0MDAuNjU1IEM1Mi4wODQsMzkxLjc3OCA0Ny45OCwzNzguNDM5IDQ2Ljg2LDM1My44NzcgQzQ1LjY0OCwzMjcuMzEzIDQ1LjM5MSwzMTkuMzQ1IDQ1LjM5MSwyNTIuMDggQzQ1LjM5MSwxODQuODE0IDQ1LjY0OCwxNzYuODQ2IDQ2Ljg2LDE1MC4yODIgQzQ3Ljk4LDEyNS43MiA1Mi4wODQsMTEyLjM4MSA1NS41MzQsMTAzLjUwNCBDNjAuMTA0LDkxLjc0NSA2NS41NjMsODMuMzUzIDc0LjM3OSw3NC41MzggQzgzLjE5NCw2NS43MjIgOTEuNTg2LDYwLjI2MyAxMDMuMzQ1LDU1LjY5MyBDMTEyLjIyMiw1Mi4yNDMgMTI1LjU2MSw0OC4xMzkgMTUwLjEyMyw0Ny4wMTkgQzE3Ni42ODcsNDUuODA3IDE4NC42NTUsNDUuNTUgMjUxLjkyMSw0NS41NSBaIiBpZD0iRmlsbC0xIiBmaWxsPSIjRkZGRkZGIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgICAgIDxwYXRoIGQ9Ik0yNTEuOTIxLDMzNi4wNTMgQzIwNS41NDMsMzM2LjA1MyAxNjcuOTQ3LDI5OC40NTcgMTY3Ljk0NywyNTIuMDggQzE2Ny45NDcsMjA1LjcwMiAyMDUuNTQzLDE2OC4xMDYgMjUxLjkyMSwxNjguMTA2IEMyOTguMjk4LDE2OC4xMDYgMzM1Ljg5NCwyMDUuNzAyIDMzNS44OTQsMjUyLjA4IEMzMzUuODk0LDI5OC40NTcgMjk4LjI5OCwzMzYuMDUzIDI1MS45MjEsMzM2LjA1MyBaIE0yNTEuOTIxLDEyMi43MTUgQzE4MC40NzQsMTIyLjcxNSAxMjIuNTU2LDE4MC42MzMgMTIyLjU1NiwyNTIuMDggQzEyMi41NTYsMzIzLjUyNiAxODAuNDc0LDM4MS40NDQgMjUxLjkyMSwzODEuNDQ0IEMzMjMuMzY3LDM4MS40NDQgMzgxLjI4NSwzMjMuNTI2IDM4MS4yODUsMjUyLjA4IEMzODEuMjg1LDE4MC42MzMgMzIzLjM2NywxMjIuNzE1IDI1MS45MjEsMTIyLjcxNSBaIiBpZD0iRmlsbC00IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgICAgICA8cGF0aCBkPSJNNDE2LjYyNywxMTcuNjA0IEM0MTYuNjI3LDEzNC4zIDQwMy4wOTIsMTQ3LjgzNCAzODYuMzk2LDE0Ny44MzQgQzM2OS43MDEsMTQ3LjgzNCAzNTYuMTY2LDEzNC4zIDM1Ni4xNjYsMTE3LjYwNCBDMzU2LjE2NiwxMDAuOTA4IDM2OS43MDEsODcuMzczIDM4Ni4zOTYsODcuMzczIEM0MDMuMDkyLDg3LjM3MyA0MTYuNjI3LDEwMC45MDggNDE2LjYyNywxMTcuNjA0IiBpZD0iRmlsbC01IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgIDwvZz48L3N2Zz4=);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-media-form{display:flex;align-items:flex-start;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css"],
      names: [],
      mappings: "AAOA,kBACC,YAAa,CACb,sBAAuB,CACvB,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content .media{clear:both;margin:1em 0;display:block;min-width:15em}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css"],
      names: [],
      mappings: "AAKA,mBAGC,UAAW,CAGX,YAAa,CAIb,aAAc,CAId,cACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\tmargin: 1em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ":root{--ck-color-table-focused-cell-background:rgba(158,207,250,0.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"],
      names: [],
      mappings: "AAKA,MACC,8DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button .ck-tooltip{display:none}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-right-radius:unset;border-bottom-right-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__action{border-top-left-radius:unset;border-bottom-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-radius:0}.ck-rounded-corners [dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow,[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:unset;border-bottom-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-top-right-radius:unset;border-bottom-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-left-color:var(--ck-color-split-button-hover-border)}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled){border-right-color:var(--ck-color-split-button-hover-border)}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/mixins/_tooltip.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"],
      names: [],
      mappings: "AAOA,mBAEC,iBAUD,CARC,iDACC,qCACD,CC0BA,8DACC,YACD,CClCD,MACC,gDAAyD,CACzD,4CACD,CAMC,qDAGE,6BAA8B,CAC9B,gCAQF,CAZA,qDASE,4BAA6B,CAC7B,+BAEF,CAEA,0CAGC,eAmBD,CAtBA,oDCnBA,eDyCA,CAtBA,+ICfC,qCAAsC,CDuBpC,4BAA6B,CAC7B,+BAaH,CAtBA,oDAeE,6BAA8B,CAC9B,gCAMF,CAHC,8CACC,mCACD,CASA,0KACC,wDACD,CAGC,sKACC,2DACD,CAIA,sKACC,4DACD,CAMF,uCCpEA,eD8EA,CAVA,qHChEC,qCD0ED,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../tooltip/mixins/_tooltip.css";\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n\n\t/* Disable tooltips for the buttons when the button is "open" */\n\t&.ck-splitbutton_open > .ck-button {\n\t\t@mixin ck-tooltip_disabled;\n\t}\n}\n\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Enables the tooltip, which is the tooltip is in DOM but\n * not yet displayed.\n */\n@define-mixin ck-tooltip_enabled {\n\t& .ck-tooltip {\n\t\tdisplay: block;\n\n\t\t/*\n\t\t * Don't display tooltips in devices which don't support :hover.\n\t\t * In fact, it's all about iOS, which forces user to click UI elements twice to execute\n\t\t * the primary action, when tooltips are enabled.\n\t\t *\n\t\t * Q: OK, but why not the following query?\n\t\t *\n\t\t *   @media (hover) {\n\t\t *       display: block;\n\t\t *   }\n\t\t *\n\t\t * A: Because FF does not support it and it would completely disable tooltips\n\t\t * in that browser.\n\t\t *\n\t\t * More in https://github.com/ckeditor/ckeditor5/issues/920.\n\t\t */\n\t\t@media (hover:none) {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/**\n * Disables the tooltip making it disappear from DOM.\n */\n@define-mixin ck-tooltip_disabled {\n\t& .ck-tooltip {\n\t\tdisplay: none;\n\t}\n}\n\n/**\n * Shows the tooltip, which is already in DOM.\n * Requires `ck-tooltip_enabled` first.\n */\n@define-mixin ck-tooltip_visible {\n\t& .ck-tooltip {\n\t\tvisibility: visible;\n\t\topacity: 1;\n\t}\n}\n", '/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t& > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: unset;\n\t\t\t\tborder-bottom-left-radius: unset;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled) {\n\t\t\t\tborder-left-color: var(--ck-color-split-button-hover-border);\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled) {\n\t\t\t\tborder-right-color: var(--ck-color-split-button-hover-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n', "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2);padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0}.ck .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{width:var(--ck-insert-table-dropdown-box-width);height:var(--ck-insert-table-dropdown-box-height);margin:var(--ck-insert-table-dropdown-box-margin);border:1px solid var(--ck-color-base-border);border-radius:1px}.ck .ck-insert-table-dropdown-grid-box.ck-on{border-color:var(--ck-color-focus-border);background:var(--ck-color-focus-outer-shadow)}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css", "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"],
      names: [],
      mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAEC,oJAA2J,CAC3J,yFACD,CAEA,qCACC,iBACD,CAEA,uCACC,+CAAgD,CAChD,iDAAkD,CAClD,iDAAkD,CAClD,4CAA6C,CAC7C,iBAMD,CAJC,6CACC,yCAA0C,CAC1C,6CACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\twidth: var(--ck-insert-table-dropdown-box-width);\n\theight: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ':root{--ck-table-selected-cell-background:rgba(158,207,250,0.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{position:relative;caret-color:transparent;outline:unset;box-shadow:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{content:"";pointer-events:none;background-color:var(--ck-table-selected-cell-background);position:absolute;top:0;left:0;right:0;bottom:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget_selected{outline:unset}', "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"],
      names: [],
      mappings: "AAKA,MACC,yDACD,CAGC,0IAEC,iBAAkB,CAClB,uBAAwB,CACxB,aAAc,CACd,gBAsBD,CAnBC,sJACC,UAAW,CACX,mBAAoB,CACpB,yDAA0D,CAC1D,iBAAkB,CAClB,KAAM,CACN,MAAO,CACP,OAAQ,CACR,QACD,CAEA,wTAEC,4BACD,CAEA,kLACC,aACD",
      sourcesContent: ["/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t& .ck-widget_selected {\n\t\t\toutline: unset;\n\t\t}\n\t}\n}\n"],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e, n) {
    "use strict";

    var o = n(2);
    var i = n.n(o);
    var r = n(3);
    var s = n.n(r);
    var a = s()(i.a);
    a.push([t.i, ".ck-content .table{margin:1em auto;display:table}.ck-content .table table{border-collapse:collapse;border-spacing:0;width:100%;height:100%;border:1px double #b3b3b3}.ck-content .table table td,.ck-content .table table th{min-width:2em;padding:.4em;border:1px solid #bfbfbf}.ck-content .table table th{font-weight:700;background:hsla(0,0%,0%,5%)}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}", "", {
      version: 3,
      sources: ["webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css"],
      names: [],
      mappings: "AAKA,mBAEC,eAAgB,CAChB,aAgCD,CA9BC,yBAEC,wBAAyB,CACzB,gBAAiB,CAIjB,UAAW,CACX,WAAY,CAIZ,yBAiBD,CAfC,wDAEC,aAAc,CACd,YAAa,CAKb,wBACD,CAEA,4BACC,eAAiB,CACjB,2BACD,CAMF,+BACC,gBACD,CAEA,+BACC,eACD",
      sourcesContent: ['/*\n * Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\tmargin: 1em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the ediitor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n'],
      sourceRoot: ""
    }]);
    e["a"] = a;
  }, function (t, e) {
    var n;
    n = function () {
      return this;
    }();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      if (typeof window === "object") n = window;
    }
    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    function o() {
      return false;
    }
    e["a"] = o;
  }, function (t, e, n) {
    "use strict";

    var _marked = /*#__PURE__*/_regeneratorRuntime().mark($m),
      _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(Zm),
      _marked3 = /*#__PURE__*/_regeneratorRuntime().mark(rg),
      _marked4 = /*#__PURE__*/_regeneratorRuntime().mark(sg),
      _marked6 = /*#__PURE__*/_regeneratorRuntime().mark(Zv);
    n.r(e);
    var o = n(5);
    var i = o["a"].Symbol;
    var r = i;
    var s = Object.prototype;
    var a = s.hasOwnProperty;
    var c = s.toString;
    var l = r ? r.toStringTag : undefined;
    function d(t) {
      var e = a.call(t, l),
        n = t[l];
      try {
        t[l] = undefined;
        var o = true;
      } catch (t) {}
      var i = c.call(t);
      if (o) {
        if (e) {
          t[l] = n;
        } else {
          delete t[l];
        }
      }
      return i;
    }
    var u = d;
    var h = Object.prototype;
    var f = h.toString;
    function m(t) {
      return f.call(t);
    }
    var g = m;
    var p = "[object Null]",
      k = "[object Undefined]";
    var b = r ? r.toStringTag : undefined;
    function w(t) {
      if (t == null) {
        return t === undefined ? k : p;
      }
      return b && b in Object(t) ? u(t) : g(t);
    }
    var C = w;
    function A(t, e) {
      return function (n) {
        return t(e(n));
      };
    }
    var _ = A;
    var v = _(Object.getPrototypeOf, Object);
    var y = v;
    function x(t) {
      return t != null && typeof t == "object";
    }
    var D = x;
    var E = "[object Object]";
    var M = Function.prototype,
      S = Object.prototype;
    var T = M.toString;
    var I = S.hasOwnProperty;
    var N = T.call(Object);
    function P(t) {
      if (!D(t) || C(t) != E) {
        return false;
      }
      var e = y(t);
      if (e === null) {
        return true;
      }
      var n = I.call(e, "constructor") && e.constructor;
      return typeof n == "function" && n instanceof n && T.call(n) == N;
    }
    var B = P;
    function z() {
      this.__data__ = [];
      this.size = 0;
    }
    var L = z;
    function O(t, e) {
      return t === e || t !== t && e !== e;
    }
    var R = O;
    function j(t, e) {
      var n = t.length;
      while (n--) {
        if (R(t[n][0], e)) {
          return n;
        }
      }
      return -1;
    }
    var F = j;
    var V = Array.prototype;
    var U = V.splice;
    function H(t) {
      var e = this.__data__,
        n = F(e, t);
      if (n < 0) {
        return false;
      }
      var o = e.length - 1;
      if (n == o) {
        e.pop();
      } else {
        U.call(e, n, 1);
      }
      --this.size;
      return true;
    }
    var G = H;
    function W(t) {
      var e = this.__data__,
        n = F(e, t);
      return n < 0 ? undefined : e[n][1];
    }
    var K = W;
    function q(t) {
      return F(this.__data__, t) > -1;
    }
    var Y = q;
    function Q(t, e) {
      var n = this.__data__,
        o = F(n, t);
      if (o < 0) {
        ++this.size;
        n.push([t, e]);
      } else {
        n[o][1] = e;
      }
      return this;
    }
    var $ = Q;
    function Z(t) {
      var e = -1,
        n = t == null ? 0 : t.length;
      this.clear();
      while (++e < n) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    Z.prototype.clear = L;
    Z.prototype["delete"] = G;
    Z.prototype.get = K;
    Z.prototype.has = Y;
    Z.prototype.set = $;
    var J = Z;
    function X() {
      this.__data__ = new J();
      this.size = 0;
    }
    var tt = X;
    function et(t) {
      var e = this.__data__,
        n = e["delete"](t);
      this.size = e.size;
      return n;
    }
    var nt = et;
    function ot(t) {
      return this.__data__.get(t);
    }
    var it = ot;
    function rt(t) {
      return this.__data__.has(t);
    }
    var st = rt;
    function at(t) {
      var e = typeof t;
      return t != null && (e == "object" || e == "function");
    }
    var ct = at;
    var lt = "[object AsyncFunction]",
      dt = "[object Function]",
      ut = "[object GeneratorFunction]",
      ht = "[object Proxy]";
    function ft(t) {
      if (!ct(t)) {
        return false;
      }
      var e = C(t);
      return e == dt || e == ut || e == lt || e == ht;
    }
    var mt = ft;
    var gt = o["a"]["__core-js_shared__"];
    var pt = gt;
    var kt = function () {
      var t = /[^.]+$/.exec(pt && pt.keys && pt.keys.IE_PROTO || "");
      return t ? "Symbol(src)_1." + t : "";
    }();
    function bt(t) {
      return !!kt && kt in t;
    }
    var wt = bt;
    var Ct = Function.prototype;
    var At = Ct.toString;
    function _t(t) {
      if (t != null) {
        try {
          return At.call(t);
        } catch (t) {}
        try {
          return t + "";
        } catch (t) {}
      }
      return "";
    }
    var vt = _t;
    var yt = /[\\^$.*+?()[\]{}|]/g;
    var xt = /^\[object .+?Constructor\]$/;
    var Dt = Function.prototype,
      Et = Object.prototype;
    var Mt = Dt.toString;
    var St = Et.hasOwnProperty;
    var Tt = RegExp("^" + Mt.call(St).replace(yt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    function It(t) {
      if (!ct(t) || wt(t)) {
        return false;
      }
      var e = mt(t) ? Tt : xt;
      return e.test(vt(t));
    }
    var Nt = It;
    function Pt(t, e) {
      return t == null ? undefined : t[e];
    }
    var Bt = Pt;
    function zt(t, e) {
      var n = Bt(t, e);
      return Nt(n) ? n : undefined;
    }
    var Lt = zt;
    var Ot = Lt(o["a"], "Map");
    var Rt = Ot;
    var jt = Lt(Object, "create");
    var Ft = jt;
    function Vt() {
      this.__data__ = Ft ? Ft(null) : {};
      this.size = 0;
    }
    var Ut = Vt;
    function Ht(t) {
      var e = this.has(t) && delete this.__data__[t];
      this.size -= e ? 1 : 0;
      return e;
    }
    var Gt = Ht;
    var Wt = "__lodash_hash_undefined__";
    var Kt = Object.prototype;
    var qt = Kt.hasOwnProperty;
    function Yt(t) {
      var e = this.__data__;
      if (Ft) {
        var n = e[t];
        return n === Wt ? undefined : n;
      }
      return qt.call(e, t) ? e[t] : undefined;
    }
    var Qt = Yt;
    var $t = Object.prototype;
    var Zt = $t.hasOwnProperty;
    function Jt(t) {
      var e = this.__data__;
      return Ft ? e[t] !== undefined : Zt.call(e, t);
    }
    var Xt = Jt;
    var te = "__lodash_hash_undefined__";
    function ee(t, e) {
      var n = this.__data__;
      this.size += this.has(t) ? 0 : 1;
      n[t] = Ft && e === undefined ? te : e;
      return this;
    }
    var ne = ee;
    function oe(t) {
      var e = -1,
        n = t == null ? 0 : t.length;
      this.clear();
      while (++e < n) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    oe.prototype.clear = Ut;
    oe.prototype["delete"] = Gt;
    oe.prototype.get = Qt;
    oe.prototype.has = Xt;
    oe.prototype.set = ne;
    var ie = oe;
    function re() {
      this.size = 0;
      this.__data__ = {
        hash: new ie(),
        map: new (Rt || J)(),
        string: new ie()
      };
    }
    var se = re;
    function ae(t) {
      var e = typeof t;
      return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
    }
    var ce = ae;
    function le(t, e) {
      var n = t.__data__;
      return ce(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
    }
    var de = le;
    function ue(t) {
      var e = de(this, t)["delete"](t);
      this.size -= e ? 1 : 0;
      return e;
    }
    var he = ue;
    function fe(t) {
      return de(this, t).get(t);
    }
    var me = fe;
    function ge(t) {
      return de(this, t).has(t);
    }
    var pe = ge;
    function ke(t, e) {
      var n = de(this, t),
        o = n.size;
      n.set(t, e);
      this.size += n.size == o ? 0 : 1;
      return this;
    }
    var be = ke;
    function we(t) {
      var e = -1,
        n = t == null ? 0 : t.length;
      this.clear();
      while (++e < n) {
        var o = t[e];
        this.set(o[0], o[1]);
      }
    }
    we.prototype.clear = se;
    we.prototype["delete"] = he;
    we.prototype.get = me;
    we.prototype.has = pe;
    we.prototype.set = be;
    var Ce = we;
    var Ae = 200;
    function _e(t, e) {
      var n = this.__data__;
      if (n instanceof J) {
        var o = n.__data__;
        if (!Rt || o.length < Ae - 1) {
          o.push([t, e]);
          this.size = ++n.size;
          return this;
        }
        n = this.__data__ = new Ce(o);
      }
      n.set(t, e);
      this.size = n.size;
      return this;
    }
    var ve = _e;
    function ye(t) {
      var e = this.__data__ = new J(t);
      this.size = e.size;
    }
    ye.prototype.clear = tt;
    ye.prototype["delete"] = nt;
    ye.prototype.get = it;
    ye.prototype.has = st;
    ye.prototype.set = ve;
    var xe = ye;
    function De(t, e) {
      var n = -1,
        o = t == null ? 0 : t.length;
      while (++n < o) {
        if (e(t[n], n, t) === false) {
          break;
        }
      }
      return t;
    }
    var Ee = De;
    var Me = function () {
      try {
        var t = Lt(Object, "defineProperty");
        t({}, "", {});
        return t;
      } catch (t) {}
    }();
    var Se = Me;
    function Te(t, e, n) {
      if (e == "__proto__" && Se) {
        Se(t, e, {
          configurable: true,
          enumerable: true,
          value: n,
          writable: true
        });
      } else {
        t[e] = n;
      }
    }
    var Ie = Te;
    var Ne = Object.prototype;
    var Pe = Ne.hasOwnProperty;
    function Be(t, e, n) {
      var o = t[e];
      if (!(Pe.call(t, e) && R(o, n)) || n === undefined && !(e in t)) {
        Ie(t, e, n);
      }
    }
    var ze = Be;
    function Le(t, e, n, o) {
      var i = !n;
      n || (n = {});
      var r = -1,
        s = e.length;
      while (++r < s) {
        var a = e[r];
        var c = o ? o(n[a], t[a], a, n, t) : undefined;
        if (c === undefined) {
          c = t[a];
        }
        if (i) {
          Ie(n, a, c);
        } else {
          ze(n, a, c);
        }
      }
      return n;
    }
    var Oe = Le;
    function Re(t, e) {
      var n = -1,
        o = Array(t);
      while (++n < t) {
        o[n] = e(n);
      }
      return o;
    }
    var je = Re;
    var Fe = "[object Arguments]";
    function Ve(t) {
      return D(t) && C(t) == Fe;
    }
    var Ue = Ve;
    var He = Object.prototype;
    var Ge = He.hasOwnProperty;
    var We = He.propertyIsEnumerable;
    var Ke = Ue(function () {
      return arguments;
    }()) ? Ue : function (t) {
      return D(t) && Ge.call(t, "callee") && !We.call(t, "callee");
    };
    var qe = Ke;
    var Ye = Array.isArray;
    var Qe = Ye;
    var $e = n(6);
    var Ze = 9007199254740991;
    var Je = /^(?:0|[1-9]\d*)$/;
    function Xe(t, e) {
      var n = typeof t;
      e = e == null ? Ze : e;
      return !!e && (n == "number" || n != "symbol" && Je.test(t)) && t > -1 && t % 1 == 0 && t < e;
    }
    var tn = Xe;
    var en = 9007199254740991;
    function nn(t) {
      return typeof t == "number" && t > -1 && t % 1 == 0 && t <= en;
    }
    var on = nn;
    var rn = "[object Arguments]",
      sn = "[object Array]",
      an = "[object Boolean]",
      cn = "[object Date]",
      ln = "[object Error]",
      dn = "[object Function]",
      un = "[object Map]",
      hn = "[object Number]",
      fn = "[object Object]",
      mn = "[object RegExp]",
      gn = "[object Set]",
      pn = "[object String]",
      kn = "[object WeakMap]";
    var bn = "[object ArrayBuffer]",
      wn = "[object DataView]",
      Cn = "[object Float32Array]",
      An = "[object Float64Array]",
      _n = "[object Int8Array]",
      vn = "[object Int16Array]",
      yn = "[object Int32Array]",
      xn = "[object Uint8Array]",
      Dn = "[object Uint8ClampedArray]",
      En = "[object Uint16Array]",
      Mn = "[object Uint32Array]";
    var Sn = {};
    Sn[Cn] = Sn[An] = Sn[_n] = Sn[vn] = Sn[yn] = Sn[xn] = Sn[Dn] = Sn[En] = Sn[Mn] = true;
    Sn[rn] = Sn[sn] = Sn[bn] = Sn[an] = Sn[wn] = Sn[cn] = Sn[ln] = Sn[dn] = Sn[un] = Sn[hn] = Sn[fn] = Sn[mn] = Sn[gn] = Sn[pn] = Sn[kn] = false;
    function Tn(t) {
      return D(t) && on(t.length) && !!Sn[C(t)];
    }
    var In = Tn;
    function Nn(t) {
      return function (e) {
        return t(e);
      };
    }
    var Pn = Nn;
    var Bn = n(7);
    var zn = Bn["a"] && Bn["a"].isTypedArray;
    var Ln = zn ? Pn(zn) : In;
    var On = Ln;
    var Rn = Object.prototype;
    var jn = Rn.hasOwnProperty;
    function Fn(t, e) {
      var n = Qe(t),
        o = !n && qe(t),
        i = !n && !o && Object($e["a"])(t),
        r = !n && !o && !i && On(t),
        s = n || o || i || r,
        a = s ? je(t.length, String) : [],
        c = a.length;
      for (var l in t) {
        if ((e || jn.call(t, l)) && !(s && (l == "length" || i && (l == "offset" || l == "parent") || r && (l == "buffer" || l == "byteLength" || l == "byteOffset") || tn(l, c)))) {
          a.push(l);
        }
      }
      return a;
    }
    var Vn = Fn;
    var Un = Object.prototype;
    function Hn(t) {
      var e = t && t.constructor,
        n = typeof e == "function" && e.prototype || Un;
      return t === n;
    }
    var Gn = Hn;
    var Wn = _(Object.keys, Object);
    var Kn = Wn;
    var qn = Object.prototype;
    var Yn = qn.hasOwnProperty;
    function Qn(t) {
      if (!Gn(t)) {
        return Kn(t);
      }
      var e = [];
      for (var n in Object(t)) {
        if (Yn.call(t, n) && n != "constructor") {
          e.push(n);
        }
      }
      return e;
    }
    var $n = Qn;
    function Zn(t) {
      return t != null && on(t.length) && !mt(t);
    }
    var Jn = Zn;
    function Xn(t) {
      return Jn(t) ? Vn(t) : $n(t);
    }
    var to = Xn;
    function eo(t, e) {
      return t && Oe(e, to(e), t);
    }
    var no = eo;
    function oo(t) {
      var e = [];
      if (t != null) {
        for (var n in Object(t)) {
          e.push(n);
        }
      }
      return e;
    }
    var io = oo;
    var ro = Object.prototype;
    var so = ro.hasOwnProperty;
    function ao(t) {
      if (!ct(t)) {
        return io(t);
      }
      var e = Gn(t),
        n = [];
      for (var o in t) {
        if (!(o == "constructor" && (e || !so.call(t, o)))) {
          n.push(o);
        }
      }
      return n;
    }
    var co = ao;
    function lo(t) {
      return Jn(t) ? Vn(t, true) : co(t);
    }
    var uo = lo;
    function ho(t, e) {
      return t && Oe(e, uo(e), t);
    }
    var fo = ho;
    var mo = n(10);
    function go(t, e) {
      var n = -1,
        o = t.length;
      e || (e = Array(o));
      while (++n < o) {
        e[n] = t[n];
      }
      return e;
    }
    var po = go;
    function ko(t, e) {
      var n = -1,
        o = t == null ? 0 : t.length,
        i = 0,
        r = [];
      while (++n < o) {
        var s = t[n];
        if (e(s, n, t)) {
          r[i++] = s;
        }
      }
      return r;
    }
    var bo = ko;
    function wo() {
      return [];
    }
    var Co = wo;
    var Ao = Object.prototype;
    var _o = Ao.propertyIsEnumerable;
    var vo = Object.getOwnPropertySymbols;
    var yo = !vo ? Co : function (t) {
      if (t == null) {
        return [];
      }
      t = Object(t);
      return bo(vo(t), function (e) {
        return _o.call(t, e);
      });
    };
    var xo = yo;
    function Do(t, e) {
      return Oe(t, xo(t), e);
    }
    var Eo = Do;
    function Mo(t, e) {
      var n = -1,
        o = e.length,
        i = t.length;
      while (++n < o) {
        t[i + n] = e[n];
      }
      return t;
    }
    var So = Mo;
    var To = Object.getOwnPropertySymbols;
    var Io = !To ? Co : function (t) {
      var e = [];
      while (t) {
        So(e, xo(t));
        t = y(t);
      }
      return e;
    };
    var No = Io;
    function Po(t, e) {
      return Oe(t, No(t), e);
    }
    var Bo = Po;
    function zo(t, e, n) {
      var o = e(t);
      return Qe(t) ? o : So(o, n(t));
    }
    var Lo = zo;
    function Oo(t) {
      return Lo(t, to, xo);
    }
    var Ro = Oo;
    function jo(t) {
      return Lo(t, uo, No);
    }
    var Fo = jo;
    var Vo = Lt(o["a"], "DataView");
    var Uo = Vo;
    var Ho = Lt(o["a"], "Promise");
    var Go = Ho;
    var Wo = Lt(o["a"], "Set");
    var Ko = Wo;
    var qo = Lt(o["a"], "WeakMap");
    var Yo = qo;
    var Qo = "[object Map]",
      $o = "[object Object]",
      Zo = "[object Promise]",
      Jo = "[object Set]",
      Xo = "[object WeakMap]";
    var ti = "[object DataView]";
    var ei = vt(Uo),
      ni = vt(Rt),
      oi = vt(Go),
      ii = vt(Ko),
      ri = vt(Yo);
    var si = C;
    if (Uo && si(new Uo(new ArrayBuffer(1))) != ti || Rt && si(new Rt()) != Qo || Go && si(Go.resolve()) != Zo || Ko && si(new Ko()) != Jo || Yo && si(new Yo()) != Xo) {
      si = function si(t) {
        var e = C(t),
          n = e == $o ? t.constructor : undefined,
          o = n ? vt(n) : "";
        if (o) {
          switch (o) {
            case ei:
              return ti;
            case ni:
              return Qo;
            case oi:
              return Zo;
            case ii:
              return Jo;
            case ri:
              return Xo;
          }
        }
        return e;
      };
    }
    var ai = si;
    var ci = Object.prototype;
    var li = ci.hasOwnProperty;
    function di(t) {
      var e = t.length,
        n = new t.constructor(e);
      if (e && typeof t[0] == "string" && li.call(t, "index")) {
        n.index = t.index;
        n.input = t.input;
      }
      return n;
    }
    var ui = di;
    var hi = o["a"].Uint8Array;
    var fi = hi;
    function mi(t) {
      var e = new t.constructor(t.byteLength);
      new fi(e).set(new fi(t));
      return e;
    }
    var gi = mi;
    function pi(t, e) {
      var n = e ? gi(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.byteLength);
    }
    var ki = pi;
    var bi = /\w*$/;
    function wi(t) {
      var e = new t.constructor(t.source, bi.exec(t));
      e.lastIndex = t.lastIndex;
      return e;
    }
    var Ci = wi;
    var Ai = r ? r.prototype : undefined,
      _i = Ai ? Ai.valueOf : undefined;
    function vi(t) {
      return _i ? Object(_i.call(t)) : {};
    }
    var yi = vi;
    function xi(t, e) {
      var n = e ? gi(t.buffer) : t.buffer;
      return new t.constructor(n, t.byteOffset, t.length);
    }
    var Di = xi;
    var Ei = "[object Boolean]",
      Mi = "[object Date]",
      Si = "[object Map]",
      Ti = "[object Number]",
      Ii = "[object RegExp]",
      Ni = "[object Set]",
      Pi = "[object String]",
      Bi = "[object Symbol]";
    var zi = "[object ArrayBuffer]",
      Li = "[object DataView]",
      Oi = "[object Float32Array]",
      Ri = "[object Float64Array]",
      ji = "[object Int8Array]",
      Fi = "[object Int16Array]",
      Vi = "[object Int32Array]",
      Ui = "[object Uint8Array]",
      Hi = "[object Uint8ClampedArray]",
      Gi = "[object Uint16Array]",
      Wi = "[object Uint32Array]";
    function Ki(t, e, n) {
      var o = t.constructor;
      switch (e) {
        case zi:
          return gi(t);
        case Ei:
        case Mi:
          return new o(+t);
        case Li:
          return ki(t, n);
        case Oi:
        case Ri:
        case ji:
        case Fi:
        case Vi:
        case Ui:
        case Hi:
        case Gi:
        case Wi:
          return Di(t, n);
        case Si:
          return new o();
        case Ti:
        case Pi:
          return new o(t);
        case Ii:
          return Ci(t);
        case Ni:
          return new o();
        case Bi:
          return yi(t);
      }
    }
    var qi = Ki;
    var Yi = Object.create;
    var Qi = function () {
      function t() {}
      return function (e) {
        if (!ct(e)) {
          return {};
        }
        if (Yi) {
          return Yi(e);
        }
        t.prototype = e;
        var n = new t();
        t.prototype = undefined;
        return n;
      };
    }();
    var $i = Qi;
    function Zi(t) {
      return typeof t.constructor == "function" && !Gn(t) ? $i(y(t)) : {};
    }
    var Ji = Zi;
    var Xi = "[object Map]";
    function tr(t) {
      return D(t) && ai(t) == Xi;
    }
    var er = tr;
    var nr = Bn["a"] && Bn["a"].isMap;
    var or = nr ? Pn(nr) : er;
    var ir = or;
    var rr = "[object Set]";
    function sr(t) {
      return D(t) && ai(t) == rr;
    }
    var ar = sr;
    var cr = Bn["a"] && Bn["a"].isSet;
    var lr = cr ? Pn(cr) : ar;
    var dr = lr;
    var ur = 1,
      hr = 2,
      fr = 4;
    var mr = "[object Arguments]",
      gr = "[object Array]",
      pr = "[object Boolean]",
      kr = "[object Date]",
      br = "[object Error]",
      wr = "[object Function]",
      Cr = "[object GeneratorFunction]",
      Ar = "[object Map]",
      _r = "[object Number]",
      vr = "[object Object]",
      yr = "[object RegExp]",
      xr = "[object Set]",
      Dr = "[object String]",
      Er = "[object Symbol]",
      Mr = "[object WeakMap]";
    var Sr = "[object ArrayBuffer]",
      Tr = "[object DataView]",
      Ir = "[object Float32Array]",
      Nr = "[object Float64Array]",
      Pr = "[object Int8Array]",
      Br = "[object Int16Array]",
      zr = "[object Int32Array]",
      Lr = "[object Uint8Array]",
      Or = "[object Uint8ClampedArray]",
      Rr = "[object Uint16Array]",
      jr = "[object Uint32Array]";
    var Fr = {};
    Fr[mr] = Fr[gr] = Fr[Sr] = Fr[Tr] = Fr[pr] = Fr[kr] = Fr[Ir] = Fr[Nr] = Fr[Pr] = Fr[Br] = Fr[zr] = Fr[Ar] = Fr[_r] = Fr[vr] = Fr[yr] = Fr[xr] = Fr[Dr] = Fr[Er] = Fr[Lr] = Fr[Or] = Fr[Rr] = Fr[jr] = true;
    Fr[br] = Fr[wr] = Fr[Mr] = false;
    function Vr(t, e, n, o, i, r) {
      var s,
        a = e & ur,
        c = e & hr,
        l = e & fr;
      if (n) {
        s = i ? n(t, o, i, r) : n(t);
      }
      if (s !== undefined) {
        return s;
      }
      if (!ct(t)) {
        return t;
      }
      var d = Qe(t);
      if (d) {
        s = ui(t);
        if (!a) {
          return po(t, s);
        }
      } else {
        var u = ai(t),
          h = u == wr || u == Cr;
        if (Object($e["a"])(t)) {
          return Object(mo["a"])(t, a);
        }
        if (u == vr || u == mr || h && !i) {
          s = c || h ? {} : Ji(t);
          if (!a) {
            return c ? Bo(t, fo(s, t)) : Eo(t, no(s, t));
          }
        } else {
          if (!Fr[u]) {
            return i ? t : {};
          }
          s = qi(t, u, a);
        }
      }
      r || (r = new xe());
      var f = r.get(t);
      if (f) {
        return f;
      }
      r.set(t, s);
      if (dr(t)) {
        t.forEach(function (o) {
          s.add(Vr(o, e, n, o, t, r));
        });
      } else if (ir(t)) {
        t.forEach(function (o, i) {
          s.set(i, Vr(o, e, n, i, t, r));
        });
      }
      var m = l ? c ? Fo : Ro : c ? keysIn : to;
      var g = d ? undefined : m(t);
      Ee(g || t, function (o, i) {
        if (g) {
          i = o;
          o = t[i];
        }
        ze(s, i, Vr(o, e, n, i, t, r));
      });
      return s;
    }
    var Ur = Vr;
    var Hr = 1,
      Gr = 4;
    function Wr(t, e) {
      e = typeof e == "function" ? e : undefined;
      return Ur(t, Hr | Gr, e);
    }
    var Kr = Wr;
    function qr(t) {
      return D(t) && t.nodeType === 1 && !B(t);
    }
    var Yr = qr;
    var Qr = /*#__PURE__*/function () {
      function Qr(t, e) {
        _classCallCheck(this, Qr);
        this._config = {};
        if (e) {
          this.define($r(e));
        }
        if (t) {
          this._setObjectToTarget(this._config, t);
        }
      }
      _createClass(Qr, [{
        key: "set",
        value: function set(t, e) {
          this._setToTarget(this._config, t, e);
        }
      }, {
        key: "define",
        value: function define(t, e) {
          var n = true;
          this._setToTarget(this._config, t, e, n);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._getFromSource(this._config, t);
        }
      }, {
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          var _i2, _Object$keys, _t2;
          return _regeneratorRuntime().wrap(function names$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _i2 = 0, _Object$keys = Object.keys(this._config);
              case 1:
                if (!(_i2 < _Object$keys.length)) {
                  _context.next = 8;
                  break;
                }
                _t2 = _Object$keys[_i2];
                _context.next = 5;
                return _t2;
              case 5:
                _i2++;
                _context.next = 1;
                break;
              case 8:
              case "end":
                return _context.stop();
            }
          }, names, this);
        })
      }, {
        key: "_setToTarget",
        value: function _setToTarget(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          if (B(e)) {
            this._setObjectToTarget(t, e, o);
            return;
          }
          var i = e.split(".");
          e = i.pop();
          var _iterator = _createForOfIteratorHelper(i),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _e2 = _step.value;
              if (!B(t[_e2])) {
                t[_e2] = {};
              }
              t = t[_e2];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          if (B(n)) {
            if (!B(t[e])) {
              t[e] = {};
            }
            t = t[e];
            this._setObjectToTarget(t, n, o);
            return;
          }
          if (o && typeof t[e] != "undefined") {
            return;
          }
          t[e] = n;
        }
      }, {
        key: "_getFromSource",
        value: function _getFromSource(t, e) {
          var n = e.split(".");
          e = n.pop();
          var _iterator2 = _createForOfIteratorHelper(n),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _e3 = _step2.value;
              if (!B(t[_e3])) {
                t = null;
                break;
              }
              t = t[_e3];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return t ? $r(t[e]) : undefined;
        }
      }, {
        key: "_setObjectToTarget",
        value: function _setObjectToTarget(t, e, n) {
          var _this2 = this;
          Object.keys(e).forEach(function (o) {
            _this2._setToTarget(t, o, e[o], n);
          });
        }
      }]);
      return Qr;
    }();
    function $r(t) {
      return Kr(t, Zr);
    }
    function Zr(t) {
      return Yr(t) ? t : undefined;
    }
    function Jr() {
      return function t() {
        t.called = true;
      };
    }
    var Xr = Jr;
    var ts = function ts(t, e) {
      _classCallCheck(this, ts);
      this.source = t;
      this.name = e;
      this.path = [];
      this.stop = Xr();
      this.off = Xr();
    };
    var es = new Array(256).fill().map(function (t, e) {
      return ("0" + e.toString(16)).slice(-2);
    });
    function ns() {
      var t = Math.random() * 4294967296 >>> 0;
      var e = Math.random() * 4294967296 >>> 0;
      var n = Math.random() * 4294967296 >>> 0;
      var o = Math.random() * 4294967296 >>> 0;
      return "e" + es[t >> 0 & 255] + es[t >> 8 & 255] + es[t >> 16 & 255] + es[t >> 24 & 255] + es[e >> 0 & 255] + es[e >> 8 & 255] + es[e >> 16 & 255] + es[e >> 24 & 255] + es[n >> 0 & 255] + es[n >> 8 & 255] + es[n >> 16 & 255] + es[n >> 24 & 255] + es[o >> 0 & 255] + es[o >> 8 & 255] + es[o >> 16 & 255] + es[o >> 24 & 255];
    }
    var os = {
      get: function get(t) {
        if (typeof t != "number") {
          return this[t] || this.normal;
        } else {
          return t;
        }
      },
      highest: 1e5,
      high: 1e3,
      normal: 0,
      low: -1e3,
      lowest: -1e5
    };
    var is = os;
    var rs = n(8);
    var ss = n(0);
    var as = Symbol("listeningTo");
    var cs = Symbol("emitterId");
    var ls = {
      on: function on(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.listenTo(this, t, e, n);
      },
      once: function once(t, e, n) {
        var o = false;
        var i = function i(t) {
          if (!o) {
            o = true;
            t.off();
            for (var _len = arguments.length, n = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              n[_key - 1] = arguments[_key];
            }
            e.call.apply(e, [this, t].concat(n));
          }
        };
        this.listenTo(this, t, i, n);
      },
      off: function off(t, e) {
        this.stopListening(this, t, e);
      },
      listenTo: function listenTo(t, e, n) {
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var i, r;
        if (!this[as]) {
          this[as] = {};
        }
        var s = this[as];
        if (!fs(t)) {
          hs(t);
        }
        var a = fs(t);
        if (!(i = s[a])) {
          i = s[a] = {
            emitter: t,
            callbacks: {}
          };
        }
        if (!(r = i.callbacks[e])) {
          r = i.callbacks[e] = [];
        }
        r.push(n);
        ps(t, e);
        var c = ks(t, e);
        var l = is.get(o.priority);
        var d = {
          callback: n,
          priority: l
        };
        var _iterator3 = _createForOfIteratorHelper(c),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t3 = _step3.value;
            var _e4 = false;
            for (var _n2 = 0; _n2 < _t3.length; _n2++) {
              if (_t3[_n2].priority < l) {
                _t3.splice(_n2, 0, d);
                _e4 = true;
                break;
              }
            }
            if (!_e4) {
              _t3.push(d);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      },
      stopListening: function stopListening(t, e, n) {
        var o = this[as];
        var i = t && fs(t);
        var r = o && i && o[i];
        var s = r && e && r.callbacks[e];
        if (!o || t && !r || e && !s) {
          return;
        }
        if (n) {
          Cs(t, e, n);
          var _o2 = s.indexOf(n);
          if (_o2 !== -1) {
            if (s.length === 1) {
              delete r.callbacks[e];
            } else {
              Cs(t, e, n);
            }
          }
        } else if (s) {
          while (n = s.pop()) {
            Cs(t, e, n);
          }
          delete r.callbacks[e];
        } else if (r) {
          for (e in r.callbacks) {
            this.stopListening(t, e);
          }
          delete o[i];
        } else {
          for (i in o) {
            this.stopListening(o[i].emitter);
          }
          delete this[as];
        }
      },
      fire: function fire(t) {
        try {
          var _n3 = t instanceof ts ? t : new ts(this, t);
          var _o3 = _n3.name;
          var _i3 = bs(this, _o3);
          _n3.path.push(this);
          for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            e[_key2 - 1] = arguments[_key2];
          }
          if (_i3) {
            var _t4 = [_n3].concat(e);
            _i3 = Array.from(_i3);
            for (var _e5 = 0; _e5 < _i3.length; _e5++) {
              _i3[_e5].callback.apply(this, _t4);
              if (_n3.off.called) {
                delete _n3.off.called;
                Cs(this, _o3, _i3[_e5].callback);
              }
              if (_n3.stop.called) {
                break;
              }
            }
          }
          if (this._delegations) {
            var _t5 = this._delegations.get(_o3);
            var _i4 = this._delegations.get("*");
            if (_t5) {
              ws(_t5, _n3, e);
            }
            if (_i4) {
              ws(_i4, _n3, e);
            }
          }
          return _n3.return;
        } catch (t) {
          ss["a"].rethrowUnexpectedError(t, this);
        }
      },
      delegate: function delegate() {
        var _this3 = this;
        for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          t[_key3] = arguments[_key3];
        }
        return {
          to: function to(e, n) {
            if (!_this3._delegations) {
              _this3._delegations = new Map();
            }
            t.forEach(function (t) {
              var o = _this3._delegations.get(t);
              if (!o) {
                _this3._delegations.set(t, new Map([[e, n]]));
              } else {
                o.set(e, n);
              }
            });
          }
        };
      },
      stopDelegating: function stopDelegating(t, e) {
        if (!this._delegations) {
          return;
        }
        if (!t) {
          this._delegations.clear();
        } else if (!e) {
          this._delegations.delete(t);
        } else {
          var _n4 = this._delegations.get(t);
          if (_n4) {
            _n4.delete(e);
          }
        }
      }
    };
    var ds = ls;
    function us(t, e) {
      if (t[as] && t[as][e]) {
        return t[as][e].emitter;
      }
      return null;
    }
    function hs(t, e) {
      if (!t[cs]) {
        t[cs] = e || ns();
      }
    }
    function fs(t) {
      return t[cs];
    }
    function ms(t) {
      if (!t._events) {
        Object.defineProperty(t, "_events", {
          value: {}
        });
      }
      return t._events;
    }
    function gs() {
      return {
        callbacks: [],
        childEvents: []
      };
    }
    function ps(t, e) {
      var n = ms(t);
      if (n[e]) {
        return;
      }
      var o = e;
      var i = null;
      var r = [];
      while (o !== "") {
        if (n[o]) {
          break;
        }
        n[o] = gs();
        r.push(n[o]);
        if (i) {
          n[o].childEvents.push(i);
        }
        i = o;
        o = o.substr(0, o.lastIndexOf(":"));
      }
      if (o !== "") {
        var _iterator4 = _createForOfIteratorHelper(r),
          _step4;
        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t6 = _step4.value;
            _t6.callbacks = n[o].callbacks.slice();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
        n[o].childEvents.push(i);
      }
    }
    function ks(t, e) {
      var n = ms(t)[e];
      if (!n) {
        return [];
      }
      var o = [n.callbacks];
      for (var _e6 = 0; _e6 < n.childEvents.length; _e6++) {
        var _i5 = ks(t, n.childEvents[_e6]);
        o = o.concat(_i5);
      }
      return o;
    }
    function bs(t, e) {
      var n;
      if (!t._events || !(n = t._events[e]) || !n.callbacks.length) {
        if (e.indexOf(":") > -1) {
          return bs(t, e.substr(0, e.lastIndexOf(":")));
        } else {
          return null;
        }
      }
      return n.callbacks;
    }
    function ws(t, e, n) {
      var _iterator5 = _createForOfIteratorHelper(t),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
            _o4 = _step5$value[0],
            _i6 = _step5$value[1];
          if (!_i6) {
            _i6 = e.name;
          } else if (typeof _i6 == "function") {
            _i6 = _i6(e.name);
          }
          var _t7 = new ts(e.source, _i6);
          _t7.path = _toConsumableArray(e.path);
          _o4.fire.apply(_o4, [_t7].concat(_toConsumableArray(n)));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    function Cs(t, e, n) {
      var o = ks(t, e);
      var _iterator6 = _createForOfIteratorHelper(o),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _t8 = _step6.value;
          for (var _e7 = 0; _e7 < _t8.length; _e7++) {
            if (_t8[_e7].callback == n) {
              _t8.splice(_e7, 1);
              _e7--;
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
    function As(t) {
      return !!(t && t[Symbol.iterator]);
    }
    function _s(t) {
      for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        e[_key4 - 1] = arguments[_key4];
      }
      e.forEach(function (e) {
        Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e)).forEach(function (n) {
          if (n in t.prototype) {
            return;
          }
          var o = Object.getOwnPropertyDescriptor(e, n);
          o.enumerable = false;
          Object.defineProperty(t.prototype, n, o);
        });
      });
    }
    var vs = /*#__PURE__*/function () {
      function vs() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, vs);
        var n = As(t);
        if (!n) {
          e = t;
        }
        this._items = [];
        this._itemMap = new Map();
        this._idProperty = e.idProperty || "id";
        this._bindToExternalToInternalMap = new WeakMap();
        this._bindToInternalToExternalMap = new WeakMap();
        this._skippedIndexesFromExternal = [];
        if (n) {
          var _iterator7 = _createForOfIteratorHelper(t),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _e8 = _step7.value;
              this._items.push(_e8);
              this._itemMap.set(this._getItemIdBeforeAdding(_e8), _e8);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }
      _createClass(vs, [{
        key: "add",
        value: function add(t, e) {
          return this.addMany([t], e);
        }
      }, {
        key: "addMany",
        value: function addMany(t, e) {
          if (e === undefined) {
            e = this._items.length;
          } else if (e > this._items.length || e < 0) {
            throw new ss["a"]("collection-add-item-invalid-index", this);
          }
          for (var _n5 = 0; _n5 < t.length; _n5++) {
            var _o5 = t[_n5];
            var _i7 = this._getItemIdBeforeAdding(_o5);
            var _r2 = e + _n5;
            this._items.splice(_r2, 0, _o5);
            this._itemMap.set(_i7, _o5);
            this.fire("add", _o5, _r2);
          }
          this.fire("change", {
            added: t,
            removed: [],
            index: e
          });
          return this;
        }
      }, {
        key: "get",
        value: function get(t) {
          var e;
          if (typeof t == "string") {
            e = this._itemMap.get(t);
          } else if (typeof t == "number") {
            e = this._items[t];
          } else {
            throw new ss["a"]("collection-get-invalid-arg", this);
          }
          return e || null;
        }
      }, {
        key: "has",
        value: function has(t) {
          if (typeof t == "string") {
            return this._itemMap.has(t);
          } else {
            var _e9 = this._idProperty;
            var _n6 = t[_e9];
            return this._itemMap.has(_n6);
          }
        }
      }, {
        key: "getIndex",
        value: function getIndex(t) {
          var e;
          if (typeof t == "string") {
            e = this._itemMap.get(t);
          } else {
            e = t;
          }
          return this._items.indexOf(e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var _this$_remove = this._remove(t),
            _this$_remove2 = _slicedToArray(_this$_remove, 2),
            e = _this$_remove2[0],
            n = _this$_remove2[1];
          this.fire("change", {
            added: [],
            removed: [e],
            index: n
          });
          return e;
        }
      }, {
        key: "map",
        value: function map(t, e) {
          return this._items.map(t, e);
        }
      }, {
        key: "find",
        value: function find(t, e) {
          return this._items.find(t, e);
        }
      }, {
        key: "filter",
        value: function filter(t, e) {
          return this._items.filter(t, e);
        }
      }, {
        key: "clear",
        value: function clear() {
          if (this._bindToCollection) {
            this.stopListening(this._bindToCollection);
            this._bindToCollection = null;
          }
          var t = Array.from(this._items);
          while (this.length) {
            this._remove(0);
          }
          this.fire("change", {
            added: [],
            removed: t,
            index: 0
          });
        }
      }, {
        key: "bindTo",
        value: function bindTo(t) {
          var _this4 = this;
          if (this._bindToCollection) {
            throw new ss["a"]("collection-bind-to-rebind", this);
          }
          this._bindToCollection = t;
          return {
            as: function as(t) {
              _this4._setUpBindToBinding(function (e) {
                return new t(e);
              });
            },
            using: function using(t) {
              if (typeof t == "function") {
                _this4._setUpBindToBinding(function (e) {
                  return t(e);
                });
              } else {
                _this4._setUpBindToBinding(function (e) {
                  return e[t];
                });
              }
            }
          };
        }
      }, {
        key: "_setUpBindToBinding",
        value: function _setUpBindToBinding(t) {
          var _this5 = this;
          var e = this._bindToCollection;
          var n = function n(_n8, o, i) {
            var r = e._bindToCollection == _this5;
            var s = e._bindToInternalToExternalMap.get(o);
            if (r && s) {
              _this5._bindToExternalToInternalMap.set(o, s);
              _this5._bindToInternalToExternalMap.set(s, o);
            } else {
              var _n7 = t(o);
              if (!_n7) {
                _this5._skippedIndexesFromExternal.push(i);
                return;
              }
              var _r3 = i;
              var _iterator8 = _createForOfIteratorHelper(_this5._skippedIndexesFromExternal),
                _step8;
              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var _t10 = _step8.value;
                  if (i > _t10) {
                    _r3--;
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
              var _iterator9 = _createForOfIteratorHelper(e._skippedIndexesFromExternal),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _t11 = _step9.value;
                  if (_r3 >= _t11) {
                    _r3++;
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
              _this5._bindToExternalToInternalMap.set(o, _n7);
              _this5._bindToInternalToExternalMap.set(_n7, o);
              _this5.add(_n7, _r3);
              for (var _t9 = 0; _t9 < e._skippedIndexesFromExternal.length; _t9++) {
                if (_r3 <= e._skippedIndexesFromExternal[_t9]) {
                  e._skippedIndexesFromExternal[_t9]++;
                }
              }
            }
          };
          var _iterator10 = _createForOfIteratorHelper(e),
            _step10;
          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _t12 = _step10.value;
              n(null, _t12, e.getIndex(_t12));
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
          this.listenTo(e, "add", n);
          this.listenTo(e, "remove", function (t, e, n) {
            var o = _this5._bindToExternalToInternalMap.get(e);
            if (o) {
              _this5.remove(o);
            }
            _this5._skippedIndexesFromExternal = _this5._skippedIndexesFromExternal.reduce(function (t, e) {
              if (n < e) {
                t.push(e - 1);
              }
              if (n > e) {
                t.push(e);
              }
              return t;
            }, []);
          });
        }
      }, {
        key: "_getItemIdBeforeAdding",
        value: function _getItemIdBeforeAdding(t) {
          var e = this._idProperty;
          var n;
          if (e in t) {
            n = t[e];
            if (typeof n != "string") {
              throw new ss["a"]("collection-add-invalid-id", this);
            }
            if (this.get(n)) {
              throw new ss["a"]("collection-add-item-already-exists", this);
            }
          } else {
            t[e] = n = ns();
          }
          return n;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e, n, o;
          var i = false;
          var r = this._idProperty;
          if (typeof t == "string") {
            n = t;
            o = this._itemMap.get(n);
            i = !o;
            if (o) {
              e = this._items.indexOf(o);
            }
          } else if (typeof t == "number") {
            e = t;
            o = this._items[e];
            i = !o;
            if (o) {
              n = o[r];
            }
          } else {
            o = t;
            n = o[r];
            e = this._items.indexOf(o);
            i = e == -1 || !this._itemMap.get(n);
          }
          if (i) {
            throw new ss["a"]("collection-remove-404", this);
          }
          this._items.splice(e, 1);
          this._itemMap.delete(n);
          var s = this._bindToInternalToExternalMap.get(o);
          this._bindToInternalToExternalMap.delete(o);
          this._bindToExternalToInternalMap.delete(s);
          this.fire("remove", o, e);
          return [o, e];
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "first",
        get: function get() {
          return this._items[0] || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this.length - 1] || null;
        }
      }]);
      return vs;
    }();
    _s(vs, ds);
    var ys = /*#__PURE__*/function () {
      function ys(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        _classCallCheck(this, ys);
        this._context = t;
        this._plugins = new Map();
        this._availablePlugins = new Map();
        var _iterator11 = _createForOfIteratorHelper(e),
          _step11;
        try {
          for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
            var _t13 = _step11.value;
            if (_t13.pluginName) {
              this._availablePlugins.set(_t13.pluginName, _t13);
            }
          }
        } catch (err) {
          _iterator11.e(err);
        } finally {
          _iterator11.f();
        }
        this._contextPlugins = new Map();
        var _iterator12 = _createForOfIteratorHelper(n),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var _step12$value = _slicedToArray(_step12.value, 2),
              _t14 = _step12$value[0],
              _e10 = _step12$value[1];
            this._contextPlugins.set(_t14, _e10);
            this._contextPlugins.set(_e10, _t14);
            if (_t14.pluginName) {
              this._availablePlugins.set(_t14.pluginName, _t14);
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }
      _createClass(ys, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          var _iterator13, _step13, _t15;
          return _regeneratorRuntime().wrap(function value$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _iterator13 = _createForOfIteratorHelper(this._plugins);
                _context2.prev = 1;
                _iterator13.s();
              case 3:
                if ((_step13 = _iterator13.n()).done) {
                  _context2.next = 10;
                  break;
                }
                _t15 = _step13.value;
                if (!(typeof _t15[0] == "function")) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 8;
                return _t15;
              case 8:
                _context2.next = 3;
                break;
              case 10:
                _context2.next = 15;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                _iterator13.e(_context2.t0);
              case 15:
                _context2.prev = 15;
                _iterator13.f();
                return _context2.finish(15);
              case 18:
              case "end":
                return _context2.stop();
            }
          }, value, this, [[1, 12, 15, 18]]);
        })
      }, {
        key: "get",
        value: function get(t) {
          var e = this._plugins.get(t);
          if (!e) {
            var _e11 = t;
            if (typeof t == "function") {
              _e11 = t.pluginName || t.name;
            }
            throw new ss["a"]("plugincollection-plugin-not-loaded", this._context, {
              plugin: _e11
            });
          }
          return e;
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._plugins.has(t);
        }
      }, {
        key: "init",
        value: function init(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          var n = this;
          var o = this._context;
          var i = new Set();
          var r = [];
          var s = m(t);
          var a = m(e);
          var c = f(t);
          if (c) {
            var _t16 = "plugincollection-plugin-not-found";
            Object(ss["b"])(_t16, {
              plugins: c
            });
            return Promise.reject(new ss["a"](_t16, o, {
              plugins: c
            }));
          }
          return Promise.all(s.map(l)).then(function () {
            return d(r, "init");
          }).then(function () {
            return d(r, "afterInit");
          }).then(function () {
            return r;
          });
          function l(t) {
            if (a.includes(t)) {
              return;
            }
            if (n._plugins.has(t) || i.has(t)) {
              return;
            }
            return u(t).catch(function (e) {
              Object(ss["b"])("plugincollection-load", {
                plugin: t
              });
              throw e;
            });
          }
          function d(t, e) {
            return t.reduce(function (t, o) {
              if (!o[e]) {
                return t;
              }
              if (n._contextPlugins.has(o)) {
                return t;
              }
              return t.then(o[e].bind(o));
            }, Promise.resolve());
          }
          function u(t) {
            return new Promise(function (s) {
              i.add(t);
              if (t.requires) {
                t.requires.forEach(function (n) {
                  var i = h(n);
                  if (t.isContextPlugin && !i.isContextPlugin) {
                    throw new ss["a"]("plugincollection-context-required", null, {
                      plugin: i.name,
                      requiredBy: t.name
                    });
                  }
                  if (e.includes(i)) {
                    throw new ss["a"]("plugincollection-required", o, {
                      plugin: i.name,
                      requiredBy: t.name
                    });
                  }
                  l(i);
                });
              }
              var a = n._contextPlugins.get(t) || new t(o);
              n._add(t, a);
              r.push(a);
              s();
            });
          }
          function h(t) {
            if (typeof t == "function") {
              return t;
            }
            return n._availablePlugins.get(t);
          }
          function f(t) {
            var e = [];
            var _iterator14 = _createForOfIteratorHelper(t),
              _step14;
            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var _n9 = _step14.value;
                if (!h(_n9)) {
                  e.push(_n9);
                }
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }
            return e.length ? e : null;
          }
          function m(t) {
            return t.map(function (t) {
              return h(t);
            }).filter(function (t) {
              return !!t;
            });
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = [];
          var _iterator15 = _createForOfIteratorHelper(this),
            _step15;
          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var _step15$value = _slicedToArray(_step15.value, 2),
                _e12 = _step15$value[1];
              if (typeof _e12.destroy == "function" && !this._contextPlugins.has(_e12)) {
                t.push(_e12.destroy());
              }
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
          return Promise.all(t);
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          this._plugins.set(t, e);
          var n = t.pluginName;
          if (!n) {
            return;
          }
          if (this._plugins.has(n)) {
            throw new ss["a"]("plugincollection-plugin-name-conflict", null, {
              pluginName: n,
              plugin1: this._plugins.get(n).constructor,
              plugin2: t
            });
          }
          this._plugins.set(n, e);
        }
      }]);
      return ys;
    }();
    _s(ys, ds);
    function xs(t) {
      return Array.isArray(t) ? t : [t];
    }
    if (!window.CKEDITOR_TRANSLATIONS) {
      window.CKEDITOR_TRANSLATIONS = {};
    }
    function Ds(t, e, n) {
      if (!window.CKEDITOR_TRANSLATIONS[t]) {
        window.CKEDITOR_TRANSLATIONS[t] = {};
      }
      var o = window.CKEDITOR_TRANSLATIONS[t];
      o.dictionary = o.dictionary || {};
      o.getPluralForm = n || o.getPluralForm;
      Object.assign(o.dictionary, e);
    }
    function Es(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      if (typeof n !== "number") {
        throw new ss["a"]("translation-service-quantity-not-a-number", null, {
          quantity: n
        });
      }
      var o = Ts();
      if (o === 1) {
        t = Object.keys(window.CKEDITOR_TRANSLATIONS)[0];
      }
      var i = e.id || e.string;
      if (o === 0 || !Ss(t, i)) {
        if (n !== 1) {
          return e.plural;
        }
        return e.string;
      }
      var r = window.CKEDITOR_TRANSLATIONS[t].dictionary;
      var s = window.CKEDITOR_TRANSLATIONS[t].getPluralForm || function (t) {
        return t === 1 ? 0 : 1;
      };
      if (typeof r[i] === "string") {
        return r[i];
      }
      var a = Number(s(n));
      return r[i][a];
    }
    function Ms() {
      window.CKEDITOR_TRANSLATIONS = {};
    }
    function Ss(t, e) {
      return !!window.CKEDITOR_TRANSLATIONS[t] && !!window.CKEDITOR_TRANSLATIONS[t].dictionary[e];
    }
    function Ts() {
      return Object.keys(window.CKEDITOR_TRANSLATIONS).length;
    }
    var Is = ["ar", "fa", "he", "ku", "ug"];
    var Ns = /*#__PURE__*/function () {
      function Ns() {
        var _this6 = this;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, Ns);
        this.uiLanguage = t.uiLanguage || "en";
        this.contentLanguage = t.contentLanguage || this.uiLanguage;
        this.uiLanguageDirection = Bs(this.uiLanguage);
        this.contentLanguageDirection = Bs(this.contentLanguage);
        this.t = function (t, e) {
          return _this6._t(t, e);
        };
      }
      _createClass(Ns, [{
        key: "_t",
        value: function _t(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          e = xs(e);
          if (typeof t === "string") {
            t = {
              string: t
            };
          }
          var n = !!t.plural;
          var o = n ? e[0] : 1;
          var i = Es(this.uiLanguage, t, o);
          return Ps(i, e);
        }
      }, {
        key: "language",
        get: function get() {
          console.warn("locale-deprecated-language-property: " + "The Locale#language property has been deprecated and will be removed in the near future. " + "Please use #uiLanguage and #contentLanguage properties instead.");
          return this.uiLanguage;
        }
      }]);
      return Ns;
    }();
    function Ps(t, e) {
      return t.replace(/%(\d+)/g, function (t, n) {
        return n < e.length ? e[n] : t;
      });
    }
    function Bs(t) {
      return Is.includes(t) ? "rtl" : "ltr";
    }
    var zs = /*#__PURE__*/function () {
      function zs(t) {
        _classCallCheck(this, zs);
        this.config = new Qr(t, this.constructor.defaultConfig);
        var e = this.constructor.builtinPlugins;
        this.config.define("plugins", e);
        this.plugins = new ys(this, e);
        var n = this.config.get("language") || {};
        this.locale = new Ns({
          uiLanguage: typeof n === "string" ? n : n.ui,
          contentLanguage: this.config.get("language.content")
        });
        this.t = this.locale.t;
        this.editors = new vs();
        this._contextOwner = null;
      }
      _createClass(zs, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config.get("plugins") || [];
          var _iterator16 = _createForOfIteratorHelper(t),
            _step16;
          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _e13 = _step16.value;
              if (typeof _e13 != "function") {
                throw new ss["a"]("context-initplugins-constructor-only", null, {
                  Plugin: _e13
                });
              }
              if (_e13.isContextPlugin !== true) {
                throw new ss["a"]("context-initplugins-invalid-plugin", null, {
                  Plugin: _e13
                });
              }
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
          return this.plugins.init(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this7 = this;
          return Promise.all(Array.from(this.editors, function (t) {
            return t.destroy();
          })).then(function () {
            return _this7.plugins.destroy();
          });
        }
      }, {
        key: "_addEditor",
        value: function _addEditor(t, e) {
          if (this._contextOwner) {
            throw new ss["a"]("context-addeditor-private-context");
          }
          this.editors.add(t);
          if (e) {
            this._contextOwner = t;
          }
        }
      }, {
        key: "_removeEditor",
        value: function _removeEditor(t) {
          if (this.editors.has(t)) {
            this.editors.remove(t);
          }
          if (this._contextOwner === t) {
            return this.destroy();
          }
          return Promise.resolve();
        }
      }, {
        key: "_getEditorConfig",
        value: function _getEditorConfig() {
          var t = {};
          var _iterator17 = _createForOfIteratorHelper(this.config.names()),
            _step17;
          try {
            for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
              var _e14 = _step17.value;
              if (!["plugins", "removePlugins", "extraPlugins"].includes(_e14)) {
                t[_e14] = this.config.get(_e14);
              }
            }
          } catch (err) {
            _iterator17.e(err);
          } finally {
            _iterator17.f();
          }
          return t;
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this8 = this;
          return new Promise(function (e) {
            var n = new _this8(t);
            e(n.initPlugins().then(function () {
              return n;
            }));
          });
        }
      }]);
      return zs;
    }();
    function Ls(t, e) {
      var n = Math.min(t.length, e.length);
      for (var _o6 = 0; _o6 < n; _o6++) {
        if (t[_o6] != e[_o6]) {
          return _o6;
        }
      }
      if (t.length == e.length) {
        return "same";
      } else if (t.length < e.length) {
        return "prefix";
      } else {
        return "extension";
      }
    }
    var Os = 4;
    function Rs(t) {
      return Ur(t, Os);
    }
    var js = Rs;
    var Fs = /*#__PURE__*/function () {
      function Fs(t) {
        _classCallCheck(this, Fs);
        this.document = t;
        this.parent = null;
      }
      _createClass(Fs, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;
          while (e.parent) {
            t.unshift(e.index);
            e = e.parent;
          }
          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: false,
            parentFirst: false
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          while (n) {
            e[t.parentFirst ? "push" : "unshift"](n);
            n = n.parent;
          }
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e);
          var o = t.getAncestors(e);
          var i = 0;
          while (n[i] == o[i] && n[i]) {
            i++;
          }
          return i === 0 ? null : n[i - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) {
            return false;
          }
          if (this.root !== t.root) {
            return false;
          }
          var e = this.getPath();
          var n = t.getPath();
          var o = Ls(e, n);
          switch (o) {
            case "prefix":
              return true;
            case "extension":
              return false;
            default:
              return e[o] < n[o];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          if (this == t) {
            return false;
          }
          if (this.root !== t.root) {
            return false;
          }
          return !this.isBefore(t);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
          if (this.parent) {
            this.parent._fireChange(t, e);
          }
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = js(this);
          delete t.parent;
          return t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "node" || t === "view:node";
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) {
            return null;
          }
          if ((t = this.parent.getChildIndex(this)) == -1) {
            throw new ss["a"]("view-node-not-found-in-parent", this);
          }
          return t;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return t !== null && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return t !== null && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;
          while (t.parent) {
            t = t.parent;
          }
          return t;
        }
      }]);
      return Fs;
    }();
    _s(Fs, ds);
    var Vs = /*#__PURE__*/function (_Fs) {
      _inherits(Vs, _Fs);
      function Vs(t, e) {
        var _this9;
        _classCallCheck(this, Vs);
        _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Vs).call(this, t));
        _this9._textData = e;
        return _this9;
      }
      _createClass(Vs, [{
        key: "is",
        value: function is(t) {
          return t === "$text" || t === "view:$text" || t === "text" || t === "view:text" || t === "node" || t === "view:node";
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof Vs)) {
            return false;
          }
          return this === t || this.data === t.data;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Vs(this.document, this.data);
        }
      }, {
        key: "data",
        get: function get() {
          return this._textData;
        }
      }, {
        key: "_data",
        get: function get() {
          return this.data;
        },
        set: function set(t) {
          this._fireChange("text", this);
          this._textData = t;
        }
      }]);
      return Vs;
    }(Fs);
    var Us = /*#__PURE__*/function () {
      function Us(t, e, n) {
        _classCallCheck(this, Us);
        this.textNode = t;
        if (e < 0 || e > t.data.length) {
          throw new ss["a"]("view-textproxy-wrong-offsetintext", this);
        }
        if (n < 0 || e + n > t.data.length) {
          throw new ss["a"]("view-textproxy-wrong-length", this);
        }
        this.data = t.data.substring(e, e + n);
        this.offsetInText = e;
      }
      _createClass(Us, [{
        key: "is",
        value: function is(t) {
          return t === "$textProxy" || t === "view:$textProxy" || t === "textProxy" || t === "view:textProxy";
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: false,
            parentFirst: false
          };
          var e = [];
          var n = t.includeSelf ? this.textNode : this.parent;
          while (n !== null) {
            e[t.parentFirst ? "push" : "unshift"](n);
            n = n.parent;
          }
          return e;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.data.length !== this.textNode.data.length;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }, {
        key: "document",
        get: function get() {
          return this.textNode.document;
        }
      }]);
      return Us;
    }();
    function Hs(t) {
      var e = new Map();
      for (var _n10 in t) {
        e.set(_n10, t[_n10]);
      }
      return e;
    }
    function Gs(t) {
      if (As(t)) {
        return new Map(t);
      } else {
        return Hs(t);
      }
    }
    var Ws = /*#__PURE__*/function () {
      function Ws() {
        _classCallCheck(this, Ws);
        this._patterns = [];
        this.add.apply(this, arguments);
      }
      _createClass(Ws, [{
        key: "add",
        value: function add() {
          for (var _len5 = arguments.length, t = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            t[_key5] = arguments[_key5];
          }
          for (var _i8 = 0, _t17 = t; _i8 < _t17.length; _i8++) {
            var _e15 = _t17[_i8];
            if (typeof _e15 == "string" || _e15 instanceof RegExp) {
              _e15 = {
                name: _e15
              };
            }
            if (_e15.classes && (typeof _e15.classes == "string" || _e15.classes instanceof RegExp)) {
              _e15.classes = [_e15.classes];
            }
            this._patterns.push(_e15);
          }
        }
      }, {
        key: "match",
        value: function match() {
          for (var _len6 = arguments.length, t = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
            t[_key6] = arguments[_key6];
          }
          for (var _i9 = 0, _t18 = t; _i9 < _t18.length; _i9++) {
            var _e16 = _t18[_i9];
            var _iterator18 = _createForOfIteratorHelper(this._patterns),
              _step18;
            try {
              for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                var _t19 = _step18.value;
                var _n11 = Ks(_e16, _t19);
                if (_n11) {
                  return {
                    element: _e16,
                    pattern: _t19,
                    match: _n11
                  };
                }
              }
            } catch (err) {
              _iterator18.e(err);
            } finally {
              _iterator18.f();
            }
          }
          return null;
        }
      }, {
        key: "matchAll",
        value: function matchAll() {
          var e = [];
          for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
            t[_key7] = arguments[_key7];
          }
          for (var _i10 = 0, _t20 = t; _i10 < _t20.length; _i10++) {
            var _n12 = _t20[_i10];
            var _iterator19 = _createForOfIteratorHelper(this._patterns),
              _step19;
            try {
              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                var _t21 = _step19.value;
                var _o7 = Ks(_n12, _t21);
                if (_o7) {
                  e.push({
                    element: _n12,
                    pattern: _t21,
                    match: _o7
                  });
                }
              }
            } catch (err) {
              _iterator19.e(err);
            } finally {
              _iterator19.f();
            }
          }
          return e.length > 0 ? e : null;
        }
      }, {
        key: "getElementName",
        value: function getElementName() {
          if (this._patterns.length !== 1) {
            return null;
          }
          var t = this._patterns[0];
          var e = t.name;
          return typeof t != "function" && e && !(e instanceof RegExp) ? e : null;
        }
      }]);
      return Ws;
    }();
    function Ks(t, e) {
      if (typeof e == "function") {
        return e(t);
      }
      var n = {};
      if (e.name) {
        n.name = qs(e.name, t.name);
        if (!n.name) {
          return null;
        }
      }
      if (e.attributes) {
        n.attributes = Ys(e.attributes, t);
        if (!n.attributes) {
          return null;
        }
      }
      if (e.classes) {
        n.classes = Qs(e.classes, t);
        if (!n.classes) {
          return false;
        }
      }
      if (e.styles) {
        n.styles = $s(e.styles, t);
        if (!n.styles) {
          return false;
        }
      }
      return n;
    }
    function qs(t, e) {
      if (t instanceof RegExp) {
        return t.test(e);
      }
      return t === e;
    }
    function Ys(t, e) {
      var n = [];
      for (var _o8 in t) {
        var _i11 = t[_o8];
        if (e.hasAttribute(_o8)) {
          var _t22 = e.getAttribute(_o8);
          if (_i11 === true) {
            n.push(_o8);
          } else if (_i11 instanceof RegExp) {
            if (_i11.test(_t22)) {
              n.push(_o8);
            } else {
              return null;
            }
          } else if (_t22 === _i11) {
            n.push(_o8);
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
      return n;
    }
    function Qs(t, e) {
      var n = [];
      var _iterator20 = _createForOfIteratorHelper(t),
        _step20;
      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var _o9 = _step20.value;
          if (_o9 instanceof RegExp) {
            var _t23 = e.getClassNames();
            var _iterator21 = _createForOfIteratorHelper(_t23),
              _step21;
            try {
              for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
                var _e17 = _step21.value;
                if (_o9.test(_e17)) {
                  n.push(_e17);
                }
              }
            } catch (err) {
              _iterator21.e(err);
            } finally {
              _iterator21.f();
            }
            if (n.length === 0) {
              return null;
            }
          } else if (e.hasClass(_o9)) {
            n.push(_o9);
          } else {
            return null;
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }
      return n;
    }
    function $s(t, e) {
      var n = [];
      for (var _o10 in t) {
        var _i12 = t[_o10];
        if (e.hasStyle(_o10)) {
          var _t24 = e.getStyle(_o10);
          if (_i12 instanceof RegExp) {
            if (_i12.test(_t24)) {
              n.push(_o10);
            } else {
              return null;
            }
          } else if (_t24 === _i12) {
            n.push(_o10);
          } else {
            return null;
          }
        } else {
          return null;
        }
      }
      return n;
    }
    var Zs = "[object Symbol]";
    function Js(t) {
      return typeof t == "symbol" || D(t) && C(t) == Zs;
    }
    var Xs = Js;
    var ta = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      ea = /^\w*$/;
    function na(t, e) {
      if (Qe(t)) {
        return false;
      }
      var n = typeof t;
      if (n == "number" || n == "symbol" || n == "boolean" || t == null || Xs(t)) {
        return true;
      }
      return ea.test(t) || !ta.test(t) || e != null && t in Object(e);
    }
    var oa = na;
    var ia = "Expected a function";
    function ra(t, e) {
      if (typeof t != "function" || e != null && typeof e != "function") {
        throw new TypeError(ia);
      }
      var n = function n() {
        var o = arguments,
          i = e ? e.apply(this, o) : o[0],
          r = n.cache;
        if (r.has(i)) {
          return r.get(i);
        }
        var s = t.apply(this, o);
        n.cache = r.set(i, s) || r;
        return s;
      };
      n.cache = new (ra.Cache || Ce)();
      return n;
    }
    ra.Cache = Ce;
    var sa = ra;
    var aa = 500;
    function ca(t) {
      var e = sa(t, function (t) {
        if (n.size === aa) {
          n.clear();
        }
        return t;
      });
      var n = e.cache;
      return e;
    }
    var la = ca;
    var da = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var ua = /\\(\\)?/g;
    var ha = la(function (t) {
      var e = [];
      if (t.charCodeAt(0) === 46) {
        e.push("");
      }
      t.replace(da, function (t, n, o, i) {
        e.push(o ? i.replace(ua, "$1") : n || t);
      });
      return e;
    });
    var fa = ha;
    function ma(t, e) {
      var n = -1,
        o = t == null ? 0 : t.length,
        i = Array(o);
      while (++n < o) {
        i[n] = e(t[n], n, t);
      }
      return i;
    }
    var ga = ma;
    var pa = 1 / 0;
    var ka = r ? r.prototype : undefined,
      ba = ka ? ka.toString : undefined;
    function wa(t) {
      if (typeof t == "string") {
        return t;
      }
      if (Qe(t)) {
        return ga(t, wa) + "";
      }
      if (Xs(t)) {
        return ba ? ba.call(t) : "";
      }
      var e = t + "";
      return e == "0" && 1 / t == -pa ? "-0" : e;
    }
    var Ca = wa;
    function Aa(t) {
      return t == null ? "" : Ca(t);
    }
    var _a = Aa;
    function va(t, e) {
      if (Qe(t)) {
        return t;
      }
      return oa(t, e) ? [t] : fa(_a(t));
    }
    var ya = va;
    function xa(t) {
      var e = t == null ? 0 : t.length;
      return e ? t[e - 1] : undefined;
    }
    var Da = xa;
    var Ea = 1 / 0;
    function Ma(t) {
      if (typeof t == "string" || Xs(t)) {
        return t;
      }
      var e = t + "";
      return e == "0" && 1 / t == -Ea ? "-0" : e;
    }
    var Sa = Ma;
    function Ta(t, e) {
      e = ya(e, t);
      var n = 0,
        o = e.length;
      while (t != null && n < o) {
        t = t[Sa(e[n++])];
      }
      return n && n == o ? t : undefined;
    }
    var Ia = Ta;
    function Na(t, e, n) {
      var o = -1,
        i = t.length;
      if (e < 0) {
        e = -e > i ? 0 : i + e;
      }
      n = n > i ? i : n;
      if (n < 0) {
        n += i;
      }
      i = e > n ? 0 : n - e >>> 0;
      e >>>= 0;
      var r = Array(i);
      while (++o < i) {
        r[o] = t[o + e];
      }
      return r;
    }
    var Pa = Na;
    function Ba(t, e) {
      return e.length < 2 ? t : Ia(t, Pa(e, 0, -1));
    }
    var za = Ba;
    function La(t, e) {
      e = ya(e, t);
      t = za(t, e);
      return t == null || delete t[Sa(Da(e))];
    }
    var Oa = La;
    function Ra(t, e) {
      return t == null ? true : Oa(t, e);
    }
    var ja = Ra;
    function Fa(t, e, n) {
      var o = t == null ? undefined : Ia(t, e);
      return o === undefined ? n : o;
    }
    var Va = Fa;
    function Ua(t, e, n) {
      if (n !== undefined && !R(t[e], n) || n === undefined && !(e in t)) {
        Ie(t, e, n);
      }
    }
    var Ha = Ua;
    function Ga(t) {
      return function (e, n, o) {
        var i = -1,
          r = Object(e),
          s = o(e),
          a = s.length;
        while (a--) {
          var c = s[t ? a : ++i];
          if (n(r[c], c, r) === false) {
            break;
          }
        }
        return e;
      };
    }
    var Wa = Ga;
    var Ka = Wa();
    var qa = Ka;
    function Ya(t) {
      return D(t) && Jn(t);
    }
    var Qa = Ya;
    function $a(t, e) {
      if (e === "constructor" && typeof t[e] === "function") {
        return;
      }
      if (e == "__proto__") {
        return;
      }
      return t[e];
    }
    var Za = $a;
    function Ja(t) {
      return Oe(t, uo(t));
    }
    var Xa = Ja;
    function tc(t, e, n, o, i, r, s) {
      var a = Za(t, n),
        c = Za(e, n),
        l = s.get(c);
      if (l) {
        Ha(t, n, l);
        return;
      }
      var d = r ? r(a, c, n + "", t, e, s) : undefined;
      var u = d === undefined;
      if (u) {
        var h = Qe(c),
          f = !h && Object($e["a"])(c),
          m = !h && !f && On(c);
        d = c;
        if (h || f || m) {
          if (Qe(a)) {
            d = a;
          } else if (Qa(a)) {
            d = po(a);
          } else if (f) {
            u = false;
            d = Object(mo["a"])(c, true);
          } else if (m) {
            u = false;
            d = Di(c, true);
          } else {
            d = [];
          }
        } else if (B(c) || qe(c)) {
          d = a;
          if (qe(a)) {
            d = Xa(a);
          } else if (!ct(a) || mt(a)) {
            d = Ji(c);
          }
        } else {
          u = false;
        }
      }
      if (u) {
        s.set(c, d);
        i(d, c, o, r, s);
        s["delete"](c);
      }
      Ha(t, n, d);
    }
    var ec = tc;
    function nc(t, e, n, o, i) {
      if (t === e) {
        return;
      }
      qa(e, function (r, s) {
        i || (i = new xe());
        if (ct(r)) {
          ec(t, e, s, n, nc, o, i);
        } else {
          var a = o ? o(Za(t, s), r, s + "", t, e, i) : undefined;
          if (a === undefined) {
            a = r;
          }
          Ha(t, s, a);
        }
      }, uo);
    }
    var oc = nc;
    function ic(t) {
      return t;
    }
    var rc = ic;
    function sc(t, e, n) {
      switch (n.length) {
        case 0:
          return t.call(e);
        case 1:
          return t.call(e, n[0]);
        case 2:
          return t.call(e, n[0], n[1]);
        case 3:
          return t.call(e, n[0], n[1], n[2]);
      }
      return t.apply(e, n);
    }
    var ac = sc;
    var cc = Math.max;
    function lc(t, e, n) {
      e = cc(e === undefined ? t.length - 1 : e, 0);
      return function () {
        var o = arguments,
          i = -1,
          r = cc(o.length - e, 0),
          s = Array(r);
        while (++i < r) {
          s[i] = o[e + i];
        }
        i = -1;
        var a = Array(e + 1);
        while (++i < e) {
          a[i] = o[i];
        }
        a[e] = n(s);
        return ac(t, this, a);
      };
    }
    var dc = lc;
    function uc(t) {
      return function () {
        return t;
      };
    }
    var hc = uc;
    var fc = !Se ? rc : function (t, e) {
      return Se(t, "toString", {
        configurable: true,
        enumerable: false,
        value: hc(e),
        writable: true
      });
    };
    var mc = fc;
    var gc = 800,
      pc = 16;
    var kc = Date.now;
    function bc(t) {
      var e = 0,
        n = 0;
      return function () {
        var o = kc(),
          i = pc - (o - n);
        n = o;
        if (i > 0) {
          if (++e >= gc) {
            return arguments[0];
          }
        } else {
          e = 0;
        }
        return t.apply(undefined, arguments);
      };
    }
    var wc = bc;
    var Cc = wc(mc);
    var Ac = Cc;
    function _c(t, e) {
      return Ac(dc(t, e, rc), t + "");
    }
    var vc = _c;
    function yc(t, e, n) {
      if (!ct(n)) {
        return false;
      }
      var o = typeof e;
      if (o == "number" ? Jn(n) && tn(e, n.length) : o == "string" && e in n) {
        return R(n[e], t);
      }
      return false;
    }
    var xc = yc;
    function Dc(t) {
      return vc(function (e, n) {
        var o = -1,
          i = n.length,
          r = i > 1 ? n[i - 1] : undefined,
          s = i > 2 ? n[2] : undefined;
        r = t.length > 3 && typeof r == "function" ? (i--, r) : undefined;
        if (s && xc(n[0], n[1], s)) {
          r = i < 3 ? undefined : r;
          i = 1;
        }
        e = Object(e);
        while (++o < i) {
          var a = n[o];
          if (a) {
            t(e, a, o, r);
          }
        }
        return e;
      });
    }
    var Ec = Dc;
    var Mc = Ec(function (t, e, n) {
      oc(t, e, n);
    });
    var Sc = Mc;
    function Tc(t, e, n, o) {
      if (!ct(t)) {
        return t;
      }
      e = ya(e, t);
      var i = -1,
        r = e.length,
        s = r - 1,
        a = t;
      while (a != null && ++i < r) {
        var c = Sa(e[i]),
          l = n;
        if (i != s) {
          var d = a[c];
          l = o ? o(d, c, a) : undefined;
          if (l === undefined) {
            l = ct(d) ? d : tn(e[i + 1]) ? [] : {};
          }
        }
        ze(a, c, l);
        a = a[c];
      }
      return t;
    }
    var Ic = Tc;
    function Nc(t, e, n) {
      return t == null ? t : Ic(t, e, n);
    }
    var Pc = Nc;
    var Bc = /*#__PURE__*/function () {
      function Bc(t) {
        _classCallCheck(this, Bc);
        this._styles = {};
        this._styleProcessor = t;
      }
      _createClass(Bc, [{
        key: "setTo",
        value: function setTo(t) {
          this.clear();
          var e = Array.from(Lc(t).entries());
          for (var _i13 = 0, _e18 = e; _i13 < _e18.length; _i13++) {
            var _e18$_i = _slicedToArray(_e18[_i13], 2),
              _t25 = _e18$_i[0],
              _n13 = _e18$_i[1];
            this._styleProcessor.toNormalizedForm(_t25, _n13, this._styles);
          }
        }
      }, {
        key: "has",
        value: function has(t) {
          if (this.isEmpty) {
            return false;
          }
          var e = this._styleProcessor.getReducedForm(t, this._styles);
          var n = e.find(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
              e = _ref2[0];
            return e === t;
          });
          return Array.isArray(n);
        }
      }, {
        key: "set",
        value: function set(t, e) {
          if (ct(t)) {
            for (var _i14 = 0, _Object$entries = Object.entries(t); _i14 < _Object$entries.length; _i14++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i14], 2),
                _e19 = _Object$entries$_i[0],
                _n14 = _Object$entries$_i[1];
              this._styleProcessor.toNormalizedForm(_e19, _n14, this._styles);
            }
          } else {
            this._styleProcessor.toNormalizedForm(t, e, this._styles);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = Oc(t);
          ja(this._styles, e);
          delete this._styles[t];
          this._cleanEmptyObjectsOnPath(e);
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(t) {
          return this._styleProcessor.getNormalized(t, this._styles);
        }
      }, {
        key: "toString",
        value: function toString() {
          if (this.isEmpty) {
            return "";
          }
          return this._getStylesEntries().map(function (t) {
            return t.join(":");
          }).sort().join(";") + ";";
        }
      }, {
        key: "getAsString",
        value: function getAsString(t) {
          if (this.isEmpty) {
            return;
          }
          if (this._styles[t] && !ct(this._styles[t])) {
            return this._styles[t];
          }
          var e = this._styleProcessor.getReducedForm(t, this._styles);
          var n = e.find(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 1),
              e = _ref4[0];
            return e === t;
          });
          if (Array.isArray(n)) {
            return n[1];
          }
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          if (this.isEmpty) {
            return [];
          }
          var t = this._getStylesEntries();
          return t.map(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 1),
              t = _ref6[0];
            return t;
          });
        }
      }, {
        key: "clear",
        value: function clear() {
          this._styles = {};
        }
      }, {
        key: "_getStylesEntries",
        value: function _getStylesEntries() {
          var t = [];
          var e = Object.keys(this._styles);
          for (var _i15 = 0, _e20 = e; _i15 < _e20.length; _i15++) {
            var _n15 = _e20[_i15];
            t.push.apply(t, _toConsumableArray(this._styleProcessor.getReducedForm(_n15, this._styles)));
          }
          return t;
        }
      }, {
        key: "_cleanEmptyObjectsOnPath",
        value: function _cleanEmptyObjectsOnPath(t) {
          var e = t.split(".");
          var n = e.length > 1;
          if (!n) {
            return;
          }
          var o = e.splice(0, e.length - 1).join(".");
          var i = Va(this._styles, o);
          if (!i) {
            return;
          }
          var r = !Array.from(Object.keys(i)).length;
          if (r) {
            this.remove(o);
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          var t = Object.entries(this._styles);
          var e = Array.from(t);
          return !e.length;
        }
      }, {
        key: "size",
        get: function get() {
          if (this.isEmpty) {
            return 0;
          }
          return this.getStyleNames().length;
        }
      }]);
      return Bc;
    }();
    var zc = /*#__PURE__*/function () {
      function zc() {
        _classCallCheck(this, zc);
        this._normalizers = new Map();
        this._extractors = new Map();
        this._reducers = new Map();
        this._consumables = new Map();
      }
      _createClass(zc, [{
        key: "toNormalizedForm",
        value: function toNormalizedForm(t, e, n) {
          if (ct(e)) {
            Rc(n, Oc(t), e);
            return;
          }
          if (this._normalizers.has(t)) {
            var _o11 = this._normalizers.get(t);
            var _o12 = _o11(e),
              _i16 = _o12.path,
              _r4 = _o12.value;
            Rc(n, _i16, _r4);
          } else {
            Rc(n, t, e);
          }
        }
      }, {
        key: "getNormalized",
        value: function getNormalized(t, e) {
          if (!t) {
            return Sc({}, e);
          }
          if (e[t] !== undefined) {
            return e[t];
          }
          if (this._extractors.has(t)) {
            var _n16 = this._extractors.get(t);
            if (typeof _n16 === "string") {
              return Va(e, _n16);
            }
            var _o13 = _n16(t, e);
            if (_o13) {
              return _o13;
            }
          }
          return Va(e, Oc(t));
        }
      }, {
        key: "getReducedForm",
        value: function getReducedForm(t, e) {
          var n = this.getNormalized(t, e);
          if (n === undefined) {
            return [];
          }
          if (this._reducers.has(t)) {
            var _e21 = this._reducers.get(t);
            return _e21(n);
          }
          return [[t, n]];
        }
      }, {
        key: "getRelatedStyles",
        value: function getRelatedStyles(t) {
          return this._consumables.get(t) || [];
        }
      }, {
        key: "setNormalizer",
        value: function setNormalizer(t, e) {
          this._normalizers.set(t, e);
        }
      }, {
        key: "setExtractor",
        value: function setExtractor(t, e) {
          this._extractors.set(t, e);
        }
      }, {
        key: "setReducer",
        value: function setReducer(t, e) {
          this._reducers.set(t, e);
        }
      }, {
        key: "setStyleRelation",
        value: function setStyleRelation(t, e) {
          this._mapStyleNames(t, e);
          var _iterator22 = _createForOfIteratorHelper(e),
            _step22;
          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var _n17 = _step22.value;
              this._mapStyleNames(_n17, [t]);
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
        }
      }, {
        key: "_mapStyleNames",
        value: function _mapStyleNames(t, e) {
          var _this$_consumables$ge;
          if (!this._consumables.has(t)) {
            this._consumables.set(t, []);
          }
          (_this$_consumables$ge = this._consumables.get(t)).push.apply(_this$_consumables$ge, _toConsumableArray(e));
        }
      }]);
      return zc;
    }();
    function Lc(t) {
      var e = null;
      var n = 0;
      var o = 0;
      var i = null;
      var r = new Map();
      if (t === "") {
        return r;
      }
      if (t.charAt(t.length - 1) != ";") {
        t = t + ";";
      }
      for (var _s2 = 0; _s2 < t.length; _s2++) {
        var _a2 = t.charAt(_s2);
        if (e === null) {
          switch (_a2) {
            case ":":
              if (!i) {
                i = t.substr(n, _s2 - n);
                o = _s2 + 1;
              }
              break;
            case '"':
            case "'":
              e = _a2;
              break;
            case ";":
              {
                var _e22 = t.substr(o, _s2 - o);
                if (i) {
                  r.set(i.trim(), _e22.trim());
                }
                i = null;
                n = _s2 + 1;
                break;
              }
          }
        } else if (_a2 === e) {
          e = null;
        }
      }
      return r;
    }
    function Oc(t) {
      return t.replace("-", ".");
    }
    function Rc(t, e, n) {
      var o = n;
      if (ct(n)) {
        o = Sc({}, Va(t, e), n);
      }
      Pc(t, e, o);
    }
    var jc = /*#__PURE__*/function (_Fs2) {
      _inherits(jc, _Fs2);
      function jc(t, e, n, o) {
        var _this10;
        _classCallCheck(this, jc);
        _this10 = _possibleConstructorReturn(this, _getPrototypeOf(jc).call(this, t));
        _this10.name = e;
        _this10._attrs = Fc(n);
        _this10._children = [];
        if (o) {
          _this10._insertChild(0, o);
        }
        _this10._classes = new Set();
        if (_this10._attrs.has("class")) {
          var _t26 = _this10._attrs.get("class");
          Vc(_this10._classes, _t26);
          _this10._attrs.delete("class");
        }
        _this10._styles = new Bc(_this10.document.stylesProcessor);
        if (_this10._attrs.has("style")) {
          _this10._styles.setTo(_this10._attrs.get("style"));
          _this10._attrs.delete("style");
        }
        _this10._customProperties = new Map();
        return _this10;
      }
      _createClass(jc, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "element" || t === "view:element");
          }
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getAttributeKeys",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
          return _regeneratorRuntime().wrap(function getAttributeKeys$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this._classes.size > 0)) {
                  _context3.next = 3;
                  break;
                }
                _context3.next = 3;
                return "class";
              case 3:
                if (this._styles.isEmpty) {
                  _context3.next = 6;
                  break;
                }
                _context3.next = 6;
                return "style";
              case 6:
                return _context3.delegateYield(this._attrs.keys(), "t0", 7);
              case 7:
              case "end":
                return _context3.stop();
            }
          }, getAttributeKeys, this);
        })
      }, {
        key: "getAttributes",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributes() {
          return _regeneratorRuntime().wrap(function getAttributes$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.delegateYield(this._attrs.entries(), "t0", 1);
              case 1:
                if (!(this._classes.size > 0)) {
                  _context4.next = 4;
                  break;
                }
                _context4.next = 4;
                return ["class", this.getAttribute("class")];
              case 4:
                if (this._styles.isEmpty) {
                  _context4.next = 7;
                  break;
                }
                _context4.next = 7;
                return ["style", this.getAttribute("style")];
              case 7:
              case "end":
                return _context4.stop();
            }
          }, getAttributes, this);
        })
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          if (t == "class") {
            if (this._classes.size > 0) {
              return _toConsumableArray(this._classes).join(" ");
            }
            return undefined;
          }
          if (t == "style") {
            var _t27 = this._styles.toString();
            return _t27 == "" ? undefined : _t27;
          }
          return this._attrs.get(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          if (t == "class") {
            return this._classes.size > 0;
          }
          if (t == "style") {
            return !this._styles.isEmpty;
          }
          return this._attrs.has(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (!(t instanceof jc)) {
            return false;
          }
          if (this === t) {
            return true;
          }
          if (this.name != t.name) {
            return false;
          }
          if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) {
            return false;
          }
          var _iterator23 = _createForOfIteratorHelper(this._attrs),
            _step23;
          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var _step23$value = _slicedToArray(_step23.value, 2),
                _e23 = _step23$value[0],
                _n18 = _step23$value[1];
              if (!t._attrs.has(_e23) || t._attrs.get(_e23) !== _n18) {
                return false;
              }
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }
          var _iterator24 = _createForOfIteratorHelper(this._classes),
            _step24;
          try {
            for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
              var _e24 = _step24.value;
              if (!t._classes.has(_e24)) {
                return false;
              }
            }
          } catch (err) {
            _iterator24.e(err);
          } finally {
            _iterator24.f();
          }
          var _iterator25 = _createForOfIteratorHelper(this._styles.getStyleNames()),
            _step25;
          try {
            for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _e25 = _step25.value;
              if (!t._styles.has(_e25) || t._styles.getAsString(_e25) !== this._styles.getAsString(_e25)) {
                return false;
              }
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }
          return true;
        }
      }, {
        key: "hasClass",
        value: function hasClass() {
          for (var _len8 = arguments.length, t = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            t[_key8] = arguments[_key8];
          }
          for (var _i17 = 0, _t28 = t; _i17 < _t28.length; _i17++) {
            var _e26 = _t28[_i17];
            if (!this._classes.has(_e26)) {
              return false;
            }
          }
          return true;
        }
      }, {
        key: "getClassNames",
        value: function getClassNames() {
          return this._classes.keys();
        }
      }, {
        key: "getStyle",
        value: function getStyle(t) {
          return this._styles.getAsString(t);
        }
      }, {
        key: "getNormalizedStyle",
        value: function getNormalizedStyle(t) {
          return this._styles.getNormalized(t);
        }
      }, {
        key: "getStyleNames",
        value: function getStyleNames() {
          return this._styles.getStyleNames();
        }
      }, {
        key: "hasStyle",
        value: function hasStyle() {
          for (var _len9 = arguments.length, t = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            t[_key9] = arguments[_key9];
          }
          for (var _i18 = 0, _t29 = t; _i18 < _t29.length; _i18++) {
            var _e27 = _t29[_i18];
            if (!this._styles.has(_e27)) {
              return false;
            }
          }
          return true;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor() {
          for (var _len10 = arguments.length, t = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            t[_key10] = arguments[_key10];
          }
          var e = _construct(Ws, t);
          var n = this.parent;
          while (n) {
            if (e.match(n)) {
              return n;
            }
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "getCustomProperty",
        value: function getCustomProperty(t) {
          return this._customProperties.get(t);
        }
      }, {
        key: "getCustomProperties",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getCustomProperties() {
          return _regeneratorRuntime().wrap(function getCustomProperties$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.delegateYield(this._customProperties.entries(), "t0", 1);
              case 1:
              case "end":
                return _context5.stop();
            }
          }, getCustomProperties, this);
        })
      }, {
        key: "getIdentity",
        value: function getIdentity() {
          var t = Array.from(this._classes).sort().join(",");
          var e = this._styles.toString();
          var n = Array.from(this._attrs).map(function (t) {
            return "".concat(t[0], "=\"").concat(t[1], "\"");
          }).sort().join(" ");
          return this.name + (t == "" ? "" : " class=\"".concat(t, "\"")) + (!e ? "" : " style=\"".concat(e, "\"")) + (n == "" ? "" : " ".concat(n));
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var e = [];
          if (t) {
            var _iterator26 = _createForOfIteratorHelper(this.getChildren()),
              _step26;
            try {
              for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
                var _n19 = _step26.value;
                e.push(_n19._clone(t));
              }
            } catch (err) {
              _iterator26.e(err);
            } finally {
              _iterator26.f();
            }
          }
          var n = new this.constructor(this.document, this.name, this._attrs, e);
          n._classes = new Set(this._classes);
          n._styles.set(this._styles.getNormalized());
          n._customProperties = new Map(this._customProperties);
          n.getFillerOffset = this.getFillerOffset;
          return n;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);
          var n = 0;
          var o = Uc(this.document, e);
          var _iterator27 = _createForOfIteratorHelper(o),
            _step27;
          try {
            for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
              var _e28 = _step27.value;
              if (_e28.parent !== null) {
                _e28._remove();
              }
              _e28.parent = this;
              _e28.document = this.document;
              this._children.splice(t, 0, _e28);
              t++;
              n++;
            }
          } catch (err) {
            _iterator27.e(err);
          } finally {
            _iterator27.f();
          }
          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          this._fireChange("children", this);
          for (var _n20 = t; _n20 < t + e; _n20++) {
            this._children[_n20].parent = null;
          }
          return this._children.splice(t, e);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          e = String(e);
          this._fireChange("attributes", this);
          if (t == "class") {
            Vc(this._classes, e);
          } else if (t == "style") {
            this._styles.setTo(e);
          } else {
            this._attrs.set(t, e);
          }
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._fireChange("attributes", this);
          if (t == "class") {
            if (this._classes.size > 0) {
              this._classes.clear();
              return true;
            }
            return false;
          }
          if (t == "style") {
            if (!this._styles.isEmpty) {
              this._styles.clear();
              return true;
            }
            return false;
          }
          return this._attrs.delete(t);
        }
      }, {
        key: "_addClass",
        value: function _addClass(t) {
          this._fireChange("attributes", this);
          var _iterator28 = _createForOfIteratorHelper(xs(t)),
            _step28;
          try {
            for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
              var _e29 = _step28.value;
              this._classes.add(_e29);
            }
          } catch (err) {
            _iterator28.e(err);
          } finally {
            _iterator28.f();
          }
        }
      }, {
        key: "_removeClass",
        value: function _removeClass(t) {
          this._fireChange("attributes", this);
          var _iterator29 = _createForOfIteratorHelper(xs(t)),
            _step29;
          try {
            for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
              var _e30 = _step29.value;
              this._classes.delete(_e30);
            }
          } catch (err) {
            _iterator29.e(err);
          } finally {
            _iterator29.f();
          }
        }
      }, {
        key: "_setStyle",
        value: function _setStyle(t, e) {
          this._fireChange("attributes", this);
          this._styles.set(t, e);
        }
      }, {
        key: "_removeStyle",
        value: function _removeStyle(t) {
          this._fireChange("attributes", this);
          var _iterator30 = _createForOfIteratorHelper(xs(t)),
            _step30;
          try {
            for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
              var _e31 = _step30.value;
              this._styles.remove(_e31);
            }
          } catch (err) {
            _iterator30.e(err);
          } finally {
            _iterator30.f();
          }
        }
      }, {
        key: "_setCustomProperty",
        value: function _setCustomProperty(t, e) {
          this._customProperties.set(t, e);
        }
      }, {
        key: "_removeCustomProperty",
        value: function _removeCustomProperty(t) {
          return this._customProperties.delete(t);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return this._children.length === 0;
        }
      }]);
      return jc;
    }(Fs);
    function Fc(t) {
      t = Gs(t);
      var _iterator31 = _createForOfIteratorHelper(t),
        _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var _step31$value = _slicedToArray(_step31.value, 2),
            _e32 = _step31$value[0],
            _n21 = _step31$value[1];
          if (_n21 === null) {
            t.delete(_e32);
          } else if (typeof _n21 != "string") {
            t.set(_e32, String(_n21));
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return t;
    }
    function Vc(t, e) {
      var n = e.split(/\s+/);
      t.clear();
      n.forEach(function (e) {
        return t.add(e);
      });
    }
    function Uc(t, e) {
      if (typeof e == "string") {
        return [new Vs(t, e)];
      }
      if (!As(e)) {
        e = [e];
      }
      return Array.from(e).map(function (e) {
        if (typeof e == "string") {
          return new Vs(t, e);
        }
        if (e instanceof Us) {
          return new Vs(t, e.data);
        }
        return e;
      });
    }
    var Hc = /*#__PURE__*/function (_jc) {
      _inherits(Hc, _jc);
      function Hc(t, e, n, o) {
        var _this11;
        _classCallCheck(this, Hc);
        _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Hc).call(this, t, e, n, o));
        _this11.getFillerOffset = Gc;
        return _this11;
      }
      _createClass(Hc, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
          }
        }
      }]);
      return Hc;
    }(jc);
    function Gc() {
      var t = _toConsumableArray(this.getChildren());
      var e = t[this.childCount - 1];
      if (e && e.is("element", "br")) {
        return this.childCount;
      }
      var _iterator32 = _createForOfIteratorHelper(t),
        _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _e33 = _step32.value;
          if (!_e33.is("uiElement")) {
            return null;
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
      return this.childCount;
    }
    var Wc = Ec(function (t, e) {
      Oe(e, uo(e), t);
    });
    var Kc = Wc;
    var qc = Symbol("observableProperties");
    var Yc = Symbol("boundObservables");
    var Qc = Symbol("boundProperties");
    var $c = {
      set: function set(t, e) {
        var _this12 = this;
        if (ct(t)) {
          Object.keys(t).forEach(function (e) {
            _this12.set(e, t[e]);
          }, this);
          return;
        }
        Jc(this);
        var n = this[qc];
        if (t in this && !n.has(t)) {
          throw new ss["a"]("observable-set-cannot-override", this);
        }
        Object.defineProperty(this, t, {
          enumerable: true,
          configurable: true,
          get: function get() {
            return n.get(t);
          },
          set: function set(e) {
            var o = n.get(t);
            var i = this.fire("set:" + t, t, e, o);
            if (i === undefined) {
              i = e;
            }
            if (o !== i || !n.has(t)) {
              n.set(t, i);
              this.fire("change:" + t, t, i, o);
            }
          }
        });
        this[t] = e;
      },
      bind: function bind() {
        var _this13 = this;
        for (var _len11 = arguments.length, t = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          t[_key11] = arguments[_key11];
        }
        if (!t.length || !nl(t)) {
          throw new ss["a"]("observable-bind-wrong-properties", this);
        }
        if (new Set(t).size !== t.length) {
          throw new ss["a"]("observable-bind-duplicate-properties", this);
        }
        Jc(this);
        var e = this[Qc];
        t.forEach(function (t) {
          if (e.has(t)) {
            throw new ss["a"]("observable-bind-rebind", _this13);
          }
        });
        var n = new Map();
        t.forEach(function (t) {
          var o = {
            property: t,
            to: []
          };
          e.set(t, o);
          n.set(t, o);
        });
        return {
          to: Xc,
          toMany: tl,
          _observable: this,
          _bindProperties: t,
          _to: [],
          _bindings: n
        };
      },
      unbind: function unbind() {
        var _this14 = this;
        if (!this[qc]) {
          return;
        }
        var e = this[Qc];
        var n = this[Yc];
        for (var _len12 = arguments.length, t = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          t[_key12] = arguments[_key12];
        }
        if (t.length) {
          if (!nl(t)) {
            throw new ss["a"]("observable-unbind-wrong-properties", this);
          }
          t.forEach(function (t) {
            var o = e.get(t);
            if (!o) {
              return;
            }
            var i, r, s, a;
            o.to.forEach(function (t) {
              i = t[0];
              r = t[1];
              s = n.get(i);
              a = s[r];
              a.delete(o);
              if (!a.size) {
                delete s[r];
              }
              if (!Object.keys(s).length) {
                n.delete(i);
                _this14.stopListening(i, "change");
              }
            });
            e.delete(t);
          });
        } else {
          n.forEach(function (t, e) {
            _this14.stopListening(e, "change");
          });
          n.clear();
          e.clear();
        }
      },
      decorate: function decorate(t) {
        var _this15 = this;
        var e = this[t];
        if (!e) {
          throw new ss["a"]("observablemixin-cannot-decorate-undefined", this, {
            object: this,
            methodName: t
          });
        }
        this.on(t, function (t, n) {
          t.return = e.apply(_this15, n);
        });
        this[t] = function () {
          for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            e[_key13] = arguments[_key13];
          }
          return this.fire(t, e);
        };
      }
    };
    Kc($c, ds);
    var Zc = $c;
    function Jc(t) {
      if (t[qc]) {
        return;
      }
      Object.defineProperty(t, qc, {
        value: new Map()
      });
      Object.defineProperty(t, Yc, {
        value: new Map()
      });
      Object.defineProperty(t, Qc, {
        value: new Map()
      });
    }
    function Xc() {
      var _this16 = this;
      var e = ol.apply(void 0, arguments);
      var n = Array.from(this._bindings.keys());
      var o = n.length;
      if (!e.callback && e.to.length > 1) {
        throw new ss["a"]("observable-bind-to-no-callback", this);
      }
      if (o > 1 && e.callback) {
        throw new ss["a"]("observable-bind-to-extra-callback", this);
      }
      e.to.forEach(function (t) {
        if (t.properties.length && t.properties.length !== o) {
          throw new ss["a"]("observable-bind-to-properties-length", _this16);
        }
        if (!t.properties.length) {
          t.properties = _this16._bindProperties;
        }
      });
      this._to = e.to;
      if (e.callback) {
        this._bindings.get(n[0]).callback = e.callback;
      }
      al(this._observable, this._to);
      rl(this);
      this._bindProperties.forEach(function (t) {
        sl(_this16._observable, t);
      });
    }
    function tl(t, e, n) {
      if (this._bindings.size > 1) {
        throw new ss["a"]("observable-bind-to-many-not-one-binding", this);
      }
      this.to.apply(this, _toConsumableArray(el(t, e)).concat([n]));
    }
    function el(t, e) {
      var n = t.map(function (t) {
        return [t, e];
      });
      return Array.prototype.concat.apply([], n);
    }
    function nl(t) {
      return t.every(function (t) {
        return typeof t == "string";
      });
    }
    function ol() {
      for (var _len14 = arguments.length, t = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
        t[_key14] = arguments[_key14];
      }
      if (!t.length) {
        throw new ss["a"]("observable-bind-to-parse-error", null);
      }
      var e = {
        to: []
      };
      var n;
      if (typeof t[t.length - 1] == "function") {
        e.callback = t.pop();
      }
      t.forEach(function (t) {
        if (typeof t == "string") {
          n.properties.push(t);
        } else if (typeof t == "object") {
          n = {
            observable: t,
            properties: []
          };
          e.to.push(n);
        } else {
          throw new ss["a"]("observable-bind-to-parse-error", null);
        }
      });
      return e;
    }
    function il(t, e, n, o) {
      var i = t[Yc];
      var r = i.get(n);
      var s = r || {};
      if (!s[o]) {
        s[o] = new Set();
      }
      s[o].add(e);
      if (!r) {
        i.set(n, s);
      }
    }
    function rl(t) {
      var e;
      t._bindings.forEach(function (n, o) {
        t._to.forEach(function (i) {
          e = i.properties[n.callback ? 0 : t._bindProperties.indexOf(o)];
          n.to.push([i.observable, e]);
          il(t._observable, n, i.observable, e);
        });
      });
    }
    function sl(t, e) {
      var n = t[Qc];
      var o = n.get(e);
      var i;
      if (o.callback) {
        i = o.callback.apply(t, o.to.map(function (t) {
          return t[0][t[1]];
        }));
      } else {
        i = o.to[0];
        i = i[0][i[1]];
      }
      if (Object.prototype.hasOwnProperty.call(t, e)) {
        t[e] = i;
      } else {
        t.set(e, i);
      }
    }
    function al(t, e) {
      e.forEach(function (e) {
        var n = t[Yc];
        var o;
        if (!n.get(e.observable)) {
          t.listenTo(e.observable, "change", function (i, r) {
            o = n.get(e.observable)[r];
            if (o) {
              o.forEach(function (e) {
                sl(t, e.property);
              });
            }
          });
        }
      });
    }
    var cl = /*#__PURE__*/function (_Hc) {
      _inherits(cl, _Hc);
      function cl(t, e, n, o) {
        var _this17;
        _classCallCheck(this, cl);
        _this17 = _possibleConstructorReturn(this, _getPrototypeOf(cl).call(this, t, e, n, o));
        _this17.set("isReadOnly", false);
        _this17.set("isFocused", false);
        _this17.bind("isReadOnly").to(t);
        _this17.bind("isFocused").to(t, "isFocused", function (e) {
          return e && t.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this17));
        });
        _this17.listenTo(t.selection, "change", function () {
          _this17.isFocused = t.isFocused && t.selection.editableElement == _assertThisInitialized(_assertThisInitialized(_this17));
        });
        return _this17;
      }
      _createClass(cl, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);
      return cl;
    }(Hc);
    _s(cl, Zc);
    var ll = Symbol("rootName");
    var dl = /*#__PURE__*/function (_cl) {
      _inherits(dl, _cl);
      function dl(t, e) {
        var _this18;
        _classCallCheck(this, dl);
        _this18 = _possibleConstructorReturn(this, _getPrototypeOf(dl).call(this, t, e));
        _this18.rootName = "main";
        return _this18;
      }
      _createClass(dl, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "rootName",
        get: function get() {
          return this.getCustomProperty(ll);
        },
        set: function set(t) {
          this._setCustomProperty(ll, t);
        }
      }, {
        key: "_name",
        set: function set(t) {
          this.name = t;
        }
      }]);
      return dl;
    }(cl);
    var ul = /*#__PURE__*/function () {
      function ul() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, ul);
        if (!t.boundaries && !t.startPosition) {
          throw new ss["a"]("view-tree-walker-no-start-position", null);
        }
        if (t.direction && t.direction != "forward" && t.direction != "backward") {
          throw new ss["a"]("view-tree-walker-unknown-direction", t.startPosition, {
            direction: t.direction
          });
        }
        this.boundaries = t.boundaries || null;
        if (t.startPosition) {
          this.position = hl._createAt(t.startPosition);
        } else {
          this.position = hl._createAt(t.boundaries[t.direction == "backward" ? "end" : "start"]);
        }
        this.direction = t.direction || "forward";
        this.singleCharacters = !!t.singleCharacters;
        this.shallow = !!t.shallow;
        this.ignoreElementEnd = !!t.ignoreElementEnd;
        this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
        this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
      }
      _createClass(ul, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, o;
          do {
            o = this.position;
            var _this$next = this.next();
            e = _this$next.done;
            n = _this$next.value;
          } while (!e && t(n));
          if (!e) {
            this.position = o;
          }
        }
      }, {
        key: "next",
        value: function next() {
          if (this.direction == "forward") {
            return this._next();
          } else {
            return this._previous();
          }
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position.clone();
          var e = this.position;
          var n = t.parent;
          if (n.parent === null && t.offset === n.childCount) {
            return {
              done: true
            };
          }
          if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) {
            return {
              done: true
            };
          }
          var o;
          if (n instanceof Vs) {
            if (t.isAtEnd) {
              this.position = hl._createAfter(n);
              return this._next();
            }
            o = n.data[t.offset];
          } else {
            o = n.getChild(t.offset);
          }
          if (o instanceof jc) {
            if (!this.shallow) {
              t = new hl(o, 0);
            } else {
              t.offset++;
            }
            this.position = t;
            return this._formatReturnValue("elementStart", o, e, t, 1);
          } else if (o instanceof Vs) {
            if (this.singleCharacters) {
              t = new hl(o, 0);
              this.position = t;
              return this._next();
            } else {
              var _n22 = o.data.length;
              var _i19;
              if (o == this._boundaryEndParent) {
                _n22 = this.boundaries.end.offset;
                _i19 = new Us(o, 0, _n22);
                t = hl._createAfter(_i19);
              } else {
                _i19 = new Us(o, 0, o.data.length);
                t.offset++;
              }
              this.position = t;
              return this._formatReturnValue("text", _i19, e, t, _n22);
            }
          } else if (typeof o == "string") {
            var _o14;
            if (this.singleCharacters) {
              _o14 = 1;
            } else {
              var _e34 = n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length;
              _o14 = _e34 - t.offset;
            }
            var _i20 = new Us(n, t.offset, _o14);
            t.offset += _o14;
            this.position = t;
            return this._formatReturnValue("text", _i20, e, t, _o14);
          } else {
            t = hl._createAfter(n);
            this.position = t;
            if (this.ignoreElementEnd) {
              return this._next();
            } else {
              return this._formatReturnValue("elementEnd", n, e, t);
            }
          }
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position.clone();
          var e = this.position;
          var n = t.parent;
          if (n.parent === null && t.offset === 0) {
            return {
              done: true
            };
          }
          if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) {
            return {
              done: true
            };
          }
          var o;
          if (n instanceof Vs) {
            if (t.isAtStart) {
              this.position = hl._createBefore(n);
              return this._previous();
            }
            o = n.data[t.offset - 1];
          } else {
            o = n.getChild(t.offset - 1);
          }
          if (o instanceof jc) {
            if (!this.shallow) {
              t = new hl(o, o.childCount);
              this.position = t;
              if (this.ignoreElementEnd) {
                return this._previous();
              } else {
                return this._formatReturnValue("elementEnd", o, e, t);
              }
            } else {
              t.offset--;
              this.position = t;
              return this._formatReturnValue("elementStart", o, e, t, 1);
            }
          } else if (o instanceof Vs) {
            if (this.singleCharacters) {
              t = new hl(o, o.data.length);
              this.position = t;
              return this._previous();
            } else {
              var _n23 = o.data.length;
              var _i21;
              if (o == this._boundaryStartParent) {
                var _e35 = this.boundaries.start.offset;
                _i21 = new Us(o, _e35, o.data.length - _e35);
                _n23 = _i21.data.length;
                t = hl._createBefore(_i21);
              } else {
                _i21 = new Us(o, 0, o.data.length);
                t.offset--;
              }
              this.position = t;
              return this._formatReturnValue("text", _i21, e, t, _n23);
            }
          } else if (typeof o == "string") {
            var _o15;
            if (!this.singleCharacters) {
              var _e36 = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
              _o15 = t.offset - _e36;
            } else {
              _o15 = 1;
            }
            t.offset -= _o15;
            var _i22 = new Us(n, t.offset, _o15);
            this.position = t;
            return this._formatReturnValue("text", _i22, e, t, _o15);
          } else {
            t = hl._createBefore(n);
            this.position = t;
            return this._formatReturnValue("elementStart", n, e, t, 1);
          }
        }
      }, {
        key: "_formatReturnValue",
        value: function _formatReturnValue(t, e, n, o, i) {
          if (e instanceof Us) {
            if (e.offsetInText + e.data.length == e.textNode.data.length) {
              if (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position))) {
                o = hl._createAfter(e.textNode);
                this.position = o;
              } else {
                n = hl._createAfter(e.textNode);
              }
            }
            if (e.offsetInText === 0) {
              if (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position))) {
                o = hl._createBefore(e.textNode);
                this.position = o;
              } else {
                n = hl._createBefore(e.textNode);
              }
            }
          }
          return {
            done: false,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: o,
              length: i
            }
          };
        }
      }]);
      return ul;
    }();
    var hl = /*#__PURE__*/function () {
      function hl(t, e) {
        _classCallCheck(this, hl);
        this.parent = t;
        this.offset = e;
      }
      _createClass(hl, [{
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = hl._createAt(this);
          var n = e.offset + t;
          e.offset = n < 0 ? 0 : n;
          return e;
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new ul(e);
          n.skip(t);
          return n.position;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          if (this.parent.is("documentFragment")) {
            return [this.parent];
          } else {
            return this.parent.getAncestors({
              includeSelf: true
            });
          }
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors();
          var n = t.getAncestors();
          var o = 0;
          while (e[o] == n[o] && e[o]) {
            o++;
          }
          return o === 0 ? null : e[o - 1];
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "position" || t === "view:position";
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset;
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return this.compareWith(t) == "before";
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this.compareWith(t) == "after";
        }
      }, {
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root !== t.root) {
            return "different";
          }
          if (this.isEqual(t)) {
            return "same";
          }
          var e = this.parent.is("node") ? this.parent.getPath() : [];
          var n = t.parent.is("node") ? t.parent.getPath() : [];
          e.push(this.offset);
          n.push(t.offset);
          var o = Ls(e, n);
          switch (o) {
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return e[o] < n[o] ? "before" : "after";
          }
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          t.startPosition = this;
          return new ul(t);
        }
      }, {
        key: "clone",
        value: function clone() {
          return new hl(this.parent, this.offset);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          if (this.parent.is("$text")) {
            return null;
          }
          return this.parent.getChild(this.offset) || null;
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          if (this.parent.is("$text")) {
            return null;
          }
          return this.parent.getChild(this.offset - 1) || null;
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return this.offset === 0;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          var t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
          return this.offset === t;
        }
      }, {
        key: "root",
        get: function get() {
          return this.parent.root;
        }
      }, {
        key: "editableElement",
        get: function get() {
          var t = this.parent;
          while (!(t instanceof cl)) {
            if (t.parent) {
              t = t.parent;
            } else {
              return null;
            }
          }
          return t;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          if (t instanceof hl) {
            return new this(t.parent, t.offset);
          } else {
            var _n24 = t;
            if (e == "end") {
              e = _n24.is("$text") ? _n24.data.length : _n24.childCount;
            } else if (e == "before") {
              return this._createBefore(_n24);
            } else if (e == "after") {
              return this._createAfter(_n24);
            } else if (e !== 0 && !e) {
              throw new ss["a"]("view-createpositionat-offset-required", _n24);
            }
            return new hl(_n24, e);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t) {
          if (t.is("$textProxy")) {
            return new hl(t.textNode, t.offsetInText + t.data.length);
          }
          if (!t.parent) {
            throw new ss["a"]("view-position-after-root", t, {
              root: t
            });
          }
          return new hl(t.parent, t.index + 1);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t) {
          if (t.is("$textProxy")) {
            return new hl(t.textNode, t.offsetInText);
          }
          if (!t.parent) {
            throw new ss["a"]("view-position-before-root", t, {
              root: t
            });
          }
          return new hl(t.parent, t.index);
        }
      }]);
      return hl;
    }();
    var fl = /*#__PURE__*/function () {
      function fl(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _classCallCheck(this, fl);
        this.start = t.clone();
        this.end = e ? e.clone() : t.clone();
      }
      _createClass(fl, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          return _regeneratorRuntime().wrap(function value$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.delegateYield(new ul({
                  boundaries: this,
                  ignoreElementEnd: true
                }), "t0", 1);
              case 1:
              case "end":
                return _context6.stop();
            }
          }, value, this);
        })
      }, {
        key: "getEnlarged",
        value: function getEnlarged() {
          var t = this.start.getLastMatchingPosition(ml, {
            direction: "backward"
          });
          var e = this.end.getLastMatchingPosition(ml);
          if (t.parent.is("$text") && t.isAtStart) {
            t = hl._createBefore(t.parent);
          }
          if (e.parent.is("$text") && e.isAtEnd) {
            e = hl._createAfter(e.parent);
          }
          return new fl(t, e);
        }
      }, {
        key: "getTrimmed",
        value: function getTrimmed() {
          var t = this.start.getLastMatchingPosition(ml);
          if (t.isAfter(this.end) || t.isEqual(this.end)) {
            return new fl(t, t);
          }
          var e = this.end.getLastMatchingPosition(ml, {
            direction: "backward"
          });
          var n = t.nodeAfter;
          var o = e.nodeBefore;
          if (n && n.is("$text")) {
            t = new hl(n, 0);
          }
          if (o && o.is("$text")) {
            e = new hl(o, o.data.length);
          }
          return new fl(t, e);
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          if (t.isCollapsed) {
            e = false;
          }
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start);
          var o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && o;
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          if (this.isIntersecting(t)) {
            if (this.containsPosition(t.start)) {
              e.push(new fl(this.start, t.start));
            }
            if (this.containsPosition(t.end)) {
              e.push(new fl(t.end, this.end));
            }
          } else {
            e.push(this.clone());
          }
          return e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e37 = this.start;
            var _n25 = this.end;
            if (this.containsPosition(t.start)) {
              _e37 = t.start;
            }
            if (this.containsPosition(t.end)) {
              _n25 = t.end;
            }
            return new fl(_e37, _n25);
          }
          return null;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          t.boundaries = this;
          return new ul(t);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) {
            return null;
          }
          var t = this.start.nodeAfter;
          var e = this.end.nodeBefore;
          if (this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling) {
            t = this.start.parent.nextSibling;
          }
          if (this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling) {
            e = this.end.parent.previousSibling;
          }
          if (t && t.is("element") && t === e) {
            return t;
          }
          return null;
        }
      }, {
        key: "clone",
        value: function clone() {
          return new fl(this.start, this.end);
        }
      }, {
        key: "getItems",
        value: function getItems() {
          var _this19 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var e, _iterator33, _step33, _t30;
            return _regeneratorRuntime().wrap(function _callee$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  t.boundaries = _this19;
                  t.ignoreElementEnd = true;
                  e = new ul(t);
                  _iterator33 = _createForOfIteratorHelper(e);
                  _context7.prev = 4;
                  _iterator33.s();
                case 6:
                  if ((_step33 = _iterator33.n()).done) {
                    _context7.next = 12;
                    break;
                  }
                  _t30 = _step33.value;
                  _context7.next = 10;
                  return _t30.item;
                case 10:
                  _context7.next = 6;
                  break;
                case 12:
                  _context7.next = 17;
                  break;
                case 14:
                  _context7.prev = 14;
                  _context7.t0 = _context7["catch"](4);
                  _iterator33.e(_context7.t0);
                case 17:
                  _context7.prev = 17;
                  _iterator33.f();
                  return _context7.finish(17);
                case 20:
                case "end":
                  return _context7.stop();
              }
            }, _callee, null, [[4, 14, 17, 20]]);
          })();
        }
      }, {
        key: "getPositions",
        value: function getPositions() {
          var _this20 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
            var e, _iterator34, _step34, _t31;
            return _regeneratorRuntime().wrap(function _callee2$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  t.boundaries = _this20;
                  e = new ul(t);
                  _context8.next = 4;
                  return e.position;
                case 4:
                  _iterator34 = _createForOfIteratorHelper(e);
                  _context8.prev = 5;
                  _iterator34.s();
                case 7:
                  if ((_step34 = _iterator34.n()).done) {
                    _context8.next = 13;
                    break;
                  }
                  _t31 = _step34.value;
                  _context8.next = 11;
                  return _t31.nextPosition;
                case 11:
                  _context8.next = 7;
                  break;
                case 13:
                  _context8.next = 18;
                  break;
                case 15:
                  _context8.prev = 15;
                  _context8.t0 = _context8["catch"](5);
                  _iterator34.e(_context8.t0);
                case 18:
                  _context8.prev = 18;
                  _iterator34.f();
                  return _context8.finish(18);
                case 21:
                case "end":
                  return _context8.stop();
              }
            }, _callee2, null, [[5, 15, 18, 21]]);
          })();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "range" || t === "view:range";
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          return this.start.parent === this.end.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromParentsAndOffsets",
        value: function _createFromParentsAndOffsets(t, e, n, o) {
          return new this(new hl(t, e), new hl(n, o));
        }
      }, {
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t;
          var o = t.getShiftedBy(e);
          return e > 0 ? new this(n, o) : new this(o, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          var e = t.is("$textProxy") ? t.offsetSize : 1;
          return this._createFromPositionAndShift(hl._createBefore(t), e);
        }
      }]);
      return fl;
    }();
    function ml(t) {
      if (t.item.is("attributeElement") || t.item.is("uiElement")) {
        return true;
      }
      return false;
    }
    function gl(t) {
      var e = 0;
      var _iterator35 = _createForOfIteratorHelper(t),
        _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _n26 = _step35.value;
          e++;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      return e;
    }
    var pl = /*#__PURE__*/function () {
      function pl() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        _classCallCheck(this, pl);
        this._ranges = [];
        this._lastRangeBackward = false;
        this._isFake = false;
        this._fakeSelectionLabel = "";
        this.setTo(t, e, n);
      }
      _createClass(pl, [{
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          var _iterator36, _step36, _t32;
          return _regeneratorRuntime().wrap(function getRanges$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _iterator36 = _createForOfIteratorHelper(this._ranges);
                _context9.prev = 1;
                _iterator36.s();
              case 3:
                if ((_step36 = _iterator36.n()).done) {
                  _context9.next = 9;
                  break;
                }
                _t32 = _step36.value;
                _context9.next = 7;
                return _t32.clone();
              case 7:
                _context9.next = 3;
                break;
              case 9:
                _context9.next = 14;
                break;
              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](1);
                _iterator36.e(_context9.t0);
              case 14:
                _context9.prev = 14;
                _iterator36.f();
                return _context9.finish(14);
              case 17:
              case "end":
                return _context9.stop();
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iterator37 = _createForOfIteratorHelper(this._ranges),
            _step37;
          try {
            for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
              var _e38 = _step37.value;
              if (!t || _e38.start.isBefore(t.start)) {
                t = _e38;
              }
            }
          } catch (err) {
            _iterator37.e(err);
          } finally {
            _iterator37.f();
          }
          return t ? t.clone() : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iterator38 = _createForOfIteratorHelper(this._ranges),
            _step38;
          try {
            for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
              var _e39 = _step38.value;
              if (!t || _e39.end.isAfter(t.end)) {
                t = _e39;
              }
            }
          } catch (err) {
            _iterator38.e(err);
          } finally {
            _iterator38.f();
          }
          return t ? t.clone() : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          if (this.isFake != t.isFake) {
            return false;
          }
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) {
            return false;
          }
          if (this.rangeCount != t.rangeCount) {
            return false;
          } else if (this.rangeCount === 0) {
            return true;
          }
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
            return false;
          }
          var _iterator39 = _createForOfIteratorHelper(this._ranges),
            _step39;
          try {
            for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
              var _e40 = _step39.value;
              var _n27 = false;
              var _iterator40 = _createForOfIteratorHelper(t._ranges),
                _step40;
              try {
                for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
                  var _o16 = _step40.value;
                  if (_e40.isEqual(_o16)) {
                    _n27 = true;
                    break;
                  }
                }
              } catch (err) {
                _iterator40.e(err);
              } finally {
                _iterator40.f();
              }
              if (!_n27) {
                return false;
              }
            }
          } catch (err) {
            _iterator39.e(err);
          } finally {
            _iterator39.f();
          }
          return true;
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.isBackward != t.isBackward) {
            return false;
          }
          var e = gl(this.getRanges());
          var n = gl(t.getRanges());
          if (e != n) {
            return false;
          }
          if (e == 0) {
            return true;
          }
          var _iterator41 = _createForOfIteratorHelper(this.getRanges()),
            _step41;
          try {
            for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
              var _e41 = _step41.value;
              _e41 = _e41.getTrimmed();
              var _n28 = false;
              var _iterator42 = _createForOfIteratorHelper(t.getRanges()),
                _step42;
              try {
                for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
                  var _o17 = _step42.value;
                  _o17 = _o17.getTrimmed();
                  if (_e41.start.isEqual(_o17.start) && _e41.end.isEqual(_o17.end)) {
                    _n28 = true;
                    break;
                  }
                }
              } catch (err) {
                _iterator42.e(err);
              } finally {
                _iterator42.f();
              }
              if (!_n28) {
                return false;
              }
            }
          } catch (err) {
            _iterator41.e(err);
          } finally {
            _iterator41.f();
          }
          return true;
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null;
          }
          return this.getFirstRange().getContainedElement();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (t === null) {
            this._setRanges([]);
            this._setFakeOptions(e);
          } else if (t instanceof pl || t instanceof kl) {
            this._setRanges(t.getRanges(), t.isBackward);
            this._setFakeOptions({
              fake: t.isFake,
              label: t.fakeSelectionLabel
            });
          } else if (t instanceof fl) {
            this._setRanges([t], e && e.backward);
            this._setFakeOptions(e);
          } else if (t instanceof hl) {
            this._setRanges([new fl(t)]);
            this._setFakeOptions(e);
          } else if (t instanceof Fs) {
            var _o18 = !!n && !!n.backward;
            var _i23;
            if (e === undefined) {
              throw new ss["a"]("view-selection-setto-required-second-parameter", this);
            } else if (e == "in") {
              _i23 = fl._createIn(t);
            } else if (e == "on") {
              _i23 = fl._createOn(t);
            } else {
              _i23 = new fl(hl._createAt(t, e));
            }
            this._setRanges([_i23], _o18);
            this._setFakeOptions(n);
          } else if (As(t)) {
            this._setRanges(t, e && e.backward);
            this._setFakeOptions(e);
          } else {
            throw new ss["a"]("view-selection-setto-not-selectable", this);
          }
          this.fire("change");
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (this.anchor === null) {
            throw new ss["a"]("view-selection-setfocus-no-ranges", this);
          }
          var n = hl._createAt(t, e);
          if (n.compareWith(this.focus) == "same") {
            return;
          }
          var o = this.anchor;
          this._ranges.pop();
          if (n.compareWith(o) == "before") {
            this._addRange(new fl(n, o), true);
          } else {
            this._addRange(new fl(o, n));
          }
          this.fire("change");
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "selection" || t === "view:selection";
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          t = Array.from(t);
          this._ranges = [];
          var _iterator43 = _createForOfIteratorHelper(t),
            _step43;
          try {
            for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
              var _e42 = _step43.value;
              this._addRange(_e42);
            }
          } catch (err) {
            _iterator43.e(err);
          } finally {
            _iterator43.f();
          }
          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_setFakeOptions",
        value: function _setFakeOptions() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          this._isFake = !!t.fake;
          this._fakeSelectionLabel = t.fake ? t.label || "" : "";
        }
      }, {
        key: "_addRange",
        value: function _addRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          if (!(t instanceof fl)) {
            throw new ss["a"]("view-selection-add-range-not-range", this);
          }
          this._pushRange(t);
          this._lastRangeBackward = !!e;
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var _iterator44 = _createForOfIteratorHelper(this._ranges),
            _step44;
          try {
            for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
              var _e43 = _step44.value;
              if (t.isIntersecting(_e43)) {
                throw new ss["a"]("view-selection-range-intersects", this, {
                  addedRange: t,
                  intersectingRange: _e43
                });
              }
            }
          } catch (err) {
            _iterator44.e(err);
          } finally {
            _iterator44.f();
          }
          this._ranges.push(new fl(t.start, t.end));
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          if (!this._ranges.length) {
            return null;
          }
          var t = this._ranges[this._ranges.length - 1];
          var e = this._lastRangeBackward ? t.end : t.start;
          return e.clone();
        }
      }, {
        key: "focus",
        get: function get() {
          if (!this._ranges.length) {
            return null;
          }
          var t = this._ranges[this._ranges.length - 1];
          var e = this._lastRangeBackward ? t.start : t.end;
          return e.clone();
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.rangeCount === 1 && this._ranges[0].isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          if (this.anchor) {
            return this.anchor.editableElement;
          }
          return null;
        }
      }]);
      return pl;
    }();
    _s(pl, ds);
    var kl = /*#__PURE__*/function () {
      function kl() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        _classCallCheck(this, kl);
        this._selection = new pl();
        this._selection.delegate("change").to(this);
        this._selection.setTo(t, e, n);
      }
      _createClass(kl, [{
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          return _regeneratorRuntime().wrap(function getRanges$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.delegateYield(this._selection.getRanges(), "t0", 1);
              case 1:
              case "end":
                return _context10.stop();
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this._selection.isEqual(t);
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          return this._selection.isSimilar(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "selection" || t == "documentSelection" || t == "view:selection" || t == "view:documentSelection";
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "isFake",
        get: function get() {
          return this._selection.isFake;
        }
      }, {
        key: "fakeSelectionLabel",
        get: function get() {
          return this._selection.fakeSelectionLabel;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "editableElement",
        get: function get() {
          return this._selection.editableElement;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }]);
      return kl;
    }();
    _s(kl, ds);
    var bl = /*#__PURE__*/function () {
      function bl(t) {
        _classCallCheck(this, bl);
        this.selection = new kl();
        this.roots = new vs({
          idProperty: "rootName"
        });
        this.stylesProcessor = t;
        this.set("isReadOnly", false);
        this.set("isFocused", false);
        this.set("isComposing", false);
        this._postFixers = new Set();
      }
      _createClass(bl, [{
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.roots.map(function (t) {
            return t.destroy();
          });
          this.stopListening();
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = false;
          do {
            var _iterator45 = _createForOfIteratorHelper(this._postFixers),
              _step45;
            try {
              for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
                var _n29 = _step45.value;
                e = _n29(t);
                if (e) {
                  break;
                }
              }
            } catch (err) {
              _iterator45.e(err);
            } finally {
              _iterator45.f();
            }
          } while (e);
        }
      }]);
      return bl;
    }();
    _s(bl, Zc);
    var wl = 10;
    var Cl = /*#__PURE__*/function (_jc2) {
      _inherits(Cl, _jc2);
      function Cl(t, e, n, o) {
        var _this21;
        _classCallCheck(this, Cl);
        _this21 = _possibleConstructorReturn(this, _getPrototypeOf(Cl).call(this, t, e, n, o));
        _this21.getFillerOffset = Al;
        _this21._priority = wl;
        _this21._id = null;
        _this21._clonesGroup = null;
        return _this21;
      }
      _createClass(Cl, [{
        key: "getElementsWithSameId",
        value: function getElementsWithSameId() {
          if (this.id === null) {
            throw new ss["a"]("attribute-element-get-elements-with-same-id-no-id", this);
          }
          return new Set(this._clonesGroup);
        }
      }, {
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "isSimilar",
        value: function isSimilar(t) {
          if (this.id !== null || t.id !== null) {
            return this.id === t.id;
          }
          return _get(_getPrototypeOf(Cl.prototype), "isSimilar", this).call(this, t) && this.priority == t.priority;
        }
      }, {
        key: "_clone",
        value: function _clone(t) {
          var e = _get(_getPrototypeOf(Cl.prototype), "_clone", this).call(this, t);
          e._priority = this._priority;
          e._id = this._id;
          return e;
        }
      }, {
        key: "priority",
        get: function get() {
          return this._priority;
        }
      }, {
        key: "id",
        get: function get() {
          return this._id;
        }
      }]);
      return Cl;
    }(jc);
    Cl.DEFAULT_PRIORITY = wl;
    function Al() {
      if (_l(this)) {
        return null;
      }
      var t = this.parent;
      while (t && t.is("attributeElement")) {
        if (_l(t) > 1) {
          return null;
        }
        t = t.parent;
      }
      if (!t || _l(t) > 1) {
        return null;
      }
      return this.childCount;
    }
    function _l(t) {
      return Array.from(t.getChildren()).filter(function (t) {
        return !t.is("uiElement");
      }).length;
    }
    var vl = /*#__PURE__*/function (_jc3) {
      _inherits(vl, _jc3);
      function vl(t, e, n, o) {
        var _this22;
        _classCallCheck(this, vl);
        _this22 = _possibleConstructorReturn(this, _getPrototypeOf(vl).call(this, t, e, n, o));
        _this22.getFillerOffset = yl;
        return _this22;
      }
      _createClass(vl, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Fs || Array.from(e).length > 0)) {
            throw new ss["a"]("view-emptyelement-cannot-add", [this, e]);
          }
        }
      }]);
      return vl;
    }(jc);
    function yl() {
      return null;
    }
    var xl = navigator.userAgent.toLowerCase();
    var Dl = {
      isMac: Ml(xl),
      isGecko: Sl(xl),
      isSafari: Tl(xl),
      isAndroid: Il(xl),
      isBlink: Nl(xl),
      features: {
        isRegExpUnicodePropertySupported: Pl()
      }
    };
    var El = Dl;
    function Ml(t) {
      return t.indexOf("macintosh") > -1;
    }
    function Sl(t) {
      return !!t.match(/gecko\/\d+/);
    }
    function Tl(t) {
      return t.indexOf(" applewebkit/") > -1 && t.indexOf("chrome") === -1;
    }
    function Il(t) {
      return t.indexOf("android") > -1;
    }
    function Nl(t) {
      return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
    }
    function Pl() {
      var t = false;
      try {
        t = "ć".search(new RegExp("[\\p{L}]", "u")) === 0;
      } catch (t) {}
      return t;
    }
    var Bl = {
      "⌘": "ctrl",
      "⇧": "shift",
      "⌥": "alt"
    };
    var zl = {
      ctrl: "⌘",
      shift: "⇧",
      alt: "⌥"
    };
    var Ll = Hl();
    function Ol(t) {
      var e;
      if (typeof t == "string") {
        e = Ll[t.toLowerCase()];
        if (!e) {
          throw new ss["a"]("keyboard-unknown-key", null, {
            key: t
          });
        }
      } else {
        e = t.keyCode + (t.altKey ? Ll.alt : 0) + (t.ctrlKey ? Ll.ctrl : 0) + (t.shiftKey ? Ll.shift : 0);
      }
      return e;
    }
    function Rl(t) {
      if (typeof t == "string") {
        t = Gl(t);
      }
      return t.map(function (t) {
        return typeof t == "string" ? Ol(t) : t;
      }).reduce(function (t, e) {
        return e + t;
      }, 0);
    }
    function jl(t) {
      if (!El.isMac) {
        return t;
      }
      return Gl(t).map(function (t) {
        return zl[t.toLowerCase()] || t;
      }).reduce(function (t, e) {
        if (t.slice(-1) in Bl) {
          return t + e;
        } else {
          return t + "+" + e;
        }
      });
    }
    function Fl(t) {
      return t == Ll.arrowright || t == Ll.arrowleft || t == Ll.arrowup || t == Ll.arrowdown;
    }
    function Vl(t, e) {
      var n = e === "ltr";
      switch (t) {
        case Ll.arrowleft:
          return n ? "left" : "right";
        case Ll.arrowright:
          return n ? "right" : "left";
        case Ll.arrowup:
          return "up";
        case Ll.arrowdown:
          return "down";
      }
    }
    function Ul(t, e) {
      var n = Vl(t, e);
      return n === "down" || n === "right";
    }
    function Hl() {
      var t = {
        arrowleft: 37,
        arrowup: 38,
        arrowright: 39,
        arrowdown: 40,
        backspace: 8,
        delete: 46,
        enter: 13,
        space: 32,
        esc: 27,
        tab: 9,
        ctrl: 1114112,
        cmd: 1114112,
        shift: 2228224,
        alt: 4456448
      };
      for (var _e44 = 65; _e44 <= 90; _e44++) {
        var _n30 = String.fromCharCode(_e44);
        t[_n30.toLowerCase()] = _e44;
      }
      for (var _e45 = 48; _e45 <= 57; _e45++) {
        t[_e45 - 48] = _e45;
      }
      for (var _e46 = 112; _e46 <= 123; _e46++) {
        t["f" + (_e46 - 111)] = _e46;
      }
      return t;
    }
    function Gl(t) {
      return t.split(/\s*\+\s*/);
    }
    var Wl = /*#__PURE__*/function (_jc4) {
      _inherits(Wl, _jc4);
      function Wl(t, e, n, o) {
        var _this23;
        _classCallCheck(this, Wl);
        _this23 = _possibleConstructorReturn(this, _getPrototypeOf(Wl).call(this, t, e, n, o));
        _this23.getFillerOffset = ql;
        return _this23;
      }
      _createClass(Wl, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Fs || Array.from(e).length > 0)) {
            throw new ss["a"]("view-uielement-cannot-add", this);
          }
        }
      }, {
        key: "render",
        value: function render(t) {
          return this.toDomElement(t);
        }
      }, {
        key: "toDomElement",
        value: function toDomElement(t) {
          var e = t.createElement(this.name);
          var _iterator46 = _createForOfIteratorHelper(this.getAttributeKeys()),
            _step46;
          try {
            for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
              var _t33 = _step46.value;
              e.setAttribute(_t33, this.getAttribute(_t33));
            }
          } catch (err) {
            _iterator46.e(err);
          } finally {
            _iterator46.f();
          }
          return e;
        }
      }]);
      return Wl;
    }(jc);
    function Kl(t) {
      t.document.on("keydown", function (e, n) {
        return Yl(e, n, t.domConverter);
      });
    }
    function ql() {
      return null;
    }
    function Yl(t, e, n) {
      if (e.keyCode == Ll.arrowright) {
        var _t34 = e.domTarget.ownerDocument.defaultView.getSelection();
        var _o19 = _t34.rangeCount == 1 && _t34.getRangeAt(0).collapsed;
        if (_o19 || e.shiftKey) {
          var _e47 = _t34.focusNode;
          var _i24 = _t34.focusOffset;
          var _r5 = n.domPositionToView(_e47, _i24);
          if (_r5 === null) {
            return;
          }
          var _s3 = false;
          var _a3 = _r5.getLastMatchingPosition(function (t) {
            if (t.item.is("uiElement")) {
              _s3 = true;
            }
            if (t.item.is("uiElement") || t.item.is("attributeElement")) {
              return true;
            }
            return false;
          });
          if (_s3) {
            var _e48 = n.viewPositionToDom(_a3);
            if (_o19) {
              _t34.collapse(_e48.parent, _e48.offset);
            } else {
              _t34.extend(_e48.parent, _e48.offset);
            }
          }
        }
      }
    }
    var Ql = /*#__PURE__*/function (_jc5) {
      _inherits(Ql, _jc5);
      function Ql(t, e, n, o) {
        var _this24;
        _classCallCheck(this, Ql);
        _this24 = _possibleConstructorReturn(this, _getPrototypeOf(Ql).call(this, t, e, n, o));
        _this24.getFillerOffset = $l;
        return _this24;
      }
      _createClass(Ql, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "rawElement" || t === "view:rawElement" || t === this.name || t === "view:" + this.name || t === "element" || t === "view:element" || t === "node" || t === "view:node";
          } else {
            return e === this.name && (t === "rawElement" || t === "view:rawElement" || t === "element" || t === "view:element");
          }
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          if (e && (e instanceof Fs || Array.from(e).length > 0)) {
            throw new ss["a"]("view-rawelement-cannot-add", [this, e]);
          }
        }
      }]);
      return Ql;
    }(jc);
    function $l() {
      return null;
    }
    var Zl = /*#__PURE__*/function () {
      function Zl(t, e) {
        _classCallCheck(this, Zl);
        this.document = t;
        this._children = [];
        if (e) {
          this._insertChild(0, e);
        }
      }
      _createClass(Zl, [{
        key: Symbol.iterator,
        value: function value() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "documentFragment" || t === "view:documentFragment";
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          return this._insertChild(this.childCount, t);
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children[t];
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.indexOf(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          this._fireChange("children", this);
          var n = 0;
          var o = Jl(this.document, e);
          var _iterator47 = _createForOfIteratorHelper(o),
            _step47;
          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var _e49 = _step47.value;
              if (_e49.parent !== null) {
                _e49._remove();
              }
              _e49.parent = this;
              this._children.splice(t, 0, _e49);
              t++;
              n++;
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
          return n;
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          this._fireChange("children", this);
          for (var _n31 = t; _n31 < t + e; _n31++) {
            this._children[_n31].parent = null;
          }
          return this._children.splice(t, e);
        }
      }, {
        key: "_fireChange",
        value: function _fireChange(t, e) {
          this.fire("change:" + t, e);
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return this.childCount === 0;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }]);
      return Zl;
    }();
    _s(Zl, ds);
    function Jl(t, e) {
      if (typeof e == "string") {
        return [new Vs(t, e)];
      }
      if (!As(e)) {
        e = [e];
      }
      return Array.from(e).map(function (e) {
        if (typeof e == "string") {
          return new Vs(t, e);
        }
        if (e instanceof Us) {
          return new Vs(t, e.data);
        }
        return e;
      });
    }
    var Xl = /*#__PURE__*/function () {
      function Xl(t) {
        _classCallCheck(this, Xl);
        this.document = t;
        this._cloneGroups = new Map();
      }
      _createClass(Xl, [{
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this.document.selection._setFocus(t, e);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new Vs(this.document, t);
        }
      }, {
        key: "createAttributeElement",
        value: function createAttributeElement(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = new Cl(this.document, t, e);
          if (n.priority) {
            o._priority = n.priority;
          }
          if (n.id) {
            o._id = n.id;
          }
          return o;
        }
      }, {
        key: "createContainerElement",
        value: function createContainerElement(t, e) {
          return new Hc(this.document, t, e);
        }
      }, {
        key: "createEditableElement",
        value: function createEditableElement(t, e) {
          var n = new cl(this.document, t, e);
          n._document = this.document;
          return n;
        }
      }, {
        key: "createEmptyElement",
        value: function createEmptyElement(t, e) {
          return new vl(this.document, t, e);
        }
      }, {
        key: "createUIElement",
        value: function createUIElement(t, e, n) {
          var o = new Wl(this.document, t, e);
          if (n) {
            o.render = n;
          }
          return o;
        }
      }, {
        key: "createRawElement",
        value: function createRawElement(t, e, n) {
          var o = new Ql(this.document, t, e);
          o.render = n || function () {};
          return o;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          if (B(t) && n === undefined) {
            n = e;
          }
          n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "breakAttributes",
        value: function breakAttributes(t) {
          if (t instanceof hl) {
            return this._breakAttributes(t);
          } else {
            return this._breakAttributesRange(t);
          }
        }
      }, {
        key: "breakContainer",
        value: function breakContainer(t) {
          var e = t.parent;
          if (!e.is("containerElement")) {
            throw new ss["a"]("view-writer-break-non-container-element", this.document);
          }
          if (!e.parent) {
            throw new ss["a"]("view-writer-break-root", this.document);
          }
          if (t.isAtStart) {
            return hl._createBefore(e);
          } else if (!t.isAtEnd) {
            var _n32 = e._clone(false);
            this.insert(hl._createAfter(e), _n32);
            var _o20 = new fl(t, hl._createAt(e, "end"));
            var _i25 = new hl(_n32, 0);
            this.move(_o20, _i25);
          }
          return hl._createAfter(e);
        }
      }, {
        key: "mergeAttributes",
        value: function mergeAttributes(t) {
          var e = t.offset;
          var n = t.parent;
          if (n.is("$text")) {
            return t;
          }
          if (n.is("attributeElement") && n.childCount === 0) {
            var _t35 = n.parent;
            var _e50 = n.index;
            n._remove();
            this._removeFromClonedElementsGroup(n);
            return this.mergeAttributes(new hl(_t35, _e50));
          }
          var o = n.getChild(e - 1);
          var i = n.getChild(e);
          if (!o || !i) {
            return t;
          }
          if (o.is("$text") && i.is("$text")) {
            return rd(o, i);
          } else if (o.is("attributeElement") && i.is("attributeElement") && o.isSimilar(i)) {
            var _t36 = o.childCount;
            o._appendChild(i.getChildren());
            i._remove();
            this._removeFromClonedElementsGroup(i);
            return this.mergeAttributes(new hl(o, _t36));
          }
          return t;
        }
      }, {
        key: "mergeContainers",
        value: function mergeContainers(t) {
          var e = t.nodeBefore;
          var n = t.nodeAfter;
          if (!e || !n || !e.is("containerElement") || !n.is("containerElement")) {
            throw new ss["a"]("view-writer-merge-containers-invalid-position", this.document);
          }
          var o = e.getChild(e.childCount - 1);
          var i = o instanceof Vs ? hl._createAt(o, "end") : hl._createAt(e, "end");
          this.move(fl._createIn(n), hl._createAt(e, "end"));
          this.remove(fl._createOn(n));
          return i;
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          e = As(e) ? _toConsumableArray(e) : [e];
          sd(e, this.document);
          var n = ed(t);
          if (!n) {
            throw new ss["a"]("view-writer-invalid-position-container", this.document);
          }
          var o = this._breakAttributes(t, true);
          var i = n._insertChild(o.offset, e);
          var _iterator48 = _createForOfIteratorHelper(e),
            _step48;
          try {
            for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
              var _t38 = _step48.value;
              this._addToClonedElementsGroup(_t38);
            }
          } catch (err) {
            _iterator48.e(err);
          } finally {
            _iterator48.f();
          }
          var r = o.getShiftedBy(i);
          var s = this.mergeAttributes(o);
          if (i === 0) {
            return new fl(s, s);
          } else {
            if (!s.isEqual(o)) {
              r.offset--;
            }
            var _t37 = this.mergeAttributes(r);
            return new fl(s, _t37);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t instanceof fl ? t : fl._createOn(t);
          ld(e, this.document);
          if (e.isCollapsed) {
            return new Zl(this.document);
          }
          var _this$_breakAttribute = this._breakAttributesRange(e, true),
            n = _this$_breakAttribute.start,
            o = _this$_breakAttribute.end;
          var i = n.parent;
          var r = o.offset - n.offset;
          var s = i._removeChildren(n.offset, r);
          var _iterator49 = _createForOfIteratorHelper(s),
            _step49;
          try {
            for (_iterator49.s(); !(_step49 = _iterator49.n()).done;) {
              var _t39 = _step49.value;
              this._removeFromClonedElementsGroup(_t39);
            }
          } catch (err) {
            _iterator49.e(err);
          } finally {
            _iterator49.f();
          }
          var a = this.mergeAttributes(n);
          e.start = a;
          e.end = a.clone();
          return new Zl(this.document, s);
        }
      }, {
        key: "clear",
        value: function clear(t, e) {
          ld(t, this.document);
          var n = t.getWalker({
            direction: "backward",
            ignoreElementEnd: true
          });
          var _iterator50 = _createForOfIteratorHelper(n),
            _step50;
          try {
            for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
              var _o21 = _step50.value;
              var _n33 = _o21.item;
              var _i26 = void 0;
              if (_n33.is("element") && e.isSimilar(_n33)) {
                _i26 = fl._createOn(_n33);
              } else if (!_o21.nextPosition.isAfter(t.start) && _n33.is("$textProxy")) {
                var _t40 = _n33.getAncestors().find(function (t) {
                  return t.is("element") && e.isSimilar(t);
                });
                if (_t40) {
                  _i26 = fl._createIn(_t40);
                }
              }
              if (_i26) {
                if (_i26.end.isAfter(t.end)) {
                  _i26.end = t.end;
                }
                if (_i26.start.isBefore(t.start)) {
                  _i26.start = t.start;
                }
                this.remove(_i26);
              }
            }
          } catch (err) {
            _iterator50.e(err);
          } finally {
            _iterator50.f();
          }
        }
      }, {
        key: "move",
        value: function move(t, e) {
          var n;
          if (e.isAfter(t.end)) {
            e = this._breakAttributes(e, true);
            var _o22 = e.parent;
            var _i27 = _o22.childCount;
            t = this._breakAttributesRange(t, true);
            n = this.remove(t);
            e.offset += _o22.childCount - _i27;
          } else {
            n = this.remove(t);
          }
          return this.insert(e, n);
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          if (!(e instanceof Cl)) {
            throw new ss["a"]("view-writer-wrap-invalid-attribute", this.document);
          }
          ld(t, this.document);
          if (!t.isCollapsed) {
            return this._wrapRange(t, e);
          } else {
            var _n34 = t.start;
            if (_n34.parent.is("element") && !td(_n34.parent)) {
              _n34 = _n34.getLastMatchingPosition(function (t) {
                return t.item.is("uiElement");
              });
            }
            _n34 = this._wrapPosition(_n34, e);
            var _o23 = this.document.selection;
            if (_o23.isCollapsed && _o23.getFirstPosition().isEqual(t.start)) {
              this.setSelection(_n34);
            }
            return new fl(_n34);
          }
        }
      }, {
        key: "unwrap",
        value: function unwrap(t, e) {
          if (!(e instanceof Cl)) {
            throw new ss["a"]("view-writer-unwrap-invalid-attribute", this.document);
          }
          ld(t, this.document);
          if (t.isCollapsed) {
            return t;
          }
          var _this$_breakAttribute2 = this._breakAttributesRange(t, true),
            n = _this$_breakAttribute2.start,
            o = _this$_breakAttribute2.end;
          var i = n.parent;
          var r = this._unwrapChildren(i, n.offset, o.offset, e);
          var s = this.mergeAttributes(r.start);
          if (!s.isEqual(r.start)) {
            r.end.offset--;
          }
          var a = this.mergeAttributes(r.end);
          return new fl(s, a);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new Hc(this.document, t, e.getAttributes());
          this.insert(hl._createAfter(e), n);
          this.move(fl._createIn(e), hl._createAt(n, 0));
          this.remove(fl._createOn(e));
          return n;
        }
      }, {
        key: "clearClonedElementsGroup",
        value: function clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return hl._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return hl._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return hl._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new fl(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return fl._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return fl._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new pl(t, e, n);
        }
      }, {
        key: "_wrapChildren",
        value: function _wrapChildren(t, e, n, o) {
          var i = e;
          var r = [];
          while (i < n) {
            var _e51 = t.getChild(i);
            var _n35 = _e51.is("$text");
            var _s4 = _e51.is("attributeElement");
            var _a4 = _e51.is("emptyElement");
            var _c2 = _e51.is("uiElement");
            var _l2 = _e51.is("rawElement");
            if (_s4 && this._wrapAttributeElement(o, _e51)) {
              r.push(new hl(t, i));
            } else if (_n35 || _a4 || _c2 || _l2 || _s4 && nd(o, _e51)) {
              var _n36 = o._clone();
              _e51._remove();
              _n36._appendChild(_e51);
              t._insertChild(i, _n36);
              this._addToClonedElementsGroup(_n36);
              r.push(new hl(t, i));
            } else if (_s4) {
              this._wrapChildren(_e51, 0, _e51.childCount, o);
            }
            i++;
          }
          var s = 0;
          for (var _i28 = 0, _r6 = r; _i28 < _r6.length; _i28++) {
            var _t41 = _r6[_i28];
            _t41.offset -= s;
            if (_t41.offset == e) {
              continue;
            }
            var _o24 = this.mergeAttributes(_t41);
            if (!_o24.isEqual(_t41)) {
              s++;
              n--;
            }
          }
          return fl._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_unwrapChildren",
        value: function _unwrapChildren(t, e, n, o) {
          var i = e;
          var r = [];
          while (i < n) {
            var _e52 = t.getChild(i);
            if (!_e52.is("attributeElement")) {
              i++;
              continue;
            }
            if (_e52.isSimilar(o)) {
              var _o25 = _e52.getChildren();
              var _s5 = _e52.childCount;
              _e52._remove();
              t._insertChild(i, _o25);
              this._removeFromClonedElementsGroup(_e52);
              r.push(new hl(t, i), new hl(t, i + _s5));
              i += _s5;
              n += _s5 - 1;
              continue;
            }
            if (this._unwrapAttributeElement(o, _e52)) {
              r.push(new hl(t, i), new hl(t, i + 1));
              i++;
              continue;
            }
            this._unwrapChildren(_e52, 0, _e52.childCount, o);
            i++;
          }
          var s = 0;
          for (var _i29 = 0, _r7 = r; _i29 < _r7.length; _i29++) {
            var _t42 = _r7[_i29];
            _t42.offset -= s;
            if (_t42.offset == e || _t42.offset == n) {
              continue;
            }
            var _o26 = this.mergeAttributes(_t42);
            if (!_o26.isEqual(_t42)) {
              s++;
              n--;
            }
          }
          return fl._createFromParentsAndOffsets(t, e, t, n);
        }
      }, {
        key: "_wrapRange",
        value: function _wrapRange(t, e) {
          var _this$_breakAttribute3 = this._breakAttributesRange(t, true),
            n = _this$_breakAttribute3.start,
            o = _this$_breakAttribute3.end;
          var i = n.parent;
          var r = this._wrapChildren(i, n.offset, o.offset, e);
          var s = this.mergeAttributes(r.start);
          if (!s.isEqual(r.start)) {
            r.end.offset--;
          }
          var a = this.mergeAttributes(r.end);
          return new fl(s, a);
        }
      }, {
        key: "_wrapPosition",
        value: function _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) {
            return od(t.clone());
          }
          if (t.parent.is("$text")) {
            t = id(t);
          }
          var n = this.createAttributeElement();
          n._priority = Number.POSITIVE_INFINITY;
          n.isSimilar = function () {
            return false;
          };
          t.parent._insertChild(t.offset, n);
          var o = new fl(t, t.getShiftedBy(1));
          this.wrap(o, e);
          var i = new hl(n.parent, n.index);
          n._remove();
          var r = i.nodeBefore;
          var s = i.nodeAfter;
          if (r instanceof Vs && s instanceof Vs) {
            return rd(r, s);
          }
          return od(i);
        }
      }, {
        key: "_wrapAttributeElement",
        value: function _wrapAttributeElement(t, e) {
          if (!dd(t, e)) {
            return false;
          }
          if (t.name !== e.name || t.priority !== e.priority) {
            return false;
          }
          var _iterator51 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step51;
          try {
            for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
              var _n37 = _step51.value;
              if (_n37 === "class" || _n37 === "style") {
                continue;
              }
              if (e.hasAttribute(_n37) && e.getAttribute(_n37) !== t.getAttribute(_n37)) {
                return false;
              }
            }
          } catch (err) {
            _iterator51.e(err);
          } finally {
            _iterator51.f();
          }
          var _iterator52 = _createForOfIteratorHelper(t.getStyleNames()),
            _step52;
          try {
            for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
              var _n38 = _step52.value;
              if (e.hasStyle(_n38) && e.getStyle(_n38) !== t.getStyle(_n38)) {
                return false;
              }
            }
          } catch (err) {
            _iterator52.e(err);
          } finally {
            _iterator52.f();
          }
          var _iterator53 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step53;
          try {
            for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
              var _n39 = _step53.value;
              if (_n39 === "class" || _n39 === "style") {
                continue;
              }
              if (!e.hasAttribute(_n39)) {
                this.setAttribute(_n39, t.getAttribute(_n39), e);
              }
            }
          } catch (err) {
            _iterator53.e(err);
          } finally {
            _iterator53.f();
          }
          var _iterator54 = _createForOfIteratorHelper(t.getStyleNames()),
            _step54;
          try {
            for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
              var _n40 = _step54.value;
              if (!e.hasStyle(_n40)) {
                this.setStyle(_n40, t.getStyle(_n40), e);
              }
            }
          } catch (err) {
            _iterator54.e(err);
          } finally {
            _iterator54.f();
          }
          var _iterator55 = _createForOfIteratorHelper(t.getClassNames()),
            _step55;
          try {
            for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
              var _n41 = _step55.value;
              if (!e.hasClass(_n41)) {
                this.addClass(_n41, e);
              }
            }
          } catch (err) {
            _iterator55.e(err);
          } finally {
            _iterator55.f();
          }
          return true;
        }
      }, {
        key: "_unwrapAttributeElement",
        value: function _unwrapAttributeElement(t, e) {
          if (!dd(t, e)) {
            return false;
          }
          if (t.name !== e.name || t.priority !== e.priority) {
            return false;
          }
          var _iterator56 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step56;
          try {
            for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
              var _n42 = _step56.value;
              if (_n42 === "class" || _n42 === "style") {
                continue;
              }
              if (!e.hasAttribute(_n42) || e.getAttribute(_n42) !== t.getAttribute(_n42)) {
                return false;
              }
            }
          } catch (err) {
            _iterator56.e(err);
          } finally {
            _iterator56.f();
          }
          if (!e.hasClass.apply(e, _toConsumableArray(t.getClassNames()))) {
            return false;
          }
          var _iterator57 = _createForOfIteratorHelper(t.getStyleNames()),
            _step57;
          try {
            for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
              var _n43 = _step57.value;
              if (!e.hasStyle(_n43) || e.getStyle(_n43) !== t.getStyle(_n43)) {
                return false;
              }
            }
          } catch (err) {
            _iterator57.e(err);
          } finally {
            _iterator57.f();
          }
          var _iterator58 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step58;
          try {
            for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
              var _n44 = _step58.value;
              if (_n44 === "class" || _n44 === "style") {
                continue;
              }
              this.removeAttribute(_n44, e);
            }
          } catch (err) {
            _iterator58.e(err);
          } finally {
            _iterator58.f();
          }
          this.removeClass(Array.from(t.getClassNames()), e);
          this.removeStyle(Array.from(t.getStyleNames()), e);
          return true;
        }
      }, {
        key: "_breakAttributesRange",
        value: function _breakAttributesRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var n = t.start;
          var o = t.end;
          ld(t, this.document);
          if (t.isCollapsed) {
            var _n45 = this._breakAttributes(t.start, e);
            return new fl(_n45, _n45);
          }
          var i = this._breakAttributes(o, e);
          var r = i.parent.childCount;
          var s = this._breakAttributes(n, e);
          i.offset += i.parent.childCount - r;
          return new fl(s, i);
        }
      }, {
        key: "_breakAttributes",
        value: function _breakAttributes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var n = t.offset;
          var o = t.parent;
          if (t.parent.is("emptyElement")) {
            throw new ss["a"]("view-writer-cannot-break-empty-element", this.document);
          }
          if (t.parent.is("uiElement")) {
            throw new ss["a"]("view-writer-cannot-break-ui-element", this.document);
          }
          if (t.parent.is("rawElement")) {
            throw new ss["a"]("view-writer-cannot-break-raw-element", this.document);
          }
          if (!e && o.is("$text") && cd(o.parent)) {
            return t.clone();
          }
          if (cd(o)) {
            return t.clone();
          }
          if (o.is("$text")) {
            return this._breakAttributes(id(t), e);
          }
          var i = o.childCount;
          if (n == i) {
            var _t43 = new hl(o.parent, o.index + 1);
            return this._breakAttributes(_t43, e);
          } else {
            if (n === 0) {
              var _t44 = new hl(o.parent, o.index);
              return this._breakAttributes(_t44, e);
            } else {
              var _t45 = o.index + 1;
              var _i30 = o._clone();
              o.parent._insertChild(_t45, _i30);
              this._addToClonedElementsGroup(_i30);
              var _r8 = o.childCount - n;
              var _s6 = o._removeChildren(n, _r8);
              _i30._appendChild(_s6);
              var _a5 = new hl(o.parent, _t45);
              return this._breakAttributes(_a5, e);
            }
          }
        }
      }, {
        key: "_addToClonedElementsGroup",
        value: function _addToClonedElementsGroup(t) {
          if (!t.root.is("rootElement")) {
            return;
          }
          if (t.is("element")) {
            var _iterator59 = _createForOfIteratorHelper(t.getChildren()),
              _step59;
            try {
              for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
                var _e53 = _step59.value;
                this._addToClonedElementsGroup(_e53);
              }
            } catch (err) {
              _iterator59.e(err);
            } finally {
              _iterator59.f();
            }
          }
          var e = t.id;
          if (!e) {
            return;
          }
          var n = this._cloneGroups.get(e);
          if (!n) {
            n = new Set();
            this._cloneGroups.set(e, n);
          }
          n.add(t);
          t._clonesGroup = n;
        }
      }, {
        key: "_removeFromClonedElementsGroup",
        value: function _removeFromClonedElementsGroup(t) {
          if (t.is("element")) {
            var _iterator60 = _createForOfIteratorHelper(t.getChildren()),
              _step60;
            try {
              for (_iterator60.s(); !(_step60 = _iterator60.n()).done;) {
                var _e54 = _step60.value;
                this._removeFromClonedElementsGroup(_e54);
              }
            } catch (err) {
              _iterator60.e(err);
            } finally {
              _iterator60.f();
            }
          }
          var e = t.id;
          if (!e) {
            return;
          }
          var n = this._cloneGroups.get(e);
          if (!n) {
            return;
          }
          n.delete(t);
        }
      }]);
      return Xl;
    }();
    function td(t) {
      return Array.from(t.getChildren()).some(function (t) {
        return !t.is("uiElement");
      });
    }
    function ed(t) {
      var e = t.parent;
      while (!cd(e)) {
        if (!e) {
          return undefined;
        }
        e = e.parent;
      }
      return e;
    }
    function nd(t, e) {
      if (t.priority < e.priority) {
        return true;
      } else if (t.priority > e.priority) {
        return false;
      }
      return t.getIdentity() < e.getIdentity();
    }
    function od(t) {
      var e = t.nodeBefore;
      if (e && e.is("$text")) {
        return new hl(e, e.data.length);
      }
      var n = t.nodeAfter;
      if (n && n.is("$text")) {
        return new hl(n, 0);
      }
      return t;
    }
    function id(t) {
      if (t.offset == t.parent.data.length) {
        return new hl(t.parent.parent, t.parent.index + 1);
      }
      if (t.offset === 0) {
        return new hl(t.parent.parent, t.parent.index);
      }
      var e = t.parent.data.slice(t.offset);
      t.parent._data = t.parent.data.slice(0, t.offset);
      t.parent.parent._insertChild(t.parent.index + 1, new Vs(t.root.document, e));
      return new hl(t.parent.parent, t.parent.index + 1);
    }
    function rd(t, e) {
      var n = t.data.length;
      t._data += e.data;
      e._remove();
      return new hl(t, n);
    }
    function sd(t, e) {
      var _iterator61 = _createForOfIteratorHelper(t),
        _step61;
      try {
        var _loop = function _loop() {
          var n = _step61.value;
          if (!ad.some(function (t) {
            return n instanceof t;
          })) {
            throw new ss["a"]("view-writer-insert-invalid-node-type", e);
          }
          if (!n.is("$text")) {
            sd(n.getChildren(), e);
          }
        };
        for (_iterator61.s(); !(_step61 = _iterator61.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator61.e(err);
      } finally {
        _iterator61.f();
      }
    }
    var ad = [Vs, Cl, Hc, vl, Ql, Wl];
    function cd(t) {
      return t && (t.is("containerElement") || t.is("documentFragment"));
    }
    function ld(t, e) {
      var n = ed(t.start);
      var o = ed(t.end);
      if (!n || !o || n !== o) {
        throw new ss["a"]("view-writer-invalid-range-container", e);
      }
    }
    function dd(t, e) {
      return t.id === null && e.id === null;
    }
    function ud(t) {
      return Object.prototype.toString.call(t) == "[object Text]";
    }
    var hd = function hd(t) {
      return t.createTextNode(" ");
    };
    var fd = function fd(t) {
      var e = t.createElement("br");
      e.dataset.ckeFiller = true;
      return e;
    };
    var md = 7;
    var gd = function () {
      var t = "";
      for (var _e55 = 0; _e55 < md; _e55++) {
        t += "​";
      }
      return t;
    }();
    function pd(t) {
      return ud(t) && t.data.substr(0, md) === gd;
    }
    function kd(t) {
      return t.data.length == md && pd(t);
    }
    function bd(t) {
      if (pd(t)) {
        return t.data.slice(md);
      } else {
        return t.data;
      }
    }
    function wd(t) {
      t.document.on("keydown", Cd);
    }
    function Cd(t, e) {
      if (e.keyCode == Ll.arrowleft) {
        var _t46 = e.domTarget.ownerDocument.defaultView.getSelection();
        if (_t46.rangeCount == 1 && _t46.getRangeAt(0).collapsed) {
          var _e56 = _t46.getRangeAt(0).startContainer;
          var _n46 = _t46.getRangeAt(0).startOffset;
          if (pd(_e56) && _n46 <= md) {
            _t46.collapse(_e56, 0);
          }
        }
      }
    }
    function Ad(t, e, n) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      n = n || function (t, e) {
        return t === e;
      };
      if (!Array.isArray(t)) {
        t = Array.prototype.slice.call(t);
      }
      if (!Array.isArray(e)) {
        e = Array.prototype.slice.call(e);
      }
      var i = _d(t, e, n);
      return o ? Dd(i, e.length) : xd(e, i);
    }
    function _d(t, e, n) {
      var o = vd(t, e, n);
      if (o === -1) {
        return {
          firstIndex: -1,
          lastIndexOld: -1,
          lastIndexNew: -1
        };
      }
      var i = yd(t, o);
      var r = yd(e, o);
      var s = vd(i, r, n);
      var a = t.length - s;
      var c = e.length - s;
      return {
        firstIndex: o,
        lastIndexOld: a,
        lastIndexNew: c
      };
    }
    function vd(t, e, n) {
      for (var _o27 = 0; _o27 < Math.max(t.length, e.length); _o27++) {
        if (t[_o27] === undefined || e[_o27] === undefined || !n(t[_o27], e[_o27])) {
          return _o27;
        }
      }
      return -1;
    }
    function yd(t, e) {
      return t.slice(e).reverse();
    }
    function xd(t, e) {
      var n = [];
      var o = e.firstIndex,
        i = e.lastIndexOld,
        r = e.lastIndexNew;
      if (r - o > 0) {
        n.push({
          index: o,
          type: "insert",
          values: t.slice(o, r)
        });
      }
      if (i - o > 0) {
        n.push({
          index: o + (r - o),
          type: "delete",
          howMany: i - o
        });
      }
      return n;
    }
    function Dd(t, e) {
      var n = t.firstIndex,
        o = t.lastIndexOld,
        i = t.lastIndexNew;
      if (n === -1) {
        return Array(e).fill("equal");
      }
      var r = [];
      if (n > 0) {
        r = r.concat(Array(n).fill("equal"));
      }
      if (i - n > 0) {
        r = r.concat(Array(i - n).fill("insert"));
      }
      if (o - n > 0) {
        r = r.concat(Array(o - n).fill("delete"));
      }
      if (i < e) {
        r = r.concat(Array(e - i).fill("equal"));
      }
      return r;
    }
    function Ed(t, e, n) {
      n = n || function (t, e) {
        return t === e;
      };
      var o = t.length;
      var i = e.length;
      if (o > 200 || i > 200 || o + i > 300) {
        return Ed.fastDiff(t, e, n, true);
      }
      var r, s;
      if (i < o) {
        var _n47 = t;
        t = e;
        e = _n47;
        r = "delete";
        s = "insert";
      } else {
        r = "insert";
        s = "delete";
      }
      var a = t.length;
      var c = e.length;
      var l = c - a;
      var d = {};
      var u = {};
      function h(o) {
        var i = (u[o - 1] !== undefined ? u[o - 1] : -1) + 1;
        var l = u[o + 1] !== undefined ? u[o + 1] : -1;
        var h = i > l ? -1 : 1;
        if (d[o + h]) {
          d[o] = d[o + h].slice(0);
        }
        if (!d[o]) {
          d[o] = [];
        }
        d[o].push(i > l ? r : s);
        var f = Math.max(i, l);
        var m = f - o;
        while (m < a && f < c && n(t[m], e[f])) {
          m++;
          f++;
          d[o].push("equal");
        }
        return f;
      }
      var f = 0;
      var m;
      do {
        for (m = -f; m < l; m++) {
          u[m] = h(m);
        }
        for (m = l + f; m > l; m--) {
          u[m] = h(m);
        }
        u[l] = h(l);
        f++;
      } while (u[l] !== c);
      return d[l].slice(1);
    }
    Ed.fastDiff = Ad;
    function Md(t, e, n) {
      t.insertBefore(n, t.childNodes[e] || null);
    }
    function Sd(t) {
      var e = t.parentNode;
      if (e) {
        e.removeChild(t);
      }
    }
    function Td(t) {
      if (t) {
        if (t.defaultView) {
          return t instanceof t.defaultView.Document;
        } else if (t.ownerDocument && t.ownerDocument.defaultView) {
          return t instanceof t.ownerDocument.defaultView.Node;
        }
      }
      return false;
    }
    var Id = /*#__PURE__*/function () {
      function Id(t, e) {
        _classCallCheck(this, Id);
        this.domDocuments = new Set();
        this.domConverter = t;
        this.markedAttributes = new Set();
        this.markedChildren = new Set();
        this.markedTexts = new Set();
        this.selection = e;
        this.isFocused = false;
        this._inlineFiller = null;
        this._fakeSelectionContainer = null;
      }
      _createClass(Id, [{
        key: "markToSync",
        value: function markToSync(t, e) {
          if (t === "text") {
            if (this.domConverter.mapViewToDom(e.parent)) {
              this.markedTexts.add(e);
            }
          } else {
            if (!this.domConverter.mapViewToDom(e)) {
              return;
            }
            if (t === "attributes") {
              this.markedAttributes.add(e);
            } else if (t === "children") {
              this.markedChildren.add(e);
            } else {
              throw new ss["a"]("view-renderer-unknown-type", this);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var t;
          var _iterator62 = _createForOfIteratorHelper(this.markedChildren),
            _step62;
          try {
            for (_iterator62.s(); !(_step62 = _iterator62.n()).done;) {
              var _t47 = _step62.value;
              this._updateChildrenMappings(_t47);
            }
          } catch (err) {
            _iterator62.e(err);
          } finally {
            _iterator62.f();
          }
          if (this._inlineFiller && !this._isSelectionInInlineFiller()) {
            this._removeInlineFiller();
          }
          if (this._inlineFiller) {
            t = this._getInlineFillerPosition();
          } else if (this._needsInlineFillerAtSelection()) {
            t = this.selection.getFirstPosition();
            this.markedChildren.add(t.parent);
          }
          var _iterator63 = _createForOfIteratorHelper(this.markedAttributes),
            _step63;
          try {
            for (_iterator63.s(); !(_step63 = _iterator63.n()).done;) {
              var _t48 = _step63.value;
              this._updateAttrs(_t48);
            }
          } catch (err) {
            _iterator63.e(err);
          } finally {
            _iterator63.f();
          }
          var _iterator64 = _createForOfIteratorHelper(this.markedChildren),
            _step64;
          try {
            for (_iterator64.s(); !(_step64 = _iterator64.n()).done;) {
              var _e58 = _step64.value;
              this._updateChildren(_e58, {
                inlineFillerPosition: t
              });
            }
          } catch (err) {
            _iterator64.e(err);
          } finally {
            _iterator64.f();
          }
          var _iterator65 = _createForOfIteratorHelper(this.markedTexts),
            _step65;
          try {
            for (_iterator65.s(); !(_step65 = _iterator65.n()).done;) {
              var _e59 = _step65.value;
              if (!this.markedChildren.has(_e59.parent) && this.domConverter.mapViewToDom(_e59.parent)) {
                this._updateText(_e59, {
                  inlineFillerPosition: t
                });
              }
            }
          } catch (err) {
            _iterator65.e(err);
          } finally {
            _iterator65.f();
          }
          if (t) {
            var _e57 = this.domConverter.viewPositionToDom(t);
            var _n48 = _e57.parent.ownerDocument;
            if (!pd(_e57.parent)) {
              this._inlineFiller = Pd(_n48, _e57.parent, _e57.offset);
            } else {
              this._inlineFiller = _e57.parent;
            }
          } else {
            this._inlineFiller = null;
          }
          this._updateSelection();
          this._updateFocus();
          this.markedTexts.clear();
          this.markedAttributes.clear();
          this.markedChildren.clear();
        }
      }, {
        key: "_updateChildrenMappings",
        value: function _updateChildrenMappings(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) {
            return;
          }
          var n = this.domConverter.mapViewToDom(t).childNodes;
          var o = Array.from(this.domConverter.viewChildrenToDom(t, e.ownerDocument, {
            withChildren: false
          }));
          var i = this._diffNodeLists(n, o);
          var r = this._findReplaceActions(i, n, o);
          if (r.indexOf("replace") !== -1) {
            var _e60 = {
              equal: 0,
              insert: 0,
              delete: 0
            };
            var _iterator66 = _createForOfIteratorHelper(r),
              _step66;
            try {
              for (_iterator66.s(); !(_step66 = _iterator66.n()).done;) {
                var _i31 = _step66.value;
                if (_i31 === "replace") {
                  var _i32 = _e60.equal + _e60.insert;
                  var _r9 = _e60.equal + _e60.delete;
                  var _s7 = t.getChild(_i32);
                  if (_s7 && !(_s7.is("uiElement") || _s7.is("rawElement"))) {
                    this._updateElementMappings(_s7, n[_r9]);
                  }
                  Sd(o[_i32]);
                  _e60.equal++;
                } else {
                  _e60[_i31]++;
                }
              }
            } catch (err) {
              _iterator66.e(err);
            } finally {
              _iterator66.f();
            }
          }
        }
      }, {
        key: "_updateElementMappings",
        value: function _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e);
          this.domConverter.bindElements(e, t);
          this.markedChildren.add(t);
          this.markedAttributes.add(t);
        }
      }, {
        key: "_getInlineFillerPosition",
        value: function _getInlineFillerPosition() {
          var t = this.selection.getFirstPosition();
          if (t.parent.is("$text")) {
            return hl._createBefore(this.selection.getFirstPosition().parent);
          } else {
            return t;
          }
        }
      }, {
        key: "_isSelectionInInlineFiller",
        value: function _isSelectionInInlineFiller() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false;
          }
          var t = this.selection.getFirstPosition();
          var e = this.domConverter.viewPositionToDom(t);
          if (e && ud(e.parent) && pd(e.parent)) {
            return true;
          }
          return false;
        }
      }, {
        key: "_removeInlineFiller",
        value: function _removeInlineFiller() {
          var t = this._inlineFiller;
          if (!pd(t)) {
            throw new ss["a"]("view-renderer-filler-was-lost", this);
          }
          if (kd(t)) {
            t.parentNode.removeChild(t);
          } else {
            t.data = t.data.substr(md);
          }
          this._inlineFiller = null;
        }
      }, {
        key: "_needsInlineFillerAtSelection",
        value: function _needsInlineFillerAtSelection() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false;
          }
          var t = this.selection.getFirstPosition();
          var e = t.parent;
          var n = t.offset;
          if (!this.domConverter.mapViewToDom(e.root)) {
            return false;
          }
          if (!e.is("element")) {
            return false;
          }
          if (!Nd(e)) {
            return false;
          }
          if (n === e.getFillerOffset()) {
            return false;
          }
          var o = t.nodeBefore;
          var i = t.nodeAfter;
          if (o instanceof Vs || i instanceof Vs) {
            return false;
          }
          return true;
        }
      }, {
        key: "_updateText",
        value: function _updateText(t, e) {
          var n = this.domConverter.findCorrespondingDomText(t);
          var o = this.domConverter.viewToDom(t, n.ownerDocument);
          var i = n.data;
          var r = o.data;
          var s = e.inlineFillerPosition;
          if (s && s.parent == t.parent && s.offset == t.index) {
            r = gd + r;
          }
          if (i != r) {
            var _t49 = Ad(i, r);
            var _iterator67 = _createForOfIteratorHelper(_t49),
              _step67;
            try {
              for (_iterator67.s(); !(_step67 = _iterator67.n()).done;) {
                var _e61 = _step67.value;
                if (_e61.type === "insert") {
                  n.insertData(_e61.index, _e61.values.join(""));
                } else {
                  n.deleteData(_e61.index, _e61.howMany);
                }
              }
            } catch (err) {
              _iterator67.e(err);
            } finally {
              _iterator67.f();
            }
          }
        }
      }, {
        key: "_updateAttrs",
        value: function _updateAttrs(t) {
          var e = this.domConverter.mapViewToDom(t);
          if (!e) {
            return;
          }
          var n = Array.from(e.attributes).map(function (t) {
            return t.name;
          });
          var o = t.getAttributeKeys();
          var _iterator68 = _createForOfIteratorHelper(o),
            _step68;
          try {
            for (_iterator68.s(); !(_step68 = _iterator68.n()).done;) {
              var _n49 = _step68.value;
              e.setAttribute(_n49, t.getAttribute(_n49));
            }
          } catch (err) {
            _iterator68.e(err);
          } finally {
            _iterator68.f();
          }
          var _iterator69 = _createForOfIteratorHelper(n),
            _step69;
          try {
            for (_iterator69.s(); !(_step69 = _iterator69.n()).done;) {
              var _o28 = _step69.value;
              if (!t.hasAttribute(_o28)) {
                e.removeAttribute(_o28);
              }
            }
          } catch (err) {
            _iterator69.e(err);
          } finally {
            _iterator69.f();
          }
        }
      }, {
        key: "_updateChildren",
        value: function _updateChildren(t, e) {
          var n = this.domConverter.mapViewToDom(t);
          if (!n) {
            return;
          }
          var o = e.inlineFillerPosition;
          var i = this.domConverter.mapViewToDom(t).childNodes;
          var r = Array.from(this.domConverter.viewChildrenToDom(t, n.ownerDocument, {
            bind: true,
            inlineFillerPosition: o
          }));
          if (o && o.parent === t) {
            Pd(n.ownerDocument, r, o.offset);
          }
          var s = this._diffNodeLists(i, r);
          var a = 0;
          var c = new Set();
          var _iterator70 = _createForOfIteratorHelper(s),
            _step70;
          try {
            for (_iterator70.s(); !(_step70 = _iterator70.n()).done;) {
              var _t50 = _step70.value;
              if (_t50 === "delete") {
                c.add(i[a]);
                Sd(i[a]);
              } else if (_t50 === "equal") {
                a++;
              }
            }
          } catch (err) {
            _iterator70.e(err);
          } finally {
            _iterator70.f();
          }
          a = 0;
          var _iterator71 = _createForOfIteratorHelper(s),
            _step71;
          try {
            for (_iterator71.s(); !(_step71 = _iterator71.n()).done;) {
              var _t51 = _step71.value;
              if (_t51 === "insert") {
                Md(n, a, r[a]);
                a++;
              } else if (_t51 === "equal") {
                this._markDescendantTextToSync(this.domConverter.domToView(r[a]));
                a++;
              }
            }
          } catch (err) {
            _iterator71.e(err);
          } finally {
            _iterator71.f();
          }
          var _iterator72 = _createForOfIteratorHelper(c),
            _step72;
          try {
            for (_iterator72.s(); !(_step72 = _iterator72.n()).done;) {
              var _t52 = _step72.value;
              if (!_t52.parentNode) {
                this.domConverter.unbindDomElement(_t52);
              }
            }
          } catch (err) {
            _iterator72.e(err);
          } finally {
            _iterator72.f();
          }
        }
      }, {
        key: "_diffNodeLists",
        value: function _diffNodeLists(t, e) {
          t = Od(t, this._fakeSelectionContainer);
          return Ed(t, e, zd.bind(null, this.domConverter));
        }
      }, {
        key: "_findReplaceActions",
        value: function _findReplaceActions(t, e, n) {
          if (t.indexOf("insert") === -1 || t.indexOf("delete") === -1) {
            return t;
          }
          var o = [];
          var i = [];
          var r = [];
          var s = {
            equal: 0,
            insert: 0,
            delete: 0
          };
          var _iterator73 = _createForOfIteratorHelper(t),
            _step73;
          try {
            for (_iterator73.s(); !(_step73 = _iterator73.n()).done;) {
              var _a6 = _step73.value;
              if (_a6 === "insert") {
                r.push(n[s.equal + s.insert]);
              } else if (_a6 === "delete") {
                i.push(e[s.equal + s.delete]);
              } else {
                o = o.concat(Ed(i, r, Bd).map(function (t) {
                  return t === "equal" ? "replace" : t;
                }));
                o.push("equal");
                i = [];
                r = [];
              }
              s[_a6]++;
            }
          } catch (err) {
            _iterator73.e(err);
          } finally {
            _iterator73.f();
          }
          return o.concat(Ed(i, r, Bd).map(function (t) {
            return t === "equal" ? "replace" : t;
          }));
        }
      }, {
        key: "_markDescendantTextToSync",
        value: function _markDescendantTextToSync(t) {
          if (!t) {
            return;
          }
          if (t.is("$text")) {
            this.markedTexts.add(t);
          } else if (t.is("element")) {
            var _iterator74 = _createForOfIteratorHelper(t.getChildren()),
              _step74;
            try {
              for (_iterator74.s(); !(_step74 = _iterator74.n()).done;) {
                var _e62 = _step74.value;
                this._markDescendantTextToSync(_e62);
              }
            } catch (err) {
              _iterator74.e(err);
            } finally {
              _iterator74.f();
            }
          }
        }
      }, {
        key: "_updateSelection",
        value: function _updateSelection() {
          if (this.selection.rangeCount === 0) {
            this._removeDomSelection();
            this._removeFakeSelection();
            return;
          }
          var t = this.domConverter.mapViewToDom(this.selection.editableElement);
          if (!this.isFocused || !t) {
            return;
          }
          if (this.selection.isFake) {
            this._updateFakeSelection(t);
          } else {
            this._removeFakeSelection();
            this._updateDomSelection(t);
          }
        }
      }, {
        key: "_updateFakeSelection",
        value: function _updateFakeSelection(t) {
          var e = t.ownerDocument;
          if (!this._fakeSelectionContainer) {
            this._fakeSelectionContainer = Rd(e);
          }
          var n = this._fakeSelectionContainer;
          this.domConverter.bindFakeSelection(n, this.selection);
          if (!this._fakeSelectionNeedsUpdate(t)) {
            return;
          }
          if (!n.parentElement || n.parentElement != t) {
            t.appendChild(n);
          }
          n.textContent = this.selection.fakeSelectionLabel || " ";
          var o = e.getSelection();
          var i = e.createRange();
          o.removeAllRanges();
          i.selectNodeContents(n);
          o.addRange(i);
        }
      }, {
        key: "_updateDomSelection",
        value: function _updateDomSelection(t) {
          var e = t.ownerDocument.defaultView.getSelection();
          if (!this._domSelectionNeedsUpdate(e)) {
            return;
          }
          var n = this.domConverter.viewPositionToDom(this.selection.anchor);
          var o = this.domConverter.viewPositionToDom(this.selection.focus);
          t.focus();
          e.collapse(n.parent, n.offset);
          e.extend(o.parent, o.offset);
          if (El.isGecko) {
            Ld(o, e);
          }
        }
      }, {
        key: "_domSelectionNeedsUpdate",
        value: function _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) {
            return true;
          }
          var e = t && this.domConverter.domSelectionToView(t);
          if (e && this.selection.isEqual(e)) {
            return false;
          }
          if (!this.selection.isCollapsed && this.selection.isSimilar(e)) {
            return false;
          }
          return true;
        }
      }, {
        key: "_fakeSelectionNeedsUpdate",
        value: function _fakeSelectionNeedsUpdate(t) {
          var e = this._fakeSelectionContainer;
          var n = t.ownerDocument.getSelection();
          if (!e || e.parentElement !== t) {
            return true;
          }
          if (n.anchorNode !== e && !e.contains(n.anchorNode)) {
            return true;
          }
          return e.textContent !== this.selection.fakeSelectionLabel;
        }
      }, {
        key: "_removeDomSelection",
        value: function _removeDomSelection() {
          var _iterator75 = _createForOfIteratorHelper(this.domDocuments),
            _step75;
          try {
            for (_iterator75.s(); !(_step75 = _iterator75.n()).done;) {
              var _t53 = _step75.value;
              var _e63 = _t53.getSelection();
              if (_e63.rangeCount) {
                var _e64 = _t53.activeElement;
                var _n50 = this.domConverter.mapDomToView(_e64);
                if (_e64 && _n50) {
                  _t53.getSelection().removeAllRanges();
                }
              }
            }
          } catch (err) {
            _iterator75.e(err);
          } finally {
            _iterator75.f();
          }
        }
      }, {
        key: "_removeFakeSelection",
        value: function _removeFakeSelection() {
          var t = this._fakeSelectionContainer;
          if (t) {
            t.remove();
          }
        }
      }, {
        key: "_updateFocus",
        value: function _updateFocus() {
          if (this.isFocused) {
            var _t54 = this.selection.editableElement;
            if (_t54) {
              this.domConverter.focus(_t54);
            }
          }
        }
      }]);
      return Id;
    }();
    _s(Id, Zc);
    function Nd(t) {
      if (t.getAttribute("contenteditable") == "false") {
        return false;
      }
      var e = t.findAncestor(function (t) {
        return t.hasAttribute("contenteditable");
      });
      return !e || e.getAttribute("contenteditable") == "true";
    }
    function Pd(t, e, n) {
      var o = e instanceof Array ? e : e.childNodes;
      var i = o[n];
      if (ud(i)) {
        i.data = gd + i.data;
        return i;
      } else {
        var _i33 = t.createTextNode(gd);
        if (Array.isArray(e)) {
          o.splice(n, 0, _i33);
        } else {
          Md(e, n, _i33);
        }
        return _i33;
      }
    }
    function Bd(t, e) {
      return Td(t) && Td(e) && !ud(t) && !ud(e) && t.nodeType !== Node.COMMENT_NODE && e.nodeType !== Node.COMMENT_NODE && t.tagName.toLowerCase() === e.tagName.toLowerCase();
    }
    function zd(t, e, n) {
      if (e === n) {
        return true;
      } else if (ud(e) && ud(n)) {
        return e.data === n.data;
      } else if (t.isBlockFiller(e) && t.isBlockFiller(n)) {
        return true;
      }
      return false;
    }
    function Ld(t, e) {
      var n = t.parent;
      if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) {
        return;
      }
      var o = n.childNodes[t.offset];
      if (o && o.tagName == "BR") {
        e.addRange(e.getRangeAt(0));
      }
    }
    function Od(t, e) {
      var n = Array.from(t);
      if (n.length == 0 || !e) {
        return n;
      }
      var o = n[n.length - 1];
      if (o == e) {
        n.pop();
      }
      return n;
    }
    function Rd(t) {
      var e = t.createElement("div");
      e.className = "ck-fake-selection-container";
      Object.assign(e.style, {
        position: "fixed",
        top: 0,
        left: "-9999px",
        width: "42px"
      });
      e.textContent = " ";
      return e;
    }
    var jd = {
      window: window,
      document: document
    };
    function Fd(t) {
      var e = 0;
      while (t.previousSibling) {
        t = t.previousSibling;
        e++;
      }
      return e;
    }
    function Vd(t) {
      var e = [];
      while (t && t.nodeType != Node.DOCUMENT_NODE) {
        e.unshift(t);
        t = t.parentNode;
      }
      return e;
    }
    function Ud(t, e) {
      var n = Vd(t);
      var o = Vd(e);
      var i = 0;
      while (n[i] == o[i] && n[i]) {
        i++;
      }
      return i === 0 ? null : n[i - 1];
    }
    var Hd = fd(document);
    var Gd = /*#__PURE__*/function () {
      function Gd(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, Gd);
        this.document = t;
        this.blockFillerMode = e.blockFillerMode || "br";
        this.preElements = ["pre"];
        this.blockElements = ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6", "li", "dd", "dt", "figcaption", "td", "th"];
        this._blockFiller = this.blockFillerMode == "br" ? fd : hd;
        this._domToViewMapping = new WeakMap();
        this._viewToDomMapping = new WeakMap();
        this._fakeSelectionMapping = new WeakMap();
        this._rawContentElementMatcher = new Ws();
        this._encounteredRawContentDomNodes = new WeakSet();
      }
      _createClass(Gd, [{
        key: "bindFakeSelection",
        value: function bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new pl(e));
        }
      }, {
        key: "fakeSelectionToView",
        value: function fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t);
        }
      }, {
        key: "bindElements",
        value: function bindElements(t, e) {
          this._domToViewMapping.set(t, e);
          this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "unbindDomElement",
        value: function unbindDomElement(t) {
          var e = this._domToViewMapping.get(t);
          if (e) {
            this._domToViewMapping.delete(t);
            this._viewToDomMapping.delete(e);
            var _iterator76 = _createForOfIteratorHelper(t.childNodes),
              _step76;
            try {
              for (_iterator76.s(); !(_step76 = _iterator76.n()).done;) {
                var _e65 = _step76.value;
                this.unbindDomElement(_e65);
              }
            } catch (err) {
              _iterator76.e(err);
            } finally {
              _iterator76.f();
            }
          }
        }
      }, {
        key: "bindDocumentFragments",
        value: function bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e);
          this._viewToDomMapping.set(e, t);
        }
      }, {
        key: "viewToDom",
        value: function viewToDom(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (t.is("$text")) {
            var _n51 = this._processDataFromViewText(t);
            return e.createTextNode(_n51);
          } else {
            if (this.mapViewToDom(t)) {
              return this.mapViewToDom(t);
            }
            var _o29;
            if (t.is("documentFragment")) {
              _o29 = e.createDocumentFragment();
              if (n.bind) {
                this.bindDocumentFragments(_o29, t);
              }
            } else if (t.is("uiElement")) {
              _o29 = t.render(e);
              if (n.bind) {
                this.bindElements(_o29, t);
              }
              return _o29;
            } else {
              if (t.hasAttribute("xmlns")) {
                _o29 = e.createElementNS(t.getAttribute("xmlns"), t.name);
              } else {
                _o29 = e.createElement(t.name);
              }
              if (t.is("rawElement")) {
                t.render(_o29);
              }
              if (n.bind) {
                this.bindElements(_o29, t);
              }
              var _iterator77 = _createForOfIteratorHelper(t.getAttributeKeys()),
                _step77;
              try {
                for (_iterator77.s(); !(_step77 = _iterator77.n()).done;) {
                  var _e66 = _step77.value;
                  _o29.setAttribute(_e66, t.getAttribute(_e66));
                }
              } catch (err) {
                _iterator77.e(err);
              } finally {
                _iterator77.f();
              }
            }
            if (n.withChildren !== false) {
              var _iterator78 = _createForOfIteratorHelper(this.viewChildrenToDom(t, e, n)),
                _step78;
              try {
                for (_iterator78.s(); !(_step78 = _iterator78.n()).done;) {
                  var _i34 = _step78.value;
                  _o29.appendChild(_i34);
                }
              } catch (err) {
                _iterator78.e(err);
              } finally {
                _iterator78.f();
              }
            }
            return _o29;
          }
        }
      }, {
        key: "viewChildrenToDom",
        value: function viewChildrenToDom(t, e) {
          var _this25 = this;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
            var o, i, _iterator79, _step79, _r10;
            return _regeneratorRuntime().wrap(function _callee3$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  o = t.getFillerOffset && t.getFillerOffset();
                  i = 0;
                  _iterator79 = _createForOfIteratorHelper(t.getChildren());
                  _context11.prev = 3;
                  _iterator79.s();
                case 5:
                  if ((_step79 = _iterator79.n()).done) {
                    _context11.next = 15;
                    break;
                  }
                  _r10 = _step79.value;
                  if (!(o === i)) {
                    _context11.next = 10;
                    break;
                  }
                  _context11.next = 10;
                  return _this25._blockFiller(e);
                case 10:
                  _context11.next = 12;
                  return _this25.viewToDom(_r10, e, n);
                case 12:
                  i++;
                case 13:
                  _context11.next = 5;
                  break;
                case 15:
                  _context11.next = 20;
                  break;
                case 17:
                  _context11.prev = 17;
                  _context11.t0 = _context11["catch"](3);
                  _iterator79.e(_context11.t0);
                case 20:
                  _context11.prev = 20;
                  _iterator79.f();
                  return _context11.finish(20);
                case 23:
                  if (!(o === i)) {
                    _context11.next = 26;
                    break;
                  }
                  _context11.next = 26;
                  return _this25._blockFiller(e);
                case 26:
                case "end":
                  return _context11.stop();
              }
            }, _callee3, null, [[3, 17, 20, 23]]);
          })();
        }
      }, {
        key: "viewRangeToDom",
        value: function viewRangeToDom(t) {
          var e = this.viewPositionToDom(t.start);
          var n = this.viewPositionToDom(t.end);
          var o = document.createRange();
          o.setStart(e.parent, e.offset);
          o.setEnd(n.parent, n.offset);
          return o;
        }
      }, {
        key: "viewPositionToDom",
        value: function viewPositionToDom(t) {
          var e = t.parent;
          if (e.is("$text")) {
            var _n52 = this.findCorrespondingDomText(e);
            if (!_n52) {
              return null;
            }
            var _o30 = t.offset;
            if (pd(_n52)) {
              _o30 += md;
            }
            return {
              parent: _n52,
              offset: _o30
            };
          } else {
            var _n53, _o31, _i35;
            if (t.offset === 0) {
              _n53 = this.mapViewToDom(e);
              if (!_n53) {
                return null;
              }
              _i35 = _n53.childNodes[0];
            } else {
              var _e67 = t.nodeBefore;
              _o31 = _e67.is("$text") ? this.findCorrespondingDomText(_e67) : this.mapViewToDom(t.nodeBefore);
              if (!_o31) {
                return null;
              }
              _n53 = _o31.parentNode;
              _i35 = _o31.nextSibling;
            }
            if (ud(_i35) && pd(_i35)) {
              return {
                parent: _i35,
                offset: md
              };
            }
            var _r11 = _o31 ? Fd(_o31) + 1 : 0;
            return {
              parent: _n53,
              offset: _r11
            };
          }
        }
      }, {
        key: "domToView",
        value: function domToView(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          if (this.isBlockFiller(t, this.blockFillerMode)) {
            return null;
          }
          var n = this.getHostViewElement(t);
          if (n) {
            return n;
          }
          if (ud(t)) {
            if (kd(t)) {
              return null;
            } else {
              var _e68 = this._processDataFromDomText(t);
              return _e68 === "" ? null : new Vs(this.document, _e68);
            }
          } else if (this.isComment(t)) {
            return null;
          } else {
            if (this.mapDomToView(t)) {
              return this.mapDomToView(t);
            }
            var _n54;
            if (this.isDocumentFragment(t)) {
              _n54 = new Zl(this.document);
              if (e.bind) {
                this.bindDocumentFragments(t, _n54);
              }
            } else {
              var _o32 = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
              _n54 = new jc(this.document, _o32);
              if (e.bind) {
                this.bindElements(t, _n54);
              }
              var _i36 = t.attributes;
              for (var _t55 = _i36.length - 1; _t55 >= 0; _t55--) {
                _n54._setAttribute(_i36[_t55].name, _i36[_t55].value);
              }
              if (e.withChildren !== false && this._rawContentElementMatcher.match(_n54)) {
                _n54._setCustomProperty("$rawContent", t.innerHTML);
                this._encounteredRawContentDomNodes.add(t);
                return _n54;
              }
            }
            if (e.withChildren !== false) {
              var _iterator80 = _createForOfIteratorHelper(this.domChildrenToView(t, e)),
                _step80;
              try {
                for (_iterator80.s(); !(_step80 = _iterator80.n()).done;) {
                  var _o33 = _step80.value;
                  _n54._appendChild(_o33);
                }
              } catch (err) {
                _iterator80.e(err);
              } finally {
                _iterator80.f();
              }
            }
            return _n54;
          }
        }
      }, {
        key: "domChildrenToView",
        value: function domChildrenToView(t) {
          var _this26 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
            var _n55, _o34, _i37;
            return _regeneratorRuntime().wrap(function _callee4$(_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _n55 = 0;
                case 1:
                  if (!(_n55 < t.childNodes.length)) {
                    _context12.next = 10;
                    break;
                  }
                  _o34 = t.childNodes[_n55];
                  _i37 = _this26.domToView(_o34, e);
                  if (!(_i37 !== null)) {
                    _context12.next = 7;
                    break;
                  }
                  _context12.next = 7;
                  return _i37;
                case 7:
                  _n55++;
                  _context12.next = 1;
                  break;
                case 10:
                case "end":
                  return _context12.stop();
              }
            }, _callee4);
          })();
        }
      }, {
        key: "domSelectionToView",
        value: function domSelectionToView(t) {
          if (t.rangeCount === 1) {
            var _e69 = t.getRangeAt(0).startContainer;
            if (ud(_e69)) {
              _e69 = _e69.parentNode;
            }
            var _n56 = this.fakeSelectionToView(_e69);
            if (_n56) {
              return _n56;
            }
          }
          var e = this.isDomSelectionBackward(t);
          var n = [];
          for (var _e70 = 0; _e70 < t.rangeCount; _e70++) {
            var _o35 = t.getRangeAt(_e70);
            var _i38 = this.domRangeToView(_o35);
            if (_i38) {
              n.push(_i38);
            }
          }
          return new pl(n, {
            backward: e
          });
        }
      }, {
        key: "domRangeToView",
        value: function domRangeToView(t) {
          var e = this.domPositionToView(t.startContainer, t.startOffset);
          var n = this.domPositionToView(t.endContainer, t.endOffset);
          if (e && n) {
            return new fl(e, n);
          }
          return null;
        }
      }, {
        key: "domPositionToView",
        value: function domPositionToView(t, e) {
          if (this.isBlockFiller(t, this.blockFillerMode)) {
            return this.domPositionToView(t.parentNode, Fd(t));
          }
          var n = this.mapDomToView(t);
          if (n && (n.is("uiElement") || n.is("rawElement"))) {
            return hl._createBefore(n);
          }
          if (ud(t)) {
            if (kd(t)) {
              return this.domPositionToView(t.parentNode, Fd(t));
            }
            var _n57 = this.findCorrespondingViewText(t);
            var _o36 = e;
            if (!_n57) {
              return null;
            }
            if (pd(t)) {
              _o36 -= md;
              _o36 = _o36 < 0 ? 0 : _o36;
            }
            return new hl(_n57, _o36);
          } else {
            if (e === 0) {
              var _e71 = this.mapDomToView(t);
              if (_e71) {
                return new hl(_e71, 0);
              }
            } else {
              var _n58 = t.childNodes[e - 1];
              var _o37 = ud(_n58) ? this.findCorrespondingViewText(_n58) : this.mapDomToView(_n58);
              if (_o37 && _o37.parent) {
                return new hl(_o37.parent, _o37.index + 1);
              }
            }
            return null;
          }
        }
      }, {
        key: "mapDomToView",
        value: function mapDomToView(t) {
          var e = this.getHostViewElement(t);
          return e || this._domToViewMapping.get(t);
        }
      }, {
        key: "findCorrespondingViewText",
        value: function findCorrespondingViewText(t) {
          if (kd(t)) {
            return null;
          }
          var e = this.getHostViewElement(t);
          if (e) {
            return e;
          }
          var n = t.previousSibling;
          if (n) {
            if (!this.isElement(n)) {
              return null;
            }
            var _t56 = this.mapDomToView(n);
            if (_t56) {
              var _e72 = _t56.nextSibling;
              if (_e72 instanceof Vs) {
                return _t56.nextSibling;
              } else {
                return null;
              }
            }
          } else {
            var _e73 = this.mapDomToView(t.parentNode);
            if (_e73) {
              var _t57 = _e73.getChild(0);
              if (_t57 instanceof Vs) {
                return _t57;
              } else {
                return null;
              }
            }
          }
          return null;
        }
      }, {
        key: "mapViewToDom",
        value: function mapViewToDom(t) {
          return this._viewToDomMapping.get(t);
        }
      }, {
        key: "findCorrespondingDomText",
        value: function findCorrespondingDomText(t) {
          var e = t.previousSibling;
          if (e && this.mapViewToDom(e)) {
            return this.mapViewToDom(e).nextSibling;
          }
          if (!e && t.parent && this.mapViewToDom(t.parent)) {
            return this.mapViewToDom(t.parent).childNodes[0];
          }
          return null;
        }
      }, {
        key: "focus",
        value: function focus(t) {
          var e = this.mapViewToDom(t);
          if (e && e.ownerDocument.activeElement !== e) {
            var _jd$window = jd.window,
              _t58 = _jd$window.scrollX,
              _n59 = _jd$window.scrollY;
            var _o38 = [];
            Kd(e, function (t) {
              var e = t.scrollLeft,
                n = t.scrollTop;
              _o38.push([e, n]);
            });
            e.focus();
            Kd(e, function (t) {
              var _o38$shift = _o38.shift(),
                _o38$shift2 = _slicedToArray(_o38$shift, 2),
                e = _o38$shift2[0],
                n = _o38$shift2[1];
              t.scrollLeft = e;
              t.scrollTop = n;
            });
            jd.window.scrollTo(_t58, _n59);
          }
        }
      }, {
        key: "isElement",
        value: function isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE;
        }
      }, {
        key: "isDocumentFragment",
        value: function isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
        }
      }, {
        key: "isComment",
        value: function isComment(t) {
          return t && t.nodeType == Node.COMMENT_NODE;
        }
      }, {
        key: "isBlockFiller",
        value: function isBlockFiller(t) {
          if (this.blockFillerMode == "br") {
            return t.isEqualNode(Hd);
          }
          if (t.tagName === "BR" && Yd(t, this.blockElements) && t.parentNode.childNodes.length === 1) {
            return true;
          }
          return qd(t, this.blockElements);
        }
      }, {
        key: "isDomSelectionBackward",
        value: function isDomSelectionBackward(t) {
          if (t.isCollapsed) {
            return false;
          }
          var e = document.createRange();
          e.setStart(t.anchorNode, t.anchorOffset);
          e.setEnd(t.focusNode, t.focusOffset);
          var n = e.collapsed;
          e.detach();
          return n;
        }
      }, {
        key: "getHostViewElement",
        value: function getHostViewElement(t) {
          var e = Vd(t);
          e.pop();
          while (e.length) {
            var _t59 = e.pop();
            var _n60 = this._domToViewMapping.get(_t59);
            if (_n60 && (_n60.is("uiElement") || _n60.is("rawElement"))) {
              return _n60;
            }
          }
          return null;
        }
      }, {
        key: "isDomSelectionCorrect",
        value: function isDomSelectionCorrect(t) {
          return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(t) {
          this._rawContentElementMatcher.add(t);
        }
      }, {
        key: "_isDomSelectionPositionCorrect",
        value: function _isDomSelectionPositionCorrect(t, e) {
          if (ud(t) && pd(t) && e < md) {
            return false;
          }
          if (this.isElement(t) && pd(t.childNodes[e])) {
            return false;
          }
          var n = this.mapDomToView(t);
          if (n && (n.is("uiElement") || n.is("rawElement"))) {
            return false;
          }
          return true;
        }
      }, {
        key: "_processDataFromViewText",
        value: function _processDataFromViewText(t) {
          var _this27 = this;
          var e = t.data;
          if (t.getAncestors().some(function (t) {
            return _this27.preElements.includes(t.name);
          })) {
            return e;
          }
          if (e.charAt(0) == " ") {
            var _n61 = this._getTouchingViewTextNode(t, false);
            var _o39 = _n61 && this._nodeEndsWithSpace(_n61);
            if (_o39 || !_n61) {
              e = " " + e.substr(1);
            }
          }
          if (e.charAt(e.length - 1) == " ") {
            var _n62 = this._getTouchingViewTextNode(t, true);
            if (e.charAt(e.length - 2) == " " || !_n62 || _n62.data.charAt(0) == " ") {
              e = e.substr(0, e.length - 1) + " ";
            }
          }
          return e.replace(/ {2}/g, "  ");
        }
      }, {
        key: "_nodeEndsWithSpace",
        value: function _nodeEndsWithSpace(t) {
          var _this28 = this;
          if (t.getAncestors().some(function (t) {
            return _this28.preElements.includes(t.name);
          })) {
            return false;
          }
          var e = this._processDataFromViewText(t);
          return e.charAt(e.length - 1) == " ";
        }
      }, {
        key: "_processDataFromDomText",
        value: function _processDataFromDomText(t) {
          var e = t.data;
          if (Wd(t, this.preElements)) {
            return bd(t);
          }
          e = e.replace(/[ \n\t\r]{1,}/g, " ");
          var n = this._getTouchingInlineDomNode(t, false);
          var o = this._getTouchingInlineDomNode(t, true);
          var i = this._checkShouldLeftTrimDomText(t, n);
          var r = this._checkShouldRightTrimDomText(t, o);
          if (i) {
            e = e.replace(/^ /, "");
          }
          if (r) {
            e = e.replace(/ $/, "");
          }
          e = bd(new Text(e));
          e = e.replace(/ \u00A0/g, "  ");
          if (/( |\u00A0)\u00A0$/.test(e) || !o || o.data && o.data.charAt(0) == " ") {
            e = e.replace(/\u00A0$/, " ");
          }
          if (i) {
            e = e.replace(/^\u00A0/, " ");
          }
          return e;
        }
      }, {
        key: "_checkShouldLeftTrimDomText",
        value: function _checkShouldLeftTrimDomText(t, e) {
          if (!e) {
            return true;
          }
          if (Yr(e)) {
            return true;
          }
          if (this._encounteredRawContentDomNodes.has(t.previousSibling)) {
            return false;
          }
          return /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1));
        }
      }, {
        key: "_checkShouldRightTrimDomText",
        value: function _checkShouldRightTrimDomText(t, e) {
          if (e) {
            return false;
          }
          return !pd(t);
        }
      }, {
        key: "_getTouchingViewTextNode",
        value: function _getTouchingViewTextNode(t, e) {
          var n = new ul({
            startPosition: e ? hl._createAfter(t) : hl._createBefore(t),
            direction: e ? "forward" : "backward"
          });
          var _iterator81 = _createForOfIteratorHelper(n),
            _step81;
          try {
            for (_iterator81.s(); !(_step81 = _iterator81.n()).done;) {
              var _t60 = _step81.value;
              if (_t60.item.is("containerElement")) {
                return null;
              } else if (_t60.item.is("element", "br")) {
                return null;
              } else if (_t60.item.is("$textProxy")) {
                return _t60.item;
              }
            }
          } catch (err) {
            _iterator81.e(err);
          } finally {
            _iterator81.f();
          }
          return null;
        }
      }, {
        key: "_getTouchingInlineDomNode",
        value: function _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) {
            return null;
          }
          var n = e ? "nextNode" : "previousNode";
          var o = t.ownerDocument;
          var i = Vd(t)[0];
          var r = o.createTreeWalker(i, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, {
            acceptNode: function acceptNode(t) {
              if (ud(t)) {
                return NodeFilter.FILTER_ACCEPT;
              }
              if (t.tagName == "BR") {
                return NodeFilter.FILTER_ACCEPT;
              }
              return NodeFilter.FILTER_SKIP;
            }
          });
          r.currentNode = t;
          var s = r[n]();
          if (s !== null) {
            var _e74 = Ud(t, s);
            if (_e74 && !Wd(t, this.blockElements, _e74) && !Wd(s, this.blockElements, _e74)) {
              return s;
            }
          }
          return null;
        }
      }]);
      return Gd;
    }();
    function Wd(t, e, n) {
      var o = Vd(t);
      if (n) {
        o = o.slice(o.indexOf(n) + 1);
      }
      return o.some(function (t) {
        return t.tagName && e.includes(t.tagName.toLowerCase());
      });
    }
    function Kd(t, e) {
      while (t && t != jd.document) {
        e(t);
        t = t.parentNode;
      }
    }
    function qd(t, e) {
      var n = ud(t) && t.data == " ";
      return n && Yd(t, e) && t.parentNode.childNodes.length === 1;
    }
    function Yd(t, e) {
      var n = t.parentNode;
      return n && n.tagName && e.includes(n.tagName.toLowerCase());
    }
    function Qd(t) {
      var e = Object.prototype.toString.apply(t);
      if (e == "[object Window]") {
        return true;
      }
      if (e == "[object global]") {
        return true;
      }
      return false;
    }
    var $d = Kc({}, ds, {
      listenTo: function listenTo(t) {
        var _ds$listenTo;
        for (var _len15 = arguments.length, e = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
          e[_key15 - 1] = arguments[_key15];
        }
        if (Td(t) || Qd(t)) {
          var _n63 = this._getProxyEmitter(t) || new Jd(t);
          _n63.attach.apply(_n63, e);
          t = _n63;
        }
        (_ds$listenTo = ds.listenTo).call.apply(_ds$listenTo, [this, t].concat(e));
      },
      stopListening: function stopListening(t, e, n) {
        if (Td(t) || Qd(t)) {
          var _e75 = this._getProxyEmitter(t);
          if (!_e75) {
            return;
          }
          t = _e75;
        }
        ds.stopListening.call(this, t, e, n);
        if (t instanceof Jd) {
          t.detach(e);
        }
      },
      _getProxyEmitter: function _getProxyEmitter(t) {
        return us(this, Xd(t));
      }
    });
    var Zd = $d;
    var Jd = function Jd(t) {
      _classCallCheck(this, Jd);
      hs(this, Xd(t));
      this._domNode = t;
    };
    Kc(Jd.prototype, ds, {
      attach: function attach(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (this._domListeners && this._domListeners[t]) {
          return;
        }
        var o = {
          capture: !!n.useCapture,
          passive: !!n.usePassive
        };
        var i = this._createDomListener(t, o);
        this._domNode.addEventListener(t, i, o);
        if (!this._domListeners) {
          this._domListeners = {};
        }
        this._domListeners[t] = i;
      },
      detach: function detach(t) {
        var e;
        if (this._domListeners[t] && (!(e = this._events[t]) || !e.callbacks.length)) {
          this._domListeners[t].removeListener();
        }
      },
      _createDomListener: function _createDomListener(t, e) {
        var _this29 = this;
        var n = function n(e) {
          _this29.fire(t, e);
        };
        n.removeListener = function () {
          _this29._domNode.removeEventListener(t, n, e);
          delete _this29._domListeners[t];
        };
        return n;
      }
    });
    function Xd(t) {
      return t["data-ck-expando"] || (t["data-ck-expando"] = ns());
    }
    var tu = /*#__PURE__*/function () {
      function tu(t) {
        _classCallCheck(this, tu);
        this.view = t;
        this.document = t.document;
        this.isEnabled = false;
      }
      _createClass(tu, [{
        key: "enable",
        value: function enable() {
          this.isEnabled = true;
        }
      }, {
        key: "disable",
        value: function disable() {
          this.isEnabled = false;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.disable();
          this.stopListening();
        }
      }, {
        key: "checkShouldIgnoreEventFromTarget",
        value: function checkShouldIgnoreEventFromTarget(t) {
          if (t && t.nodeType === 3) {
            t = t.parentNode;
          }
          if (!t || t.nodeType !== 1) {
            return false;
          }
          return t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
        }
      }]);
      return tu;
    }();
    _s(tu, Zd);
    var eu = "__lodash_hash_undefined__";
    function nu(t) {
      this.__data__.set(t, eu);
      return this;
    }
    var ou = nu;
    function iu(t) {
      return this.__data__.has(t);
    }
    var ru = iu;
    function su(t) {
      var e = -1,
        n = t == null ? 0 : t.length;
      this.__data__ = new Ce();
      while (++e < n) {
        this.add(t[e]);
      }
    }
    su.prototype.add = su.prototype.push = ou;
    su.prototype.has = ru;
    var au = su;
    function cu(t, e) {
      var n = -1,
        o = t == null ? 0 : t.length;
      while (++n < o) {
        if (e(t[n], n, t)) {
          return true;
        }
      }
      return false;
    }
    var lu = cu;
    function du(t, e) {
      return t.has(e);
    }
    var uu = du;
    var hu = 1,
      fu = 2;
    function mu(t, e, n, o, i, r) {
      var s = n & hu,
        a = t.length,
        c = e.length;
      if (a != c && !(s && c > a)) {
        return false;
      }
      var l = r.get(t);
      if (l && r.get(e)) {
        return l == e;
      }
      var d = -1,
        u = true,
        h = n & fu ? new au() : undefined;
      r.set(t, e);
      r.set(e, t);
      while (++d < a) {
        var f = t[d],
          m = e[d];
        if (o) {
          var g = s ? o(m, f, d, e, t, r) : o(f, m, d, t, e, r);
        }
        if (g !== undefined) {
          if (g) {
            continue;
          }
          u = false;
          break;
        }
        if (h) {
          if (!lu(e, function (t, e) {
            if (!uu(h, e) && (f === t || i(f, t, n, o, r))) {
              return h.push(e);
            }
          })) {
            u = false;
            break;
          }
        } else if (!(f === m || i(f, m, n, o, r))) {
          u = false;
          break;
        }
      }
      r["delete"](t);
      r["delete"](e);
      return u;
    }
    var gu = mu;
    function pu(t) {
      var e = -1,
        n = Array(t.size);
      t.forEach(function (t, o) {
        n[++e] = [o, t];
      });
      return n;
    }
    var ku = pu;
    function bu(t) {
      var e = -1,
        n = Array(t.size);
      t.forEach(function (t) {
        n[++e] = t;
      });
      return n;
    }
    var wu = bu;
    var Cu = 1,
      Au = 2;
    var _u = "[object Boolean]",
      vu = "[object Date]",
      yu = "[object Error]",
      xu = "[object Map]",
      Du = "[object Number]",
      Eu = "[object RegExp]",
      Mu = "[object Set]",
      Su = "[object String]",
      Tu = "[object Symbol]";
    var Iu = "[object ArrayBuffer]",
      Nu = "[object DataView]";
    var Pu = r ? r.prototype : undefined,
      Bu = Pu ? Pu.valueOf : undefined;
    function zu(t, e, n, o, i, r, s) {
      switch (n) {
        case Nu:
          if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) {
            return false;
          }
          t = t.buffer;
          e = e.buffer;
        case Iu:
          if (t.byteLength != e.byteLength || !r(new fi(t), new fi(e))) {
            return false;
          }
          return true;
        case _u:
        case vu:
        case Du:
          return R(+t, +e);
        case yu:
          return t.name == e.name && t.message == e.message;
        case Eu:
        case Su:
          return t == e + "";
        case xu:
          var a = ku;
        case Mu:
          var c = o & Cu;
          a || (a = wu);
          if (t.size != e.size && !c) {
            return false;
          }
          var l = s.get(t);
          if (l) {
            return l == e;
          }
          o |= Au;
          s.set(t, e);
          var d = gu(a(t), a(e), o, i, r, s);
          s["delete"](t);
          return d;
        case Tu:
          if (Bu) {
            return Bu.call(t) == Bu.call(e);
          }
      }
      return false;
    }
    var Lu = zu;
    var Ou = 1;
    var Ru = Object.prototype;
    var ju = Ru.hasOwnProperty;
    function Fu(t, e, n, o, i, r) {
      var s = n & Ou,
        a = Ro(t),
        c = a.length,
        l = Ro(e),
        d = l.length;
      if (c != d && !s) {
        return false;
      }
      var u = c;
      while (u--) {
        var h = a[u];
        if (!(s ? h in e : ju.call(e, h))) {
          return false;
        }
      }
      var f = r.get(t);
      if (f && r.get(e)) {
        return f == e;
      }
      var m = true;
      r.set(t, e);
      r.set(e, t);
      var g = s;
      while (++u < c) {
        h = a[u];
        var p = t[h],
          k = e[h];
        if (o) {
          var b = s ? o(k, p, h, e, t, r) : o(p, k, h, t, e, r);
        }
        if (!(b === undefined ? p === k || i(p, k, n, o, r) : b)) {
          m = false;
          break;
        }
        g || (g = h == "constructor");
      }
      if (m && !g) {
        var w = t.constructor,
          C = e.constructor;
        if (w != C && "constructor" in t && "constructor" in e && !(typeof w == "function" && w instanceof w && typeof C == "function" && C instanceof C)) {
          m = false;
        }
      }
      r["delete"](t);
      r["delete"](e);
      return m;
    }
    var Vu = Fu;
    var Uu = 1;
    var Hu = "[object Arguments]",
      Gu = "[object Array]",
      Wu = "[object Object]";
    var Ku = Object.prototype;
    var qu = Ku.hasOwnProperty;
    function Yu(t, e, n, o, i, r) {
      var s = Qe(t),
        a = Qe(e),
        c = s ? Gu : ai(t),
        l = a ? Gu : ai(e);
      c = c == Hu ? Wu : c;
      l = l == Hu ? Wu : l;
      var d = c == Wu,
        u = l == Wu,
        h = c == l;
      if (h && Object($e["a"])(t)) {
        if (!Object($e["a"])(e)) {
          return false;
        }
        s = true;
        d = false;
      }
      if (h && !d) {
        r || (r = new xe());
        return s || On(t) ? gu(t, e, n, o, i, r) : Lu(t, e, c, n, o, i, r);
      }
      if (!(n & Uu)) {
        var f = d && qu.call(t, "__wrapped__"),
          m = u && qu.call(e, "__wrapped__");
        if (f || m) {
          var g = f ? t.value() : t,
            p = m ? e.value() : e;
          r || (r = new xe());
          return i(g, p, n, o, r);
        }
      }
      if (!h) {
        return false;
      }
      r || (r = new xe());
      return Vu(t, e, n, o, i, r);
    }
    var Qu = Yu;
    function $u(t, e, n, o, i) {
      if (t === e) {
        return true;
      }
      if (t == null || e == null || !D(t) && !D(e)) {
        return t !== t && e !== e;
      }
      return Qu(t, e, n, o, $u, i);
    }
    var Zu = $u;
    function Ju(t, e, n) {
      n = typeof n == "function" ? n : undefined;
      var o = n ? n(t, e) : undefined;
      return o === undefined ? Zu(t, e, undefined, n) : !!o;
    }
    var Xu = Ju;
    var th = /*#__PURE__*/function (_tu) {
      _inherits(th, _tu);
      function th(t) {
        var _this30;
        _classCallCheck(this, th);
        _this30 = _possibleConstructorReturn(this, _getPrototypeOf(th).call(this, t));
        _this30._config = {
          childList: true,
          characterData: true,
          characterDataOldValue: true,
          subtree: true
        };
        _this30.domConverter = t.domConverter;
        _this30.renderer = t._renderer;
        _this30._domElements = [];
        _this30._mutationObserver = new window.MutationObserver(_this30._onMutations.bind(_assertThisInitialized(_assertThisInitialized(_this30))));
        return _this30;
      }
      _createClass(th, [{
        key: "flush",
        value: function flush() {
          this._onMutations(this._mutationObserver.takeRecords());
        }
      }, {
        key: "observe",
        value: function observe(t) {
          this._domElements.push(t);
          if (this.isEnabled) {
            this._mutationObserver.observe(t, this._config);
          }
        }
      }, {
        key: "enable",
        value: function enable() {
          _get(_getPrototypeOf(th.prototype), "enable", this).call(this);
          var _iterator82 = _createForOfIteratorHelper(this._domElements),
            _step82;
          try {
            for (_iterator82.s(); !(_step82 = _iterator82.n()).done;) {
              var _t61 = _step82.value;
              this._mutationObserver.observe(_t61, this._config);
            }
          } catch (err) {
            _iterator82.e(err);
          } finally {
            _iterator82.f();
          }
        }
      }, {
        key: "disable",
        value: function disable() {
          _get(_getPrototypeOf(th.prototype), "disable", this).call(this);
          this._mutationObserver.disconnect();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(th.prototype), "destroy", this).call(this);
          this._mutationObserver.disconnect();
        }
      }, {
        key: "_onMutations",
        value: function _onMutations(t) {
          if (t.length === 0) {
            return;
          }
          var e = this.domConverter;
          var n = new Map();
          var o = new Set();
          var _iterator83 = _createForOfIteratorHelper(t),
            _step83;
          try {
            for (_iterator83.s(); !(_step83 = _iterator83.n()).done;) {
              var _n65 = _step83.value;
              if (_n65.type === "childList") {
                var _t63 = e.mapDomToView(_n65.target);
                if (_t63 && (_t63.is("uiElement") || _t63.is("rawElement"))) {
                  continue;
                }
                if (_t63 && !this._isBogusBrMutation(_n65)) {
                  o.add(_t63);
                }
              }
            }
          } catch (err) {
            _iterator83.e(err);
          } finally {
            _iterator83.f();
          }
          var _iterator84 = _createForOfIteratorHelper(t),
            _step84;
          try {
            for (_iterator84.s(); !(_step84 = _iterator84.n()).done;) {
              var _i39 = _step84.value;
              var _t64 = e.mapDomToView(_i39.target);
              if (_t64 && (_t64.is("uiElement") || _t64.is("rawElement"))) {
                continue;
              }
              if (_i39.type === "characterData") {
                var _t65 = e.findCorrespondingViewText(_i39.target);
                if (_t65 && !o.has(_t65.parent)) {
                  n.set(_t65, {
                    type: "text",
                    oldText: _t65.data,
                    newText: bd(_i39.target),
                    node: _t65
                  });
                } else if (!_t65 && pd(_i39.target)) {
                  o.add(e.mapDomToView(_i39.target.parentNode));
                }
              }
            }
          } catch (err) {
            _iterator84.e(err);
          } finally {
            _iterator84.f();
          }
          var i = [];
          var _iterator85 = _createForOfIteratorHelper(n.values()),
            _step85;
          try {
            for (_iterator85.s(); !(_step85 = _iterator85.n()).done;) {
              var _t66 = _step85.value;
              this.renderer.markToSync("text", _t66.node);
              i.push(_t66);
            }
          } catch (err) {
            _iterator85.e(err);
          } finally {
            _iterator85.f();
          }
          var _iterator86 = _createForOfIteratorHelper(o),
            _step86;
          try {
            for (_iterator86.s(); !(_step86 = _iterator86.n()).done;) {
              var _t67 = _step86.value;
              var _n66 = e.mapViewToDom(_t67);
              var _o40 = Array.from(_t67.getChildren());
              var _r12 = Array.from(e.domChildrenToView(_n66, {
                withChildren: false
              }));
              if (!Xu(_o40, _r12, a)) {
                this.renderer.markToSync("children", _t67);
                i.push({
                  type: "children",
                  oldChildren: _o40,
                  newChildren: _r12,
                  node: _t67
                });
              }
            }
          } catch (err) {
            _iterator86.e(err);
          } finally {
            _iterator86.f();
          }
          var r = t[0].target.ownerDocument.getSelection();
          var s = null;
          if (r && r.anchorNode) {
            var _t62 = e.domPositionToView(r.anchorNode, r.anchorOffset);
            var _n64 = e.domPositionToView(r.focusNode, r.focusOffset);
            if (_t62 && _n64) {
              s = new pl(_t62);
              s.setFocus(_n64);
            }
          }
          if (i.length) {
            this.document.fire("mutations", i, s);
            this.view.forceRender();
          }
          function a(t, e) {
            if (Array.isArray(t)) {
              return;
            }
            if (t === e) {
              return true;
            } else if (t.is("$text") && e.is("$text")) {
              return t.data === e.data;
            }
            return false;
          }
        }
      }, {
        key: "_isBogusBrMutation",
        value: function _isBogusBrMutation(t) {
          var e = null;
          if (t.nextSibling === null && t.removedNodes.length === 0 && t.addedNodes.length == 1) {
            e = this.domConverter.domToView(t.addedNodes[0], {
              withChildren: false
            });
          }
          return e && e.is("element", "br");
        }
      }]);
      return th;
    }(tu);
    var eh = /*#__PURE__*/function () {
      function eh(t, e, n) {
        _classCallCheck(this, eh);
        this.view = t;
        this.document = t.document;
        this.domEvent = e;
        this.domTarget = e.target;
        Kc(this, n);
      }
      _createClass(eh, [{
        key: "preventDefault",
        value: function preventDefault() {
          this.domEvent.preventDefault();
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          this.domEvent.stopPropagation();
        }
      }, {
        key: "target",
        get: function get() {
          return this.view.domConverter.mapDomToView(this.domTarget);
        }
      }]);
      return eh;
    }();
    var nh = /*#__PURE__*/function (_tu2) {
      _inherits(nh, _tu2);
      function nh(t) {
        var _this31;
        _classCallCheck(this, nh);
        _this31 = _possibleConstructorReturn(this, _getPrototypeOf(nh).call(this, t));
        _this31.useCapture = false;
        return _this31;
      }
      _createClass(nh, [{
        key: "observe",
        value: function observe(t) {
          var _this32 = this;
          var e = typeof this.domEventType == "string" ? [this.domEventType] : this.domEventType;
          e.forEach(function (e) {
            _this32.listenTo(t, e, function (t, e) {
              if (_this32.isEnabled && !_this32.checkShouldIgnoreEventFromTarget(e.target)) {
                _this32.onDomEvent(e);
              }
            }, {
              useCapture: _this32.useCapture
            });
          });
        }
      }, {
        key: "fire",
        value: function fire(t, e, n) {
          if (this.isEnabled) {
            this.document.fire(t, new eh(this.view, e, n));
          }
        }
      }]);
      return nh;
    }(tu);
    var oh = /*#__PURE__*/function (_nh) {
      _inherits(oh, _nh);
      function oh(t) {
        var _this33;
        _classCallCheck(this, oh);
        _this33 = _possibleConstructorReturn(this, _getPrototypeOf(oh).call(this, t));
        _this33.domEventType = ["keydown", "keyup"];
        return _this33;
      }
      _createClass(oh, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t, {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey || t.metaKey,
            shiftKey: t.shiftKey,
            get keystroke() {
              return Ol(this);
            }
          });
        }
      }]);
      return oh;
    }(nh);
    var ih = function ih() {
      return o["a"].Date.now();
    };
    var rh = ih;
    var sh = 0 / 0;
    var ah = /^\s+|\s+$/g;
    var ch = /^[-+]0x[0-9a-f]+$/i;
    var lh = /^0b[01]+$/i;
    var dh = /^0o[0-7]+$/i;
    var uh = parseInt;
    function hh(t) {
      if (typeof t == "number") {
        return t;
      }
      if (Xs(t)) {
        return sh;
      }
      if (ct(t)) {
        var e = typeof t.valueOf == "function" ? t.valueOf() : t;
        t = ct(e) ? e + "" : e;
      }
      if (typeof t != "string") {
        return t === 0 ? t : +t;
      }
      t = t.replace(ah, "");
      var n = lh.test(t);
      return n || dh.test(t) ? uh(t.slice(2), n ? 2 : 8) : ch.test(t) ? sh : +t;
    }
    var fh = hh;
    var mh = "Expected a function";
    var gh = Math.max,
      ph = Math.min;
    function kh(t, e, n) {
      var o,
        i,
        r,
        s,
        a,
        c,
        l = 0,
        d = false,
        u = false,
        h = true;
      if (typeof t != "function") {
        throw new TypeError(mh);
      }
      e = fh(e) || 0;
      if (ct(n)) {
        d = !!n.leading;
        u = "maxWait" in n;
        r = u ? gh(fh(n.maxWait) || 0, e) : r;
        h = "trailing" in n ? !!n.trailing : h;
      }
      function f(e) {
        var n = o,
          r = i;
        o = i = undefined;
        l = e;
        s = t.apply(r, n);
        return s;
      }
      function m(t) {
        l = t;
        a = setTimeout(k, e);
        return d ? f(t) : s;
      }
      function g(t) {
        var n = t - c,
          o = t - l,
          i = e - n;
        return u ? ph(i, r - o) : i;
      }
      function p(t) {
        var n = t - c,
          o = t - l;
        return c === undefined || n >= e || n < 0 || u && o >= r;
      }
      function k() {
        var t = rh();
        if (p(t)) {
          return b(t);
        }
        a = setTimeout(k, g(t));
      }
      function b(t) {
        a = undefined;
        if (h && o) {
          return f(t);
        }
        o = i = undefined;
        return s;
      }
      function w() {
        if (a !== undefined) {
          clearTimeout(a);
        }
        l = 0;
        o = c = i = a = undefined;
      }
      function C() {
        return a === undefined ? s : b(rh());
      }
      function A() {
        var t = rh(),
          n = p(t);
        o = arguments;
        i = this;
        c = t;
        if (n) {
          if (a === undefined) {
            return m(c);
          }
          if (u) {
            clearTimeout(a);
            a = setTimeout(k, e);
            return f(c);
          }
        }
        if (a === undefined) {
          a = setTimeout(k, e);
        }
        return s;
      }
      A.cancel = w;
      A.flush = C;
      return A;
    }
    var bh = kh;
    var wh = /*#__PURE__*/function (_tu3) {
      _inherits(wh, _tu3);
      function wh(t) {
        var _this34;
        _classCallCheck(this, wh);
        _this34 = _possibleConstructorReturn(this, _getPrototypeOf(wh).call(this, t));
        _this34._fireSelectionChangeDoneDebounced = bh(function (t) {
          return _this34.document.fire("selectionChangeDone", t);
        }, 200);
        return _this34;
      }
      _createClass(wh, [{
        key: "observe",
        value: function observe() {
          var _this35 = this;
          var t = this.document;
          t.on("keydown", function (e, n) {
            var o = t.selection;
            if (o.isFake && Fl(n.keyCode) && _this35.isEnabled) {
              n.preventDefault();
              _this35._handleSelectionMove(n.keyCode);
            }
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(wh.prototype), "destroy", this).call(this);
          this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionMove",
        value: function _handleSelectionMove(t) {
          var e = this.document.selection;
          var n = new pl(e.getRanges(), {
            backward: e.isBackward,
            fake: false
          });
          if (t == Ll.arrowleft || t == Ll.arrowup) {
            n.setTo(n.getFirstPosition());
          }
          if (t == Ll.arrowright || t == Ll.arrowdown) {
            n.setTo(n.getLastPosition());
          }
          var o = {
            oldSelection: e,
            newSelection: n,
            domSelection: null
          };
          this.document.fire("selectionChange", o);
          this._fireSelectionChangeDoneDebounced(o);
        }
      }]);
      return wh;
    }(tu);
    var Ch = /*#__PURE__*/function (_tu4) {
      _inherits(Ch, _tu4);
      function Ch(t) {
        var _this36;
        _classCallCheck(this, Ch);
        _this36 = _possibleConstructorReturn(this, _getPrototypeOf(Ch).call(this, t));
        _this36.mutationObserver = t.getObserver(th);
        _this36.selection = _this36.document.selection;
        _this36.domConverter = t.domConverter;
        _this36._documents = new WeakSet();
        _this36._fireSelectionChangeDoneDebounced = bh(function (t) {
          return _this36.document.fire("selectionChangeDone", t);
        }, 200);
        _this36._clearInfiniteLoopInterval = setInterval(function () {
          return _this36._clearInfiniteLoop();
        }, 1e3);
        _this36._loopbackCounter = 0;
        return _this36;
      }
      _createClass(Ch, [{
        key: "observe",
        value: function observe(t) {
          var _this37 = this;
          var e = t.ownerDocument;
          if (this._documents.has(e)) {
            return;
          }
          this.listenTo(e, "selectionchange", function (t, n) {
            _this37._handleSelectionChange(n, e);
          });
          this._documents.add(e);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(Ch.prototype), "destroy", this).call(this);
          clearInterval(this._clearInfiniteLoopInterval);
          this._fireSelectionChangeDoneDebounced.cancel();
        }
      }, {
        key: "_handleSelectionChange",
        value: function _handleSelectionChange(t, e) {
          if (!this.isEnabled) {
            return;
          }
          var n = e.defaultView.getSelection();
          if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) {
            return;
          }
          this.mutationObserver.flush();
          var o = this.domConverter.domSelectionToView(n);
          if (o.rangeCount == 0) {
            this.view.hasDomSelection = false;
            return;
          }
          this.view.hasDomSelection = true;
          if (this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(n)) {
            return;
          }
          if (++this._loopbackCounter > 60) {
            return;
          }
          if (this.selection.isSimilar(o)) {
            this.view.forceRender();
          } else {
            var _t68 = {
              oldSelection: this.selection,
              newSelection: o,
              domSelection: n
            };
            this.document.fire("selectionChange", _t68);
            this._fireSelectionChangeDoneDebounced(_t68);
          }
        }
      }, {
        key: "_clearInfiniteLoop",
        value: function _clearInfiniteLoop() {
          this._loopbackCounter = 0;
        }
      }]);
      return Ch;
    }(tu);
    var Ah = /*#__PURE__*/function (_nh2) {
      _inherits(Ah, _nh2);
      function Ah(t) {
        var _this38;
        _classCallCheck(this, Ah);
        _this38 = _possibleConstructorReturn(this, _getPrototypeOf(Ah).call(this, t));
        _this38.domEventType = ["focus", "blur"];
        _this38.useCapture = true;
        var e = _this38.document;
        e.on("focus", function () {
          e.isFocused = true;
          _this38._renderTimeoutId = setTimeout(function () {
            return t.forceRender();
          }, 50);
        });
        e.on("blur", function (n, o) {
          var i = e.selection.editableElement;
          if (i === null || i === o.target) {
            e.isFocused = false;
            t.forceRender();
          }
        });
        return _this38;
      }
      _createClass(Ah, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          if (this._renderTimeoutId) {
            clearTimeout(this._renderTimeoutId);
          }
          _get(_getPrototypeOf(Ah.prototype), "destroy", this).call(this);
        }
      }]);
      return Ah;
    }(nh);
    var _h = /*#__PURE__*/function (_nh3) {
      _inherits(_h, _nh3);
      function _h(t) {
        var _this39;
        _classCallCheck(this, _h);
        _this39 = _possibleConstructorReturn(this, _getPrototypeOf(_h).call(this, t));
        _this39.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
        var e = _this39.document;
        e.on("compositionstart", function () {
          e.isComposing = true;
        });
        e.on("compositionend", function () {
          e.isComposing = false;
        });
        return _this39;
      }
      _createClass(_h, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return _h;
    }(nh);
    var vh = /*#__PURE__*/function (_nh4) {
      _inherits(vh, _nh4);
      function vh(t) {
        var _this40;
        _classCallCheck(this, vh);
        _this40 = _possibleConstructorReturn(this, _getPrototypeOf(vh).call(this, t));
        _this40.domEventType = ["beforeinput"];
        return _this40;
      }
      _createClass(vh, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return vh;
    }(nh);
    function yh(t) {
      return Object.prototype.toString.apply(t) == "[object Range]";
    }
    function xh(t) {
      var e = t.ownerDocument.defaultView.getComputedStyle(t);
      return {
        top: parseInt(e.borderTopWidth, 10),
        right: parseInt(e.borderRightWidth, 10),
        bottom: parseInt(e.borderBottomWidth, 10),
        left: parseInt(e.borderLeftWidth, 10)
      };
    }
    var Dh = ["top", "right", "bottom", "left", "width", "height"];
    var Eh = /*#__PURE__*/function () {
      function Eh(t) {
        _classCallCheck(this, Eh);
        var e = yh(t);
        Object.defineProperty(this, "_source", {
          value: t._source || t,
          writable: true,
          enumerable: false
        });
        if (Yr(t) || e) {
          if (e) {
            var _e76 = Eh.getDomRangeRects(t);
            Mh(this, Eh.getBoundingRect(_e76));
          } else {
            Mh(this, t.getBoundingClientRect());
          }
        } else if (Qd(t)) {
          var _e77 = t.innerWidth,
            _n67 = t.innerHeight;
          Mh(this, {
            top: 0,
            right: _e77,
            bottom: _n67,
            left: 0,
            width: _e77,
            height: _n67
          });
        } else {
          Mh(this, t);
        }
      }
      _createClass(Eh, [{
        key: "clone",
        value: function clone() {
          return new Eh(this);
        }
      }, {
        key: "moveTo",
        value: function moveTo(t, e) {
          this.top = e;
          this.right = t + this.width;
          this.bottom = e + this.height;
          this.left = t;
          return this;
        }
      }, {
        key: "moveBy",
        value: function moveBy(t, e) {
          this.top += e;
          this.right += t;
          this.left += t;
          this.bottom += e;
          return this;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          var e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left)
          };
          e.width = e.right - e.left;
          e.height = e.bottom - e.top;
          if (e.width < 0 || e.height < 0) {
            return null;
          } else {
            return new Eh(e);
          }
        }
      }, {
        key: "getIntersectionArea",
        value: function getIntersectionArea(t) {
          var e = this.getIntersection(t);
          if (e) {
            return e.getArea();
          } else {
            return 0;
          }
        }
      }, {
        key: "getArea",
        value: function getArea() {
          return this.width * this.height;
        }
      }, {
        key: "getVisible",
        value: function getVisible() {
          var t = this._source;
          var e = this.clone();
          if (!Sh(t)) {
            var _n68 = t.parentNode || t.commonAncestorContainer;
            while (_n68 && !Sh(_n68)) {
              var _t69 = new Eh(_n68);
              var _o41 = e.getIntersection(_t69);
              if (_o41) {
                if (_o41.getArea() < e.getArea()) {
                  e = _o41;
                }
              } else {
                return null;
              }
              _n68 = _n68.parentNode;
            }
          }
          return e;
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          for (var _i40 = 0, _Dh = Dh; _i40 < _Dh.length; _i40++) {
            var _e78 = _Dh[_i40];
            if (this[_e78] !== t[_e78]) {
              return false;
            }
          }
          return true;
        }
      }, {
        key: "contains",
        value: function contains(t) {
          var e = this.getIntersection(t);
          return !!(e && e.isEqual(t));
        }
      }, {
        key: "excludeScrollbarsAndBorders",
        value: function excludeScrollbarsAndBorders() {
          var t = this._source;
          var e, n, o;
          if (Qd(t)) {
            e = t.innerWidth - t.document.documentElement.clientWidth;
            n = t.innerHeight - t.document.documentElement.clientHeight;
            o = t.getComputedStyle(t.document.documentElement).direction;
          } else {
            var _i41 = xh(this._source);
            e = t.offsetWidth - t.clientWidth - _i41.left - _i41.right;
            n = t.offsetHeight - t.clientHeight - _i41.top - _i41.bottom;
            o = t.ownerDocument.defaultView.getComputedStyle(t).direction;
            this.left += _i41.left;
            this.top += _i41.top;
            this.right -= _i41.right;
            this.bottom -= _i41.bottom;
            this.width = this.right - this.left;
            this.height = this.bottom - this.top;
          }
          this.width -= e;
          if (o === "ltr") {
            this.right -= e;
          } else {
            this.left += e;
          }
          this.height -= n;
          this.bottom -= n;
          return this;
        }
      }], [{
        key: "getDomRangeRects",
        value: function getDomRangeRects(t) {
          var e = [];
          var n = Array.from(t.getClientRects());
          if (n.length) {
            var _iterator87 = _createForOfIteratorHelper(n),
              _step87;
            try {
              for (_iterator87.s(); !(_step87 = _iterator87.n()).done;) {
                var _t70 = _step87.value;
                e.push(new Eh(_t70));
              }
            } catch (err) {
              _iterator87.e(err);
            } finally {
              _iterator87.f();
            }
          } else {
            var _n69 = t.startContainer;
            if (ud(_n69)) {
              _n69 = _n69.parentNode;
            }
            var _o42 = new Eh(_n69.getBoundingClientRect());
            _o42.right = _o42.left;
            _o42.width = 0;
            e.push(_o42);
          }
          return e;
        }
      }, {
        key: "getBoundingRect",
        value: function getBoundingRect(t) {
          var e = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY
          };
          var n = 0;
          var _iterator88 = _createForOfIteratorHelper(t),
            _step88;
          try {
            for (_iterator88.s(); !(_step88 = _iterator88.n()).done;) {
              var _o43 = _step88.value;
              n++;
              e.left = Math.min(e.left, _o43.left);
              e.top = Math.min(e.top, _o43.top);
              e.right = Math.max(e.right, _o43.right);
              e.bottom = Math.max(e.bottom, _o43.bottom);
            }
          } catch (err) {
            _iterator88.e(err);
          } finally {
            _iterator88.f();
          }
          if (n == 0) {
            return null;
          }
          e.width = e.right - e.left;
          e.height = e.bottom - e.top;
          return new Eh(e);
        }
      }]);
      return Eh;
    }();
    function Mh(t, e) {
      var _iterator89 = _createForOfIteratorHelper(Dh),
        _step89;
      try {
        for (_iterator89.s(); !(_step89 = _iterator89.n()).done;) {
          var _n70 = _step89.value;
          t[_n70] = e[_n70];
        }
      } catch (err) {
        _iterator89.e(err);
      } finally {
        _iterator89.f();
      }
    }
    function Sh(t) {
      if (!Yr(t)) {
        return false;
      }
      return t === t.ownerDocument.body;
    }
    var Th = {};
    function Ih(_ref7) {
      var t = _ref7.target,
        _ref7$viewportOffset = _ref7.viewportOffset,
        e = _ref7$viewportOffset === void 0 ? 0 : _ref7$viewportOffset;
      var n = jh(t);
      var o = n;
      var i = null;
      while (o) {
        var _r13 = void 0;
        if (o == n) {
          _r13 = Fh(t);
        } else {
          _r13 = Fh(i);
        }
        Bh(_r13, function () {
          return Vh(t, o);
        });
        var _s8 = Vh(t, o);
        Ph(o, _s8, e);
        if (o.parent != o) {
          i = o.frameElement;
          o = o.parent;
          if (!i) {
            return;
          }
        } else {
          o = null;
        }
      }
    }
    function Nh(t) {
      var e = Fh(t);
      Bh(e, function () {
        return new Eh(t);
      });
    }
    Object.assign(Th, {
      scrollViewportToShowTarget: Ih,
      scrollAncestorsToShowTarget: Nh
    });
    function Ph(t, e, n) {
      var o = e.clone().moveBy(0, n);
      var i = e.clone().moveBy(0, -n);
      var r = new Eh(t).excludeScrollbarsAndBorders();
      var s = [i, o];
      if (!s.every(function (t) {
        return r.contains(t);
      })) {
        var _s9 = t.scrollX,
          _a7 = t.scrollY;
        if (Lh(i, r)) {
          _a7 -= r.top - e.top + n;
        } else if (zh(o, r)) {
          _a7 += e.bottom - r.bottom + n;
        }
        if (Oh(e, r)) {
          _s9 -= r.left - e.left + n;
        } else if (Rh(e, r)) {
          _s9 += e.right - r.right + n;
        }
        t.scrollTo(_s9, _a7);
      }
    }
    function Bh(t, e) {
      var n = jh(t);
      var o, i;
      while (t != n.document.body) {
        i = e();
        o = new Eh(t).excludeScrollbarsAndBorders();
        if (!o.contains(i)) {
          if (Lh(i, o)) {
            t.scrollTop -= o.top - i.top;
          } else if (zh(i, o)) {
            t.scrollTop += i.bottom - o.bottom;
          }
          if (Oh(i, o)) {
            t.scrollLeft -= o.left - i.left;
          } else if (Rh(i, o)) {
            t.scrollLeft += i.right - o.right;
          }
        }
        t = t.parentNode;
      }
    }
    function zh(t, e) {
      return t.bottom > e.bottom;
    }
    function Lh(t, e) {
      return t.top < e.top;
    }
    function Oh(t, e) {
      return t.left < e.left;
    }
    function Rh(t, e) {
      return t.right > e.right;
    }
    function jh(t) {
      if (yh(t)) {
        return t.startContainer.ownerDocument.defaultView;
      } else {
        return t.ownerDocument.defaultView;
      }
    }
    function Fh(t) {
      if (yh(t)) {
        var _e79 = t.commonAncestorContainer;
        if (ud(_e79)) {
          _e79 = _e79.parentNode;
        }
        return _e79;
      } else {
        return t.parentNode;
      }
    }
    function Vh(t, e) {
      var n = jh(t);
      var o = new Eh(t);
      if (n === e) {
        return o;
      } else {
        var _t71 = n;
        while (_t71 != e) {
          var _e80 = _t71.frameElement;
          var _n71 = new Eh(_e80).excludeScrollbarsAndBorders();
          o.moveBy(_n71.left, _n71.top);
          _t71 = _t71.parent;
        }
      }
      return o;
    }
    var Uh = /*#__PURE__*/function () {
      function Uh(t) {
        var _this41 = this;
        _classCallCheck(this, Uh);
        this.document = new bl(t);
        this.domConverter = new Gd(this.document);
        this.domRoots = new Map();
        this.set("isRenderingInProgress", false);
        this.set("hasDomSelection", false);
        this._renderer = new Id(this.domConverter, this.document.selection);
        this._renderer.bind("isFocused").to(this.document);
        this._initialDomRootAttributes = new WeakMap();
        this._observers = new Map();
        this._ongoingChange = false;
        this._postFixersInProgress = false;
        this._renderingDisabled = false;
        this._hasChangedSinceTheLastRendering = false;
        this._writer = new Xl(this.document);
        this.addObserver(th);
        this.addObserver(Ch);
        this.addObserver(Ah);
        this.addObserver(oh);
        this.addObserver(wh);
        this.addObserver(_h);
        if (El.isAndroid) {
          this.addObserver(vh);
        }
        wd(this);
        Kl(this);
        this.on("render", function () {
          _this41._render();
          _this41.document.fire("layoutChanged");
          _this41._hasChangedSinceTheLastRendering = false;
        });
        this.listenTo(this.document.selection, "change", function () {
          _this41._hasChangedSinceTheLastRendering = true;
        });
      }
      _createClass(Uh, [{
        key: "attachDomRoot",
        value: function attachDomRoot(t) {
          var _this42 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          var n = this.document.getRoot(e);
          n._name = t.tagName.toLowerCase();
          var o = {};
          for (var _i42 = 0, _Array$from = Array.from(t.attributes); _i42 < _Array$from.length; _i42++) {
            var _Array$from$_i = _Array$from[_i42],
              _e81 = _Array$from$_i.name,
              _i43 = _Array$from$_i.value;
            o[_e81] = _i43;
            if (_e81 === "class") {
              this._writer.addClass(_i43.split(" "), n);
            } else {
              this._writer.setAttribute(_e81, _i43, n);
            }
          }
          this._initialDomRootAttributes.set(t, o);
          var i = function i() {
            _this42._writer.setAttribute("contenteditable", !n.isReadOnly, n);
            if (n.isReadOnly) {
              _this42._writer.addClass("ck-read-only", n);
            } else {
              _this42._writer.removeClass("ck-read-only", n);
            }
          };
          i();
          this.domRoots.set(e, t);
          this.domConverter.bindElements(t, n);
          this._renderer.markToSync("children", n);
          this._renderer.markToSync("attributes", n);
          this._renderer.domDocuments.add(t.ownerDocument);
          n.on("change:children", function (t, e) {
            return _this42._renderer.markToSync("children", e);
          });
          n.on("change:attributes", function (t, e) {
            return _this42._renderer.markToSync("attributes", e);
          });
          n.on("change:text", function (t, e) {
            return _this42._renderer.markToSync("text", e);
          });
          n.on("change:isReadOnly", function () {
            return _this42.change(i);
          });
          n.on("change", function () {
            _this42._hasChangedSinceTheLastRendering = true;
          });
          var _iterator90 = _createForOfIteratorHelper(this._observers.values()),
            _step90;
          try {
            for (_iterator90.s(); !(_step90 = _iterator90.n()).done;) {
              var _n72 = _step90.value;
              _n72.observe(t, e);
            }
          } catch (err) {
            _iterator90.e(err);
          } finally {
            _iterator90.f();
          }
        }
      }, {
        key: "detachDomRoot",
        value: function detachDomRoot(t) {
          var e = this.domRoots.get(t);
          Array.from(e.attributes).forEach(function (_ref8) {
            var t = _ref8.name;
            return e.removeAttribute(t);
          });
          var n = this._initialDomRootAttributes.get(e);
          for (var _t72 in n) {
            e.setAttribute(_t72, n[_t72]);
          }
          this.domRoots.delete(t);
          this.domConverter.unbindDomElement(e);
        }
      }, {
        key: "getDomRoot",
        value: function getDomRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.domRoots.get(t);
        }
      }, {
        key: "addObserver",
        value: function addObserver(t) {
          var e = this._observers.get(t);
          if (e) {
            return e;
          }
          e = new t(this);
          this._observers.set(t, e);
          var _iterator91 = _createForOfIteratorHelper(this.domRoots),
            _step91;
          try {
            for (_iterator91.s(); !(_step91 = _iterator91.n()).done;) {
              var _step91$value = _slicedToArray(_step91.value, 2),
                _t73 = _step91$value[0],
                _n73 = _step91$value[1];
              e.observe(_n73, _t73);
            }
          } catch (err) {
            _iterator91.e(err);
          } finally {
            _iterator91.f();
          }
          e.enable();
          return e;
        }
      }, {
        key: "getObserver",
        value: function getObserver(t) {
          return this._observers.get(t);
        }
      }, {
        key: "disableObservers",
        value: function disableObservers() {
          var _iterator92 = _createForOfIteratorHelper(this._observers.values()),
            _step92;
          try {
            for (_iterator92.s(); !(_step92 = _iterator92.n()).done;) {
              var _t74 = _step92.value;
              _t74.disable();
            }
          } catch (err) {
            _iterator92.e(err);
          } finally {
            _iterator92.f();
          }
        }
      }, {
        key: "enableObservers",
        value: function enableObservers() {
          var _iterator93 = _createForOfIteratorHelper(this._observers.values()),
            _step93;
          try {
            for (_iterator93.s(); !(_step93 = _iterator93.n()).done;) {
              var _t75 = _step93.value;
              _t75.enable();
            }
          } catch (err) {
            _iterator93.e(err);
          } finally {
            _iterator93.f();
          }
        }
      }, {
        key: "scrollToTheSelection",
        value: function scrollToTheSelection() {
          var t = this.document.selection.getFirstRange();
          if (t) {
            Ih({
              target: this.domConverter.viewRangeToDom(t),
              viewportOffset: 20
            });
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          if (!this.document.isFocused) {
            var _t76 = this.document.selection.editableElement;
            if (_t76) {
              this.domConverter.focus(_t76);
              this.forceRender();
            } else {}
          }
        }
      }, {
        key: "change",
        value: function change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) {
            throw new ss["a"]("cannot-change-view-tree", this);
          }
          try {
            if (this._ongoingChange) {
              return t(this._writer);
            }
            this._ongoingChange = true;
            var _e82 = t(this._writer);
            this._ongoingChange = false;
            if (!this._renderingDisabled && this._hasChangedSinceTheLastRendering) {
              this._postFixersInProgress = true;
              this.document._callPostFixers(this._writer);
              this._postFixersInProgress = false;
              this.fire("render");
            }
            return _e82;
          } catch (t) {
            ss["a"].rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "forceRender",
        value: function forceRender() {
          this._hasChangedSinceTheLastRendering = true;
          this.change(function () {});
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator94 = _createForOfIteratorHelper(this._observers.values()),
            _step94;
          try {
            for (_iterator94.s(); !(_step94 = _iterator94.n()).done;) {
              var _t77 = _step94.value;
              _t77.destroy();
            }
          } catch (err) {
            _iterator94.e(err);
          } finally {
            _iterator94.f();
          }
          this.document.destroy();
          this.stopListening();
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return hl._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return hl._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return hl._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new fl(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return fl._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return fl._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new pl(t, e, n);
        }
      }, {
        key: "_disableRendering",
        value: function _disableRendering(t) {
          this._renderingDisabled = t;
          if (t == false) {
            this.change(function () {});
          }
        }
      }, {
        key: "_render",
        value: function _render() {
          this.isRenderingInProgress = true;
          this.disableObservers();
          this._renderer.render();
          this.enableObservers();
          this.isRenderingInProgress = false;
        }
      }]);
      return Uh;
    }();
    _s(Uh, Zc);
    var Hh = /*#__PURE__*/function () {
      function Hh(t) {
        _classCallCheck(this, Hh);
        this.parent = null;
        this._attrs = Gs(t);
      }
      _createClass(Hh, [{
        key: "isAttached",
        value: function isAttached() {
          return this.root.is("rootElement");
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = [];
          var e = this;
          while (e.parent) {
            t.unshift(e.startOffset);
            e = e.parent;
          }
          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: false,
            parentFirst: false
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          while (n) {
            e[t.parentFirst ? "push" : "unshift"](n);
            n = n.parent;
          }
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.getAncestors(e);
          var o = t.getAncestors(e);
          var i = 0;
          while (n[i] == o[i] && n[i]) {
            i++;
          }
          return i === 0 ? null : n[i - 1];
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          if (this == t) {
            return false;
          }
          if (this.root !== t.root) {
            return false;
          }
          var e = this.getPath();
          var n = t.getPath();
          var o = Ls(e, n);
          switch (o) {
            case "prefix":
              return true;
            case "extension":
              return false;
            default:
              return e[o] < n[o];
          }
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          if (this == t) {
            return false;
          }
          if (this.root !== t.root) {
            return false;
          }
          return !this.isBefore(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = {};
          if (this._attrs.size) {
            t.attributes = Array.from(this._attrs).reduce(function (t, e) {
              t[e[0]] = e[1];
              return t;
            }, {});
          }
          return t;
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "node" || t === "model:node";
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Hh(this._attrs);
        }
      }, {
        key: "_remove",
        value: function _remove() {
          this.parent._removeChildren(this.index);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._attrs.set(t, e);
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          this._attrs = Gs(t);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          return this._attrs.delete(t);
        }
      }, {
        key: "_clearAttributes",
        value: function _clearAttributes() {
          this._attrs.clear();
        }
      }, {
        key: "index",
        get: function get() {
          var t;
          if (!this.parent) {
            return null;
          }
          if ((t = this.parent.getChildIndex(this)) === null) {
            throw new ss["a"]("model-node-not-found-in-parent", this);
          }
          return t;
        }
      }, {
        key: "startOffset",
        get: function get() {
          var t;
          if (!this.parent) {
            return null;
          }
          if ((t = this.parent.getChildStartOffset(this)) === null) {
            throw new ss["a"]("model-node-not-found-in-parent", this);
          }
          return t;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return 1;
        }
      }, {
        key: "endOffset",
        get: function get() {
          if (!this.parent) {
            return null;
          }
          return this.startOffset + this.offsetSize;
        }
      }, {
        key: "nextSibling",
        get: function get() {
          var t = this.index;
          return t !== null && this.parent.getChild(t + 1) || null;
        }
      }, {
        key: "previousSibling",
        get: function get() {
          var t = this.index;
          return t !== null && this.parent.getChild(t - 1) || null;
        }
      }, {
        key: "root",
        get: function get() {
          var t = this;
          while (t.parent) {
            t = t.parent;
          }
          return t;
        }
      }]);
      return Hh;
    }();
    var Gh = /*#__PURE__*/function (_Hh) {
      _inherits(Gh, _Hh);
      function Gh(t, e) {
        var _this43;
        _classCallCheck(this, Gh);
        _this43 = _possibleConstructorReturn(this, _getPrototypeOf(Gh).call(this, e));
        _this43._data = t || "";
        return _this43;
      }
      _createClass(Gh, [{
        key: "is",
        value: function is(t) {
          return t === "$text" || t === "model:$text" || t === "text" || t === "model:text" || t === "node" || t === "model:node";
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Gh.prototype), "toJSON", this).call(this);
          t.data = this.data;
          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          return new Gh(this.data, this.getAttributes());
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new Gh(t.data, t.attributes);
        }
      }]);
      return Gh;
    }(Hh);
    var Wh = /*#__PURE__*/function () {
      function Wh(t, e, n) {
        _classCallCheck(this, Wh);
        this.textNode = t;
        if (e < 0 || e > t.offsetSize) {
          throw new ss["a"]("model-textproxy-wrong-offsetintext", this);
        }
        if (n < 0 || e + n > t.offsetSize) {
          throw new ss["a"]("model-textproxy-wrong-length", this);
        }
        this.data = t.data.substring(e, e + n);
        this.offsetInText = e;
      }
      _createClass(Wh, [{
        key: "is",
        value: function is(t) {
          return t === "$textProxy" || t === "model:$textProxy" || t === "textProxy" || t === "model:textProxy";
        }
      }, {
        key: "getPath",
        value: function getPath() {
          var t = this.textNode.getPath();
          if (t.length > 0) {
            t[t.length - 1] += this.offsetInText;
          }
          return t;
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeSelf: false,
            parentFirst: false
          };
          var e = [];
          var n = t.includeSelf ? this : this.parent;
          while (n) {
            e[t.parentFirst ? "push" : "unshift"](n);
            n = n.parent;
          }
          return e;
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this.textNode.hasAttribute(t);
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this.textNode.getAttribute(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this.textNode.getAttributes();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this.textNode.getAttributeKeys();
        }
      }, {
        key: "startOffset",
        get: function get() {
          return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
        }
      }, {
        key: "offsetSize",
        get: function get() {
          return this.data.length;
        }
      }, {
        key: "endOffset",
        get: function get() {
          return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
        }
      }, {
        key: "isPartial",
        get: function get() {
          return this.offsetSize !== this.textNode.offsetSize;
        }
      }, {
        key: "parent",
        get: function get() {
          return this.textNode.parent;
        }
      }, {
        key: "root",
        get: function get() {
          return this.textNode.root;
        }
      }]);
      return Wh;
    }();
    var Kh = /*#__PURE__*/function () {
      function Kh(t) {
        _classCallCheck(this, Kh);
        this._nodes = [];
        if (t) {
          this._insertNodes(0, t);
        }
      }
      _createClass(Kh, [{
        key: Symbol.iterator,
        value: function value() {
          return this._nodes[Symbol.iterator]();
        }
      }, {
        key: "getNode",
        value: function getNode(t) {
          return this._nodes[t] || null;
        }
      }, {
        key: "getNodeIndex",
        value: function getNodeIndex(t) {
          var e = this._nodes.indexOf(t);
          return e == -1 ? null : e;
        }
      }, {
        key: "getNodeStartOffset",
        value: function getNodeStartOffset(t) {
          var e = this.getNodeIndex(t);
          return e === null ? null : this._nodes.slice(0, e).reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }, {
        key: "indexToOffset",
        value: function indexToOffset(t) {
          if (t == this._nodes.length) {
            return this.maxOffset;
          }
          var e = this._nodes[t];
          if (!e) {
            throw new ss["a"]("model-nodelist-index-out-of-bounds", this);
          }
          return this.getNodeStartOffset(e);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          var e = 0;
          var _iterator95 = _createForOfIteratorHelper(this._nodes),
            _step95;
          try {
            for (_iterator95.s(); !(_step95 = _iterator95.n()).done;) {
              var _n74 = _step95.value;
              if (t >= e && t < e + _n74.offsetSize) {
                return this.getNodeIndex(_n74);
              }
              e += _n74.offsetSize;
            }
          } catch (err) {
            _iterator95.e(err);
          } finally {
            _iterator95.f();
          }
          if (e != t) {
            throw new ss["a"]("model-nodelist-offset-out-of-bounds", this, {
              offset: t,
              nodeList: this
            });
          }
          return this.length;
        }
      }, {
        key: "_insertNodes",
        value: function _insertNodes(t, e) {
          var _this$_nodes;
          var _iterator96 = _createForOfIteratorHelper(e),
            _step96;
          try {
            for (_iterator96.s(); !(_step96 = _iterator96.n()).done;) {
              var _t78 = _step96.value;
              if (!(_t78 instanceof Hh)) {
                throw new ss["a"]("model-nodelist-insertnodes-not-node", this);
              }
            }
          } catch (err) {
            _iterator96.e(err);
          } finally {
            _iterator96.f();
          }
          (_this$_nodes = this._nodes).splice.apply(_this$_nodes, [t, 0].concat(_toConsumableArray(e)));
        }
      }, {
        key: "_removeNodes",
        value: function _removeNodes(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          return this._nodes.splice(t, e);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this._nodes.map(function (t) {
            return t.toJSON();
          });
        }
      }, {
        key: "length",
        get: function get() {
          return this._nodes.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._nodes.reduce(function (t, e) {
            return t + e.offsetSize;
          }, 0);
        }
      }]);
      return Kh;
    }();
    var qh = /*#__PURE__*/function (_Hh2) {
      _inherits(qh, _Hh2);
      function qh(t, e, n) {
        var _this44;
        _classCallCheck(this, qh);
        _this44 = _possibleConstructorReturn(this, _getPrototypeOf(qh).call(this, e));
        _this44.name = t;
        _this44._children = new Kh();
        if (n) {
          _this44._insertChild(0, n);
        }
        return _this44;
      }
      _createClass(qh, [{
        key: "is",
        value: function is(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (!e) {
            return t === "element" || t === "model:element" || t === "node" || t === "model:node";
          }
          return e === this.name && (t === "element" || t === "model:element");
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iterator97 = _createForOfIteratorHelper(t),
            _step97;
          try {
            for (_iterator97.s(); !(_step97 = _iterator97.n()).done;) {
              var _n75 = _step97.value;
              e = e.getChild(e.offsetToIndex(_n75));
            }
          } catch (err) {
            _iterator97.e(err);
          } finally {
            _iterator97.f();
          }
          return e;
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            includeSelf: false
          };
          var n = e.includeSelf ? this : this.parent;
          while (n) {
            if (n.name === t) {
              return n;
            }
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(qh.prototype), "toJSON", this).call(this);
          t.name = this.name;
          if (this._children.length > 0) {
            t.children = [];
            var _iterator98 = _createForOfIteratorHelper(this._children),
              _step98;
            try {
              for (_iterator98.s(); !(_step98 = _iterator98.n()).done;) {
                var _e83 = _step98.value;
                t.children.push(_e83.toJSON());
              }
            } catch (err) {
              _iterator98.e(err);
            } finally {
              _iterator98.f();
            }
          }
          return t;
        }
      }, {
        key: "_clone",
        value: function _clone() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          var e = t ? Array.from(this._children).map(function (t) {
            return t._clone(true);
          }) : null;
          return new qh(this.name, this.getAttributes(), e);
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = Yh(e);
          var _iterator99 = _createForOfIteratorHelper(n),
            _step99;
          try {
            for (_iterator99.s(); !(_step99 = _iterator99.n()).done;) {
              var _t79 = _step99.value;
              if (_t79.parent !== null) {
                _t79._remove();
              }
              _t79.parent = this;
            }
          } catch (err) {
            _iterator99.e(err);
          } finally {
            _iterator99.f();
          }
          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var n = this._children._removeNodes(t, e);
          var _iterator100 = _createForOfIteratorHelper(n),
            _step100;
          try {
            for (_iterator100.s(); !(_step100 = _iterator100.n()).done;) {
              var _t80 = _step100.value;
              _t80.parent = null;
            }
          } catch (err) {
            _iterator100.e(err);
          } finally {
            _iterator100.f();
          }
          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return this.childCount === 0;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = null;
          if (t.children) {
            e = [];
            var _iterator101 = _createForOfIteratorHelper(t.children),
              _step101;
            try {
              for (_iterator101.s(); !(_step101 = _iterator101.n()).done;) {
                var _n76 = _step101.value;
                if (_n76.name) {
                  e.push(qh.fromJSON(_n76));
                } else {
                  e.push(Gh.fromJSON(_n76));
                }
              }
            } catch (err) {
              _iterator101.e(err);
            } finally {
              _iterator101.f();
            }
          }
          return new qh(t.name, t.attributes, e);
        }
      }]);
      return qh;
    }(Hh);
    function Yh(t) {
      if (typeof t == "string") {
        return [new Gh(t)];
      }
      if (!As(t)) {
        t = [t];
      }
      return Array.from(t).map(function (t) {
        if (typeof t == "string") {
          return new Gh(t);
        }
        if (t instanceof Wh) {
          return new Gh(t.data, t.getAttributes());
        }
        return t;
      });
    }
    var Qh = /*#__PURE__*/function () {
      function Qh() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, Qh);
        if (!t.boundaries && !t.startPosition) {
          throw new ss["a"]("model-tree-walker-no-start-position", null);
        }
        var e = t.direction || "forward";
        if (e != "forward" && e != "backward") {
          throw new ss["a"]("model-tree-walker-unknown-direction", t, {
            direction: e
          });
        }
        this.direction = e;
        this.boundaries = t.boundaries || null;
        if (t.startPosition) {
          this.position = t.startPosition.clone();
        } else {
          this.position = Zh._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]);
        }
        this.position.stickiness = "toNone";
        this.singleCharacters = !!t.singleCharacters;
        this.shallow = !!t.shallow;
        this.ignoreElementEnd = !!t.ignoreElementEnd;
        this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
        this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
        this._visitedParent = this.position.parent;
      }
      _createClass(Qh, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "skip",
        value: function skip(t) {
          var e, n, o, i;
          do {
            o = this.position;
            i = this._visitedParent;
            var _this$next2 = this.next();
            e = _this$next2.done;
            n = _this$next2.value;
          } while (!e && t(n));
          if (!e) {
            this.position = o;
            this._visitedParent = i;
          }
        }
      }, {
        key: "next",
        value: function next() {
          if (this.direction == "forward") {
            return this._next();
          } else {
            return this._previous();
          }
        }
      }, {
        key: "_next",
        value: function _next() {
          var t = this.position;
          var e = this.position.clone();
          var n = this._visitedParent;
          if (n.parent === null && e.offset === n.maxOffset) {
            return {
              done: true
            };
          }
          if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) {
            return {
              done: true
            };
          }
          var o = e.parent;
          var i = Jh(e, o);
          var r = i ? i : Xh(e, o, i);
          if (r instanceof qh) {
            if (!this.shallow) {
              e.path.push(0);
              this._visitedParent = r;
            } else {
              e.offset++;
            }
            this.position = e;
            return $h("elementStart", r, t, e, 1);
          } else if (r instanceof Gh) {
            var _o44;
            if (this.singleCharacters) {
              _o44 = 1;
            } else {
              var _t81 = r.endOffset;
              if (this._boundaryEndParent == n && this.boundaries.end.offset < _t81) {
                _t81 = this.boundaries.end.offset;
              }
              _o44 = _t81 - e.offset;
            }
            var _i44 = e.offset - r.startOffset;
            var _s10 = new Wh(r, _i44, _o44);
            e.offset += _o44;
            this.position = e;
            return $h("text", _s10, t, e, _o44);
          } else {
            e.path.pop();
            e.offset++;
            this.position = e;
            this._visitedParent = n.parent;
            if (this.ignoreElementEnd) {
              return this._next();
            } else {
              return $h("elementEnd", n, t, e);
            }
          }
        }
      }, {
        key: "_previous",
        value: function _previous() {
          var t = this.position;
          var e = this.position.clone();
          var n = this._visitedParent;
          if (n.parent === null && e.offset === 0) {
            return {
              done: true
            };
          }
          if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) {
            return {
              done: true
            };
          }
          var o = e.parent;
          var i = Jh(e, o);
          var r = i ? i : tf(e, o, i);
          if (r instanceof qh) {
            e.offset--;
            if (!this.shallow) {
              e.path.push(r.maxOffset);
              this.position = e;
              this._visitedParent = r;
              if (this.ignoreElementEnd) {
                return this._previous();
              } else {
                return $h("elementEnd", r, t, e);
              }
            } else {
              this.position = e;
              return $h("elementStart", r, t, e, 1);
            }
          } else if (r instanceof Gh) {
            var _o45;
            if (this.singleCharacters) {
              _o45 = 1;
            } else {
              var _t82 = r.startOffset;
              if (this._boundaryStartParent == n && this.boundaries.start.offset > _t82) {
                _t82 = this.boundaries.start.offset;
              }
              _o45 = e.offset - _t82;
            }
            var _i45 = e.offset - r.startOffset;
            var _s11 = new Wh(r, _i45 - _o45, _o45);
            e.offset -= _o45;
            this.position = e;
            return $h("text", _s11, t, e, _o45);
          } else {
            e.path.pop();
            this.position = e;
            this._visitedParent = n.parent;
            return $h("elementStart", n, t, e, 1);
          }
        }
      }]);
      return Qh;
    }();
    function $h(t, e, n, o, i) {
      return {
        done: false,
        value: {
          type: t,
          item: e,
          previousPosition: n,
          nextPosition: o,
          length: i
        }
      };
    }
    var Zh = /*#__PURE__*/function () {
      function Zh(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        _classCallCheck(this, Zh);
        if (!t.is("element") && !t.is("documentFragment")) {
          throw new ss["a"]("model-position-root-invalid", t);
        }
        if (!(e instanceof Array) || e.length === 0) {
          throw new ss["a"]("model-position-path-incorrect-format", t, {
            path: e
          });
        }
        if (t.is("rootElement")) {
          e = e.slice();
        } else {
          e = [].concat(_toConsumableArray(t.getPath()), _toConsumableArray(e));
          t = t.root;
        }
        this.root = t;
        this.path = e;
        this.stickiness = n;
      }
      _createClass(Zh, [{
        key: "compareWith",
        value: function compareWith(t) {
          if (this.root != t.root) {
            return "different";
          }
          var e = Ls(this.path, t.path);
          switch (e) {
            case "same":
              return "same";
            case "prefix":
              return "before";
            case "extension":
              return "after";
            default:
              return this.path[e] < t.path[e] ? "before" : "after";
          }
        }
      }, {
        key: "getLastMatchingPosition",
        value: function getLastMatchingPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          e.startPosition = this;
          var n = new Qh(e);
          n.skip(t);
          return n.position;
        }
      }, {
        key: "getParentPath",
        value: function getParentPath() {
          return this.path.slice(0, -1);
        }
      }, {
        key: "getAncestors",
        value: function getAncestors() {
          var t = this.parent;
          if (t.is("documentFragment")) {
            return [t];
          } else {
            return t.getAncestors({
              includeSelf: true
            });
          }
        }
      }, {
        key: "findAncestor",
        value: function findAncestor(t) {
          var e = this.parent;
          if (e.is("element")) {
            return e.findAncestor(t, {
              includeSelf: true
            });
          }
          return null;
        }
      }, {
        key: "getCommonPath",
        value: function getCommonPath(t) {
          if (this.root != t.root) {
            return [];
          }
          var e = Ls(this.path, t.path);
          var n = typeof e == "string" ? Math.min(this.path.length, t.path.length) : e;
          return this.path.slice(0, n);
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor(t) {
          var e = this.getAncestors();
          var n = t.getAncestors();
          var o = 0;
          while (e[o] == n[o] && e[o]) {
            o++;
          }
          return o === 0 ? null : e[o - 1];
        }
      }, {
        key: "getShiftedBy",
        value: function getShiftedBy(t) {
          var e = this.clone();
          var n = e.offset + t;
          e.offset = n < 0 ? 0 : n;
          return e;
        }
      }, {
        key: "isAfter",
        value: function isAfter(t) {
          return this.compareWith(t) == "after";
        }
      }, {
        key: "isBefore",
        value: function isBefore(t) {
          return this.compareWith(t) == "before";
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.compareWith(t) == "same";
        }
      }, {
        key: "isTouching",
        value: function isTouching(t) {
          var e = null;
          var n = null;
          var o = this.compareWith(t);
          switch (o) {
            case "same":
              return true;
            case "before":
              e = Zh._createAt(this);
              n = Zh._createAt(t);
              break;
            case "after":
              e = Zh._createAt(t);
              n = Zh._createAt(this);
              break;
            default:
              return false;
          }
          var i = e.parent;
          while (e.path.length + n.path.length) {
            if (e.isEqual(n)) {
              return true;
            }
            if (e.path.length > n.path.length) {
              if (e.offset !== i.maxOffset) {
                return false;
              }
              e.path = e.path.slice(0, -1);
              i = i.parent;
              e.offset++;
            } else {
              if (n.offset !== 0) {
                return false;
              }
              n.path = n.path.slice(0, -1);
            }
          }
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "position" || t === "model:position";
        }
      }, {
        key: "hasSameParentAs",
        value: function hasSameParentAs(t) {
          if (this.root !== t.root) {
            return false;
          }
          var e = this.getParentPath();
          var n = t.getParentPath();
          return Ls(e, n) == "same";
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          var e;
          switch (t.type) {
            case "insert":
              e = this._getTransformedByInsertOperation(t);
              break;
            case "move":
            case "remove":
            case "reinsert":
              e = this._getTransformedByMoveOperation(t);
              break;
            case "split":
              e = this._getTransformedBySplitOperation(t);
              break;
            case "merge":
              e = this._getTransformedByMergeOperation(t);
              break;
            default:
              e = Zh._createAt(this);
              break;
          }
          return e;
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = t.movedRange;
          var n = e.containsPosition(this) || e.start.isEqual(this) && this.stickiness == "toNext";
          if (n) {
            return this._getCombined(t.splitPosition, t.moveTargetPosition);
          } else {
            if (t.graveyardPosition) {
              return this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1);
            } else {
              return this._getTransformedByInsertion(t.insertionPosition, 1);
            }
          }
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          var e = t.movedRange;
          var n = e.containsPosition(this) || e.start.isEqual(this);
          var o;
          if (n) {
            o = this._getCombined(t.sourcePosition, t.targetPosition);
            if (t.sourcePosition.isBefore(t.targetPosition)) {
              o = o._getTransformedByDeletion(t.deletionPosition, 1);
            }
          } else if (this.isEqual(t.deletionPosition)) {
            o = Zh._createAt(t.deletionPosition);
          } else {
            o = this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1);
          }
          return o;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = Zh._createAt(this);
          if (this.root != t.root) {
            return n;
          }
          if (Ls(t.getParentPath(), this.getParentPath()) == "same") {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) {
                return null;
              } else {
                n.offset -= e;
              }
            }
          } else if (Ls(t.getParentPath(), this.getParentPath()) == "prefix") {
            var _o46 = t.path.length - 1;
            if (t.offset <= this.path[_o46]) {
              if (t.offset + e > this.path[_o46]) {
                return null;
              } else {
                n.path[_o46] -= e;
              }
            }
          }
          return n;
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = Zh._createAt(this);
          if (this.root != t.root) {
            return n;
          }
          if (Ls(t.getParentPath(), this.getParentPath()) == "same") {
            if (t.offset < this.offset || t.offset == this.offset && this.stickiness != "toPrevious") {
              n.offset += e;
            }
          } else if (Ls(t.getParentPath(), this.getParentPath()) == "prefix") {
            var _o47 = t.path.length - 1;
            if (t.offset <= this.path[_o47]) {
              n.path[_o47] += e;
            }
          }
          return n;
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          e = e._getTransformedByDeletion(t, n);
          if (t.isEqual(e)) {
            return Zh._createAt(this);
          }
          var o = this._getTransformedByDeletion(t, n);
          var i = o === null || t.isEqual(this) && this.stickiness == "toNext" || t.getShiftedBy(n).isEqual(this) && this.stickiness == "toPrevious";
          if (i) {
            return this._getCombined(t, e);
          } else {
            return o._getTransformedByInsertion(e, n);
          }
        }
      }, {
        key: "_getCombined",
        value: function _getCombined(t, e) {
          var n = t.path.length - 1;
          var o = Zh._createAt(e);
          o.stickiness = this.stickiness;
          o.offset = o.offset + this.path[n] - t.offset;
          o.path = [].concat(_toConsumableArray(o.path), _toConsumableArray(this.path.slice(n + 1)));
          return o;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.root, this.path, this.stickiness);
        }
      }, {
        key: "offset",
        get: function get() {
          return this.path[this.path.length - 1];
        },
        set: function set(t) {
          this.path[this.path.length - 1] = t;
        }
      }, {
        key: "parent",
        get: function get() {
          var t = this.root;
          for (var _e84 = 0; _e84 < this.path.length - 1; _e84++) {
            t = t.getChild(t.offsetToIndex(this.path[_e84]));
            if (!t) {
              throw new ss["a"]("model-position-path-incorrect", this, {
                position: this
              });
            }
          }
          if (t.is("$text")) {
            throw new ss["a"]("model-position-path-incorrect", this, {
              position: this
            });
          }
          return t;
        }
      }, {
        key: "index",
        get: function get() {
          return this.parent.offsetToIndex(this.offset);
        }
      }, {
        key: "textNode",
        get: function get() {
          return Jh(this, this.parent);
        }
      }, {
        key: "nodeAfter",
        get: function get() {
          var t = this.parent;
          return Xh(this, t, Jh(this, t));
        }
      }, {
        key: "nodeBefore",
        get: function get() {
          var t = this.parent;
          return tf(this, t, Jh(this, t));
        }
      }, {
        key: "isAtStart",
        get: function get() {
          return this.offset === 0;
        }
      }, {
        key: "isAtEnd",
        get: function get() {
          return this.offset == this.parent.maxOffset;
        }
      }], [{
        key: "_createAt",
        value: function _createAt(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
          if (t instanceof Zh) {
            return new Zh(t.root, t.path, t.stickiness);
          } else {
            var _o48 = t;
            if (e == "end") {
              e = _o48.maxOffset;
            } else if (e == "before") {
              return this._createBefore(_o48, n);
            } else if (e == "after") {
              return this._createAfter(_o48, n);
            } else if (e !== 0 && !e) {
              throw new ss["a"]("model-createpositionat-offset-required", [this, t]);
            }
            if (!_o48.is("element") && !_o48.is("documentFragment")) {
              throw new ss["a"]("model-position-parent-incorrect", [this, t]);
            }
            var _i46 = _o48.getPath();
            _i46.push(e);
            return new this(_o48.root, _i46, n);
          }
        }
      }, {
        key: "_createAfter",
        value: function _createAfter(t, e) {
          if (!t.parent) {
            throw new ss["a"]("model-position-after-root", [this, t], {
              root: t
            });
          }
          return this._createAt(t.parent, t.endOffset, e);
        }
      }, {
        key: "_createBefore",
        value: function _createBefore(t, e) {
          if (!t.parent) {
            throw new ss["a"]("model-position-before-root", t, {
              root: t
            });
          }
          return this._createAt(t.parent, t.startOffset, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (t.root === "$graveyard") {
            var _n77 = new Zh(e.graveyard, t.path);
            _n77.stickiness = t.stickiness;
            return _n77;
          }
          if (!e.getRoot(t.root)) {
            throw new ss["a"]("model-position-fromjson-no-root", e, {
              rootName: t.root
            });
          }
          return new Zh(e.getRoot(t.root), t.path, t.stickiness);
        }
      }]);
      return Zh;
    }();
    function Jh(t, e) {
      var n = e.getChild(e.offsetToIndex(t.offset));
      if (n && n.is("$text") && n.startOffset < t.offset) {
        return n;
      }
      return null;
    }
    function Xh(t, e, n) {
      if (n !== null) {
        return null;
      }
      return e.getChild(e.offsetToIndex(t.offset));
    }
    function tf(t, e, n) {
      if (n !== null) {
        return null;
      }
      return e.getChild(e.offsetToIndex(t.offset) - 1);
    }
    var ef = /*#__PURE__*/function () {
      function ef(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _classCallCheck(this, ef);
        this.start = Zh._createAt(t);
        this.end = e ? Zh._createAt(e) : Zh._createAt(t);
        this.start.stickiness = this.isCollapsed ? "toNone" : "toNext";
        this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
      }
      _createClass(ef, [{
        key: Symbol.iterator,
        value: /*#__PURE__*/_regeneratorRuntime().mark(function value() {
          return _regeneratorRuntime().wrap(function value$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.delegateYield(new Qh({
                  boundaries: this,
                  ignoreElementEnd: true
                }), "t0", 1);
              case 1:
              case "end":
                return _context13.stop();
            }
          }, value, this);
        })
      }, {
        key: "containsPosition",
        value: function containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end);
        }
      }, {
        key: "containsRange",
        value: function containsRange(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          if (t.isCollapsed) {
            e = false;
          }
          var n = this.containsPosition(t.start) || e && this.start.isEqual(t.start);
          var o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
          return n && o;
        }
      }, {
        key: "containsItem",
        value: function containsItem(t) {
          var e = Zh._createBefore(t);
          return this.containsPosition(e) || this.start.isEqual(e);
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "range" || t === "model:range";
        }
      }, {
        key: "isEqual",
        value: function isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end);
        }
      }, {
        key: "isIntersecting",
        value: function isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start);
        }
      }, {
        key: "getDifference",
        value: function getDifference(t) {
          var e = [];
          if (this.isIntersecting(t)) {
            if (this.containsPosition(t.start)) {
              e.push(new ef(this.start, t.start));
            }
            if (this.containsPosition(t.end)) {
              e.push(new ef(t.end, this.end));
            }
          } else {
            e.push(new ef(this.start, this.end));
          }
          return e;
        }
      }, {
        key: "getIntersection",
        value: function getIntersection(t) {
          if (this.isIntersecting(t)) {
            var _e85 = this.start;
            var _n78 = this.end;
            if (this.containsPosition(t.start)) {
              _e85 = t.start;
            }
            if (this.containsPosition(t.end)) {
              _n78 = t.end;
            }
            return new ef(_e85, _n78);
          }
          return null;
        }
      }, {
        key: "getJoined",
        value: function getJoined(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var n = this.isIntersecting(t);
          if (!n) {
            if (this.start.isBefore(t.start)) {
              n = e ? this.end.isTouching(t.start) : this.end.isEqual(t.start);
            } else {
              n = e ? t.end.isTouching(this.start) : t.end.isEqual(this.start);
            }
          }
          if (!n) {
            return null;
          }
          var o = this.start;
          var i = this.end;
          if (t.start.isBefore(o)) {
            o = t.start;
          }
          if (t.end.isAfter(i)) {
            i = t.end;
          }
          return new ef(o, i);
        }
      }, {
        key: "getMinimalFlatRanges",
        value: function getMinimalFlatRanges() {
          var t = [];
          var e = this.start.getCommonPath(this.end).length;
          var n = Zh._createAt(this.start);
          var o = n.parent;
          while (n.path.length > e + 1) {
            var _e86 = o.maxOffset - n.offset;
            if (_e86 !== 0) {
              t.push(new ef(n, n.getShiftedBy(_e86)));
            }
            n.path = n.path.slice(0, -1);
            n.offset++;
            o = o.parent;
          }
          while (n.path.length <= this.end.path.length) {
            var _e87 = this.end.path[n.path.length - 1];
            var _o49 = _e87 - n.offset;
            if (_o49 !== 0) {
              t.push(new ef(n, n.getShiftedBy(_o49)));
            }
            n.offset = _e87;
            n.path.push(0);
          }
          return t;
        }
      }, {
        key: "getWalker",
        value: function getWalker() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          t.boundaries = this;
          return new Qh(t);
        }
      }, {
        key: "getItems",
        value: function getItems() {
          var _this45 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
            var e, _iterator102, _step102, _t83;
            return _regeneratorRuntime().wrap(function _callee5$(_context14) {
              while (1) switch (_context14.prev = _context14.next) {
                case 0:
                  t.boundaries = _this45;
                  t.ignoreElementEnd = true;
                  e = new Qh(t);
                  _iterator102 = _createForOfIteratorHelper(e);
                  _context14.prev = 4;
                  _iterator102.s();
                case 6:
                  if ((_step102 = _iterator102.n()).done) {
                    _context14.next = 12;
                    break;
                  }
                  _t83 = _step102.value;
                  _context14.next = 10;
                  return _t83.item;
                case 10:
                  _context14.next = 6;
                  break;
                case 12:
                  _context14.next = 17;
                  break;
                case 14:
                  _context14.prev = 14;
                  _context14.t0 = _context14["catch"](4);
                  _iterator102.e(_context14.t0);
                case 17:
                  _context14.prev = 17;
                  _iterator102.f();
                  return _context14.finish(17);
                case 20:
                case "end":
                  return _context14.stop();
              }
            }, _callee5, null, [[4, 14, 17, 20]]);
          })();
        }
      }, {
        key: "getPositions",
        value: function getPositions() {
          var _this46 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var e, _iterator103, _step103, _t84;
            return _regeneratorRuntime().wrap(function _callee6$(_context15) {
              while (1) switch (_context15.prev = _context15.next) {
                case 0:
                  t.boundaries = _this46;
                  e = new Qh(t);
                  _context15.next = 4;
                  return e.position;
                case 4:
                  _iterator103 = _createForOfIteratorHelper(e);
                  _context15.prev = 5;
                  _iterator103.s();
                case 7:
                  if ((_step103 = _iterator103.n()).done) {
                    _context15.next = 13;
                    break;
                  }
                  _t84 = _step103.value;
                  _context15.next = 11;
                  return _t84.nextPosition;
                case 11:
                  _context15.next = 7;
                  break;
                case 13:
                  _context15.next = 18;
                  break;
                case 15:
                  _context15.prev = 15;
                  _context15.t0 = _context15["catch"](5);
                  _iterator103.e(_context15.t0);
                case 18:
                  _context15.prev = 18;
                  _iterator103.f();
                  return _context15.finish(18);
                case 21:
                case "end":
                  return _context15.stop();
              }
            }, _callee6, null, [[5, 15, 18, 21]]);
          })();
        }
      }, {
        key: "getTransformedByOperation",
        value: function getTransformedByOperation(t) {
          switch (t.type) {
            case "insert":
              return this._getTransformedByInsertOperation(t);
            case "move":
            case "remove":
            case "reinsert":
              return this._getTransformedByMoveOperation(t);
            case "split":
              return [this._getTransformedBySplitOperation(t)];
            case "merge":
              return [this._getTransformedByMergeOperation(t)];
          }
          return [new ef(this.start, this.end)];
        }
      }, {
        key: "getTransformedByOperations",
        value: function getTransformedByOperations(t) {
          var e = [new ef(this.start, this.end)];
          var _iterator104 = _createForOfIteratorHelper(t),
            _step104;
          try {
            for (_iterator104.s(); !(_step104 = _iterator104.n()).done;) {
              var _n80 = _step104.value;
              for (var _t87 = 0; _t87 < e.length; _t87++) {
                var _o51 = e[_t87].getTransformedByOperation(_n80);
                e.splice.apply(e, [_t87, 1].concat(_toConsumableArray(_o51)));
                _t87 += _o51.length - 1;
              }
            }
          } catch (err) {
            _iterator104.e(err);
          } finally {
            _iterator104.f();
          }
          for (var _t85 = 0; _t85 < e.length; _t85++) {
            var _n79 = e[_t85];
            for (var _o50 = _t85 + 1; _o50 < e.length; _o50++) {
              var _t86 = e[_o50];
              if (_n79.containsRange(_t86) || _t86.containsRange(_n79) || _n79.isEqual(_t86)) {
                e.splice(_o50, 1);
              }
            }
          }
          return e;
        }
      }, {
        key: "getCommonAncestor",
        value: function getCommonAncestor() {
          return this.start.getCommonAncestor(this.end);
        }
      }, {
        key: "getContainedElement",
        value: function getContainedElement() {
          if (this.isCollapsed) {
            return null;
          }
          var t = this.start.nodeAfter;
          var e = this.end.nodeBefore;
          if (t && t.is("element") && t === e) {
            return t;
          }
          return null;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return {
            start: this.start.toJSON(),
            end: this.end.toJSON()
          };
        }
      }, {
        key: "clone",
        value: function clone() {
          return new this.constructor(this.start, this.end);
        }
      }, {
        key: "_getTransformedByInsertOperation",
        value: function _getTransformedByInsertOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          return this._getTransformedByInsertion(t.position, t.howMany, e);
        }
      }, {
        key: "_getTransformedByMoveOperation",
        value: function _getTransformedByMoveOperation(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var n = t.sourcePosition;
          var o = t.howMany;
          var i = t.targetPosition;
          return this._getTransformedByMove(n, i, o, e);
        }
      }, {
        key: "_getTransformedBySplitOperation",
        value: function _getTransformedBySplitOperation(t) {
          var e = this.start._getTransformedBySplitOperation(t);
          var n = this.end._getTransformedBySplitOperation(t);
          if (this.end.isEqual(t.insertionPosition)) {
            n = this.end.getShiftedBy(1);
          }
          if (e.root != n.root) {
            n = this.end.getShiftedBy(-1);
          }
          return new ef(e, n);
        }
      }, {
        key: "_getTransformedByMergeOperation",
        value: function _getTransformedByMergeOperation(t) {
          if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) {
            return new ef(this.start);
          }
          var e = this.start._getTransformedByMergeOperation(t);
          var n = this.end._getTransformedByMergeOperation(t);
          if (e.root != n.root) {
            n = this.end.getShiftedBy(-1);
          }
          if (e.isAfter(n)) {
            if (t.sourcePosition.isBefore(t.targetPosition)) {
              e = Zh._createAt(n);
              e.offset = 0;
            } else {
              if (!t.deletionPosition.isEqual(e)) {
                n = t.deletionPosition;
              }
              e = t.targetPosition;
            }
            return new ef(e, n);
          }
          return new ef(e, n);
        }
      }, {
        key: "_getTransformedByInsertion",
        value: function _getTransformedByInsertion(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          if (n && this.containsPosition(t)) {
            return [new ef(this.start, t), new ef(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))];
          } else {
            var _n81 = new ef(this.start, this.end);
            _n81.start = _n81.start._getTransformedByInsertion(t, e);
            _n81.end = _n81.end._getTransformedByInsertion(t, e);
            return [_n81];
          }
        }
      }, {
        key: "_getTransformedByMove",
        value: function _getTransformedByMove(t, e, n) {
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          if (this.isCollapsed) {
            var _o52 = this.start._getTransformedByMove(t, e, n);
            return [new ef(_o52)];
          }
          var i = ef._createFromPositionAndShift(t, n);
          var r = e._getTransformedByDeletion(t, n);
          if (this.containsPosition(e) && !o) {
            if (i.containsPosition(this.start) || i.containsPosition(this.end)) {
              var _o53 = this.start._getTransformedByMove(t, e, n);
              var _i47 = this.end._getTransformedByMove(t, e, n);
              return [new ef(_o53, _i47)];
            }
          }
          var s;
          var a = this.getDifference(i);
          var c = null;
          var l = this.getIntersection(i);
          if (a.length == 1) {
            c = new ef(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n));
          } else if (a.length == 2) {
            c = new ef(this.start, this.end._getTransformedByDeletion(t, n));
          }
          if (c) {
            s = c._getTransformedByInsertion(r, n, l !== null || o);
          } else {
            s = [];
          }
          if (l) {
            var _t88 = new ef(l.start._getCombined(i.start, r), l.end._getCombined(i.start, r));
            if (s.length == 2) {
              s.splice(1, 0, _t88);
            } else {
              s.push(_t88);
            }
          }
          return s;
        }
      }, {
        key: "_getTransformedByDeletion",
        value: function _getTransformedByDeletion(t, e) {
          var n = this.start._getTransformedByDeletion(t, e);
          var o = this.end._getTransformedByDeletion(t, e);
          if (n == null && o == null) {
            return null;
          }
          if (n == null) {
            n = t;
          }
          if (o == null) {
            o = t;
          }
          return new ef(n, o);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this.start.isEqual(this.end);
        }
      }, {
        key: "isFlat",
        get: function get() {
          var t = this.start.getParentPath();
          var e = this.end.getParentPath();
          return Ls(t, e) == "same";
        }
      }, {
        key: "root",
        get: function get() {
          return this.start.root;
        }
      }], [{
        key: "_createFromPositionAndShift",
        value: function _createFromPositionAndShift(t, e) {
          var n = t;
          var o = t.getShiftedBy(e);
          return e > 0 ? new this(n, o) : new this(o, n);
        }
      }, {
        key: "_createIn",
        value: function _createIn(t) {
          return new this(Zh._createAt(t, 0), Zh._createAt(t, t.maxOffset));
        }
      }, {
        key: "_createOn",
        value: function _createOn(t) {
          return this._createFromPositionAndShift(Zh._createBefore(t), t.offsetSize);
        }
      }, {
        key: "_createFromRanges",
        value: function _createFromRanges(t) {
          if (t.length === 0) {
            throw new ss["a"]("range-create-from-ranges-empty-array", null);
          } else if (t.length == 1) {
            return t[0].clone();
          }
          var e = t[0];
          t.sort(function (t, e) {
            return t.start.isAfter(e.start) ? 1 : -1;
          });
          var n = t.indexOf(e);
          var o = new this(e.start, e.end);
          if (n > 0) {
            for (var _e88 = n - 1; true; _e88++) {
              if (t[_e88].end.isEqual(o.start)) {
                o.start = Zh._createAt(t[_e88].start);
              } else {
                break;
              }
            }
          }
          for (var _e89 = n + 1; _e89 < t.length; _e89++) {
            if (t[_e89].start.isEqual(o.end)) {
              o.end = Zh._createAt(t[_e89].end);
            } else {
              break;
            }
          }
          return o;
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new this(Zh.fromJSON(t.start, e), Zh.fromJSON(t.end, e));
        }
      }]);
      return ef;
    }();
    var nf = /*#__PURE__*/function () {
      function nf() {
        var _this47 = this;
        _classCallCheck(this, nf);
        this._modelToViewMapping = new WeakMap();
        this._viewToModelMapping = new WeakMap();
        this._viewToModelLengthCallbacks = new Map();
        this._markerNameToElements = new Map();
        this._elementToMarkerNames = new Map();
        this._unboundMarkerNames = new Set();
        this.on("modelToViewPosition", function (t, e) {
          if (e.viewPosition) {
            return;
          }
          var n = _this47._modelToViewMapping.get(e.modelPosition.parent);
          e.viewPosition = _this47.findPositionIn(n, e.modelPosition.offset);
        }, {
          priority: "low"
        });
        this.on("viewToModelPosition", function (t, e) {
          if (e.modelPosition) {
            return;
          }
          var n = _this47.findMappedViewAncestor(e.viewPosition);
          var o = _this47._viewToModelMapping.get(n);
          var i = _this47._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);
          e.modelPosition = Zh._createAt(o, i);
        }, {
          priority: "low"
        });
      }
      _createClass(nf, [{
        key: "bindElements",
        value: function bindElements(t, e) {
          this._modelToViewMapping.set(t, e);
          this._viewToModelMapping.set(e, t);
        }
      }, {
        key: "unbindViewElement",
        value: function unbindViewElement(t) {
          var e = this.toModelElement(t);
          this._viewToModelMapping.delete(t);
          if (this._elementToMarkerNames.has(t)) {
            var _iterator105 = _createForOfIteratorHelper(this._elementToMarkerNames.get(t)),
              _step105;
            try {
              for (_iterator105.s(); !(_step105 = _iterator105.n()).done;) {
                var _e90 = _step105.value;
                this._unboundMarkerNames.add(_e90);
              }
            } catch (err) {
              _iterator105.e(err);
            } finally {
              _iterator105.f();
            }
          }
          if (this._modelToViewMapping.get(e) == t) {
            this._modelToViewMapping.delete(e);
          }
        }
      }, {
        key: "unbindModelElement",
        value: function unbindModelElement(t) {
          var e = this.toViewElement(t);
          this._modelToViewMapping.delete(t);
          if (this._viewToModelMapping.get(e) == t) {
            this._viewToModelMapping.delete(e);
          }
        }
      }, {
        key: "bindElementToMarker",
        value: function bindElementToMarker(t, e) {
          var n = this._markerNameToElements.get(e) || new Set();
          n.add(t);
          var o = this._elementToMarkerNames.get(t) || new Set();
          o.add(e);
          this._markerNameToElements.set(e, n);
          this._elementToMarkerNames.set(t, o);
        }
      }, {
        key: "unbindElementFromMarkerName",
        value: function unbindElementFromMarkerName(t, e) {
          var n = this._markerNameToElements.get(e);
          if (n) {
            n.delete(t);
            if (n.size == 0) {
              this._markerNameToElements.delete(e);
            }
          }
          var o = this._elementToMarkerNames.get(t);
          if (o) {
            o.delete(e);
            if (o.size == 0) {
              this._elementToMarkerNames.delete(t);
            }
          }
        }
      }, {
        key: "flushUnboundMarkerNames",
        value: function flushUnboundMarkerNames() {
          var t = Array.from(this._unboundMarkerNames);
          this._unboundMarkerNames.clear();
          return t;
        }
      }, {
        key: "clearBindings",
        value: function clearBindings() {
          this._modelToViewMapping = new WeakMap();
          this._viewToModelMapping = new WeakMap();
          this._markerNameToElements = new Map();
          this._elementToMarkerNames = new Map();
          this._unboundMarkerNames = new Set();
        }
      }, {
        key: "toModelElement",
        value: function toModelElement(t) {
          return this._viewToModelMapping.get(t);
        }
      }, {
        key: "toViewElement",
        value: function toViewElement(t) {
          return this._modelToViewMapping.get(t);
        }
      }, {
        key: "toModelRange",
        value: function toModelRange(t) {
          return new ef(this.toModelPosition(t.start), this.toModelPosition(t.end));
        }
      }, {
        key: "toViewRange",
        value: function toViewRange(t) {
          return new fl(this.toViewPosition(t.start), this.toViewPosition(t.end));
        }
      }, {
        key: "toModelPosition",
        value: function toModelPosition(t) {
          var e = {
            viewPosition: t,
            mapper: this
          };
          this.fire("viewToModelPosition", e);
          return e.modelPosition;
        }
      }, {
        key: "toViewPosition",
        value: function toViewPosition(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            isPhantom: false
          };
          var n = {
            modelPosition: t,
            mapper: this,
            isPhantom: e.isPhantom
          };
          this.fire("modelToViewPosition", n);
          return n.viewPosition;
        }
      }, {
        key: "markerNameToElements",
        value: function markerNameToElements(t) {
          var e = this._markerNameToElements.get(t);
          if (!e) {
            return null;
          }
          var n = new Set();
          var _iterator106 = _createForOfIteratorHelper(e),
            _step106;
          try {
            for (_iterator106.s(); !(_step106 = _iterator106.n()).done;) {
              var _t89 = _step106.value;
              if (_t89.is("attributeElement")) {
                var _iterator107 = _createForOfIteratorHelper(_t89.getElementsWithSameId()),
                  _step107;
                try {
                  for (_iterator107.s(); !(_step107 = _iterator107.n()).done;) {
                    var _e91 = _step107.value;
                    n.add(_e91);
                  }
                } catch (err) {
                  _iterator107.e(err);
                } finally {
                  _iterator107.f();
                }
              } else {
                n.add(_t89);
              }
            }
          } catch (err) {
            _iterator106.e(err);
          } finally {
            _iterator106.f();
          }
          return n;
        }
      }, {
        key: "registerViewToModelLength",
        value: function registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e);
        }
      }, {
        key: "findMappedViewAncestor",
        value: function findMappedViewAncestor(t) {
          var e = t.parent;
          while (!this._viewToModelMapping.has(e)) {
            e = e.parent;
          }
          return e;
        }
      }, {
        key: "_toModelOffset",
        value: function _toModelOffset(t, e, n) {
          if (n != t) {
            var _o54 = this._toModelOffset(t.parent, t.index, n);
            var _i48 = this._toModelOffset(t, e, t);
            return _o54 + _i48;
          }
          if (t.is("$text")) {
            return e;
          }
          var o = 0;
          for (var _n82 = 0; _n82 < e; _n82++) {
            o += this.getModelLength(t.getChild(_n82));
          }
          return o;
        }
      }, {
        key: "getModelLength",
        value: function getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            var _e92 = this._viewToModelLengthCallbacks.get(t.name);
            return _e92(t);
          } else if (this._viewToModelMapping.has(t)) {
            return 1;
          } else if (t.is("$text")) {
            return t.data.length;
          } else if (t.is("uiElement")) {
            return 0;
          } else {
            var _e93 = 0;
            var _iterator108 = _createForOfIteratorHelper(t.getChildren()),
              _step108;
            try {
              for (_iterator108.s(); !(_step108 = _iterator108.n()).done;) {
                var _n83 = _step108.value;
                _e93 += this.getModelLength(_n83);
              }
            } catch (err) {
              _iterator108.e(err);
            } finally {
              _iterator108.f();
            }
            return _e93;
          }
        }
      }, {
        key: "findPositionIn",
        value: function findPositionIn(t, e) {
          var n;
          var o = 0;
          var i = 0;
          var r = 0;
          if (t.is("$text")) {
            return new hl(t, e);
          }
          while (i < e) {
            n = t.getChild(r);
            o = this.getModelLength(n);
            i += o;
            r++;
          }
          if (i == e) {
            return this._moveViewPositionToTextNode(new hl(t, r));
          } else {
            return this.findPositionIn(n, e - (i - o));
          }
        }
      }, {
        key: "_moveViewPositionToTextNode",
        value: function _moveViewPositionToTextNode(t) {
          var e = t.nodeBefore;
          var n = t.nodeAfter;
          if (e instanceof Vs) {
            return new hl(e, e.data.length);
          } else if (n instanceof Vs) {
            return new hl(n, 0);
          }
          return t;
        }
      }]);
      return nf;
    }();
    _s(nf, ds);
    var of = /*#__PURE__*/function () {
      function of() {
        _classCallCheck(this, of);
        this._consumable = new Map();
        this._textProxyRegistry = new Map();
      }
      _createClass(of, [{
        key: "add",
        value: function add(t, e) {
          e = rf(e);
          if (t instanceof Wh) {
            t = this._getSymbolForTextProxy(t);
          }
          if (!this._consumable.has(t)) {
            this._consumable.set(t, new Map());
          }
          this._consumable.get(t).set(e, true);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          e = rf(e);
          if (t instanceof Wh) {
            t = this._getSymbolForTextProxy(t);
          }
          if (this.test(t, e)) {
            this._consumable.get(t).set(e, false);
            return true;
          } else {
            return false;
          }
        }
      }, {
        key: "test",
        value: function test(t, e) {
          e = rf(e);
          if (t instanceof Wh) {
            t = this._getSymbolForTextProxy(t);
          }
          var n = this._consumable.get(t);
          if (n === undefined) {
            return null;
          }
          var o = n.get(e);
          if (o === undefined) {
            return null;
          }
          return o;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          e = rf(e);
          if (t instanceof Wh) {
            t = this._getSymbolForTextProxy(t);
          }
          var n = this.test(t, e);
          if (n === false) {
            this._consumable.get(t).set(e, true);
            return true;
          } else if (n === true) {
            return false;
          }
          return null;
        }
      }, {
        key: "_getSymbolForTextProxy",
        value: function _getSymbolForTextProxy(t) {
          var e = null;
          var n = this._textProxyRegistry.get(t.startOffset);
          if (n) {
            var _o55 = n.get(t.endOffset);
            if (_o55) {
              e = _o55.get(t.parent);
            }
          }
          if (!e) {
            e = this._addSymbolForTextProxy(t.startOffset, t.endOffset, t.parent);
          }
          return e;
        }
      }, {
        key: "_addSymbolForTextProxy",
        value: function _addSymbolForTextProxy(t, e, n) {
          var o = Symbol("textProxySymbol");
          var i, r;
          i = this._textProxyRegistry.get(t);
          if (!i) {
            i = new Map();
            this._textProxyRegistry.set(t, i);
          }
          r = i.get(e);
          if (!r) {
            r = new Map();
            i.set(e, r);
          }
          r.set(n, o);
          return o;
        }
      }]);
      return of;
    }();
    function rf(t) {
      var e = t.split(":");
      return e.length > 1 ? e[0] + ":" + e[1] : e[0];
    }
    var sf = /*#__PURE__*/function () {
      function sf(t) {
        _classCallCheck(this, sf);
        this.conversionApi = Object.assign({
          dispatcher: this
        }, t);
        this._reconversionEventsMapping = new Map();
      }
      _createClass(sf, [{
        key: "convertChanges",
        value: function convertChanges(t, e, n) {
          var _iterator109 = _createForOfIteratorHelper(t.getMarkersToRemove()),
            _step109;
          try {
            for (_iterator109.s(); !(_step109 = _iterator109.n()).done;) {
              var _e94 = _step109.value;
              this.convertMarkerRemove(_e94.name, _e94.range, n);
            }
          } catch (err) {
            _iterator109.e(err);
          } finally {
            _iterator109.f();
          }
          var o = this._mapChangesWithAutomaticReconversion(t);
          var _iterator110 = _createForOfIteratorHelper(o),
            _step110;
          try {
            for (_iterator110.s(); !(_step110 = _iterator110.n()).done;) {
              var _t90 = _step110.value;
              if (_t90.type === "insert") {
                this.convertInsert(ef._createFromPositionAndShift(_t90.position, _t90.length), n);
              } else if (_t90.type === "remove") {
                this.convertRemove(_t90.position, _t90.length, _t90.name, n);
              } else if (_t90.type === "reconvert") {
                this.reconvertElement(_t90.element, n);
              } else {
                this.convertAttribute(_t90.range, _t90.attributeKey, _t90.attributeOldValue, _t90.attributeNewValue, n);
              }
            }
          } catch (err) {
            _iterator110.e(err);
          } finally {
            _iterator110.f();
          }
          var _iterator111 = _createForOfIteratorHelper(this.conversionApi.mapper.flushUnboundMarkerNames()),
            _step111;
          try {
            for (_iterator111.s(); !(_step111 = _iterator111.n()).done;) {
              var _t91 = _step111.value;
              var _o56 = e.get(_t91).getRange();
              this.convertMarkerRemove(_t91, _o56, n);
              this.convertMarkerAdd(_t91, _o56, n);
            }
          } catch (err) {
            _iterator111.e(err);
          } finally {
            _iterator111.f();
          }
          var _iterator112 = _createForOfIteratorHelper(t.getMarkersToAdd()),
            _step112;
          try {
            for (_iterator112.s(); !(_step112 = _iterator112.n()).done;) {
              var _e95 = _step112.value;
              this.convertMarkerAdd(_e95.name, _e95.range, n);
            }
          } catch (err) {
            _iterator112.e(err);
          } finally {
            _iterator112.f();
          }
        }
      }, {
        key: "convertInsert",
        value: function convertInsert(t, e) {
          this.conversionApi.writer = e;
          this.conversionApi.consumable = this._createInsertConsumable(t);
          var _iterator113 = _createForOfIteratorHelper(Array.from(t).map(lf)),
            _step113;
          try {
            for (_iterator113.s(); !(_step113 = _iterator113.n()).done;) {
              var _e96 = _step113.value;
              this._convertInsertWithAttributes(_e96);
            }
          } catch (err) {
            _iterator113.e(err);
          } finally {
            _iterator113.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "convertRemove",
        value: function convertRemove(t, e, n, o) {
          this.conversionApi.writer = o;
          this.fire("remove:" + n, {
            position: t,
            length: e
          }, this.conversionApi);
          this._clearConversionApi();
        }
      }, {
        key: "convertAttribute",
        value: function convertAttribute(t, e, n, o, i) {
          this.conversionApi.writer = i;
          this.conversionApi.consumable = this._createConsumableForRange(t, "attribute:".concat(e));
          var _iterator114 = _createForOfIteratorHelper(t),
            _step114;
          try {
            for (_iterator114.s(); !(_step114 = _iterator114.n()).done;) {
              var _i49 = _step114.value;
              var _t92 = _i49.item;
              var _r14 = ef._createFromPositionAndShift(_i49.previousPosition, _i49.length);
              var _s12 = {
                item: _t92,
                range: _r14,
                attributeKey: e,
                attributeOldValue: n,
                attributeNewValue: o
              };
              this._testAndFire("attribute:".concat(e), _s12);
            }
          } catch (err) {
            _iterator114.e(err);
          } finally {
            _iterator114.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "reconvertElement",
        value: function reconvertElement(t, e) {
          var n = ef._createOn(t);
          this.conversionApi.writer = e;
          this.conversionApi.consumable = this._createInsertConsumable(n);
          var o = this.conversionApi.mapper;
          var i = o.toViewElement(t);
          e.remove(i);
          this._convertInsertWithAttributes({
            item: t,
            range: n
          });
          var r = o.toViewElement(t);
          var _iterator115 = _createForOfIteratorHelper(ef._createIn(t)),
            _step115;
          try {
            for (_iterator115.s(); !(_step115 = _iterator115.n()).done;) {
              var _n84 = _step115.value;
              var _t93 = _n84.item;
              var _i50 = df(_t93, o);
              if (_i50) {
                if (_i50.root !== r.root) {
                  e.move(e.createRangeOn(_i50), o.toViewPosition(Zh._createBefore(_t93)));
                }
              } else {
                this._convertInsertWithAttributes(lf(_n84));
              }
            }
          } catch (err) {
            _iterator115.e(err);
          } finally {
            _iterator115.f();
          }
          o.unbindViewElement(i);
          this._clearConversionApi();
        }
      }, {
        key: "convertSelection",
        value: function convertSelection(t, e, n) {
          var o = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
          this.conversionApi.writer = n;
          this.conversionApi.consumable = this._createSelectionConsumable(t, o);
          this.fire("selection", {
            selection: t
          }, this.conversionApi);
          if (!t.isCollapsed) {
            return;
          }
          for (var _i51 = 0, _o57 = o; _i51 < _o57.length; _i51++) {
            var _e97 = _o57[_i51];
            var _n85 = _e97.getRange();
            if (!af(t.getFirstPosition(), _e97, this.conversionApi.mapper)) {
              continue;
            }
            var _o58 = {
              item: t,
              markerName: _e97.name,
              markerRange: _n85
            };
            if (this.conversionApi.consumable.test(t, "addMarker:" + _e97.name)) {
              this.fire("addMarker:" + _e97.name, _o58, this.conversionApi);
            }
          }
          var _iterator116 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step116;
          try {
            for (_iterator116.s(); !(_step116 = _iterator116.n()).done;) {
              var _e98 = _step116.value;
              var _n86 = {
                item: t,
                range: t.getFirstRange(),
                attributeKey: _e98,
                attributeOldValue: null,
                attributeNewValue: t.getAttribute(_e98)
              };
              if (this.conversionApi.consumable.test(t, "attribute:" + _n86.attributeKey)) {
                this.fire("attribute:" + _n86.attributeKey + ":$text", _n86, this.conversionApi);
              }
            }
          } catch (err) {
            _iterator116.e(err);
          } finally {
            _iterator116.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "convertMarkerAdd",
        value: function convertMarkerAdd(t, e, n) {
          if (!e.root.document || e.root.rootName == "$graveyard") {
            return;
          }
          this.conversionApi.writer = n;
          var o = "addMarker:" + t;
          var i = new of();
          i.add(e, o);
          this.conversionApi.consumable = i;
          this.fire(o, {
            markerName: t,
            markerRange: e
          }, this.conversionApi);
          if (!i.test(e, o)) {
            return;
          }
          this.conversionApi.consumable = this._createConsumableForRange(e, o);
          var _iterator117 = _createForOfIteratorHelper(e.getItems()),
            _step117;
          try {
            for (_iterator117.s(); !(_step117 = _iterator117.n()).done;) {
              var _n87 = _step117.value;
              if (!this.conversionApi.consumable.test(_n87, o)) {
                continue;
              }
              var _i52 = {
                item: _n87,
                range: ef._createOn(_n87),
                markerName: t,
                markerRange: e
              };
              this.fire(o, _i52, this.conversionApi);
            }
          } catch (err) {
            _iterator117.e(err);
          } finally {
            _iterator117.f();
          }
          this._clearConversionApi();
        }
      }, {
        key: "convertMarkerRemove",
        value: function convertMarkerRemove(t, e, n) {
          if (!e.root.document || e.root.rootName == "$graveyard") {
            return;
          }
          this.conversionApi.writer = n;
          this.fire("removeMarker:" + t, {
            markerName: t,
            markerRange: e
          }, this.conversionApi);
          this._clearConversionApi();
        }
      }, {
        key: "_mapReconversionTriggerEvent",
        value: function _mapReconversionTriggerEvent(t, e) {
          this._reconversionEventsMapping.set(e, t);
        }
      }, {
        key: "_createInsertConsumable",
        value: function _createInsertConsumable(t) {
          var e = new of();
          var _iterator118 = _createForOfIteratorHelper(t),
            _step118;
          try {
            for (_iterator118.s(); !(_step118 = _iterator118.n()).done;) {
              var _n88 = _step118.value;
              var _t94 = _n88.item;
              e.add(_t94, "insert");
              var _iterator119 = _createForOfIteratorHelper(_t94.getAttributeKeys()),
                _step119;
              try {
                for (_iterator119.s(); !(_step119 = _iterator119.n()).done;) {
                  var _n89 = _step119.value;
                  e.add(_t94, "attribute:" + _n89);
                }
              } catch (err) {
                _iterator119.e(err);
              } finally {
                _iterator119.f();
              }
            }
          } catch (err) {
            _iterator118.e(err);
          } finally {
            _iterator118.f();
          }
          return e;
        }
      }, {
        key: "_createConsumableForRange",
        value: function _createConsumableForRange(t, e) {
          var n = new of();
          var _iterator120 = _createForOfIteratorHelper(t.getItems()),
            _step120;
          try {
            for (_iterator120.s(); !(_step120 = _iterator120.n()).done;) {
              var _o59 = _step120.value;
              n.add(_o59, e);
            }
          } catch (err) {
            _iterator120.e(err);
          } finally {
            _iterator120.f();
          }
          return n;
        }
      }, {
        key: "_createSelectionConsumable",
        value: function _createSelectionConsumable(t, e) {
          var n = new of();
          n.add(t, "selection");
          var _iterator121 = _createForOfIteratorHelper(e),
            _step121;
          try {
            for (_iterator121.s(); !(_step121 = _iterator121.n()).done;) {
              var _o60 = _step121.value;
              n.add(t, "addMarker:" + _o60.name);
            }
          } catch (err) {
            _iterator121.e(err);
          } finally {
            _iterator121.f();
          }
          var _iterator122 = _createForOfIteratorHelper(t.getAttributeKeys()),
            _step122;
          try {
            for (_iterator122.s(); !(_step122 = _iterator122.n()).done;) {
              var _e99 = _step122.value;
              n.add(t, "attribute:" + _e99);
            }
          } catch (err) {
            _iterator122.e(err);
          } finally {
            _iterator122.f();
          }
          return n;
        }
      }, {
        key: "_testAndFire",
        value: function _testAndFire(t, e) {
          if (!this.conversionApi.consumable.test(e.item, t)) {
            return;
          }
          this.fire(cf(t, e), e, this.conversionApi);
        }
      }, {
        key: "_clearConversionApi",
        value: function _clearConversionApi() {
          delete this.conversionApi.writer;
          delete this.conversionApi.consumable;
        }
      }, {
        key: "_convertInsertWithAttributes",
        value: function _convertInsertWithAttributes(t) {
          this._testAndFire("insert", t);
          var _iterator123 = _createForOfIteratorHelper(t.item.getAttributeKeys()),
            _step123;
          try {
            for (_iterator123.s(); !(_step123 = _iterator123.n()).done;) {
              var _e100 = _step123.value;
              t.attributeKey = _e100;
              t.attributeOldValue = null;
              t.attributeNewValue = t.item.getAttribute(_e100);
              this._testAndFire("attribute:".concat(_e100), t);
            }
          } catch (err) {
            _iterator123.e(err);
          } finally {
            _iterator123.f();
          }
        }
      }, {
        key: "_mapChangesWithAutomaticReconversion",
        value: function _mapChangesWithAutomaticReconversion(t) {
          var e = new Set();
          var n = [];
          var _iterator124 = _createForOfIteratorHelper(t.getChanges()),
            _step124;
          try {
            for (_iterator124.s(); !(_step124 = _iterator124.n()).done;) {
              var _o61 = _step124.value;
              var _t95 = _o61.position || _o61.range.start;
              var _i53 = _t95.parent;
              var _r15 = Jh(_t95, _i53);
              if (_r15) {
                n.push(_o61);
                continue;
              }
              var _s13 = _o61.type === "attribute" ? Xh(_t95, _i53, null) : _i53;
              if (_s13.is("$text")) {
                n.push(_o61);
                continue;
              }
              var _a8 = void 0;
              if (_o61.type === "attribute") {
                _a8 = "attribute:".concat(_o61.attributeKey, ":").concat(_s13.name);
              } else {
                _a8 = "".concat(_o61.type, ":").concat(_o61.name);
              }
              if (this._isReconvertTriggerEvent(_a8, _s13.name)) {
                if (e.has(_s13)) {
                  continue;
                }
                e.add(_s13);
                n.push({
                  type: "reconvert",
                  element: _s13
                });
              } else {
                n.push(_o61);
              }
            }
          } catch (err) {
            _iterator124.e(err);
          } finally {
            _iterator124.f();
          }
          return n;
        }
      }, {
        key: "_isReconvertTriggerEvent",
        value: function _isReconvertTriggerEvent(t, e) {
          return this._reconversionEventsMapping.get(t) === e;
        }
      }]);
      return sf;
    }();
    _s(sf, ds);
    function af(t, e, n) {
      var o = e.getRange();
      var i = Array.from(t.getAncestors());
      i.shift();
      i.reverse();
      var r = i.some(function (t) {
        if (o.containsItem(t)) {
          var _e101 = n.toViewElement(t);
          return !!_e101.getCustomProperty("addHighlight");
        }
      });
      return !r;
    }
    function cf(t, e) {
      var n = e.item.name || "$text";
      return "".concat(t, ":").concat(n);
    }
    function lf(t) {
      var e = t.item;
      var n = ef._createFromPositionAndShift(t.previousPosition, t.length);
      return {
        item: e,
        range: n
      };
    }
    function df(t, e) {
      if (t.is("textProxy")) {
        var _n90 = e.toViewPosition(Zh._createBefore(t));
        var _o62 = _n90.parent;
        return _o62.is("$text") ? _o62 : null;
      }
      return e.toViewElement(t);
    }
    var uf = /*#__PURE__*/function () {
      function uf(t, e, n) {
        _classCallCheck(this, uf);
        this._lastRangeBackward = false;
        this._ranges = [];
        this._attrs = new Map();
        if (t) {
          this.setTo(t, e, n);
        }
      }
      _createClass(uf, [{
        key: "isEqual",
        value: function isEqual(t) {
          if (this.rangeCount != t.rangeCount) {
            return false;
          } else if (this.rangeCount === 0) {
            return true;
          }
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
            return false;
          }
          var _iterator125 = _createForOfIteratorHelper(this._ranges),
            _step125;
          try {
            for (_iterator125.s(); !(_step125 = _iterator125.n()).done;) {
              var _e102 = _step125.value;
              var _n91 = false;
              var _iterator126 = _createForOfIteratorHelper(t._ranges),
                _step126;
              try {
                for (_iterator126.s(); !(_step126 = _iterator126.n()).done;) {
                  var _o63 = _step126.value;
                  if (_e102.isEqual(_o63)) {
                    _n91 = true;
                    break;
                  }
                }
              } catch (err) {
                _iterator126.e(err);
              } finally {
                _iterator126.f();
              }
              if (!_n91) {
                return false;
              }
            }
          } catch (err) {
            _iterator125.e(err);
          } finally {
            _iterator125.f();
          }
          return true;
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          var _iterator127, _step127, _t96;
          return _regeneratorRuntime().wrap(function getRanges$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                _iterator127 = _createForOfIteratorHelper(this._ranges);
                _context16.prev = 1;
                _iterator127.s();
              case 3:
                if ((_step127 = _iterator127.n()).done) {
                  _context16.next = 9;
                  break;
                }
                _t96 = _step127.value;
                _context16.next = 7;
                return new ef(_t96.start, _t96.end);
              case 7:
                _context16.next = 3;
                break;
              case 9:
                _context16.next = 14;
                break;
              case 11:
                _context16.prev = 11;
                _context16.t0 = _context16["catch"](1);
                _iterator127.e(_context16.t0);
              case 14:
                _context16.prev = 14;
                _iterator127.f();
                return _context16.finish(14);
              case 17:
              case "end":
                return _context16.stop();
            }
          }, getRanges, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          var t = null;
          var _iterator128 = _createForOfIteratorHelper(this._ranges),
            _step128;
          try {
            for (_iterator128.s(); !(_step128 = _iterator128.n()).done;) {
              var _e103 = _step128.value;
              if (!t || _e103.start.isBefore(t.start)) {
                t = _e103;
              }
            }
          } catch (err) {
            _iterator128.e(err);
          } finally {
            _iterator128.f();
          }
          return t ? new ef(t.start, t.end) : null;
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          var t = null;
          var _iterator129 = _createForOfIteratorHelper(this._ranges),
            _step129;
          try {
            for (_iterator129.s(); !(_step129 = _iterator129.n()).done;) {
              var _e104 = _step129.value;
              if (!t || _e104.end.isAfter(t.end)) {
                t = _e104;
              }
            }
          } catch (err) {
            _iterator129.e(err);
          } finally {
            _iterator129.f();
          }
          return t ? new ef(t.start, t.end) : null;
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          var t = this.getFirstRange();
          return t ? t.start.clone() : null;
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          var t = this.getLastRange();
          return t ? t.end.clone() : null;
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          if (t === null) {
            this._setRanges([]);
          } else if (t instanceof uf) {
            this._setRanges(t.getRanges(), t.isBackward);
          } else if (t && typeof t.getRanges == "function") {
            this._setRanges(t.getRanges(), t.isBackward);
          } else if (t instanceof ef) {
            this._setRanges([t], !!e && !!e.backward);
          } else if (t instanceof Zh) {
            this._setRanges([new ef(t)]);
          } else if (t instanceof Hh) {
            var _o64 = !!n && !!n.backward;
            var _i54;
            if (e == "in") {
              _i54 = ef._createIn(t);
            } else if (e == "on") {
              _i54 = ef._createOn(t);
            } else if (e !== undefined) {
              _i54 = new ef(Zh._createAt(t, e));
            } else {
              throw new ss["a"]("model-selection-setto-required-second-parameter", [this, t]);
            }
            this._setRanges([_i54], _o64);
          } else if (As(t)) {
            this._setRanges(t, e && !!e.backward);
          } else {
            throw new ss["a"]("model-selection-setto-not-selectable", [this, t]);
          }
        }
      }, {
        key: "_setRanges",
        value: function _setRanges(t) {
          var _this48 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          t = Array.from(t);
          var n = t.some(function (e) {
            if (!(e instanceof ef)) {
              throw new ss["a"]("model-selection-set-ranges-not-range", [_this48, t]);
            }
            return _this48._ranges.every(function (t) {
              return !t.isEqual(e);
            });
          });
          if (t.length === this._ranges.length && !n) {
            return;
          }
          this._removeAllRanges();
          var _iterator130 = _createForOfIteratorHelper(t),
            _step130;
          try {
            for (_iterator130.s(); !(_step130 = _iterator130.n()).done;) {
              var _e105 = _step130.value;
              this._pushRange(_e105);
            }
          } catch (err) {
            _iterator130.e(err);
          } finally {
            _iterator130.f();
          }
          this._lastRangeBackward = !!e;
          this.fire("change:range", {
            directChange: true
          });
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          if (this.anchor === null) {
            throw new ss["a"]("model-selection-setfocus-no-ranges", [this, t]);
          }
          var n = Zh._createAt(t, e);
          if (n.compareWith(this.focus) == "same") {
            return;
          }
          var o = this.anchor;
          if (this._ranges.length) {
            this._popRange();
          }
          if (n.compareWith(o) == "before") {
            this._pushRange(new ef(n, o));
            this._lastRangeBackward = true;
          } else {
            this._pushRange(new ef(o, n));
            this._lastRangeBackward = false;
          }
          this.fire("change:range", {
            directChange: true
          });
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._attrs.get(t);
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._attrs.entries();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._attrs.keys();
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._attrs.has(t);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this.hasAttribute(t)) {
            this._attrs.delete(t);
            this.fire("change:attribute", {
              attributeKeys: [t],
              directChange: true
            });
          }
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this.getAttribute(t) !== e) {
            this._attrs.set(t, e);
            this.fire("change:attribute", {
              attributeKeys: [t],
              directChange: true
            });
          }
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null;
          }
          return this.getFirstRange().getContainedElement();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "selection" || t === "model:selection";
        }
      }, {
        key: "getSelectedBlocks",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getSelectedBlocks() {
          var t, _iterator131, _step131, _e106, _n92, _iterator132, _step132, _n93, _o66, _o65;
          return _regeneratorRuntime().wrap(function getSelectedBlocks$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                t = new WeakSet();
                _iterator131 = _createForOfIteratorHelper(this.getRanges());
                _context17.prev = 2;
                _iterator131.s();
              case 4:
                if ((_step131 = _iterator131.n()).done) {
                  _context17.next = 35;
                  break;
                }
                _e106 = _step131.value;
                _n92 = mf(_e106.start, t);
                if (!(_n92 && gf(_n92, _e106))) {
                  _context17.next = 10;
                  break;
                }
                _context17.next = 10;
                return _n92;
              case 10:
                _iterator132 = _createForOfIteratorHelper(_e106.getWalker());
                _context17.prev = 11;
                _iterator132.s();
              case 13:
                if ((_step132 = _iterator132.n()).done) {
                  _context17.next = 21;
                  break;
                }
                _n93 = _step132.value;
                _o66 = _n93.item;
                if (!(_n93.type == "elementEnd" && ff(_o66, t, _e106))) {
                  _context17.next = 19;
                  break;
                }
                _context17.next = 19;
                return _o66;
              case 19:
                _context17.next = 13;
                break;
              case 21:
                _context17.next = 26;
                break;
              case 23:
                _context17.prev = 23;
                _context17.t0 = _context17["catch"](11);
                _iterator132.e(_context17.t0);
              case 26:
                _context17.prev = 26;
                _iterator132.f();
                return _context17.finish(26);
              case 29:
                _o65 = mf(_e106.end, t);
                if (!(_o65 && !_e106.end.isTouching(Zh._createAt(_o65, 0)) && gf(_o65, _e106))) {
                  _context17.next = 33;
                  break;
                }
                _context17.next = 33;
                return _o65;
              case 33:
                _context17.next = 4;
                break;
              case 35:
                _context17.next = 40;
                break;
              case 37:
                _context17.prev = 37;
                _context17.t1 = _context17["catch"](2);
                _iterator131.e(_context17.t1);
              case 40:
                _context17.prev = 40;
                _iterator131.f();
                return _context17.finish(40);
              case 43:
              case "end":
                return _context17.stop();
            }
          }, getSelectedBlocks, this, [[2, 37, 40, 43], [11, 23, 26, 29]]);
        })
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.anchor.root;
          var e = Zh._createAt(t, 0);
          var n = Zh._createAt(t, "end");
          return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          this._checkRange(t);
          this._ranges.push(new ef(t.start, t.end));
        }
      }, {
        key: "_checkRange",
        value: function _checkRange(t) {
          for (var _e107 = 0; _e107 < this._ranges.length; _e107++) {
            if (t.isIntersecting(this._ranges[_e107])) {
              throw new ss["a"]("model-selection-range-intersects", [this, t], {
                addedRange: t,
                intersectingRange: this._ranges[_e107]
              });
            }
          }
        }
      }, {
        key: "_removeAllRanges",
        value: function _removeAllRanges() {
          while (this._ranges.length > 0) {
            this._popRange();
          }
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop();
        }
      }, {
        key: "anchor",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t97 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t97.end : _t97.start;
          }
          return null;
        }
      }, {
        key: "focus",
        get: function get() {
          if (this._ranges.length > 0) {
            var _t98 = this._ranges[this._ranges.length - 1];
            return this._lastRangeBackward ? _t98.start : _t98.end;
          }
          return null;
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          var t = this._ranges.length;
          if (t === 1) {
            return this._ranges[0].isCollapsed;
          } else {
            return false;
          }
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return !this.isCollapsed && this._lastRangeBackward;
        }
      }]);
      return uf;
    }();
    _s(uf, ds);
    function hf(t, e) {
      if (e.has(t)) {
        return false;
      }
      e.add(t);
      return t.root.document.model.schema.isBlock(t) && t.parent;
    }
    function ff(t, e, n) {
      return hf(t, e) && gf(t, n);
    }
    function mf(t, e) {
      var n = t.parent;
      var o = n.root.document.model.schema;
      var i = t.parent.getAncestors({
        parentFirst: true,
        includeSelf: true
      });
      var r = false;
      var s = i.find(function (t) {
        if (r) {
          return false;
        }
        r = o.isLimit(t);
        return !r && hf(t, e);
      });
      i.forEach(function (t) {
        return e.add(t);
      });
      return s;
    }
    function gf(t, e) {
      var n = pf(t);
      if (!n) {
        return true;
      }
      var o = e.containsRange(ef._createOn(n), true);
      return !o;
    }
    function pf(t) {
      var e = t.root.document.model.schema;
      var n = t.parent;
      while (n) {
        if (e.isBlock(n)) {
          return n;
        }
        n = n.parent;
      }
    }
    var kf = /*#__PURE__*/function (_ef) {
      _inherits(kf, _ef);
      function kf(t, e) {
        var _this49;
        _classCallCheck(this, kf);
        _this49 = _possibleConstructorReturn(this, _getPrototypeOf(kf).call(this, t, e));
        bf.call(_assertThisInitialized(_assertThisInitialized(_this49)));
        return _this49;
      }
      _createClass(kf, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "liveRange" || t === "model:liveRange" || t == "range" || t === "model:range";
        }
      }, {
        key: "toRange",
        value: function toRange() {
          return new ef(this.start, this.end);
        }
      }], [{
        key: "fromRange",
        value: function fromRange(t) {
          return new kf(t.start, t.end);
        }
      }]);
      return kf;
    }(ef);
    function bf() {
      var _this50 = this;
      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        if (!n.isDocumentOperation) {
          return;
        }
        wf.call(_this50, n);
      }, {
        priority: "low"
      });
    }
    function wf(t) {
      var e = this.getTransformedByOperation(t);
      var n = ef._createFromRanges(e);
      var o = !n.isEqual(this);
      var i = Cf(this, t);
      var r = null;
      if (o) {
        if (n.root.rootName == "$graveyard") {
          if (t.type == "remove") {
            r = t.sourcePosition;
          } else {
            r = t.deletionPosition;
          }
        }
        var _e108 = this.toRange();
        this.start = n.start;
        this.end = n.end;
        this.fire("change:range", _e108, {
          deletionPosition: r
        });
      } else if (i) {
        this.fire("change:content", this.toRange(), {
          deletionPosition: r
        });
      }
    }
    function Cf(t, e) {
      switch (e.type) {
        case "insert":
          return t.containsPosition(e.position);
        case "move":
        case "remove":
        case "reinsert":
        case "merge":
          return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
        case "split":
          return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
      }
      return false;
    }
    _s(kf, ds);
    var Af = "selection:";
    var _f = /*#__PURE__*/function () {
      function _f(t) {
        _classCallCheck(this, _f);
        this._selection = new vf(t);
        this._selection.delegate("change:range").to(this);
        this._selection.delegate("change:attribute").to(this);
        this._selection.delegate("change:marker").to(this);
      }
      _createClass(_f, [{
        key: "getRanges",
        value: function getRanges() {
          return this._selection.getRanges();
        }
      }, {
        key: "getFirstPosition",
        value: function getFirstPosition() {
          return this._selection.getFirstPosition();
        }
      }, {
        key: "getLastPosition",
        value: function getLastPosition() {
          return this._selection.getLastPosition();
        }
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return this._selection.getFirstRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return this._selection.getLastRange();
        }
      }, {
        key: "getSelectedBlocks",
        value: function getSelectedBlocks() {
          return this._selection.getSelectedBlocks();
        }
      }, {
        key: "getSelectedElement",
        value: function getSelectedElement() {
          return this._selection.getSelectedElement();
        }
      }, {
        key: "containsEntireContent",
        value: function containsEntireContent(t) {
          return this._selection.containsEntireContent(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._selection.destroy();
        }
      }, {
        key: "getAttributeKeys",
        value: function getAttributeKeys() {
          return this._selection.getAttributeKeys();
        }
      }, {
        key: "getAttributes",
        value: function getAttributes() {
          return this._selection.getAttributes();
        }
      }, {
        key: "getAttribute",
        value: function getAttribute(t) {
          return this._selection.getAttribute(t);
        }
      }, {
        key: "hasAttribute",
        value: function hasAttribute(t) {
          return this._selection.hasAttribute(t);
        }
      }, {
        key: "refresh",
        value: function refresh() {
          this._selection._updateMarkers();
          this._selection._updateAttributes(false);
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(t) {
          this._selection.observeMarkers(t);
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "selection" || t == "model:selection" || t == "documentSelection" || t == "model:documentSelection";
        }
      }, {
        key: "_setFocus",
        value: function _setFocus(t, e) {
          this._selection.setFocus(t, e);
        }
      }, {
        key: "_setTo",
        value: function _setTo(t, e, n) {
          this._selection.setTo(t, e, n);
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          this._selection.setAttribute(t, e);
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          this._selection.removeAttribute(t);
        }
      }, {
        key: "_getStoredAttributes",
        value: function _getStoredAttributes() {
          return this._selection._getStoredAttributes();
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          return this._selection.overrideGravity();
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity(t) {
          this._selection.restoreGravity(t);
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          return this._selection.isCollapsed;
        }
      }, {
        key: "anchor",
        get: function get() {
          return this._selection.anchor;
        }
      }, {
        key: "focus",
        get: function get() {
          return this._selection.focus;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._selection.rangeCount;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._selection.hasOwnRange;
        }
      }, {
        key: "isBackward",
        get: function get() {
          return this._selection.isBackward;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return this._selection.isGravityOverridden;
        }
      }, {
        key: "markers",
        get: function get() {
          return this._selection.markers;
        }
      }, {
        key: "_ranges",
        get: function get() {
          return this._selection._ranges;
        }
      }], [{
        key: "_getStoreAttributeKey",
        value: function _getStoreAttributeKey(t) {
          return Af + t;
        }
      }, {
        key: "_isStoreAttributeKey",
        value: function _isStoreAttributeKey(t) {
          return t.startsWith(Af);
        }
      }]);
      return _f;
    }();
    _s(_f, ds);
    var vf = /*#__PURE__*/function (_uf) {
      _inherits(vf, _uf);
      function vf(t) {
        var _this51;
        _classCallCheck(this, vf);
        _this51 = _possibleConstructorReturn(this, _getPrototypeOf(vf).call(this));
        _this51.markers = new vs({
          idProperty: "name"
        });
        _this51._model = t.model;
        _this51._document = t;
        _this51._attributePriority = new Map();
        _this51._selectionRestorePosition = null;
        _this51._hasChangedRange = false;
        _this51._overriddenGravityRegister = new Set();
        _this51._observedMarkers = new Set();
        _this51.listenTo(_this51._model, "applyOperation", function (t, e) {
          var n = e[0];
          if (!n.isDocumentOperation || n.type == "marker" || n.type == "rename" || n.type == "noop") {
            return;
          }
          if (_this51._ranges.length == 0 && _this51._selectionRestorePosition) {
            _this51._fixGraveyardSelection(_this51._selectionRestorePosition);
          }
          _this51._selectionRestorePosition = null;
          if (_this51._hasChangedRange) {
            _this51._hasChangedRange = false;
            _this51.fire("change:range", {
              directChange: false
            });
          }
        }, {
          priority: "lowest"
        });
        _this51.on("change:range", function () {
          var _iterator133 = _createForOfIteratorHelper(_this51.getRanges()),
            _step133;
          try {
            for (_iterator133.s(); !(_step133 = _iterator133.n()).done;) {
              var _t99 = _step133.value;
              if (!_this51._document._validateSelectionRange(_t99)) {
                throw new ss["a"]("document-selection-wrong-position", _assertThisInitialized(_assertThisInitialized(_this51)), {
                  range: _t99
                });
              }
            }
          } catch (err) {
            _iterator133.e(err);
          } finally {
            _iterator133.f();
          }
        });
        _this51.listenTo(_this51._model.markers, "update", function (t, e, n, o) {
          _this51._updateMarker(e, o);
        });
        _this51.listenTo(_this51._document, "change", function (t, e) {
          xf(_this51._model, e);
        });
        return _this51;
      }
      _createClass(vf, [{
        key: "destroy",
        value: function destroy() {
          for (var _t100 = 0; _t100 < this._ranges.length; _t100++) {
            this._ranges[_t100].detach();
          }
          this.stopListening();
        }
      }, {
        key: "getRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getRanges() {
          return _regeneratorRuntime().wrap(function getRanges$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                if (!this._ranges.length) {
                  _context18.next = 4;
                  break;
                }
                return _context18.delegateYield(_get(_getPrototypeOf(vf.prototype), "getRanges", this).call(this), "t0", 2);
              case 2:
                _context18.next = 6;
                break;
              case 4:
                _context18.next = 6;
                return this._document._getDefaultRange();
              case 6:
              case "end":
                return _context18.stop();
            }
          }, getRanges, this);
        })
      }, {
        key: "getFirstRange",
        value: function getFirstRange() {
          return _get(_getPrototypeOf(vf.prototype), "getFirstRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "getLastRange",
        value: function getLastRange() {
          return _get(_getPrototypeOf(vf.prototype), "getLastRange", this).call(this) || this._document._getDefaultRange();
        }
      }, {
        key: "setTo",
        value: function setTo(t, e, n) {
          _get(_getPrototypeOf(vf.prototype), "setTo", this).call(this, t, e, n);
          this._updateAttributes(true);
          this._updateMarkers();
        }
      }, {
        key: "setFocus",
        value: function setFocus(t, e) {
          _get(_getPrototypeOf(vf.prototype), "setFocus", this).call(this, t, e);
          this._updateAttributes(true);
          this._updateMarkers();
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            var _e109 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e109,
              directChange: true
            });
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t) {
          if (this._removeAttribute(t)) {
            var _e110 = [t];
            this.fire("change:attribute", {
              attributeKeys: _e110,
              directChange: true
            });
          }
        }
      }, {
        key: "overrideGravity",
        value: function overrideGravity() {
          var t = ns();
          this._overriddenGravityRegister.add(t);
          if (this._overriddenGravityRegister.size === 1) {
            this._updateAttributes(true);
          }
          return t;
        }
      }, {
        key: "restoreGravity",
        value: function restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) {
            throw new ss["a"]("document-selection-gravity-wrong-restore", this, {
              uid: t
            });
          }
          this._overriddenGravityRegister.delete(t);
          if (!this.isGravityOverridden) {
            this._updateAttributes(true);
          }
        }
      }, {
        key: "observeMarkers",
        value: function observeMarkers(t) {
          this._observedMarkers.add(t);
          this._updateMarkers();
        }
      }, {
        key: "_popRange",
        value: function _popRange() {
          this._ranges.pop().detach();
        }
      }, {
        key: "_pushRange",
        value: function _pushRange(t) {
          var e = this._prepareRange(t);
          if (e) {
            this._ranges.push(e);
          }
        }
      }, {
        key: "_prepareRange",
        value: function _prepareRange(t) {
          var _this52 = this;
          this._checkRange(t);
          if (t.root == this._document.graveyard) {
            return;
          }
          var e = kf.fromRange(t);
          e.on("change:range", function (t, n, o) {
            _this52._hasChangedRange = true;
            if (e.root == _this52._document.graveyard) {
              _this52._selectionRestorePosition = o.deletionPosition;
              var _t101 = _this52._ranges.indexOf(e);
              _this52._ranges.splice(_t101, 1);
              e.detach();
            }
          });
          return e;
        }
      }, {
        key: "_updateMarkers",
        value: function _updateMarkers() {
          if (!this._observedMarkers.size) {
            return;
          }
          var t = [];
          var e = false;
          var _iterator134 = _createForOfIteratorHelper(this._model.markers),
            _step134;
          try {
            for (_iterator134.s(); !(_step134 = _iterator134.n()).done;) {
              var _e111 = _step134.value;
              var _n96 = _e111.name.split(":", 1)[0];
              if (!this._observedMarkers.has(_n96)) {
                continue;
              }
              var _o67 = _e111.getRange();
              var _iterator135 = _createForOfIteratorHelper(this.getRanges()),
                _step135;
              try {
                for (_iterator135.s(); !(_step135 = _iterator135.n()).done;) {
                  var _n97 = _step135.value;
                  if (_o67.containsRange(_n97, !_n97.isCollapsed)) {
                    t.push(_e111);
                  }
                }
              } catch (err) {
                _iterator135.e(err);
              } finally {
                _iterator135.f();
              }
            }
          } catch (err) {
            _iterator134.e(err);
          } finally {
            _iterator134.f();
          }
          var n = Array.from(this.markers);
          for (var _i55 = 0, _t102 = t; _i55 < _t102.length; _i55++) {
            var _n94 = _t102[_i55];
            if (!this.markers.has(_n94)) {
              this.markers.add(_n94);
              e = true;
            }
          }
          for (var _i56 = 0, _Array$from2 = Array.from(this.markers); _i56 < _Array$from2.length; _i56++) {
            var _n95 = _Array$from2[_i56];
            if (!t.includes(_n95)) {
              this.markers.remove(_n95);
              e = true;
            }
          }
          if (e) {
            this.fire("change:marker", {
              oldMarkers: n,
              directChange: false
            });
          }
        }
      }, {
        key: "_updateMarker",
        value: function _updateMarker(t, e) {
          var n = t.name.split(":", 1)[0];
          if (!this._observedMarkers.has(n)) {
            return;
          }
          var o = false;
          var i = Array.from(this.markers);
          var r = this.markers.has(t);
          if (!e) {
            if (r) {
              this.markers.remove(t);
              o = true;
            }
          } else {
            var _n98 = false;
            var _iterator136 = _createForOfIteratorHelper(this.getRanges()),
              _step136;
            try {
              for (_iterator136.s(); !(_step136 = _iterator136.n()).done;) {
                var _t103 = _step136.value;
                if (e.containsRange(_t103, !_t103.isCollapsed)) {
                  _n98 = true;
                  break;
                }
              }
            } catch (err) {
              _iterator136.e(err);
            } finally {
              _iterator136.f();
            }
            if (_n98 && !r) {
              this.markers.add(t);
              o = true;
            } else if (!_n98 && r) {
              this.markers.remove(t);
              o = true;
            }
          }
          if (o) {
            this.fire("change:marker", {
              oldMarkers: i,
              directChange: false
            });
          }
        }
      }, {
        key: "_updateAttributes",
        value: function _updateAttributes(t) {
          var e = Gs(this._getSurroundingAttributes());
          var n = Gs(this.getAttributes());
          if (t) {
            this._attributePriority = new Map();
            this._attrs = new Map();
          } else {
            var _iterator137 = _createForOfIteratorHelper(this._attributePriority),
              _step137;
            try {
              for (_iterator137.s(); !(_step137 = _iterator137.n()).done;) {
                var _step137$value = _slicedToArray(_step137.value, 2),
                  _t104 = _step137$value[0],
                  _e112 = _step137$value[1];
                if (_e112 == "low") {
                  this._attrs.delete(_t104);
                  this._attributePriority.delete(_t104);
                }
              }
            } catch (err) {
              _iterator137.e(err);
            } finally {
              _iterator137.f();
            }
          }
          this._setAttributesTo(e);
          var o = [];
          var _iterator138 = _createForOfIteratorHelper(this.getAttributes()),
            _step138;
          try {
            for (_iterator138.s(); !(_step138 = _iterator138.n()).done;) {
              var _step138$value = _slicedToArray(_step138.value, 2),
                _t105 = _step138$value[0],
                _e113 = _step138$value[1];
              if (!n.has(_t105) || n.get(_t105) !== _e113) {
                o.push(_t105);
              }
            }
          } catch (err) {
            _iterator138.e(err);
          } finally {
            _iterator138.f();
          }
          var _iterator139 = _createForOfIteratorHelper(n),
            _step139;
          try {
            for (_iterator139.s(); !(_step139 = _iterator139.n()).done;) {
              var _step139$value = _slicedToArray(_step139.value, 1),
                _t106 = _step139$value[0];
              if (!this.hasAttribute(_t106)) {
                o.push(_t106);
              }
            }
          } catch (err) {
            _iterator139.e(err);
          } finally {
            _iterator139.f();
          }
          if (o.length > 0) {
            this.fire("change:attribute", {
              attributeKeys: o,
              directChange: false
            });
          }
        }
      }, {
        key: "_setAttribute",
        value: function _setAttribute(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
          var o = n ? "normal" : "low";
          if (o == "low" && this._attributePriority.get(t) == "normal") {
            return false;
          }
          var i = _get(_getPrototypeOf(vf.prototype), "getAttribute", this).call(this, t);
          if (i === e) {
            return false;
          }
          this._attrs.set(t, e);
          this._attributePriority.set(t, o);
          return true;
        }
      }, {
        key: "_removeAttribute",
        value: function _removeAttribute(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          var n = e ? "normal" : "low";
          if (n == "low" && this._attributePriority.get(t) == "normal") {
            return false;
          }
          this._attributePriority.set(t, n);
          if (!_get(_getPrototypeOf(vf.prototype), "hasAttribute", this).call(this, t)) {
            return false;
          }
          this._attrs.delete(t);
          return true;
        }
      }, {
        key: "_setAttributesTo",
        value: function _setAttributesTo(t) {
          var e = new Set();
          var _iterator140 = _createForOfIteratorHelper(this.getAttributes()),
            _step140;
          try {
            for (_iterator140.s(); !(_step140 = _iterator140.n()).done;) {
              var _step140$value = _slicedToArray(_step140.value, 2),
                _e114 = _step140$value[0],
                _n99 = _step140$value[1];
              if (t.get(_e114) === _n99) {
                continue;
              }
              this._removeAttribute(_e114, false);
            }
          } catch (err) {
            _iterator140.e(err);
          } finally {
            _iterator140.f();
          }
          var _iterator141 = _createForOfIteratorHelper(t),
            _step141;
          try {
            for (_iterator141.s(); !(_step141 = _iterator141.n()).done;) {
              var _step141$value = _slicedToArray(_step141.value, 2),
                _n100 = _step141$value[0],
                _o68 = _step141$value[1];
              var _t107 = this._setAttribute(_n100, _o68, false);
              if (_t107) {
                e.add(_n100);
              }
            }
          } catch (err) {
            _iterator141.e(err);
          } finally {
            _iterator141.f();
          }
          return e;
        }
      }, {
        key: "_getStoredAttributes",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function _getStoredAttributes() {
          var t, _iterator142, _step142, _e115, _n101;
          return _regeneratorRuntime().wrap(function _getStoredAttributes$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                t = this.getFirstPosition().parent;
                if (!(this.isCollapsed && t.isEmpty)) {
                  _context19.next = 21;
                  break;
                }
                _iterator142 = _createForOfIteratorHelper(t.getAttributeKeys());
                _context19.prev = 3;
                _iterator142.s();
              case 5:
                if ((_step142 = _iterator142.n()).done) {
                  _context19.next = 13;
                  break;
                }
                _e115 = _step142.value;
                if (!_e115.startsWith(Af)) {
                  _context19.next = 11;
                  break;
                }
                _n101 = _e115.substr(Af.length);
                _context19.next = 11;
                return [_n101, t.getAttribute(_e115)];
              case 11:
                _context19.next = 5;
                break;
              case 13:
                _context19.next = 18;
                break;
              case 15:
                _context19.prev = 15;
                _context19.t0 = _context19["catch"](3);
                _iterator142.e(_context19.t0);
              case 18:
                _context19.prev = 18;
                _iterator142.f();
                return _context19.finish(18);
              case 21:
              case "end":
                return _context19.stop();
            }
          }, _getStoredAttributes, this, [[3, 15, 18, 21]]);
        })
      }, {
        key: "_getSurroundingAttributes",
        value: function _getSurroundingAttributes() {
          var t = this.getFirstPosition();
          var e = this._model.schema;
          var n = null;
          if (!this.isCollapsed) {
            var _t108 = this.getFirstRange();
            var _iterator143 = _createForOfIteratorHelper(_t108),
              _step143;
            try {
              for (_iterator143.s(); !(_step143 = _iterator143.n()).done;) {
                var _o69 = _step143.value;
                if (_o69.item.is("element") && e.isObject(_o69.item)) {
                  break;
                }
                if (_o69.type == "text") {
                  n = _o69.item.getAttributes();
                  break;
                }
              }
            } catch (err) {
              _iterator143.e(err);
            } finally {
              _iterator143.f();
            }
          } else {
            var _o70 = t.textNode ? t.textNode : t.nodeBefore;
            var _i57 = t.textNode ? t.textNode : t.nodeAfter;
            if (!this.isGravityOverridden) {
              n = yf(_o70);
            }
            if (!n) {
              n = yf(_i57);
            }
            if (!this.isGravityOverridden && !n) {
              var _t109 = _o70;
              while (_t109 && !e.isInline(_t109) && !n) {
                _t109 = _t109.previousSibling;
                n = yf(_t109);
              }
            }
            if (!n) {
              var _t110 = _i57;
              while (_t110 && !e.isInline(_t110) && !n) {
                _t110 = _t110.nextSibling;
                n = yf(_t110);
              }
            }
            if (!n) {
              n = this._getStoredAttributes();
            }
          }
          return n;
        }
      }, {
        key: "_fixGraveyardSelection",
        value: function _fixGraveyardSelection(t) {
          var e = this._model.schema.getNearestSelectionRange(t);
          if (e) {
            this._pushRange(e);
          }
        }
      }, {
        key: "isCollapsed",
        get: function get() {
          var t = this._ranges.length;
          return t === 0 ? this._document._getDefaultRange().isCollapsed : _get(_getPrototypeOf(vf.prototype), "isCollapsed", this);
        }
      }, {
        key: "anchor",
        get: function get() {
          return _get(_getPrototypeOf(vf.prototype), "anchor", this) || this._document._getDefaultRange().start;
        }
      }, {
        key: "focus",
        get: function get() {
          return _get(_getPrototypeOf(vf.prototype), "focus", this) || this._document._getDefaultRange().end;
        }
      }, {
        key: "rangeCount",
        get: function get() {
          return this._ranges.length ? this._ranges.length : 1;
        }
      }, {
        key: "hasOwnRange",
        get: function get() {
          return this._ranges.length > 0;
        }
      }, {
        key: "isGravityOverridden",
        get: function get() {
          return !!this._overriddenGravityRegister.size;
        }
      }]);
      return vf;
    }(uf);
    function yf(t) {
      if (t instanceof Wh || t instanceof Gh) {
        return t.getAttributes();
      }
      return null;
    }
    function xf(t, e) {
      var n = t.document.differ;
      var _iterator144 = _createForOfIteratorHelper(n.getChanges()),
        _step144;
      try {
        var _loop2 = function _loop2() {
          var o = _step144.value;
          if (o.type != "insert") {
            return 1; // continue
          }
          var n = o.position.parent;
          var i = o.length === n.maxOffset;
          if (i) {
            t.enqueueChange(e, function (t) {
              var e = Array.from(n.getAttributeKeys()).filter(function (t) {
                return t.startsWith(Af);
              });
              var _iterator145 = _createForOfIteratorHelper(e),
                _step145;
              try {
                for (_iterator145.s(); !(_step145 = _iterator145.n()).done;) {
                  var _o71 = _step145.value;
                  t.removeAttribute(_o71, n);
                }
              } catch (err) {
                _iterator145.e(err);
              } finally {
                _iterator145.f();
              }
            });
          }
        };
        for (_iterator144.s(); !(_step144 = _iterator144.n()).done;) {
          if (_loop2()) continue;
        }
      } catch (err) {
        _iterator144.e(err);
      } finally {
        _iterator144.f();
      }
    }
    var Df = /*#__PURE__*/function () {
      function Df(t) {
        _classCallCheck(this, Df);
        this._dispatchers = t;
      }
      _createClass(Df, [{
        key: "add",
        value: function add(t) {
          var _iterator146 = _createForOfIteratorHelper(this._dispatchers),
            _step146;
          try {
            for (_iterator146.s(); !(_step146 = _iterator146.n()).done;) {
              var _e116 = _step146.value;
              t(_e116);
            }
          } catch (err) {
            _iterator146.e(err);
          } finally {
            _iterator146.f();
          }
          return this;
        }
      }]);
      return Df;
    }();
    var Ef = 1,
      Mf = 4;
    function Sf(t) {
      return Ur(t, Ef | Mf);
    }
    var Tf = Sf;
    var If = /*#__PURE__*/function (_Df) {
      _inherits(If, _Df);
      function If() {
        _classCallCheck(this, If);
        return _possibleConstructorReturn(this, _getPrototypeOf(If).apply(this, arguments));
      }
      _createClass(If, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(Zf(t));
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          return this.add(Jf(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(Xf(t));
        }
      }, {
        key: "markerToElement",
        value: function markerToElement(t) {
          return this.add(tm(t));
        }
      }, {
        key: "markerToHighlight",
        value: function markerToHighlight(t) {
          return this.add(nm(t));
        }
      }, {
        key: "markerToData",
        value: function markerToData(t) {
          return this.add(em(t));
        }
      }]);
      return If;
    }(Df);
    function Nf() {
      return function (t, e, n) {
        if (!n.consumable.consume(e.item, "insert")) {
          return;
        }
        var o = n.writer;
        var i = n.mapper.toViewPosition(e.range.start);
        var r = o.createText(e.item.data);
        o.insert(i, r);
      };
    }
    function Pf() {
      return function (t, e, n) {
        var o = n.mapper.toViewPosition(e.position);
        var i = e.position.getShiftedBy(e.length);
        var r = n.mapper.toViewPosition(i, {
          isPhantom: true
        });
        var s = n.writer.createRange(o, r);
        var a = n.writer.remove(s.getTrimmed());
        var _iterator147 = _createForOfIteratorHelper(n.writer.createRangeIn(a).getItems()),
          _step147;
        try {
          for (_iterator147.s(); !(_step147 = _iterator147.n()).done;) {
            var _t111 = _step147.value;
            n.mapper.unbindViewElement(_t111);
          }
        } catch (err) {
          _iterator147.e(err);
        } finally {
          _iterator147.f();
        }
      };
    }
    function Bf(t, e) {
      var n = t.createAttributeElement("span", e.attributes);
      if (e.classes) {
        n._addClass(e.classes);
      }
      if (e.priority) {
        n._priority = e.priority;
      }
      n._id = e.id;
      return n;
    }
    function zf() {
      return function (t, e, n) {
        var o = e.selection;
        if (o.isCollapsed) {
          return;
        }
        if (!n.consumable.consume(o, "selection")) {
          return;
        }
        var i = [];
        var _iterator148 = _createForOfIteratorHelper(o.getRanges()),
          _step148;
        try {
          for (_iterator148.s(); !(_step148 = _iterator148.n()).done;) {
            var _t112 = _step148.value;
            var _e117 = n.mapper.toViewRange(_t112);
            i.push(_e117);
          }
        } catch (err) {
          _iterator148.e(err);
        } finally {
          _iterator148.f();
        }
        n.writer.setSelection(i, {
          backward: o.isBackward
        });
      };
    }
    function Lf() {
      return function (t, e, n) {
        var o = e.selection;
        if (!o.isCollapsed) {
          return;
        }
        if (!n.consumable.consume(o, "selection")) {
          return;
        }
        var i = n.writer;
        var r = o.getFirstPosition();
        var s = n.mapper.toViewPosition(r);
        var a = i.breakAttributes(s);
        i.setSelection(a);
      };
    }
    function Of() {
      return function (t, e, n) {
        var o = n.writer;
        var i = o.document.selection;
        var _iterator149 = _createForOfIteratorHelper(i.getRanges()),
          _step149;
        try {
          for (_iterator149.s(); !(_step149 = _iterator149.n()).done;) {
            var _t113 = _step149.value;
            if (_t113.isCollapsed) {
              if (_t113.end.parent.isAttached()) {
                n.writer.mergeAttributes(_t113.start);
              }
            }
          }
        } catch (err) {
          _iterator149.e(err);
        } finally {
          _iterator149.f();
        }
        o.setSelection(null);
      };
    }
    function Rf(t) {
      return function (e, n, o) {
        var i = t(n.attributeOldValue, o);
        var r = t(n.attributeNewValue, o);
        if (!i && !r) {
          return;
        }
        if (!o.consumable.consume(n.item, e.name)) {
          return;
        }
        var s = o.writer;
        var a = s.document.selection;
        if (n.item instanceof uf || n.item instanceof _f) {
          s.wrap(a.getFirstRange(), r);
        } else {
          var _t114 = o.mapper.toViewRange(n.range);
          if (n.attributeOldValue !== null && i) {
            _t114 = s.unwrap(_t114, i);
          }
          if (n.attributeNewValue !== null && r) {
            s.wrap(_t114, r);
          }
        }
      };
    }
    function jf(t) {
      return function (e, n, o) {
        var i = t(n.item, o);
        if (!i) {
          return;
        }
        if (!o.consumable.consume(n.item, "insert")) {
          return;
        }
        var r = o.mapper.toViewPosition(n.range.start);
        o.mapper.bindElements(n.item, i);
        o.writer.insert(r, i);
      };
    }
    function Ff(t) {
      return function (e, n, o) {
        n.isOpening = true;
        var i = t(n, o);
        n.isOpening = false;
        var r = t(n, o);
        if (!i || !r) {
          return;
        }
        var s = n.markerRange;
        if (s.isCollapsed && !o.consumable.consume(s, e.name)) {
          return;
        }
        var _iterator150 = _createForOfIteratorHelper(s),
          _step150;
        try {
          for (_iterator150.s(); !(_step150 = _iterator150.n()).done;) {
            var _t115 = _step150.value;
            if (!o.consumable.consume(_t115.item, e.name)) {
              return;
            }
          }
        } catch (err) {
          _iterator150.e(err);
        } finally {
          _iterator150.f();
        }
        var a = o.mapper;
        var c = o.writer;
        c.insert(a.toViewPosition(s.start), i);
        o.mapper.bindElementToMarker(i, n.markerName);
        if (!s.isCollapsed) {
          c.insert(a.toViewPosition(s.end), r);
          o.mapper.bindElementToMarker(r, n.markerName);
        }
        e.stop();
      };
    }
    function Vf() {
      return function (t, e, n) {
        var o = n.mapper.markerNameToElements(e.markerName);
        if (!o) {
          return;
        }
        var _iterator151 = _createForOfIteratorHelper(o),
          _step151;
        try {
          for (_iterator151.s(); !(_step151 = _iterator151.n()).done;) {
            var _t116 = _step151.value;
            n.mapper.unbindElementFromMarkerName(_t116, e.markerName);
            n.writer.clear(n.writer.createRangeOn(_t116), _t116);
          }
        } catch (err) {
          _iterator151.e(err);
        } finally {
          _iterator151.f();
        }
        n.writer.clearClonedElementsGroup(e.markerName);
        t.stop();
      };
    }
    function Uf(t) {
      return function (e, n, o) {
        var i = t(n.markerName, o);
        if (!i) {
          return;
        }
        var r = n.markerRange;
        if (!o.consumable.consume(r, e.name)) {
          return;
        }
        Hf(r, false, o, n, i);
        Hf(r, true, o, n, i);
        e.stop();
      };
    }
    function Hf(t, e, n, o, i) {
      var r = e ? t.start : t.end;
      var s = n.schema.checkChild(r, "$text");
      if (s) {
        var _t117 = n.mapper.toViewPosition(r);
        Wf(_t117, e, n, o, i);
      } else {
        var _t118;
        var _s14;
        if (e && r.nodeAfter || !e && !r.nodeBefore) {
          _t118 = r.nodeAfter;
          _s14 = true;
        } else {
          _t118 = r.nodeBefore;
          _s14 = false;
        }
        var _a9 = n.mapper.toViewElement(_t118);
        Gf(_a9, e, _s14, n, o, i);
      }
    }
    function Gf(t, e, n, o, i, r) {
      var s = "data-".concat(r.group, "-").concat(e ? "start" : "end", "-").concat(n ? "before" : "after");
      var a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
      a.unshift(r.name);
      o.writer.setAttribute(s, a.join(","), t);
      o.mapper.bindElementToMarker(t, i.markerName);
    }
    function Wf(t, e, n, o, i) {
      var r = "".concat(i.group, "-").concat(e ? "start" : "end");
      var s = i.name ? {
        name: i.name
      } : null;
      var a = n.writer.createUIElement(r, s);
      n.writer.insert(t, a);
      n.mapper.bindElementToMarker(a, o.markerName);
    }
    function Kf(t) {
      return function (e, n, o) {
        var i = t(n.markerName, o);
        if (!i) {
          return;
        }
        var r = o.mapper.markerNameToElements(n.markerName);
        if (!r) {
          return;
        }
        var _iterator152 = _createForOfIteratorHelper(r),
          _step152;
        try {
          for (_iterator152.s(); !(_step152 = _iterator152.n()).done;) {
            var _t119 = _step152.value;
            o.mapper.unbindElementFromMarkerName(_t119, n.markerName);
            if (_t119.is("containerElement")) {
              s("data-".concat(i.group, "-start-before"), _t119);
              s("data-".concat(i.group, "-start-after"), _t119);
              s("data-".concat(i.group, "-end-before"), _t119);
              s("data-".concat(i.group, "-end-after"), _t119);
            } else {
              o.writer.clear(o.writer.createRangeOn(_t119), _t119);
            }
          }
        } catch (err) {
          _iterator152.e(err);
        } finally {
          _iterator152.f();
        }
        o.writer.clearClonedElementsGroup(n.markerName);
        e.stop();
        function s(t, e) {
          if (e.hasAttribute(t)) {
            var _n102 = new Set(e.getAttribute(t).split(","));
            _n102.delete(i.name);
            if (_n102.size == 0) {
              o.writer.removeAttribute(t, e);
            } else {
              o.writer.setAttribute(t, Array.from(_n102).join(","), e);
            }
          }
        }
      };
    }
    function qf(t) {
      return function (e, n, o) {
        var i = t(n.attributeOldValue, o);
        var r = t(n.attributeNewValue, o);
        if (!i && !r) {
          return;
        }
        if (!o.consumable.consume(n.item, e.name)) {
          return;
        }
        var s = o.mapper.toViewElement(n.item);
        var a = o.writer;
        if (!s) {
          throw new ss["a"]("conversion-attribute-to-attribute-on-text", [n, o]);
        }
        if (n.attributeOldValue !== null && i) {
          if (i.key == "class") {
            var _t120 = xs(i.value);
            var _iterator153 = _createForOfIteratorHelper(_t120),
              _step153;
            try {
              for (_iterator153.s(); !(_step153 = _iterator153.n()).done;) {
                var _e118 = _step153.value;
                a.removeClass(_e118, s);
              }
            } catch (err) {
              _iterator153.e(err);
            } finally {
              _iterator153.f();
            }
          } else if (i.key == "style") {
            var _t121 = Object.keys(i.value);
            for (var _i58 = 0, _t122 = _t121; _i58 < _t122.length; _i58++) {
              var _e119 = _t122[_i58];
              a.removeStyle(_e119, s);
            }
          } else {
            a.removeAttribute(i.key, s);
          }
        }
        if (n.attributeNewValue !== null && r) {
          if (r.key == "class") {
            var _t123 = xs(r.value);
            var _iterator154 = _createForOfIteratorHelper(_t123),
              _step154;
            try {
              for (_iterator154.s(); !(_step154 = _iterator154.n()).done;) {
                var _e120 = _step154.value;
                a.addClass(_e120, s);
              }
            } catch (err) {
              _iterator154.e(err);
            } finally {
              _iterator154.f();
            }
          } else if (r.key == "style") {
            var _t124 = Object.keys(r.value);
            for (var _i59 = 0, _t125 = _t124; _i59 < _t125.length; _i59++) {
              var _e121 = _t125[_i59];
              a.setStyle(_e121, r.value[_e121], s);
            }
          } else {
            a.setAttribute(r.key, r.value, s);
          }
        }
      };
    }
    function Yf(t) {
      return function (e, n, o) {
        if (!n.item) {
          return;
        }
        if (!(n.item instanceof uf || n.item instanceof _f) && !n.item.is("$textProxy")) {
          return;
        }
        var i = am(t, n, o);
        if (!i) {
          return;
        }
        if (!o.consumable.consume(n.item, e.name)) {
          return;
        }
        var r = o.writer;
        var s = Bf(r, i);
        var a = r.document.selection;
        if (n.item instanceof uf || n.item instanceof _f) {
          r.wrap(a.getFirstRange(), s, a);
        } else {
          var _t126 = o.mapper.toViewRange(n.range);
          var _e122 = r.wrap(_t126, s);
          var _iterator155 = _createForOfIteratorHelper(_e122.getItems()),
            _step155;
          try {
            for (_iterator155.s(); !(_step155 = _iterator155.n()).done;) {
              var _t127 = _step155.value;
              if (_t127.is("attributeElement") && _t127.isSimilar(s)) {
                o.mapper.bindElementToMarker(_t127, n.markerName);
                break;
              }
            }
          } catch (err) {
            _iterator155.e(err);
          } finally {
            _iterator155.f();
          }
        }
      };
    }
    function Qf(t) {
      return function (e, n, o) {
        if (!n.item) {
          return;
        }
        if (!(n.item instanceof qh)) {
          return;
        }
        var i = am(t, n, o);
        if (!i) {
          return;
        }
        if (!o.consumable.test(n.item, e.name)) {
          return;
        }
        var r = o.mapper.toViewElement(n.item);
        if (r && r.getCustomProperty("addHighlight")) {
          o.consumable.consume(n.item, e.name);
          var _iterator156 = _createForOfIteratorHelper(ef._createIn(n.item)),
            _step156;
          try {
            for (_iterator156.s(); !(_step156 = _iterator156.n()).done;) {
              var _t128 = _step156.value;
              o.consumable.consume(_t128.item, e.name);
            }
          } catch (err) {
            _iterator156.e(err);
          } finally {
            _iterator156.f();
          }
          r.getCustomProperty("addHighlight")(r, i, o.writer);
          o.mapper.bindElementToMarker(r, n.markerName);
        }
      };
    }
    function $f(t) {
      return function (e, n, o) {
        if (n.markerRange.isCollapsed) {
          return;
        }
        var i = am(t, n, o);
        if (!i) {
          return;
        }
        var r = Bf(o.writer, i);
        var s = o.mapper.markerNameToElements(n.markerName);
        if (!s) {
          return;
        }
        var _iterator157 = _createForOfIteratorHelper(s),
          _step157;
        try {
          for (_iterator157.s(); !(_step157 = _iterator157.n()).done;) {
            var _t129 = _step157.value;
            o.mapper.unbindElementFromMarkerName(_t129, n.markerName);
            if (_t129.is("attributeElement")) {
              o.writer.unwrap(o.writer.createRangeOn(_t129), r);
            } else {
              _t129.getCustomProperty("removeHighlight")(_t129, i.id, o.writer);
            }
          }
        } catch (err) {
          _iterator157.e(err);
        } finally {
          _iterator157.f();
        }
        o.writer.clearClonedElementsGroup(n.markerName);
        e.stop();
      };
    }
    function Zf(t) {
      t = Tf(t);
      t.view = om(t.view, "container");
      return function (e) {
        e.on("insert:" + t.model, jf(t.view), {
          priority: t.converterPriority || "normal"
        });
        if (t.triggerBy) {
          if (t.triggerBy.attributes) {
            var _iterator158 = _createForOfIteratorHelper(t.triggerBy.attributes),
              _step158;
            try {
              for (_iterator158.s(); !(_step158 = _iterator158.n()).done;) {
                var _n103 = _step158.value;
                e._mapReconversionTriggerEvent(t.model, "attribute:".concat(_n103, ":").concat(t.model));
              }
            } catch (err) {
              _iterator158.e(err);
            } finally {
              _iterator158.f();
            }
          }
          if (t.triggerBy.children) {
            var _iterator159 = _createForOfIteratorHelper(t.triggerBy.children),
              _step159;
            try {
              for (_iterator159.s(); !(_step159 = _iterator159.n()).done;) {
                var _n104 = _step159.value;
                e._mapReconversionTriggerEvent(t.model, "insert:".concat(_n104));
                e._mapReconversionTriggerEvent(t.model, "remove:".concat(_n104));
              }
            } catch (err) {
              _iterator159.e(err);
            } finally {
              _iterator159.f();
            }
          }
        }
      };
    }
    function Jf(t) {
      t = Tf(t);
      var e = t.model.key ? t.model.key : t.model;
      var n = "attribute:" + e;
      if (t.model.name) {
        n += ":" + t.model.name;
      }
      if (t.model.values) {
        var _iterator160 = _createForOfIteratorHelper(t.model.values),
          _step160;
        try {
          for (_iterator160.s(); !(_step160 = _iterator160.n()).done;) {
            var _e123 = _step160.value;
            t.view[_e123] = om(t.view[_e123], "attribute");
          }
        } catch (err) {
          _iterator160.e(err);
        } finally {
          _iterator160.f();
        }
      } else {
        t.view = om(t.view, "attribute");
      }
      var o = rm(t);
      return function (e) {
        e.on(n, Rf(o), {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function Xf(t) {
      t = Tf(t);
      var e = t.model.key ? t.model.key : t.model;
      var n = "attribute:" + e;
      if (t.model.name) {
        n += ":" + t.model.name;
      }
      if (t.model.values) {
        var _iterator161 = _createForOfIteratorHelper(t.model.values),
          _step161;
        try {
          for (_iterator161.s(); !(_step161 = _iterator161.n()).done;) {
            var _e124 = _step161.value;
            t.view[_e124] = sm(t.view[_e124]);
          }
        } catch (err) {
          _iterator161.e(err);
        } finally {
          _iterator161.f();
        }
      } else {
        t.view = sm(t.view);
      }
      var o = rm(t);
      return function (e) {
        e.on(n, qf(o), {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function tm(t) {
      t = Tf(t);
      t.view = om(t.view, "ui");
      return function (e) {
        e.on("addMarker:" + t.model, Ff(t.view), {
          priority: t.converterPriority || "normal"
        });
        e.on("removeMarker:" + t.model, Vf(t.view), {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function em(t) {
      t = Tf(t);
      var e = t.model;
      if (!t.view) {
        t.view = function (n) {
          return {
            group: e,
            name: n.substr(t.model.length + 1)
          };
        };
      }
      return function (n) {
        n.on("addMarker:" + e, Uf(t.view), {
          priority: t.converterPriority || "normal"
        });
        n.on("removeMarker:" + e, Kf(t.view), {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function nm(t) {
      return function (e) {
        e.on("addMarker:" + t.model, Yf(t.view), {
          priority: t.converterPriority || "normal"
        });
        e.on("addMarker:" + t.model, Qf(t.view), {
          priority: t.converterPriority || "normal"
        });
        e.on("removeMarker:" + t.model, $f(t.view), {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function om(t, e) {
      if (typeof t == "function") {
        return t;
      }
      return function (n, o) {
        return im(t, o, e);
      };
    }
    function im(t, e, n) {
      if (typeof t == "string") {
        t = {
          name: t
        };
      }
      var o;
      var i = e.writer;
      var r = Object.assign({}, t.attributes);
      if (n == "container") {
        o = i.createContainerElement(t.name, r);
      } else if (n == "attribute") {
        var _e125 = {
          priority: t.priority || Cl.DEFAULT_PRIORITY
        };
        o = i.createAttributeElement(t.name, r, _e125);
      } else {
        o = i.createUIElement(t.name, r);
      }
      if (t.styles) {
        var _e126 = Object.keys(t.styles);
        for (var _i60 = 0, _e127 = _e126; _i60 < _e127.length; _i60++) {
          var _n105 = _e127[_i60];
          i.setStyle(_n105, t.styles[_n105], o);
        }
      }
      if (t.classes) {
        var _e128 = t.classes;
        if (typeof _e128 == "string") {
          i.addClass(_e128, o);
        } else {
          var _iterator162 = _createForOfIteratorHelper(_e128),
            _step162;
          try {
            for (_iterator162.s(); !(_step162 = _iterator162.n()).done;) {
              var _t130 = _step162.value;
              i.addClass(_t130, o);
            }
          } catch (err) {
            _iterator162.e(err);
          } finally {
            _iterator162.f();
          }
        }
      }
      return o;
    }
    function rm(t) {
      if (t.model.values) {
        return function (e, n) {
          var o = t.view[e];
          if (o) {
            return o(e, n);
          }
          return null;
        };
      } else {
        return t.view;
      }
    }
    function sm(t) {
      if (typeof t == "string") {
        return function (e) {
          return {
            key: t,
            value: e
          };
        };
      } else if (typeof t == "object") {
        if (t.value) {
          return function () {
            return t;
          };
        } else {
          return function (e) {
            return {
              key: t.key,
              value: e
            };
          };
        }
      } else {
        return t;
      }
    }
    function am(t, e, n) {
      var o = typeof t == "function" ? t(e, n) : t;
      if (!o) {
        return null;
      }
      if (!o.priority) {
        o.priority = 10;
      }
      if (!o.id) {
        o.id = e.markerName;
      }
      return o;
    }
    function cm(t) {
      var _t$model = t.model,
        e = _t$model.schema,
        n = _t$model.document;
      var _iterator163 = _createForOfIteratorHelper(n.getRootNames()),
        _step163;
      try {
        for (_iterator163.s(); !(_step163 = _iterator163.n()).done;) {
          var _o72 = _step163.value;
          var _i61 = n.getRoot(_o72);
          if (_i61.isEmpty && !e.checkChild(_i61, "$text")) {
            if (e.checkChild(_i61, "paragraph")) {
              t.insertElement("paragraph", _i61);
              return true;
            }
          }
        }
      } catch (err) {
        _iterator163.e(err);
      } finally {
        _iterator163.f();
      }
      return false;
    }
    function lm(t, e, n) {
      var o = n.createContext(t);
      if (!n.checkChild(o, "paragraph")) {
        return false;
      }
      if (!n.checkChild(o.push("paragraph"), e)) {
        return false;
      }
      return true;
    }
    function dm(t, e) {
      var n = e.createElement("paragraph");
      e.insert(n, t);
      return e.createPositionAt(n, 0);
    }
    var um = /*#__PURE__*/function (_Df2) {
      _inherits(um, _Df2);
      function um() {
        _classCallCheck(this, um);
        return _possibleConstructorReturn(this, _getPrototypeOf(um).apply(this, arguments));
      }
      _createClass(um, [{
        key: "elementToElement",
        value: function elementToElement(t) {
          return this.add(gm(t));
        }
      }, {
        key: "elementToAttribute",
        value: function elementToAttribute(t) {
          return this.add(pm(t));
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          return this.add(km(t));
        }
      }, {
        key: "elementToMarker",
        value: function elementToMarker(t) {
          Object(ss["c"])("upcast-helpers-element-to-marker-deprecated");
          return this.add(bm(t));
        }
      }, {
        key: "dataToMarker",
        value: function dataToMarker(t) {
          return this.add(wm(t));
        }
      }]);
      return um;
    }(Df);
    function hm() {
      return function (t, e, n) {
        if (!e.modelRange && n.consumable.consume(e.viewItem, {
          name: true
        })) {
          var _n$convertChildren = n.convertChildren(e.viewItem, e.modelCursor),
            _t131 = _n$convertChildren.modelRange,
            _o73 = _n$convertChildren.modelCursor;
          e.modelRange = _t131;
          e.modelCursor = _o73;
        }
      };
    }
    function fm() {
      return function (t, e, _ref9) {
        var n = _ref9.schema,
          o = _ref9.consumable,
          i = _ref9.writer;
        var r = e.modelCursor;
        if (!o.test(e.viewItem)) {
          return;
        }
        if (!n.checkChild(r, "$text")) {
          if (!lm(r, "$text", n)) {
            return;
          }
          r = dm(r, i);
        }
        o.consume(e.viewItem);
        var s = i.createText(e.viewItem.data);
        i.insert(s, r);
        e.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize));
        e.modelCursor = e.modelRange.end;
      };
    }
    function mm(t, e) {
      return function (n, o) {
        var i = o.newSelection;
        var r = [];
        var _iterator164 = _createForOfIteratorHelper(i.getRanges()),
          _step164;
        try {
          for (_iterator164.s(); !(_step164 = _iterator164.n()).done;) {
            var _t132 = _step164.value;
            r.push(e.toModelRange(_t132));
          }
        } catch (err) {
          _iterator164.e(err);
        } finally {
          _iterator164.f();
        }
        var s = t.createSelection(r, {
          backward: i.isBackward
        });
        if (!s.isEqual(t.document.selection)) {
          t.change(function (t) {
            t.setSelection(s);
          });
        }
      };
    }
    function gm(t) {
      t = Tf(t);
      var e = _m(t);
      var n = Am(t.view);
      var o = n ? "element:" + n : "element";
      return function (n) {
        n.on(o, e, {
          priority: t.converterPriority || "normal"
        });
      };
    }
    function pm(t) {
      t = Tf(t);
      xm(t);
      var e = Dm(t, false);
      var n = Am(t.view);
      var o = n ? "element:" + n : "element";
      return function (n) {
        n.on(o, e, {
          priority: t.converterPriority || "low"
        });
      };
    }
    function km(t) {
      t = Tf(t);
      var e = null;
      if (typeof t.view == "string" || t.view.key) {
        e = ym(t);
      }
      xm(t, e);
      var n = Dm(t, true);
      return function (e) {
        e.on("element", n, {
          priority: t.converterPriority || "low"
        });
      };
    }
    function bm(t) {
      t = Tf(t);
      Sm(t);
      return gm(t);
    }
    function wm(t) {
      t = Tf(t);
      if (!t.model) {
        t.model = function (e) {
          return e ? t.view + ":" + e : t.view;
        };
      }
      var e = _m(Tm(t, "start"));
      var n = _m(Tm(t, "end"));
      return function (o) {
        o.on("element:" + t.view + "-start", e, {
          priority: t.converterPriority || "normal"
        });
        o.on("element:" + t.view + "-end", n, {
          priority: t.converterPriority || "normal"
        });
        var i = is.get("low");
        var r = is.get("highest");
        var s = is.get(t.converterPriority) / r;
        o.on("element", Cm(t), {
          priority: i + s
        });
      };
    }
    function Cm(t) {
      return function (e, n, o) {
        var i = "data-".concat(t.view);
        if (!n.modelRange) {
          n = Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor));
        }
        if (o.consumable.consume(n.viewItem, {
          attributes: i + "-end-after"
        })) {
          r(n.modelRange.end, n.viewItem.getAttribute(i + "-end-after").split(","));
        }
        if (o.consumable.consume(n.viewItem, {
          attributes: i + "-start-after"
        })) {
          r(n.modelRange.end, n.viewItem.getAttribute(i + "-start-after").split(","));
        }
        if (o.consumable.consume(n.viewItem, {
          attributes: i + "-end-before"
        })) {
          r(n.modelRange.start, n.viewItem.getAttribute(i + "-end-before").split(","));
        }
        if (o.consumable.consume(n.viewItem, {
          attributes: i + "-start-before"
        })) {
          r(n.modelRange.start, n.viewItem.getAttribute(i + "-start-before").split(","));
        }
        function r(e, i) {
          var _iterator165 = _createForOfIteratorHelper(i),
            _step165;
          try {
            for (_iterator165.s(); !(_step165 = _iterator165.n()).done;) {
              var _r16 = _step165.value;
              var _i62 = t.model(_r16, o);
              var _s15 = o.writer.createElement("$marker", {
                "data-name": _i62
              });
              o.writer.insert(_s15, e);
              if (n.modelCursor.isEqual(e)) {
                n.modelCursor = n.modelCursor.getShiftedBy(1);
              } else {
                n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1);
              }
              n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
            }
          } catch (err) {
            _iterator165.e(err);
          } finally {
            _iterator165.f();
          }
        }
      };
    }
    function Am(t) {
      if (typeof t == "string") {
        return t;
      }
      if (typeof t == "object" && typeof t.name == "string") {
        return t.name;
      }
      return null;
    }
    function _m(t) {
      var e = new Ws(t.view);
      return function (n, o, i) {
        var r = e.match(o.viewItem);
        if (!r) {
          return;
        }
        var s = r.match;
        s.name = true;
        if (!i.consumable.test(o.viewItem, s)) {
          return;
        }
        var a = vm(t.model, o.viewItem, i);
        if (!a) {
          return;
        }
        if (!i.safeInsert(a, o.modelCursor)) {
          return;
        }
        i.consumable.consume(o.viewItem, s);
        i.convertChildren(o.viewItem, a);
        i.updateConversionResult(a, o);
      };
    }
    function vm(t, e, n) {
      if (t instanceof Function) {
        return t(e, n);
      } else {
        return n.writer.createElement(t);
      }
    }
    function ym(t) {
      if (typeof t.view == "string") {
        t.view = {
          key: t.view
        };
      }
      var e = t.view.key;
      var n;
      if (e == "class" || e == "style") {
        var _o74 = e == "class" ? "classes" : "styles";
        n = _defineProperty({}, _o74, t.view.value);
      } else {
        var _o75 = typeof t.view.value == "undefined" ? /[\s\S]*/ : t.view.value;
        n = {
          attributes: _defineProperty({}, e, _o75)
        };
      }
      if (t.view.name) {
        n.name = t.view.name;
      }
      t.view = n;
      return e;
    }
    function xm(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = e === null ? true : function (t) {
        return t.getAttribute(e);
      };
      var o = typeof t.model != "object" ? t.model : t.model.key;
      var i = typeof t.model != "object" || typeof t.model.value == "undefined" ? n : t.model.value;
      t.model = {
        key: o,
        value: i
      };
    }
    function Dm(t, e) {
      var n = new Ws(t.view);
      return function (o, i, r) {
        var s = n.match(i.viewItem);
        if (!s) {
          return;
        }
        var a = t.model.key;
        var c = typeof t.model.value == "function" ? t.model.value(i.viewItem, r) : t.model.value;
        if (c === null) {
          return;
        }
        if (Em(t.view, i.viewItem)) {
          s.match.name = true;
        } else {
          delete s.match.name;
        }
        if (!r.consumable.test(i.viewItem, s.match)) {
          return;
        }
        if (!i.modelRange) {
          i = Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
        }
        var l = Mm(i.modelRange, {
          key: a,
          value: c
        }, e, r);
        if (l) {
          r.consumable.consume(i.viewItem, s.match);
        }
      };
    }
    function Em(t, e) {
      var n = typeof t == "function" ? t(e) : t;
      if (typeof n == "object" && !Am(n)) {
        return false;
      }
      return !n.classes && !n.attributes && !n.styles;
    }
    function Mm(t, e, n, o) {
      var i = false;
      for (var _i63 = 0, _Array$from3 = Array.from(t.getItems({
          shallow: n
        })); _i63 < _Array$from3.length; _i63++) {
        var _r17 = _Array$from3[_i63];
        if (o.schema.checkAttribute(_r17, e.key)) {
          o.writer.setAttribute(e.key, e.value, _r17);
          i = true;
        }
      }
      return i;
    }
    function Sm(t) {
      var e = t.model;
      t.model = function (t, n) {
        var o = typeof e == "string" ? e : e(t, n);
        return n.writer.createElement("$marker", {
          "data-name": o
        });
      };
    }
    function Tm(t, e) {
      var n = {};
      n.view = t.view + "-" + e;
      n.model = function (e, n) {
        var o = e.getAttribute("name");
        var i = t.model(o, n);
        return n.writer.createElement("$marker", {
          "data-name": i
        });
      };
      return n;
    }
    var Im = /*#__PURE__*/function () {
      function Im(t, e) {
        var _this53 = this;
        _classCallCheck(this, Im);
        this.model = t;
        this.view = new Uh(e);
        this.mapper = new nf();
        this.downcastDispatcher = new sf({
          mapper: this.mapper,
          schema: t.schema
        });
        var n = this.model.document;
        var o = n.selection;
        var i = this.model.markers;
        this.listenTo(this.model, "_beforeChanges", function () {
          _this53.view._disableRendering(true);
        }, {
          priority: "highest"
        });
        this.listenTo(this.model, "_afterChanges", function () {
          _this53.view._disableRendering(false);
        }, {
          priority: "lowest"
        });
        this.listenTo(n, "change", function () {
          _this53.view.change(function (t) {
            _this53.downcastDispatcher.convertChanges(n.differ, i, t);
            _this53.downcastDispatcher.convertSelection(o, i, t);
          });
        }, {
          priority: "low"
        });
        this.listenTo(this.view.document, "selectionChange", mm(this.model, this.mapper));
        this.downcastDispatcher.on("insert:$text", Nf(), {
          priority: "lowest"
        });
        this.downcastDispatcher.on("remove", Pf(), {
          priority: "low"
        });
        this.downcastDispatcher.on("selection", Of(), {
          priority: "low"
        });
        this.downcastDispatcher.on("selection", zf(), {
          priority: "low"
        });
        this.downcastDispatcher.on("selection", Lf(), {
          priority: "low"
        });
        this.view.document.roots.bindTo(this.model.document.roots).using(function (t) {
          if (t.rootName == "$graveyard") {
            return null;
          }
          var e = new dl(_this53.view.document, t.name);
          e.rootName = t.rootName;
          _this53.mapper.bindElements(t, e);
          return e;
        });
      }
      _createClass(Im, [{
        key: "destroy",
        value: function destroy() {
          this.view.destroy();
          this.stopListening();
        }
      }]);
      return Im;
    }();
    _s(Im, Zc);
    var Nm = /*#__PURE__*/function () {
      function Nm() {
        _classCallCheck(this, Nm);
        this._commands = new Map();
      }
      _createClass(Nm, [{
        key: "add",
        value: function add(t, e) {
          this._commands.set(t, e);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._commands.get(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var n = this.get(t);
          if (!n) {
            throw new ss["a"]("commandcollection-command-not-found", this, {
              commandName: t
            });
          }
          for (var _len16 = arguments.length, e = new Array(_len16 > 1 ? _len16 - 1 : 0), _key16 = 1; _key16 < _len16; _key16++) {
            e[_key16 - 1] = arguments[_key16];
          }
          return n.execute.apply(n, e);
        }
      }, {
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          return _regeneratorRuntime().wrap(function names$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.delegateYield(this._commands.keys(), "t0", 1);
              case 1:
              case "end":
                return _context20.stop();
            }
          }, names, this);
        })
      }, {
        key: "commands",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function commands() {
          return _regeneratorRuntime().wrap(function commands$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.delegateYield(this._commands.values(), "t0", 1);
              case 1:
              case "end":
                return _context21.stop();
            }
          }, commands, this);
        })
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._commands[Symbol.iterator]();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator166 = _createForOfIteratorHelper(this.commands()),
            _step166;
          try {
            for (_iterator166.s(); !(_step166 = _iterator166.n()).done;) {
              var _t133 = _step166.value;
              _t133.destroy();
            }
          } catch (err) {
            _iterator166.e(err);
          } finally {
            _iterator166.f();
          }
        }
      }]);
      return Nm;
    }();
    var Pm = /*#__PURE__*/function () {
      function Pm() {
        _classCallCheck(this, Pm);
        this._consumables = new Map();
      }
      _createClass(Pm, [{
        key: "add",
        value: function add(t, e) {
          var n;
          if (t.is("$text") || t.is("documentFragment")) {
            this._consumables.set(t, true);
            return;
          }
          if (!this._consumables.has(t)) {
            n = new Bm(t);
            this._consumables.set(t, n);
          } else {
            n = this._consumables.get(t);
          }
          n.add(e);
        }
      }, {
        key: "test",
        value: function test(t, e) {
          var n = this._consumables.get(t);
          if (n === undefined) {
            return null;
          }
          if (t.is("$text") || t.is("documentFragment")) {
            return n;
          }
          return n.test(e);
        }
      }, {
        key: "consume",
        value: function consume(t, e) {
          if (this.test(t, e)) {
            if (t.is("$text") || t.is("documentFragment")) {
              this._consumables.set(t, false);
            } else {
              this._consumables.get(t).consume(e);
            }
            return true;
          }
          return false;
        }
      }, {
        key: "revert",
        value: function revert(t, e) {
          var n = this._consumables.get(t);
          if (n !== undefined) {
            if (t.is("$text") || t.is("documentFragment")) {
              this._consumables.set(t, true);
            } else {
              n.revert(e);
            }
          }
        }
      }], [{
        key: "consumablesFromElement",
        value: function consumablesFromElement(t) {
          var e = {
            element: t,
            name: true,
            attributes: [],
            classes: [],
            styles: []
          };
          var n = t.getAttributeKeys();
          var _iterator167 = _createForOfIteratorHelper(n),
            _step167;
          try {
            for (_iterator167.s(); !(_step167 = _iterator167.n()).done;) {
              var _t134 = _step167.value;
              if (_t134 == "style" || _t134 == "class") {
                continue;
              }
              e.attributes.push(_t134);
            }
          } catch (err) {
            _iterator167.e(err);
          } finally {
            _iterator167.f();
          }
          var o = t.getClassNames();
          var _iterator168 = _createForOfIteratorHelper(o),
            _step168;
          try {
            for (_iterator168.s(); !(_step168 = _iterator168.n()).done;) {
              var _t135 = _step168.value;
              e.classes.push(_t135);
            }
          } catch (err) {
            _iterator168.e(err);
          } finally {
            _iterator168.f();
          }
          var i = t.getStyleNames();
          var _iterator169 = _createForOfIteratorHelper(i),
            _step169;
          try {
            for (_iterator169.s(); !(_step169 = _iterator169.n()).done;) {
              var _t136 = _step169.value;
              e.styles.push(_t136);
            }
          } catch (err) {
            _iterator169.e(err);
          } finally {
            _iterator169.f();
          }
          return e;
        }
      }, {
        key: "createFrom",
        value: function createFrom(t, e) {
          if (!e) {
            e = new Pm(t);
          }
          if (t.is("$text")) {
            e.add(t);
            return e;
          }
          if (t.is("element")) {
            e.add(t, Pm.consumablesFromElement(t));
          }
          if (t.is("documentFragment")) {
            e.add(t);
          }
          var _iterator170 = _createForOfIteratorHelper(t.getChildren()),
            _step170;
          try {
            for (_iterator170.s(); !(_step170 = _iterator170.n()).done;) {
              var _n107 = _step170.value;
              e = Pm.createFrom(_n107, e);
            }
          } catch (err) {
            _iterator170.e(err);
          } finally {
            _iterator170.f();
          }
          return e;
        }
      }]);
      return Pm;
    }();
    var Bm = /*#__PURE__*/function () {
      function Bm(t) {
        _classCallCheck(this, Bm);
        this.element = t;
        this._canConsumeName = null;
        this._consumables = {
          attributes: new Map(),
          styles: new Map(),
          classes: new Map()
        };
      }
      _createClass(Bm, [{
        key: "add",
        value: function add(t) {
          if (t.name) {
            this._canConsumeName = true;
          }
          for (var _e129 in this._consumables) {
            if (_e129 in t) {
              this._add(_e129, t[_e129]);
            }
          }
        }
      }, {
        key: "test",
        value: function test(t) {
          if (t.name && !this._canConsumeName) {
            return this._canConsumeName;
          }
          for (var _e130 in this._consumables) {
            if (_e130 in t) {
              var _n108 = this._test(_e130, t[_e130]);
              if (_n108 !== true) {
                return _n108;
              }
            }
          }
          return true;
        }
      }, {
        key: "consume",
        value: function consume(t) {
          if (t.name) {
            this._canConsumeName = false;
          }
          for (var _e131 in this._consumables) {
            if (_e131 in t) {
              this._consume(_e131, t[_e131]);
            }
          }
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (t.name) {
            this._canConsumeName = true;
          }
          for (var _e132 in this._consumables) {
            if (_e132 in t) {
              this._revert(_e132, t[_e132]);
            }
          }
        }
      }, {
        key: "_add",
        value: function _add(t, e) {
          var n = Qe(e) ? e : [e];
          var o = this._consumables[t];
          var _iterator171 = _createForOfIteratorHelper(n),
            _step171;
          try {
            for (_iterator171.s(); !(_step171 = _iterator171.n()).done;) {
              var _e133 = _step171.value;
              if (t === "attributes" && (_e133 === "class" || _e133 === "style")) {
                throw new ss["a"]("viewconsumable-invalid-attribute", this);
              }
              o.set(_e133, true);
              if (t === "styles") {
                var _iterator172 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e133)),
                  _step172;
                try {
                  for (_iterator172.s(); !(_step172 = _iterator172.n()).done;) {
                    var _t137 = _step172.value;
                    o.set(_t137, true);
                  }
                } catch (err) {
                  _iterator172.e(err);
                } finally {
                  _iterator172.f();
                }
              }
            }
          } catch (err) {
            _iterator171.e(err);
          } finally {
            _iterator171.f();
          }
        }
      }, {
        key: "_test",
        value: function _test(t, e) {
          var n = Qe(e) ? e : [e];
          var o = this._consumables[t];
          var _iterator173 = _createForOfIteratorHelper(n),
            _step173;
          try {
            for (_iterator173.s(); !(_step173 = _iterator173.n()).done;) {
              var _e134 = _step173.value;
              if (t === "attributes" && (_e134 === "class" || _e134 === "style")) {
                var _t138 = _e134 == "class" ? "classes" : "styles";
                var _n109 = this._test(_t138, _toConsumableArray(this._consumables[_t138].keys()));
                if (_n109 !== true) {
                  return _n109;
                }
              } else {
                var _t139 = o.get(_e134);
                if (_t139 === undefined) {
                  return null;
                }
                if (!_t139) {
                  return false;
                }
              }
            }
          } catch (err) {
            _iterator173.e(err);
          } finally {
            _iterator173.f();
          }
          return true;
        }
      }, {
        key: "_consume",
        value: function _consume(t, e) {
          var n = Qe(e) ? e : [e];
          var o = this._consumables[t];
          var _iterator174 = _createForOfIteratorHelper(n),
            _step174;
          try {
            for (_iterator174.s(); !(_step174 = _iterator174.n()).done;) {
              var _e135 = _step174.value;
              if (t === "attributes" && (_e135 === "class" || _e135 === "style")) {
                var _t140 = _e135 == "class" ? "classes" : "styles";
                this._consume(_t140, _toConsumableArray(this._consumables[_t140].keys()));
              } else {
                o.set(_e135, false);
                if (t == "styles") {
                  var _iterator175 = _createForOfIteratorHelper(this.element.document.stylesProcessor.getRelatedStyles(_e135)),
                    _step175;
                  try {
                    for (_iterator175.s(); !(_step175 = _iterator175.n()).done;) {
                      var _t141 = _step175.value;
                      o.set(_t141, false);
                    }
                  } catch (err) {
                    _iterator175.e(err);
                  } finally {
                    _iterator175.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator174.e(err);
          } finally {
            _iterator174.f();
          }
        }
      }, {
        key: "_revert",
        value: function _revert(t, e) {
          var n = Qe(e) ? e : [e];
          var o = this._consumables[t];
          var _iterator176 = _createForOfIteratorHelper(n),
            _step176;
          try {
            for (_iterator176.s(); !(_step176 = _iterator176.n()).done;) {
              var _e136 = _step176.value;
              if (t === "attributes" && (_e136 === "class" || _e136 === "style")) {
                var _t142 = _e136 == "class" ? "classes" : "styles";
                this._revert(_t142, _toConsumableArray(this._consumables[_t142].keys()));
              } else {
                var _t143 = o.get(_e136);
                if (_t143 === false) {
                  o.set(_e136, true);
                }
              }
            }
          } catch (err) {
            _iterator176.e(err);
          } finally {
            _iterator176.f();
          }
        }
      }]);
      return Bm;
    }();
    var zm = /*#__PURE__*/function () {
      function zm() {
        var _this54 = this;
        _classCallCheck(this, zm);
        this._sourceDefinitions = {};
        this._attributeProperties = {};
        this.decorate("checkChild");
        this.decorate("checkAttribute");
        this.on("checkAttribute", function (t, e) {
          e[0] = new Lm(e[0]);
        }, {
          priority: "highest"
        });
        this.on("checkChild", function (t, e) {
          e[0] = new Lm(e[0]);
          e[1] = _this54.getDefinition(e[1]);
        }, {
          priority: "highest"
        });
      }
      _createClass(zm, [{
        key: "register",
        value: function register(t, e) {
          if (this._sourceDefinitions[t]) {
            throw new ss["a"]("schema-cannot-register-item-twice", this, {
              itemName: t
            });
          }
          this._sourceDefinitions[t] = [Object.assign({}, e)];
          this._clearCache();
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (!this._sourceDefinitions[t]) {
            throw new ss["a"]("schema-cannot-extend-missing-item", this, {
              itemName: t
            });
          }
          this._sourceDefinitions[t].push(Object.assign({}, e));
          this._clearCache();
        }
      }, {
        key: "getDefinitions",
        value: function getDefinitions() {
          if (!this._compiledDefinitions) {
            this._compile();
          }
          return this._compiledDefinitions;
        }
      }, {
        key: "getDefinition",
        value: function getDefinition(t) {
          var e;
          if (typeof t == "string") {
            e = t;
          } else if (t.is && (t.is("$text") || t.is("$textProxy"))) {
            e = "$text";
          } else {
            e = t.name;
          }
          return this.getDefinitions()[e];
        }
      }, {
        key: "isRegistered",
        value: function isRegistered(t) {
          return !!this.getDefinition(t);
        }
      }, {
        key: "isBlock",
        value: function isBlock(t) {
          var e = this.getDefinition(t);
          return !!(e && e.isBlock);
        }
      }, {
        key: "isLimit",
        value: function isLimit(t) {
          var e = this.getDefinition(t);
          if (!e) {
            return false;
          }
          return !!(e.isLimit || e.isObject);
        }
      }, {
        key: "isObject",
        value: function isObject(t) {
          var e = this.getDefinition(t);
          if (!e) {
            return false;
          }
          return !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
        }
      }, {
        key: "isInline",
        value: function isInline(t) {
          var e = this.getDefinition(t);
          return !!(e && e.isInline);
        }
      }, {
        key: "isSelectable",
        value: function isSelectable(t) {
          var e = this.getDefinition(t);
          if (!e) {
            return false;
          }
          return !!(e.isSelectable || e.isObject);
        }
      }, {
        key: "isContent",
        value: function isContent(t) {
          var e = this.getDefinition(t);
          if (!e) {
            return false;
          }
          return !!(e.isContent || e.isObject);
        }
      }, {
        key: "checkChild",
        value: function checkChild(t, e) {
          if (!e) {
            return false;
          }
          return this._checkContextMatch(e, t);
        }
      }, {
        key: "checkAttribute",
        value: function checkAttribute(t, e) {
          var n = this.getDefinition(t.last);
          if (!n) {
            return false;
          }
          return n.allowAttributes.includes(e);
        }
      }, {
        key: "checkMerge",
        value: function checkMerge(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          if (t instanceof Zh) {
            var _e137 = t.nodeBefore;
            var _n110 = t.nodeAfter;
            if (!(_e137 instanceof qh)) {
              throw new ss["a"]("schema-check-merge-no-element-before", this);
            }
            if (!(_n110 instanceof qh)) {
              throw new ss["a"]("schema-check-merge-no-element-after", this);
            }
            return this.checkMerge(_e137, _n110);
          }
          var _iterator177 = _createForOfIteratorHelper(e.getChildren()),
            _step177;
          try {
            for (_iterator177.s(); !(_step177 = _iterator177.n()).done;) {
              var _n111 = _step177.value;
              if (!this.checkChild(t, _n111)) {
                return false;
              }
            }
          } catch (err) {
            _iterator177.e(err);
          } finally {
            _iterator177.f();
          }
          return true;
        }
      }, {
        key: "addChildCheck",
        value: function addChildCheck(t) {
          this.on("checkChild", function (e, _ref10) {
            var _ref11 = _slicedToArray(_ref10, 2),
              n = _ref11[0],
              o = _ref11[1];
            if (!o) {
              return;
            }
            var i = t(n, o);
            if (typeof i == "boolean") {
              e.stop();
              e.return = i;
            }
          }, {
            priority: "high"
          });
        }
      }, {
        key: "addAttributeCheck",
        value: function addAttributeCheck(t) {
          this.on("checkAttribute", function (e, _ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
              n = _ref13[0],
              o = _ref13[1];
            var i = t(n, o);
            if (typeof i == "boolean") {
              e.stop();
              e.return = i;
            }
          }, {
            priority: "high"
          });
        }
      }, {
        key: "setAttributeProperties",
        value: function setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
        }
      }, {
        key: "getAttributeProperties",
        value: function getAttributeProperties(t) {
          return this._attributeProperties[t] || {};
        }
      }, {
        key: "getLimitElement",
        value: function getLimitElement(t) {
          var e;
          if (t instanceof Zh) {
            e = t.parent;
          } else {
            var _n112 = t instanceof ef ? [t] : Array.from(t.getRanges());
            e = _n112.reduce(function (t, e) {
              var n = e.getCommonAncestor();
              if (!t) {
                return n;
              }
              return t.getCommonAncestor(n, {
                includeSelf: true
              });
            }, null);
          }
          while (!this.isLimit(e)) {
            if (e.parent) {
              e = e.parent;
            } else {
              break;
            }
          }
          return e;
        }
      }, {
        key: "checkAttributeInSelection",
        value: function checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            var _n113 = t.getFirstPosition();
            var _o76 = [].concat(_toConsumableArray(_n113.getAncestors()), [new Gh("", t.getAttributes())]);
            return this.checkAttribute(_o76, e);
          } else {
            var _n114 = t.getRanges();
            var _iterator178 = _createForOfIteratorHelper(_n114),
              _step178;
            try {
              for (_iterator178.s(); !(_step178 = _iterator178.n()).done;) {
                var _t144 = _step178.value;
                var _iterator179 = _createForOfIteratorHelper(_t144),
                  _step179;
                try {
                  for (_iterator179.s(); !(_step179 = _iterator179.n()).done;) {
                    var _n115 = _step179.value;
                    if (this.checkAttribute(_n115.item, e)) {
                      return true;
                    }
                  }
                } catch (err) {
                  _iterator179.e(err);
                } finally {
                  _iterator179.f();
                }
              }
            } catch (err) {
              _iterator178.e(err);
            } finally {
              _iterator178.f();
            }
          }
          return false;
        }
      }, {
        key: "getValidRanges",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getValidRanges(t, e) {
          var _iterator180, _step180, _n116;
          return _regeneratorRuntime().wrap(function getValidRanges$(_context22) {
            while (1) switch (_context22.prev = _context22.next) {
              case 0:
                t = Zm(t);
                _iterator180 = _createForOfIteratorHelper(t);
                _context22.prev = 2;
                _iterator180.s();
              case 4:
                if ((_step180 = _iterator180.n()).done) {
                  _context22.next = 9;
                  break;
                }
                _n116 = _step180.value;
                return _context22.delegateYield(this._getValidRangesForRange(_n116, e), "t0", 7);
              case 7:
                _context22.next = 4;
                break;
              case 9:
                _context22.next = 14;
                break;
              case 11:
                _context22.prev = 11;
                _context22.t1 = _context22["catch"](2);
                _iterator180.e(_context22.t1);
              case 14:
                _context22.prev = 14;
                _iterator180.f();
                return _context22.finish(14);
              case 17:
              case "end":
                return _context22.stop();
            }
          }, getValidRanges, this, [[2, 11, 14, 17]]);
        })
      }, {
        key: "getNearestSelectionRange",
        value: function getNearestSelectionRange(t) {
          var _this55 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "both";
          if (this.checkChild(t, "$text")) {
            return new ef(t);
          }
          var n, o;
          var i = t.getAncestors().reverse().find(function (t) {
            return _this55.isLimit(t);
          }) || t.root;
          if (e == "both" || e == "backward") {
            n = new Qh({
              boundaries: ef._createIn(i),
              startPosition: t,
              direction: "backward"
            });
          }
          if (e == "both" || e == "forward") {
            o = new Qh({
              boundaries: ef._createIn(i),
              startPosition: t
            });
          }
          var _iterator181 = _createForOfIteratorHelper($m(n, o)),
            _step181;
          try {
            for (_iterator181.s(); !(_step181 = _iterator181.n()).done;) {
              var _t145 = _step181.value;
              var _e138 = _t145.walker == n ? "elementEnd" : "elementStart";
              var _o77 = _t145.value;
              if (_o77.type == _e138 && this.isObject(_o77.item)) {
                return ef._createOn(_o77.item);
              }
              if (this.checkChild(_o77.nextPosition, "$text")) {
                return new ef(_o77.nextPosition);
              }
            }
          } catch (err) {
            _iterator181.e(err);
          } finally {
            _iterator181.f();
          }
          return null;
        }
      }, {
        key: "findAllowedParent",
        value: function findAllowedParent(t, e) {
          var n = t.parent;
          while (n) {
            if (this.checkChild(n, e)) {
              return n;
            }
            if (this.isLimit(n)) {
              return null;
            }
            n = n.parent;
          }
          return null;
        }
      }, {
        key: "removeDisallowedAttributes",
        value: function removeDisallowedAttributes(t, e) {
          var _iterator182 = _createForOfIteratorHelper(t),
            _step182;
          try {
            for (_iterator182.s(); !(_step182 = _iterator182.n()).done;) {
              var _n117 = _step182.value;
              if (_n117.is("$text")) {
                Jm(this, _n117, e);
              } else {
                var _t146 = ef._createIn(_n117);
                var _o78 = _t146.getPositions();
                var _iterator183 = _createForOfIteratorHelper(_o78),
                  _step183;
                try {
                  for (_iterator183.s(); !(_step183 = _iterator183.n()).done;) {
                    var _t147 = _step183.value;
                    var _n118 = _t147.nodeBefore || _t147.parent;
                    Jm(this, _n118, e);
                  }
                } catch (err) {
                  _iterator183.e(err);
                } finally {
                  _iterator183.f();
                }
              }
            }
          } catch (err) {
            _iterator182.e(err);
          } finally {
            _iterator182.f();
          }
        }
      }, {
        key: "createContext",
        value: function createContext(t) {
          return new Lm(t);
        }
      }, {
        key: "_clearCache",
        value: function _clearCache() {
          this._compiledDefinitions = null;
        }
      }, {
        key: "_compile",
        value: function _compile() {
          var t = {};
          var e = this._sourceDefinitions;
          var n = Object.keys(e);
          for (var _i64 = 0, _n119 = n; _i64 < _n119.length; _i64++) {
            var _o79 = _n119[_i64];
            t[_o79] = Om(e[_o79], _o79);
          }
          for (var _i65 = 0, _n120 = n; _i65 < _n120.length; _i65++) {
            var _e139 = _n120[_i65];
            Rm(t, _e139);
          }
          for (var _i66 = 0, _n121 = n; _i66 < _n121.length; _i66++) {
            var _e140 = _n121[_i66];
            jm(t, _e140);
          }
          for (var _i67 = 0, _n122 = n; _i67 < _n122.length; _i67++) {
            var _e141 = _n122[_i67];
            Fm(t, _e141);
            Vm(t, _e141);
          }
          for (var _i68 = 0, _n123 = n; _i68 < _n123.length; _i68++) {
            var _e142 = _n123[_i68];
            Um(t, _e142);
            Hm(t, _e142);
          }
          this._compiledDefinitions = t;
        }
      }, {
        key: "_checkContextMatch",
        value: function _checkContextMatch(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length - 1;
          var o = e.getItem(n);
          if (t.allowIn.includes(o.name)) {
            if (n == 0) {
              return true;
            } else {
              var _t148 = this.getDefinition(o);
              return this._checkContextMatch(_t148, e, n - 1);
            }
          } else {
            return false;
          }
        }
      }, {
        key: "_getValidRangesForRange",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function _getValidRangesForRange(t, e) {
          var n, o, _iterator184, _step184, _i69;
          return _regeneratorRuntime().wrap(function _getValidRangesForRange$(_context23) {
            while (1) switch (_context23.prev = _context23.next) {
              case 0:
                n = t.start;
                o = t.start;
                _iterator184 = _createForOfIteratorHelper(t.getItems({
                  shallow: true
                }));
                _context23.prev = 3;
                _iterator184.s();
              case 5:
                if ((_step184 = _iterator184.n()).done) {
                  _context23.next = 17;
                  break;
                }
                _i69 = _step184.value;
                if (!_i69.is("element")) {
                  _context23.next = 9;
                  break;
                }
                return _context23.delegateYield(this._getValidRangesForRange(ef._createIn(_i69), e), "t0", 9);
              case 9:
                if (this.checkAttribute(_i69, e)) {
                  _context23.next = 14;
                  break;
                }
                if (n.isEqual(o)) {
                  _context23.next = 13;
                  break;
                }
                _context23.next = 13;
                return new ef(n, o);
              case 13:
                n = Zh._createAfter(_i69);
              case 14:
                o = Zh._createAfter(_i69);
              case 15:
                _context23.next = 5;
                break;
              case 17:
                _context23.next = 22;
                break;
              case 19:
                _context23.prev = 19;
                _context23.t1 = _context23["catch"](3);
                _iterator184.e(_context23.t1);
              case 22:
                _context23.prev = 22;
                _iterator184.f();
                return _context23.finish(22);
              case 25:
                if (n.isEqual(o)) {
                  _context23.next = 28;
                  break;
                }
                _context23.next = 28;
                return new ef(n, o);
              case 28:
              case "end":
                return _context23.stop();
            }
          }, _getValidRangesForRange, this, [[3, 19, 22, 25]]);
        })
      }]);
      return zm;
    }();
    _s(zm, Zc);
    var Lm = /*#__PURE__*/function () {
      function Lm(t) {
        _classCallCheck(this, Lm);
        if (t instanceof Lm) {
          return t;
        }
        if (typeof t == "string") {
          t = [t];
        } else if (!Array.isArray(t)) {
          t = t.getAncestors({
            includeSelf: true
          });
        }
        if (t[0] && typeof t[0] != "string" && t[0].is("documentFragment")) {
          t.shift();
        }
        this._items = t.map(Qm);
      }
      _createClass(Lm, [{
        key: Symbol.iterator,
        value: function value() {
          return this._items[Symbol.iterator]();
        }
      }, {
        key: "push",
        value: function push(t) {
          var e = new Lm([t]);
          e._items = [].concat(_toConsumableArray(this._items), _toConsumableArray(e._items));
          return e;
        }
      }, {
        key: "getItem",
        value: function getItem(t) {
          return this._items[t];
        }
      }, {
        key: "getNames",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getNames() {
          return _regeneratorRuntime().wrap(function getNames$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.delegateYield(this._items.map(function (t) {
                  return t.name;
                }), "t0", 1);
              case 1:
              case "end":
                return _context24.stop();
            }
          }, getNames, this);
        })
      }, {
        key: "endsWith",
        value: function endsWith(t) {
          return Array.from(this.getNames()).join(" ").endsWith(t);
        }
      }, {
        key: "startsWith",
        value: function startsWith(t) {
          return Array.from(this.getNames()).join(" ").startsWith(t);
        }
      }, {
        key: "length",
        get: function get() {
          return this._items.length;
        }
      }, {
        key: "last",
        get: function get() {
          return this._items[this._items.length - 1];
        }
      }]);
      return Lm;
    }();
    function Om(t, e) {
      var n = {
        name: e,
        allowIn: [],
        allowContentOf: [],
        allowWhere: [],
        allowAttributes: [],
        allowAttributesOf: [],
        inheritTypesFrom: []
      };
      Gm(t, n);
      Wm(t, n, "allowIn");
      Wm(t, n, "allowContentOf");
      Wm(t, n, "allowWhere");
      Wm(t, n, "allowAttributes");
      Wm(t, n, "allowAttributesOf");
      Wm(t, n, "inheritTypesFrom");
      Km(t, n);
      return n;
    }
    function Rm(t, e) {
      var _iterator185 = _createForOfIteratorHelper(t[e].allowContentOf),
        _step185;
      try {
        for (_iterator185.s(); !(_step185 = _iterator185.n()).done;) {
          var _n124 = _step185.value;
          if (t[_n124]) {
            var _o80 = qm(t, _n124);
            _o80.forEach(function (t) {
              t.allowIn.push(e);
            });
          }
        }
      } catch (err) {
        _iterator185.e(err);
      } finally {
        _iterator185.f();
      }
      delete t[e].allowContentOf;
    }
    function jm(t, e) {
      var _iterator186 = _createForOfIteratorHelper(t[e].allowWhere),
        _step186;
      try {
        for (_iterator186.s(); !(_step186 = _iterator186.n()).done;) {
          var _n125 = _step186.value;
          var _o81 = t[_n125];
          if (_o81) {
            var _t$e$allowIn;
            var _n126 = _o81.allowIn;
            (_t$e$allowIn = t[e].allowIn).push.apply(_t$e$allowIn, _toConsumableArray(_n126));
          }
        }
      } catch (err) {
        _iterator186.e(err);
      } finally {
        _iterator186.f();
      }
      delete t[e].allowWhere;
    }
    function Fm(t, e) {
      var _iterator187 = _createForOfIteratorHelper(t[e].allowAttributesOf),
        _step187;
      try {
        for (_iterator187.s(); !(_step187 = _iterator187.n()).done;) {
          var _n127 = _step187.value;
          var _o82 = t[_n127];
          if (_o82) {
            var _t$e$allowAttributes;
            var _n128 = _o82.allowAttributes;
            (_t$e$allowAttributes = t[e].allowAttributes).push.apply(_t$e$allowAttributes, _toConsumableArray(_n128));
          }
        }
      } catch (err) {
        _iterator187.e(err);
      } finally {
        _iterator187.f();
      }
      delete t[e].allowAttributesOf;
    }
    function Vm(t, e) {
      var n = t[e];
      var _iterator188 = _createForOfIteratorHelper(n.inheritTypesFrom),
        _step188;
      try {
        for (_iterator188.s(); !(_step188 = _iterator188.n()).done;) {
          var _e143 = _step188.value;
          var _o83 = t[_e143];
          if (_o83) {
            var _t149 = Object.keys(_o83).filter(function (t) {
              return t.startsWith("is");
            });
            var _iterator189 = _createForOfIteratorHelper(_t149),
              _step189;
            try {
              for (_iterator189.s(); !(_step189 = _iterator189.n()).done;) {
                var _e144 = _step189.value;
                if (!(_e144 in n)) {
                  n[_e144] = _o83[_e144];
                }
              }
            } catch (err) {
              _iterator189.e(err);
            } finally {
              _iterator189.f();
            }
          }
        }
      } catch (err) {
        _iterator188.e(err);
      } finally {
        _iterator188.f();
      }
      delete n.inheritTypesFrom;
    }
    function Um(t, e) {
      var n = t[e];
      var o = n.allowIn.filter(function (e) {
        return t[e];
      });
      n.allowIn = Array.from(new Set(o));
    }
    function Hm(t, e) {
      var n = t[e];
      n.allowAttributes = Array.from(new Set(n.allowAttributes));
    }
    function Gm(t, e) {
      var _iterator190 = _createForOfIteratorHelper(t),
        _step190;
      try {
        for (_iterator190.s(); !(_step190 = _iterator190.n()).done;) {
          var _n129 = _step190.value;
          var _t150 = Object.keys(_n129).filter(function (t) {
            return t.startsWith("is");
          });
          var _iterator191 = _createForOfIteratorHelper(_t150),
            _step191;
          try {
            for (_iterator191.s(); !(_step191 = _iterator191.n()).done;) {
              var _o84 = _step191.value;
              e[_o84] = _n129[_o84];
            }
          } catch (err) {
            _iterator191.e(err);
          } finally {
            _iterator191.f();
          }
        }
      } catch (err) {
        _iterator190.e(err);
      } finally {
        _iterator190.f();
      }
    }
    function Wm(t, e, n) {
      var _iterator192 = _createForOfIteratorHelper(t),
        _step192;
      try {
        for (_iterator192.s(); !(_step192 = _iterator192.n()).done;) {
          var _o85 = _step192.value;
          if (typeof _o85[n] == "string") {
            e[n].push(_o85[n]);
          } else if (Array.isArray(_o85[n])) {
            var _e$n;
            (_e$n = e[n]).push.apply(_e$n, _toConsumableArray(_o85[n]));
          }
        }
      } catch (err) {
        _iterator192.e(err);
      } finally {
        _iterator192.f();
      }
    }
    function Km(t, e) {
      var _iterator193 = _createForOfIteratorHelper(t),
        _step193;
      try {
        for (_iterator193.s(); !(_step193 = _iterator193.n()).done;) {
          var _n130 = _step193.value;
          var _t151 = _n130.inheritAllFrom;
          if (_t151) {
            e.allowContentOf.push(_t151);
            e.allowWhere.push(_t151);
            e.allowAttributesOf.push(_t151);
            e.inheritTypesFrom.push(_t151);
          }
        }
      } catch (err) {
        _iterator193.e(err);
      } finally {
        _iterator193.f();
      }
    }
    function qm(t, e) {
      var n = t[e];
      return Ym(t).filter(function (t) {
        return t.allowIn.includes(n.name);
      });
    }
    function Ym(t) {
      return Object.keys(t).map(function (e) {
        return t[e];
      });
    }
    function Qm(t) {
      if (typeof t == "string") {
        return {
          name: t,
          getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
            return _regeneratorRuntime().wrap(function getAttributeKeys$(_context25) {
              while (1) switch (_context25.prev = _context25.next) {
                case 0:
                case "end":
                  return _context25.stop();
              }
            }, getAttributeKeys);
          }),
          getAttribute: function getAttribute() {}
        };
      } else {
        return {
          name: t.is("element") ? t.name : "$text",
          getAttributeKeys: /*#__PURE__*/_regeneratorRuntime().mark(function getAttributeKeys() {
            return _regeneratorRuntime().wrap(function getAttributeKeys$(_context26) {
              while (1) switch (_context26.prev = _context26.next) {
                case 0:
                  return _context26.delegateYield(t.getAttributeKeys(), "t0", 1);
                case 1:
                case "end":
                  return _context26.stop();
              }
            }, getAttributeKeys);
          }),
          getAttribute: function getAttribute(e) {
            return t.getAttribute(e);
          }
        };
      }
    }
    function $m(t, e) {
      var n, _e145, _t152;
      return _regeneratorRuntime().wrap(function $m$(_context27) {
        while (1) switch (_context27.prev = _context27.next) {
          case 0:
            n = false;
          case 1:
            if (n) {
              _context27.next = 17;
              break;
            }
            n = true;
            if (!t) {
              _context27.next = 9;
              break;
            }
            _e145 = t.next();
            if (_e145.done) {
              _context27.next = 9;
              break;
            }
            n = false;
            _context27.next = 9;
            return {
              walker: t,
              value: _e145.value
            };
          case 9:
            if (!e) {
              _context27.next = 15;
              break;
            }
            _t152 = e.next();
            if (_t152.done) {
              _context27.next = 15;
              break;
            }
            n = false;
            _context27.next = 15;
            return {
              walker: e,
              value: _t152.value
            };
          case 15:
            _context27.next = 1;
            break;
          case 17:
          case "end":
            return _context27.stop();
        }
      }, _marked);
    }
    function Zm(t) {
      var _iterator194, _step194, _e146;
      return _regeneratorRuntime().wrap(function Zm$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            _iterator194 = _createForOfIteratorHelper(t);
            _context28.prev = 1;
            _iterator194.s();
          case 3:
            if ((_step194 = _iterator194.n()).done) {
              _context28.next = 8;
              break;
            }
            _e146 = _step194.value;
            return _context28.delegateYield(_e146.getMinimalFlatRanges(), "t0", 6);
          case 6:
            _context28.next = 3;
            break;
          case 8:
            _context28.next = 13;
            break;
          case 10:
            _context28.prev = 10;
            _context28.t1 = _context28["catch"](1);
            _iterator194.e(_context28.t1);
          case 13:
            _context28.prev = 13;
            _iterator194.f();
            return _context28.finish(13);
          case 16:
          case "end":
            return _context28.stop();
        }
      }, _marked2, null, [[1, 10, 13, 16]]);
    }
    function Jm(t, e, n) {
      var _iterator195 = _createForOfIteratorHelper(e.getAttributeKeys()),
        _step195;
      try {
        for (_iterator195.s(); !(_step195 = _iterator195.n()).done;) {
          var _o86 = _step195.value;
          if (!t.checkAttribute(e, _o86)) {
            n.removeAttribute(_o86, e);
          }
        }
      } catch (err) {
        _iterator195.e(err);
      } finally {
        _iterator195.f();
      }
    }
    var Xm = /*#__PURE__*/function () {
      function Xm() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, Xm);
        this._splitParts = new Map();
        this._cursorParents = new Map();
        this._modelCursor = null;
        this.conversionApi = Object.assign({}, t);
        this.conversionApi.convertItem = this._convertItem.bind(this);
        this.conversionApi.convertChildren = this._convertChildren.bind(this);
        this.conversionApi.safeInsert = this._safeInsert.bind(this);
        this.conversionApi.updateConversionResult = this._updateConversionResult.bind(this);
        this.conversionApi.splitToAllowedParent = this._splitToAllowedParent.bind(this);
        this.conversionApi.getSplitParts = this._getSplitParts.bind(this);
      }
      _createClass(Xm, [{
        key: "convert",
        value: function convert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["$root"];
          this.fire("viewCleanup", t);
          this._modelCursor = eg(n, e);
          this.conversionApi.writer = e;
          this.conversionApi.consumable = Pm.createFrom(t);
          this.conversionApi.store = {};
          var _this$_convertItem = this._convertItem(t, this._modelCursor),
            o = _this$_convertItem.modelRange;
          var i = e.createDocumentFragment();
          if (o) {
            this._removeEmptyElements();
            for (var _i70 = 0, _Array$from4 = Array.from(this._modelCursor.parent.getChildren()); _i70 < _Array$from4.length; _i70++) {
              var _t153 = _Array$from4[_i70];
              e.append(_t153, i);
            }
            i.markers = tg(i, e);
          }
          this._modelCursor = null;
          this._splitParts.clear();
          this._cursorParents.clear();
          this.conversionApi.writer = null;
          this.conversionApi.store = null;
          return i;
        }
      }, {
        key: "_convertItem",
        value: function _convertItem(t, e) {
          var n = Object.assign({
            viewItem: t,
            modelCursor: e,
            modelRange: null
          });
          if (t.is("element")) {
            this.fire("element:" + t.name, n, this.conversionApi);
          } else if (t.is("$text")) {
            this.fire("text", n, this.conversionApi);
          } else {
            this.fire("documentFragment", n, this.conversionApi);
          }
          if (n.modelRange && !(n.modelRange instanceof ef)) {
            throw new ss["a"]("view-conversion-dispatcher-incorrect-result", this);
          }
          return {
            modelRange: n.modelRange,
            modelCursor: n.modelCursor
          };
        }
      }, {
        key: "_convertChildren",
        value: function _convertChildren(t, e) {
          var n = e.is("position") ? e : Zh._createAt(e, 0);
          var o = new ef(n);
          for (var _i71 = 0, _Array$from5 = Array.from(t.getChildren()); _i71 < _Array$from5.length; _i71++) {
            var _e147 = _Array$from5[_i71];
            var _t154 = this._convertItem(_e147, n);
            if (_t154.modelRange instanceof ef) {
              o.end = _t154.modelRange.end;
              n = _t154.modelCursor;
            }
          }
          return {
            modelRange: o,
            modelCursor: n
          };
        }
      }, {
        key: "_safeInsert",
        value: function _safeInsert(t, e) {
          var n = this._splitToAllowedParent(t, e);
          if (!n) {
            return false;
          }
          this.conversionApi.writer.insert(t, n.position);
          return true;
        }
      }, {
        key: "_updateConversionResult",
        value: function _updateConversionResult(t, e) {
          var n = this._getSplitParts(t);
          var o = this.conversionApi.writer;
          if (!e.modelRange) {
            e.modelRange = o.createRange(o.createPositionBefore(t), o.createPositionAfter(n[n.length - 1]));
          }
          var i = this._cursorParents.get(t);
          if (i) {
            e.modelCursor = o.createPositionAt(i, 0);
          } else {
            e.modelCursor = e.modelRange.end;
          }
        }
      }, {
        key: "_splitToAllowedParent",
        value: function _splitToAllowedParent(t, e) {
          var _this$conversionApi = this.conversionApi,
            n = _this$conversionApi.schema,
            o = _this$conversionApi.writer;
          var i = n.findAllowedParent(e, t);
          if (i) {
            if (i === e.parent) {
              return {
                position: e
              };
            }
            if (this._modelCursor.parent.getAncestors().includes(i)) {
              i = null;
            }
          }
          if (!i) {
            if (!lm(e, t, n)) {
              return null;
            }
            return {
              position: dm(e, o)
            };
          }
          var r = this.conversionApi.writer.split(e, i);
          var s = [];
          var _iterator196 = _createForOfIteratorHelper(r.range.getWalker()),
            _step196;
          try {
            for (_iterator196.s(); !(_step196 = _iterator196.n()).done;) {
              var _t155 = _step196.value;
              if (_t155.type == "elementEnd") {
                s.push(_t155.item);
              } else {
                var _e148 = s.pop();
                var _n131 = _t155.item;
                this._registerSplitPair(_e148, _n131);
              }
            }
          } catch (err) {
            _iterator196.e(err);
          } finally {
            _iterator196.f();
          }
          var a = r.range.end.parent;
          this._cursorParents.set(t, a);
          return {
            position: r.position,
            cursorParent: a
          };
        }
      }, {
        key: "_registerSplitPair",
        value: function _registerSplitPair(t, e) {
          if (!this._splitParts.has(t)) {
            this._splitParts.set(t, [t]);
          }
          var n = this._splitParts.get(t);
          this._splitParts.set(e, n);
          n.push(e);
        }
      }, {
        key: "_getSplitParts",
        value: function _getSplitParts(t) {
          var e;
          if (!this._splitParts.has(t)) {
            e = [t];
          } else {
            e = this._splitParts.get(t);
          }
          return e;
        }
      }, {
        key: "_removeEmptyElements",
        value: function _removeEmptyElements() {
          var t = false;
          var _iterator197 = _createForOfIteratorHelper(this._splitParts.keys()),
            _step197;
          try {
            for (_iterator197.s(); !(_step197 = _iterator197.n()).done;) {
              var _e149 = _step197.value;
              if (_e149.isEmpty) {
                this.conversionApi.writer.remove(_e149);
                this._splitParts.delete(_e149);
                t = true;
              }
            }
          } catch (err) {
            _iterator197.e(err);
          } finally {
            _iterator197.f();
          }
          if (t) {
            this._removeEmptyElements();
          }
        }
      }]);
      return Xm;
    }();
    _s(Xm, ds);
    function tg(t, e) {
      var n = new Set();
      var o = new Map();
      var i = ef._createIn(t).getItems();
      var _iterator198 = _createForOfIteratorHelper(i),
        _step198;
      try {
        for (_iterator198.s(); !(_step198 = _iterator198.n()).done;) {
          var _t156 = _step198.value;
          if (_t156.name == "$marker") {
            n.add(_t156);
          }
        }
      } catch (err) {
        _iterator198.e(err);
      } finally {
        _iterator198.f();
      }
      var _iterator199 = _createForOfIteratorHelper(n),
        _step199;
      try {
        for (_iterator199.s(); !(_step199 = _iterator199.n()).done;) {
          var _t157 = _step199.value;
          var _n132 = _t157.getAttribute("data-name");
          var _i72 = e.createPositionBefore(_t157);
          if (!o.has(_n132)) {
            o.set(_n132, new ef(_i72.clone()));
          } else {
            o.get(_n132).end = _i72.clone();
          }
          e.remove(_t157);
        }
      } catch (err) {
        _iterator199.e(err);
      } finally {
        _iterator199.f();
      }
      return o;
    }
    function eg(t, e) {
      var n;
      var _iterator200 = _createForOfIteratorHelper(new Lm(t)),
        _step200;
      try {
        for (_iterator200.s(); !(_step200 = _iterator200.n()).done;) {
          var _o87 = _step200.value;
          var _t158 = {};
          var _iterator201 = _createForOfIteratorHelper(_o87.getAttributeKeys()),
            _step201;
          try {
            for (_iterator201.s(); !(_step201 = _iterator201.n()).done;) {
              var _e150 = _step201.value;
              _t158[_e150] = _o87.getAttribute(_e150);
            }
          } catch (err) {
            _iterator201.e(err);
          } finally {
            _iterator201.f();
          }
          var _i73 = e.createElement(_o87.name, _t158);
          if (n) {
            e.append(_i73, n);
          }
          n = Zh._createAt(_i73, 0);
        }
      } catch (err) {
        _iterator200.e(err);
      } finally {
        _iterator200.f();
      }
      return n;
    }
    var ng = /*#__PURE__*/function () {
      function ng(t, e) {
        var _this56 = this;
        _classCallCheck(this, ng);
        this.model = t;
        this.stylesProcessor = e;
        this.processor = undefined;
        this.mapper = new nf();
        this.downcastDispatcher = new sf({
          mapper: this.mapper,
          schema: t.schema
        });
        this.downcastDispatcher.on("insert:$text", Nf(), {
          priority: "lowest"
        });
        this.upcastDispatcher = new Xm({
          schema: t.schema
        });
        this.viewDocument = new bl(e);
        this._viewWriter = new Xl(this.viewDocument);
        this.upcastDispatcher.on("text", fm(), {
          priority: "lowest"
        });
        this.upcastDispatcher.on("element", hm(), {
          priority: "lowest"
        });
        this.upcastDispatcher.on("documentFragment", hm(), {
          priority: "lowest"
        });
        this.decorate("init");
        this.decorate("set");
        this.on("init", function () {
          _this56.fire("ready");
        }, {
          priority: "lowest"
        });
        this.on("ready", function () {
          _this56.model.enqueueChange("transparent", cm);
        }, {
          priority: "lowest"
        });
      }
      _createClass(ng, [{
        key: "get",
        value: function get() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var _t$rootName = t.rootName,
            e = _t$rootName === void 0 ? "main" : _t$rootName,
            _t$trim = t.trim,
            n = _t$trim === void 0 ? "empty" : _t$trim;
          if (!this._checkIfRootsExists([e])) {
            throw new ss["a"]("datacontroller-get-non-existent-root", this);
          }
          var o = this.model.document.getRoot(e);
          if (n === "empty" && !this.model.hasContent(o, {
            ignoreWhitespaces: true
          })) {
            return "";
          }
          return this.stringify(o, t);
        }
      }, {
        key: "stringify",
        value: function stringify(t, e) {
          var n = this.toView(t, e);
          return this.processor.toData(n);
        }
      }, {
        key: "toView",
        value: function toView(t, e) {
          var n = this.viewDocument;
          var o = this._viewWriter;
          this.mapper.clearBindings();
          var i = ef._createIn(t);
          var r = new Zl(n);
          this.mapper.bindElements(t, r);
          this.downcastDispatcher.conversionApi.options = e;
          this.downcastDispatcher.convertInsert(i, o);
          if (!t.is("documentFragment")) {
            var _e151 = og(t);
            var _iterator202 = _createForOfIteratorHelper(_e151),
              _step202;
            try {
              for (_iterator202.s(); !(_step202 = _iterator202.n()).done;) {
                var _step202$value = _slicedToArray(_step202.value, 2),
                  _t159 = _step202$value[0],
                  _n133 = _step202$value[1];
                this.downcastDispatcher.convertMarkerAdd(_t159, _n133, o);
              }
            } catch (err) {
              _iterator202.e(err);
            } finally {
              _iterator202.f();
            }
          }
          delete this.downcastDispatcher.conversionApi.options;
          return r;
        }
      }, {
        key: "init",
        value: function init(t) {
          var _this57 = this;
          if (this.model.document.version) {
            throw new ss["a"]("datacontroller-init-document-not-empty", this);
          }
          var e = {};
          if (typeof t === "string") {
            e.main = t;
          } else {
            e = t;
          }
          if (!this._checkIfRootsExists(Object.keys(e))) {
            throw new ss["a"]("datacontroller-init-non-existent-root", this);
          }
          this.model.enqueueChange("transparent", function (t) {
            for (var _i74 = 0, _Object$keys2 = Object.keys(e); _i74 < _Object$keys2.length; _i74++) {
              var _n134 = _Object$keys2[_i74];
              var _o88 = _this57.model.document.getRoot(_n134);
              t.insert(_this57.parse(e[_n134], _o88), _o88, 0);
            }
          });
          return Promise.resolve();
        }
      }, {
        key: "set",
        value: function set(t) {
          var _this58 = this;
          var e = {};
          if (typeof t === "string") {
            e.main = t;
          } else {
            e = t;
          }
          if (!this._checkIfRootsExists(Object.keys(e))) {
            throw new ss["a"]("datacontroller-set-non-existent-root", this);
          }
          this.model.enqueueChange("transparent", function (t) {
            t.setSelection(null);
            t.removeSelectionAttribute(_this58.model.document.selection.getAttributeKeys());
            for (var _i75 = 0, _Object$keys3 = Object.keys(e); _i75 < _Object$keys3.length; _i75++) {
              var _n135 = _Object$keys3[_i75];
              var _o89 = _this58.model.document.getRoot(_n135);
              t.remove(t.createRangeIn(_o89));
              t.insert(_this58.parse(e[_n135], _o89), _o89, 0);
            }
          });
        }
      }, {
        key: "parse",
        value: function parse(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          var n = this.processor.toView(t);
          return this.toModel(n, e);
        }
      }, {
        key: "toModel",
        value: function toModel(t) {
          var _this59 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "$root";
          return this.model.change(function (n) {
            return _this59.upcastDispatcher.convert(t, n, e);
          });
        }
      }, {
        key: "addStyleProcessorRules",
        value: function addStyleProcessorRules(t) {
          t(this.stylesProcessor);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_checkIfRootsExists",
        value: function _checkIfRootsExists(t) {
          var _iterator203 = _createForOfIteratorHelper(t),
            _step203;
          try {
            for (_iterator203.s(); !(_step203 = _iterator203.n()).done;) {
              var _e152 = _step203.value;
              if (!this.model.document.getRootNames().includes(_e152)) {
                return false;
              }
            }
          } catch (err) {
            _iterator203.e(err);
          } finally {
            _iterator203.f();
          }
          return true;
        }
      }]);
      return ng;
    }();
    _s(ng, Zc);
    function og(t) {
      var e = [];
      var n = t.root.document;
      if (!n) {
        return [];
      }
      var o = ef._createIn(t);
      var _iterator204 = _createForOfIteratorHelper(n.model.markers),
        _step204;
      try {
        for (_iterator204.s(); !(_step204 = _iterator204.n()).done;) {
          var _t160 = _step204.value;
          var _n136 = o.getIntersection(_t160.getRange());
          if (_n136) {
            e.push([_t160.name, _n136]);
          }
        }
      } catch (err) {
        _iterator204.e(err);
      } finally {
        _iterator204.f();
      }
      return e;
    }
    var ig = /*#__PURE__*/function () {
      function ig(t, e) {
        _classCallCheck(this, ig);
        this._helpers = new Map();
        this._downcast = xs(t);
        this._createConversionHelpers({
          name: "downcast",
          dispatchers: this._downcast,
          isDowncast: true
        });
        this._upcast = xs(e);
        this._createConversionHelpers({
          name: "upcast",
          dispatchers: this._upcast,
          isDowncast: false
        });
      }
      _createClass(ig, [{
        key: "addAlias",
        value: function addAlias(t, e) {
          var n = this._downcast.includes(e);
          var o = this._upcast.includes(e);
          if (!o && !n) {
            throw new ss["a"]("conversion-add-alias-dispatcher-not-registered", this);
          }
          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          });
        }
      }, {
        key: "for",
        value: function _for(t) {
          if (!this._helpers.has(t)) {
            throw new ss["a"]("conversion-for-unknown-group", this);
          }
          return this._helpers.get(t);
        }
      }, {
        key: "elementToElement",
        value: function elementToElement(t) {
          this.for("downcast").elementToElement(t);
          var _iterator205 = _createForOfIteratorHelper(rg(t)),
            _step205;
          try {
            for (_iterator205.s(); !(_step205 = _iterator205.n()).done;) {
              var _step205$value = _step205.value,
                _e153 = _step205$value.model,
                _n137 = _step205$value.view;
              this.for("upcast").elementToElement({
                model: _e153,
                view: _n137,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator205.e(err);
          } finally {
            _iterator205.f();
          }
        }
      }, {
        key: "attributeToElement",
        value: function attributeToElement(t) {
          this.for("downcast").attributeToElement(t);
          var _iterator206 = _createForOfIteratorHelper(rg(t)),
            _step206;
          try {
            for (_iterator206.s(); !(_step206 = _iterator206.n()).done;) {
              var _step206$value = _step206.value,
                _e154 = _step206$value.model,
                _n138 = _step206$value.view;
              this.for("upcast").elementToAttribute({
                view: _n138,
                model: _e154,
                converterPriority: t.converterPriority
              });
            }
          } catch (err) {
            _iterator206.e(err);
          } finally {
            _iterator206.f();
          }
        }
      }, {
        key: "attributeToAttribute",
        value: function attributeToAttribute(t) {
          this.for("downcast").attributeToAttribute(t);
          var _iterator207 = _createForOfIteratorHelper(rg(t)),
            _step207;
          try {
            for (_iterator207.s(); !(_step207 = _iterator207.n()).done;) {
              var _step207$value = _step207.value,
                _e155 = _step207$value.model,
                _n139 = _step207$value.view;
              this.for("upcast").attributeToAttribute({
                view: _n139,
                model: _e155
              });
            }
          } catch (err) {
            _iterator207.e(err);
          } finally {
            _iterator207.f();
          }
        }
      }, {
        key: "_createConversionHelpers",
        value: function _createConversionHelpers(_ref14) {
          var t = _ref14.name,
            e = _ref14.dispatchers,
            n = _ref14.isDowncast;
          if (this._helpers.has(t)) {
            throw new ss["a"]("conversion-group-exists", this);
          }
          var o = n ? new If(e) : new um(e);
          this._helpers.set(t, o);
        }
      }]);
      return ig;
    }();
    function rg(t) {
      var _iterator208, _step208, _e156, _n140, _o90, _i76;
      return _regeneratorRuntime().wrap(function rg$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            if (!t.model.values) {
              _context29.next = 22;
              break;
            }
            _iterator208 = _createForOfIteratorHelper(t.model.values);
            _context29.prev = 2;
            _iterator208.s();
          case 4:
            if ((_step208 = _iterator208.n()).done) {
              _context29.next = 12;
              break;
            }
            _e156 = _step208.value;
            _n140 = {
              key: t.model.key,
              value: _e156
            };
            _o90 = t.view[_e156];
            _i76 = t.upcastAlso ? t.upcastAlso[_e156] : undefined;
            return _context29.delegateYield(sg(_n140, _o90, _i76), "t0", 10);
          case 10:
            _context29.next = 4;
            break;
          case 12:
            _context29.next = 17;
            break;
          case 14:
            _context29.prev = 14;
            _context29.t1 = _context29["catch"](2);
            _iterator208.e(_context29.t1);
          case 17:
            _context29.prev = 17;
            _iterator208.f();
            return _context29.finish(17);
          case 20:
            _context29.next = 23;
            break;
          case 22:
            return _context29.delegateYield(sg(t.model, t.view, t.upcastAlso), "t2", 23);
          case 23:
          case "end":
            return _context29.stop();
        }
      }, _marked3, null, [[2, 14, 17, 20]]);
    }
    function sg(t, e, n) {
      var _iterator209, _step209, _e157;
      return _regeneratorRuntime().wrap(function sg$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return {
              model: t,
              view: e
            };
          case 2:
            if (!n) {
              _context30.next = 20;
              break;
            }
            _iterator209 = _createForOfIteratorHelper(xs(n));
            _context30.prev = 4;
            _iterator209.s();
          case 6:
            if ((_step209 = _iterator209.n()).done) {
              _context30.next = 12;
              break;
            }
            _e157 = _step209.value;
            _context30.next = 10;
            return {
              model: t,
              view: _e157
            };
          case 10:
            _context30.next = 6;
            break;
          case 12:
            _context30.next = 17;
            break;
          case 14:
            _context30.prev = 14;
            _context30.t0 = _context30["catch"](4);
            _iterator209.e(_context30.t0);
          case 17:
            _context30.prev = 17;
            _iterator209.f();
            return _context30.finish(17);
          case 20:
          case "end":
            return _context30.stop();
        }
      }, _marked4, null, [[4, 14, 17, 20]]);
    }
    var ag = /*#__PURE__*/function () {
      function ag() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
        _classCallCheck(this, ag);
        this.operations = [];
        this.type = t;
      }
      _createClass(ag, [{
        key: "addOperation",
        value: function addOperation(t) {
          t.batch = this;
          this.operations.push(t);
          return t;
        }
      }, {
        key: "baseVersion",
        get: function get() {
          var _iterator210 = _createForOfIteratorHelper(this.operations),
            _step210;
          try {
            for (_iterator210.s(); !(_step210 = _iterator210.n()).done;) {
              var _t161 = _step210.value;
              if (_t161.baseVersion !== null) {
                return _t161.baseVersion;
              }
            }
          } catch (err) {
            _iterator210.e(err);
          } finally {
            _iterator210.f();
          }
          return null;
        }
      }]);
      return ag;
    }();
    var cg = /*#__PURE__*/function () {
      function cg(t) {
        _classCallCheck(this, cg);
        this.baseVersion = t;
        this.isDocumentOperation = this.baseVersion !== null;
        this.batch = null;
      }
      _createClass(cg, [{
        key: "_validate",
        value: function _validate() {}
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = Object.assign({}, this);
          t.__className = this.constructor.className;
          delete t.batch;
          delete t.isDocumentOperation;
          return t;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          return new this(t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "Operation";
        }
      }]);
      return cg;
    }();
    var lg = /*#__PURE__*/function () {
      function lg(t) {
        _classCallCheck(this, lg);
        this.markers = new Map();
        this._children = new Kh();
        if (t) {
          this._insertChild(0, t);
        }
      }
      _createClass(lg, [{
        key: Symbol.iterator,
        value: function value() {
          return this.getChildren();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "documentFragment" || t === "model:documentFragment";
        }
      }, {
        key: "getChild",
        value: function getChild(t) {
          return this._children.getNode(t);
        }
      }, {
        key: "getChildren",
        value: function getChildren() {
          return this._children[Symbol.iterator]();
        }
      }, {
        key: "getChildIndex",
        value: function getChildIndex(t) {
          return this._children.getNodeIndex(t);
        }
      }, {
        key: "getChildStartOffset",
        value: function getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t);
        }
      }, {
        key: "getPath",
        value: function getPath() {
          return [];
        }
      }, {
        key: "getNodeByPath",
        value: function getNodeByPath(t) {
          var e = this;
          var _iterator211 = _createForOfIteratorHelper(t),
            _step211;
          try {
            for (_iterator211.s(); !(_step211 = _iterator211.n()).done;) {
              var _n141 = _step211.value;
              e = e.getChild(e.offsetToIndex(_n141));
            }
          } catch (err) {
            _iterator211.e(err);
          } finally {
            _iterator211.f();
          }
          return e;
        }
      }, {
        key: "offsetToIndex",
        value: function offsetToIndex(t) {
          return this._children.offsetToIndex(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = [];
          var _iterator212 = _createForOfIteratorHelper(this._children),
            _step212;
          try {
            for (_iterator212.s(); !(_step212 = _iterator212.n()).done;) {
              var _e158 = _step212.value;
              t.push(_e158.toJSON());
            }
          } catch (err) {
            _iterator212.e(err);
          } finally {
            _iterator212.f();
          }
          return t;
        }
      }, {
        key: "_appendChild",
        value: function _appendChild(t) {
          this._insertChild(this.childCount, t);
        }
      }, {
        key: "_insertChild",
        value: function _insertChild(t, e) {
          var n = dg(e);
          var _iterator213 = _createForOfIteratorHelper(n),
            _step213;
          try {
            for (_iterator213.s(); !(_step213 = _iterator213.n()).done;) {
              var _t162 = _step213.value;
              if (_t162.parent !== null) {
                _t162._remove();
              }
              _t162.parent = this;
            }
          } catch (err) {
            _iterator213.e(err);
          } finally {
            _iterator213.f();
          }
          this._children._insertNodes(t, n);
        }
      }, {
        key: "_removeChildren",
        value: function _removeChildren(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
          var n = this._children._removeNodes(t, e);
          var _iterator214 = _createForOfIteratorHelper(n),
            _step214;
          try {
            for (_iterator214.s(); !(_step214 = _iterator214.n()).done;) {
              var _t163 = _step214.value;
              _t163.parent = null;
            }
          } catch (err) {
            _iterator214.e(err);
          } finally {
            _iterator214.f();
          }
          return n;
        }
      }, {
        key: "childCount",
        get: function get() {
          return this._children.length;
        }
      }, {
        key: "maxOffset",
        get: function get() {
          return this._children.maxOffset;
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return this.childCount === 0;
        }
      }, {
        key: "root",
        get: function get() {
          return this;
        }
      }, {
        key: "parent",
        get: function get() {
          return null;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t) {
          var e = [];
          var _iterator215 = _createForOfIteratorHelper(t),
            _step215;
          try {
            for (_iterator215.s(); !(_step215 = _iterator215.n()).done;) {
              var _n142 = _step215.value;
              if (_n142.name) {
                e.push(qh.fromJSON(_n142));
              } else {
                e.push(Gh.fromJSON(_n142));
              }
            }
          } catch (err) {
            _iterator215.e(err);
          } finally {
            _iterator215.f();
          }
          return new lg(e);
        }
      }]);
      return lg;
    }();
    function dg(t) {
      if (typeof t == "string") {
        return [new Gh(t)];
      }
      if (!As(t)) {
        t = [t];
      }
      return Array.from(t).map(function (t) {
        if (typeof t == "string") {
          return new Gh(t);
        }
        if (t instanceof Wh) {
          return new Gh(t.data, t.getAttributes());
        }
        return t;
      });
    }
    function ug(t, e) {
      e = gg(e);
      var n = e.reduce(function (t, e) {
        return t + e.offsetSize;
      }, 0);
      var o = t.parent;
      kg(t);
      var i = t.index;
      o._insertChild(i, e);
      pg(o, i + e.length);
      pg(o, i);
      return new ef(t, t.getShiftedBy(n));
    }
    function hg(t) {
      if (!t.isFlat) {
        throw new ss["a"]("operation-utils-remove-range-not-flat", this);
      }
      var e = t.start.parent;
      kg(t.start);
      kg(t.end);
      var n = e._removeChildren(t.start.index, t.end.index - t.start.index);
      pg(e, t.start.index);
      return n;
    }
    function fg(t, e) {
      if (!t.isFlat) {
        throw new ss["a"]("operation-utils-move-range-not-flat", this);
      }
      var n = hg(t);
      e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset);
      return ug(e, n);
    }
    function mg(t, e, n) {
      kg(t.start);
      kg(t.end);
      var _iterator216 = _createForOfIteratorHelper(t.getItems({
          shallow: true
        })),
        _step216;
      try {
        for (_iterator216.s(); !(_step216 = _iterator216.n()).done;) {
          var _o91 = _step216.value;
          var _t164 = _o91.is("$textProxy") ? _o91.textNode : _o91;
          if (n !== null) {
            _t164._setAttribute(e, n);
          } else {
            _t164._removeAttribute(e);
          }
          pg(_t164.parent, _t164.index);
        }
      } catch (err) {
        _iterator216.e(err);
      } finally {
        _iterator216.f();
      }
      pg(t.end.parent, t.end.index);
    }
    function gg(t) {
      var e = [];
      if (!(t instanceof Array)) {
        t = [t];
      }
      for (var _n143 = 0; _n143 < t.length; _n143++) {
        if (typeof t[_n143] == "string") {
          e.push(new Gh(t[_n143]));
        } else if (t[_n143] instanceof Wh) {
          e.push(new Gh(t[_n143].data, t[_n143].getAttributes()));
        } else if (t[_n143] instanceof lg || t[_n143] instanceof Kh) {
          var _iterator217 = _createForOfIteratorHelper(t[_n143]),
            _step217;
          try {
            for (_iterator217.s(); !(_step217 = _iterator217.n()).done;) {
              var _o92 = _step217.value;
              e.push(_o92);
            }
          } catch (err) {
            _iterator217.e(err);
          } finally {
            _iterator217.f();
          }
        } else if (t[_n143] instanceof Hh) {
          e.push(t[_n143]);
        }
      }
      for (var _t165 = 1; _t165 < e.length; _t165++) {
        var _n144 = e[_t165];
        var _o93 = e[_t165 - 1];
        if (_n144 instanceof Gh && _o93 instanceof Gh && bg(_n144, _o93)) {
          e.splice(_t165 - 1, 2, new Gh(_o93.data + _n144.data, _o93.getAttributes()));
          _t165--;
        }
      }
      return e;
    }
    function pg(t, e) {
      var n = t.getChild(e - 1);
      var o = t.getChild(e);
      if (n && o && n.is("$text") && o.is("$text") && bg(n, o)) {
        var _i77 = new Gh(n.data + o.data, n.getAttributes());
        t._removeChildren(e - 1, 2);
        t._insertChild(e - 1, _i77);
      }
    }
    function kg(t) {
      var e = t.textNode;
      var n = t.parent;
      if (e) {
        var _o94 = t.offset - e.startOffset;
        var _i78 = e.index;
        n._removeChildren(_i78, 1);
        var _r18 = new Gh(e.data.substr(0, _o94), e.getAttributes());
        var _s16 = new Gh(e.data.substr(_o94), e.getAttributes());
        n._insertChild(_i78, [_r18, _s16]);
      }
    }
    function bg(t, e) {
      var n = t.getAttributes();
      var o = e.getAttributes();
      var _iterator218 = _createForOfIteratorHelper(n),
        _step218;
      try {
        for (_iterator218.s(); !(_step218 = _iterator218.n()).done;) {
          var _t166 = _step218.value;
          if (_t166[1] !== e.getAttribute(_t166[0])) {
            return false;
          }
          o.next();
        }
      } catch (err) {
        _iterator218.e(err);
      } finally {
        _iterator218.f();
      }
      return o.next().done;
    }
    function wg(t, e) {
      return Zu(t, e);
    }
    var Cg = wg;
    var Ag = /*#__PURE__*/function (_cg) {
      _inherits(Ag, _cg);
      function Ag(t, e, n, o, i) {
        var _this60;
        _classCallCheck(this, Ag);
        _this60 = _possibleConstructorReturn(this, _getPrototypeOf(Ag).call(this, i));
        _this60.range = t.clone();
        _this60.key = e;
        _this60.oldValue = n === undefined ? null : n;
        _this60.newValue = o === undefined ? null : o;
        return _this60;
      }
      _createClass(Ag, [{
        key: "clone",
        value: function clone() {
          return new Ag(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Ag(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Ag.prototype), "toJSON", this).call(this);
          t.range = this.range.toJSON();
          return t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (!this.range.isFlat) {
            throw new ss["a"]("attribute-operation-range-not-flat", this);
          }
          var _iterator219 = _createForOfIteratorHelper(this.range.getItems({
              shallow: true
            })),
            _step219;
          try {
            for (_iterator219.s(); !(_step219 = _iterator219.n()).done;) {
              var _t167 = _step219.value;
              if (this.oldValue !== null && !Cg(_t167.getAttribute(this.key), this.oldValue)) {
                throw new ss["a"]("attribute-operation-wrong-old-value", this, {
                  item: _t167,
                  key: this.key,
                  value: this.oldValue
                });
              }
              if (this.oldValue === null && this.newValue !== null && _t167.hasAttribute(this.key)) {
                throw new ss["a"]("attribute-operation-attribute-exists", this, {
                  node: _t167,
                  key: this.key
                });
              }
            }
          } catch (err) {
            _iterator219.e(err);
          } finally {
            _iterator219.f();
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          if (!Cg(this.oldValue, this.newValue)) {
            mg(this.range, this.key, this.newValue);
          }
        }
      }, {
        key: "type",
        get: function get() {
          if (this.oldValue === null) {
            return "addAttribute";
          } else if (this.newValue === null) {
            return "removeAttribute";
          } else {
            return "changeAttribute";
          }
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new Ag(ef.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "AttributeOperation";
        }
      }]);
      return Ag;
    }(cg);
    var _g = /*#__PURE__*/function (_cg2) {
      _inherits(_g, _cg2);
      function _g(t, e) {
        var _this61;
        _classCallCheck(this, _g);
        _this61 = _possibleConstructorReturn(this, _getPrototypeOf(_g).call(this, null));
        _this61.sourcePosition = t.clone();
        _this61.howMany = e;
        return _this61;
      }
      _createClass(_g, [{
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(_g.prototype), "toJSON", this).call(this);
          t.sourcePosition = this.sourcePosition.toJSON();
          return t;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.sourcePosition.root.document) {
            throw new ss["a"]("detach-operation-on-document-node", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          hg(ef._createFromPositionAndShift(this.sourcePosition, this.howMany));
        }
      }, {
        key: "type",
        get: function get() {
          return "detach";
        }
      }], [{
        key: "className",
        get: function get() {
          return "DetachOperation";
        }
      }]);
      return _g;
    }(cg);
    var vg = /*#__PURE__*/function (_cg3) {
      _inherits(vg, _cg3);
      function vg(t, e, n, o) {
        var _this62;
        _classCallCheck(this, vg);
        _this62 = _possibleConstructorReturn(this, _getPrototypeOf(vg).call(this, o));
        _this62.sourcePosition = t.clone();
        _this62.sourcePosition.stickiness = "toNext";
        _this62.howMany = e;
        _this62.targetPosition = n.clone();
        _this62.targetPosition.stickiness = "toNone";
        return _this62;
      }
      _createClass(vg, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
        }
      }, {
        key: "getMovedRangeStart",
        value: function getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
          return new this.constructor(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent;
          var e = this.targetPosition.parent;
          var n = this.sourcePosition.offset;
          var o = this.targetPosition.offset;
          if (n + this.howMany > t.maxOffset) {
            throw new ss["a"]("move-operation-nodes-do-not-exist", this);
          } else if (t === e && n < o && o < n + this.howMany) {
            throw new ss["a"]("move-operation-range-into-itself", this);
          } else if (this.sourcePosition.root == this.targetPosition.root) {
            if (Ls(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
              var _t168 = this.sourcePosition.path.length - 1;
              if (this.targetPosition.path[_t168] >= n && this.targetPosition.path[_t168] < n + this.howMany) {
                throw new ss["a"]("move-operation-node-into-itself", this);
              }
            }
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          fg(ef._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(vg.prototype), "toJSON", this).call(this);
          t.sourcePosition = this.sourcePosition.toJSON();
          t.targetPosition = this.targetPosition.toJSON();
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          if (this.targetPosition.root.rootName == "$graveyard") {
            return "remove";
          } else if (this.sourcePosition.root.rootName == "$graveyard") {
            return "reinsert";
          }
          return "move";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Zh.fromJSON(t.sourcePosition, e);
          var o = Zh.fromJSON(t.targetPosition, e);
          return new this(n, t.howMany, o, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MoveOperation";
        }
      }]);
      return vg;
    }(cg);
    var yg = /*#__PURE__*/function (_cg4) {
      _inherits(yg, _cg4);
      function yg(t, e, n) {
        var _this63;
        _classCallCheck(this, yg);
        _this63 = _possibleConstructorReturn(this, _getPrototypeOf(yg).call(this, n));
        _this63.position = t.clone();
        _this63.position.stickiness = "toNone";
        _this63.nodes = new Kh(gg(e));
        _this63.shouldReceiveAttributes = false;
        return _this63;
      }
      _createClass(yg, [{
        key: "clone",
        value: function clone() {
          var t = new Kh(_toConsumableArray(this.nodes).map(function (t) {
            return t._clone(true);
          }));
          var e = new yg(this.position, t, this.baseVersion);
          e.shouldReceiveAttributes = this.shouldReceiveAttributes;
          return e;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.position.root.document.graveyard;
          var e = new Zh(t, [0]);
          return new vg(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.parent;
          if (!t || t.maxOffset < this.position.offset) {
            throw new ss["a"]("insert-operation-position-invalid", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.nodes;
          this.nodes = new Kh(_toConsumableArray(t).map(function (t) {
            return t._clone(true);
          }));
          ug(this.position, t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(yg.prototype), "toJSON", this).call(this);
          t.position = this.position.toJSON();
          t.nodes = this.nodes.toJSON();
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          return "insert";
        }
      }, {
        key: "howMany",
        get: function get() {
          return this.nodes.maxOffset;
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = [];
          var _iterator220 = _createForOfIteratorHelper(t.nodes),
            _step220;
          try {
            for (_iterator220.s(); !(_step220 = _iterator220.n()).done;) {
              var _e159 = _step220.value;
              if (_e159.name) {
                n.push(qh.fromJSON(_e159));
              } else {
                n.push(Gh.fromJSON(_e159));
              }
            }
          } catch (err) {
            _iterator220.e(err);
          } finally {
            _iterator220.f();
          }
          var o = new yg(Zh.fromJSON(t.position, e), n, t.baseVersion);
          o.shouldReceiveAttributes = t.shouldReceiveAttributes;
          return o;
        }
      }, {
        key: "className",
        get: function get() {
          return "InsertOperation";
        }
      }]);
      return yg;
    }(cg);
    var xg = /*#__PURE__*/function (_cg5) {
      _inherits(xg, _cg5);
      function xg(t, e, n, o, i, r) {
        var _this64;
        _classCallCheck(this, xg);
        _this64 = _possibleConstructorReturn(this, _getPrototypeOf(xg).call(this, r));
        _this64.name = t;
        _this64.oldRange = e ? e.clone() : null;
        _this64.newRange = n ? n.clone() : null;
        _this64.affectsData = i;
        _this64._markers = o;
        return _this64;
      }
      _createClass(xg, [{
        key: "clone",
        value: function clone() {
          return new xg(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new xg(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.newRange ? "_set" : "_remove";
          this._markers[t](this.name, this.newRange, true, this.affectsData);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(xg.prototype), "toJSON", this).call(this);
          if (this.oldRange) {
            t.oldRange = this.oldRange.toJSON();
          }
          if (this.newRange) {
            t.newRange = this.newRange.toJSON();
          }
          delete t._markers;
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          return "marker";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new xg(t.name, t.oldRange ? ef.fromJSON(t.oldRange, e) : null, t.newRange ? ef.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MarkerOperation";
        }
      }]);
      return xg;
    }(cg);
    var Dg = /*#__PURE__*/function (_cg6) {
      _inherits(Dg, _cg6);
      function Dg(t, e, n, o) {
        var _this65;
        _classCallCheck(this, Dg);
        _this65 = _possibleConstructorReturn(this, _getPrototypeOf(Dg).call(this, o));
        _this65.position = t;
        _this65.position.stickiness = "toNext";
        _this65.oldName = e;
        _this65.newName = n;
        return _this65;
      }
      _createClass(Dg, [{
        key: "clone",
        value: function clone() {
          return new Dg(this.position.clone(), this.oldName, this.newName, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Dg(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.position.nodeAfter;
          if (!(t instanceof qh)) {
            throw new ss["a"]("rename-operation-wrong-position", this);
          } else if (t.name !== this.oldName) {
            throw new ss["a"]("rename-operation-wrong-name", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.position.nodeAfter;
          t.name = this.newName;
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Dg.prototype), "toJSON", this).call(this);
          t.position = this.position.toJSON();
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          return "rename";
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return new Dg(Zh.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RenameOperation";
        }
      }]);
      return Dg;
    }(cg);
    var Eg = /*#__PURE__*/function (_cg7) {
      _inherits(Eg, _cg7);
      function Eg(t, e, n, o, i) {
        var _this66;
        _classCallCheck(this, Eg);
        _this66 = _possibleConstructorReturn(this, _getPrototypeOf(Eg).call(this, i));
        _this66.root = t;
        _this66.key = e;
        _this66.oldValue = n;
        _this66.newValue = o;
        return _this66;
      }
      _createClass(Eg, [{
        key: "clone",
        value: function clone() {
          return new Eg(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Eg(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          if (this.root != this.root.root || this.root.is("documentFragment")) {
            throw new ss["a"]("rootattribute-operation-not-a-root", this, {
              root: this.root,
              key: this.key
            });
          }
          if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) {
            throw new ss["a"]("rootattribute-operation-wrong-old-value", this, {
              root: this.root,
              key: this.key
            });
          }
          if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) {
            throw new ss["a"]("rootattribute-operation-attribute-exists", this, {
              root: this.root,
              key: this.key
            });
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          if (this.newValue !== null) {
            this.root._setAttribute(this.key, this.newValue);
          } else {
            this.root._removeAttribute(this.key);
          }
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Eg.prototype), "toJSON", this).call(this);
          t.root = this.root.toJSON();
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          if (this.oldValue === null) {
            return "addRootAttribute";
          } else if (this.newValue === null) {
            return "removeRootAttribute";
          } else {
            return "changeRootAttribute";
          }
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          if (!e.getRoot(t.root)) {
            throw new ss["a"]("rootattribute-operation-fromjson-no-root", this, {
              rootName: t.root
            });
          }
          return new Eg(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "RootAttributeOperation";
        }
      }]);
      return Eg;
    }(cg);
    var Mg = /*#__PURE__*/function (_cg8) {
      _inherits(Mg, _cg8);
      function Mg(t, e, n, o, i) {
        var _this67;
        _classCallCheck(this, Mg);
        _this67 = _possibleConstructorReturn(this, _getPrototypeOf(Mg).call(this, i));
        _this67.sourcePosition = t.clone();
        _this67.sourcePosition.stickiness = "toPrevious";
        _this67.howMany = e;
        _this67.targetPosition = n.clone();
        _this67.targetPosition.stickiness = "toNext";
        _this67.graveyardPosition = o.clone();
        return _this67;
      }
      _createClass(Mg, [{
        key: "clone",
        value: function clone() {
          return new this.constructor(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.targetPosition._getTransformedByMergeOperation(this);
          var e = this.sourcePosition.path.slice(0, -1);
          var n = new Zh(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);
          var o = new Sg(t, this.howMany, this.graveyardPosition, this.baseVersion + 1);
          o.insertionPosition = n;
          return o;
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.sourcePosition.parent;
          var e = this.targetPosition.parent;
          if (!t.parent) {
            throw new ss["a"]("merge-operation-source-position-invalid", this);
          } else if (!e.parent) {
            throw new ss["a"]("merge-operation-target-position-invalid", this);
          } else if (this.howMany != t.maxOffset) {
            throw new ss["a"]("merge-operation-how-many-invalid", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.sourcePosition.parent;
          var e = ef._createIn(t);
          fg(e, this.targetPosition);
          fg(ef._createOn(t), this.graveyardPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Mg.prototype), "toJSON", this).call(this);
          t.sourcePosition = t.sourcePosition.toJSON();
          t.targetPosition = t.targetPosition.toJSON();
          t.graveyardPosition = t.graveyardPosition.toJSON();
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          return "merge";
        }
      }, {
        key: "deletionPosition",
        get: function get() {
          return new Zh(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ef(this.sourcePosition, t);
        }
      }], [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Zh.fromJSON(t.sourcePosition, e);
          var o = Zh.fromJSON(t.targetPosition, e);
          var i = Zh.fromJSON(t.graveyardPosition, e);
          return new this(n, t.howMany, o, i, t.baseVersion);
        }
      }, {
        key: "className",
        get: function get() {
          return "MergeOperation";
        }
      }]);
      return Mg;
    }(cg);
    var Sg = /*#__PURE__*/function (_cg9) {
      _inherits(Sg, _cg9);
      function Sg(t, e, n, o) {
        var _this68;
        _classCallCheck(this, Sg);
        _this68 = _possibleConstructorReturn(this, _getPrototypeOf(Sg).call(this, o));
        _this68.splitPosition = t.clone();
        _this68.splitPosition.stickiness = "toNext";
        _this68.howMany = e;
        _this68.insertionPosition = Sg.getInsertionPosition(t);
        _this68.insertionPosition.stickiness = "toNone";
        _this68.graveyardPosition = n ? n.clone() : null;
        if (_this68.graveyardPosition) {
          _this68.graveyardPosition.stickiness = "toNext";
        }
        return _this68;
      }
      _createClass(Sg, [{
        key: "clone",
        value: function clone() {
          var t = new this.constructor(this.splitPosition, this.howMany, this.graveyardPosition, this.baseVersion);
          t.insertionPosition = this.insertionPosition;
          return t;
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          var t = this.splitPosition.root.document.graveyard;
          var e = new Zh(t, [0]);
          return new Mg(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
        }
      }, {
        key: "_validate",
        value: function _validate() {
          var t = this.splitPosition.parent;
          var e = this.splitPosition.offset;
          if (!t || t.maxOffset < e) {
            throw new ss["a"]("split-operation-position-invalid", this);
          } else if (!t.parent) {
            throw new ss["a"]("split-operation-split-in-root", this);
          } else if (this.howMany != t.maxOffset - this.splitPosition.offset) {
            throw new ss["a"]("split-operation-how-many-invalid", this);
          } else if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) {
            throw new ss["a"]("split-operation-graveyard-position-invalid", this);
          }
        }
      }, {
        key: "_execute",
        value: function _execute() {
          var t = this.splitPosition.parent;
          if (this.graveyardPosition) {
            fg(ef._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
          } else {
            var _e160 = t._clone();
            ug(this.insertionPosition, _e160);
          }
          var e = new ef(Zh._createAt(t, this.splitPosition.offset), Zh._createAt(t, t.maxOffset));
          fg(e, this.moveTargetPosition);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = _get(_getPrototypeOf(Sg.prototype), "toJSON", this).call(this);
          t.splitPosition = this.splitPosition.toJSON();
          t.insertionPosition = this.insertionPosition.toJSON();
          if (this.graveyardPosition) {
            t.graveyardPosition = this.graveyardPosition.toJSON();
          }
          return t;
        }
      }, {
        key: "type",
        get: function get() {
          return "split";
        }
      }, {
        key: "moveTargetPosition",
        get: function get() {
          var t = this.insertionPosition.path.slice();
          t.push(0);
          return new Zh(this.insertionPosition.root, t);
        }
      }, {
        key: "movedRange",
        get: function get() {
          var t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
          return new ef(this.splitPosition, t);
        }
      }], [{
        key: "getInsertionPosition",
        value: function getInsertionPosition(t) {
          var e = t.path.slice(0, -1);
          e[e.length - 1]++;
          return new Zh(t.root, e);
        }
      }, {
        key: "fromJSON",
        value: function fromJSON(t, e) {
          var n = Zh.fromJSON(t.splitPosition, e);
          var o = Zh.fromJSON(t.insertionPosition, e);
          var i = t.graveyardPosition ? Zh.fromJSON(t.graveyardPosition, e) : null;
          var r = new this(n, t.howMany, i, t.baseVersion);
          r.insertionPosition = o;
          return r;
        }
      }, {
        key: "className",
        get: function get() {
          return "SplitOperation";
        }
      }]);
      return Sg;
    }(cg);
    var Tg = /*#__PURE__*/function (_qh) {
      _inherits(Tg, _qh);
      function Tg(t, e) {
        var _this69;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "main";
        _classCallCheck(this, Tg);
        _this69 = _possibleConstructorReturn(this, _getPrototypeOf(Tg).call(this, e));
        _this69._document = t;
        _this69.rootName = n;
        return _this69;
      }
      _createClass(Tg, [{
        key: "is",
        value: function is(t, e) {
          if (!e) {
            return t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element" || t === "node" || t === "model:node";
          }
          return e === this.name && (t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element");
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          return this.rootName;
        }
      }, {
        key: "document",
        get: function get() {
          return this._document;
        }
      }]);
      return Tg;
    }(qh);
    var Ig = /*#__PURE__*/function () {
      function Ig(t, e) {
        _classCallCheck(this, Ig);
        this.model = t;
        this.batch = e;
      }
      _createClass(Ig, [{
        key: "createText",
        value: function createText(t, e) {
          return new Gh(t, e);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e) {
          return new qh(t, e);
        }
      }, {
        key: "createDocumentFragment",
        value: function createDocumentFragment() {
          return new lg();
        }
      }, {
        key: "cloneElement",
        value: function cloneElement(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          return t._clone(e);
        }
      }, {
        key: "insert",
        value: function insert(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
          this._assertWriterUsedCorrectly();
          if (t instanceof Gh && t.data == "") {
            return;
          }
          var o = Zh._createAt(e, n);
          if (t.parent) {
            if (Lg(t.root, o.root)) {
              this.move(ef._createOn(t), o);
              return;
            } else {
              if (t.root.document) {
                throw new ss["a"]("model-writer-insert-forbidden-move", this);
              } else {
                this.remove(t);
              }
            }
          }
          var i = o.root.document ? o.root.document.version : null;
          var r = new yg(o, t, i);
          if (t instanceof Gh) {
            r.shouldReceiveAttributes = true;
          }
          this.batch.addOperation(r);
          this.model.applyOperation(r);
          if (t instanceof lg) {
            var _iterator221 = _createForOfIteratorHelper(t.markers),
              _step221;
            try {
              for (_iterator221.s(); !(_step221 = _iterator221.n()).done;) {
                var _step221$value = _slicedToArray(_step221.value, 2),
                  _e161 = _step221$value[0],
                  _n145 = _step221$value[1];
                var _t169 = Zh._createAt(_n145.root, 0);
                var _i79 = new ef(_n145.start._getCombined(_t169, o), _n145.end._getCombined(_t169, o));
                var _r19 = {
                  range: _i79,
                  usingOperation: true,
                  affectsData: true
                };
                if (this.model.markers.has(_e161)) {
                  this.updateMarker(_e161, _r19);
                } else {
                  this.addMarker(_e161, _r19);
                }
              }
            } catch (err) {
              _iterator221.e(err);
            } finally {
              _iterator221.f();
            }
          }
        }
      }, {
        key: "insertText",
        value: function insertText(t, e, n, o) {
          if (e instanceof lg || e instanceof qh || e instanceof Zh) {
            this.insert(this.createText(t), e, n);
          } else {
            this.insert(this.createText(t, e), n, o);
          }
        }
      }, {
        key: "insertElement",
        value: function insertElement(t, e, n, o) {
          if (e instanceof lg || e instanceof qh || e instanceof Zh) {
            this.insert(this.createElement(t), e, n);
          } else {
            this.insert(this.createElement(t, e), n, o);
          }
        }
      }, {
        key: "append",
        value: function append(t, e) {
          this.insert(t, e, "end");
        }
      }, {
        key: "appendText",
        value: function appendText(t, e, n) {
          if (e instanceof lg || e instanceof qh) {
            this.insert(this.createText(t), e, "end");
          } else {
            this.insert(this.createText(t, e), n, "end");
          }
        }
      }, {
        key: "appendElement",
        value: function appendElement(t, e, n) {
          if (e instanceof lg || e instanceof qh) {
            this.insert(this.createElement(t), e, "end");
          } else {
            this.insert(this.createElement(t, e), n, "end");
          }
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          this._assertWriterUsedCorrectly();
          if (n instanceof ef) {
            var _o95 = n.getMinimalFlatRanges();
            var _iterator222 = _createForOfIteratorHelper(_o95),
              _step222;
            try {
              for (_iterator222.s(); !(_step222 = _iterator222.n()).done;) {
                var _n146 = _step222.value;
                Ng(this, t, e, _n146);
              }
            } catch (err) {
              _iterator222.e(err);
            } finally {
              _iterator222.f();
            }
          } else {
            Pg(this, t, e, n);
          }
        }
      }, {
        key: "setAttributes",
        value: function setAttributes(t, e) {
          var _iterator223 = _createForOfIteratorHelper(Gs(t)),
            _step223;
          try {
            for (_iterator223.s(); !(_step223 = _iterator223.n()).done;) {
              var _step223$value = _slicedToArray(_step223.value, 2),
                _n147 = _step223$value[0],
                _o96 = _step223$value[1];
              this.setAttribute(_n147, _o96, e);
            }
          } catch (err) {
            _iterator223.e(err);
          } finally {
            _iterator223.f();
          }
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          this._assertWriterUsedCorrectly();
          if (e instanceof ef) {
            var _n148 = e.getMinimalFlatRanges();
            var _iterator224 = _createForOfIteratorHelper(_n148),
              _step224;
            try {
              for (_iterator224.s(); !(_step224 = _iterator224.n()).done;) {
                var _e162 = _step224.value;
                Ng(this, t, null, _e162);
              }
            } catch (err) {
              _iterator224.e(err);
            } finally {
              _iterator224.f();
            }
          } else {
            Pg(this, t, null, e);
          }
        }
      }, {
        key: "clearAttributes",
        value: function clearAttributes(t) {
          var _this70 = this;
          this._assertWriterUsedCorrectly();
          var e = function e(t) {
            var _iterator225 = _createForOfIteratorHelper(t.getAttributeKeys()),
              _step225;
            try {
              for (_iterator225.s(); !(_step225 = _iterator225.n()).done;) {
                var _e163 = _step225.value;
                _this70.removeAttribute(_e163, t);
              }
            } catch (err) {
              _iterator225.e(err);
            } finally {
              _iterator225.f();
            }
          };
          if (!(t instanceof ef)) {
            e(t);
          } else {
            var _iterator226 = _createForOfIteratorHelper(t.getItems()),
              _step226;
            try {
              for (_iterator226.s(); !(_step226 = _iterator226.n()).done;) {
                var _n149 = _step226.value;
                e(_n149);
              }
            } catch (err) {
              _iterator226.e(err);
            } finally {
              _iterator226.f();
            }
          }
        }
      }, {
        key: "move",
        value: function move(t, e, n) {
          this._assertWriterUsedCorrectly();
          if (!(t instanceof ef)) {
            throw new ss["a"]("writer-move-invalid-range", this);
          }
          if (!t.isFlat) {
            throw new ss["a"]("writer-move-range-not-flat", this);
          }
          var o = Zh._createAt(e, n);
          if (o.isEqual(t.start)) {
            return;
          }
          this._addOperationForAffectedMarkers("move", t);
          if (!Lg(t.root, o.root)) {
            throw new ss["a"]("writer-move-different-document", this);
          }
          var i = t.root.document ? t.root.document.version : null;
          var r = new vg(t.start, t.end.offset - t.start.offset, o, i);
          this.batch.addOperation(r);
          this.model.applyOperation(r);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._assertWriterUsedCorrectly();
          var e = t instanceof ef ? t : ef._createOn(t);
          var n = e.getMinimalFlatRanges().reverse();
          var _iterator227 = _createForOfIteratorHelper(n),
            _step227;
          try {
            for (_iterator227.s(); !(_step227 = _iterator227.n()).done;) {
              var _t170 = _step227.value;
              this._addOperationForAffectedMarkers("move", _t170);
              zg(_t170.start, _t170.end.offset - _t170.start.offset, this.batch, this.model);
            }
          } catch (err) {
            _iterator227.e(err);
          } finally {
            _iterator227.f();
          }
        }
      }, {
        key: "merge",
        value: function merge(t) {
          this._assertWriterUsedCorrectly();
          var e = t.nodeBefore;
          var n = t.nodeAfter;
          this._addOperationForAffectedMarkers("merge", t);
          if (!(e instanceof qh)) {
            throw new ss["a"]("writer-merge-no-element-before", this);
          }
          if (!(n instanceof qh)) {
            throw new ss["a"]("writer-merge-no-element-after", this);
          }
          if (!t.root.document) {
            this._mergeDetached(t);
          } else {
            this._merge(t);
          }
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return this.model.createPositionAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return this.model.createPositionAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return this.model.createPositionBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return this.model.createRange(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return this.model.createRangeIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return this.model.createRangeOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return this.model.createSelection(t, e, n);
        }
      }, {
        key: "_mergeDetached",
        value: function _mergeDetached(t) {
          var e = t.nodeBefore;
          var n = t.nodeAfter;
          this.move(ef._createIn(n), Zh._createAt(e, "end"));
          this.remove(n);
        }
      }, {
        key: "_merge",
        value: function _merge(t) {
          var e = Zh._createAt(t.nodeBefore, "end");
          var n = Zh._createAt(t.nodeAfter, 0);
          var o = t.root.document.graveyard;
          var i = new Zh(o, [0]);
          var r = t.root.document.version;
          var s = new Mg(n, t.nodeAfter.maxOffset, e, i, r);
          this.batch.addOperation(s);
          this.model.applyOperation(s);
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          this._assertWriterUsedCorrectly();
          if (!(t instanceof qh)) {
            throw new ss["a"]("writer-rename-not-element-instance", this);
          }
          var n = t.root.document ? t.root.document.version : null;
          var o = new Dg(Zh._createBefore(t), t.name, e, n);
          this.batch.addOperation(o);
          this.model.applyOperation(o);
        }
      }, {
        key: "split",
        value: function split(t, e) {
          this._assertWriterUsedCorrectly();
          var n = t.parent;
          if (!n.parent) {
            throw new ss["a"]("writer-split-element-no-parent", this);
          }
          if (!e) {
            e = n.parent;
          }
          if (!t.parent.getAncestors({
            includeSelf: true
          }).includes(e)) {
            throw new ss["a"]("writer-split-invalid-limit-element", this);
          }
          var o, i;
          do {
            var _e164 = n.root.document ? n.root.document.version : null;
            var _r20 = n.maxOffset - t.offset;
            var _s17 = new Sg(t, _r20, null, _e164);
            this.batch.addOperation(_s17);
            this.model.applyOperation(_s17);
            if (!o && !i) {
              o = n;
              i = t.parent.nextSibling;
            }
            t = this.createPositionAfter(t.parent);
            n = t.parent;
          } while (n !== e);
          return {
            position: t,
            range: new ef(Zh._createAt(o, "end"), Zh._createAt(i, 0))
          };
        }
      }, {
        key: "wrap",
        value: function wrap(t, e) {
          this._assertWriterUsedCorrectly();
          if (!t.isFlat) {
            throw new ss["a"]("writer-wrap-range-not-flat", this);
          }
          var n = e instanceof qh ? e : new qh(e);
          if (n.childCount > 0) {
            throw new ss["a"]("writer-wrap-element-not-empty", this);
          }
          if (n.parent !== null) {
            throw new ss["a"]("writer-wrap-element-attached", this);
          }
          this.insert(n, t.start);
          var o = new ef(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
          this.move(o, Zh._createAt(n, 0));
        }
      }, {
        key: "unwrap",
        value: function unwrap(t) {
          this._assertWriterUsedCorrectly();
          if (t.parent === null) {
            throw new ss["a"]("writer-unwrap-element-no-parent", this);
          }
          this.move(ef._createIn(t), this.createPositionAfter(t));
          this.remove(t);
        }
      }, {
        key: "addMarker",
        value: function addMarker(t, e) {
          this._assertWriterUsedCorrectly();
          if (!e || typeof e.usingOperation != "boolean") {
            throw new ss["a"]("writer-addmarker-no-usingoperation", this);
          }
          var n = e.usingOperation;
          var o = e.range;
          var i = e.affectsData === undefined ? false : e.affectsData;
          if (this.model.markers.has(t)) {
            throw new ss["a"]("writer-addmarker-marker-exists", this);
          }
          if (!o) {
            throw new ss["a"]("writer-addmarker-no-range", this);
          }
          if (!n) {
            return this.model.markers._set(t, o, n, i);
          }
          Bg(this, t, null, o, i);
          return this.model.markers.get(t);
        }
      }, {
        key: "updateMarker",
        value: function updateMarker(t, e) {
          this._assertWriterUsedCorrectly();
          var n = typeof t == "string" ? t : t.name;
          var o = this.model.markers.get(n);
          if (!o) {
            throw new ss["a"]("writer-updatemarker-marker-not-exists", this);
          }
          if (!e) {
            this.model.markers._refresh(o);
            return;
          }
          var i = typeof e.usingOperation == "boolean";
          var r = typeof e.affectsData == "boolean";
          var s = r ? e.affectsData : o.affectsData;
          if (!i && !e.range && !r) {
            throw new ss["a"]("writer-updatemarker-wrong-options", this);
          }
          var a = o.getRange();
          var c = e.range ? e.range : a;
          if (i && e.usingOperation !== o.managedUsingOperations) {
            if (e.usingOperation) {
              Bg(this, n, null, c, s);
            } else {
              Bg(this, n, a, null, s);
              this.model.markers._set(n, c, undefined, s);
            }
            return;
          }
          if (o.managedUsingOperations) {
            Bg(this, n, a, c, s);
          } else {
            this.model.markers._set(n, c, undefined, s);
          }
        }
      }, {
        key: "removeMarker",
        value: function removeMarker(t) {
          this._assertWriterUsedCorrectly();
          var e = typeof t == "string" ? t : t.name;
          if (!this.model.markers.has(e)) {
            throw new ss["a"]("writer-removemarker-no-marker", this);
          }
          var n = this.model.markers.get(e);
          if (!n.managedUsingOperations) {
            this.model.markers._remove(e);
            return;
          }
          var o = n.getRange();
          Bg(this, e, o, null, n.affectsData);
        }
      }, {
        key: "setSelection",
        value: function setSelection(t, e, n) {
          this._assertWriterUsedCorrectly();
          this.model.document.selection._setTo(t, e, n);
        }
      }, {
        key: "setSelectionFocus",
        value: function setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly();
          this.model.document.selection._setFocus(t, e);
        }
      }, {
        key: "setSelectionAttribute",
        value: function setSelectionAttribute(t, e) {
          this._assertWriterUsedCorrectly();
          if (typeof t === "string") {
            this._setSelectionAttribute(t, e);
          } else {
            var _iterator228 = _createForOfIteratorHelper(Gs(t)),
              _step228;
            try {
              for (_iterator228.s(); !(_step228 = _iterator228.n()).done;) {
                var _step228$value = _slicedToArray(_step228.value, 2),
                  _e165 = _step228$value[0],
                  _n150 = _step228$value[1];
                this._setSelectionAttribute(_e165, _n150);
              }
            } catch (err) {
              _iterator228.e(err);
            } finally {
              _iterator228.f();
            }
          }
        }
      }, {
        key: "removeSelectionAttribute",
        value: function removeSelectionAttribute(t) {
          this._assertWriterUsedCorrectly();
          if (typeof t === "string") {
            this._removeSelectionAttribute(t);
          } else {
            var _iterator229 = _createForOfIteratorHelper(t),
              _step229;
            try {
              for (_iterator229.s(); !(_step229 = _iterator229.n()).done;) {
                var _e166 = _step229.value;
                this._removeSelectionAttribute(_e166);
              }
            } catch (err) {
              _iterator229.e(err);
            } finally {
              _iterator229.f();
            }
          }
        }
      }, {
        key: "overrideSelectionGravity",
        value: function overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity();
        }
      }, {
        key: "restoreSelectionGravity",
        value: function restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t);
        }
      }, {
        key: "_setSelectionAttribute",
        value: function _setSelectionAttribute(t, e) {
          var n = this.model.document.selection;
          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            var _o97 = _f._getStoreAttributeKey(t);
            this.setAttribute(_o97, e, n.anchor.parent);
          }
          n._setAttribute(t, e);
        }
      }, {
        key: "_removeSelectionAttribute",
        value: function _removeSelectionAttribute(t) {
          var e = this.model.document.selection;
          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            var _n151 = _f._getStoreAttributeKey(t);
            this.removeAttribute(_n151, e.anchor.parent);
          }
          e._removeAttribute(t);
        }
      }, {
        key: "_assertWriterUsedCorrectly",
        value: function _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) {
            throw new ss["a"]("writer-incorrect-use", this);
          }
        }
      }, {
        key: "_addOperationForAffectedMarkers",
        value: function _addOperationForAffectedMarkers(t, e) {
          var _iterator230 = _createForOfIteratorHelper(this.model.markers),
            _step230;
          try {
            for (_iterator230.s(); !(_step230 = _iterator230.n()).done;) {
              var _n152 = _step230.value;
              if (!_n152.managedUsingOperations) {
                continue;
              }
              var _o98 = _n152.getRange();
              var _i80 = false;
              if (t === "move") {
                _i80 = e.containsPosition(_o98.start) || e.start.isEqual(_o98.start) || e.containsPosition(_o98.end) || e.end.isEqual(_o98.end);
              } else {
                var _t171 = e.nodeBefore;
                var _n153 = e.nodeAfter;
                var _r21 = _o98.start.parent == _t171 && _o98.start.isAtEnd;
                var _s18 = _o98.end.parent == _n153 && _o98.end.offset == 0;
                var _a10 = _o98.end.nodeAfter == _n153;
                var _c3 = _o98.start.nodeAfter == _n153;
                _i80 = _r21 || _s18 || _a10 || _c3;
              }
              if (_i80) {
                this.updateMarker(_n152.name, {
                  range: _o98
                });
              }
            }
          } catch (err) {
            _iterator230.e(err);
          } finally {
            _iterator230.f();
          }
        }
      }]);
      return Ig;
    }();
    function Ng(t, e, n, o) {
      var i = t.model;
      var r = i.document;
      var s = o.start;
      var a;
      var c;
      var l;
      var _iterator231 = _createForOfIteratorHelper(o.getWalker({
          shallow: true
        })),
        _step231;
      try {
        for (_iterator231.s(); !(_step231 = _iterator231.n()).done;) {
          var _t172 = _step231.value;
          l = _t172.item.getAttribute(e);
          if (a && c != l) {
            if (c != n) {
              d();
            }
            s = a;
          }
          a = _t172.nextPosition;
          c = l;
        }
      } catch (err) {
        _iterator231.e(err);
      } finally {
        _iterator231.f();
      }
      if (a instanceof Zh && a != s && c != n) {
        d();
      }
      function d() {
        var o = new ef(s, a);
        var l = o.root.document ? r.version : null;
        var d = new Ag(o, e, c, n, l);
        t.batch.addOperation(d);
        i.applyOperation(d);
      }
    }
    function Pg(t, e, n, o) {
      var i = t.model;
      var r = i.document;
      var s = o.getAttribute(e);
      var a, c;
      if (s != n) {
        var _l3 = o.root === o;
        if (_l3) {
          var _t173 = o.document ? r.version : null;
          c = new Eg(o, e, s, n, _t173);
        } else {
          a = new ef(Zh._createBefore(o), t.createPositionAfter(o));
          var _i81 = a.root.document ? r.version : null;
          c = new Ag(a, e, s, n, _i81);
        }
        t.batch.addOperation(c);
        i.applyOperation(c);
      }
    }
    function Bg(t, e, n, o, i) {
      var r = t.model;
      var s = r.document;
      var a = new xg(e, n, o, r.markers, i, s.version);
      t.batch.addOperation(a);
      r.applyOperation(a);
    }
    function zg(t, e, n, o) {
      var i;
      if (t.root.document) {
        var _n154 = o.document;
        var _r22 = new Zh(_n154.graveyard, [0]);
        i = new vg(t, e, _r22, _n154.version);
      } else {
        i = new _g(t, e);
      }
      n.addOperation(i);
      o.applyOperation(i);
    }
    function Lg(t, e) {
      if (t === e) {
        return true;
      }
      if (t instanceof Tg && e instanceof Tg) {
        return true;
      }
      return false;
    }
    var Og = /*#__PURE__*/function () {
      function Og(t) {
        _classCallCheck(this, Og);
        this._markerCollection = t;
        this._changesInElement = new Map();
        this._elementSnapshots = new Map();
        this._changedMarkers = new Map();
        this._changeCount = 0;
        this._cachedChanges = null;
        this._cachedChangesWithGraveyard = null;
      }
      _createClass(Og, [{
        key: "refreshItem",
        value: function refreshItem(t) {
          if (this._isInInsertedElement(t.parent)) {
            return;
          }
          this._markRemove(t.parent, t.startOffset, t.offsetSize);
          this._markInsert(t.parent, t.startOffset, t.offsetSize);
          var e = ef._createOn(t);
          var _iterator232 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(e)),
            _step232;
          try {
            for (_iterator232.s(); !(_step232 = _iterator232.n()).done;) {
              var _t174 = _step232.value;
              var _e167 = _t174.getRange();
              this.bufferMarkerChange(_t174.name, _e167, _e167, _t174.affectsData);
            }
          } catch (err) {
            _iterator232.e(err);
          } finally {
            _iterator232.f();
          }
          this._cachedChanges = null;
        }
      }, {
        key: "bufferOperation",
        value: function bufferOperation(t) {
          switch (t.type) {
            case "insert":
              {
                if (this._isInInsertedElement(t.position.parent)) {
                  return;
                }
                this._markInsert(t.position.parent, t.position.offset, t.nodes.maxOffset);
                break;
              }
            case "addAttribute":
            case "removeAttribute":
            case "changeAttribute":
              {
                var _iterator233 = _createForOfIteratorHelper(t.range.getItems({
                    shallow: true
                  })),
                  _step233;
                try {
                  for (_iterator233.s(); !(_step233 = _iterator233.n()).done;) {
                    var _e168 = _step233.value;
                    if (this._isInInsertedElement(_e168.parent)) {
                      continue;
                    }
                    this._markAttribute(_e168);
                  }
                } catch (err) {
                  _iterator233.e(err);
                } finally {
                  _iterator233.f();
                }
                break;
              }
            case "remove":
            case "move":
            case "reinsert":
              {
                if (t.sourcePosition.isEqual(t.targetPosition) || t.sourcePosition.getShiftedBy(t.howMany).isEqual(t.targetPosition)) {
                  return;
                }
                var _e169 = this._isInInsertedElement(t.sourcePosition.parent);
                var _n155 = this._isInInsertedElement(t.targetPosition.parent);
                if (!_e169) {
                  this._markRemove(t.sourcePosition.parent, t.sourcePosition.offset, t.howMany);
                }
                if (!_n155) {
                  this._markInsert(t.targetPosition.parent, t.getMovedRangeStart().offset, t.howMany);
                }
                break;
              }
            case "rename":
              {
                if (this._isInInsertedElement(t.position.parent)) {
                  return;
                }
                this._markRemove(t.position.parent, t.position.offset, 1);
                this._markInsert(t.position.parent, t.position.offset, 1);
                var _e170 = ef._createFromPositionAndShift(t.position, 1);
                var _iterator234 = _createForOfIteratorHelper(this._markerCollection.getMarkersIntersectingRange(_e170)),
                  _step234;
                try {
                  for (_iterator234.s(); !(_step234 = _iterator234.n()).done;) {
                    var _t175 = _step234.value;
                    var _e171 = _t175.getRange();
                    this.bufferMarkerChange(_t175.name, _e171, _e171, _t175.affectsData);
                  }
                } catch (err) {
                  _iterator234.e(err);
                } finally {
                  _iterator234.f();
                }
                break;
              }
            case "split":
              {
                var _e172 = t.splitPosition.parent;
                if (!this._isInInsertedElement(_e172)) {
                  this._markRemove(_e172, t.splitPosition.offset, t.howMany);
                }
                if (!this._isInInsertedElement(t.insertionPosition.parent)) {
                  this._markInsert(t.insertionPosition.parent, t.insertionPosition.offset, 1);
                }
                if (t.graveyardPosition) {
                  this._markRemove(t.graveyardPosition.parent, t.graveyardPosition.offset, 1);
                }
                break;
              }
            case "merge":
              {
                var _e173 = t.sourcePosition.parent;
                if (!this._isInInsertedElement(_e173.parent)) {
                  this._markRemove(_e173.parent, _e173.startOffset, 1);
                }
                var _n156 = t.graveyardPosition.parent;
                this._markInsert(_n156, t.graveyardPosition.offset, 1);
                var _o99 = t.targetPosition.parent;
                if (!this._isInInsertedElement(_o99)) {
                  this._markInsert(_o99, t.targetPosition.offset, _e173.maxOffset);
                }
                break;
              }
          }
          this._cachedChanges = null;
        }
      }, {
        key: "bufferMarkerChange",
        value: function bufferMarkerChange(t, e, n, o) {
          var i = this._changedMarkers.get(t);
          if (!i) {
            this._changedMarkers.set(t, {
              oldRange: e,
              newRange: n,
              affectsData: o
            });
          } else {
            i.newRange = n;
            i.affectsData = o;
            if (i.oldRange == null && i.newRange == null) {
              this._changedMarkers.delete(t);
            }
          }
        }
      }, {
        key: "getMarkersToRemove",
        value: function getMarkersToRemove() {
          var t = [];
          var _iterator235 = _createForOfIteratorHelper(this._changedMarkers),
            _step235;
          try {
            for (_iterator235.s(); !(_step235 = _iterator235.n()).done;) {
              var _step235$value = _slicedToArray(_step235.value, 2),
                _e174 = _step235$value[0],
                _n157 = _step235$value[1];
              if (_n157.oldRange != null) {
                t.push({
                  name: _e174,
                  range: _n157.oldRange
                });
              }
            }
          } catch (err) {
            _iterator235.e(err);
          } finally {
            _iterator235.f();
          }
          return t;
        }
      }, {
        key: "getMarkersToAdd",
        value: function getMarkersToAdd() {
          var t = [];
          var _iterator236 = _createForOfIteratorHelper(this._changedMarkers),
            _step236;
          try {
            for (_iterator236.s(); !(_step236 = _iterator236.n()).done;) {
              var _step236$value = _slicedToArray(_step236.value, 2),
                _e175 = _step236$value[0],
                _n158 = _step236$value[1];
              if (_n158.newRange != null) {
                t.push({
                  name: _e175,
                  range: _n158.newRange
                });
              }
            }
          } catch (err) {
            _iterator236.e(err);
          } finally {
            _iterator236.f();
          }
          return t;
        }
      }, {
        key: "getChangedMarkers",
        value: function getChangedMarkers() {
          return Array.from(this._changedMarkers).map(function (t) {
            return {
              name: t[0],
              data: {
                oldRange: t[1].oldRange,
                newRange: t[1].newRange
              }
            };
          });
        }
      }, {
        key: "hasDataChanges",
        value: function hasDataChanges() {
          var _iterator237 = _createForOfIteratorHelper(this._changedMarkers),
            _step237;
          try {
            for (_iterator237.s(); !(_step237 = _iterator237.n()).done;) {
              var _step237$value = _slicedToArray(_step237.value, 2),
                _t176 = _step237$value[1];
              if (_t176.affectsData) {
                return true;
              }
            }
          } catch (err) {
            _iterator237.e(err);
          } finally {
            _iterator237.f();
          }
          return this._changesInElement.size > 0;
        }
      }, {
        key: "getChanges",
        value: function getChanges() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            includeChangesInGraveyard: false
          };
          if (this._cachedChanges) {
            if (t.includeChangesInGraveyard) {
              return this._cachedChangesWithGraveyard.slice();
            } else {
              return this._cachedChanges.slice();
            }
          }
          var e = [];
          var _iterator238 = _createForOfIteratorHelper(this._changesInElement.keys()),
            _step238;
          try {
            for (_iterator238.s(); !(_step238 = _iterator238.n()).done;) {
              var _t179 = _step238.value;
              var _n160 = this._changesInElement.get(_t179).sort(function (t, e) {
                if (t.offset === e.offset) {
                  if (t.type != e.type) {
                    return t.type == "remove" ? -1 : 1;
                  }
                  return 0;
                }
                return t.offset < e.offset ? -1 : 1;
              });
              var _o101 = this._elementSnapshots.get(_t179);
              var _i84 = Rg(_t179.getChildren());
              var _r24 = jg(_o101.length, _n160);
              var _s20 = 0;
              var _a11 = 0;
              var _iterator239 = _createForOfIteratorHelper(_r24),
                _step239;
              try {
                for (_iterator239.s(); !(_step239 = _iterator239.n()).done;) {
                  var _n161 = _step239.value;
                  if (_n161 === "i") {
                    e.push(this._getInsertDiff(_t179, _s20, _i84[_s20].name));
                    _s20++;
                  } else if (_n161 === "r") {
                    e.push(this._getRemoveDiff(_t179, _s20, _o101[_a11].name));
                    _a11++;
                  } else if (_n161 === "a") {
                    var _n162 = _i84[_s20].attributes;
                    var _r25 = _o101[_a11].attributes;
                    var _c4 = void 0;
                    if (_i84[_s20].name == "$text") {
                      _c4 = new ef(Zh._createAt(_t179, _s20), Zh._createAt(_t179, _s20 + 1));
                    } else {
                      var _e177 = _t179.offsetToIndex(_s20);
                      _c4 = new ef(Zh._createAt(_t179, _s20), Zh._createAt(_t179.getChild(_e177), 0));
                    }
                    e.push.apply(e, _toConsumableArray(this._getAttributesDiff(_c4, _r25, _n162)));
                    _s20++;
                    _a11++;
                  } else {
                    _s20++;
                    _a11++;
                  }
                }
              } catch (err) {
                _iterator239.e(err);
              } finally {
                _iterator239.f();
              }
            }
          } catch (err) {
            _iterator238.e(err);
          } finally {
            _iterator238.f();
          }
          e.sort(function (t, e) {
            if (t.position.root != e.position.root) {
              return t.position.root.rootName < e.position.root.rootName ? -1 : 1;
            }
            if (t.position.isEqual(e.position)) {
              return t.changeCount - e.changeCount;
            }
            return t.position.isBefore(e.position) ? -1 : 1;
          });
          for (var _t177 = 1; _t177 < e.length; _t177++) {
            var _n159 = e[_t177 - 1];
            var _o100 = e[_t177];
            var _i82 = _n159.type == "remove" && _o100.type == "remove" && _n159.name == "$text" && _o100.name == "$text" && _n159.position.isEqual(_o100.position);
            var _r23 = _n159.type == "insert" && _o100.type == "insert" && _n159.name == "$text" && _o100.name == "$text" && _n159.position.parent == _o100.position.parent && _n159.position.offset + _n159.length == _o100.position.offset;
            var _s19 = _n159.type == "attribute" && _o100.type == "attribute" && _n159.position.parent == _o100.position.parent && _n159.range.isFlat && _o100.range.isFlat && _n159.position.offset + _n159.length == _o100.position.offset && _n159.attributeKey == _o100.attributeKey && _n159.attributeOldValue == _o100.attributeOldValue && _n159.attributeNewValue == _o100.attributeNewValue;
            if (_i82 || _r23 || _s19) {
              e[_t177 - 1].length++;
              if (_s19) {
                e[_t177 - 1].range.end = e[_t177 - 1].range.end.getShiftedBy(1);
              }
              e.splice(_t177, 1);
              _t177--;
            }
          }
          for (var _i83 = 0, _e176 = e; _i83 < _e176.length; _i83++) {
            var _t178 = _e176[_i83];
            delete _t178.changeCount;
            if (_t178.type == "attribute") {
              delete _t178.position;
              delete _t178.length;
            }
          }
          this._changeCount = 0;
          this._cachedChangesWithGraveyard = e.slice();
          this._cachedChanges = e.slice().filter(Fg);
          if (t.includeChangesInGraveyard) {
            return this._cachedChangesWithGraveyard;
          } else {
            return this._cachedChanges;
          }
        }
      }, {
        key: "reset",
        value: function reset() {
          this._changesInElement.clear();
          this._elementSnapshots.clear();
          this._changedMarkers.clear();
          this._cachedChanges = null;
        }
      }, {
        key: "_markInsert",
        value: function _markInsert(t, e, n) {
          var o = {
            type: "insert",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, o);
        }
      }, {
        key: "_markRemove",
        value: function _markRemove(t, e, n) {
          var o = {
            type: "remove",
            offset: e,
            howMany: n,
            count: this._changeCount++
          };
          this._markChange(t, o);
          this._removeAllNestedChanges(t, e, n);
        }
      }, {
        key: "_markAttribute",
        value: function _markAttribute(t) {
          var e = {
            type: "attribute",
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          };
          this._markChange(t.parent, e);
        }
      }, {
        key: "_markChange",
        value: function _markChange(t, e) {
          this._makeSnapshot(t);
          var n = this._getChangesForElement(t);
          this._handleChange(e, n);
          n.push(e);
          for (var _t180 = 0; _t180 < n.length; _t180++) {
            if (n[_t180].howMany < 1) {
              n.splice(_t180, 1);
              _t180--;
            }
          }
        }
      }, {
        key: "_getChangesForElement",
        value: function _getChangesForElement(t) {
          var e;
          if (this._changesInElement.has(t)) {
            e = this._changesInElement.get(t);
          } else {
            e = [];
            this._changesInElement.set(t, e);
          }
          return e;
        }
      }, {
        key: "_makeSnapshot",
        value: function _makeSnapshot(t) {
          if (!this._elementSnapshots.has(t)) {
            this._elementSnapshots.set(t, Rg(t.getChildren()));
          }
        }
      }, {
        key: "_handleChange",
        value: function _handleChange(t, e) {
          t.nodesToHandle = t.howMany;
          var _iterator240 = _createForOfIteratorHelper(e),
            _step240;
          try {
            for (_iterator240.s(); !(_step240 = _iterator240.n()).done;) {
              var _n163 = _step240.value;
              var _o102 = t.offset + t.howMany;
              var _i85 = _n163.offset + _n163.howMany;
              if (t.type == "insert") {
                if (_n163.type == "insert") {
                  if (t.offset <= _n163.offset) {
                    _n163.offset += t.howMany;
                  } else if (t.offset < _i85) {
                    _n163.howMany += t.nodesToHandle;
                    t.nodesToHandle = 0;
                  }
                }
                if (_n163.type == "remove") {
                  if (t.offset < _n163.offset) {
                    _n163.offset += t.howMany;
                  }
                }
                if (_n163.type == "attribute") {
                  if (t.offset <= _n163.offset) {
                    _n163.offset += t.howMany;
                  } else if (t.offset < _i85) {
                    var _i86 = _n163.howMany;
                    _n163.howMany = t.offset - _n163.offset;
                    e.unshift({
                      type: "attribute",
                      offset: _o102,
                      howMany: _i86 - _n163.howMany,
                      count: this._changeCount++
                    });
                  }
                }
              }
              if (t.type == "remove") {
                if (_n163.type == "insert") {
                  if (_o102 <= _n163.offset) {
                    _n163.offset -= t.howMany;
                  } else if (_o102 <= _i85) {
                    if (t.offset < _n163.offset) {
                      var _e178 = _o102 - _n163.offset;
                      _n163.offset = t.offset;
                      _n163.howMany -= _e178;
                      t.nodesToHandle -= _e178;
                    } else {
                      _n163.howMany -= t.nodesToHandle;
                      t.nodesToHandle = 0;
                    }
                  } else {
                    if (t.offset <= _n163.offset) {
                      t.nodesToHandle -= _n163.howMany;
                      _n163.howMany = 0;
                    } else if (t.offset < _i85) {
                      var _e179 = _i85 - t.offset;
                      _n163.howMany -= _e179;
                      t.nodesToHandle -= _e179;
                    }
                  }
                }
                if (_n163.type == "remove") {
                  if (_o102 <= _n163.offset) {
                    _n163.offset -= t.howMany;
                  } else if (t.offset < _n163.offset) {
                    t.nodesToHandle += _n163.howMany;
                    _n163.howMany = 0;
                  }
                }
                if (_n163.type == "attribute") {
                  if (_o102 <= _n163.offset) {
                    _n163.offset -= t.howMany;
                  } else if (t.offset < _n163.offset) {
                    var _e180 = _o102 - _n163.offset;
                    _n163.offset = t.offset;
                    _n163.howMany -= _e180;
                  } else if (t.offset < _i85) {
                    if (_o102 <= _i85) {
                      var _o103 = _n163.howMany;
                      _n163.howMany = t.offset - _n163.offset;
                      var _i87 = _o103 - _n163.howMany - t.nodesToHandle;
                      e.unshift({
                        type: "attribute",
                        offset: t.offset,
                        howMany: _i87,
                        count: this._changeCount++
                      });
                    } else {
                      _n163.howMany -= _i85 - t.offset;
                    }
                  }
                }
              }
              if (t.type == "attribute") {
                if (_n163.type == "insert") {
                  if (t.offset < _n163.offset && _o102 > _n163.offset) {
                    if (_o102 > _i85) {
                      var _t181 = {
                        type: "attribute",
                        offset: _i85,
                        howMany: _o102 - _i85,
                        count: this._changeCount++
                      };
                      this._handleChange(_t181, e);
                      e.push(_t181);
                    }
                    t.nodesToHandle = _n163.offset - t.offset;
                    t.howMany = t.nodesToHandle;
                  } else if (t.offset >= _n163.offset && t.offset < _i85) {
                    if (_o102 > _i85) {
                      t.nodesToHandle = _o102 - _i85;
                      t.offset = _i85;
                    } else {
                      t.nodesToHandle = 0;
                    }
                  }
                }
                if (_n163.type == "remove") {
                  if (t.offset < _n163.offset && _o102 > _n163.offset) {
                    var _i88 = {
                      type: "attribute",
                      offset: _n163.offset,
                      howMany: _o102 - _n163.offset,
                      count: this._changeCount++
                    };
                    this._handleChange(_i88, e);
                    e.push(_i88);
                    t.nodesToHandle = _n163.offset - t.offset;
                    t.howMany = t.nodesToHandle;
                  }
                }
                if (_n163.type == "attribute") {
                  if (t.offset >= _n163.offset && _o102 <= _i85) {
                    t.nodesToHandle = 0;
                    t.howMany = 0;
                    t.offset = 0;
                  } else if (t.offset <= _n163.offset && _o102 >= _i85) {
                    _n163.howMany = 0;
                  }
                }
              }
            }
          } catch (err) {
            _iterator240.e(err);
          } finally {
            _iterator240.f();
          }
          t.howMany = t.nodesToHandle;
          delete t.nodesToHandle;
        }
      }, {
        key: "_getInsertDiff",
        value: function _getInsertDiff(t, e, n) {
          return {
            type: "insert",
            position: Zh._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getRemoveDiff",
        value: function _getRemoveDiff(t, e, n) {
          return {
            type: "remove",
            position: Zh._createAt(t, e),
            name: n,
            length: 1,
            changeCount: this._changeCount++
          };
        }
      }, {
        key: "_getAttributesDiff",
        value: function _getAttributesDiff(t, e, n) {
          var o = [];
          n = new Map(n);
          var _iterator241 = _createForOfIteratorHelper(e),
            _step241;
          try {
            for (_iterator241.s(); !(_step241 = _iterator241.n()).done;) {
              var _step241$value = _slicedToArray(_step241.value, 2),
                _i89 = _step241$value[0],
                _r26 = _step241$value[1];
              var _e181 = n.has(_i89) ? n.get(_i89) : null;
              if (_e181 !== _r26) {
                o.push({
                  type: "attribute",
                  position: t.start,
                  range: t.clone(),
                  length: 1,
                  attributeKey: _i89,
                  attributeOldValue: _r26,
                  attributeNewValue: _e181,
                  changeCount: this._changeCount++
                });
              }
              n.delete(_i89);
            }
          } catch (err) {
            _iterator241.e(err);
          } finally {
            _iterator241.f();
          }
          var _iterator242 = _createForOfIteratorHelper(n),
            _step242;
          try {
            for (_iterator242.s(); !(_step242 = _iterator242.n()).done;) {
              var _step242$value = _slicedToArray(_step242.value, 2),
                _e182 = _step242$value[0],
                _i90 = _step242$value[1];
              o.push({
                type: "attribute",
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: _e182,
                attributeOldValue: null,
                attributeNewValue: _i90,
                changeCount: this._changeCount++
              });
            }
          } catch (err) {
            _iterator242.e(err);
          } finally {
            _iterator242.f();
          }
          return o;
        }
      }, {
        key: "_isInInsertedElement",
        value: function _isInInsertedElement(t) {
          var e = t.parent;
          if (!e) {
            return false;
          }
          var n = this._changesInElement.get(e);
          var o = t.startOffset;
          if (n) {
            var _iterator243 = _createForOfIteratorHelper(n),
              _step243;
            try {
              for (_iterator243.s(); !(_step243 = _iterator243.n()).done;) {
                var _t182 = _step243.value;
                if (_t182.type == "insert" && o >= _t182.offset && o < _t182.offset + _t182.howMany) {
                  return true;
                }
              }
            } catch (err) {
              _iterator243.e(err);
            } finally {
              _iterator243.f();
            }
          }
          return this._isInInsertedElement(e);
        }
      }, {
        key: "_removeAllNestedChanges",
        value: function _removeAllNestedChanges(t, e, n) {
          var o = new ef(Zh._createAt(t, e), Zh._createAt(t, e + n));
          var _iterator244 = _createForOfIteratorHelper(o.getItems({
              shallow: true
            })),
            _step244;
          try {
            for (_iterator244.s(); !(_step244 = _iterator244.n()).done;) {
              var _t183 = _step244.value;
              if (_t183.is("element")) {
                this._elementSnapshots.delete(_t183);
                this._changesInElement.delete(_t183);
                this._removeAllNestedChanges(_t183, 0, _t183.maxOffset);
              }
            }
          } catch (err) {
            _iterator244.e(err);
          } finally {
            _iterator244.f();
          }
        }
      }, {
        key: "isEmpty",
        get: function get() {
          return this._changesInElement.size == 0 && this._changedMarkers.size == 0;
        }
      }]);
      return Og;
    }();
    function Rg(t) {
      var e = [];
      var _iterator245 = _createForOfIteratorHelper(t),
        _step245;
      try {
        for (_iterator245.s(); !(_step245 = _iterator245.n()).done;) {
          var _n164 = _step245.value;
          if (_n164.is("$text")) {
            for (var _t184 = 0; _t184 < _n164.data.length; _t184++) {
              e.push({
                name: "$text",
                attributes: new Map(_n164.getAttributes())
              });
            }
          } else {
            e.push({
              name: _n164.name,
              attributes: new Map(_n164.getAttributes())
            });
          }
        }
      } catch (err) {
        _iterator245.e(err);
      } finally {
        _iterator245.f();
      }
      return e;
    }
    function jg(t, e) {
      var n = [];
      var o = 0;
      var i = 0;
      var _iterator246 = _createForOfIteratorHelper(e),
        _step246;
      try {
        for (_iterator246.s(); !(_step246 = _iterator246.n()).done;) {
          var _t185 = _step246.value;
          if (_t185.offset > o) {
            for (var _e184 = 0; _e184 < _t185.offset - o; _e184++) {
              n.push("e");
            }
            i += _t185.offset - o;
          }
          if (_t185.type == "insert") {
            for (var _e185 = 0; _e185 < _t185.howMany; _e185++) {
              n.push("i");
            }
            o = _t185.offset + _t185.howMany;
          } else if (_t185.type == "remove") {
            for (var _e186 = 0; _e186 < _t185.howMany; _e186++) {
              n.push("r");
            }
            o = _t185.offset;
            i += _t185.howMany;
          } else {
            n.push.apply(n, _toConsumableArray("a".repeat(_t185.howMany).split("")));
            o = _t185.offset + _t185.howMany;
            i += _t185.howMany;
          }
        }
      } catch (err) {
        _iterator246.e(err);
      } finally {
        _iterator246.f();
      }
      if (i < t) {
        for (var _e183 = 0; _e183 < t - i - o; _e183++) {
          n.push("e");
        }
      }
      return n;
    }
    function Fg(t) {
      var e = t.position && t.position.root.rootName == "$graveyard";
      var n = t.range && t.range.root.rootName == "$graveyard";
      return !e && !n;
    }
    var Vg = /*#__PURE__*/function () {
      function Vg() {
        _classCallCheck(this, Vg);
        this._operations = [];
        this._undoPairs = new Map();
        this._undoneOperations = new Set();
      }
      _createClass(Vg, [{
        key: "addOperation",
        value: function addOperation(t) {
          if (this._operations.includes(t)) {
            return;
          }
          this._operations.push(t);
        }
      }, {
        key: "getOperations",
        value: function getOperations() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Number.NEGATIVE_INFINITY;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;
          var n = [];
          var _iterator247 = _createForOfIteratorHelper(this._operations),
            _step247;
          try {
            for (_iterator247.s(); !(_step247 = _iterator247.n()).done;) {
              var _o104 = _step247.value;
              if (_o104.baseVersion >= t && _o104.baseVersion < e) {
                n.push(_o104);
              }
            }
          } catch (err) {
            _iterator247.e(err);
          } finally {
            _iterator247.f();
          }
          return n;
        }
      }, {
        key: "getOperation",
        value: function getOperation(t) {
          var _iterator248 = _createForOfIteratorHelper(this._operations),
            _step248;
          try {
            for (_iterator248.s(); !(_step248 = _iterator248.n()).done;) {
              var _e187 = _step248.value;
              if (_e187.baseVersion == t) {
                return _e187;
              }
            }
          } catch (err) {
            _iterator248.e(err);
          } finally {
            _iterator248.f();
          }
        }
      }, {
        key: "setOperationAsUndone",
        value: function setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t);
          this._undoneOperations.add(t);
        }
      }, {
        key: "isUndoingOperation",
        value: function isUndoingOperation(t) {
          return this._undoPairs.has(t);
        }
      }, {
        key: "isUndoneOperation",
        value: function isUndoneOperation(t) {
          return this._undoneOperations.has(t);
        }
      }, {
        key: "getUndoneOperation",
        value: function getUndoneOperation(t) {
          return this._undoPairs.get(t);
        }
      }]);
      return Vg;
    }();
    function Ug(t) {
      return !!t && t.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t);
    }
    function Hg(t) {
      return !!t && t.length == 1 && /[\ud800-\udbff]/.test(t);
    }
    function Gg(t) {
      return !!t && t.length == 1 && /[\udc00-\udfff]/.test(t);
    }
    function Wg(t, e) {
      return Hg(t.charAt(e - 1)) && Gg(t.charAt(e));
    }
    function Kg(t, e) {
      return Ug(t.charAt(e));
    }
    var qg = "$graveyard";
    var Yg = /*#__PURE__*/function () {
      function Yg(t) {
        var _this71 = this;
        _classCallCheck(this, Yg);
        this.model = t;
        this.version = 0;
        this.history = new Vg(this);
        this.selection = new _f(this);
        this.roots = new vs({
          idProperty: "rootName"
        });
        this.differ = new Og(t.markers);
        this._postFixers = new Set();
        this._hasSelectionChangedFromTheLastChangeBlock = false;
        this.createRoot("$root", qg);
        this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation && n.baseVersion !== _this71.version) {
            throw new ss["a"]("model-document-applyoperation-wrong-version", _this71, {
              operation: n
            });
          }
        }, {
          priority: "highest"
        });
        this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation) {
            _this71.differ.bufferOperation(n);
          }
        }, {
          priority: "high"
        });
        this.listenTo(t, "applyOperation", function (t, e) {
          var n = e[0];
          if (n.isDocumentOperation) {
            _this71.version++;
            _this71.history.addOperation(n);
          }
        }, {
          priority: "low"
        });
        this.listenTo(this.selection, "change", function () {
          _this71._hasSelectionChangedFromTheLastChangeBlock = true;
        });
        this.listenTo(t.markers, "update", function (t, e, n, o) {
          _this71.differ.bufferMarkerChange(e.name, n, o, e.affectsData);
          if (n === null) {
            e.on("change", function (t, n) {
              _this71.differ.bufferMarkerChange(e.name, n, e.getRange(), e.affectsData);
            });
          }
        });
      }
      _createClass(Yg, [{
        key: "createRoot",
        value: function createRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$root";
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "main";
          if (this.roots.get(e)) {
            throw new ss["a"]("model-document-createroot-name-exists", this, {
              name: e
            });
          }
          var n = new Tg(this, t, e);
          this.roots.add(n);
          return n;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.selection.destroy();
          this.stopListening();
        }
      }, {
        key: "getRoot",
        value: function getRoot() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this.roots.get(t);
        }
      }, {
        key: "getRootNames",
        value: function getRootNames() {
          return Array.from(this.roots, function (t) {
            return t.rootName;
          }).filter(function (t) {
            return t != qg;
          });
        }
      }, {
        key: "registerPostFixer",
        value: function registerPostFixer(t) {
          this._postFixers.add(t);
        }
      }, {
        key: "toJSON",
        value: function toJSON() {
          var t = js(this);
          t.selection = "[engine.model.DocumentSelection]";
          t.model = "[engine.model.Model]";
          return t;
        }
      }, {
        key: "_handleChangeBlock",
        value: function _handleChangeBlock(t) {
          if (this._hasDocumentChangedFromTheLastChangeBlock()) {
            this._callPostFixers(t);
            this.selection.refresh();
            if (this.differ.hasDataChanges()) {
              this.fire("change:data", t.batch);
            } else {
              this.fire("change", t.batch);
            }
            this.selection.refresh();
            this.differ.reset();
          }
          this._hasSelectionChangedFromTheLastChangeBlock = false;
        }
      }, {
        key: "_hasDocumentChangedFromTheLastChangeBlock",
        value: function _hasDocumentChangedFromTheLastChangeBlock() {
          return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
        }
      }, {
        key: "_getDefaultRoot",
        value: function _getDefaultRoot() {
          var _iterator249 = _createForOfIteratorHelper(this.roots),
            _step249;
          try {
            for (_iterator249.s(); !(_step249 = _iterator249.n()).done;) {
              var _t186 = _step249.value;
              if (_t186 !== this.graveyard) {
                return _t186;
              }
            }
          } catch (err) {
            _iterator249.e(err);
          } finally {
            _iterator249.f();
          }
          return this.graveyard;
        }
      }, {
        key: "_getDefaultRange",
        value: function _getDefaultRange() {
          var t = this._getDefaultRoot();
          var e = this.model;
          var n = e.schema;
          var o = e.createPositionFromPath(t, [0]);
          var i = n.getNearestSelectionRange(o);
          return i || e.createRange(o);
        }
      }, {
        key: "_validateSelectionRange",
        value: function _validateSelectionRange(t) {
          return Qg(t.start) && Qg(t.end);
        }
      }, {
        key: "_callPostFixers",
        value: function _callPostFixers(t) {
          var e = false;
          do {
            var _iterator250 = _createForOfIteratorHelper(this._postFixers),
              _step250;
            try {
              for (_iterator250.s(); !(_step250 = _iterator250.n()).done;) {
                var _n165 = _step250.value;
                this.selection.refresh();
                e = _n165(t);
                if (e) {
                  break;
                }
              }
            } catch (err) {
              _iterator250.e(err);
            } finally {
              _iterator250.f();
            }
          } while (e);
        }
      }, {
        key: "graveyard",
        get: function get() {
          return this.getRoot(qg);
        }
      }]);
      return Yg;
    }();
    _s(Yg, ds);
    function Qg(t) {
      var e = t.textNode;
      if (e) {
        var _n166 = e.data;
        var _o105 = t.offset - e.startOffset;
        return !Wg(_n166, _o105) && !Kg(_n166, _o105);
      }
      return true;
    }
    var $g = /*#__PURE__*/function () {
      function $g() {
        _classCallCheck(this, $g);
        this._markers = new Map();
      }
      _createClass($g, [{
        key: Symbol.iterator,
        value: function value() {
          return this._markers.values();
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._markers.has(t);
        }
      }, {
        key: "get",
        value: function get(t) {
          return this._markers.get(t) || null;
        }
      }, {
        key: "_set",
        value: function _set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
          var i = t instanceof Zg ? t.name : t;
          if (i.includes(",")) {
            throw new ss["a"]("markercollection-incorrect-marker-name", this);
          }
          var r = this._markers.get(i);
          if (r) {
            var _t187 = r.getRange();
            var _s21 = false;
            if (!_t187.isEqual(e)) {
              r._attachLiveRange(kf.fromRange(e));
              _s21 = true;
            }
            if (n != r.managedUsingOperations) {
              r._managedUsingOperations = n;
              _s21 = true;
            }
            if (typeof o === "boolean" && o != r.affectsData) {
              r._affectsData = o;
              _s21 = true;
            }
            if (_s21) {
              this.fire("update:" + i, r, _t187, e);
            }
            return r;
          }
          var s = kf.fromRange(e);
          var a = new Zg(i, s, n, o);
          this._markers.set(i, a);
          this.fire("update:" + i, a, null, e);
          return a;
        }
      }, {
        key: "_remove",
        value: function _remove(t) {
          var e = t instanceof Zg ? t.name : t;
          var n = this._markers.get(e);
          if (n) {
            this._markers.delete(e);
            this.fire("update:" + e, n, n.getRange(), null);
            this._destroyMarker(n);
            return true;
          }
          return false;
        }
      }, {
        key: "_refresh",
        value: function _refresh(t) {
          var e = t instanceof Zg ? t.name : t;
          var n = this._markers.get(e);
          if (!n) {
            throw new ss["a"]("markercollection-refresh-marker-not-exists", this);
          }
          var o = n.getRange();
          this.fire("update:" + e, n, o, o, n.managedUsingOperations, n.affectsData);
        }
      }, {
        key: "getMarkersAtPosition",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersAtPosition(t) {
          var _iterator251, _step251, _e188;
          return _regeneratorRuntime().wrap(function getMarkersAtPosition$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                _iterator251 = _createForOfIteratorHelper(this);
                _context31.prev = 1;
                _iterator251.s();
              case 3:
                if ((_step251 = _iterator251.n()).done) {
                  _context31.next = 10;
                  break;
                }
                _e188 = _step251.value;
                if (!_e188.getRange().containsPosition(t)) {
                  _context31.next = 8;
                  break;
                }
                _context31.next = 8;
                return _e188;
              case 8:
                _context31.next = 3;
                break;
              case 10:
                _context31.next = 15;
                break;
              case 12:
                _context31.prev = 12;
                _context31.t0 = _context31["catch"](1);
                _iterator251.e(_context31.t0);
              case 15:
                _context31.prev = 15;
                _iterator251.f();
                return _context31.finish(15);
              case 18:
              case "end":
                return _context31.stop();
            }
          }, getMarkersAtPosition, this, [[1, 12, 15, 18]]);
        })
      }, {
        key: "getMarkersIntersectingRange",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersIntersectingRange(t) {
          var _iterator252, _step252, _e189;
          return _regeneratorRuntime().wrap(function getMarkersIntersectingRange$(_context32) {
            while (1) switch (_context32.prev = _context32.next) {
              case 0:
                _iterator252 = _createForOfIteratorHelper(this);
                _context32.prev = 1;
                _iterator252.s();
              case 3:
                if ((_step252 = _iterator252.n()).done) {
                  _context32.next = 10;
                  break;
                }
                _e189 = _step252.value;
                if (!(_e189.getRange().getIntersection(t) !== null)) {
                  _context32.next = 8;
                  break;
                }
                _context32.next = 8;
                return _e189;
              case 8:
                _context32.next = 3;
                break;
              case 10:
                _context32.next = 15;
                break;
              case 12:
                _context32.prev = 12;
                _context32.t0 = _context32["catch"](1);
                _iterator252.e(_context32.t0);
              case 15:
                _context32.prev = 15;
                _iterator252.f();
                return _context32.finish(15);
              case 18:
              case "end":
                return _context32.stop();
            }
          }, getMarkersIntersectingRange, this, [[1, 12, 15, 18]]);
        })
      }, {
        key: "destroy",
        value: function destroy() {
          var _iterator253 = _createForOfIteratorHelper(this._markers.values()),
            _step253;
          try {
            for (_iterator253.s(); !(_step253 = _iterator253.n()).done;) {
              var _t188 = _step253.value;
              this._destroyMarker(_t188);
            }
          } catch (err) {
            _iterator253.e(err);
          } finally {
            _iterator253.f();
          }
          this._markers = null;
          this.stopListening();
        }
      }, {
        key: "getMarkersGroup",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getMarkersGroup(t) {
          var _iterator254, _step254, _e190;
          return _regeneratorRuntime().wrap(function getMarkersGroup$(_context33) {
            while (1) switch (_context33.prev = _context33.next) {
              case 0:
                _iterator254 = _createForOfIteratorHelper(this._markers.values());
                _context33.prev = 1;
                _iterator254.s();
              case 3:
                if ((_step254 = _iterator254.n()).done) {
                  _context33.next = 10;
                  break;
                }
                _e190 = _step254.value;
                if (!_e190.name.startsWith(t + ":")) {
                  _context33.next = 8;
                  break;
                }
                _context33.next = 8;
                return _e190;
              case 8:
                _context33.next = 3;
                break;
              case 10:
                _context33.next = 15;
                break;
              case 12:
                _context33.prev = 12;
                _context33.t0 = _context33["catch"](1);
                _iterator254.e(_context33.t0);
              case 15:
                _context33.prev = 15;
                _iterator254.f();
                return _context33.finish(15);
              case 18:
              case "end":
                return _context33.stop();
            }
          }, getMarkersGroup, this, [[1, 12, 15, 18]]);
        })
      }, {
        key: "_destroyMarker",
        value: function _destroyMarker(t) {
          t.stopListening();
          t._detachLiveRange();
        }
      }]);
      return $g;
    }();
    _s($g, ds);
    var Zg = /*#__PURE__*/function () {
      function Zg(t, e, n, o) {
        _classCallCheck(this, Zg);
        this.name = t;
        this._liveRange = this._attachLiveRange(e);
        this._managedUsingOperations = n;
        this._affectsData = o;
      }
      _createClass(Zg, [{
        key: "getStart",
        value: function getStart() {
          if (!this._liveRange) {
            throw new ss["a"]("marker-destroyed", this);
          }
          return this._liveRange.start.clone();
        }
      }, {
        key: "getEnd",
        value: function getEnd() {
          if (!this._liveRange) {
            throw new ss["a"]("marker-destroyed", this);
          }
          return this._liveRange.end.clone();
        }
      }, {
        key: "getRange",
        value: function getRange() {
          if (!this._liveRange) {
            throw new ss["a"]("marker-destroyed", this);
          }
          return this._liveRange.toRange();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "marker" || t === "model:marker";
        }
      }, {
        key: "_attachLiveRange",
        value: function _attachLiveRange(t) {
          if (this._liveRange) {
            this._detachLiveRange();
          }
          t.delegate("change:range").to(this);
          t.delegate("change:content").to(this);
          this._liveRange = t;
          return t;
        }
      }, {
        key: "_detachLiveRange",
        value: function _detachLiveRange() {
          this._liveRange.stopDelegating("change:range", this);
          this._liveRange.stopDelegating("change:content", this);
          this._liveRange.detach();
          this._liveRange = null;
        }
      }, {
        key: "managedUsingOperations",
        get: function get() {
          if (!this._liveRange) {
            throw new ss["a"]("marker-destroyed", this);
          }
          return this._managedUsingOperations;
        }
      }, {
        key: "affectsData",
        get: function get() {
          if (!this._liveRange) {
            throw new ss["a"]("marker-destroyed", this);
          }
          return this._affectsData;
        }
      }]);
      return Zg;
    }();
    _s(Zg, ds);
    var Jg = /*#__PURE__*/function (_cg10) {
      _inherits(Jg, _cg10);
      function Jg() {
        _classCallCheck(this, Jg);
        return _possibleConstructorReturn(this, _getPrototypeOf(Jg).apply(this, arguments));
      }
      _createClass(Jg, [{
        key: "clone",
        value: function clone() {
          return new Jg(this.baseVersion);
        }
      }, {
        key: "getReversed",
        value: function getReversed() {
          return new Jg(this.baseVersion + 1);
        }
      }, {
        key: "_execute",
        value: function _execute() {}
      }, {
        key: "type",
        get: function get() {
          return "noop";
        }
      }], [{
        key: "className",
        get: function get() {
          return "NoOperation";
        }
      }]);
      return Jg;
    }(cg);
    var Xg = {};
    Xg[Ag.className] = Ag;
    Xg[yg.className] = yg;
    Xg[xg.className] = xg;
    Xg[vg.className] = vg;
    Xg[Jg.className] = Jg;
    Xg[cg.className] = cg;
    Xg[Dg.className] = Dg;
    Xg[Eg.className] = Eg;
    Xg[Sg.className] = Sg;
    Xg[Mg.className] = Mg;
    var tp = /*#__PURE__*/function () {
      function tp() {
        _classCallCheck(this, tp);
      }
      _createClass(tp, null, [{
        key: "fromJSON",
        value: function fromJSON(t, e) {
          return Xg[t.__className].fromJSON(t, e);
        }
      }]);
      return tp;
    }();
    var ep = /*#__PURE__*/function (_Zh) {
      _inherits(ep, _Zh);
      function ep(t, e) {
        var _this72;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "toNone";
        _classCallCheck(this, ep);
        _this72 = _possibleConstructorReturn(this, _getPrototypeOf(ep).call(this, t, e, n));
        if (!_this72.root.is("rootElement")) {
          throw new ss["a"]("model-liveposition-root-not-rootelement", t);
        }
        np.call(_assertThisInitialized(_assertThisInitialized(_this72)));
        return _this72;
      }
      _createClass(ep, [{
        key: "detach",
        value: function detach() {
          this.stopListening();
        }
      }, {
        key: "is",
        value: function is(t) {
          return t === "livePosition" || t === "model:livePosition" || t == "position" || t === "model:position";
        }
      }, {
        key: "toPosition",
        value: function toPosition() {
          return new Zh(this.root, this.path.slice(), this.stickiness);
        }
      }], [{
        key: "fromPosition",
        value: function fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e ? e : t.stickiness);
        }
      }]);
      return ep;
    }(Zh);
    function np() {
      var _this73 = this;
      this.listenTo(this.root.document.model, "applyOperation", function (t, e) {
        var n = e[0];
        if (!n.isDocumentOperation) {
          return;
        }
        op.call(_this73, n);
      }, {
        priority: "low"
      });
    }
    function op(t) {
      var e = this.getTransformedByOperation(t);
      if (!this.isEqual(e)) {
        var _t189 = this.toPosition();
        this.path = e.path;
        this.root = e.root;
        this.fire("change", _t189);
      }
    }
    _s(ep, ds);
    function ip(t, e, n, o) {
      return t.change(function (i) {
        var r;
        if (!n) {
          r = t.document.selection;
        } else if (n instanceof uf || n instanceof _f) {
          r = n;
        } else {
          r = i.createSelection(n, o);
        }
        if (!r.isCollapsed) {
          t.deleteContent(r, {
            doNotAutoparagraph: true
          });
        }
        var s = new rp(t, i, r.anchor);
        var a;
        if (e.is("documentFragment")) {
          a = e.getChildren();
        } else {
          a = [e];
        }
        s.handleNodes(a, {
          isFirst: true,
          isLast: true
        });
        var c = s.getSelectionRange();
        if (c) {
          if (r instanceof _f) {
            i.setSelection(c);
          } else {
            r.setTo(c);
          }
        } else {}
        var l = s.getAffectedRange() || t.createRange(r.anchor);
        s.destroy();
        return l;
      });
    }
    var rp = /*#__PURE__*/function () {
      function rp(t, e, n) {
        _classCallCheck(this, rp);
        this.model = t;
        this.writer = e;
        this.position = n;
        this.canMergeWith = new Set([this.position.parent]);
        this.schema = t.schema;
        this._filterAttributesOf = [];
        this._affectedStart = null;
        this._affectedEnd = null;
      }
      _createClass(rp, [{
        key: "handleNodes",
        value: function handleNodes(t, e) {
          t = Array.from(t);
          for (var _n167 = 0; _n167 < t.length; _n167++) {
            var _o106 = t[_n167];
            this._handleNode(_o106, {
              isFirst: _n167 === 0 && e.isFirst,
              isLast: _n167 === t.length - 1 && e.isLast
            });
          }
          this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer);
          this._filterAttributesOf = [];
        }
      }, {
        key: "getSelectionRange",
        value: function getSelectionRange() {
          if (this.nodeToSelect) {
            return ef._createOn(this.nodeToSelect);
          }
          return this.model.schema.getNearestSelectionRange(this.position);
        }
      }, {
        key: "getAffectedRange",
        value: function getAffectedRange() {
          if (!this._affectedStart) {
            return null;
          }
          return new ef(this._affectedStart, this._affectedEnd);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          if (this._affectedStart) {
            this._affectedStart.detach();
          }
          if (this._affectedEnd) {
            this._affectedEnd.detach();
          }
        }
      }, {
        key: "_handleNode",
        value: function _handleNode(t, e) {
          if (this.schema.isObject(t)) {
            this._handleObject(t, e);
            return;
          }
          var n = this._checkAndSplitToAllowedPosition(t, e);
          if (!n) {
            this._handleDisallowedNode(t, e);
            return;
          }
          this._insert(t);
          this._mergeSiblingsOf(t, e);
        }
      }, {
        key: "_handleObject",
        value: function _handleObject(t, e) {
          if (this._checkAndSplitToAllowedPosition(t)) {
            this._insert(t);
          } else {
            this._tryAutoparagraphing(t, e);
          }
        }
      }, {
        key: "_handleDisallowedNode",
        value: function _handleDisallowedNode(t, e) {
          if (t.is("element")) {
            this.handleNodes(t.getChildren(), e);
          } else {
            this._tryAutoparagraphing(t, e);
          }
        }
      }, {
        key: "_insert",
        value: function _insert(t) {
          if (!this.schema.checkChild(this.position, t)) {
            throw new ss["a"]("insertcontent-wrong-position", this, {
              node: t,
              position: this.position
            });
          }
          var e = ep.fromPosition(this.position, "toNext");
          this._setAffectedBoundaries(this.position);
          this.writer.insert(t, this.position);
          this.position = e.toPosition();
          e.detach();
          if (this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text")) {
            this.nodeToSelect = t;
          } else {
            this.nodeToSelect = null;
          }
          this._filterAttributesOf.push(t);
        }
      }, {
        key: "_setAffectedBoundaries",
        value: function _setAffectedBoundaries(t) {
          if (!this._affectedStart) {
            this._affectedStart = ep.fromPosition(t, "toPrevious");
          }
          if (!this._affectedEnd || this._affectedEnd.isBefore(t)) {
            if (this._affectedEnd) {
              this._affectedEnd.detach();
            }
            this._affectedEnd = ep.fromPosition(t, "toNext");
          }
        }
      }, {
        key: "_mergeSiblingsOf",
        value: function _mergeSiblingsOf(t, e) {
          if (!(t instanceof qh)) {
            return;
          }
          var n = this._canMergeLeft(t, e);
          var o = this._canMergeRight(t, e);
          var i = ep._createBefore(t);
          i.stickiness = "toNext";
          var r = ep._createAfter(t);
          r.stickiness = "toNext";
          if (n) {
            var _t190 = ep.fromPosition(this.position);
            _t190.stickiness = "toNext";
            if (this._affectedStart.isEqual(i)) {
              this._affectedStart.detach();
              this._affectedStart = ep._createAt(i.nodeBefore, "end", "toPrevious");
            }
            this.writer.merge(i);
            if (i.isEqual(this._affectedEnd) && e.isLast) {
              this._affectedEnd.detach();
              this._affectedEnd = ep._createAt(i.nodeBefore, "end", "toNext");
            }
            this.position = _t190.toPosition();
            _t190.detach();
          }
          if (o) {
            if (!this.position.isEqual(r)) {
              throw new ss["a"]("insertcontent-invalid-insertion-position", this);
            }
            this.position = Zh._createAt(r.nodeBefore, "end");
            var _t191 = ep.fromPosition(this.position, "toPrevious");
            if (this._affectedEnd.isEqual(r)) {
              this._affectedEnd.detach();
              this._affectedEnd = ep._createAt(r.nodeBefore, "end", "toNext");
            }
            this.writer.merge(r);
            if (r.getShiftedBy(-1).isEqual(this._affectedStart) && e.isFirst) {
              this._affectedStart.detach();
              this._affectedStart = ep._createAt(r.nodeBefore, 0, "toPrevious");
            }
            this.position = _t191.toPosition();
            _t191.detach();
          }
          if (n || o) {
            this._filterAttributesOf.push(this.position.parent);
          }
          i.detach();
          r.detach();
        }
      }, {
        key: "_canMergeLeft",
        value: function _canMergeLeft(t, e) {
          var n = t.previousSibling;
          return e.isFirst && n instanceof qh && this.canMergeWith.has(n) && this.model.schema.checkMerge(n, t);
        }
      }, {
        key: "_canMergeRight",
        value: function _canMergeRight(t, e) {
          var n = t.nextSibling;
          return e.isLast && n instanceof qh && this.canMergeWith.has(n) && this.model.schema.checkMerge(t, n);
        }
      }, {
        key: "_tryAutoparagraphing",
        value: function _tryAutoparagraphing(t, e) {
          var n = this.writer.createElement("paragraph");
          if (this._getAllowedIn(n, this.position.parent) && this.schema.checkChild(n, t)) {
            n._appendChild(t);
            this._handleNode(n, e);
          }
        }
      }, {
        key: "_checkAndSplitToAllowedPosition",
        value: function _checkAndSplitToAllowedPosition(t) {
          var e = this._getAllowedIn(t, this.position.parent);
          if (!e) {
            return false;
          }
          while (e != this.position.parent) {
            if (this.schema.isLimit(this.position.parent)) {
              return false;
            }
            if (this.position.isAtStart) {
              var _t192 = this.position.parent;
              this.position = this.writer.createPositionBefore(_t192);
              if (_t192.isEmpty && _t192.parent === e) {
                this.writer.remove(_t192);
              }
            } else if (this.position.isAtEnd) {
              this.position = this.writer.createPositionAfter(this.position.parent);
            } else {
              var _t193 = this.writer.createPositionAfter(this.position.parent);
              this._setAffectedBoundaries(this.position);
              this.writer.split(this.position);
              this.position = _t193;
              this.canMergeWith.add(this.position.nodeAfter);
            }
          }
          return true;
        }
      }, {
        key: "_getAllowedIn",
        value: function _getAllowedIn(t, e) {
          if (this.schema.checkChild(e, t)) {
            return e;
          }
          if (e.parent) {
            return this._getAllowedIn(t, e.parent);
          }
          return null;
        }
      }]);
      return rp;
    }();
    function sp(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (e.isCollapsed) {
        return;
      }
      var o = e.getFirstRange();
      if (o.root.rootName == "$graveyard") {
        return;
      }
      var i = t.schema;
      t.change(function (t) {
        if (!n.doNotResetEntireContent && wp(i, e)) {
          bp(t, e, i);
          return;
        }
        var _ap = ap(o),
          _ap2 = _slicedToArray(_ap, 2),
          r = _ap2[0],
          s = _ap2[1];
        if (!r.isTouching(s)) {
          t.remove(t.createRange(r, s));
        }
        if (!n.leaveUnmerged) {
          lp(t, r, s);
          i.removeDisallowedAttributes(r.parent.getChildren(), t);
        }
        Cp(t, e, r);
        if (!n.doNotAutoparagraph && gp(i, r)) {
          kp(t, r, e);
        }
        r.detach();
        s.detach();
      });
    }
    function ap(t) {
      var e = t.root.document.model;
      var n = t.start;
      var o = t.end;
      if (e.hasContent(t, {
        ignoreMarkers: true
      })) {
        var _n168 = cp(o);
        if (_n168 && o.isTouching(e.createPositionAt(_n168, 0))) {
          var _n169 = e.createSelection(t);
          e.modifySelection(_n169, {
            direction: "backward"
          });
          o = _n169.getLastPosition();
        }
      }
      return [ep.fromPosition(n, "toPrevious"), ep.fromPosition(o, "toNext")];
    }
    function cp(t) {
      var e = t.parent;
      var n = e.root.document.model.schema;
      var o = e.getAncestors({
        parentFirst: true,
        includeSelf: true
      });
      var _iterator255 = _createForOfIteratorHelper(o),
        _step255;
      try {
        for (_iterator255.s(); !(_step255 = _iterator255.n()).done;) {
          var _t194 = _step255.value;
          if (n.isLimit(_t194)) {
            return null;
          }
          if (n.isBlock(_t194)) {
            return _t194;
          }
        }
      } catch (err) {
        _iterator255.e(err);
      } finally {
        _iterator255.f();
      }
    }
    function lp(t, e, n) {
      var o = t.model;
      if (!fp(t.model.schema, e, n)) {
        return;
      }
      var _mp = mp(e, n),
        _mp2 = _slicedToArray(_mp, 2),
        i = _mp2[0],
        r = _mp2[1];
      if (!i || !r) {
        return;
      }
      if (!o.hasContent(i, {
        ignoreMarkers: true
      }) && o.hasContent(r, {
        ignoreMarkers: true
      })) {
        up(t, e, n, i.parent);
      } else {
        dp(t, e, n, i.parent);
      }
    }
    function dp(t, e, n, o) {
      var i = e.parent;
      var r = n.parent;
      if (i == o || r == o) {
        return;
      }
      e = t.createPositionAfter(i);
      n = t.createPositionBefore(r);
      if (!n.isEqual(e)) {
        t.insert(r, e);
      }
      t.merge(e);
      while (n.parent.isEmpty) {
        var _e191 = n.parent;
        n = t.createPositionBefore(_e191);
        t.remove(_e191);
      }
      if (!fp(t.model.schema, e, n)) {
        return;
      }
      dp(t, e, n, o);
    }
    function up(t, e, n, o) {
      var i = e.parent;
      var r = n.parent;
      if (i == o || r == o) {
        return;
      }
      e = t.createPositionAfter(i);
      n = t.createPositionBefore(r);
      if (!n.isEqual(e)) {
        t.insert(i, n);
      }
      while (e.parent.isEmpty) {
        var _n170 = e.parent;
        e = t.createPositionBefore(_n170);
        t.remove(_n170);
      }
      n = t.createPositionBefore(r);
      hp(t, n);
      if (!fp(t.model.schema, e, n)) {
        return;
      }
      up(t, e, n, o);
    }
    function hp(t, e) {
      var n = e.nodeBefore;
      var o = e.nodeAfter;
      if (n.name != o.name) {
        t.rename(n, o.name);
      }
      t.clearAttributes(n);
      t.setAttributes(Object.fromEntries(o.getAttributes()), n);
      t.merge(e);
    }
    function fp(t, e, n) {
      var o = e.parent;
      var i = n.parent;
      if (o == i) {
        return false;
      }
      if (t.isLimit(o) || t.isLimit(i)) {
        return false;
      }
      return pp(e, n, t);
    }
    function mp(t, e) {
      var n = t.getAncestors();
      var o = e.getAncestors();
      var i = 0;
      while (n[i] && n[i] == o[i]) {
        i++;
      }
      return [n[i], o[i]];
    }
    function gp(t, e) {
      var n = t.checkChild(e, "$text");
      var o = t.checkChild(e, "paragraph");
      return !n && o;
    }
    function pp(t, e, n) {
      var o = new ef(t, e);
      var _iterator256 = _createForOfIteratorHelper(o.getWalker()),
        _step256;
      try {
        for (_iterator256.s(); !(_step256 = _iterator256.n()).done;) {
          var _t195 = _step256.value;
          if (n.isLimit(_t195.item)) {
            return false;
          }
        }
      } catch (err) {
        _iterator256.e(err);
      } finally {
        _iterator256.f();
      }
      return true;
    }
    function kp(t, e, n) {
      var o = t.createElement("paragraph");
      t.insert(o, e);
      Cp(t, n, t.createPositionAt(o, 0));
    }
    function bp(t, e) {
      var n = t.model.schema.getLimitElement(e);
      t.remove(t.createRangeIn(n));
      kp(t, t.createPositionAt(n, 0), e);
    }
    function wp(t, e) {
      var n = t.getLimitElement(e);
      if (!e.containsEntireContent(n)) {
        return false;
      }
      var o = e.getFirstRange();
      if (o.start.parent == o.end.parent) {
        return false;
      }
      return t.checkChild(n, "paragraph");
    }
    function Cp(t, e, n) {
      if (e instanceof _f) {
        t.setSelection(n);
      } else {
        e.setTo(n);
      }
    }
    var Ap = ' ,.?!:;"-()';
    function _p(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = t.schema;
      var i = n.direction != "backward";
      var r = n.unit ? n.unit : "character";
      var s = e.focus;
      var a = new Qh({
        boundaries: Dp(s, i),
        singleCharacters: true,
        direction: i ? "forward" : "backward"
      });
      var c = {
        walker: a,
        schema: o,
        isForward: i,
        unit: r
      };
      var l;
      var _loop3 = function _loop3() {
          if (l.done) {
            return {
              v: void 0
            };
          }
          var n = vp(c, l.value);
          if (n) {
            if (e instanceof _f) {
              t.change(function (t) {
                t.setSelectionFocus(n);
              });
            } else {
              e.setFocus(n);
            }
            return {
              v: void 0
            };
          }
        },
        _ret;
      while (l = a.next()) {
        _ret = _loop3();
        if (_ret) return _ret.v;
      }
    }
    function vp(t, e) {
      var n = t.isForward,
        o = t.walker,
        i = t.unit,
        r = t.schema;
      var s = e.type,
        a = e.item,
        c = e.nextPosition;
      if (s == "text") {
        if (t.unit === "word") {
          return xp(o, n);
        }
        return yp(o, i, n);
      }
      if (s == (n ? "elementStart" : "elementEnd")) {
        if (r.isSelectable(a)) {
          return Zh._createAt(a, n ? "after" : "before");
        }
        if (r.checkChild(c, "$text")) {
          return c;
        }
      } else {
        if (r.isLimit(a)) {
          o.skip(function () {
            return true;
          });
          return;
        }
        if (r.checkChild(c, "$text")) {
          return c;
        }
      }
    }
    function yp(t, e) {
      var n = t.position.textNode;
      if (n) {
        var _o107 = n.data;
        var _i91 = t.position.offset - n.startOffset;
        while (Wg(_o107, _i91) || e == "character" && Kg(_o107, _i91)) {
          t.next();
          _i91 = t.position.offset - n.startOffset;
        }
      }
      return t.position;
    }
    function xp(t, e) {
      var n = t.position.textNode;
      if (n) {
        var _o108 = t.position.offset - n.startOffset;
        while (!Ep(n.data, _o108, e) && !Mp(n, _o108, e)) {
          t.next();
          var _i92 = e ? t.position.nodeAfter : t.position.nodeBefore;
          if (_i92 && _i92.is("$text")) {
            var _o109 = _i92.data.charAt(e ? 0 : _i92.data.length - 1);
            if (!Ap.includes(_o109)) {
              t.next();
              n = t.position.textNode;
            }
          }
          _o108 = t.position.offset - n.startOffset;
        }
      }
      return t.position;
    }
    function Dp(t, e) {
      var n = t.root;
      var o = Zh._createAt(n, e ? "end" : 0);
      if (e) {
        return new ef(t, o);
      } else {
        return new ef(o, t);
      }
    }
    function Ep(t, e, n) {
      var o = e + (n ? 0 : -1);
      return Ap.includes(t.charAt(o));
    }
    function Mp(t, e, n) {
      return e === (n ? t.endOffset : 0);
    }
    function Sp(t, e) {
      return t.change(function (t) {
        var n = t.createDocumentFragment();
        var o = e.getFirstRange();
        if (!o || o.isCollapsed) {
          return n;
        }
        var i = o.start.root;
        var r = o.start.getCommonPath(o.end);
        var s = i.getNodeByPath(r);
        var a;
        if (o.start.parent == o.end.parent) {
          a = o;
        } else {
          a = t.createRange(t.createPositionAt(s, o.start.path[r.length]), t.createPositionAt(s, o.end.path[r.length] + 1));
        }
        var c = a.end.offset - a.start.offset;
        var _iterator257 = _createForOfIteratorHelper(a.getItems({
            shallow: true
          })),
          _step257;
        try {
          for (_iterator257.s(); !(_step257 = _iterator257.n()).done;) {
            var _e193 = _step257.value;
            if (_e193.is("$textProxy")) {
              t.appendText(_e193.data, _e193.getAttributes(), n);
            } else {
              t.append(t.cloneElement(_e193, true), n);
            }
          }
        } catch (err) {
          _iterator257.e(err);
        } finally {
          _iterator257.f();
        }
        if (a != o) {
          var _e192 = o._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0];
          var _i93 = t.createRange(t.createPositionAt(n, 0), _e192.start);
          var _r27 = t.createRange(_e192.end, t.createPositionAt(n, "end"));
          Tp(_r27, t);
          Tp(_i93, t);
        }
        return n;
      });
    }
    function Tp(t, e) {
      var n = [];
      Array.from(t.getItems({
        direction: "backward"
      })).map(function (t) {
        return e.createRangeOn(t);
      }).filter(function (e) {
        var n = (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
        return n;
      }).forEach(function (t) {
        n.push(t.start.parent);
        e.remove(t);
      });
      n.forEach(function (t) {
        var n = t;
        while (n.parent && n.isEmpty) {
          var _t196 = e.createRangeOn(n);
          n = n.parent;
          e.remove(_t196);
        }
      });
    }
    function Ip(t) {
      t.document.registerPostFixer(function (e) {
        return Np(e, t);
      });
    }
    function Np(t, e) {
      var n = e.document.selection;
      var o = e.schema;
      var i = [];
      var r = false;
      var _iterator258 = _createForOfIteratorHelper(n.getRanges()),
        _step258;
      try {
        for (_iterator258.s(); !(_step258 = _iterator258.n()).done;) {
          var _t197 = _step258.value;
          var _e194 = Pp(_t197, o);
          if (_e194 && !_e194.isEqual(_t197)) {
            i.push(_e194);
            r = true;
          } else {
            i.push(_t197);
          }
        }
      } catch (err) {
        _iterator258.e(err);
      } finally {
        _iterator258.f();
      }
      if (r) {
        t.setSelection(Rp(i), {
          backward: n.isBackward
        });
      }
    }
    function Pp(t, e) {
      if (t.isCollapsed) {
        return Bp(t, e);
      }
      return zp(t, e);
    }
    function Bp(t, e) {
      var n = t.start;
      var o = e.getNearestSelectionRange(n);
      if (!o) {
        return null;
      }
      if (!o.isCollapsed) {
        return o;
      }
      var i = o.start;
      if (n.isEqual(i)) {
        return null;
      }
      return new ef(i);
    }
    function zp(t, e) {
      var n = t.start,
        o = t.end;
      var i = e.checkChild(n, "$text");
      var r = e.checkChild(o, "$text");
      var s = e.getLimitElement(n);
      var a = e.getLimitElement(o);
      if (s === a) {
        if (i && r) {
          return null;
        }
        if (Op(n, o, e)) {
          var _t198 = n.nodeAfter && e.isSelectable(n.nodeAfter);
          var _i94 = _t198 ? null : e.getNearestSelectionRange(n, "forward");
          var _r28 = o.nodeBefore && e.isSelectable(o.nodeBefore);
          var _s22 = _r28 ? null : e.getNearestSelectionRange(o, "backward");
          var _a12 = _i94 ? _i94.start : n;
          var _c5 = _s22 ? _s22.end : o;
          return new ef(_a12, _c5);
        }
      }
      var c = s && !s.is("rootElement");
      var l = a && !a.is("rootElement");
      if (c || l) {
        var _t199 = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent;
        var _i95 = c && (!_t199 || !jp(n.nodeAfter, e));
        var _r29 = l && (!_t199 || !jp(o.nodeBefore, e));
        var _d2 = n;
        var _u2 = o;
        if (_i95) {
          _d2 = Zh._createBefore(Lp(s, e));
        }
        if (_r29) {
          _u2 = Zh._createAfter(Lp(a, e));
        }
        return new ef(_d2, _u2);
      }
      return null;
    }
    function Lp(t, e) {
      var n = t;
      var o = n;
      while (e.isLimit(o) && o.parent) {
        n = o;
        o = o.parent;
      }
      return n;
    }
    function Op(t, e, n) {
      var o = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text");
      var i = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
      return o || i;
    }
    function Rp(t) {
      var e = [];
      e.push(t.shift());
      var _iterator259 = _createForOfIteratorHelper(t),
        _step259;
      try {
        for (_iterator259.s(); !(_step259 = _iterator259.n()).done;) {
          var _n171 = _step259.value;
          var _t200 = e.pop();
          if (_n171.isEqual(_t200)) {
            e.push(_t200);
          } else if (_n171.isIntersecting(_t200)) {
            var _o110 = _t200.start.isAfter(_n171.start) ? _n171.start : _t200.start;
            var _i96 = _t200.end.isAfter(_n171.end) ? _t200.end : _n171.end;
            var _r30 = new ef(_o110, _i96);
            e.push(_r30);
          } else {
            e.push(_t200);
            e.push(_n171);
          }
        }
      } catch (err) {
        _iterator259.e(err);
      } finally {
        _iterator259.f();
      }
      return e;
    }
    function jp(t, e) {
      return t && e.isSelectable(t);
    }
    var Fp = /*#__PURE__*/function () {
      function Fp() {
        var _this74 = this;
        _classCallCheck(this, Fp);
        this.markers = new $g();
        this.document = new Yg(this);
        this.schema = new zm();
        this._pendingChanges = [];
        this._currentWriter = null;
        ["insertContent", "deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach(function (t) {
          return _this74.decorate(t);
        });
        this.on("applyOperation", function (t, e) {
          var n = e[0];
          n._validate();
        }, {
          priority: "highest"
        });
        this.schema.register("$root", {
          isLimit: true
        });
        this.schema.register("$block", {
          allowIn: "$root",
          isBlock: true
        });
        this.schema.register("$text", {
          allowIn: "$block",
          isInline: true,
          isContent: true
        });
        this.schema.register("$clipboardHolder", {
          allowContentOf: "$root",
          isLimit: true
        });
        this.schema.extend("$text", {
          allowIn: "$clipboardHolder"
        });
        this.schema.register("$marker");
        this.schema.addChildCheck(function (t, e) {
          if (e.name === "$marker") {
            return true;
          }
        });
        Ip(this);
        this.document.registerPostFixer(cm);
      }
      _createClass(Fp, [{
        key: "change",
        value: function change(t) {
          try {
            if (this._pendingChanges.length === 0) {
              this._pendingChanges.push({
                batch: new ag(),
                callback: t
              });
              return this._runPendingChanges()[0];
            } else {
              return t(this._currentWriter);
            }
          } catch (t) {
            ss["a"].rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "enqueueChange",
        value: function enqueueChange(t, e) {
          try {
            if (typeof t === "string") {
              t = new ag(t);
            } else if (typeof t == "function") {
              e = t;
              t = new ag();
            }
            this._pendingChanges.push({
              batch: t,
              callback: e
            });
            if (this._pendingChanges.length == 1) {
              this._runPendingChanges();
            }
          } catch (t) {
            ss["a"].rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "applyOperation",
        value: function applyOperation(t) {
          t._execute();
        }
      }, {
        key: "insertContent",
        value: function insertContent(t, e, n) {
          return ip(this, t, e, n);
        }
      }, {
        key: "deleteContent",
        value: function deleteContent(t, e) {
          sp(this, t, e);
        }
      }, {
        key: "modifySelection",
        value: function modifySelection(t, e) {
          _p(this, t, e);
        }
      }, {
        key: "getSelectedContent",
        value: function getSelectedContent(t) {
          return Sp(this, t);
        }
      }, {
        key: "hasContent",
        value: function hasContent(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = t instanceof qh ? ef._createIn(t) : t;
          if (n.isCollapsed) {
            return false;
          }
          var _e$ignoreWhitespaces = e.ignoreWhitespaces,
            o = _e$ignoreWhitespaces === void 0 ? false : _e$ignoreWhitespaces,
            _e$ignoreMarkers = e.ignoreMarkers,
            i = _e$ignoreMarkers === void 0 ? false : _e$ignoreMarkers;
          if (!i) {
            var _iterator260 = _createForOfIteratorHelper(this.markers.getMarkersIntersectingRange(n)),
              _step260;
            try {
              for (_iterator260.s(); !(_step260 = _iterator260.n()).done;) {
                var _t201 = _step260.value;
                if (_t201.affectsData) {
                  return true;
                }
              }
            } catch (err) {
              _iterator260.e(err);
            } finally {
              _iterator260.f();
            }
          }
          var _iterator261 = _createForOfIteratorHelper(n.getItems()),
            _step261;
          try {
            for (_iterator261.s(); !(_step261 = _iterator261.n()).done;) {
              var _t202 = _step261.value;
              if (this.schema.isContent(_t202)) {
                if (_t202.is("$textProxy")) {
                  if (!o) {
                    return true;
                  } else if (_t202.data.search(/\S/) !== -1) {
                    return true;
                  }
                } else {
                  return true;
                }
              }
            }
          } catch (err) {
            _iterator261.e(err);
          } finally {
            _iterator261.f();
          }
          return false;
        }
      }, {
        key: "createPositionFromPath",
        value: function createPositionFromPath(t, e, n) {
          return new Zh(t, e, n);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return Zh._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return Zh._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return Zh._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new ef(t, e);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return ef._createIn(t);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return ef._createOn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new uf(t, e, n);
        }
      }, {
        key: "createBatch",
        value: function createBatch(t) {
          return new ag(t);
        }
      }, {
        key: "createOperationFromJSON",
        value: function createOperationFromJSON(t) {
          return tp.fromJSON(t, this.document);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.document.destroy();
          this.stopListening();
        }
      }, {
        key: "_runPendingChanges",
        value: function _runPendingChanges() {
          var t = [];
          this.fire("_beforeChanges");
          while (this._pendingChanges.length) {
            var _e195 = this._pendingChanges[0].batch;
            this._currentWriter = new Ig(this, _e195);
            var _n172 = this._pendingChanges[0].callback(this._currentWriter);
            t.push(_n172);
            this.document._handleChangeBlock(this._currentWriter);
            this._pendingChanges.shift();
            this._currentWriter = null;
          }
          this.fire("_afterChanges");
          return t;
        }
      }]);
      return Fp;
    }();
    _s(Fp, Zc);
    var Vp = /*#__PURE__*/function () {
      function Vp() {
        _classCallCheck(this, Vp);
        this._listener = Object.create(Zd);
      }
      _createClass(Vp, [{
        key: "listenTo",
        value: function listenTo(t) {
          var _this75 = this;
          this._listener.listenTo(t, "keydown", function (t, e) {
            _this75._listener.fire("_keydown:" + Ol(e), e);
          });
        }
      }, {
        key: "set",
        value: function set(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          var o = Rl(t);
          var i = n.priority;
          this._listener.listenTo(this._listener, "_keydown:" + o, function (t, n) {
            e(n, function () {
              n.preventDefault();
              n.stopPropagation();
              t.stop();
            });
            t.return = true;
          }, {
            priority: i
          });
        }
      }, {
        key: "press",
        value: function press(t) {
          return !!this._listener.fire("_keydown:" + Ol(t), t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._listener.stopListening();
        }
      }]);
      return Vp;
    }();
    var Up = /*#__PURE__*/function (_Vp) {
      _inherits(Up, _Vp);
      function Up(t) {
        var _this76;
        _classCallCheck(this, Up);
        _this76 = _possibleConstructorReturn(this, _getPrototypeOf(Up).call(this));
        _this76.editor = t;
        return _this76;
      }
      _createClass(Up, [{
        key: "set",
        value: function set(t, e) {
          var _this77 = this;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (typeof e == "string") {
            var _t203 = e;
            e = function e(_e196, n) {
              _this77.editor.execute(_t203);
              n();
            };
          }
          _get(_getPrototypeOf(Up.prototype), "set", this).call(this, t, e, n);
        }
      }]);
      return Up;
    }(Vp);
    var Hp = /*#__PURE__*/function () {
      function Hp() {
        var _this78 = this;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _classCallCheck(this, Hp);
        this._context = t.context || new zs({
          language: t.language
        });
        this._context._addEditor(this, !t.context);
        var e = Array.from(this.constructor.builtinPlugins || []);
        this.config = new Qr(t, this.constructor.defaultConfig);
        this.config.define("plugins", e);
        this.config.define(this._context._getEditorConfig());
        this.plugins = new ys(this, e, this._context.plugins);
        this.locale = this._context.locale;
        this.t = this.locale.t;
        this.commands = new Nm();
        this.set("state", "initializing");
        this.once("ready", function () {
          return _this78.state = "ready";
        }, {
          priority: "high"
        });
        this.once("destroy", function () {
          return _this78.state = "destroyed";
        }, {
          priority: "high"
        });
        this.set("isReadOnly", false);
        this.model = new Fp();
        var n = new zc();
        this.data = new ng(this.model, n);
        this.editing = new Im(this.model, n);
        this.editing.view.document.bind("isReadOnly").to(this);
        this.conversion = new ig([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher);
        this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher);
        this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher);
        this.keystrokes = new Up(this);
        this.keystrokes.listenTo(this.editing.view.document);
      }
      _createClass(Hp, [{
        key: "initPlugins",
        value: function initPlugins() {
          var t = this.config;
          var e = t.get("plugins");
          var n = t.get("removePlugins") || [];
          var o = t.get("extraPlugins") || [];
          return this.plugins.init(e.concat(o), n);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var _this79 = this;
          var t = Promise.resolve();
          if (this.state == "initializing") {
            t = new Promise(function (t) {
              return _this79.once("ready", t);
            });
          }
          return t.then(function () {
            _this79.fire("destroy");
            _this79.stopListening();
            _this79.commands.destroy();
          }).then(function () {
            return _this79.plugins.destroy();
          }).then(function () {
            _this79.model.destroy();
            _this79.data.destroy();
            _this79.editing.destroy();
            _this79.keystrokes.destroy();
          }).then(function () {
            return _this79._context._removeEditor(_this79);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          try {
            var _this$commands;
            return (_this$commands = this.commands).execute.apply(_this$commands, arguments);
          } catch (t) {
            ss["a"].rethrowUnexpectedError(t, this);
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          this.editing.view.focus();
        }
      }]);
      return Hp;
    }();
    _s(Hp, Zc);
    var Gp = {
      setData: function setData(t) {
        this.data.set(t);
      },
      getData: function getData(t) {
        return this.data.get(t);
      }
    };
    var Wp = Gp;
    function Kp(t, e) {
      if (t instanceof HTMLTextAreaElement) {
        t.value = e;
      }
      t.innerHTML = e;
    }
    var qp = {
      updateSourceElement: function updateSourceElement() {
        if (!this.sourceElement) {
          throw new ss["a"]("editor-missing-sourceelement", this);
        }
        Kp(this.sourceElement, this.data.get());
      }
    };
    var Yp = qp;
    function Qp(t) {
      if (!mt(t.updateSourceElement)) {
        throw new ss["a"]("attachtoform-missing-elementapi-interface", t);
      }
      var e = t.sourceElement;
      if (e && e.tagName.toLowerCase() === "textarea" && e.form) {
        var _n173;
        var _o111 = e.form;
        var _i97 = function _i97() {
          return t.updateSourceElement();
        };
        if (mt(_o111.submit)) {
          _n173 = _o111.submit;
          _o111.submit = function () {
            _i97();
            _n173.apply(_o111);
          };
        }
        _o111.addEventListener("submit", _i97);
        t.on("destroy", function () {
          _o111.removeEventListener("submit", _i97);
          if (_n173) {
            _o111.submit = _n173;
          }
        });
      }
    }
    var $p = /*#__PURE__*/function () {
      function $p() {
        _classCallCheck(this, $p);
      }
      _createClass($p, [{
        key: "getHtml",
        value: function getHtml(t) {
          var e = document.implementation.createHTMLDocument("");
          var n = e.createElement("div");
          n.appendChild(t);
          return n.innerHTML;
        }
      }]);
      return $p;
    }();
    var Zp = /*#__PURE__*/function () {
      function Zp(t) {
        _classCallCheck(this, Zp);
        this._domParser = new DOMParser();
        this._domConverter = new Gd(t, {
          blockFillerMode: "nbsp"
        });
        this._htmlWriter = new $p();
      }
      _createClass(Zp, [{
        key: "toData",
        value: function toData(t) {
          var e = this._domConverter.viewToDom(t, document);
          return this._htmlWriter.getHtml(e);
        }
      }, {
        key: "toView",
        value: function toView(t) {
          var e = this._toDom(t);
          return this._domConverter.domToView(e);
        }
      }, {
        key: "registerRawContentMatcher",
        value: function registerRawContentMatcher(t) {
          this._domConverter.registerRawContentMatcher(t);
        }
      }, {
        key: "_toDom",
        value: function _toDom(t) {
          var e = this._domParser.parseFromString(t, "text/html");
          var n = e.createDocumentFragment();
          var o = e.body.childNodes;
          while (o.length > 0) {
            n.appendChild(o[0]);
          }
          return n;
        }
      }]);
      return Zp;
    }();
    var Jp = /*#__PURE__*/function () {
      function Jp(t) {
        _classCallCheck(this, Jp);
        this.editor = t;
        this._components = new Map();
      }
      _createClass(Jp, [{
        key: "names",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function names() {
          var _iterator262, _step262, _t204;
          return _regeneratorRuntime().wrap(function names$(_context34) {
            while (1) switch (_context34.prev = _context34.next) {
              case 0:
                _iterator262 = _createForOfIteratorHelper(this._components.values());
                _context34.prev = 1;
                _iterator262.s();
              case 3:
                if ((_step262 = _iterator262.n()).done) {
                  _context34.next = 9;
                  break;
                }
                _t204 = _step262.value;
                _context34.next = 7;
                return _t204.originalName;
              case 7:
                _context34.next = 3;
                break;
              case 9:
                _context34.next = 14;
                break;
              case 11:
                _context34.prev = 11;
                _context34.t0 = _context34["catch"](1);
                _iterator262.e(_context34.t0);
              case 14:
                _context34.prev = 14;
                _iterator262.f();
                return _context34.finish(14);
              case 17:
              case "end":
                return _context34.stop();
            }
          }, names, this, [[1, 11, 14, 17]]);
        })
      }, {
        key: "add",
        value: function add(t, e) {
          this._components.set(Xp(t), {
            callback: e,
            originalName: t
          });
        }
      }, {
        key: "create",
        value: function create(t) {
          if (!this.has(t)) {
            throw new ss["a"]("componentfactory-item-missing", this, {
              name: t
            });
          }
          return this._components.get(Xp(t)).callback(this.editor.locale);
        }
      }, {
        key: "has",
        value: function has(t) {
          return this._components.has(Xp(t));
        }
      }]);
      return Jp;
    }();
    function Xp(t) {
      return String(t).toLowerCase();
    }
    var tk = /*#__PURE__*/function () {
      function tk() {
        _classCallCheck(this, tk);
        this.set("isFocused", false);
        this.set("focusedElement", null);
        this._elements = new Set();
        this._nextEventLoopTimeout = null;
      }
      _createClass(tk, [{
        key: "add",
        value: function add(t) {
          var _this80 = this;
          if (this._elements.has(t)) {
            throw new ss["a"]("focustracker-add-element-already-exist", this);
          }
          this.listenTo(t, "focus", function () {
            return _this80._focus(t);
          }, {
            useCapture: true
          });
          this.listenTo(t, "blur", function () {
            return _this80._blur();
          }, {
            useCapture: true
          });
          this._elements.add(t);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (t === this.focusedElement) {
            this._blur(t);
          }
          if (this._elements.has(t)) {
            this.stopListening(t);
            this._elements.delete(t);
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          clearTimeout(this._nextEventLoopTimeout);
          this.focusedElement = t;
          this.isFocused = true;
        }
      }, {
        key: "_blur",
        value: function _blur() {
          var _this81 = this;
          clearTimeout(this._nextEventLoopTimeout);
          this._nextEventLoopTimeout = setTimeout(function () {
            _this81.focusedElement = null;
            _this81.isFocused = false;
          }, 0);
        }
      }]);
      return tk;
    }();
    _s(tk, Zd);
    _s(tk, Zc);
    var ek = /*#__PURE__*/function () {
      function ek(t) {
        var _this82 = this;
        _classCallCheck(this, ek);
        this.editor = t;
        this.componentFactory = new Jp(t);
        this.focusTracker = new tk();
        this._editableElementsMap = new Map();
        this.listenTo(t.editing.view.document, "layoutChanged", function () {
          return _this82.update();
        });
      }
      _createClass(ek, [{
        key: "update",
        value: function update() {
          this.fire("update");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
          this.focusTracker.destroy();
          var _iterator263 = _createForOfIteratorHelper(this._editableElementsMap.values()),
            _step263;
          try {
            for (_iterator263.s(); !(_step263 = _iterator263.n()).done;) {
              var _t205 = _step263.value;
              _t205.ckeditorInstance = null;
            }
          } catch (err) {
            _iterator263.e(err);
          } finally {
            _iterator263.f();
          }
          this._editableElementsMap = new Map();
        }
      }, {
        key: "setEditableElement",
        value: function setEditableElement(t, e) {
          this._editableElementsMap.set(t, e);
          if (!e.ckeditorInstance) {
            e.ckeditorInstance = this.editor;
          }
        }
      }, {
        key: "getEditableElement",
        value: function getEditableElement() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "main";
          return this._editableElementsMap.get(t);
        }
      }, {
        key: "getEditableElementsNames",
        value: function getEditableElementsNames() {
          return this._editableElementsMap.keys();
        }
      }, {
        key: "element",
        get: function get() {
          return null;
        }
      }, {
        key: "_editableElements",
        get: function get() {
          console.warn("editor-ui-deprecated-editable-elements: " + "The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
            editorUI: this
          });
          return this._editableElementsMap;
        }
      }]);
      return ek;
    }();
    _s(ek, ds);
    function nk(_ref15) {
      var t = _ref15.origin,
        e = _ref15.originKeystrokeHandler,
        n = _ref15.originFocusTracker,
        o = _ref15.toolbar,
        i = _ref15.beforeFocus,
        r = _ref15.afterBlur;
      n.add(o.element);
      e.set("Alt+F10", function (t, e) {
        if (n.isFocused && !o.focusTracker.isFocused) {
          if (i) {
            i();
          }
          o.focus();
          e();
        }
      });
      o.keystrokes.set("Esc", function (e, n) {
        if (o.focusTracker.isFocused) {
          t.focus();
          if (r) {
            r();
          }
          n();
        }
      });
    }
    function ok(t) {
      if (Array.isArray(t)) {
        return {
          items: t
        };
      }
      if (!t) {
        return {
          items: []
        };
      }
      return Object.assign({
        items: []
      }, t);
    }
    var ik = n(1);
    var rk = n.n(ik);
    var sk = n(12);
    var ak = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    ak.insert = "head";
    ak.singleton = true;
    var ck = rk()(sk["a"], ak);
    var lk = sk["a"].locals || {};
    var dk = new WeakMap();
    function uk(t) {
      var e = t.view,
        n = t.element,
        o = t.text,
        _t$isDirectHost = t.isDirectHost,
        i = _t$isDirectHost === void 0 ? true : _t$isDirectHost;
      var r = e.document;
      if (!dk.has(r)) {
        dk.set(r, new Map());
        r.registerPostFixer(function (t) {
          return pk(r, t);
        });
      }
      dk.get(r).set(n, {
        text: o,
        isDirectHost: i
      });
      e.change(function (t) {
        return pk(r, t);
      });
    }
    function hk(t, e) {
      var n = e.document;
      t.change(function (t) {
        if (!dk.has(n)) {
          return;
        }
        var o = dk.get(n);
        var i = o.get(e);
        t.removeAttribute("data-placeholder", i.hostElement);
        mk(t, i.hostElement);
        o.delete(e);
      });
    }
    function fk(t, e) {
      if (!e.hasClass("ck-placeholder")) {
        t.addClass("ck-placeholder", e);
        return true;
      }
      return false;
    }
    function mk(t, e) {
      if (e.hasClass("ck-placeholder")) {
        t.removeClass("ck-placeholder", e);
        return true;
      }
      return false;
    }
    function gk(t) {
      if (!t.isAttached()) {
        return false;
      }
      var e = !Array.from(t.getChildren()).some(function (t) {
        return !t.is("uiElement");
      });
      var n = t.document;
      if (!n.isFocused && e) {
        return true;
      }
      var o = n.selection;
      var i = o.anchor;
      if (e && i && i.parent !== t) {
        return true;
      }
      return false;
    }
    function pk(t, e) {
      var n = dk.get(t);
      var o = false;
      var _iterator264 = _createForOfIteratorHelper(n),
        _step264;
      try {
        for (_iterator264.s(); !(_step264 = _iterator264.n()).done;) {
          var _step264$value = _slicedToArray(_step264.value, 2),
            _t206 = _step264$value[0],
            _i98 = _step264$value[1];
          if (kk(e, _t206, _i98)) {
            o = true;
          }
        }
      } catch (err) {
        _iterator264.e(err);
      } finally {
        _iterator264.f();
      }
      return o;
    }
    function kk(t, e, n) {
      var o = n.text,
        i = n.isDirectHost;
      var r = i ? e : bk(e);
      var s = false;
      if (!r) {
        return false;
      }
      n.hostElement = r;
      if (r.getAttribute("data-placeholder") !== o) {
        t.setAttribute("data-placeholder", o, r);
        s = true;
      }
      if (gk(r)) {
        if (fk(t, r)) {
          s = true;
        }
      } else if (mk(t, r)) {
        s = true;
      }
      return s;
    }
    function bk(t) {
      if (t.childCount === 1) {
        var _e197 = t.getChild(0);
        if (_e197.is("element") && !_e197.is("uiElement")) {
          return _e197;
        }
      }
      return null;
    }
    var wk = /*#__PURE__*/function () {
      function wk() {
        _classCallCheck(this, wk);
        this._replacedElements = [];
      }
      _createClass(wk, [{
        key: "replace",
        value: function replace(t, e) {
          this._replacedElements.push({
            element: t,
            newElement: e
          });
          t.style.display = "none";
          if (e) {
            t.parentNode.insertBefore(e, t.nextSibling);
          }
        }
      }, {
        key: "restore",
        value: function restore() {
          this._replacedElements.forEach(function (_ref16) {
            var t = _ref16.element,
              e = _ref16.newElement;
            t.style.display = "";
            if (e) {
              e.remove();
            }
          });
          this._replacedElements = [];
        }
      }]);
      return wk;
    }();
    var Ck = /*#__PURE__*/function (_ek) {
      _inherits(Ck, _ek);
      function Ck(t, e) {
        var _this83;
        _classCallCheck(this, Ck);
        _this83 = _possibleConstructorReturn(this, _getPrototypeOf(Ck).call(this, t));
        _this83.view = e;
        _this83._toolbarConfig = ok(t.config.get("toolbar"));
        _this83._elementReplacer = new wk();
        return _this83;
      }
      _createClass(Ck, [{
        key: "init",
        value: function init(t) {
          var e = this.editor;
          var n = this.view;
          var o = e.editing.view;
          var i = n.editable;
          var r = o.document.getRoot();
          i.name = r.rootName;
          n.render();
          var s = i.element;
          this.setEditableElement(i.name, s);
          this.focusTracker.add(s);
          n.editable.bind("isFocused").to(this.focusTracker);
          o.attachDomRoot(s);
          if (t) {
            this._elementReplacer.replace(t, this.element);
          }
          this._initPlaceholder();
          this._initToolbar();
          this.fire("ready");
        }
      }, {
        key: "destroy",
        value: function destroy() {
          var t = this.view;
          var e = this.editor.editing.view;
          this._elementReplacer.restore();
          e.detachDomRoot(t.editable.name);
          t.destroy();
          _get(_getPrototypeOf(Ck.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_initToolbar",
        value: function _initToolbar() {
          var t = this.editor;
          var e = this.view;
          var n = t.editing.view;
          e.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused");
          e.stickyPanel.limiterElement = e.element;
          if (this._toolbarConfig.viewportTopOffset) {
            e.stickyPanel.viewportTopOffset = this._toolbarConfig.viewportTopOffset;
          }
          e.toolbar.fillFromConfig(this._toolbarConfig.items, this.componentFactory);
          nk({
            origin: n,
            originFocusTracker: this.focusTracker,
            originKeystrokeHandler: t.keystrokes,
            toolbar: e.toolbar
          });
        }
      }, {
        key: "_initPlaceholder",
        value: function _initPlaceholder() {
          var t = this.editor;
          var e = t.editing.view;
          var n = e.document.getRoot();
          var o = t.sourceElement;
          var i = t.config.get("placeholder") || o && o.tagName.toLowerCase() === "textarea" && o.getAttribute("placeholder");
          if (i) {
            uk({
              view: e,
              element: n,
              text: i,
              isDirectHost: false
            });
          }
        }
      }, {
        key: "element",
        get: function get() {
          return this.view.element;
        }
      }]);
      return Ck;
    }(ek);
    var Ak = /*#__PURE__*/function (_vs) {
      _inherits(Ak, _vs);
      function Ak() {
        var _this84;
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _classCallCheck(this, Ak);
        _this84 = _possibleConstructorReturn(this, _getPrototypeOf(Ak).call(this, t, {
          idProperty: "viewUid"
        }));
        _this84.on("add", function (t, e, n) {
          _this84._renderViewIntoCollectionParent(e, n);
        });
        _this84.on("remove", function (t, e) {
          if (e.element && _this84._parentElement) {
            e.element.remove();
          }
        });
        _this84._parentElement = null;
        return _this84;
      }
      _createClass(Ak, [{
        key: "destroy",
        value: function destroy() {
          this.map(function (t) {
            return t.destroy();
          });
        }
      }, {
        key: "setParent",
        value: function setParent(t) {
          this._parentElement = t;
          var _iterator265 = _createForOfIteratorHelper(this),
            _step265;
          try {
            for (_iterator265.s(); !(_step265 = _iterator265.n()).done;) {
              var _t207 = _step265.value;
              this._renderViewIntoCollectionParent(_t207);
            }
          } catch (err) {
            _iterator265.e(err);
          } finally {
            _iterator265.f();
          }
        }
      }, {
        key: "delegate",
        value: function delegate() {
          var _this85 = this;
          for (var _len17 = arguments.length, t = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
            t[_key17] = arguments[_key17];
          }
          if (!t.length || !_k(t)) {
            throw new ss["a"]("ui-viewcollection-delegate-wrong-events", this);
          }
          return {
            to: function to(e) {
              var _iterator266 = _createForOfIteratorHelper(_this85),
                _step266;
              try {
                for (_iterator266.s(); !(_step266 = _iterator266.n()).done;) {
                  var _n176 = _step266.value;
                  for (var _i101 = 0, _t210 = t; _i101 < _t210.length; _i101++) {
                    var _o112 = _t210[_i101];
                    _n176.delegate(_o112).to(e);
                  }
                }
              } catch (err) {
                _iterator266.e(err);
              } finally {
                _iterator266.f();
              }
              _this85.on("add", function (n, o) {
                for (var _i99 = 0, _t208 = t; _i99 < _t208.length; _i99++) {
                  var _n174 = _t208[_i99];
                  o.delegate(_n174).to(e);
                }
              });
              _this85.on("remove", function (n, o) {
                for (var _i100 = 0, _t209 = t; _i100 < _t209.length; _i100++) {
                  var _n175 = _t209[_i100];
                  o.stopDelegating(_n175, e);
                }
              });
            }
          };
        }
      }, {
        key: "_renderViewIntoCollectionParent",
        value: function _renderViewIntoCollectionParent(t, e) {
          if (!t.isRendered) {
            t.render();
          }
          if (t.element && this._parentElement) {
            this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
          }
        }
      }]);
      return Ak;
    }(vs);
    function _k(t) {
      return t.every(function (t) {
        return typeof t == "string";
      });
    }
    var vk = "http://www.w3.org/1999/xhtml";
    var yk = /*#__PURE__*/function () {
      function yk(t) {
        _classCallCheck(this, yk);
        Object.assign(this, zk(Bk(t)));
        this._isRendered = false;
        this._revertData = null;
      }
      _createClass(yk, [{
        key: "render",
        value: function render() {
          var t = this._renderNode({
            intoFragment: true
          });
          this._isRendered = true;
          return t;
        }
      }, {
        key: "apply",
        value: function apply(t) {
          this._revertData = Yk();
          this._renderNode({
            node: t,
            isApplying: true,
            revertData: this._revertData
          });
          return t;
        }
      }, {
        key: "revert",
        value: function revert(t) {
          if (!this._revertData) {
            throw new ss["a"]("ui-template-revert-not-applied", [this, t]);
          }
          this._revertTemplateFromNode(t, this._revertData);
        }
      }, {
        key: "getViews",
        value: /*#__PURE__*/_regeneratorRuntime().mark(function getViews() {
          var _marked5, t;
          return _regeneratorRuntime().wrap(function getViews$(_context36) {
            while (1) switch (_context36.prev = _context36.next) {
              case 0:
                t = function _t211(e) {
                  var _iterator267, _step267, _n177;
                  return _regeneratorRuntime().wrap(function t$(_context35) {
                    while (1) switch (_context35.prev = _context35.next) {
                      case 0:
                        if (!e.children) {
                          _context35.next = 23;
                          break;
                        }
                        _iterator267 = _createForOfIteratorHelper(e.children);
                        _context35.prev = 2;
                        _iterator267.s();
                      case 4:
                        if ((_step267 = _iterator267.n()).done) {
                          _context35.next = 15;
                          break;
                        }
                        _n177 = _step267.value;
                        if (!Wk(_n177)) {
                          _context35.next = 11;
                          break;
                        }
                        _context35.next = 9;
                        return _n177;
                      case 9:
                        _context35.next = 13;
                        break;
                      case 11:
                        if (!Kk(_n177)) {
                          _context35.next = 13;
                          break;
                        }
                        return _context35.delegateYield(t(_n177), "t0", 13);
                      case 13:
                        _context35.next = 4;
                        break;
                      case 15:
                        _context35.next = 20;
                        break;
                      case 17:
                        _context35.prev = 17;
                        _context35.t1 = _context35["catch"](2);
                        _iterator267.e(_context35.t1);
                      case 20:
                        _context35.prev = 20;
                        _iterator267.f();
                        return _context35.finish(20);
                      case 23:
                      case "end":
                        return _context35.stop();
                    }
                  }, _marked5, null, [[2, 17, 20, 23]]);
                };
                _marked5 = /*#__PURE__*/_regeneratorRuntime().mark(t);
                return _context36.delegateYield(t(this), "t0", 3);
              case 3:
              case "end":
                return _context36.stop();
            }
          }, getViews, this);
        })
      }, {
        key: "_renderNode",
        value: function _renderNode(t) {
          var e;
          if (t.node) {
            e = this.tag && this.text;
          } else {
            e = this.tag ? this.text : !this.text;
          }
          if (e) {
            throw new ss["a"]("ui-template-wrong-syntax", this);
          }
          if (this.text) {
            return this._renderText(t);
          } else {
            return this._renderElement(t);
          }
        }
      }, {
        key: "_renderElement",
        value: function _renderElement(t) {
          var e = t.node;
          if (!e) {
            e = t.node = document.createElementNS(this.ns || vk, this.tag);
          }
          this._renderAttributes(t);
          this._renderElementChildren(t);
          this._setUpListeners(t);
          return e;
        }
      }, {
        key: "_renderText",
        value: function _renderText(t) {
          var e = t.node;
          if (e) {
            t.revertData.text = e.textContent;
          } else {
            e = t.node = document.createTextNode("");
          }
          if (Mk(this.text)) {
            this._bindToObservable({
              schema: this.text,
              updater: Ik(e),
              data: t
            });
          } else {
            e.textContent = this.text.join("");
          }
          return e;
        }
      }, {
        key: "_renderAttributes",
        value: function _renderAttributes(t) {
          var e, n, o, i;
          if (!this.attributes) {
            return;
          }
          var r = t.node;
          var s = t.revertData;
          for (e in this.attributes) {
            o = r.getAttribute(e);
            n = this.attributes[e];
            if (s) {
              s.attributes[e] = o;
            }
            i = ct(n[0]) && n[0].ns ? n[0].ns : null;
            if (Mk(n)) {
              var _a13 = i ? n[0].value : n;
              if (s && Qk(e)) {
                _a13.unshift(o);
              }
              this._bindToObservable({
                schema: _a13,
                updater: Nk(r, e, i),
                data: t
              });
            } else if (e == "style" && typeof n[0] !== "string") {
              this._renderStyleAttribute(n[0], t);
            } else {
              if (s && o && Qk(e)) {
                n.unshift(o);
              }
              n = n.map(function (t) {
                return t ? t.value || t : t;
              }).reduce(function (t, e) {
                return t.concat(e);
              }, []).reduce(Vk, "");
              if (!Gk(n)) {
                r.setAttributeNS(i, e, n);
              }
            }
          }
        }
      }, {
        key: "_renderStyleAttribute",
        value: function _renderStyleAttribute(t, e) {
          var n = e.node;
          for (var _o113 in t) {
            var _i102 = t[_o113];
            if (Mk(_i102)) {
              this._bindToObservable({
                schema: [_i102],
                updater: Pk(n, _o113),
                data: e
              });
            } else {
              n.style[_o113] = _i102;
            }
          }
        }
      }, {
        key: "_renderElementChildren",
        value: function _renderElementChildren(t) {
          var e = t.node;
          var n = t.intoFragment ? document.createDocumentFragment() : e;
          var o = t.isApplying;
          var i = 0;
          var _iterator268 = _createForOfIteratorHelper(this.children),
            _step268;
          try {
            for (_iterator268.s(); !(_step268 = _iterator268.n()).done;) {
              var _r31 = _step268.value;
              if (qk(_r31)) {
                if (!o) {
                  _r31.setParent(e);
                  var _iterator269 = _createForOfIteratorHelper(_r31),
                    _step269;
                  try {
                    for (_iterator269.s(); !(_step269 = _iterator269.n()).done;) {
                      var _t212 = _step269.value;
                      n.appendChild(_t212.element);
                    }
                  } catch (err) {
                    _iterator269.e(err);
                  } finally {
                    _iterator269.f();
                  }
                }
              } else if (Wk(_r31)) {
                if (!o) {
                  if (!_r31.isRendered) {
                    _r31.render();
                  }
                  n.appendChild(_r31.element);
                }
              } else if (Td(_r31)) {
                n.appendChild(_r31);
              } else {
                if (o) {
                  var _e198 = t.revertData;
                  var _o114 = Yk();
                  _e198.children.push(_o114);
                  _r31._renderNode({
                    node: n.childNodes[i++],
                    isApplying: true,
                    revertData: _o114
                  });
                } else {
                  n.appendChild(_r31.render());
                }
              }
            }
          } catch (err) {
            _iterator268.e(err);
          } finally {
            _iterator268.f();
          }
          if (t.intoFragment) {
            e.appendChild(n);
          }
        }
      }, {
        key: "_setUpListeners",
        value: function _setUpListeners(t) {
          var _this86 = this;
          if (!this.eventListeners) {
            return;
          }
          var _loop4 = function _loop4(_e199) {
            var n = _this86.eventListeners[_e199].map(function (n) {
              var _e199$split = _e199.split("@"),
                _e199$split2 = _slicedToArray(_e199$split, 2),
                o = _e199$split2[0],
                i = _e199$split2[1];
              return n.activateDomEventListener(o, i, t);
            });
            if (t.revertData) {
              t.revertData.bindings.push(n);
            }
          };
          for (var _e199 in this.eventListeners) {
            _loop4(_e199);
          }
        }
      }, {
        key: "_bindToObservable",
        value: function _bindToObservable(_ref17) {
          var t = _ref17.schema,
            e = _ref17.updater,
            n = _ref17.data;
          var o = n.revertData;
          Tk(t, e, n);
          var i = t.filter(function (t) {
            return !Gk(t);
          }).filter(function (t) {
            return t.observable;
          }).map(function (o) {
            return o.activateAttributeListener(t, e, n);
          });
          if (o) {
            o.bindings.push(i);
          }
        }
      }, {
        key: "_revertTemplateFromNode",
        value: function _revertTemplateFromNode(t, e) {
          var _iterator270 = _createForOfIteratorHelper(e.bindings),
            _step270;
          try {
            for (_iterator270.s(); !(_step270 = _iterator270.n()).done;) {
              var _t213 = _step270.value;
              var _iterator271 = _createForOfIteratorHelper(_t213),
                _step271;
              try {
                for (_iterator271.s(); !(_step271 = _iterator271.n()).done;) {
                  var _e200 = _step271.value;
                  _e200();
                }
              } catch (err) {
                _iterator271.e(err);
              } finally {
                _iterator271.f();
              }
            }
          } catch (err) {
            _iterator270.e(err);
          } finally {
            _iterator270.f();
          }
          if (e.text) {
            t.textContent = e.text;
            return;
          }
          for (var _n178 in e.attributes) {
            var _o115 = e.attributes[_n178];
            if (_o115 === null) {
              t.removeAttribute(_n178);
            } else {
              t.setAttribute(_n178, _o115);
            }
          }
          for (var _n179 = 0; _n179 < e.children.length; ++_n179) {
            this._revertTemplateFromNode(t.childNodes[_n179], e.children[_n179]);
          }
        }
      }], [{
        key: "bind",
        value: function bind(t, e) {
          return {
            to: function to(n, o) {
              return new Dk({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: o
              });
            },
            if: function _if(n, o, i) {
              return new Ek({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: o,
                callback: i
              });
            }
          };
        }
      }, {
        key: "extend",
        value: function extend(t, e) {
          if (t._isRendered) {
            throw new ss["a"]("template-extend-render", [this, t]);
          }
          Hk(t, zk(Bk(e)));
        }
      }]);
      return yk;
    }();
    _s(yk, ds);
    var xk = /*#__PURE__*/function () {
      function xk(t) {
        _classCallCheck(this, xk);
        Object.assign(this, t);
      }
      _createClass(xk, [{
        key: "getValue",
        value: function getValue(t) {
          var e = this.observable[this.attribute];
          return this.callback ? this.callback(e, t) : e;
        }
      }, {
        key: "activateAttributeListener",
        value: function activateAttributeListener(t, e, n) {
          var _this87 = this;
          var o = function o() {
            return Tk(t, e, n);
          };
          this.emitter.listenTo(this.observable, "change:" + this.attribute, o);
          return function () {
            _this87.emitter.stopListening(_this87.observable, "change:" + _this87.attribute, o);
          };
        }
      }]);
      return xk;
    }();
    var Dk = /*#__PURE__*/function (_xk) {
      _inherits(Dk, _xk);
      function Dk() {
        _classCallCheck(this, Dk);
        return _possibleConstructorReturn(this, _getPrototypeOf(Dk).apply(this, arguments));
      }
      _createClass(Dk, [{
        key: "activateDomEventListener",
        value: function activateDomEventListener(t, e, n) {
          var _this88 = this;
          var o = function o(t, n) {
            if (!e || n.target.matches(e)) {
              if (typeof _this88.eventNameOrFunction == "function") {
                _this88.eventNameOrFunction(n);
              } else {
                _this88.observable.fire(_this88.eventNameOrFunction, n);
              }
            }
          };
          this.emitter.listenTo(n.node, t, o);
          return function () {
            _this88.emitter.stopListening(n.node, t, o);
          };
        }
      }]);
      return Dk;
    }(xk);
    var Ek = /*#__PURE__*/function (_xk2) {
      _inherits(Ek, _xk2);
      function Ek() {
        _classCallCheck(this, Ek);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ek).apply(this, arguments));
      }
      _createClass(Ek, [{
        key: "getValue",
        value: function getValue(t) {
          var e = _get(_getPrototypeOf(Ek.prototype), "getValue", this).call(this, t);
          return Gk(e) ? false : this.valueIfTrue || true;
        }
      }]);
      return Ek;
    }(xk);
    function Mk(t) {
      if (!t) {
        return false;
      }
      if (t.value) {
        t = t.value;
      }
      if (Array.isArray(t)) {
        return t.some(Mk);
      } else if (t instanceof xk) {
        return true;
      }
      return false;
    }
    function Sk(t, e) {
      return t.map(function (t) {
        if (t instanceof xk) {
          return t.getValue(e);
        }
        return t;
      });
    }
    function Tk(t, e, _ref18) {
      var n = _ref18.node;
      var o = Sk(t, n);
      if (t.length == 1 && t[0] instanceof Ek) {
        o = o[0];
      } else {
        o = o.reduce(Vk, "");
      }
      if (Gk(o)) {
        e.remove();
      } else {
        e.set(o);
      }
    }
    function Ik(t) {
      return {
        set: function set(e) {
          t.textContent = e;
        },
        remove: function remove() {
          t.textContent = "";
        }
      };
    }
    function Nk(t, e, n) {
      return {
        set: function set(o) {
          t.setAttributeNS(n, e, o);
        },
        remove: function remove() {
          t.removeAttributeNS(n, e);
        }
      };
    }
    function Pk(t, e) {
      return {
        set: function set(n) {
          t.style[e] = n;
        },
        remove: function remove() {
          t.style[e] = null;
        }
      };
    }
    function Bk(t) {
      var e = Kr(t, function (t) {
        if (t && (t instanceof xk || Kk(t) || Wk(t) || qk(t))) {
          return t;
        }
      });
      return e;
    }
    function zk(t) {
      if (typeof t == "string") {
        t = Rk(t);
      } else if (t.text) {
        jk(t);
      }
      if (t.on) {
        t.eventListeners = Ok(t.on);
        delete t.on;
      }
      if (!t.text) {
        if (t.attributes) {
          Lk(t.attributes);
        }
        var _e201 = [];
        if (t.children) {
          if (qk(t.children)) {
            _e201.push(t.children);
          } else {
            var _iterator272 = _createForOfIteratorHelper(t.children),
              _step272;
            try {
              for (_iterator272.s(); !(_step272 = _iterator272.n()).done;) {
                var _n180 = _step272.value;
                if (Kk(_n180) || Wk(_n180) || Td(_n180)) {
                  _e201.push(_n180);
                } else {
                  _e201.push(new yk(_n180));
                }
              }
            } catch (err) {
              _iterator272.e(err);
            } finally {
              _iterator272.f();
            }
          }
        }
        t.children = _e201;
      }
      return t;
    }
    function Lk(t) {
      for (var _e202 in t) {
        if (t[_e202].value) {
          t[_e202].value = xs(t[_e202].value);
        }
        Fk(t, _e202);
      }
    }
    function Ok(t) {
      for (var _e203 in t) {
        Fk(t, _e203);
      }
      return t;
    }
    function Rk(t) {
      return {
        text: [t]
      };
    }
    function jk(t) {
      t.text = xs(t.text);
    }
    function Fk(t, e) {
      t[e] = xs(t[e]);
    }
    function Vk(t, e) {
      if (Gk(e)) {
        return t;
      } else if (Gk(t)) {
        return e;
      } else {
        return "".concat(t, " ").concat(e);
      }
    }
    function Uk(t, e) {
      for (var _n181 in e) {
        if (t[_n181]) {
          var _t$_n;
          (_t$_n = t[_n181]).push.apply(_t$_n, _toConsumableArray(e[_n181]));
        } else {
          t[_n181] = e[_n181];
        }
      }
    }
    function Hk(t, e) {
      if (e.attributes) {
        if (!t.attributes) {
          t.attributes = {};
        }
        Uk(t.attributes, e.attributes);
      }
      if (e.eventListeners) {
        if (!t.eventListeners) {
          t.eventListeners = {};
        }
        Uk(t.eventListeners, e.eventListeners);
      }
      if (e.text) {
        var _t$text;
        (_t$text = t.text).push.apply(_t$text, _toConsumableArray(e.text));
      }
      if (e.children && e.children.length) {
        if (t.children.length != e.children.length) {
          throw new ss["a"]("ui-template-extend-children-mismatch", t);
        }
        var _n182 = 0;
        var _iterator273 = _createForOfIteratorHelper(e.children),
          _step273;
        try {
          for (_iterator273.s(); !(_step273 = _iterator273.n()).done;) {
            var _o116 = _step273.value;
            Hk(t.children[_n182++], _o116);
          }
        } catch (err) {
          _iterator273.e(err);
        } finally {
          _iterator273.f();
        }
      }
    }
    function Gk(t) {
      return !t && t !== 0;
    }
    function Wk(t) {
      return t instanceof tb;
    }
    function Kk(t) {
      return t instanceof yk;
    }
    function qk(t) {
      return t instanceof Ak;
    }
    function Yk() {
      return {
        children: [],
        bindings: [],
        attributes: {}
      };
    }
    function Qk(t) {
      return t == "class" || t == "style";
    }
    var $k = n(13);
    var Zk = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Zk.insert = "head";
    Zk.singleton = true;
    var Jk = rk()($k["a"], Zk);
    var Xk = $k["a"].locals || {};
    var tb = /*#__PURE__*/function () {
      function tb(t) {
        _classCallCheck(this, tb);
        this.element = null;
        this.isRendered = false;
        this.locale = t;
        this.t = t && t.t;
        this._viewCollections = new vs();
        this._unboundChildren = this.createCollection();
        this._viewCollections.on("add", function (e, n) {
          n.locale = t;
        });
        this.decorate("render");
      }
      _createClass(tb, [{
        key: "createCollection",
        value: function createCollection(t) {
          var e = new Ak(t);
          this._viewCollections.add(e);
          return e;
        }
      }, {
        key: "registerChild",
        value: function registerChild(t) {
          if (!As(t)) {
            t = [t];
          }
          var _iterator274 = _createForOfIteratorHelper(t),
            _step274;
          try {
            for (_iterator274.s(); !(_step274 = _iterator274.n()).done;) {
              var _e204 = _step274.value;
              this._unboundChildren.add(_e204);
            }
          } catch (err) {
            _iterator274.e(err);
          } finally {
            _iterator274.f();
          }
        }
      }, {
        key: "deregisterChild",
        value: function deregisterChild(t) {
          if (!As(t)) {
            t = [t];
          }
          var _iterator275 = _createForOfIteratorHelper(t),
            _step275;
          try {
            for (_iterator275.s(); !(_step275 = _iterator275.n()).done;) {
              var _e205 = _step275.value;
              this._unboundChildren.remove(_e205);
            }
          } catch (err) {
            _iterator275.e(err);
          } finally {
            _iterator275.f();
          }
        }
      }, {
        key: "setTemplate",
        value: function setTemplate(t) {
          this.template = new yk(t);
        }
      }, {
        key: "extendTemplate",
        value: function extendTemplate(t) {
          yk.extend(this.template, t);
        }
      }, {
        key: "render",
        value: function render() {
          if (this.isRendered) {
            throw new ss["a"]("ui-view-render-already-rendered", this);
          }
          if (this.template) {
            this.element = this.template.render();
            this.registerChild(this.template.getViews());
          }
          this.isRendered = true;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
          this._viewCollections.map(function (t) {
            return t.destroy();
          });
          if (this.template && this.template._revertData) {
            this.template.revert(this.element);
          }
        }
      }, {
        key: "bindTemplate",
        get: function get() {
          if (this._bindTemplate) {
            return this._bindTemplate;
          }
          return this._bindTemplate = yk.bind(this, this);
        }
      }]);
      return tb;
    }();
    _s(tb, Zd);
    _s(tb, Zc);
    var eb = "[object String]";
    function nb(t) {
      return typeof t == "string" || !Qe(t) && D(t) && C(t) == eb;
    }
    var ob = nb;
    function ib(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var i = n && n.xmlns;
      var r = i ? t.createElementNS(i, e) : t.createElement(e);
      for (var _t214 in n) {
        r.setAttribute(_t214, n[_t214]);
      }
      if (ob(o) || !As(o)) {
        o = [o];
      }
      var _iterator276 = _createForOfIteratorHelper(o),
        _step276;
      try {
        for (_iterator276.s(); !(_step276 = _iterator276.n()).done;) {
          var _e206 = _step276.value;
          if (ob(_e206)) {
            _e206 = t.createTextNode(_e206);
          }
          r.appendChild(_e206);
        }
      } catch (err) {
        _iterator276.e(err);
      } finally {
        _iterator276.f();
      }
      return r;
    }
    var rb = /*#__PURE__*/function (_Ak) {
      _inherits(rb, _Ak);
      function rb(t) {
        var _this89;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        _classCallCheck(this, rb);
        _this89 = _possibleConstructorReturn(this, _getPrototypeOf(rb).call(this, e));
        _this89.locale = t;
        return _this89;
      }
      _createClass(rb, [{
        key: "attachToDom",
        value: function attachToDom() {
          this._bodyCollectionContainer = new yk({
            tag: "div",
            attributes: {
              class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"],
              dir: this.locale.uiLanguageDirection
            },
            children: this
          }).render();
          var t = document.querySelector(".ck-body-wrapper");
          if (!t) {
            t = ib(document, "div", {
              class: "ck-body-wrapper"
            });
            document.body.appendChild(t);
          }
          t.appendChild(this._bodyCollectionContainer);
        }
      }, {
        key: "detachFromDom",
        value: function detachFromDom() {
          _get(_getPrototypeOf(rb.prototype), "destroy", this).call(this);
          if (this._bodyCollectionContainer) {
            this._bodyCollectionContainer.remove();
          }
          var t = document.querySelector(".ck-body-wrapper");
          if (t && t.childElementCount == 0) {
            t.remove();
          }
        }
      }]);
      return rb;
    }(Ak);
    var sb = n(14);
    var ab = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    ab.insert = "head";
    ab.singleton = true;
    var cb = rk()(sb["a"], ab);
    var lb = sb["a"].locals || {};
    var db = /*#__PURE__*/function (_tb) {
      _inherits(db, _tb);
      function db(t) {
        var _this90;
        _classCallCheck(this, db);
        _this90 = _possibleConstructorReturn(this, _getPrototypeOf(db).call(this, t));
        _this90.body = new rb(t);
        return _this90;
      }
      _createClass(db, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(db.prototype), "render", this).call(this);
          this.body.attachToDom();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.body.detachFromDom();
          return _get(_getPrototypeOf(db.prototype), "destroy", this).call(this);
        }
      }]);
      return db;
    }(tb);
    var ub = n(15);
    var hb = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    hb.insert = "head";
    hb.singleton = true;
    var fb = rk()(ub["a"], hb);
    var mb = ub["a"].locals || {};
    var gb = /*#__PURE__*/function (_tb2) {
      _inherits(gb, _tb2);
      function gb(t) {
        var _this91;
        _classCallCheck(this, gb);
        _this91 = _possibleConstructorReturn(this, _getPrototypeOf(gb).call(this, t));
        _this91.set("text");
        _this91.set("for");
        _this91.id = "ck-editor__label_".concat(ns());
        var e = _this91.bindTemplate;
        _this91.setTemplate({
          tag: "label",
          attributes: {
            class: ["ck", "ck-label"],
            id: _this91.id,
            for: e.to("for")
          },
          children: [{
            text: e.to("text")
          }]
        });
        return _this91;
      }
      return gb;
    }(tb);
    var pb = /*#__PURE__*/function (_db) {
      _inherits(pb, _db);
      function pb(t) {
        var _this92;
        _classCallCheck(this, pb);
        _this92 = _possibleConstructorReturn(this, _getPrototypeOf(pb).call(this, t));
        _this92.top = _this92.createCollection();
        _this92.main = _this92.createCollection();
        _this92._voiceLabelView = _this92._createVoiceLabel();
        _this92.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"],
            role: "application",
            dir: t.uiLanguageDirection,
            lang: t.uiLanguage,
            "aria-labelledby": _this92._voiceLabelView.id
          },
          children: [_this92._voiceLabelView, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__top", "ck-reset_all"],
              role: "presentation"
            },
            children: _this92.top
          }, {
            tag: "div",
            attributes: {
              class: ["ck", "ck-editor__main"],
              role: "presentation"
            },
            children: _this92.main
          }]
        });
        return _this92;
      }
      _createClass(pb, [{
        key: "_createVoiceLabel",
        value: function _createVoiceLabel() {
          var t = this.t;
          var e = new gb();
          e.text = t("Rich Text Editor");
          e.extendTemplate({
            attributes: {
              class: "ck-voice-label"
            }
          });
          return e;
        }
      }]);
      return pb;
    }(db);
    var kb = /*#__PURE__*/function (_tb3) {
      _inherits(kb, _tb3);
      function kb(t, e, n) {
        var _this93;
        _classCallCheck(this, kb);
        _this93 = _possibleConstructorReturn(this, _getPrototypeOf(kb).call(this, t));
        _this93.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"],
            lang: t.contentLanguage,
            dir: t.contentLanguageDirection
          }
        });
        _this93.name = null;
        _this93.set("isFocused", false);
        _this93._editableElement = n;
        _this93._hasExternalElement = !!_this93._editableElement;
        _this93._editingView = e;
        return _this93;
      }
      _createClass(kb, [{
        key: "render",
        value: function render() {
          var _this94 = this;
          _get(_getPrototypeOf(kb.prototype), "render", this).call(this);
          if (this._hasExternalElement) {
            this.template.apply(this.element = this._editableElement);
          } else {
            this._editableElement = this.element;
          }
          this.on("change:isFocused", function () {
            return _this94._updateIsFocusedClasses();
          });
          this._updateIsFocusedClasses();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          if (this._hasExternalElement) {
            this.template.revert(this._editableElement);
          }
          _get(_getPrototypeOf(kb.prototype), "destroy", this).call(this);
        }
      }, {
        key: "_updateIsFocusedClasses",
        value: function _updateIsFocusedClasses() {
          var t = this._editingView;
          if (t.isRenderingInProgress) {
            n(this);
          } else {
            e(this);
          }
          function e(e) {
            t.change(function (n) {
              var o = t.document.getRoot(e.name);
              n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o);
              n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o);
            });
          }
          function n(o) {
            t.once("change:isRenderingInProgress", function (t, i, r) {
              if (!r) {
                e(o);
              } else {
                n(o);
              }
            });
          }
        }
      }]);
      return kb;
    }(tb);
    var bb = /*#__PURE__*/function (_kb) {
      _inherits(bb, _kb);
      function bb(t, e, n) {
        var _this95;
        _classCallCheck(this, bb);
        _this95 = _possibleConstructorReturn(this, _getPrototypeOf(bb).call(this, t, e, n));
        _this95.extendTemplate({
          attributes: {
            role: "textbox",
            class: "ck-editor__editable_inline"
          }
        });
        return _this95;
      }
      _createClass(bb, [{
        key: "render",
        value: function render() {
          var _this96 = this;
          _get(_getPrototypeOf(bb.prototype), "render", this).call(this);
          var t = this._editingView;
          var e = this.t;
          t.change(function (n) {
            var o = t.document.getRoot(_this96.name);
            n.setAttribute("aria-label", e("Rich Text Editor, %0", _this96.name), o);
          });
        }
      }]);
      return bb;
    }(kb);
    function wb(t) {
      return function (e) {
        return e + t;
      };
    }
    var Cb = n(16);
    var Ab = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Ab.insert = "head";
    Ab.singleton = true;
    var _b = rk()(Cb["a"], Ab);
    var vb = Cb["a"].locals || {};
    var yb = wb("px");
    var xb = /*#__PURE__*/function (_tb4) {
      _inherits(xb, _tb4);
      function xb(t) {
        var _this97;
        _classCallCheck(this, xb);
        _this97 = _possibleConstructorReturn(this, _getPrototypeOf(xb).call(this, t));
        var e = _this97.bindTemplate;
        _this97.set("isActive", false);
        _this97.set("isSticky", false);
        _this97.set("limiterElement", null);
        _this97.set("limiterBottomOffset", 50);
        _this97.set("viewportTopOffset", 0);
        _this97.set("_marginLeft", null);
        _this97.set("_isStickyToTheLimiter", false);
        _this97.set("_hasViewportTopOffset", false);
        _this97.content = _this97.createCollection();
        _this97._contentPanelPlaceholder = new yk({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__placeholder"],
            style: {
              display: e.to("isSticky", function (t) {
                return t ? "block" : "none";
              }),
              height: e.to("isSticky", function (t) {
                return t ? yb(_this97._panelRect.height) : null;
              })
            }
          }
        }).render();
        _this97._contentPanel = new yk({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel__content", e.if("isSticky", "ck-sticky-panel__content_sticky"), e.if("_isStickyToTheLimiter", "ck-sticky-panel__content_sticky_bottom-limit")],
            style: {
              width: e.to("isSticky", function (t) {
                return t ? yb(_this97._contentPanelPlaceholder.getBoundingClientRect().width) : null;
              }),
              top: e.to("_hasViewportTopOffset", function (t) {
                return t ? yb(_this97.viewportTopOffset) : null;
              }),
              bottom: e.to("_isStickyToTheLimiter", function (t) {
                return t ? yb(_this97.limiterBottomOffset) : null;
              }),
              marginLeft: e.to("_marginLeft")
            }
          },
          children: _this97.content
        }).render();
        _this97.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-sticky-panel"]
          },
          children: [_this97._contentPanelPlaceholder, _this97._contentPanel]
        });
        return _this97;
      }
      _createClass(xb, [{
        key: "render",
        value: function render() {
          var _this98 = this;
          _get(_getPrototypeOf(xb.prototype), "render", this).call(this);
          this._checkIfShouldBeSticky();
          this.listenTo(jd.window, "scroll", function () {
            _this98._checkIfShouldBeSticky();
          });
          this.listenTo(this, "change:isActive", function () {
            _this98._checkIfShouldBeSticky();
          });
        }
      }, {
        key: "_checkIfShouldBeSticky",
        value: function _checkIfShouldBeSticky() {
          var t = this._panelRect = this._contentPanel.getBoundingClientRect();
          var e;
          if (!this.limiterElement) {
            this.isSticky = false;
          } else {
            e = this._limiterRect = this.limiterElement.getBoundingClientRect();
            this.isSticky = this.isActive && e.top < this.viewportTopOffset && this._panelRect.height + this.limiterBottomOffset < e.height;
          }
          if (this.isSticky) {
            this._isStickyToTheLimiter = e.bottom < t.height + this.limiterBottomOffset + this.viewportTopOffset;
            this._hasViewportTopOffset = !this._isStickyToTheLimiter && !!this.viewportTopOffset;
            this._marginLeft = this._isStickyToTheLimiter ? null : yb(-jd.window.scrollX);
          } else {
            this._isStickyToTheLimiter = false;
            this._hasViewportTopOffset = false;
            this._marginLeft = null;
          }
        }
      }]);
      return xb;
    }(tb);
    var Db = /*#__PURE__*/function () {
      function Db(t) {
        var _this99 = this;
        _classCallCheck(this, Db);
        Object.assign(this, t);
        if (t.actions && t.keystrokeHandler) {
          var _loop5 = function _loop5(_e207) {
            var n = t.actions[_e207];
            if (typeof n == "string") {
              n = [n];
            }
            var _iterator277 = _createForOfIteratorHelper(n),
              _step277;
            try {
              for (_iterator277.s(); !(_step277 = _iterator277.n()).done;) {
                var _o117 = _step277.value;
                t.keystrokeHandler.set(_o117, function (t, n) {
                  _this99[_e207]();
                  n();
                });
              }
            } catch (err) {
              _iterator277.e(err);
            } finally {
              _iterator277.f();
            }
          };
          for (var _e207 in t.actions) {
            _loop5(_e207);
          }
        }
      }
      _createClass(Db, [{
        key: "focusFirst",
        value: function focusFirst() {
          this._focus(this.first);
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focus(this.last);
        }
      }, {
        key: "focusNext",
        value: function focusNext() {
          this._focus(this.next);
        }
      }, {
        key: "focusPrevious",
        value: function focusPrevious() {
          this._focus(this.previous);
        }
      }, {
        key: "_focus",
        value: function _focus(t) {
          if (t) {
            t.focus();
          }
        }
      }, {
        key: "_getFocusableItem",
        value: function _getFocusableItem(t) {
          var e = this.current;
          var n = this.focusables.length;
          if (!n) {
            return null;
          }
          if (e === null) {
            return this[t === 1 ? "first" : "last"];
          }
          var o = (e + n + t) % n;
          do {
            var _e208 = this.focusables.get(o);
            if (Eb(_e208)) {
              return _e208;
            }
            o = (o + n + t) % n;
          } while (o !== e);
          return null;
        }
      }, {
        key: "first",
        get: function get() {
          return this.focusables.find(Eb) || null;
        }
      }, {
        key: "last",
        get: function get() {
          return this.focusables.filter(Eb).slice(-1)[0] || null;
        }
      }, {
        key: "next",
        get: function get() {
          return this._getFocusableItem(1);
        }
      }, {
        key: "previous",
        get: function get() {
          return this._getFocusableItem(-1);
        }
      }, {
        key: "current",
        get: function get() {
          var _this100 = this;
          var t = null;
          if (this.focusTracker.focusedElement === null) {
            return null;
          }
          this.focusables.find(function (e, n) {
            var o = e.element === _this100.focusTracker.focusedElement;
            if (o) {
              t = n;
            }
            return o;
          });
          return t;
        }
      }]);
      return Db;
    }();
    function Eb(t) {
      return !!(t.focus && jd.window.getComputedStyle(t.element).display != "none");
    }
    var Mb = /*#__PURE__*/function (_tb5) {
      _inherits(Mb, _tb5);
      function Mb(t) {
        var _this101;
        _classCallCheck(this, Mb);
        _this101 = _possibleConstructorReturn(this, _getPrototypeOf(Mb).call(this, t));
        _this101.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__separator"]
          }
        });
        return _this101;
      }
      return Mb;
    }(tb);
    var Sb = /*#__PURE__*/function (_tb6) {
      _inherits(Sb, _tb6);
      function Sb(t) {
        var _this102;
        _classCallCheck(this, Sb);
        _this102 = _possibleConstructorReturn(this, _getPrototypeOf(Sb).call(this, t));
        _this102.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-toolbar__line-break"]
          }
        });
        return _this102;
      }
      return Sb;
    }(tb);
    var Tb = 100;
    var Ib = /*#__PURE__*/function () {
      function Ib(t, e) {
        _classCallCheck(this, Ib);
        if (!Ib._observerInstance) {
          Ib._createObserver();
        }
        this._element = t;
        this._callback = e;
        Ib._addElementCallback(t, e);
        Ib._observerInstance.observe(t);
      }
      _createClass(Ib, [{
        key: "destroy",
        value: function destroy() {
          Ib._deleteElementCallback(this._element, this._callback);
        }
      }], [{
        key: "_addElementCallback",
        value: function _addElementCallback(t, e) {
          if (!Ib._elementCallbacks) {
            Ib._elementCallbacks = new Map();
          }
          var n = Ib._elementCallbacks.get(t);
          if (!n) {
            n = new Set();
            Ib._elementCallbacks.set(t, n);
          }
          n.add(e);
        }
      }, {
        key: "_deleteElementCallback",
        value: function _deleteElementCallback(t, e) {
          var n = Ib._getElementCallbacks(t);
          if (n) {
            n.delete(e);
            if (!n.size) {
              Ib._elementCallbacks.delete(t);
              Ib._observerInstance.unobserve(t);
            }
          }
          if (Ib._elementCallbacks && !Ib._elementCallbacks.size) {
            Ib._observerInstance = null;
            Ib._elementCallbacks = null;
          }
        }
      }, {
        key: "_getElementCallbacks",
        value: function _getElementCallbacks(t) {
          if (!Ib._elementCallbacks) {
            return null;
          }
          return Ib._elementCallbacks.get(t);
        }
      }, {
        key: "_createObserver",
        value: function _createObserver() {
          var t;
          if (typeof jd.window.ResizeObserver === "function") {
            t = jd.window.ResizeObserver;
          } else {
            t = Nb;
          }
          Ib._observerInstance = new t(function (t) {
            var _iterator278 = _createForOfIteratorHelper(t),
              _step278;
            try {
              for (_iterator278.s(); !(_step278 = _iterator278.n()).done;) {
                var _e209 = _step278.value;
                var _t215 = Ib._getElementCallbacks(_e209.target);
                if (_t215) {
                  var _iterator279 = _createForOfIteratorHelper(_t215),
                    _step279;
                  try {
                    for (_iterator279.s(); !(_step279 = _iterator279.n()).done;) {
                      var _n183 = _step279.value;
                      _n183(_e209);
                    }
                  } catch (err) {
                    _iterator279.e(err);
                  } finally {
                    _iterator279.f();
                  }
                }
              }
            } catch (err) {
              _iterator278.e(err);
            } finally {
              _iterator278.f();
            }
          });
        }
      }]);
      return Ib;
    }();
    Ib._observerInstance = null;
    Ib._elementCallbacks = null;
    var Nb = /*#__PURE__*/function () {
      function Nb(t) {
        _classCallCheck(this, Nb);
        this._callback = t;
        this._elements = new Set();
        this._previousRects = new Map();
        this._periodicCheckTimeout = null;
      }
      _createClass(Nb, [{
        key: "observe",
        value: function observe(t) {
          this._elements.add(t);
          this._checkElementRectsAndExecuteCallback();
          if (this._elements.size === 1) {
            this._startPeriodicCheck();
          }
        }
      }, {
        key: "unobserve",
        value: function unobserve(t) {
          this._elements.delete(t);
          this._previousRects.delete(t);
          if (!this._elements.size) {
            this._stopPeriodicCheck();
          }
        }
      }, {
        key: "_startPeriodicCheck",
        value: function _startPeriodicCheck() {
          var _this103 = this;
          var t = function t() {
            _this103._checkElementRectsAndExecuteCallback();
            _this103._periodicCheckTimeout = setTimeout(t, Tb);
          };
          this.listenTo(jd.window, "resize", function () {
            _this103._checkElementRectsAndExecuteCallback();
          });
          this._periodicCheckTimeout = setTimeout(t, Tb);
        }
      }, {
        key: "_stopPeriodicCheck",
        value: function _stopPeriodicCheck() {
          clearTimeout(this._periodicCheckTimeout);
          this.stopListening();
          this._previousRects.clear();
        }
      }, {
        key: "_checkElementRectsAndExecuteCallback",
        value: function _checkElementRectsAndExecuteCallback() {
          var t = [];
          var _iterator280 = _createForOfIteratorHelper(this._elements),
            _step280;
          try {
            for (_iterator280.s(); !(_step280 = _iterator280.n()).done;) {
              var _e210 = _step280.value;
              if (this._hasRectChanged(_e210)) {
                t.push({
                  target: _e210,
                  contentRect: this._previousRects.get(_e210)
                });
              }
            }
          } catch (err) {
            _iterator280.e(err);
          } finally {
            _iterator280.f();
          }
          if (t.length) {
            this._callback(t);
          }
        }
      }, {
        key: "_hasRectChanged",
        value: function _hasRectChanged(t) {
          if (!t.ownerDocument.body.contains(t)) {
            return false;
          }
          var e = new Eh(t);
          var n = this._previousRects.get(t);
          var o = !n || !n.isEqual(e);
          this._previousRects.set(t, e);
          return o;
        }
      }]);
      return Nb;
    }();
    _s(Nb, Zd);
    function Pb(t) {
      return t.bindTemplate.to(function (e) {
        if (e.target === t.element) {
          e.preventDefault();
        }
      });
    }
    var Bb = /*#__PURE__*/function (_tb7) {
      _inherits(Bb, _tb7);
      function Bb(t) {
        var _this104;
        _classCallCheck(this, Bb);
        _this104 = _possibleConstructorReturn(this, _getPrototypeOf(Bb).call(this, t));
        var e = _this104.bindTemplate;
        _this104.set("isVisible", false);
        _this104.set("position", "se");
        _this104.children = _this104.createCollection();
        _this104.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-reset", "ck-dropdown__panel", e.to("position", function (t) {
              return "ck-dropdown__panel_".concat(t);
            }), e.if("isVisible", "ck-dropdown__panel-visible")]
          },
          children: _this104.children,
          on: {
            selectstart: e.to(function (t) {
              return t.preventDefault();
            })
          }
        });
        return _this104;
      }
      _createClass(Bb, [{
        key: "focus",
        value: function focus() {
          if (this.children.length) {
            this.children.first.focus();
          }
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          if (this.children.length) {
            var _t216 = this.children.last;
            if (typeof _t216.focusLast === "function") {
              _t216.focusLast();
            } else {
              _t216.focus();
            }
          }
        }
      }]);
      return Bb;
    }(tb);
    var zb = n(17);
    var Lb = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Lb.insert = "head";
    Lb.singleton = true;
    var Ob = rk()(zb["a"], Lb);
    var Rb = zb["a"].locals || {};
    function jb(t) {
      if (!t || !t.parentNode) {
        return null;
      }
      if (t.offsetParent === jd.document.body) {
        return null;
      }
      return t.offsetParent;
    }
    function Fb(_ref19) {
      var t = _ref19.element,
        e = _ref19.target,
        n = _ref19.positions,
        o = _ref19.limiter,
        i = _ref19.fitInViewport;
      if (mt(e)) {
        e = e();
      }
      if (mt(o)) {
        o = o();
      }
      var r = jb(t);
      var s = new Eh(t);
      var a = new Eh(e);
      var c;
      var l;
      if (!o && !i) {
        var _Vb = Vb(n[0], a, s);
        var _Vb2 = _slicedToArray(_Vb, 2);
        l = _Vb2[0];
        c = _Vb2[1];
      } else {
        var _t217 = o && new Eh(o).getVisible();
        var _e211 = i && new Eh(jd.window);
        var _r32 = Ub(n, {
          targetRect: a,
          elementRect: s,
          limiterRect: _t217,
          viewportRect: _e211
        });
        var _ref20 = _r32 || Vb(n[0], a, s);
        var _ref21 = _slicedToArray(_ref20, 2);
        l = _ref21[0];
        c = _ref21[1];
      }
      var d = Kb(c);
      if (r) {
        d = Wb(d, r);
      }
      return {
        left: d.left,
        top: d.top,
        name: l
      };
    }
    function Vb(t, e, n) {
      var o = t(e, n);
      if (!o) {
        return null;
      }
      var i = o.left,
        r = o.top,
        s = o.name;
      return [s, n.clone().moveTo(i, r)];
    }
    function Ub(t, e) {
      var n = e.elementRect,
        o = e.viewportRect;
      var i = n.getArea();
      var r = Hb(t, e);
      if (o) {
        var _t218 = r.filter(function (_ref22) {
          var t = _ref22.viewportIntersectArea;
          return t === i;
        });
        var _e212 = Gb(_t218, i);
        if (_e212) {
          return _e212;
        }
      }
      return Gb(r, i);
    }
    function Hb(t, _ref23) {
      var e = _ref23.targetRect,
        n = _ref23.elementRect,
        o = _ref23.limiterRect,
        i = _ref23.viewportRect;
      var r = [];
      var s = n.getArea();
      var _iterator281 = _createForOfIteratorHelper(t),
        _step281;
      try {
        for (_iterator281.s(); !(_step281 = _iterator281.n()).done;) {
          var _a14 = _step281.value;
          var _t219 = Vb(_a14, e, n);
          if (!_t219) {
            continue;
          }
          var _t220 = _slicedToArray(_t219, 2),
            _c6 = _t220[0],
            _l4 = _t220[1];
          var _d3 = 0;
          var _u3 = 0;
          if (o) {
            if (i) {
              var _t221 = o.getIntersection(i);
              if (_t221) {
                _d3 = _t221.getIntersectionArea(_l4);
              }
            } else {
              _d3 = o.getIntersectionArea(_l4);
            }
          }
          if (i) {
            _u3 = i.getIntersectionArea(_l4);
          }
          var _h2 = {
            positionName: _c6,
            positionRect: _l4,
            limiterIntersectArea: _d3,
            viewportIntersectArea: _u3
          };
          if (_d3 === s) {
            return [_h2];
          }
          r.push(_h2);
        }
      } catch (err) {
        _iterator281.e(err);
      } finally {
        _iterator281.f();
      }
      return r;
    }
    function Gb(t, e) {
      var n = 0;
      var o;
      var i;
      var _iterator282 = _createForOfIteratorHelper(t),
        _step282;
      try {
        for (_iterator282.s(); !(_step282 = _iterator282.n()).done;) {
          var _step282$value = _step282.value,
            _r33 = _step282$value.positionName,
            _s23 = _step282$value.positionRect,
            _a15 = _step282$value.limiterIntersectArea,
            _c7 = _step282$value.viewportIntersectArea;
          if (_a15 === e) {
            return [_r33, _s23];
          }
          var _t222 = Math.pow(_c7, 2) + Math.pow(_a15, 2);
          if (_t222 > n) {
            n = _t222;
            o = _s23;
            i = _r33;
          }
        }
      } catch (err) {
        _iterator282.e(err);
      } finally {
        _iterator282.f();
      }
      return o ? [i, o] : null;
    }
    function Wb(_ref24, n) {
      var t = _ref24.left,
        e = _ref24.top;
      var o = Kb(new Eh(n));
      var i = xh(n);
      t -= o.left;
      e -= o.top;
      t += n.scrollLeft;
      e += n.scrollTop;
      t -= i.left;
      e -= i.top;
      return {
        left: t,
        top: e
      };
    }
    function Kb(_ref25) {
      var t = _ref25.left,
        e = _ref25.top;
      var _jd$window2 = jd.window,
        n = _jd$window2.scrollX,
        o = _jd$window2.scrollY;
      return {
        left: t + n,
        top: e + o
      };
    }
    var qb = /*#__PURE__*/function (_tb8) {
      _inherits(qb, _tb8);
      function qb(t, e, n) {
        var _this105;
        _classCallCheck(this, qb);
        _this105 = _possibleConstructorReturn(this, _getPrototypeOf(qb).call(this, t));
        var o = _this105.bindTemplate;
        _this105.buttonView = e;
        _this105.panelView = n;
        _this105.set("isOpen", false);
        _this105.set("isEnabled", true);
        _this105.set("class");
        _this105.set("id");
        _this105.set("panelPosition", "auto");
        _this105.keystrokes = new Vp();
        _this105.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-dropdown", o.to("class"), o.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            })],
            id: o.to("id"),
            "aria-describedby": o.to("ariaDescribedById")
          },
          children: [e, n]
        });
        e.extendTemplate({
          attributes: {
            class: ["ck-dropdown__button"]
          }
        });
        return _this105;
      }
      _createClass(qb, [{
        key: "render",
        value: function render() {
          var _this106 = this;
          _get(_getPrototypeOf(qb.prototype), "render", this).call(this);
          this.listenTo(this.buttonView, "open", function () {
            _this106.isOpen = !_this106.isOpen;
          });
          this.panelView.bind("isVisible").to(this, "isOpen");
          this.on("change:isOpen", function () {
            if (!_this106.isOpen) {
              return;
            }
            if (_this106.panelPosition === "auto") {
              _this106.panelView.position = qb._getOptimalPosition({
                element: _this106.panelView.element,
                target: _this106.buttonView.element,
                fitInViewport: true,
                positions: _this106._panelPositions
              }).name;
            } else {
              _this106.panelView.position = _this106.panelPosition;
            }
          });
          this.keystrokes.listenTo(this.element);
          var t = function (_t223) {
            function t(_x2, _x3) {
              return _t223.apply(this, arguments);
            }
            t.toString = function () {
              return _t223.toString();
            };
            return t;
          }(function (t, e) {
            if (_this106.isOpen) {
              _this106.buttonView.focus();
              _this106.isOpen = false;
              e();
            }
          });
          this.keystrokes.set("arrowdown", function (t, e) {
            if (_this106.buttonView.isEnabled && !_this106.isOpen) {
              _this106.isOpen = true;
              e();
            }
          });
          this.keystrokes.set("arrowright", function (t, e) {
            if (_this106.isOpen) {
              e();
            }
          });
          this.keystrokes.set("arrowleft", t);
          this.keystrokes.set("esc", t);
        }
      }, {
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }, {
        key: "_panelPositions",
        get: function get() {
          var _qb$defaultPanelPosit = qb.defaultPanelPositions,
            t = _qb$defaultPanelPosit.southEast,
            e = _qb$defaultPanelPosit.southWest,
            n = _qb$defaultPanelPosit.northEast,
            o = _qb$defaultPanelPosit.northWest;
          if (this.locale.uiLanguageDirection === "ltr") {
            return [t, e, n, o];
          } else {
            return [e, t, o, n];
          }
        }
      }]);
      return qb;
    }(tb);
    qb.defaultPanelPositions = {
      southEast: function southEast(t) {
        return {
          top: t.bottom,
          left: t.left,
          name: "se"
        };
      },
      southWest: function southWest(t, e) {
        return {
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: "sw"
        };
      },
      northEast: function northEast(t, e) {
        return {
          top: t.top - e.height,
          left: t.left,
          name: "ne"
        };
      },
      northWest: function northWest(t, e) {
        return {
          top: t.bottom - e.height,
          left: t.left - e.width + t.width,
          name: "nw"
        };
      }
    };
    qb._getOptimalPosition = Fb;
    var Yb = n(18);
    var Qb = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Qb.insert = "head";
    Qb.singleton = true;
    var $b = rk()(Yb["a"], Qb);
    var Zb = Yb["a"].locals || {};
    var Jb = /*#__PURE__*/function (_tb9) {
      _inherits(Jb, _tb9);
      function Jb() {
        var _this107;
        _classCallCheck(this, Jb);
        _this107 = _possibleConstructorReturn(this, _getPrototypeOf(Jb).call(this));
        var t = _this107.bindTemplate;
        _this107.set("content", "");
        _this107.set("viewBox", "0 0 20 20");
        _this107.set("fillColor", "");
        _this107.setTemplate({
          tag: "svg",
          ns: "http://www.w3.org/2000/svg",
          attributes: {
            class: ["ck", "ck-icon"],
            viewBox: t.to("viewBox")
          }
        });
        return _this107;
      }
      _createClass(Jb, [{
        key: "render",
        value: function render() {
          var _this108 = this;
          _get(_getPrototypeOf(Jb.prototype), "render", this).call(this);
          this._updateXMLContent();
          this._colorFillPaths();
          this.on("change:content", function () {
            _this108._updateXMLContent();
            _this108._colorFillPaths();
          });
          this.on("change:fillColor", function () {
            _this108._colorFillPaths();
          });
        }
      }, {
        key: "_updateXMLContent",
        value: function _updateXMLContent() {
          if (this.content) {
            var _t224 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml");
            var _e213 = _t224.querySelector("svg");
            var _n184 = _e213.getAttribute("viewBox");
            if (_n184) {
              this.viewBox = _n184;
            }
            this.element.innerHTML = "";
            while (_e213.childNodes.length > 0) {
              this.element.appendChild(_e213.childNodes[0]);
            }
          }
        }
      }, {
        key: "_colorFillPaths",
        value: function _colorFillPaths() {
          var _this109 = this;
          if (this.fillColor) {
            this.element.querySelectorAll(".ck-icon__fill").forEach(function (t) {
              t.style.fill = _this109.fillColor;
            });
          }
        }
      }]);
      return Jb;
    }(tb);
    var Xb = n(19);
    var tw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    tw.insert = "head";
    tw.singleton = true;
    var ew = rk()(Xb["a"], tw);
    var nw = Xb["a"].locals || {};
    var ow = /*#__PURE__*/function (_tb10) {
      _inherits(ow, _tb10);
      function ow(t) {
        var _this110;
        _classCallCheck(this, ow);
        _this110 = _possibleConstructorReturn(this, _getPrototypeOf(ow).call(this, t));
        _this110.set("text", "");
        _this110.set("position", "s");
        var e = _this110.bindTemplate;
        _this110.setTemplate({
          tag: "span",
          attributes: {
            class: ["ck", "ck-tooltip", e.to("position", function (t) {
              return "ck-tooltip_" + t;
            }), e.if("text", "ck-hidden", function (t) {
              return !t.trim();
            })]
          },
          children: [{
            tag: "span",
            attributes: {
              class: ["ck", "ck-tooltip__text"]
            },
            children: [{
              text: e.to("text")
            }]
          }]
        });
        return _this110;
      }
      return ow;
    }(tb);
    var iw = n(20);
    var rw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    rw.insert = "head";
    rw.singleton = true;
    var sw = rk()(iw["a"], rw);
    var aw = iw["a"].locals || {};
    var cw = /*#__PURE__*/function (_tb11) {
      _inherits(cw, _tb11);
      function cw(t) {
        var _this111;
        _classCallCheck(this, cw);
        _this111 = _possibleConstructorReturn(this, _getPrototypeOf(cw).call(this, t));
        var e = _this111.bindTemplate;
        var n = ns();
        _this111.set("class");
        _this111.set("labelStyle");
        _this111.set("icon");
        _this111.set("isEnabled", true);
        _this111.set("isOn", false);
        _this111.set("isVisible", true);
        _this111.set("isToggleable", false);
        _this111.set("keystroke");
        _this111.set("label");
        _this111.set("tabindex", -1);
        _this111.set("tooltip");
        _this111.set("tooltipPosition", "s");
        _this111.set("type", "button");
        _this111.set("withText", false);
        _this111.set("withKeystroke", false);
        _this111.children = _this111.createCollection();
        _this111.tooltipView = _this111._createTooltipView();
        _this111.labelView = _this111._createLabelView(n);
        _this111.iconView = new Jb();
        _this111.iconView.extendTemplate({
          attributes: {
            class: "ck-button__icon"
          }
        });
        _this111.keystrokeView = _this111._createKeystrokeView();
        _this111.bind("_tooltipString").to(_assertThisInitialized(_assertThisInitialized(_this111)), "tooltip", _assertThisInitialized(_assertThisInitialized(_this111)), "label", _assertThisInitialized(_assertThisInitialized(_this111)), "keystroke", _this111._getTooltipString.bind(_assertThisInitialized(_assertThisInitialized(_this111))));
        _this111.setTemplate({
          tag: "button",
          attributes: {
            class: ["ck", "ck-button", e.to("class"), e.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), e.to("isOn", function (t) {
              return t ? "ck-on" : "ck-off";
            }), e.if("withText", "ck-button_with-text"), e.if("withKeystroke", "ck-button_with-keystroke")],
            type: e.to("type", function (t) {
              return t ? t : "button";
            }),
            tabindex: e.to("tabindex"),
            "aria-labelledby": "ck-editor__aria-label_".concat(n),
            "aria-disabled": e.if("isEnabled", true, function (t) {
              return !t;
            }),
            "aria-pressed": e.to("isOn", function (t) {
              return _this111.isToggleable ? String(t) : false;
            })
          },
          children: _this111.children,
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function (t) {
              if (_this111.isEnabled) {
                _this111.fire("execute");
              } else {
                t.preventDefault();
              }
            })
          }
        });
        return _this111;
      }
      _createClass(cw, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(cw.prototype), "render", this).call(this);
          if (this.icon) {
            this.iconView.bind("content").to(this, "icon");
            this.children.add(this.iconView);
          }
          this.children.add(this.tooltipView);
          this.children.add(this.labelView);
          if (this.withKeystroke) {
            this.children.add(this.keystrokeView);
          }
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_createTooltipView",
        value: function _createTooltipView() {
          var t = new ow();
          t.bind("text").to(this, "_tooltipString");
          t.bind("position").to(this, "tooltipPosition");
          return t;
        }
      }, {
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new tb();
          var n = this.bindTemplate;
          e.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__label"],
              style: n.to("labelStyle"),
              id: "ck-editor__aria-label_".concat(t)
            },
            children: [{
              text: this.bindTemplate.to("label")
            }]
          });
          return e;
        }
      }, {
        key: "_createKeystrokeView",
        value: function _createKeystrokeView() {
          var t = new tb();
          t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__keystroke"]
            },
            children: [{
              text: this.bindTemplate.to("keystroke", function (t) {
                return jl(t);
              })
            }]
          });
          return t;
        }
      }, {
        key: "_getTooltipString",
        value: function _getTooltipString(t, e, n) {
          if (t) {
            if (typeof t == "string") {
              return t;
            } else {
              if (n) {
                n = jl(n);
              }
              if (t instanceof Function) {
                return t(e, n);
              } else {
                return "".concat(e).concat(n ? " (".concat(n, ")") : "");
              }
            }
          }
          return "";
        }
      }]);
      return cw;
    }(tb);
    var lw = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
    var dw = /*#__PURE__*/function (_cw) {
      _inherits(dw, _cw);
      function dw(t) {
        var _this112;
        _classCallCheck(this, dw);
        _this112 = _possibleConstructorReturn(this, _getPrototypeOf(dw).call(this, t));
        _this112.arrowView = _this112._createArrowView();
        _this112.extendTemplate({
          attributes: {
            "aria-haspopup": true
          }
        });
        _this112.delegate("execute").to(_assertThisInitialized(_assertThisInitialized(_this112)), "open");
        return _this112;
      }
      _createClass(dw, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(dw.prototype), "render", this).call(this);
          this.children.add(this.arrowView);
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new Jb();
          t.content = lw;
          t.extendTemplate({
            attributes: {
              class: "ck-dropdown__arrow"
            }
          });
          return t;
        }
      }]);
      return dw;
    }(cw);
    var uw = n(21);
    var hw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    hw.insert = "head";
    hw.singleton = true;
    var fw = rk()(uw["a"], hw);
    var mw = uw["a"].locals || {};
    var gw = /*#__PURE__*/function (_tb12) {
      _inherits(gw, _tb12);
      function gw() {
        var _this113;
        _classCallCheck(this, gw);
        _this113 = _possibleConstructorReturn(this, _getPrototypeOf(gw).call(this));
        _this113.items = _this113.createCollection();
        _this113.focusTracker = new tk();
        _this113.keystrokes = new Vp();
        _this113._focusCycler = new Db({
          focusables: _this113.items,
          focusTracker: _this113.focusTracker,
          keystrokeHandler: _this113.keystrokes,
          actions: {
            focusPrevious: "arrowup",
            focusNext: "arrowdown"
          }
        });
        _this113.setTemplate({
          tag: "ul",
          attributes: {
            class: ["ck", "ck-reset", "ck-list"]
          },
          children: _this113.items
        });
        return _this113;
      }
      _createClass(gw, [{
        key: "render",
        value: function render() {
          var _this114 = this;
          _get(_getPrototypeOf(gw.prototype), "render", this).call(this);
          var _iterator283 = _createForOfIteratorHelper(this.items),
            _step283;
          try {
            for (_iterator283.s(); !(_step283 = _iterator283.n()).done;) {
              var _t225 = _step283.value;
              this.focusTracker.add(_t225.element);
            }
          } catch (err) {
            _iterator283.e(err);
          } finally {
            _iterator283.f();
          }
          this.items.on("add", function (t, e) {
            _this114.focusTracker.add(e.element);
          });
          this.items.on("remove", function (t, e) {
            _this114.focusTracker.remove(e.element);
          });
          this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }]);
      return gw;
    }(tb);
    var pw = /*#__PURE__*/function (_tb13) {
      _inherits(pw, _tb13);
      function pw(t) {
        var _this115;
        _classCallCheck(this, pw);
        _this115 = _possibleConstructorReturn(this, _getPrototypeOf(pw).call(this, t));
        _this115.children = _this115.createCollection();
        _this115.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__item"]
          },
          children: _this115.children
        });
        return _this115;
      }
      _createClass(pw, [{
        key: "focus",
        value: function focus() {
          this.children.first.focus();
        }
      }]);
      return pw;
    }(tb);
    var kw = /*#__PURE__*/function (_tb14) {
      _inherits(kw, _tb14);
      function kw(t) {
        var _this116;
        _classCallCheck(this, kw);
        _this116 = _possibleConstructorReturn(this, _getPrototypeOf(kw).call(this, t));
        _this116.setTemplate({
          tag: "li",
          attributes: {
            class: ["ck", "ck-list__separator"]
          }
        });
        return _this116;
      }
      return kw;
    }(tb);
    var bw = n(22);
    var ww = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    ww.insert = "head";
    ww.singleton = true;
    var Cw = rk()(bw["a"], ww);
    var Aw = bw["a"].locals || {};
    var _w = /*#__PURE__*/function (_cw2) {
      _inherits(_w, _cw2);
      function _w(t) {
        var _this117;
        _classCallCheck(this, _w);
        _this117 = _possibleConstructorReturn(this, _getPrototypeOf(_w).call(this, t));
        _this117.isToggleable = true;
        _this117.toggleSwitchView = _this117._createToggleView();
        _this117.extendTemplate({
          attributes: {
            class: "ck-switchbutton"
          }
        });
        return _this117;
      }
      _createClass(_w, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(_w.prototype), "render", this).call(this);
          this.children.add(this.toggleSwitchView);
        }
      }, {
        key: "_createToggleView",
        value: function _createToggleView() {
          var t = new tb();
          t.setTemplate({
            tag: "span",
            attributes: {
              class: ["ck", "ck-button__toggle"]
            },
            children: [{
              tag: "span",
              attributes: {
                class: ["ck", "ck-button__toggle__inner"]
              }
            }]
          });
          return t;
        }
      }]);
      return _w;
    }(cw);
    function vw(_ref26) {
      var t = _ref26.emitter,
        e = _ref26.activator,
        n = _ref26.callback,
        o = _ref26.contextElements;
      t.listenTo(document, "mousedown", function (t, i) {
        if (!e()) {
          return;
        }
        var r = typeof i.composedPath == "function" ? i.composedPath() : [];
        var _iterator284 = _createForOfIteratorHelper(o),
          _step284;
        try {
          for (_iterator284.s(); !(_step284 = _iterator284.n()).done;) {
            var _t226 = _step284.value;
            if (_t226.contains(i.target) || r.includes(_t226)) {
              return;
            }
          }
        } catch (err) {
          _iterator284.e(err);
        } finally {
          _iterator284.f();
        }
        n();
      });
    }
    var yw = n(23);
    var xw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    xw.insert = "head";
    xw.singleton = true;
    var Dw = rk()(yw["a"], xw);
    var Ew = yw["a"].locals || {};
    var Mw = n(24);
    var Sw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Sw.insert = "head";
    Sw.singleton = true;
    var Tw = rk()(Mw["a"], Sw);
    var Iw = Mw["a"].locals || {};
    function Nw(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : dw;
      var n = new e(t);
      var o = new Bb(t);
      var i = new qb(t, n, o);
      n.bind("isEnabled").to(i);
      if (n instanceof dw) {
        n.bind("isOn").to(i, "isOpen");
      } else {
        n.arrowView.bind("isOn").to(i, "isOpen");
      }
      zw(i);
      return i;
    }
    function Pw(t, e) {
      var n = t.locale;
      var o = n.t;
      var i = t.toolbarView = new Gw(n);
      i.set("ariaLabel", o("Dropdown toolbar"));
      t.extendTemplate({
        attributes: {
          class: ["ck-toolbar-dropdown"]
        }
      });
      e.map(function (t) {
        return i.items.add(t);
      });
      t.panelView.children.add(i);
      i.items.delegate("execute").to(t);
    }
    function Bw(t, e) {
      var n = t.locale;
      var o = t.listView = new gw(n);
      o.items.bindTo(e).using(function (_ref27) {
        var t = _ref27.type,
          e = _ref27.model;
        if (t === "separator") {
          return new kw(n);
        } else if (t === "button" || t === "switchbutton") {
          var _i104;
          var _o118 = new pw(n);
          var _i103;
          if (t === "button") {
            _i103 = new cw(n);
          } else {
            _i103 = new _w(n);
          }
          (_i104 = _i103).bind.apply(_i104, _toConsumableArray(Object.keys(e))).to(e);
          _i103.delegate("execute").to(_o118);
          _o118.children.add(_i103);
          return _o118;
        }
      });
      t.panelView.children.add(o);
      o.items.delegate("execute").to(t);
    }
    function zw(t) {
      Lw(t);
      Ow(t);
      Rw(t);
    }
    function Lw(t) {
      t.on("render", function () {
        vw({
          emitter: t,
          activator: function activator() {
            return t.isOpen;
          },
          callback: function callback() {
            t.isOpen = false;
          },
          contextElements: [t.element]
        });
      });
    }
    function Ow(t) {
      t.on("execute", function (e) {
        if (e.source instanceof _w) {
          return;
        }
        t.isOpen = false;
      });
    }
    function Rw(t) {
      t.keystrokes.set("arrowdown", function (e, n) {
        if (t.isOpen) {
          t.panelView.focus();
          n();
        }
      });
      t.keystrokes.set("arrowup", function (e, n) {
        if (t.isOpen) {
          t.panelView.focusLast();
          n();
        }
      });
    }
    var jw = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
    var Fw = n(25);
    var Vw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Vw.insert = "head";
    Vw.singleton = true;
    var Uw = rk()(Fw["a"], Vw);
    var Hw = Fw["a"].locals || {};
    var Gw = /*#__PURE__*/function (_tb15) {
      _inherits(Gw, _tb15);
      function Gw(t, e) {
        var _this118;
        _classCallCheck(this, Gw);
        _this118 = _possibleConstructorReturn(this, _getPrototypeOf(Gw).call(this, t));
        var n = _this118.bindTemplate;
        var o = _this118.t;
        _this118.options = e || {};
        _this118.set("ariaLabel", o("Editor toolbar"));
        _this118.set("maxWidth", "auto");
        _this118.items = _this118.createCollection();
        _this118.focusTracker = new tk();
        _this118.keystrokes = new Vp();
        _this118.set("class");
        _this118.set("isCompact", false);
        _this118.itemsView = new Ww(t);
        _this118.children = _this118.createCollection();
        _this118.children.add(_this118.itemsView);
        _this118.focusables = _this118.createCollection();
        _this118._focusCycler = new Db({
          focusables: _this118.focusables,
          focusTracker: _this118.focusTracker,
          keystrokeHandler: _this118.keystrokes,
          actions: {
            focusPrevious: ["arrowleft", "arrowup"],
            focusNext: ["arrowright", "arrowdown"]
          }
        });
        var i = ["ck", "ck-toolbar", n.to("class"), n.if("isCompact", "ck-toolbar_compact")];
        if (_this118.options.shouldGroupWhenFull && _this118.options.isFloating) {
          i.push("ck-toolbar_floating");
        }
        _this118.setTemplate({
          tag: "div",
          attributes: {
            class: i,
            role: "toolbar",
            "aria-label": n.to("ariaLabel"),
            style: {
              maxWidth: n.to("maxWidth")
            }
          },
          children: _this118.children,
          on: {
            mousedown: Pb(_assertThisInitialized(_assertThisInitialized(_this118)))
          }
        });
        _this118._behavior = _this118.options.shouldGroupWhenFull ? new qw(_assertThisInitialized(_assertThisInitialized(_this118))) : new Kw(_assertThisInitialized(_assertThisInitialized(_this118)));
        return _this118;
      }
      _createClass(Gw, [{
        key: "render",
        value: function render() {
          var _this119 = this;
          _get(_getPrototypeOf(Gw.prototype), "render", this).call(this);
          var _iterator285 = _createForOfIteratorHelper(this.items),
            _step285;
          try {
            for (_iterator285.s(); !(_step285 = _iterator285.n()).done;) {
              var _t227 = _step285.value;
              this.focusTracker.add(_t227.element);
            }
          } catch (err) {
            _iterator285.e(err);
          } finally {
            _iterator285.f();
          }
          this.items.on("add", function (t, e) {
            _this119.focusTracker.add(e.element);
          });
          this.items.on("remove", function (t, e) {
            _this119.focusTracker.remove(e.element);
          });
          this.keystrokes.listenTo(this.element);
          this._behavior.render(this);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._behavior.destroy();
          return _get(_getPrototypeOf(Gw.prototype), "destroy", this).call(this);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "focusLast",
        value: function focusLast() {
          this._focusCycler.focusLast();
        }
      }, {
        key: "fillFromConfig",
        value: function fillFromConfig(t, e) {
          var _this120 = this;
          this.items.addMany(t.map(function (n) {
            if (n == "|") {
              return new Mb();
            } else if (n == "-") {
              if (_this120.options.shouldGroupWhenFull) {
                Object(ss["c"])("toolbarview-line-break-ignored-when-grouping-items", t);
              }
              return new Sb();
            } else if (e.has(n)) {
              return e.create(n);
            } else {
              Object(ss["c"])("toolbarview-item-unavailable", {
                name: n
              });
            }
          }).filter(function (t) {
            return t !== undefined;
          }));
        }
      }]);
      return Gw;
    }(tb);
    var Ww = /*#__PURE__*/function (_tb16) {
      _inherits(Ww, _tb16);
      function Ww(t) {
        var _this121;
        _classCallCheck(this, Ww);
        _this121 = _possibleConstructorReturn(this, _getPrototypeOf(Ww).call(this, t));
        _this121.children = _this121.createCollection();
        _this121.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-toolbar__items"]
          },
          children: _this121.children
        });
        return _this121;
      }
      return Ww;
    }(tb);
    var Kw = /*#__PURE__*/function () {
      function Kw(t) {
        _classCallCheck(this, Kw);
        var e = t.bindTemplate;
        t.set("isVertical", false);
        t.itemsView.children.bindTo(t.items).using(function (t) {
          return t;
        });
        t.focusables.bindTo(t.items).using(function (t) {
          return t;
        });
        t.extendTemplate({
          attributes: {
            class: [e.if("isVertical", "ck-toolbar_vertical")]
          }
        });
      }
      _createClass(Kw, [{
        key: "render",
        value: function render() {}
      }, {
        key: "destroy",
        value: function destroy() {}
      }]);
      return Kw;
    }();
    var qw = /*#__PURE__*/function () {
      function qw(t) {
        var _this122 = this;
        _classCallCheck(this, qw);
        this.view = t;
        this.viewChildren = t.children;
        this.viewFocusables = t.focusables;
        this.viewItemsView = t.itemsView;
        this.viewFocusTracker = t.focusTracker;
        this.viewLocale = t.locale;
        this.ungroupedItems = t.createCollection();
        this.groupedItems = t.createCollection();
        this.groupedItemsDropdown = this._createGroupedItemsDropdown();
        this.resizeObserver = null;
        this.cachedPadding = null;
        this.shouldUpdateGroupingOnNextResize = false;
        t.itemsView.children.bindTo(this.ungroupedItems).using(function (t) {
          return t;
        });
        this.ungroupedItems.on("add", this._updateFocusCycleableItems.bind(this));
        this.ungroupedItems.on("remove", this._updateFocusCycleableItems.bind(this));
        t.children.on("add", this._updateFocusCycleableItems.bind(this));
        t.children.on("remove", this._updateFocusCycleableItems.bind(this));
        t.items.on("change", function (t, e) {
          var n = e.index;
          var _iterator286 = _createForOfIteratorHelper(e.removed),
            _step286;
          try {
            for (_iterator286.s(); !(_step286 = _iterator286.n()).done;) {
              var _t229 = _step286.value;
              if (n >= _this122.ungroupedItems.length) {
                _this122.groupedItems.remove(_t229);
              } else {
                _this122.ungroupedItems.remove(_t229);
              }
            }
          } catch (err) {
            _iterator286.e(err);
          } finally {
            _iterator286.f();
          }
          for (var _t228 = n; _t228 < n + e.added.length; _t228++) {
            var _o119 = e.added[_t228 - n];
            if (_t228 > _this122.ungroupedItems.length) {
              _this122.groupedItems.add(_o119, _t228 - _this122.ungroupedItems.length);
            } else {
              _this122.ungroupedItems.add(_o119, _t228);
            }
          }
          _this122._updateGrouping();
        });
        t.extendTemplate({
          attributes: {
            class: ["ck-toolbar_grouping"]
          }
        });
      }
      _createClass(qw, [{
        key: "render",
        value: function render(t) {
          this.viewElement = t.element;
          this._enableGroupingOnResize();
          this._enableGroupingOnMaxWidthChange(t);
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.groupedItemsDropdown.destroy();
          this.resizeObserver.destroy();
        }
      }, {
        key: "_updateGrouping",
        value: function _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) {
            return;
          }
          if (!this.viewElement.offsetParent) {
            this.shouldUpdateGroupingOnNextResize = true;
            return;
          }
          var t = this.groupedItems.length;
          var e;
          while (this._areItemsOverflowing) {
            this._groupLastItem();
            e = true;
          }
          if (!e && this.groupedItems.length) {
            while (this.groupedItems.length && !this._areItemsOverflowing) {
              this._ungroupFirstItem();
            }
            if (this._areItemsOverflowing) {
              this._groupLastItem();
            }
          }
          if (this.groupedItems.length !== t) {
            this.view.fire("groupedItemsUpdate");
          }
        }
      }, {
        key: "_enableGroupingOnResize",
        value: function _enableGroupingOnResize() {
          var _this123 = this;
          var t;
          this.resizeObserver = new Ib(this.viewElement, function (e) {
            if (!t || t !== e.contentRect.width || _this123.shouldUpdateGroupingOnNextResize) {
              _this123.shouldUpdateGroupingOnNextResize = false;
              _this123._updateGrouping();
              t = e.contentRect.width;
            }
          });
          this._updateGrouping();
        }
      }, {
        key: "_enableGroupingOnMaxWidthChange",
        value: function _enableGroupingOnMaxWidthChange(t) {
          var _this124 = this;
          t.on("change:maxWidth", function () {
            _this124._updateGrouping();
          });
        }
      }, {
        key: "_groupLastItem",
        value: function _groupLastItem() {
          if (!this.groupedItems.length) {
            this.viewChildren.add(new Mb());
            this.viewChildren.add(this.groupedItemsDropdown);
            this.viewFocusTracker.add(this.groupedItemsDropdown.element);
          }
          this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
        }
      }, {
        key: "_ungroupFirstItem",
        value: function _ungroupFirstItem() {
          this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first));
          if (!this.groupedItems.length) {
            this.viewChildren.remove(this.groupedItemsDropdown);
            this.viewChildren.remove(this.viewChildren.last);
            this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
          }
        }
      }, {
        key: "_createGroupedItemsDropdown",
        value: function _createGroupedItemsDropdown() {
          var t = this.viewLocale;
          var e = t.t;
          var n = Nw(t);
          n.class = "ck-toolbar__grouped-dropdown";
          n.panelPosition = t.uiLanguageDirection === "ltr" ? "sw" : "se";
          Pw(n, []);
          n.buttonView.set({
            label: e("Show more items"),
            tooltip: true,
            icon: jw
          });
          n.toolbarView.items.bindTo(this.groupedItems).using(function (t) {
            return t;
          });
          return n;
        }
      }, {
        key: "_updateFocusCycleableItems",
        value: function _updateFocusCycleableItems() {
          var _this125 = this;
          this.viewFocusables.clear();
          this.ungroupedItems.map(function (t) {
            _this125.viewFocusables.add(t);
          });
          if (this.groupedItems.length) {
            this.viewFocusables.add(this.groupedItemsDropdown);
          }
        }
      }, {
        key: "_areItemsOverflowing",
        get: function get() {
          if (!this.ungroupedItems.length) {
            return false;
          }
          var t = this.viewElement;
          var e = this.viewLocale.uiLanguageDirection;
          var n = new Eh(t.lastChild);
          var o = new Eh(t);
          if (!this.cachedPadding) {
            var _n185 = jd.window.getComputedStyle(t);
            var _o120 = e === "ltr" ? "paddingRight" : "paddingLeft";
            this.cachedPadding = Number.parseInt(_n185[_o120]);
          }
          if (e === "ltr") {
            return n.right > o.right - this.cachedPadding;
          } else {
            return n.left < o.left + this.cachedPadding;
          }
        }
      }]);
      return qw;
    }();
    var Yw = n(26);
    var Qw = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Qw.insert = "head";
    Qw.singleton = true;
    var $w = rk()(Yw["a"], Qw);
    var Zw = Yw["a"].locals || {};
    var Jw = /*#__PURE__*/function (_pb) {
      _inherits(Jw, _pb);
      function Jw(t, e) {
        var _this126;
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, Jw);
        _this126 = _possibleConstructorReturn(this, _getPrototypeOf(Jw).call(this, t));
        _this126.stickyPanel = new xb(t);
        _this126.toolbar = new Gw(t, {
          shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
        });
        _this126.editable = new bb(t, e);
        return _this126;
      }
      _createClass(Jw, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(Jw.prototype), "render", this).call(this);
          this.stickyPanel.content.add(this.toolbar);
          this.top.add(this.stickyPanel);
          this.main.add(this.editable);
        }
      }]);
      return Jw;
    }(pb);
    function Xw(t) {
      if (t instanceof HTMLTextAreaElement) {
        return t.value;
      }
      return t.innerHTML;
    }
    var tC = /*#__PURE__*/function (_Hp) {
      _inherits(tC, _Hp);
      function tC(t, e) {
        var _this127;
        _classCallCheck(this, tC);
        _this127 = _possibleConstructorReturn(this, _getPrototypeOf(tC).call(this, e));
        if (Yr(t)) {
          _this127.sourceElement = t;
        }
        _this127.data.processor = new Zp(_this127.data.viewDocument);
        _this127.model.document.createRoot();
        var n = !_this127.config.get("toolbar.shouldNotGroupWhenFull");
        var o = new Jw(_this127.locale, _this127.editing.view, {
          shouldToolbarGroupWhenFull: n
        });
        _this127.ui = new Ck(_assertThisInitialized(_assertThisInitialized(_this127)), o);
        Qp(_assertThisInitialized(_assertThisInitialized(_this127)));
        return _this127;
      }
      _createClass(tC, [{
        key: "destroy",
        value: function destroy() {
          if (this.sourceElement) {
            this.updateSourceElement();
          }
          this.ui.destroy();
          return _get(_getPrototypeOf(tC.prototype), "destroy", this).call(this);
        }
      }], [{
        key: "create",
        value: function create(t) {
          var _this128 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          return new Promise(function (n) {
            var o = new _this128(t, e);
            n(o.initPlugins().then(function () {
              return o.ui.init(Yr(t) ? t : null);
            }).then(function () {
              if (!Yr(t) && e.initialData) {
                throw new ss["a"]("editor-create-initial-data", null);
              }
              var n = e.initialData || eC(t);
              return o.data.init(n);
            }).then(function () {
              return o.fire("ready");
            }).then(function () {
              return o;
            }));
          });
        }
      }]);
      return tC;
    }(Hp);
    _s(tC, Wp);
    _s(tC, Yp);
    function eC(t) {
      return Yr(t) ? Xw(t) : t;
    }
    function nC(t) {
      var e = t.next();
      if (e.done) {
        return null;
      }
      return e.value;
    }
    function oC(t, e, n, o) {
      var i;
      var r = null;
      if (typeof o == "function") {
        i = o;
      } else {
        r = t.commands.get(o);
        i = function i() {
          t.execute(o);
        };
      }
      t.model.document.on("change:data", function (o, s) {
        if (r && !r.isEnabled || !e.isEnabled) {
          return;
        }
        var a = nC(t.model.document.selection.getRanges());
        if (!a.isCollapsed) {
          return;
        }
        if (s.type == "transparent") {
          return;
        }
        var c = Array.from(t.model.document.differ.getChanges());
        var l = c[0];
        if (c.length != 1 || l.type !== "insert" || l.name != "$text" || l.length != 1) {
          return;
        }
        var d = l.position.parent;
        if (d.is("element", "codeBlock")) {
          return;
        }
        if (r && r.value === true) {
          return;
        }
        var u = d.getChild(0);
        var h = t.model.createRangeOn(u);
        if (!h.containsRange(a) && !a.end.isEqual(h.end)) {
          return;
        }
        var f = n.exec(u.data.substr(0, a.end.offset));
        if (!f) {
          return;
        }
        t.model.enqueueChange(function (t) {
          var e = t.createPositionAt(d, 0);
          var n = t.createPositionAt(d, f[0].length);
          var o = new kf(e, n);
          var r = i({
            match: f
          });
          if (r !== false) {
            t.remove(o);
          }
          o.detach();
        });
      });
    }
    function iC(t, e, n, o) {
      var i;
      var r;
      if (n instanceof RegExp) {
        i = n;
      } else {
        r = n;
      }
      r = r || function (t) {
        var e;
        var n = [];
        var o = [];
        while ((e = i.exec(t)) !== null) {
          if (e && e.length < 4) {
            break;
          }
          var _e214 = e,
            _t230 = _e214.index,
            _i105 = _e214[1],
            _r34 = _e214[2],
            _s24 = _e214[3];
          var _a16 = _i105 + _r34 + _s24;
          _t230 += e[0].length - _a16.length;
          var _c8 = [_t230, _t230 + _i105.length];
          var _l5 = [_t230 + _i105.length + _r34.length, _t230 + _i105.length + _r34.length + _s24.length];
          n.push(_c8);
          n.push(_l5);
          o.push([_t230 + _i105.length, _t230 + _i105.length + _r34.length]);
        }
        return {
          remove: n,
          format: o
        };
      };
      t.model.document.on("change:data", function (n, i) {
        if (i.type == "transparent" || !e.isEnabled) {
          return;
        }
        var s = t.model;
        var a = s.document.selection;
        if (!a.isCollapsed) {
          return;
        }
        var c = Array.from(s.document.differ.getChanges());
        var l = c[0];
        if (c.length != 1 || l.type !== "insert" || l.name != "$text" || l.length != 1) {
          return;
        }
        var d = a.focus;
        var u = d.parent;
        var _sC = sC(s.createRange(s.createPositionAt(u, 0), d), s),
          h = _sC.text,
          f = _sC.range;
        var m = r(h);
        var g = rC(f.start, m.format, s);
        var p = rC(f.start, m.remove, s);
        if (!(g.length && p.length)) {
          return;
        }
        s.enqueueChange(function (t) {
          var e = o(t, g);
          if (e === false) {
            return;
          }
          var _iterator287 = _createForOfIteratorHelper(p.reverse()),
            _step287;
          try {
            for (_iterator287.s(); !(_step287 = _iterator287.n()).done;) {
              var _e215 = _step287.value;
              t.remove(_e215);
            }
          } catch (err) {
            _iterator287.e(err);
          } finally {
            _iterator287.f();
          }
        });
      });
    }
    function rC(t, e, n) {
      return e.filter(function (t) {
        return t[0] !== undefined && t[1] !== undefined;
      }).map(function (e) {
        return n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]));
      });
    }
    function sC(t, e) {
      var n = t.start;
      var o = Array.from(t.getItems()).reduce(function (t, o) {
        if (!(o.is("$text") || o.is("$textProxy")) || o.getAttribute("code")) {
          n = e.createPositionAfter(o);
          return "";
        }
        return t + o.data;
      }, "");
      return {
        text: o,
        range: e.createRange(n, t.end)
      };
    }
    var aC = /*#__PURE__*/function () {
      function aC(t) {
        _classCallCheck(this, aC);
        this.editor = t;
        this.set("isEnabled", true);
        this._disableStack = new Set();
      }
      _createClass(aC, [{
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t);
          if (this._disableStack.size == 1) {
            this.on("set:isEnabled", cC, {
              priority: "highest"
            });
            this.isEnabled = false;
          }
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t);
          if (this._disableStack.size == 0) {
            this.off("set:isEnabled", cC);
            this.isEnabled = true;
          }
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return false;
        }
      }]);
      return aC;
    }();
    _s(aC, Zc);
    function cC(t) {
      t.return = false;
      t.stop();
    }
    var lC = /*#__PURE__*/function (_aC) {
      _inherits(lC, _aC);
      function lC() {
        _classCallCheck(this, lC);
        return _possibleConstructorReturn(this, _getPrototypeOf(lC).apply(this, arguments));
      }
      _createClass(lC, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats();
          this._addBasicStylesAutoformats();
          this._addHeadingAutoformats();
          this._addBlockQuoteAutoformats();
          this._addCodeBlockAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var t = this.editor.commands;
          if (t.get("bulletedList")) {
            oC(this.editor, this, /^[*-]\s$/, "bulletedList");
          }
          if (t.get("numberedList")) {
            oC(this.editor, this, /^1[.|)]\s$/, "numberedList");
          }
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;
          if (t.get("bold")) {
            var _t231 = dC(this.editor, "bold");
            iC(this.editor, this, /(\*\*)([^*]+)(\*\*)$/g, _t231);
            iC(this.editor, this, /(__)([^_]+)(__)$/g, _t231);
          }
          if (t.get("italic")) {
            var _t232 = dC(this.editor, "italic");
            iC(this.editor, this, /(?:^|[^*])(\*)([^*_]+)(\*)$/g, _t232);
            iC(this.editor, this, /(?:^|[^_])(_)([^_]+)(_)$/g, _t232);
          }
          if (t.get("code")) {
            var _t233 = dC(this.editor, "code");
            iC(this.editor, this, /(`)([^`]+)(`)$/g, _t233);
          }
          if (t.get("strikethrough")) {
            var _t234 = dC(this.editor, "strikethrough");
            iC(this.editor, this, /(~~)([^~]+)(~~)$/g, _t234);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this129 = this;
          var t = this.editor.commands.get("heading");
          if (t) {
            t.modelElements.filter(function (t) {
              return t.match(/^heading[1-6]$/);
            }).forEach(function (e) {
              var n = e[7];
              var o = new RegExp("^(#{".concat(n, "})\\s$"));
              oC(_this129.editor, _this129, o, function () {
                if (!t.isEnabled || t.value === e) {
                  return false;
                }
                _this129.editor.execute("heading", {
                  value: e
                });
              });
            });
          }
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          if (this.editor.commands.get("blockQuote")) {
            oC(this.editor, this, /^>\s$/, "blockQuote");
          }
        }
      }, {
        key: "_addCodeBlockAutoformats",
        value: function _addCodeBlockAutoformats() {
          if (this.editor.commands.get("codeBlock")) {
            oC(this.editor, this, /^```$/, "codeBlock");
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);
      return lC;
    }(aC);
    function dC(t, e) {
      return function (n, o) {
        var i = t.commands.get(e);
        if (!i.isEnabled) {
          return false;
        }
        var r = t.model.schema.getValidRanges(o, e);
        var _iterator288 = _createForOfIteratorHelper(r),
          _step288;
        try {
          for (_iterator288.s(); !(_step288 = _iterator288.n()).done;) {
            var _t235 = _step288.value;
            n.setAttribute(e, true, _t235);
          }
        } catch (err) {
          _iterator288.e(err);
        } finally {
          _iterator288.f();
        }
        n.removeSelectionAttribute(e);
      };
    }
    var uC = /*#__PURE__*/function () {
      function uC(t) {
        var _this130 = this;
        _classCallCheck(this, uC);
        this.editor = t;
        this.set("value", undefined);
        this.set("isEnabled", false);
        this._disableStack = new Set();
        this.decorate("execute");
        this.listenTo(this.editor.model.document, "change", function () {
          _this130.refresh();
        });
        this.on("execute", function (t) {
          if (!_this130.isEnabled) {
            t.stop();
          }
        }, {
          priority: "high"
        });
        this.listenTo(t, "change:isReadOnly", function (t, e, n) {
          if (n) {
            _this130.forceDisabled("readOnlyMode");
          } else {
            _this130.clearForceDisabled("readOnlyMode");
          }
        });
      }
      _createClass(uC, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = true;
        }
      }, {
        key: "forceDisabled",
        value: function forceDisabled(t) {
          this._disableStack.add(t);
          if (this._disableStack.size == 1) {
            this.on("set:isEnabled", hC, {
              priority: "highest"
            });
            this.isEnabled = false;
          }
        }
      }, {
        key: "clearForceDisabled",
        value: function clearForceDisabled(t) {
          this._disableStack.delete(t);
          if (this._disableStack.size == 0) {
            this.off("set:isEnabled", hC);
            this.refresh();
          }
        }
      }, {
        key: "execute",
        value: function execute() {}
      }, {
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }]);
      return uC;
    }();
    _s(uC, Zc);
    function hC(t) {
      t.return = false;
      t.stop();
    }
    var fC = /*#__PURE__*/function (_uC) {
      _inherits(fC, _uC);
      function fC() {
        _classCallCheck(this, fC);
        return _possibleConstructorReturn(this, _getPrototypeOf(fC).apply(this, arguments));
      }
      _createClass(fC, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue();
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this131 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.schema;
          var o = e.document.selection;
          var i = Array.from(o.getSelectedBlocks());
          var r = t.forceValue === undefined ? !this.value : t.forceValue;
          e.change(function (t) {
            if (!r) {
              _this131._removeQuote(t, i.filter(mC));
            } else {
              var _e216 = i.filter(function (t) {
                return mC(t) || pC(n, t);
              });
              _this131._applyQuote(t, _e216);
            }
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = this.editor.model.document.selection;
          var e = nC(t.getSelectedBlocks());
          return !!(e && mC(e));
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) {
            return true;
          }
          var t = this.editor.model.document.selection;
          var e = this.editor.model.schema;
          var n = nC(t.getSelectedBlocks());
          if (!n) {
            return false;
          }
          return pC(e, n);
        }
      }, {
        key: "_removeQuote",
        value: function _removeQuote(t, e) {
          gC(t, e).reverse().forEach(function (e) {
            if (e.start.isAtStart && e.end.isAtEnd) {
              t.unwrap(e.start.parent);
              return;
            }
            if (e.start.isAtStart) {
              var _n186 = t.createPositionBefore(e.start.parent);
              t.move(e, _n186);
              return;
            }
            if (!e.end.isAtEnd) {
              t.split(e.end);
            }
            var n = t.createPositionAfter(e.end.parent);
            t.move(e, n);
          });
        }
      }, {
        key: "_applyQuote",
        value: function _applyQuote(t, e) {
          var n = [];
          gC(t, e).reverse().forEach(function (e) {
            var o = mC(e.start);
            if (!o) {
              o = t.createElement("blockQuote");
              t.wrap(e, o);
            }
            n.push(o);
          });
          n.reverse().reduce(function (e, n) {
            if (e.nextSibling == n) {
              t.merge(t.createPositionAfter(e));
              return e;
            }
            return n;
          });
        }
      }]);
      return fC;
    }(uC);
    function mC(t) {
      return t.parent.name == "blockQuote" ? t.parent : null;
    }
    function gC(t, e) {
      var n;
      var o = 0;
      var i = [];
      while (o < e.length) {
        var _r35 = e[o];
        var _s25 = e[o + 1];
        if (!n) {
          n = t.createPositionBefore(_r35);
        }
        if (!_s25 || _r35.nextSibling != _s25) {
          i.push(t.createRange(n, t.createPositionAfter(_r35)));
          n = null;
        }
        o++;
      }
      return i;
    }
    function pC(t, e) {
      var n = t.checkChild(e.parent, "blockQuote");
      var o = t.checkChild(["$root", "blockQuote"], e);
      return n && o;
    }
    var kC = /*#__PURE__*/function (_aC2) {
      _inherits(kC, _aC2);
      function kC() {
        _classCallCheck(this, kC);
        return _possibleConstructorReturn(this, _getPrototypeOf(kC).apply(this, arguments));
      }
      _createClass(kC, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model.schema;
          t.commands.add("blockQuote", new fC(t));
          e.register("blockQuote", {
            allowWhere: "$block",
            allowContentOf: "$root"
          });
          e.addChildCheck(function (t, e) {
            if (t.endsWith("blockQuote") && e.name == "blockQuote") {
              return false;
            }
          });
          t.conversion.elementToElement({
            model: "blockQuote",
            view: "blockquote"
          });
          t.model.document.registerPostFixer(function (n) {
            var o = t.model.document.differ.getChanges();
            var _iterator289 = _createForOfIteratorHelper(o),
              _step289;
            try {
              for (_iterator289.s(); !(_step289 = _iterator289.n()).done;) {
                var _t236 = _step289.value;
                if (_t236.type == "insert") {
                  var _o121 = _t236.position.nodeAfter;
                  if (!_o121) {
                    continue;
                  }
                  if (_o121.is("element", "blockQuote") && _o121.isEmpty) {
                    n.remove(_o121);
                    return true;
                  } else if (_o121.is("element", "blockQuote") && !e.checkChild(_t236.position, _o121)) {
                    n.unwrap(_o121);
                    return true;
                  } else if (_o121.is("element")) {
                    var _t237 = n.createRangeIn(_o121);
                    var _iterator290 = _createForOfIteratorHelper(_t237.getItems()),
                      _step290;
                    try {
                      for (_iterator290.s(); !(_step290 = _iterator290.n()).done;) {
                        var _o122 = _step290.value;
                        if (_o122.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(_o122), _o122)) {
                          n.unwrap(_o122);
                          return true;
                        }
                      }
                    } catch (err) {
                      _iterator290.e(err);
                    } finally {
                      _iterator290.f();
                    }
                  }
                } else if (_t236.type == "remove") {
                  var _e217 = _t236.position.parent;
                  if (_e217.is("element", "blockQuote") && _e217.isEmpty) {
                    n.remove(_e217);
                    return true;
                  }
                }
              }
            } catch (err) {
              _iterator289.e(err);
            } finally {
              _iterator289.f();
            }
            return false;
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var _this132 = this;
          var t = this.editor;
          var e = t.commands.get("blockQuote");
          this.listenTo(this.editor.editing.view.document, "enter", function (t, n) {
            var o = _this132.editor.model.document;
            var i = o.selection.getLastPosition().parent;
            if (o.selection.isCollapsed && i.isEmpty && e.value) {
              _this132.editor.execute("blockQuote");
              _this132.editor.editing.view.scrollToTheSelection();
              n.preventDefault();
              t.stop();
            }
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BlockQuoteEditing";
        }
      }]);
      return kC;
    }(aC);
    var bC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
    var wC = n(27);
    var CC = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    CC.insert = "head";
    CC.singleton = true;
    var AC = rk()(wC["a"], CC);
    var _C = wC["a"].locals || {};
    var vC = /*#__PURE__*/function (_aC3) {
      _inherits(vC, _aC3);
      function vC() {
        _classCallCheck(this, vC);
        return _possibleConstructorReturn(this, _getPrototypeOf(vC).apply(this, arguments));
      }
      _createClass(vC, [{
        key: "init",
        value: function init() {
          var _this133 = this;
          var t = this.editor;
          var e = t.t;
          t.ui.componentFactory.add("blockQuote", function (n) {
            var o = t.commands.get("blockQuote");
            var i = new cw(n);
            i.set({
              label: e("Block quote"),
              icon: bC,
              tooltip: true,
              isToggleable: true
            });
            i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
            _this133.listenTo(i, "execute", function () {
              t.execute("blockQuote");
              t.editing.view.focus();
            });
            return i;
          });
        }
      }]);
      return vC;
    }(aC);
    var yC = /*#__PURE__*/function (_aC4) {
      _inherits(yC, _aC4);
      function yC() {
        _classCallCheck(this, yC);
        return _possibleConstructorReturn(this, _getPrototypeOf(yC).apply(this, arguments));
      }
      _createClass(yC, null, [{
        key: "requires",
        get: function get() {
          return [kC, vC];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "BlockQuote";
        }
      }]);
      return yC;
    }(aC);
    var xC = /*#__PURE__*/function (_uC2) {
      _inherits(xC, _uC2);
      function xC(t, e) {
        var _this134;
        _classCallCheck(this, xC);
        _this134 = _possibleConstructorReturn(this, _getPrototypeOf(xC).call(this, t));
        _this134.attributeKey = e;
        return _this134;
      }
      _createClass(xC, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document;
          this.value = this._getValueFromFirstAllowedNode();
          this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this135 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.document;
          var o = n.selection;
          var i = t.forceValue === undefined ? !this.value : t.forceValue;
          e.change(function (t) {
            if (o.isCollapsed) {
              if (i) {
                t.setSelectionAttribute(_this135.attributeKey, true);
              } else {
                t.removeSelectionAttribute(_this135.attributeKey);
              }
            } else {
              var _n187 = e.schema.getValidRanges(o.getRanges(), _this135.attributeKey);
              var _iterator291 = _createForOfIteratorHelper(_n187),
                _step291;
              try {
                for (_iterator291.s(); !(_step291 = _iterator291.n()).done;) {
                  var _e218 = _step291.value;
                  if (i) {
                    t.setAttribute(_this135.attributeKey, i, _e218);
                  } else {
                    t.removeAttribute(_this135.attributeKey, _e218);
                  }
                }
              } catch (err) {
                _iterator291.e(err);
              } finally {
                _iterator291.f();
              }
            }
          });
        }
      }, {
        key: "_getValueFromFirstAllowedNode",
        value: function _getValueFromFirstAllowedNode() {
          var t = this.editor.model;
          var e = t.schema;
          var n = t.document.selection;
          if (n.isCollapsed) {
            return n.hasAttribute(this.attributeKey);
          }
          var _iterator292 = _createForOfIteratorHelper(n.getRanges()),
            _step292;
          try {
            for (_iterator292.s(); !(_step292 = _iterator292.n()).done;) {
              var _t238 = _step292.value;
              var _iterator293 = _createForOfIteratorHelper(_t238.getItems()),
                _step293;
              try {
                for (_iterator293.s(); !(_step293 = _iterator293.n()).done;) {
                  var _n188 = _step293.value;
                  if (e.checkAttribute(_n188, this.attributeKey)) {
                    return _n188.hasAttribute(this.attributeKey);
                  }
                }
              } catch (err) {
                _iterator293.e(err);
              } finally {
                _iterator293.f();
              }
            }
          } catch (err) {
            _iterator292.e(err);
          } finally {
            _iterator292.f();
          }
          return false;
        }
      }]);
      return xC;
    }(uC);
    var DC = "bold";
    var EC = /*#__PURE__*/function (_aC5) {
      _inherits(EC, _aC5);
      function EC() {
        _classCallCheck(this, EC);
        return _possibleConstructorReturn(this, _getPrototypeOf(EC).apply(this, arguments));
      }
      _createClass(EC, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: DC
          });
          t.model.schema.setAttributeProperties(DC, {
            isFormatting: true,
            copyOnEnter: true
          });
          t.conversion.attributeToElement({
            model: DC,
            view: "strong",
            upcastAlso: ["b", function (t) {
              var e = t.getStyle("font-weight");
              if (!e) {
                return null;
              }
              if (e == "bold" || Number(e) >= 600) {
                return {
                  name: true,
                  styles: ["font-weight"]
                };
              }
            }]
          });
          t.commands.add(DC, new xC(t, DC));
          t.keystrokes.set("CTRL+B", DC);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "BoldEditing";
        }
      }]);
      return EC;
    }(aC);
    var MC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
    var SC = "bold";
    var TC = /*#__PURE__*/function (_aC6) {
      _inherits(TC, _aC6);
      function TC() {
        _classCallCheck(this, TC);
        return _possibleConstructorReturn(this, _getPrototypeOf(TC).apply(this, arguments));
      }
      _createClass(TC, [{
        key: "init",
        value: function init() {
          var _this136 = this;
          var t = this.editor;
          var e = t.t;
          t.ui.componentFactory.add(SC, function (n) {
            var o = t.commands.get(SC);
            var i = new cw(n);
            i.set({
              label: e("Bold"),
              icon: MC,
              keystroke: "CTRL+B",
              tooltip: true,
              isToggleable: true
            });
            i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
            _this136.listenTo(i, "execute", function () {
              t.execute(SC);
              t.editing.view.focus();
            });
            return i;
          });
        }
      }]);
      return TC;
    }(aC);
    var IC = /*#__PURE__*/function (_aC7) {
      _inherits(IC, _aC7);
      function IC() {
        _classCallCheck(this, IC);
        return _possibleConstructorReturn(this, _getPrototypeOf(IC).apply(this, arguments));
      }
      _createClass(IC, null, [{
        key: "requires",
        get: function get() {
          return [EC, TC];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Bold";
        }
      }]);
      return IC;
    }(aC);
    var NC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>';
    var PC = /*#__PURE__*/function (_aC8) {
      _inherits(PC, _aC8);
      function PC() {
        _classCallCheck(this, PC);
        return _possibleConstructorReturn(this, _getPrototypeOf(PC).apply(this, arguments));
      }
      _createClass(PC, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.ui.componentFactory;
          var n = t.t;
          e.add("ckfinder", function (e) {
            var o = t.commands.get("ckfinder");
            var i = new cw(e);
            i.set({
              label: n("Insert image or file"),
              icon: NC,
              tooltip: true
            });
            i.bind("isEnabled").to(o);
            i.on("execute", function () {
              t.execute("ckfinder");
              t.editing.view.focus();
            });
            return i;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderUI";
        }
      }]);
      return PC;
    }(aC);
    var BC = /*#__PURE__*/function (_tu5) {
      _inherits(BC, _tu5);
      function BC() {
        _classCallCheck(this, BC);
        return _possibleConstructorReturn(this, _getPrototypeOf(BC).apply(this, arguments));
      }
      _createClass(BC, [{
        key: "observe",
        value: function observe(t) {
          var _this137 = this;
          this.listenTo(t, "load", function (t, e) {
            var n = e.target;
            if (_this137.checkShouldIgnoreEventFromTarget(n)) {
              return;
            }
            if (n.tagName == "IMG") {
              _this137._fireEvents(e);
            }
          }, {
            useCapture: true
          });
        }
      }, {
        key: "_fireEvents",
        value: function _fireEvents(t) {
          if (this.isEnabled) {
            this.document.fire("layoutChanged");
            this.document.fire("imageLoaded", t);
          }
        }
      }]);
      return BC;
    }(tu);
    var zC = /*#__PURE__*/function () {
      function zC() {
        _classCallCheck(this, zC);
        this._stack = [];
      }
      _createClass(zC, [{
        key: "add",
        value: function add(t, e) {
          var n = this._stack;
          var o = n[0];
          this._insertDescriptor(t);
          var i = n[0];
          if (o !== i && !LC(o, i)) {
            this.fire("change:top", {
              oldDescriptor: o,
              newDescriptor: i,
              writer: e
            });
          }
        }
      }, {
        key: "remove",
        value: function remove(t, e) {
          var n = this._stack;
          var o = n[0];
          this._removeDescriptor(t);
          var i = n[0];
          if (o !== i && !LC(o, i)) {
            this.fire("change:top", {
              oldDescriptor: o,
              newDescriptor: i,
              writer: e
            });
          }
        }
      }, {
        key: "_insertDescriptor",
        value: function _insertDescriptor(t) {
          var e = this._stack;
          var n = e.findIndex(function (e) {
            return e.id === t.id;
          });
          if (LC(t, e[n])) {
            return;
          }
          if (n > -1) {
            e.splice(n, 1);
          }
          var o = 0;
          while (e[o] && OC(e[o], t)) {
            o++;
          }
          e.splice(o, 0, t);
        }
      }, {
        key: "_removeDescriptor",
        value: function _removeDescriptor(t) {
          var e = this._stack;
          var n = e.findIndex(function (e) {
            return e.id === t;
          });
          if (n > -1) {
            e.splice(n, 1);
          }
        }
      }]);
      return zC;
    }();
    _s(zC, ds);
    function LC(t, e) {
      return t && e && t.priority == e.priority && RC(t.classes) == RC(e.classes);
    }
    function OC(t, e) {
      if (t.priority > e.priority) {
        return true;
      } else if (t.priority < e.priority) {
        return false;
      }
      return RC(t.classes) > RC(e.classes);
    }
    function RC(t) {
      return Array.isArray(t) ? t.sort().join(",") : t;
    }
    var jC = n(28);
    var FC = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    FC.insert = "head";
    FC.singleton = true;
    var VC = rk()(jC["a"], FC);
    var UC = jC["a"].locals || {};
    var HC = wb("px");
    var GC = jd.document.body;
    var WC = /*#__PURE__*/function (_tb17) {
      _inherits(WC, _tb17);
      function WC(t) {
        var _this138;
        _classCallCheck(this, WC);
        _this138 = _possibleConstructorReturn(this, _getPrototypeOf(WC).call(this, t));
        var e = _this138.bindTemplate;
        _this138.set("top", 0);
        _this138.set("left", 0);
        _this138.set("position", "arrow_nw");
        _this138.set("isVisible", false);
        _this138.set("withArrow", true);
        _this138.set("class");
        _this138.content = _this138.createCollection();
        _this138.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-panel", e.to("position", function (t) {
              return "ck-balloon-panel_".concat(t);
            }), e.if("isVisible", "ck-balloon-panel_visible"), e.if("withArrow", "ck-balloon-panel_with-arrow"), e.to("class")],
            style: {
              top: e.to("top", HC),
              left: e.to("left", HC)
            }
          },
          children: _this138.content
        });
        return _this138;
      }
      _createClass(WC, [{
        key: "show",
        value: function show() {
          this.isVisible = true;
        }
      }, {
        key: "hide",
        value: function hide() {
          this.isVisible = false;
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          this.show();
          var e = WC.defaultPositions;
          var n = Object.assign({}, {
            element: this.element,
            positions: [e.southArrowNorth, e.southArrowNorthMiddleWest, e.southArrowNorthMiddleEast, e.southArrowNorthWest, e.southArrowNorthEast, e.northArrowSouth, e.northArrowSouthMiddleWest, e.northArrowSouthMiddleEast, e.northArrowSouthWest, e.northArrowSouthEast],
            limiter: GC,
            fitInViewport: true
          }, t);
          var o = WC._getOptimalPosition(n);
          var i = parseInt(o.left);
          var r = parseInt(o.top);
          var s = o.name;
          Object.assign(this, {
            top: r,
            left: i,
            position: s
          });
        }
      }, {
        key: "pin",
        value: function pin(t) {
          var _this139 = this;
          this.unpin();
          this._pinWhenIsVisibleCallback = function () {
            if (_this139.isVisible) {
              _this139._startPinning(t);
            } else {
              _this139._stopPinning();
            }
          };
          this._startPinning(t);
          this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
        }
      }, {
        key: "unpin",
        value: function unpin() {
          if (this._pinWhenIsVisibleCallback) {
            this._stopPinning();
            this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback);
            this._pinWhenIsVisibleCallback = null;
            this.hide();
          }
        }
      }, {
        key: "_startPinning",
        value: function _startPinning(t) {
          var _this140 = this;
          this.attachTo(t);
          var e = KC(t.target);
          var n = t.limiter ? KC(t.limiter) : GC;
          this.listenTo(jd.document, "scroll", function (o, i) {
            var r = i.target;
            var s = e && r.contains(e);
            var a = n && r.contains(n);
            if (s || a || !e || !n) {
              _this140.attachTo(t);
            }
          }, {
            useCapture: true
          });
          this.listenTo(jd.window, "resize", function () {
            _this140.attachTo(t);
          });
        }
      }, {
        key: "_stopPinning",
        value: function _stopPinning() {
          this.stopListening(jd.document, "scroll");
          this.stopListening(jd.window, "resize");
        }
      }]);
      return WC;
    }(tb);
    function KC(t) {
      if (Yr(t)) {
        return t;
      }
      if (yh(t)) {
        return t.commonAncestorContainer;
      }
      if (typeof t == "function") {
        return KC(t());
      }
      return null;
    }
    WC.arrowHorizontalOffset = 25;
    WC.arrowVerticalOffset = 10;
    WC._getOptimalPosition = Fb;
    WC.defaultPositions = {
      northWestArrowSouthWest: function northWestArrowSouthWest(t, e) {
        return {
          top: qC(t, e),
          left: t.left - WC.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northWestArrowSouthMiddleWest: function northWestArrowSouthMiddleWest(t, e) {
        return {
          top: qC(t, e),
          left: t.left - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northWestArrowSouth: function northWestArrowSouth(t, e) {
        return {
          top: qC(t, e),
          left: t.left - e.width / 2,
          name: "arrow_s"
        };
      },
      northWestArrowSouthMiddleEast: function northWestArrowSouthMiddleEast(t, e) {
        return {
          top: qC(t, e),
          left: t.left - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northWestArrowSouthEast: function northWestArrowSouthEast(t, e) {
        return {
          top: qC(t, e),
          left: t.left - e.width + WC.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northArrowSouthWest: function northArrowSouthWest(t, e) {
        return {
          top: qC(t, e),
          left: t.left + t.width / 2 - WC.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northArrowSouthMiddleWest: function northArrowSouthMiddleWest(t, e) {
        return {
          top: qC(t, e),
          left: t.left + t.width / 2 - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northArrowSouth: function northArrowSouth(t, e) {
        return {
          top: qC(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_s"
        };
      },
      northArrowSouthMiddleEast: function northArrowSouthMiddleEast(t, e) {
        return {
          top: qC(t, e),
          left: t.left + t.width / 2 - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northArrowSouthEast: function northArrowSouthEast(t, e) {
        return {
          top: qC(t, e),
          left: t.left + t.width / 2 - e.width + WC.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      northEastArrowSouthWest: function northEastArrowSouthWest(t, e) {
        return {
          top: qC(t, e),
          left: t.right - WC.arrowHorizontalOffset,
          name: "arrow_sw"
        };
      },
      northEastArrowSouthMiddleWest: function northEastArrowSouthMiddleWest(t, e) {
        return {
          top: qC(t, e),
          left: t.right - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_smw"
        };
      },
      northEastArrowSouth: function northEastArrowSouth(t, e) {
        return {
          top: qC(t, e),
          left: t.right - e.width / 2,
          name: "arrow_s"
        };
      },
      northEastArrowSouthMiddleEast: function northEastArrowSouthMiddleEast(t, e) {
        return {
          top: qC(t, e),
          left: t.right - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_sme"
        };
      },
      northEastArrowSouthEast: function northEastArrowSouthEast(t, e) {
        return {
          top: qC(t, e),
          left: t.right - e.width + WC.arrowHorizontalOffset,
          name: "arrow_se"
        };
      },
      southWestArrowNorthWest: function southWestArrowNorthWest(t, e) {
        return {
          top: YC(t, e),
          left: t.left - WC.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southWestArrowNorthMiddleWest: function southWestArrowNorthMiddleWest(t, e) {
        return {
          top: YC(t, e),
          left: t.left - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southWestArrowNorth: function southWestArrowNorth(t, e) {
        return {
          top: YC(t, e),
          left: t.left - e.width / 2,
          name: "arrow_n"
        };
      },
      southWestArrowNorthMiddleEast: function southWestArrowNorthMiddleEast(t, e) {
        return {
          top: YC(t, e),
          left: t.left - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southWestArrowNorthEast: function southWestArrowNorthEast(t, e) {
        return {
          top: YC(t, e),
          left: t.left - e.width + WC.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southArrowNorthWest: function southArrowNorthWest(t, e) {
        return {
          top: YC(t, e),
          left: t.left + t.width / 2 - WC.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southArrowNorthMiddleWest: function southArrowNorthMiddleWest(t, e) {
        return {
          top: YC(t, e),
          left: t.left + t.width / 2 - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southArrowNorth: function southArrowNorth(t, e) {
        return {
          top: YC(t, e),
          left: t.left + t.width / 2 - e.width / 2,
          name: "arrow_n"
        };
      },
      southArrowNorthMiddleEast: function southArrowNorthMiddleEast(t, e) {
        return {
          top: YC(t, e),
          left: t.left + t.width / 2 - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southArrowNorthEast: function southArrowNorthEast(t, e) {
        return {
          top: YC(t, e),
          left: t.left + t.width / 2 - e.width + WC.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      },
      southEastArrowNorthWest: function southEastArrowNorthWest(t, e) {
        return {
          top: YC(t, e),
          left: t.right - WC.arrowHorizontalOffset,
          name: "arrow_nw"
        };
      },
      southEastArrowNorthMiddleWest: function southEastArrowNorthMiddleWest(t, e) {
        return {
          top: YC(t, e),
          left: t.right - e.width * .25 - WC.arrowHorizontalOffset,
          name: "arrow_nmw"
        };
      },
      southEastArrowNorth: function southEastArrowNorth(t, e) {
        return {
          top: YC(t, e),
          left: t.right - e.width / 2,
          name: "arrow_n"
        };
      },
      southEastArrowNorthMiddleEast: function southEastArrowNorthMiddleEast(t, e) {
        return {
          top: YC(t, e),
          left: t.right - e.width * .75 + WC.arrowHorizontalOffset,
          name: "arrow_nme"
        };
      },
      southEastArrowNorthEast: function southEastArrowNorthEast(t, e) {
        return {
          top: YC(t, e),
          left: t.right - e.width + WC.arrowHorizontalOffset,
          name: "arrow_ne"
        };
      }
    };
    function qC(t, e) {
      return t.top - e.height - WC.arrowVerticalOffset;
    }
    function YC(t) {
      return t.bottom + WC.arrowVerticalOffset;
    }
    var QC = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
    var $C = "widget-type-around";
    function ZC(t, e, n) {
      return t && iA(t) && !n.isInline(e);
    }
    function JC(t) {
      return t.closest(".ck-widget__type-around__button");
    }
    function XC(t) {
      return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
    }
    function tA(t, e) {
      var n = t.closest(".ck-widget");
      return e.mapDomToView(n);
    }
    function eA(t) {
      return t.getAttribute($C);
    }
    var nA = "ck-widget";
    var oA = "ck-widget_selected";
    function iA(t) {
      if (!t.is("element")) {
        return false;
      }
      return !!t.getCustomProperty("widget");
    }
    function rA(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!t.is("containerElement")) {
        throw new ss["a"]("widget-to-widget-wrong-element-type", null, {
          element: t
        });
      }
      e.setAttribute("contenteditable", "false", t);
      e.addClass(nA, t);
      e.setCustomProperty("widget", true, t);
      t.getFillerOffset = fA;
      if (n.label) {
        aA(t, n.label, e);
      }
      if (n.hasSelectionHandle) {
        mA(t, e);
      }
      sA(t, e, function (t, e, n) {
        return n.addClass(xs(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(xs(e.classes), t);
      });
      return t;
    }
    function sA(t, e, n, o) {
      var i = new zC();
      i.on("change:top", function (e, i) {
        if (i.oldDescriptor) {
          o(t, i.oldDescriptor, i.writer);
        }
        if (i.newDescriptor) {
          n(t, i.newDescriptor, i.writer);
        }
      });
      e.setCustomProperty("addHighlight", function (t, e, n) {
        return i.add(e, n);
      }, t);
      e.setCustomProperty("removeHighlight", function (t, e, n) {
        return i.remove(e, n);
      }, t);
    }
    function aA(t, e, n) {
      n.setCustomProperty("widgetLabel", e, t);
    }
    function cA(t) {
      var e = t.getCustomProperty("widgetLabel");
      if (!e) {
        return "";
      }
      return typeof e == "function" ? e() : e;
    }
    function lA(t, e) {
      e.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t);
      e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t);
      t.on("change:isReadOnly", function (n, o, i) {
        e.setAttribute("contenteditable", i ? "false" : "true", t);
      });
      t.on("change:isFocused", function (n, o, i) {
        if (i) {
          e.addClass("ck-editor__nested-editable_focused", t);
        } else {
          e.removeClass("ck-editor__nested-editable_focused", t);
        }
      });
      return t;
    }
    function dA(t, e) {
      var n = t.getSelectedElement();
      if (n) {
        var _o123 = eA(t);
        if (_o123) {
          return e.createPositionAt(n, _o123);
        }
        if (e.schema.isBlock(n)) {
          return e.createPositionAfter(n);
        }
      }
      var o = t.getSelectedBlocks().next().value;
      if (o) {
        if (o.isEmpty) {
          return e.createPositionAt(o, 0);
        }
        var _n189 = e.createPositionAfter(o);
        if (t.focus.isTouching(_n189)) {
          return _n189;
        }
        return e.createPositionBefore(o);
      }
      return t.focus;
    }
    function uA(t, e) {
      return function (n, o) {
        var i = o.mapper,
          r = o.viewPosition;
        var s = i.findMappedViewAncestor(r);
        if (!e(s)) {
          return;
        }
        var a = i.toModelElement(s);
        o.modelPosition = t.createPositionAt(a, r.isAtStart ? "before" : "after");
      };
    }
    function hA(t, e) {
      var n = new Eh(jd.window);
      var o = n.getIntersection(t);
      var i = e.height + WC.arrowVerticalOffset;
      if (t.top - i > n.top || t.bottom + i < n.bottom) {
        return null;
      }
      var r = o || t;
      var s = r.left + r.width / 2 - e.width / 2;
      return {
        top: Math.max(t.top, 0) + WC.arrowVerticalOffset,
        left: s,
        name: "arrow_n"
      };
    }
    function fA() {
      return null;
    }
    function mA(t, e) {
      var n = e.createUIElement("div", {
        class: "ck ck-widget__selection-handle"
      }, function (t) {
        var e = this.toDomElement(t);
        var n = new Jb();
        n.set("content", QC);
        n.render();
        e.appendChild(n.element);
        return e;
      });
      e.insert(e.createPositionAt(t, 0), n);
      e.addClass(["ck-widget_with-selection-handle"], t);
    }
    function gA(t, e, n) {
      e.setCustomProperty("image", true, t);
      return rA(t, e, {
        label: o
      });
      function o() {
        var e = AA(t);
        var o = e.getAttribute("alt");
        return o ? "".concat(o, " ").concat(n) : n;
      }
    }
    function pA(t) {
      return !!t.getCustomProperty("image") && iA(t);
    }
    function kA(t) {
      var e = t.getSelectedElement();
      if (e && pA(e)) {
        return e;
      }
      return null;
    }
    function bA(t) {
      return !!t && t.is("element", "image");
    }
    function wA(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      t.change(function (o) {
        var i = o.createElement("image", e);
        var r = n || dA(t.document.selection, t);
        t.insertContent(i, r);
        if (i.parent) {
          o.setSelection(i, "on");
        }
      });
    }
    function CA(t) {
      var e = t.schema;
      var n = t.document.selection;
      return _A(n, e, t) && !vA(n, e) && yA(n);
    }
    function AA(t) {
      var e = [];
      var _iterator294 = _createForOfIteratorHelper(t.getChildren()),
        _step294;
      try {
        for (_iterator294.s(); !(_step294 = _iterator294.n()).done;) {
          var _n190 = _step294.value;
          e.push(_n190);
          if (_n190.is("element")) {
            e.push.apply(e, _toConsumableArray(_n190.getChildren()));
          }
        }
      } catch (err) {
        _iterator294.e(err);
      } finally {
        _iterator294.f();
      }
      return e.find(function (t) {
        return t.is("element", "img");
      });
    }
    function _A(t, e, n) {
      var o = xA(t, n);
      return e.checkChild(o, "image");
    }
    function vA(t, e) {
      var n = t.getSelectedElement();
      return n && e.isObject(n);
    }
    function yA(t) {
      return _toConsumableArray(t.focus.getAncestors()).every(function (t) {
        return !t.is("element", "image");
      });
    }
    function xA(t, e) {
      var n = dA(t, e);
      var o = n.parent;
      if (o.isEmpty && !o.is("element", "$root")) {
        return o.parent;
      }
      return o;
    }
    function DA() {
      return function (e) {
        e.on("element:figure", t);
      };
      function t(t, e, n) {
        if (!n.consumable.test(e.viewItem, {
          name: true,
          classes: "image"
        })) {
          return;
        }
        var o = AA(e.viewItem);
        if (!o || !o.hasAttribute("src") || !n.consumable.test(o, {
          name: true
        })) {
          return;
        }
        var i = n.convertItem(o, e.modelCursor);
        var r = nC(i.modelRange.getItems());
        if (!r) {
          return;
        }
        n.convertChildren(e.viewItem, r);
        n.updateConversionResult(r, e);
      }
    }
    function EA() {
      return function (e) {
        e.on("attribute:srcset:image", t);
      };
      function t(t, e, n) {
        if (!n.consumable.consume(e.item, t.name)) {
          return;
        }
        var o = n.writer;
        var i = n.mapper.toViewElement(e.item);
        var r = AA(i);
        if (e.attributeNewValue === null) {
          var _t239 = e.attributeOldValue;
          if (_t239.data) {
            o.removeAttribute("srcset", r);
            o.removeAttribute("sizes", r);
            if (_t239.width) {
              o.removeAttribute("width", r);
            }
          }
        } else {
          var _t240 = e.attributeNewValue;
          if (_t240.data) {
            o.setAttribute("srcset", _t240.data, r);
            o.setAttribute("sizes", "100vw", r);
            if (_t240.width) {
              o.setAttribute("width", _t240.width, r);
            }
          }
        }
      }
    }
    function MA(t) {
      return function (n) {
        n.on("attribute:".concat(t, ":image"), e);
      };
      function e(t, e, n) {
        if (!n.consumable.consume(e.item, t.name)) {
          return;
        }
        var o = n.writer;
        var i = n.mapper.toViewElement(e.item);
        var r = AA(i);
        o.setAttribute(e.attributeKey, e.attributeNewValue || "", r);
      }
    }
    var SA = /*#__PURE__*/function (_uC3) {
      _inherits(SA, _uC3);
      function SA() {
        _classCallCheck(this, SA);
        return _possibleConstructorReturn(this, _getPrototypeOf(SA).apply(this, arguments));
      }
      _createClass(SA, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = CA(this.editor.model);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var _iterator295 = _createForOfIteratorHelper(xs(t.source)),
            _step295;
          try {
            for (_iterator295.s(); !(_step295 = _iterator295.n()).done;) {
              var _n191 = _step295.value;
              wA(e, {
                src: _n191
              });
            }
          } catch (err) {
            _iterator295.e(err);
          } finally {
            _iterator295.f();
          }
        }
      }]);
      return SA;
    }(uC);
    var TA = /*#__PURE__*/function (_aC9) {
      _inherits(TA, _aC9);
      function TA() {
        _classCallCheck(this, TA);
        return _possibleConstructorReturn(this, _getPrototypeOf(TA).apply(this, arguments));
      }
      _createClass(TA, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model.schema;
          var n = t.t;
          var o = t.conversion;
          t.editing.view.addObserver(BC);
          e.register("image", {
            isObject: true,
            isBlock: true,
            allowWhere: "$block",
            allowAttributes: ["alt", "src", "srcset"]
          });
          o.for("dataDowncast").elementToElement({
            model: "image",
            view: function view(t, _ref28) {
              var e = _ref28.writer;
              return IA(e);
            }
          });
          o.for("editingDowncast").elementToElement({
            model: "image",
            view: function view(t, _ref29) {
              var e = _ref29.writer;
              return gA(IA(e), e, n("image widget"));
            }
          });
          o.for("downcast").add(MA("src")).add(MA("alt")).add(EA());
          o.for("upcast").elementToElement({
            view: {
              name: "img",
              attributes: {
                src: true
              }
            },
            model: function model(t, _ref30) {
              var e = _ref30.writer;
              return e.createElement("image", {
                src: t.getAttribute("src")
              });
            }
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "alt"
            },
            model: "alt"
          }).attributeToAttribute({
            view: {
              name: "img",
              key: "srcset"
            },
            model: {
              key: "srcset",
              value: function value(t) {
                var e = {
                  data: t.getAttribute("srcset")
                };
                if (t.hasAttribute("width")) {
                  e.width = t.getAttribute("width");
                }
                return e;
              }
            }
          }).add(DA());
          t.commands.add("imageInsert", new SA(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageEditing";
        }
      }]);
      return TA;
    }(aC);
    function IA(t) {
      var e = t.createEmptyElement("img");
      var n = t.createContainerElement("figure", {
        class: "image"
      });
      t.insert(t.createPositionAt(n, 0), e);
      return n;
    }
    var NA = /*#__PURE__*/function (_nh5) {
      _inherits(NA, _nh5);
      function NA(t) {
        var _this141;
        _classCallCheck(this, NA);
        _this141 = _possibleConstructorReturn(this, _getPrototypeOf(NA).call(this, t));
        _this141.domEventType = "mousedown";
        return _this141;
      }
      _createClass(NA, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return NA;
    }(nh);
    var PA = /*#__PURE__*/function (_aC10) {
      _inherits(PA, _aC10);
      _createClass(PA, null, [{
        key: "pluginName",
        get: function get() {
          return "TwoStepCaretMovement";
        }
      }]);
      function PA(t) {
        var _this142;
        _classCallCheck(this, PA);
        _this142 = _possibleConstructorReturn(this, _getPrototypeOf(PA).call(this, t));
        _this142.attributes = new Set();
        _this142._overrideUid = null;
        return _this142;
      }
      _createClass(PA, [{
        key: "init",
        value: function init() {
          var _this143 = this;
          var t = this.editor;
          var e = t.model;
          var n = t.editing.view;
          var o = t.locale;
          var i = e.document.selection;
          this.listenTo(n.document, "keydown", function (t, e) {
            if (!i.isCollapsed) {
              return;
            }
            if (e.shiftKey || e.altKey || e.ctrlKey) {
              return;
            }
            var n = e.keyCode == Ll.arrowright;
            var r = e.keyCode == Ll.arrowleft;
            if (!n && !r) {
              return;
            }
            var s = o.contentLanguageDirection;
            var a = false;
            if (s === "ltr" && n || s === "rtl" && r) {
              a = _this143._handleForwardMovement(e);
            } else {
              a = _this143._handleBackwardMovement(e);
            }
            if (a === true) {
              t.stop();
            }
          }, {
            priority: is.get("high") + 1
          });
          this._isNextGravityRestorationSkipped = false;
          this.listenTo(i, "change:range", function (t, e) {
            if (_this143._isNextGravityRestorationSkipped) {
              _this143._isNextGravityRestorationSkipped = false;
              return;
            }
            if (!_this143._isGravityOverridden) {
              return;
            }
            if (!e.directChange && RA(i.getFirstPosition(), _this143.attributes)) {
              return;
            }
            _this143._restoreGravity();
          });
        }
      }, {
        key: "registerAttribute",
        value: function registerAttribute(t) {
          this.attributes.add(t);
        }
      }, {
        key: "_handleForwardMovement",
        value: function _handleForwardMovement(t) {
          var e = this.attributes;
          var n = this.editor.model;
          var o = n.document.selection;
          var i = o.getFirstPosition();
          if (this._isGravityOverridden) {
            return false;
          }
          if (i.isAtStart && BA(o, e)) {
            return false;
          }
          if (RA(i, e)) {
            LA(t);
            this._overrideGravity();
            return true;
          }
        }
      }, {
        key: "_handleBackwardMovement",
        value: function _handleBackwardMovement(t) {
          var e = this.attributes;
          var n = this.editor.model;
          var o = n.document.selection;
          var i = o.getFirstPosition();
          if (this._isGravityOverridden) {
            LA(t);
            this._restoreGravity();
            zA(n, e, i);
            return true;
          } else {
            if (i.isAtStart) {
              if (BA(o, e)) {
                LA(t);
                zA(n, e, i);
                return true;
              }
              return false;
            }
            if (OA(i, e)) {
              if (i.isAtEnd && !BA(o, e) && RA(i, e)) {
                LA(t);
                zA(n, e, i);
                return true;
              }
              this._isNextGravityRestorationSkipped = true;
              this._overrideGravity();
              return false;
            }
          }
        }
      }, {
        key: "_overrideGravity",
        value: function _overrideGravity() {
          this._overrideUid = this.editor.model.change(function (t) {
            return t.overrideSelectionGravity();
          });
        }
      }, {
        key: "_restoreGravity",
        value: function _restoreGravity() {
          var _this144 = this;
          this.editor.model.change(function (t) {
            t.restoreSelectionGravity(_this144._overrideUid);
            _this144._overrideUid = null;
          });
        }
      }, {
        key: "_isGravityOverridden",
        get: function get() {
          return !!this._overrideUid;
        }
      }]);
      return PA;
    }(aC);
    function BA(t, e) {
      var _iterator296 = _createForOfIteratorHelper(e),
        _step296;
      try {
        for (_iterator296.s(); !(_step296 = _iterator296.n()).done;) {
          var _n192 = _step296.value;
          if (t.hasAttribute(_n192)) {
            return true;
          }
        }
      } catch (err) {
        _iterator296.e(err);
      } finally {
        _iterator296.f();
      }
      return false;
    }
    function zA(t, e, n) {
      var o = n.nodeBefore;
      t.change(function (t) {
        if (o) {
          t.setSelectionAttribute(o.getAttributes());
        } else {
          t.removeSelectionAttribute(e);
        }
      });
    }
    function LA(t) {
      t.preventDefault();
    }
    function OA(t, e) {
      var n = t.getShiftedBy(-1);
      return RA(n, e);
    }
    function RA(t, e) {
      var n = t.nodeBefore,
        o = t.nodeAfter;
      var _iterator297 = _createForOfIteratorHelper(e),
        _step297;
      try {
        for (_iterator297.s(); !(_step297 = _iterator297.n()).done;) {
          var _t241 = _step297.value;
          var _e219 = n ? n.getAttribute(_t241) : undefined;
          var _i106 = o ? o.getAttribute(_t241) : undefined;
          if (_i106 !== _e219) {
            return true;
          }
        }
      } catch (err) {
        _iterator297.e(err);
      } finally {
        _iterator297.f();
      }
      return false;
    }
    function jA(t, e, n, o) {
      return o.createRange(FA(t, e, n, true, o), FA(t, e, n, false, o));
    }
    function FA(t, e, n, o, i) {
      var r = t.textNode || (o ? t.nodeBefore : t.nodeAfter);
      var s = null;
      while (r && r.getAttribute(e) == n) {
        s = r;
        r = o ? r.previousSibling : r.nextSibling;
      }
      return s ? i.createPositionAt(s, o ? "before" : "after") : t;
    }
    function VA(t, e, n, o) {
      var i = t.editing.view;
      var r = new Set();
      i.document.registerPostFixer(function (i) {
        var s = t.model.document.selection;
        var a = false;
        if (s.hasAttribute(e)) {
          var _c9 = jA(s.getFirstPosition(), e, s.getAttribute(e), t.model);
          var _l6 = t.editing.mapper.toViewRange(_c9);
          var _iterator298 = _createForOfIteratorHelper(_l6.getItems()),
            _step298;
          try {
            for (_iterator298.s(); !(_step298 = _iterator298.n()).done;) {
              var _t242 = _step298.value;
              if (_t242.is("element", n) && !_t242.hasClass(o)) {
                i.addClass(o, _t242);
                r.add(_t242);
                a = true;
              }
            }
          } catch (err) {
            _iterator298.e(err);
          } finally {
            _iterator298.f();
          }
        }
        return a;
      });
      t.conversion.for("editingDowncast").add(function (t) {
        t.on("insert", e, {
          priority: "highest"
        });
        t.on("remove", e, {
          priority: "highest"
        });
        t.on("attribute", e, {
          priority: "highest"
        });
        t.on("selection", e, {
          priority: "highest"
        });
        function e() {
          i.change(function (t) {
            var _iterator299 = _createForOfIteratorHelper(r.values()),
              _step299;
            try {
              for (_iterator299.s(); !(_step299 = _iterator299.n()).done;) {
                var _e220 = _step299.value;
                t.removeClass(o, _e220);
                r.delete(_e220);
              }
            } catch (err) {
              _iterator299.e(err);
            } finally {
              _iterator299.f();
            }
          });
        }
      });
    }
    var UA = /*#__PURE__*/function () {
      function UA(t) {
        var _this145 = this;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
        _classCallCheck(this, UA);
        this.model = t;
        this.size = 0;
        this.limit = e;
        this.isLocked = false;
        this._changeCallback = function (t, e) {
          if (e.type != "transparent" && e !== _this145._batch) {
            _this145._reset(true);
          }
        };
        this._selectionChangeCallback = function () {
          _this145._reset();
        };
        this.model.document.on("change", this._changeCallback);
        this.model.document.selection.on("change:range", this._selectionChangeCallback);
        this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
      }
      _createClass(UA, [{
        key: "input",
        value: function input(t) {
          this.size += t;
          if (this.size >= this.limit) {
            this._reset(true);
          }
        }
      }, {
        key: "lock",
        value: function lock() {
          this.isLocked = true;
        }
      }, {
        key: "unlock",
        value: function unlock() {
          this.isLocked = false;
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.model.document.off("change", this._changeCallback);
          this.model.document.selection.off("change:range", this._selectionChangeCallback);
          this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
        }
      }, {
        key: "_reset",
        value: function _reset(t) {
          if (!this.isLocked || t) {
            this._batch = null;
            this.size = 0;
          }
        }
      }, {
        key: "batch",
        get: function get() {
          if (!this._batch) {
            this._batch = this.model.createBatch();
          }
          return this._batch;
        }
      }]);
      return UA;
    }();
    var HA = /*#__PURE__*/function (_uC4) {
      _inherits(HA, _uC4);
      function HA(t, e) {
        var _this146;
        _classCallCheck(this, HA);
        _this146 = _possibleConstructorReturn(this, _getPrototypeOf(HA).call(this, t));
        _this146._buffer = new UA(t.model, e);
        _this146._batches = new WeakSet();
        return _this146;
      }
      _createClass(HA, [{
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(HA.prototype), "destroy", this).call(this);
          this._buffer.destroy();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this147 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.document;
          var o = t.text || "";
          var i = o.length;
          var r = t.range ? e.createSelection(t.range) : n.selection;
          var s = t.resultRange;
          e.enqueueChange(this._buffer.batch, function (t) {
            _this147._buffer.lock();
            _this147._batches.add(_this147._buffer.batch);
            e.deleteContent(r);
            if (o) {
              e.insertContent(t.createText(o, n.selection.getAttributes()), r);
            }
            if (s) {
              t.setSelection(s);
            } else if (!r.is("documentSelection")) {
              t.setSelection(r);
            }
            _this147._buffer.unlock();
            _this147._buffer.input(i);
          });
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);
      return HA;
    }(uC);
    function GA(t) {
      var e = null;
      var n = t.model;
      var o = t.editing.view;
      var i = t.commands.get("input");
      if (El.isAndroid) {
        o.document.on("beforeinput", function (t, e) {
          return r(e);
        }, {
          priority: "lowest"
        });
      } else {
        o.document.on("keydown", function (t, e) {
          return r(e);
        }, {
          priority: "lowest"
        });
      }
      o.document.on("compositionstart", s, {
        priority: "lowest"
      });
      o.document.on("compositionend", function () {
        e = n.createSelection(n.document.selection);
      }, {
        priority: "lowest"
      });
      function r(t) {
        var r = n.document;
        var s = o.document.isComposing;
        var c = e && e.isEqual(r.selection);
        e = null;
        if (!i.isEnabled) {
          return;
        }
        if (KA(t) || r.selection.isCollapsed) {
          return;
        }
        if (s && t.keyCode === 229) {
          return;
        }
        if (!s && t.keyCode === 229 && c) {
          return;
        }
        a();
      }
      function s() {
        var t = n.document;
        var e = t.selection.rangeCount === 1 ? t.selection.getFirstRange().isFlat : true;
        if (t.selection.isCollapsed || e) {
          return;
        }
        a();
      }
      function a() {
        var t = i.buffer;
        t.lock();
        var e = t.batch;
        i._batches.add(e);
        n.enqueueChange(e, function () {
          n.deleteContent(n.document.selection);
        });
        t.unlock();
      }
    }
    var WA = [Ol("arrowUp"), Ol("arrowRight"), Ol("arrowDown"), Ol("arrowLeft"), 9, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 45, 91, 93, 144, 145, 173, 174, 175, 176, 177, 178, 179, 255];
    for (var _t243 = 112; _t243 <= 135; _t243++) {
      WA.push(_t243);
    }
    function KA(t) {
      if (t.ctrlKey) {
        return true;
      }
      return WA.includes(t.keyCode);
    }
    function qA(t, e) {
      var n = [];
      var o = 0;
      var i;
      t.forEach(function (t) {
        if (t == "equal") {
          r();
          o++;
        } else if (t == "insert") {
          if (s("insert")) {
            i.values.push(e[o]);
          } else {
            r();
            i = {
              type: "insert",
              index: o,
              values: [e[o]]
            };
          }
          o++;
        } else {
          if (s("delete")) {
            i.howMany++;
          } else {
            r();
            i = {
              type: "delete",
              index: o,
              howMany: 1
            };
          }
        }
      });
      r();
      return n;
      function r() {
        if (i) {
          n.push(i);
          i = null;
        }
      }
      function s(t) {
        return i && i.type == t;
      }
    }
    function YA(t) {
      if (t.length == 0) {
        return false;
      }
      var _iterator300 = _createForOfIteratorHelper(t),
        _step300;
      try {
        for (_iterator300.s(); !(_step300 = _iterator300.n()).done;) {
          var _e221 = _step300.value;
          if (_e221.type === "children" && !QA(_e221)) {
            return true;
          }
        }
      } catch (err) {
        _iterator300.e(err);
      } finally {
        _iterator300.f();
      }
      return false;
    }
    function QA(t) {
      if (t.newChildren.length - t.oldChildren.length != 1) {
        return;
      }
      var e = Ed(t.oldChildren, t.newChildren, $A);
      var n = qA(e, t.newChildren);
      if (n.length > 1) {
        return;
      }
      var o = n[0];
      if (!(!!o.values[0] && o.values[0].is("$text"))) {
        return;
      }
      return o;
    }
    function $A(t, e) {
      if (!!t && t.is("$text") && !!e && e.is("$text")) {
        return t.data === e.data;
      } else {
        return t === e;
      }
    }
    function ZA(t) {
      t.editing.view.document.on("mutations", function (e, n, o) {
        new JA(t).handle(n, o);
      });
    }
    var JA = /*#__PURE__*/function () {
      function JA(t) {
        _classCallCheck(this, JA);
        this.editor = t;
        this.editing = this.editor.editing;
      }
      _createClass(JA, [{
        key: "handle",
        value: function handle(t, e) {
          if (YA(t)) {
            this._handleContainerChildrenMutations(t, e);
          } else {
            var _iterator301 = _createForOfIteratorHelper(t),
              _step301;
            try {
              for (_iterator301.s(); !(_step301 = _iterator301.n()).done;) {
                var _n193 = _step301.value;
                this._handleTextMutation(_n193, e);
                this._handleTextNodeInsertion(_n193);
              }
            } catch (err) {
              _iterator301.e(err);
            } finally {
              _iterator301.f();
            }
          }
        }
      }, {
        key: "_handleContainerChildrenMutations",
        value: function _handleContainerChildrenMutations(t, e) {
          var n = XA(t);
          if (!n) {
            return;
          }
          var o = this.editor.editing.view.domConverter;
          var i = o.mapViewToDom(n);
          var r = new Gd(this.editor.editing.view.document);
          var s = this.editor.data.toModel(r.domToView(i)).getChild(0);
          var a = this.editor.editing.mapper.toModelElement(n);
          if (!a) {
            return;
          }
          var c = Array.from(s.getChildren());
          var l = Array.from(a.getChildren());
          var d = c[c.length - 1];
          var u = l[l.length - 1];
          var h = d && d.is("element", "softBreak");
          var f = u && !u.is("element", "softBreak");
          if (h && f) {
            c.pop();
          }
          var m = this.editor.model.schema;
          if (!t_(c, m) || !t_(l, m)) {
            return;
          }
          var g = c.map(function (t) {
            return t.is("$text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          var p = l.map(function (t) {
            return t.is("$text") ? t.data : "@";
          }).join("").replace(/\u00A0/g, " ");
          if (p === g) {
            return;
          }
          var k = Ed(p, g);
          var _e_ = e_(k),
            b = _e_.firstChangeAt,
            w = _e_.insertions,
            C = _e_.deletions;
          var A = null;
          if (e) {
            A = this.editing.mapper.toModelRange(e.getFirstRange());
          }
          var _ = g.substr(b, w);
          var v = this.editor.model.createRange(this.editor.model.createPositionAt(a, b), this.editor.model.createPositionAt(a, b + C));
          this.editor.execute("input", {
            text: _,
            range: v,
            resultRange: A
          });
        }
      }, {
        key: "_handleTextMutation",
        value: function _handleTextMutation(t, e) {
          if (t.type != "text") {
            return;
          }
          var n = t.newText.replace(/\u00A0/g, " ");
          var o = t.oldText.replace(/\u00A0/g, " ");
          if (o === n) {
            return;
          }
          var i = Ed(o, n);
          var _e_2 = e_(i),
            r = _e_2.firstChangeAt,
            s = _e_2.insertions,
            a = _e_2.deletions;
          var c = null;
          if (e) {
            c = this.editing.mapper.toModelRange(e.getFirstRange());
          }
          var l = this.editing.view.createPositionAt(t.node, r);
          var d = this.editing.mapper.toModelPosition(l);
          var u = this.editor.model.createRange(d, d.getShiftedBy(a));
          var h = n.substr(r, s);
          this.editor.execute("input", {
            text: h,
            range: u,
            resultRange: c
          });
        }
      }, {
        key: "_handleTextNodeInsertion",
        value: function _handleTextNodeInsertion(t) {
          if (t.type != "children") {
            return;
          }
          var e = QA(t);
          var n = this.editing.view.createPositionAt(t.node, e.index);
          var o = this.editing.mapper.toModelPosition(n);
          var i = e.values[0].data;
          this.editor.execute("input", {
            text: i.replace(/\u00A0/g, " "),
            range: this.editor.model.createRange(o)
          });
        }
      }]);
      return JA;
    }();
    function XA(t) {
      var e = t.map(function (t) {
        return t.node;
      }).reduce(function (t, e) {
        return t.getCommonAncestor(e, {
          includeSelf: true
        });
      });
      if (!e) {
        return;
      }
      return e.getAncestors({
        includeSelf: true,
        parentFirst: true
      }).find(function (t) {
        return t.is("containerElement") || t.is("rootElement");
      });
    }
    function t_(t, e) {
      return t.every(function (t) {
        return e.isInline(t);
      });
    }
    function e_(t) {
      var e = null;
      var n = null;
      for (var _o124 = 0; _o124 < t.length; _o124++) {
        var _i107 = t[_o124];
        if (_i107 != "equal") {
          e = e === null ? _o124 : e;
          n = _o124;
        }
      }
      var o = 0;
      var i = 0;
      for (var _r36 = e; _r36 <= n; _r36++) {
        if (t[_r36] != "insert") {
          o++;
        }
        if (t[_r36] != "delete") {
          i++;
        }
      }
      return {
        insertions: i,
        deletions: o,
        firstChangeAt: e
      };
    }
    var n_ = /*#__PURE__*/function (_aC11) {
      _inherits(n_, _aC11);
      function n_() {
        _classCallCheck(this, n_);
        return _possibleConstructorReturn(this, _getPrototypeOf(n_).apply(this, arguments));
      }
      _createClass(n_, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = new HA(t, t.config.get("typing.undoStep") || 20);
          t.commands.add("input", e);
          GA(t);
          ZA(t);
        }
      }, {
        key: "isInput",
        value: function isInput(t) {
          var e = this.editor.commands.get("input");
          return e._batches.has(t);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Input";
        }
      }]);
      return n_;
    }(aC);
    var o_ = /*#__PURE__*/function () {
      function o_(t) {
        _classCallCheck(this, o_);
        this.files = i_(t);
        this._native = t;
      }
      _createClass(o_, [{
        key: "getData",
        value: function getData(t) {
          return this._native.getData(t);
        }
      }, {
        key: "setData",
        value: function setData(t, e) {
          this._native.setData(t, e);
        }
      }, {
        key: "types",
        get: function get() {
          return this._native.types;
        }
      }]);
      return o_;
    }();
    function i_(t) {
      var e = t.files ? Array.from(t.files) : [];
      var n = t.items ? Array.from(t.items) : [];
      if (e.length) {
        return e;
      }
      return n.filter(function (t) {
        return t.kind === "file";
      }).map(function (t) {
        return t.getAsFile();
      });
    }
    var r_ = /*#__PURE__*/function (_nh6) {
      _inherits(r_, _nh6);
      function r_(t) {
        var _this148;
        _classCallCheck(this, r_);
        _this148 = _possibleConstructorReturn(this, _getPrototypeOf(r_).call(this, t));
        var e = _this148.document;
        _this148.domEventType = ["paste", "copy", "cut", "drop", "dragover"];
        _this148.listenTo(e, "paste", n, {
          priority: "low"
        });
        _this148.listenTo(e, "drop", n, {
          priority: "low"
        });
        function n(t, n) {
          n.preventDefault();
          var o = n.dropRange ? [n.dropRange] : Array.from(e.selection.getRanges());
          var i = new ts(e, "clipboardInput");
          e.fire(i, {
            dataTransfer: n.dataTransfer,
            targetRanges: o
          });
          if (i.stop.called) {
            n.stopPropagation();
          }
        }
        return _this148;
      }
      _createClass(r_, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          var e = {
            dataTransfer: new o_(t.clipboardData ? t.clipboardData : t.dataTransfer)
          };
          if (t.type == "drop") {
            e.dropRange = s_(this.view, t);
          }
          this.fire(t.type, t, e);
        }
      }]);
      return r_;
    }(nh);
    function s_(t, e) {
      var n = e.target.ownerDocument;
      var o = e.clientX;
      var i = e.clientY;
      var r;
      if (n.caretRangeFromPoint && n.caretRangeFromPoint(o, i)) {
        r = n.caretRangeFromPoint(o, i);
      } else if (e.rangeParent) {
        r = n.createRange();
        r.setStart(e.rangeParent, e.rangeOffset);
        r.collapse(true);
      }
      if (r) {
        return t.domConverter.domRangeToView(r);
      } else {
        return t.document.selection.getFirstRange();
      }
    }
    var a_ = /*#__PURE__*/function (_aC12) {
      _inherits(a_, _aC12);
      function a_() {
        _classCallCheck(this, a_);
        return _possibleConstructorReturn(this, _getPrototypeOf(a_).apply(this, arguments));
      }
      _createClass(a_, [{
        key: "init",
        value: function init() {
          var t = this.editor.editing.view;
          var e = t.document;
          var n = false;
          t.addObserver(r_);
          this.listenTo(e, "keydown", function (t, e) {
            n = e.shiftKey;
          });
          this.listenTo(e, "clipboardInput", function (t, e) {
            if (n) {
              e.asPlainText = true;
            }
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PastePlainText";
        }
      }]);
      return a_;
    }(aC);
    function c_(t) {
      t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;");
      if (t.includes("</p><p>") || t.includes("<br>")) {
        t = "<p>".concat(t, "</p>");
      }
      return t;
    }
    function l_(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        if (e.length == 1) {
          return " ";
        }
        return e;
      });
    }
    var d_ = ["figcaption", "li"];
    function u_(t) {
      var e = "";
      if (t.is("$text") || t.is("$textProxy")) {
        e = t.data;
      } else if (t.is("element", "img") && t.hasAttribute("alt")) {
        e = t.getAttribute("alt");
      } else if (t.is("element", "br")) {
        e = "\n";
      } else {
        var _n194 = null;
        var _iterator302 = _createForOfIteratorHelper(t.getChildren()),
          _step302;
        try {
          for (_iterator302.s(); !(_step302 = _iterator302.n()).done;) {
            var _o125 = _step302.value;
            var _t244 = u_(_o125);
            if (_n194 && (_n194.is("containerElement") || _o125.is("containerElement"))) {
              if (d_.includes(_n194.name) || d_.includes(_o125.name)) {
                e += "\n";
              } else {
                e += "\n\n";
              }
            }
            e += _t244;
            _n194 = _o125;
          }
        } catch (err) {
          _iterator302.e(err);
        } finally {
          _iterator302.f();
        }
      }
      return e;
    }
    var h_ = /*#__PURE__*/function (_aC13) {
      _inherits(h_, _aC13);
      function h_() {
        _classCallCheck(this, h_);
        return _possibleConstructorReturn(this, _getPrototypeOf(h_).apply(this, arguments));
      }
      _createClass(h_, [{
        key: "init",
        value: function init() {
          var _this149 = this;
          var t = this.editor;
          var e = t.model.document;
          var n = t.editing.view;
          var o = n.document;
          this._htmlDataProcessor = new Zp(o);
          n.addObserver(r_);
          this.listenTo(o, "clipboardInput", function (e) {
            if (t.isReadOnly) {
              e.stop();
            }
          }, {
            priority: "highest"
          });
          this.listenTo(o, "clipboardInput", function (t, e) {
            var o = e.dataTransfer;
            var i = "";
            if (o.getData("text/html")) {
              i = l_(o.getData("text/html"));
            } else if (o.getData("text/plain")) {
              i = c_(o.getData("text/plain"));
            }
            i = _this149._htmlDataProcessor.toView(i);
            var r = new ts(_this149, "inputTransformation");
            _this149.fire(r, {
              content: i,
              dataTransfer: o,
              asPlainText: e.asPlainText
            });
            if (r.stop.called) {
              t.stop();
            }
            n.scrollToTheSelection();
          }, {
            priority: "low"
          });
          this.listenTo(this, "inputTransformation", function (t, e) {
            if (!e.content.isEmpty) {
              var _n195 = _this149.editor.data;
              var _o126 = _this149.editor.model;
              var _i108 = _n195.toModel(e.content, "$clipboardHolder");
              if (_i108.childCount == 0) {
                return;
              }
              _o126.change(function (t) {
                var n = _o126.document.selection;
                if (e.asPlainText || f_(_i108, _o126.schema)) {
                  var _e222 = Array.from(n.getAttributes()).filter(function (_ref31) {
                    var _ref32 = _slicedToArray(_ref31, 1),
                      t = _ref32[0];
                    return _o126.schema.getAttributeProperties(t).isFormatting;
                  });
                  if (!n.isCollapsed) {
                    _o126.deleteContent(n, {
                      doNotAutoparagraph: true
                    });
                  }
                  _e222.push.apply(_e222, _toConsumableArray(n.getAttributes()));
                  var _r37 = t.createRangeIn(_i108);
                  var _iterator303 = _createForOfIteratorHelper(_r37.getItems()),
                    _step303;
                  try {
                    for (_iterator303.s(); !(_step303 = _iterator303.n()).done;) {
                      var _n196 = _step303.value;
                      if (_n196.is("$text") || _n196.is("$textProxy")) {
                        t.setAttributes(_e222, _n196);
                      }
                    }
                  } catch (err) {
                    _iterator303.e(err);
                  } finally {
                    _iterator303.f();
                  }
                }
                _o126.insertContent(_i108);
              });
              t.stop();
            }
          }, {
            priority: "low"
          });
          function i(n, i) {
            var r = i.dataTransfer;
            i.preventDefault();
            var s = t.data.toView(t.model.getSelectedContent(e.selection));
            o.fire("clipboardOutput", {
              dataTransfer: r,
              content: s,
              method: n.name
            });
          }
          this.listenTo(o, "copy", i, {
            priority: "low"
          });
          this.listenTo(o, "cut", function (e, n) {
            if (t.isReadOnly) {
              n.preventDefault();
            } else {
              i(e, n);
            }
          }, {
            priority: "low"
          });
          this.listenTo(o, "clipboardOutput", function (n, o) {
            if (!o.content.isEmpty) {
              o.dataTransfer.setData("text/html", _this149._htmlDataProcessor.toData(o.content));
              o.dataTransfer.setData("text/plain", u_(o.content));
            }
            if (o.method == "cut") {
              t.model.deleteContent(e.selection);
            }
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Clipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [a_];
        }
      }]);
      return h_;
    }(aC);
    function f_(t, e) {
      if (t.childCount > 1) {
        return false;
      }
      var n = t.getChild(0);
      if (e.isObject(n)) {
        return false;
      }
      return _toConsumableArray(n.getAttributeKeys()).length == 0;
    }
    var m_ = /*#__PURE__*/function () {
      function m_() {
        _classCallCheck(this, m_);
        this._definitions = new Set();
      }
      _createClass(m_, [{
        key: "add",
        value: function add(t) {
          var _this150 = this;
          if (Array.isArray(t)) {
            t.forEach(function (t) {
              return _this150._definitions.add(t);
            });
          } else {
            this._definitions.add(t);
          }
        }
      }, {
        key: "getDispatcher",
        value: function getDispatcher() {
          var _this151 = this;
          return function (t) {
            t.on("attribute:linkHref", function (t, e, n) {
              if (!n.consumable.test(e.item, "attribute:linkHref")) {
                return;
              }
              var o = n.writer;
              var i = o.document.selection;
              var _iterator304 = _createForOfIteratorHelper(_this151._definitions),
                _step304;
              try {
                for (_iterator304.s(); !(_step304 = _iterator304.n()).done;) {
                  var _t245 = _step304.value;
                  var _r38 = o.createAttributeElement("a", _t245.attributes, {
                    priority: 5
                  });
                  o.setCustomProperty("link", true, _r38);
                  if (_t245.callback(e.attributeNewValue)) {
                    if (e.item.is("selection")) {
                      o.wrap(i.getFirstRange(), _r38);
                    } else {
                      o.wrap(n.mapper.toViewRange(e.range), _r38);
                    }
                  } else {
                    o.unwrap(n.mapper.toViewRange(e.range), _r38);
                  }
                }
              } catch (err) {
                _iterator304.e(err);
              } finally {
                _iterator304.f();
              }
            }, {
              priority: "high"
            });
          };
        }
      }, {
        key: "getDispatcherForLinkedImage",
        value: function getDispatcherForLinkedImage() {
          var _this152 = this;
          return function (t) {
            t.on("attribute:linkHref:image", function (t, e, n) {
              var o = n.mapper.toViewElement(e.item);
              var i = Array.from(o.getChildren()).find(function (t) {
                return t.name === "a";
              });
              var _iterator305 = _createForOfIteratorHelper(_this152._definitions),
                _step305;
              try {
                for (_iterator305.s(); !(_step305 = _iterator305.n()).done;) {
                  var _t246 = _step305.value;
                  var _o127 = Gs(_t246.attributes);
                  if (_t246.callback(e.attributeNewValue)) {
                    var _iterator306 = _createForOfIteratorHelper(_o127),
                      _step306;
                    try {
                      for (_iterator306.s(); !(_step306 = _iterator306.n()).done;) {
                        var _step306$value = _slicedToArray(_step306.value, 2),
                          _t247 = _step306$value[0],
                          _e223 = _step306$value[1];
                        if (_t247 === "class") {
                          n.writer.addClass(_e223, i);
                        } else {
                          n.writer.setAttribute(_t247, _e223, i);
                        }
                      }
                    } catch (err) {
                      _iterator306.e(err);
                    } finally {
                      _iterator306.f();
                    }
                  } else {
                    var _iterator307 = _createForOfIteratorHelper(_o127),
                      _step307;
                    try {
                      for (_iterator307.s(); !(_step307 = _iterator307.n()).done;) {
                        var _step307$value = _slicedToArray(_step307.value, 2),
                          _t248 = _step307$value[0],
                          _e224 = _step307$value[1];
                        if (_t248 === "class") {
                          n.writer.removeClass(_e224, i);
                        } else {
                          n.writer.removeAttribute(_t248, i);
                        }
                      }
                    } catch (err) {
                      _iterator307.e(err);
                    } finally {
                      _iterator307.f();
                    }
                  }
                }
              } catch (err) {
                _iterator305.e(err);
              } finally {
                _iterator305.f();
              }
            });
          };
        }
      }, {
        key: "length",
        get: function get() {
          return this._definitions.size;
        }
      }]);
      return m_;
    }();
    function g_(t, e, n) {
      var o = t.length;
      n = n === undefined ? o : n;
      return !e && n >= o ? t : Pa(t, e, n);
    }
    var p_ = g_;
    var k_ = "\\ud800-\\udfff",
      b_ = "\\u0300-\\u036f",
      w_ = "\\ufe20-\\ufe2f",
      C_ = "\\u20d0-\\u20ff",
      A_ = b_ + w_ + C_,
      __ = "\\ufe0e\\ufe0f";
    var v_ = "\\u200d";
    var y_ = RegExp("[" + v_ + k_ + A_ + __ + "]");
    function x_(t) {
      return y_.test(t);
    }
    var D_ = x_;
    function E_(t) {
      return t.split("");
    }
    var M_ = E_;
    var S_ = "\\ud800-\\udfff",
      T_ = "\\u0300-\\u036f",
      I_ = "\\ufe20-\\ufe2f",
      N_ = "\\u20d0-\\u20ff",
      P_ = T_ + I_ + N_,
      B_ = "\\ufe0e\\ufe0f";
    var z_ = "[" + S_ + "]",
      L_ = "[" + P_ + "]",
      O_ = "\\ud83c[\\udffb-\\udfff]",
      R_ = "(?:" + L_ + "|" + O_ + ")",
      j_ = "[^" + S_ + "]",
      F_ = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      V_ = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      U_ = "\\u200d";
    var H_ = R_ + "?",
      G_ = "[" + B_ + "]?",
      W_ = "(?:" + U_ + "(?:" + [j_, F_, V_].join("|") + ")" + G_ + H_ + ")*",
      K_ = G_ + H_ + W_,
      q_ = "(?:" + [j_ + L_ + "?", L_, F_, V_, z_].join("|") + ")";
    var Y_ = RegExp(O_ + "(?=" + O_ + ")|" + q_ + K_, "g");
    function Q_(t) {
      return t.match(Y_) || [];
    }
    var $_ = Q_;
    function Z_(t) {
      return D_(t) ? $_(t) : M_(t);
    }
    var J_ = Z_;
    function X_(t) {
      return function (e) {
        e = _a(e);
        var n = D_(e) ? J_(e) : undefined;
        var o = n ? n[0] : e.charAt(0);
        var i = n ? p_(n, 1).join("") : e.slice(1);
        return o[t]() + i;
      };
    }
    var tv = X_;
    var ev = tv("toUpperCase");
    var nv = ev;
    var ov = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
    var iv = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
    var rv = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i;
    var sv = /^((\w+:(\/{2,})?)|(\W))/i;
    var av = "Ctrl+K";
    function cv(t) {
      return t.is("attributeElement") && !!t.getCustomProperty("link");
    }
    function lv(t, _ref33) {
      var e = _ref33.writer;
      var n = e.createAttributeElement("a", {
        href: t
      }, {
        priority: 5
      });
      e.setCustomProperty("link", true, n);
      return n;
    }
    function dv(t) {
      t = String(t);
      return uv(t) ? t : "#";
    }
    function uv(t) {
      var e = t.replace(ov, "");
      return e.match(iv);
    }
    function hv(t, e) {
      var n = {
        "Open in a new tab": t("Open in a new tab"),
        Downloadable: t("Downloadable")
      };
      e.forEach(function (t) {
        if (t.label && n[t.label]) {
          t.label = n[t.label];
        }
        return t;
      });
      return e;
    }
    function fv(t) {
      var e = [];
      if (t) {
        for (var _i109 = 0, _Object$entries2 = Object.entries(t); _i109 < _Object$entries2.length; _i109++) {
          var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i109], 2),
            _n197 = _Object$entries2$_i[0],
            _o128 = _Object$entries2$_i[1];
          var _t249 = Object.assign({}, _o128, {
            id: "link".concat(nv(_n197))
          });
          e.push(_t249);
        }
      }
      return e;
    }
    function mv(t, e) {
      if (!t) {
        return false;
      }
      return t.is("element", "image") && e.checkAttribute("image", "linkHref");
    }
    function gv(t) {
      return rv.test(t);
    }
    function pv(t, e) {
      var n = gv(t) ? "mailto:" : e;
      var o = !!n && !sv.test(t);
      return t && o ? n + t : t;
    }
    var kv = /*#__PURE__*/function (_uC5) {
      _inherits(kv, _uC5);
      function kv(t) {
        var _this153;
        _classCallCheck(this, kv);
        _this153 = _possibleConstructorReturn(this, _getPrototypeOf(kv).call(this, t));
        _this153.manualDecorators = new vs();
        _this153.automaticDecorators = new m_();
        return _this153;
      }
      _createClass(kv, [{
        key: "restoreManualDecoratorStates",
        value: function restoreManualDecoratorStates() {
          var _iterator308 = _createForOfIteratorHelper(this.manualDecorators),
            _step308;
          try {
            for (_iterator308.s(); !(_step308 = _iterator308.n()).done;) {
              var _t250 = _step308.value;
              _t250.value = this._getDecoratorStateFromModel(_t250.id);
            }
          } catch (err) {
            _iterator308.e(err);
          } finally {
            _iterator308.f();
          }
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document;
          var n = nC(e.selection.getSelectedBlocks());
          if (mv(n, t.schema)) {
            this.value = n.getAttribute("linkHref");
            this.isEnabled = t.schema.checkAttribute(n, "linkHref");
          } else {
            this.value = e.selection.getAttribute("linkHref");
            this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
          }
          var _iterator309 = _createForOfIteratorHelper(this.manualDecorators),
            _step309;
          try {
            for (_iterator309.s(); !(_step309 = _iterator309.n()).done;) {
              var _t251 = _step309.value;
              _t251.value = this._getDecoratorStateFromModel(_t251.id);
            }
          } catch (err) {
            _iterator309.e(err);
          } finally {
            _iterator309.f();
          }
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this154 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model;
          var o = n.document.selection;
          var i = [];
          var r = [];
          for (var _t252 in e) {
            if (e[_t252]) {
              i.push(_t252);
            } else {
              r.push(_t252);
            }
          }
          n.change(function (e) {
            if (o.isCollapsed) {
              var _s26 = o.getFirstPosition();
              if (o.hasAttribute("linkHref")) {
                var _a17 = jA(_s26, "linkHref", o.getAttribute("linkHref"), n);
                e.setAttribute("linkHref", t, _a17);
                i.forEach(function (t) {
                  e.setAttribute(t, true, _a17);
                });
                r.forEach(function (t) {
                  e.removeAttribute(t, _a17);
                });
                e.setSelection(e.createPositionAfter(_a17.end.nodeBefore));
              } else if (t !== "") {
                var _r39 = Gs(o.getAttributes());
                _r39.set("linkHref", t);
                i.forEach(function (t) {
                  _r39.set(t, true);
                });
                var _n$insertContent = n.insertContent(e.createText(t, _r39), _s26),
                  _a18 = _n$insertContent.end;
                e.setSelection(_a18);
              }
              ["linkHref"].concat(i, r).forEach(function (t) {
                e.removeSelectionAttribute(t);
              });
            } else {
              var _s27 = n.schema.getValidRanges(o.getRanges(), "linkHref");
              var _a19 = [];
              var _iterator310 = _createForOfIteratorHelper(o.getSelectedBlocks()),
                _step310;
              try {
                for (_iterator310.s(); !(_step310 = _iterator310.n()).done;) {
                  var _t253 = _step310.value;
                  if (n.schema.checkAttribute(_t253, "linkHref")) {
                    _a19.push(e.createRangeOn(_t253));
                  }
                }
              } catch (err) {
                _iterator310.e(err);
              } finally {
                _iterator310.f();
              }
              var _c10 = _a19.slice();
              var _iterator311 = _createForOfIteratorHelper(_s27),
                _step311;
              try {
                for (_iterator311.s(); !(_step311 = _iterator311.n()).done;) {
                  var _t254 = _step311.value;
                  if (_this154._isRangeToUpdate(_t254, _a19)) {
                    _c10.push(_t254);
                  }
                }
              } catch (err) {
                _iterator311.e(err);
              } finally {
                _iterator311.f();
              }
              var _iterator312 = _createForOfIteratorHelper(_c10),
                _step312;
              try {
                var _loop6 = function _loop6() {
                  var n = _step312.value;
                  e.setAttribute("linkHref", t, n);
                  i.forEach(function (t) {
                    e.setAttribute(t, true, n);
                  });
                  r.forEach(function (t) {
                    e.removeAttribute(t, n);
                  });
                };
                for (_iterator312.s(); !(_step312 = _iterator312.n()).done;) {
                  _loop6();
                }
              } catch (err) {
                _iterator312.e(err);
              } finally {
                _iterator312.f();
              }
            }
          });
        }
      }, {
        key: "_getDecoratorStateFromModel",
        value: function _getDecoratorStateFromModel(t) {
          var e = this.editor.model;
          var n = e.document;
          var o = nC(n.selection.getSelectedBlocks());
          if (mv(o, e.schema)) {
            return o.getAttribute(t);
          }
          return n.selection.getAttribute(t);
        }
      }, {
        key: "_isRangeToUpdate",
        value: function _isRangeToUpdate(t, e) {
          var _iterator313 = _createForOfIteratorHelper(e),
            _step313;
          try {
            for (_iterator313.s(); !(_step313 = _iterator313.n()).done;) {
              var _n198 = _step313.value;
              if (_n198.containsRange(t)) {
                return false;
              }
            }
          } catch (err) {
            _iterator313.e(err);
          } finally {
            _iterator313.f();
          }
          return true;
        }
      }]);
      return kv;
    }(uC);
    var bv = /*#__PURE__*/function (_uC6) {
      _inherits(bv, _uC6);
      function bv() {
        _classCallCheck(this, bv);
        return _possibleConstructorReturn(this, _getPrototypeOf(bv).apply(this, arguments));
      }
      _createClass(bv, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document;
          var n = nC(e.selection.getSelectedBlocks());
          if (mv(n, t.schema)) {
            this.isEnabled = t.schema.checkAttribute(n, "linkHref");
          } else {
            this.isEnabled = t.schema.checkAttributeInSelection(e.selection, "linkHref");
          }
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor;
          var e = this.editor.model;
          var n = e.document.selection;
          var o = t.commands.get("link");
          e.change(function (t) {
            var i = n.isCollapsed ? [jA(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)] : e.schema.getValidRanges(n.getRanges(), "linkHref");
            var _iterator314 = _createForOfIteratorHelper(i),
              _step314;
            try {
              for (_iterator314.s(); !(_step314 = _iterator314.n()).done;) {
                var _e225 = _step314.value;
                t.removeAttribute("linkHref", _e225);
                if (o) {
                  var _iterator315 = _createForOfIteratorHelper(o.manualDecorators),
                    _step315;
                  try {
                    for (_iterator315.s(); !(_step315 = _iterator315.n()).done;) {
                      var _n199 = _step315.value;
                      t.removeAttribute(_n199.id, _e225);
                    }
                  } catch (err) {
                    _iterator315.e(err);
                  } finally {
                    _iterator315.f();
                  }
                }
              }
            } catch (err) {
              _iterator314.e(err);
            } finally {
              _iterator314.f();
            }
          });
        }
      }]);
      return bv;
    }(uC);
    var wv = function wv(_ref34) {
      var t = _ref34.id,
        e = _ref34.label,
        n = _ref34.attributes,
        o = _ref34.defaultValue;
      _classCallCheck(this, wv);
      this.id = t;
      this.set("value");
      this.defaultValue = o;
      this.label = e;
      this.attributes = n;
    };
    _s(wv, Zc);
    var Cv = n(29);
    var Av = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Av.insert = "head";
    Av.singleton = true;
    var _v = rk()(Cv["a"], Av);
    var vv = Cv["a"].locals || {};
    var yv = "ck-link_selected";
    var xv = "automatic";
    var Dv = "manual";
    var Ev = /^(https?:)?\/\//;
    var Mv = /*#__PURE__*/function (_aC14) {
      _inherits(Mv, _aC14);
      _createClass(Mv, null, [{
        key: "pluginName",
        get: function get() {
          return "LinkEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [PA, n_, h_];
        }
      }]);
      function Mv(t) {
        var _this155;
        _classCallCheck(this, Mv);
        _this155 = _possibleConstructorReturn(this, _getPrototypeOf(Mv).call(this, t));
        t.config.define("link", {
          addTargetToExternalLinks: false
        });
        return _this155;
      }
      _createClass(Mv, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: "linkHref"
          });
          t.conversion.for("dataDowncast").attributeToElement({
            model: "linkHref",
            view: lv
          });
          t.conversion.for("editingDowncast").attributeToElement({
            model: "linkHref",
            view: function view(t, e) {
              return lv(dv(t), e);
            }
          });
          t.conversion.for("upcast").elementToAttribute({
            view: {
              name: "a",
              attributes: {
                href: true
              }
            },
            model: {
              key: "linkHref",
              value: function value(t) {
                return t.getAttribute("href");
              }
            }
          });
          t.commands.add("link", new kv(t));
          t.commands.add("unlink", new bv(t));
          var e = hv(t.t, fv(t.config.get("link.decorators")));
          this._enableAutomaticDecorators(e.filter(function (t) {
            return t.mode === xv;
          }));
          this._enableManualDecorators(e.filter(function (t) {
            return t.mode === Dv;
          }));
          var n = t.plugins.get(PA);
          n.registerAttribute("linkHref");
          VA(t, "linkHref", "a", yv);
          this._enableInsertContentSelectionAttributesFixer();
          this._enableClickingAfterLink();
          this._enableTypingOverLink();
          this._handleDeleteContentAfterLink();
        }
      }, {
        key: "_enableAutomaticDecorators",
        value: function _enableAutomaticDecorators(t) {
          var e = this.editor;
          var n = e.commands.get("link");
          var o = n.automaticDecorators;
          if (e.config.get("link.addTargetToExternalLinks")) {
            o.add({
              id: "linkIsExternal",
              mode: xv,
              callback: function callback(t) {
                return Ev.test(t);
              },
              attributes: {
                target: "_blank",
                rel: "noopener noreferrer"
              }
            });
          }
          o.add(t);
          if (o.length) {
            e.conversion.for("downcast").add(o.getDispatcher());
          }
        }
      }, {
        key: "_enableManualDecorators",
        value: function _enableManualDecorators(t) {
          if (!t.length) {
            return;
          }
          var e = this.editor;
          var n = e.commands.get("link");
          var o = n.manualDecorators;
          t.forEach(function (t) {
            e.model.schema.extend("$text", {
              allowAttributes: t.id
            });
            o.add(new wv(t));
            e.conversion.for("downcast").attributeToElement({
              model: t.id,
              view: function view(e, _ref35) {
                var n = _ref35.writer;
                if (e) {
                  var _e226 = o.get(t.id).attributes;
                  var _i110 = n.createAttributeElement("a", _e226, {
                    priority: 5
                  });
                  n.setCustomProperty("link", true, _i110);
                  return _i110;
                }
              }
            });
            e.conversion.for("upcast").elementToAttribute({
              view: {
                name: "a",
                attributes: o.get(t.id).attributes
              },
              model: {
                key: t.id
              }
            });
          });
        }
      }, {
        key: "_enableInsertContentSelectionAttributesFixer",
        value: function _enableInsertContentSelectionAttributesFixer() {
          var t = this.editor;
          var e = t.model;
          var n = e.document.selection;
          var o = t.commands.get("link");
          this.listenTo(e, "insertContent", function () {
            var t = n.anchor.nodeBefore;
            var i = n.anchor.nodeAfter;
            if (!n.hasAttribute("linkHref")) {
              return;
            }
            if (!t) {
              return;
            }
            if (!t.hasAttribute("linkHref")) {
              return;
            }
            if (i && i.hasAttribute("linkHref")) {
              return;
            }
            e.change(function (t) {
              Sv(t, o.manualDecorators);
            });
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableClickingAfterLink",
        value: function _enableClickingAfterLink() {
          var t = this.editor;
          var e = t.commands.get("link");
          t.editing.view.addObserver(NA);
          var n = false;
          this.listenTo(t.editing.view.document, "mousedown", function () {
            n = true;
          });
          this.listenTo(t.editing.view.document, "selectionChange", function () {
            if (!n) {
              return;
            }
            n = false;
            var o = t.model.document.selection;
            if (!o.isCollapsed) {
              return;
            }
            if (!o.hasAttribute("linkHref")) {
              return;
            }
            var i = o.getFirstPosition();
            var r = jA(i, "linkHref", o.getAttribute("linkHref"), t.model);
            if (i.isTouching(r.start) || i.isTouching(r.end)) {
              t.model.change(function (t) {
                Sv(t, e.manualDecorators);
              });
            }
          });
        }
      }, {
        key: "_enableTypingOverLink",
        value: function _enableTypingOverLink() {
          var t = this.editor;
          var e = t.editing.view;
          var n;
          var o;
          this.listenTo(e.document, "delete", function () {
            o = true;
          }, {
            priority: "high"
          });
          this.listenTo(t.model, "deleteContent", function () {
            var e = t.model.document.selection;
            if (e.isCollapsed) {
              return;
            }
            if (o) {
              o = false;
              return;
            }
            if (!Iv(t)) {
              return;
            }
            if (Tv(t.model)) {
              n = e.getAttributes();
            }
          }, {
            priority: "high"
          });
          this.listenTo(t.model, "insertContent", function (e, _ref36) {
            var _ref37 = _slicedToArray(_ref36, 1),
              i = _ref37[0];
            o = false;
            if (!Iv(t)) {
              return;
            }
            if (!n) {
              return;
            }
            t.model.change(function (t) {
              var _iterator316 = _createForOfIteratorHelper(n),
                _step316;
              try {
                for (_iterator316.s(); !(_step316 = _iterator316.n()).done;) {
                  var _step316$value = _slicedToArray(_step316.value, 2),
                    _e227 = _step316$value[0],
                    _o129 = _step316$value[1];
                  t.setAttribute(_e227, _o129, i);
                }
              } catch (err) {
                _iterator316.e(err);
              } finally {
                _iterator316.f();
              }
            });
            n = null;
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_handleDeleteContentAfterLink",
        value: function _handleDeleteContentAfterLink() {
          var t = this.editor;
          var e = t.model;
          var n = e.document.selection;
          var o = t.editing.view;
          var i = t.commands.get("link");
          var r = false;
          var s = false;
          this.listenTo(o.document, "delete", function (t, e) {
            s = e.domEvent.keyCode === Ll.backspace;
          }, {
            priority: "high"
          });
          this.listenTo(e, "deleteContent", function () {
            r = false;
            var t = n.getFirstPosition();
            var o = n.getAttribute("linkHref");
            if (!o) {
              return;
            }
            var i = jA(t, "linkHref", o, e);
            r = i.containsPosition(t) || i.end.isEqual(t);
          }, {
            priority: "high"
          });
          this.listenTo(e, "deleteContent", function () {
            if (!s) {
              return;
            }
            s = false;
            if (r) {
              return;
            }
            t.model.enqueueChange(function (t) {
              Sv(t, i.manualDecorators);
            });
          }, {
            priority: "low"
          });
        }
      }]);
      return Mv;
    }(aC);
    function Sv(t, e) {
      t.removeSelectionAttribute("linkHref");
      var _iterator317 = _createForOfIteratorHelper(e),
        _step317;
      try {
        for (_iterator317.s(); !(_step317 = _iterator317.n()).done;) {
          var _n200 = _step317.value;
          t.removeSelectionAttribute(_n200.id);
        }
      } catch (err) {
        _iterator317.e(err);
      } finally {
        _iterator317.f();
      }
    }
    function Tv(t) {
      var e = t.document.selection;
      var n = e.getFirstPosition();
      var o = e.getLastPosition();
      var i = n.nodeAfter;
      if (!i) {
        return false;
      }
      if (!i.is("$text")) {
        return false;
      }
      if (!i.hasAttribute("linkHref")) {
        return false;
      }
      var r = o.textNode || o.nodeBefore;
      if (i === r) {
        return true;
      }
      var s = jA(n, "linkHref", i.getAttribute("linkHref"), t);
      return s.containsRange(t.createRange(n, o), true);
    }
    function Iv(t) {
      var e = t.plugins.get("Input");
      return e.isInput(t.model.change(function (t) {
        return t.batch;
      }));
    }
    var Nv = /*#__PURE__*/function () {
      function Nv(t) {
        _classCallCheck(this, Nv);
        this.context = t;
      }
      _createClass(Nv, [{
        key: "destroy",
        value: function destroy() {
          this.stopListening();
        }
      }], [{
        key: "isContextPlugin",
        get: function get() {
          return true;
        }
      }]);
      return Nv;
    }();
    _s(Nv, Zc);
    var Pv = /*#__PURE__*/function (_Nv) {
      _inherits(Pv, _Nv);
      function Pv() {
        _classCallCheck(this, Pv);
        return _possibleConstructorReturn(this, _getPrototypeOf(Pv).apply(this, arguments));
      }
      _createClass(Pv, [{
        key: "init",
        value: function init() {
          this.on("show:warning", function (t, e) {
            window.alert(e.message);
          }, {
            priority: "lowest"
          });
        }
      }, {
        key: "showSuccess",
        value: function showSuccess(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "success",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showInfo",
        value: function showInfo(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "info",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "showWarning",
        value: function showWarning(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          this._showNotification({
            message: t,
            type: "warning",
            namespace: e.namespace,
            title: e.title
          });
        }
      }, {
        key: "_showNotification",
        value: function _showNotification(t) {
          var e = "show:".concat(t.type) + (t.namespace ? ":".concat(t.namespace) : "");
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ""
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Notification";
        }
      }]);
      return Pv;
    }(Nv);
    var Bv = /*#__PURE__*/function (_uC7) {
      _inherits(Bv, _uC7);
      function Bv(t) {
        var _this156;
        _classCallCheck(this, Bv);
        _this156 = _possibleConstructorReturn(this, _getPrototypeOf(Bv).call(this, t));
        _this156.stopListening(_this156.editor.model.document, "change");
        _this156.listenTo(_this156.editor.model.document, "change", function () {
          return _this156.refresh();
        }, {
          priority: "low"
        });
        return _this156;
      }
      _createClass(Bv, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.commands.get("imageInsert");
          var e = this.editor.commands.get("link");
          this.isEnabled = t.isEnabled || e.isEnabled;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor;
          var e = this.editor.config.get("ckfinder.openerMethod") || "modal";
          if (e != "popup" && e != "modal") {
            throw new ss["a"]("ckfinder-unknown-openermethod", t);
          }
          var n = this.editor.config.get("ckfinder.options") || {};
          n.chooseFiles = true;
          var o = n.onInit;
          if (!n.language) {
            n.language = t.locale.uiLanguage;
          }
          n.onInit = function (e) {
            if (o) {
              o(e);
            }
            e.on("files:choose", function (n) {
              var o = n.data.files.toArray();
              var i = o.filter(function (t) {
                return !t.isImage();
              });
              var r = o.filter(function (t) {
                return t.isImage();
              });
              var _iterator318 = _createForOfIteratorHelper(i),
                _step318;
              try {
                for (_iterator318.s(); !(_step318 = _iterator318.n()).done;) {
                  var _e228 = _step318.value;
                  t.execute("link", _e228.getUrl());
                }
              } catch (err) {
                _iterator318.e(err);
              } finally {
                _iterator318.f();
              }
              var s = [];
              var _iterator319 = _createForOfIteratorHelper(r),
                _step319;
              try {
                for (_iterator319.s(); !(_step319 = _iterator319.n()).done;) {
                  var _t255 = _step319.value;
                  var _n201 = _t255.getUrl();
                  s.push(_n201 ? _n201 : e.request("file:getProxyUrl", {
                    file: _t255
                  }));
                }
              } catch (err) {
                _iterator319.e(err);
              } finally {
                _iterator319.f();
              }
              if (s.length) {
                zv(t, s);
              }
            });
            e.on("file:choose:resizedImage", function (e) {
              var n = e.data.resizedUrl;
              if (!n) {
                var _e229 = t.plugins.get("Notification");
                var _n202 = t.locale.t;
                _e229.showWarning(_n202("Could not obtain resized image URL."), {
                  title: _n202("Selecting resized image failed"),
                  namespace: "ckfinder"
                });
                return;
              }
              zv(t, [n]);
            });
          };
          window.CKFinder[e](n);
        }
      }]);
      return Bv;
    }(uC);
    function zv(t, e) {
      var n = t.commands.get("imageInsert");
      if (!n.isEnabled) {
        var _e230 = t.plugins.get("Notification");
        var _n203 = t.locale.t;
        _e230.showWarning(_n203("Could not insert image at the current position."), {
          title: _n203("Inserting image failed"),
          namespace: "ckfinder"
        });
        return;
      }
      t.execute("imageInsert", {
        source: e
      });
    }
    var Lv = /*#__PURE__*/function (_aC15) {
      _inherits(Lv, _aC15);
      function Lv() {
        _classCallCheck(this, Lv);
        return _possibleConstructorReturn(this, _getPrototypeOf(Lv).apply(this, arguments));
      }
      _createClass(Lv, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("ckfinder", new Bv(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CKFinderEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Pv, TA, Mv];
        }
      }]);
      return Lv;
    }(aC);
    var Ov = /*#__PURE__*/function (_Nv2) {
      _inherits(Ov, _Nv2);
      function Ov() {
        _classCallCheck(this, Ov);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ov).apply(this, arguments));
      }
      _createClass(Ov, [{
        key: "init",
        value: function init() {
          this.set("hasAny", false);
          this._actions = new vs({
            idProperty: "_id"
          });
          this._actions.delegate("add", "remove").to(this);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (typeof t !== "string") {
            throw new ss["a"]("pendingactions-add-invalid-message", this);
          }
          var e = Object.create(Zc);
          e.set("message", t);
          this._actions.add(e);
          this.hasAny = true;
          return e;
        }
      }, {
        key: "remove",
        value: function remove(t) {
          this._actions.remove(t);
          this.hasAny = !!this._actions.length;
        }
      }, {
        key: Symbol.iterator,
        value: function value() {
          return this._actions[Symbol.iterator]();
        }
      }, {
        key: "first",
        get: function get() {
          return this._actions.get(0);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PendingActions";
        }
      }]);
      return Ov;
    }(Nv);
    var Rv = /*#__PURE__*/function () {
      function Rv() {
        var _this157 = this;
        _classCallCheck(this, Rv);
        var t = new window.FileReader();
        this._reader = t;
        this._data = undefined;
        this.set("loaded", 0);
        t.onprogress = function (t) {
          _this157.loaded = t.loaded;
        };
      }
      _createClass(Rv, [{
        key: "read",
        value: function read(t) {
          var _this158 = this;
          var e = this._reader;
          this.total = t.size;
          return new Promise(function (n, o) {
            e.onload = function () {
              var t = e.result;
              _this158._data = t;
              n(t);
            };
            e.onerror = function () {
              o("error");
            };
            e.onabort = function () {
              o("aborted");
            };
            _this158._reader.readAsDataURL(t);
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          this._reader.abort();
        }
      }, {
        key: "error",
        get: function get() {
          return this._reader.error;
        }
      }, {
        key: "data",
        get: function get() {
          return this._data;
        }
      }]);
      return Rv;
    }();
    _s(Rv, Zc);
    var jv = /*#__PURE__*/function (_aC16) {
      _inherits(jv, _aC16);
      function jv() {
        _classCallCheck(this, jv);
        return _possibleConstructorReturn(this, _getPrototypeOf(jv).apply(this, arguments));
      }
      _createClass(jv, [{
        key: "init",
        value: function init() {
          var _this159 = this;
          this.loaders = new vs();
          this.loaders.on("add", function () {
            return _this159._updatePendingAction();
          });
          this.loaders.on("remove", function () {
            return _this159._updatePendingAction();
          });
          this._loadersMap = new Map();
          this._pendingAction = null;
          this.set("uploaded", 0);
          this.set("uploadTotal", null);
          this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
            return e ? t / e * 100 : 0;
          });
        }
      }, {
        key: "getLoader",
        value: function getLoader(t) {
          return this._loadersMap.get(t) || null;
        }
      }, {
        key: "createLoader",
        value: function createLoader(t) {
          var _this160 = this;
          if (!this.createUploadAdapter) {
            Object(ss["c"])("filerepository-no-upload-adapter");
            return null;
          }
          var e = new Fv(Promise.resolve(t), this.createUploadAdapter);
          this.loaders.add(e);
          this._loadersMap.set(t, e);
          if (t instanceof Promise) {
            e.file.then(function (t) {
              _this160._loadersMap.set(t, e);
            }).catch(function () {});
          }
          e.on("change:uploaded", function () {
            var t = 0;
            var _iterator320 = _createForOfIteratorHelper(_this160.loaders),
              _step320;
            try {
              for (_iterator320.s(); !(_step320 = _iterator320.n()).done;) {
                var _e231 = _step320.value;
                t += _e231.uploaded;
              }
            } catch (err) {
              _iterator320.e(err);
            } finally {
              _iterator320.f();
            }
            _this160.uploaded = t;
          });
          e.on("change:uploadTotal", function () {
            var t = 0;
            var _iterator321 = _createForOfIteratorHelper(_this160.loaders),
              _step321;
            try {
              for (_iterator321.s(); !(_step321 = _iterator321.n()).done;) {
                var _e232 = _step321.value;
                if (_e232.uploadTotal) {
                  t += _e232.uploadTotal;
                }
              }
            } catch (err) {
              _iterator321.e(err);
            } finally {
              _iterator321.f();
            }
            _this160.uploadTotal = t;
          });
          return e;
        }
      }, {
        key: "destroyLoader",
        value: function destroyLoader(t) {
          var _this161 = this;
          var e = t instanceof Fv ? t : this.getLoader(t);
          e._destroy();
          this.loaders.remove(e);
          this._loadersMap.forEach(function (t, n) {
            if (t === e) {
              _this161._loadersMap.delete(n);
            }
          });
        }
      }, {
        key: "_updatePendingAction",
        value: function _updatePendingAction() {
          var t = this.editor.plugins.get(Ov);
          if (this.loaders.length) {
            if (!this._pendingAction) {
              var _e233 = this.editor.t;
              var _n204 = function _n204(t) {
                return "".concat(_e233("Upload in progress"), " ").concat(parseInt(t), "%.");
              };
              this._pendingAction = t.add(_n204(this.uploadedPercent));
              this._pendingAction.bind("message").to(this, "uploadedPercent", _n204);
            }
          } else {
            t.remove(this._pendingAction);
            this._pendingAction = null;
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "FileRepository";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Ov];
        }
      }]);
      return jv;
    }(aC);
    _s(jv, Zc);
    var Fv = /*#__PURE__*/function () {
      function Fv(t, e) {
        _classCallCheck(this, Fv);
        this.id = ns();
        this._filePromiseWrapper = this._createFilePromiseWrapper(t);
        this._adapter = e(this);
        this._reader = new Rv();
        this.set("status", "idle");
        this.set("uploaded", 0);
        this.set("uploadTotal", null);
        this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", function (t, e) {
          return e ? t / e * 100 : 0;
        });
        this.set("uploadResponse", null);
      }
      _createClass(Fv, [{
        key: "read",
        value: function read() {
          var _this162 = this;
          if (this.status != "idle") {
            throw new ss["a"]("filerepository-read-wrong-status", this);
          }
          this.status = "reading";
          return this.file.then(function (t) {
            return _this162._reader.read(t);
          }).then(function (t) {
            if (_this162.status !== "reading") {
              throw _this162.status;
            }
            _this162.status = "idle";
            return t;
          }).catch(function (t) {
            if (t === "aborted") {
              _this162.status = "aborted";
              throw "aborted";
            }
            _this162.status = "error";
            throw _this162._reader.error ? _this162._reader.error : t;
          });
        }
      }, {
        key: "upload",
        value: function upload() {
          var _this163 = this;
          if (this.status != "idle") {
            throw new ss["a"]("filerepository-upload-wrong-status", this);
          }
          this.status = "uploading";
          return this.file.then(function () {
            return _this163._adapter.upload();
          }).then(function (t) {
            _this163.uploadResponse = t;
            _this163.status = "idle";
            return t;
          }).catch(function (t) {
            if (_this163.status === "aborted") {
              throw "aborted";
            }
            _this163.status = "error";
            throw t;
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          var t = this.status;
          this.status = "aborted";
          if (!this._filePromiseWrapper.isFulfilled) {
            this._filePromiseWrapper.promise.catch(function () {});
            this._filePromiseWrapper.rejecter("aborted");
          } else if (t == "reading") {
            this._reader.abort();
          } else if (t == "uploading" && this._adapter.abort) {
            this._adapter.abort();
          }
          this._destroy();
        }
      }, {
        key: "_destroy",
        value: function _destroy() {
          this._filePromiseWrapper = undefined;
          this._reader = undefined;
          this._adapter = undefined;
          this.uploadResponse = undefined;
        }
      }, {
        key: "_createFilePromiseWrapper",
        value: function _createFilePromiseWrapper(t) {
          var e = {};
          e.promise = new Promise(function (n, o) {
            e.rejecter = o;
            e.isFulfilled = false;
            t.then(function (t) {
              e.isFulfilled = true;
              n(t);
            }).catch(function (t) {
              e.isFulfilled = true;
              o(t);
            });
          });
          return e;
        }
      }, {
        key: "file",
        get: function get() {
          var _this164 = this;
          if (!this._filePromiseWrapper) {
            return Promise.resolve(null);
          } else {
            return this._filePromiseWrapper.promise.then(function (t) {
              return _this164._filePromiseWrapper ? t : null;
            });
          }
        }
      }, {
        key: "data",
        get: function get() {
          return this._reader.data;
        }
      }]);
      return Fv;
    }();
    _s(Fv, Zc);
    var Vv = "ckCsrfToken";
    var Uv = 40;
    var Hv = "abcdefghijklmnopqrstuvwxyz0123456789";
    function Gv() {
      var t = Wv(Vv);
      if (!t || t.length != Uv) {
        t = qv(Uv);
        Kv(Vv, t);
      }
      return t;
    }
    function Wv(t) {
      t = t.toLowerCase();
      var e = document.cookie.split(";");
      var _iterator322 = _createForOfIteratorHelper(e),
        _step322;
      try {
        for (_iterator322.s(); !(_step322 = _iterator322.n()).done;) {
          var _n205 = _step322.value;
          var _e234 = _n205.split("=");
          var _o130 = decodeURIComponent(_e234[0].trim().toLowerCase());
          if (_o130 === t) {
            return decodeURIComponent(_e234[1]);
          }
        }
      } catch (err) {
        _iterator322.e(err);
      } finally {
        _iterator322.f();
      }
      return null;
    }
    function Kv(t, e) {
      document.cookie = encodeURIComponent(t) + "=" + encodeURIComponent(e) + ";path=/";
    }
    function qv(t) {
      var e = "";
      var n = new Uint8Array(t);
      window.crypto.getRandomValues(n);
      for (var _t256 = 0; _t256 < n.length; _t256++) {
        var _o131 = Hv.charAt(n[_t256] % Hv.length);
        e += Math.random() > .5 ? _o131.toUpperCase() : _o131;
      }
      return e;
    }
    var Yv = /*#__PURE__*/function (_aC17) {
      _inherits(Yv, _aC17);
      function Yv() {
        _classCallCheck(this, Yv);
        return _possibleConstructorReturn(this, _getPrototypeOf(Yv).apply(this, arguments));
      }
      _createClass(Yv, [{
        key: "init",
        value: function init() {
          var _this165 = this;
          var t = this.editor.config.get("ckfinder.uploadUrl");
          if (!t) {
            return;
          }
          this.editor.plugins.get(jv).createUploadAdapter = function (e) {
            return new Qv(e, t, _this165.editor.t);
          };
        }
      }], [{
        key: "requires",
        get: function get() {
          return [jv];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CKFinderUploadAdapter";
        }
      }]);
      return Yv;
    }(aC);
    var Qv = /*#__PURE__*/function () {
      function Qv(t, e, n) {
        _classCallCheck(this, Qv);
        this.loader = t;
        this.url = e;
        this.t = n;
      }
      _createClass(Qv, [{
        key: "upload",
        value: function upload() {
          var _this166 = this;
          return this.loader.file.then(function (t) {
            return new Promise(function (e, n) {
              _this166._initRequest();
              _this166._initListeners(e, n, t);
              _this166._sendRequest(t);
            });
          });
        }
      }, {
        key: "abort",
        value: function abort() {
          if (this.xhr) {
            this.xhr.abort();
          }
        }
      }, {
        key: "_initRequest",
        value: function _initRequest() {
          var t = this.xhr = new XMLHttpRequest();
          t.open("POST", this.url, true);
          t.responseType = "json";
        }
      }, {
        key: "_initListeners",
        value: function _initListeners(t, e, n) {
          var o = this.xhr;
          var i = this.loader;
          var r = this.t;
          var s = r("Cannot upload file:") + " ".concat(n.name, ".");
          o.addEventListener("error", function () {
            return e(s);
          });
          o.addEventListener("abort", function () {
            return e();
          });
          o.addEventListener("load", function () {
            var n = o.response;
            if (!n || !n.uploaded) {
              return e(n && n.error && n.error.message ? n.error.message : s);
            }
            t({
              default: n.url
            });
          });
          if (o.upload) {
            o.upload.addEventListener("progress", function (t) {
              if (t.lengthComputable) {
                i.uploadTotal = t.total;
                i.uploaded = t.loaded;
              }
            });
          }
        }
      }, {
        key: "_sendRequest",
        value: function _sendRequest(t) {
          var e = new FormData();
          e.append("upload", t);
          e.append("ckCsrfToken", Gv());
          this.xhr.send(e);
        }
      }]);
      return Qv;
    }();
    var $v = /*#__PURE__*/function (_aC18) {
      _inherits($v, _aC18);
      function $v() {
        _classCallCheck(this, $v);
        return _possibleConstructorReturn(this, _getPrototypeOf($v).apply(this, arguments));
      }
      _createClass($v, null, [{
        key: "pluginName",
        get: function get() {
          return "CKFinder";
        }
      }, {
        key: "requires",
        get: function get() {
          return [Lv, PC, Yv];
        }
      }]);
      return $v;
    }(aC);
    function Zv(t, e) {
      var _iterator323, _step323, _n206;
      return _regeneratorRuntime().wrap(function Zv$(_context37) {
        while (1) switch (_context37.prev = _context37.next) {
          case 0:
            _iterator323 = _createForOfIteratorHelper(e);
            _context37.prev = 1;
            _iterator323.s();
          case 3:
            if ((_step323 = _iterator323.n()).done) {
              _context37.next = 10;
              break;
            }
            _n206 = _step323.value;
            if (!(_n206 && t.getAttributeProperties(_n206[0]).copyOnEnter)) {
              _context37.next = 8;
              break;
            }
            _context37.next = 8;
            return _n206;
          case 8:
            _context37.next = 3;
            break;
          case 10:
            _context37.next = 15;
            break;
          case 12:
            _context37.prev = 12;
            _context37.t0 = _context37["catch"](1);
            _iterator323.e(_context37.t0);
          case 15:
            _context37.prev = 15;
            _iterator323.f();
            return _context37.finish(15);
          case 18:
          case "end":
            return _context37.stop();
        }
      }, _marked6, null, [[1, 12, 15, 18]]);
    }
    var Jv = /*#__PURE__*/function (_uC8) {
      _inherits(Jv, _uC8);
      function Jv() {
        _classCallCheck(this, Jv);
        return _possibleConstructorReturn(this, _getPrototypeOf(Jv).apply(this, arguments));
      }
      _createClass(Jv, [{
        key: "execute",
        value: function execute() {
          var _this167 = this;
          var t = this.editor.model;
          var e = t.document;
          t.change(function (n) {
            Xv(_this167.editor.model, n, e.selection, t.schema);
            _this167.fire("afterExecute", {
              writer: n
            });
          });
        }
      }]);
      return Jv;
    }(uC);
    function Xv(t, e, n, o) {
      var i = n.isCollapsed;
      var r = n.getFirstRange();
      var s = r.start.parent;
      var a = r.end.parent;
      if (o.isLimit(s) || o.isLimit(a)) {
        if (!i && s == a) {
          t.deleteContent(n);
        }
        return;
      }
      if (i) {
        var _t257 = Zv(e.model.schema, n.getAttributes());
        ty(e, r.start);
        e.setSelectionAttribute(_t257);
      } else {
        var _o132 = !(r.start.isAtStart && r.end.isAtEnd);
        var _i111 = s == a;
        t.deleteContent(n, {
          leaveUnmerged: _o132
        });
        if (_o132) {
          if (_i111) {
            ty(e, n.focus);
          } else {
            e.setSelection(a, 0);
          }
        }
      }
    }
    function ty(t, e) {
      t.split(e);
      t.setSelection(e.parent.nextSibling, 0);
    }
    var ey = /*#__PURE__*/function (_tu6) {
      _inherits(ey, _tu6);
      function ey(t) {
        var _this168;
        _classCallCheck(this, ey);
        _this168 = _possibleConstructorReturn(this, _getPrototypeOf(ey).call(this, t));
        var e = _this168.document;
        e.on("keydown", function (t, n) {
          if (_this168.isEnabled && n.keyCode == Ll.enter) {
            var _o133;
            e.once("enter", function (t) {
              return _o133 = t;
            }, {
              priority: "highest"
            });
            e.fire("enter", new eh(e, n.domEvent, {
              isSoft: n.shiftKey
            }));
            if (_o133 && _o133.stop.called) {
              t.stop();
            }
          }
        });
        return _this168;
      }
      _createClass(ey, [{
        key: "observe",
        value: function observe() {}
      }]);
      return ey;
    }(tu);
    var ny = /*#__PURE__*/function (_aC19) {
      _inherits(ny, _aC19);
      function ny() {
        _classCallCheck(this, ny);
        return _possibleConstructorReturn(this, _getPrototypeOf(ny).apply(this, arguments));
      }
      _createClass(ny, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.editing.view;
          var n = e.document;
          e.addObserver(ey);
          t.commands.add("enter", new Jv(t));
          this.listenTo(n, "enter", function (n, o) {
            o.preventDefault();
            if (o.isSoft) {
              return;
            }
            t.execute("enter");
            e.scrollToTheSelection();
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Enter";
        }
      }]);
      return ny;
    }(aC);
    var oy = /*#__PURE__*/function (_uC9) {
      _inherits(oy, _uC9);
      function oy() {
        _classCallCheck(this, oy);
        return _possibleConstructorReturn(this, _getPrototypeOf(oy).apply(this, arguments));
      }
      _createClass(oy, [{
        key: "execute",
        value: function execute() {
          var _this169 = this;
          var t = this.editor.model;
          var e = t.document;
          t.change(function (n) {
            ry(t, n, e.selection);
            _this169.fire("afterExecute", {
              writer: n
            });
          });
        }
      }, {
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document;
          this.isEnabled = iy(t.schema, e.selection);
        }
      }]);
      return oy;
    }(uC);
    function iy(t, e) {
      if (e.rangeCount > 1) {
        return false;
      }
      var n = e.anchor;
      if (!n || !t.checkChild(n, "softBreak")) {
        return false;
      }
      var o = e.getFirstRange();
      var i = o.start.parent;
      var r = o.end.parent;
      if ((ay(i, t) || ay(r, t)) && i !== r) {
        return false;
      }
      return true;
    }
    function ry(t, e, n) {
      var o = n.isCollapsed;
      var i = n.getFirstRange();
      var r = i.start.parent;
      var s = i.end.parent;
      var a = r == s;
      if (o) {
        var _o134 = Zv(t.schema, n.getAttributes());
        sy(t, e, i.end);
        e.removeSelectionAttribute(n.getAttributeKeys());
        e.setSelectionAttribute(_o134);
      } else {
        var _o135 = !(i.start.isAtStart && i.end.isAtEnd);
        t.deleteContent(n, {
          leaveUnmerged: _o135
        });
        if (a) {
          sy(t, e, n.focus);
        } else {
          if (_o135) {
            e.setSelection(s, 0);
          }
        }
      }
    }
    function sy(t, e, n) {
      var o = e.createElement("softBreak");
      t.insertContent(o, n);
      e.setSelection(o, "after");
    }
    function ay(t, e) {
      if (t.is("rootElement")) {
        return false;
      }
      return e.isLimit(t) || ay(t.parent, e);
    }
    var cy = /*#__PURE__*/function (_aC20) {
      _inherits(cy, _aC20);
      function cy() {
        _classCallCheck(this, cy);
        return _possibleConstructorReturn(this, _getPrototypeOf(cy).apply(this, arguments));
      }
      _createClass(cy, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model.schema;
          var n = t.conversion;
          var o = t.editing.view;
          var i = o.document;
          e.register("softBreak", {
            allowWhere: "$text",
            isInline: true
          });
          n.for("upcast").elementToElement({
            model: "softBreak",
            view: "br"
          });
          n.for("downcast").elementToElement({
            model: "softBreak",
            view: function view(t, _ref38) {
              var e = _ref38.writer;
              return e.createEmptyElement("br");
            }
          });
          o.addObserver(ey);
          t.commands.add("shiftEnter", new oy(t));
          this.listenTo(i, "enter", function (e, n) {
            n.preventDefault();
            if (!n.isSoft) {
              return;
            }
            t.execute("shiftEnter");
            o.scrollToTheSelection();
          }, {
            priority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ShiftEnter";
        }
      }]);
      return cy;
    }(aC);
    var ly = /*#__PURE__*/function (_uC10) {
      _inherits(ly, _uC10);
      function ly() {
        _classCallCheck(this, ly);
        return _possibleConstructorReturn(this, _getPrototypeOf(ly).apply(this, arguments));
      }
      _createClass(ly, [{
        key: "execute",
        value: function execute() {
          var t = this.editor.model;
          var e = t.document.selection;
          var n = t.schema.getLimitElement(e);
          if (e.containsEntireContent(n) || !dy(t.schema, n)) {
            do {
              n = n.parent;
              if (!n) {
                return;
              }
            } while (!dy(t.schema, n));
          }
          t.change(function (t) {
            t.setSelection(n, "in");
          });
        }
      }]);
      return ly;
    }(uC);
    function dy(t, e) {
      return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
    }
    var uy = Rl("Ctrl+A");
    var hy = /*#__PURE__*/function (_aC21) {
      _inherits(hy, _aC21);
      function hy() {
        _classCallCheck(this, hy);
        return _possibleConstructorReturn(this, _getPrototypeOf(hy).apply(this, arguments));
      }
      _createClass(hy, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.editing.view;
          var n = e.document;
          t.commands.add("selectAll", new ly(t));
          this.listenTo(n, "keydown", function (e, n) {
            if (Ol(n) === uy) {
              t.execute("selectAll");
              n.preventDefault();
            }
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllEditing";
        }
      }]);
      return hy;
    }(aC);
    var fy = '<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>';
    var my = /*#__PURE__*/function (_aC22) {
      _inherits(my, _aC22);
      function my() {
        _classCallCheck(this, my);
        return _possibleConstructorReturn(this, _getPrototypeOf(my).apply(this, arguments));
      }
      _createClass(my, [{
        key: "init",
        value: function init() {
          var _this170 = this;
          var t = this.editor;
          t.ui.componentFactory.add("selectAll", function (e) {
            var n = t.commands.get("selectAll");
            var o = new cw(e);
            var i = e.t;
            o.set({
              label: i("Select all"),
              icon: fy,
              keystroke: "Ctrl+A",
              tooltip: true
            });
            o.bind("isOn", "isEnabled").to(n, "value", "isEnabled");
            _this170.listenTo(o, "execute", function () {
              t.execute("selectAll");
              t.editing.view.focus();
            });
            return o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "SelectAllUI";
        }
      }]);
      return my;
    }(aC);
    var gy = /*#__PURE__*/function (_aC23) {
      _inherits(gy, _aC23);
      function gy() {
        _classCallCheck(this, gy);
        return _possibleConstructorReturn(this, _getPrototypeOf(gy).apply(this, arguments));
      }
      _createClass(gy, null, [{
        key: "requires",
        get: function get() {
          return [hy, my];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "SelectAll";
        }
      }]);
      return gy;
    }(aC);
    var py = /*#__PURE__*/function (_uC11) {
      _inherits(py, _uC11);
      function py(t, e) {
        var _this171;
        _classCallCheck(this, py);
        _this171 = _possibleConstructorReturn(this, _getPrototypeOf(py).call(this, t));
        _this171.direction = e;
        _this171._buffer = new UA(t.model, t.config.get("typing.undoStep"));
        return _this171;
      }
      _createClass(py, [{
        key: "execute",
        value: function execute() {
          var _this172 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.document;
          e.enqueueChange(this._buffer.batch, function (o) {
            _this172._buffer.lock();
            var i = o.createSelection(t.selection || n.selection);
            var r = i.isCollapsed;
            if (i.isCollapsed) {
              e.modifySelection(i, {
                direction: _this172.direction,
                unit: t.unit
              });
            }
            if (_this172._shouldEntireContentBeReplacedWithParagraph(t.sequence || 1)) {
              _this172._replaceEntireContentWithParagraph(o);
              return;
            }
            if (i.isCollapsed) {
              return;
            }
            var s = 0;
            i.getFirstRange().getMinimalFlatRanges().forEach(function (t) {
              s += gl(t.getWalker({
                singleCharacters: true,
                ignoreElementEnd: true,
                shallow: true
              }));
            });
            e.deleteContent(i, {
              doNotResetEntireContent: r,
              direction: _this172.direction
            });
            _this172._buffer.input(s);
            o.setSelection(i);
            _this172._buffer.unlock();
          });
        }
      }, {
        key: "_shouldEntireContentBeReplacedWithParagraph",
        value: function _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) {
            return false;
          }
          var e = this.editor.model;
          var n = e.document;
          var o = n.selection;
          var i = e.schema.getLimitElement(o);
          var r = o.isCollapsed && o.containsEntireContent(i);
          if (!r) {
            return false;
          }
          if (!e.schema.checkChild(i, "paragraph")) {
            return false;
          }
          var s = i.getChild(0);
          if (s && s.name === "paragraph") {
            return false;
          }
          return true;
        }
      }, {
        key: "_replaceEntireContentWithParagraph",
        value: function _replaceEntireContentWithParagraph(t) {
          var e = this.editor.model;
          var n = e.document;
          var o = n.selection;
          var i = e.schema.getLimitElement(o);
          var r = t.createElement("paragraph");
          t.remove(t.createRangeIn(i));
          t.insert(r, i);
          t.setSelection(r, 0);
        }
      }, {
        key: "buffer",
        get: function get() {
          return this._buffer;
        }
      }]);
      return py;
    }(uC);
    var ky = /*#__PURE__*/function (_tu7) {
      _inherits(ky, _tu7);
      function ky(t) {
        var _this173;
        _classCallCheck(this, ky);
        _this173 = _possibleConstructorReturn(this, _getPrototypeOf(ky).call(this, t));
        var e = t.document;
        var n = 0;
        e.on("keyup", function (t, e) {
          if (e.keyCode == Ll.delete || e.keyCode == Ll.backspace) {
            n = 0;
          }
        });
        e.on("keydown", function (t, e) {
          var i = {};
          if (e.keyCode == Ll.delete) {
            i.direction = "forward";
            i.unit = "character";
          } else if (e.keyCode == Ll.backspace) {
            i.direction = "backward";
            i.unit = "codePoint";
          } else {
            return;
          }
          var r = El.isMac ? e.altKey : e.ctrlKey;
          i.unit = r ? "word" : i.unit;
          i.sequence = ++n;
          o(t, e.domEvent, i);
        });
        if (El.isAndroid) {
          e.on("beforeinput", function (e, n) {
            if (n.domEvent.inputType != "deleteContentBackward") {
              return;
            }
            var i = {
              unit: "codepoint",
              direction: "backward",
              sequence: 1
            };
            var r = n.domTarget.ownerDocument.defaultView.getSelection();
            if (r.anchorNode == r.focusNode && r.anchorOffset + 1 != r.focusOffset) {
              i.selectionToRemove = t.domConverter.domSelectionToView(r);
            }
            o(e, n.domEvent, i);
          });
        }
        function o(t, n, o) {
          var i;
          e.once("delete", function (t) {
            return i = t;
          }, {
            priority: Number.POSITIVE_INFINITY
          });
          e.fire("delete", new eh(e, n, o));
          if (i && i.stop.called) {
            t.stop();
          }
        }
        return _this173;
      }
      _createClass(ky, [{
        key: "observe",
        value: function observe() {}
      }]);
      return ky;
    }(tu);
    var by = /*#__PURE__*/function (_aC24) {
      _inherits(by, _aC24);
      function by() {
        _classCallCheck(this, by);
        return _possibleConstructorReturn(this, _getPrototypeOf(by).apply(this, arguments));
      }
      _createClass(by, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.editing.view;
          var n = e.document;
          e.addObserver(ky);
          t.commands.add("forwardDelete", new py(t, "forward"));
          t.commands.add("delete", new py(t, "backward"));
          this.listenTo(n, "delete", function (n, o) {
            var i = {
              unit: o.unit,
              sequence: o.sequence
            };
            if (o.selectionToRemove) {
              var _e235 = t.model.createSelection();
              var _n207 = [];
              var _iterator324 = _createForOfIteratorHelper(o.selectionToRemove.getRanges()),
                _step324;
              try {
                for (_iterator324.s(); !(_step324 = _iterator324.n()).done;) {
                  var _e236 = _step324.value;
                  _n207.push(t.editing.mapper.toModelRange(_e236));
                }
              } catch (err) {
                _iterator324.e(err);
              } finally {
                _iterator324.f();
              }
              _e235.setTo(_n207);
              i.selection = _e235;
            }
            t.execute(o.direction == "forward" ? "forwardDelete" : "delete", i);
            o.preventDefault();
            e.scrollToTheSelection();
          });
          if (El.isAndroid) {
            var _t258 = null;
            this.listenTo(n, "delete", function (e, n) {
              var o = n.domTarget.ownerDocument.defaultView.getSelection();
              _t258 = {
                anchorNode: o.anchorNode,
                anchorOffset: o.anchorOffset,
                focusNode: o.focusNode,
                focusOffset: o.focusOffset
              };
            }, {
              priority: "lowest"
            });
            this.listenTo(n, "keyup", function (e, n) {
              if (_t258) {
                var _e237 = n.domTarget.ownerDocument.defaultView.getSelection();
                _e237.collapse(_t258.anchorNode, _t258.anchorOffset);
                _e237.extend(_t258.focusNode, _t258.focusOffset);
                _t258 = null;
              }
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Delete";
        }
      }]);
      return by;
    }(aC);
    var wy = /*#__PURE__*/function (_aC25) {
      _inherits(wy, _aC25);
      function wy() {
        _classCallCheck(this, wy);
        return _possibleConstructorReturn(this, _getPrototypeOf(wy).apply(this, arguments));
      }
      _createClass(wy, null, [{
        key: "requires",
        get: function get() {
          return [n_, by];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Typing";
        }
      }]);
      return wy;
    }(aC);
    var Cy = new Map();
    function Ay(t, e, n) {
      var o = Cy.get(t);
      if (!o) {
        o = new Map();
        Cy.set(t, o);
      }
      o.set(e, n);
    }
    function _y(t, e) {
      var n = Cy.get(t);
      if (n && n.has(e)) {
        return n.get(e);
      }
      return vy;
    }
    function vy(t) {
      return [t];
    }
    function yy(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = _y(t.constructor, e.constructor);
      try {
        t = t.clone();
        return o(t, e, n);
      } catch (t) {
        throw t;
      }
    }
    function xy(t, e, n) {
      t = t.slice();
      e = e.slice();
      var o = new Dy(n.document, n.useRelations, n.forceWeakRemove);
      o.setOriginalOperations(t);
      o.setOriginalOperations(e);
      var i = o.originalOperations;
      if (t.length == 0 || e.length == 0) {
        return {
          operationsA: t,
          operationsB: e,
          originalOperations: i
        };
      }
      var r = new WeakMap();
      var _iterator325 = _createForOfIteratorHelper(t),
        _step325;
      try {
        for (_iterator325.s(); !(_step325 = _iterator325.n()).done;) {
          var _e239 = _step325.value;
          r.set(_e239, 0);
        }
      } catch (err) {
        _iterator325.e(err);
      } finally {
        _iterator325.f();
      }
      var s = {
        nextBaseVersionA: t[t.length - 1].baseVersion + 1,
        nextBaseVersionB: e[e.length - 1].baseVersion + 1,
        originalOperationsACount: t.length,
        originalOperationsBCount: e.length
      };
      var a = 0;
      while (a < t.length) {
        var _t259, _e238;
        var _n208 = t[a];
        var _i112 = r.get(_n208);
        if (_i112 == e.length) {
          a++;
          continue;
        }
        var _s28 = e[_i112];
        var _c11 = yy(_n208, _s28, o.getContext(_n208, _s28, true));
        var _l7 = yy(_s28, _n208, o.getContext(_s28, _n208, false));
        o.updateRelation(_n208, _s28);
        o.setOriginalOperations(_c11, _n208);
        o.setOriginalOperations(_l7, _s28);
        var _iterator326 = _createForOfIteratorHelper(_c11),
          _step326;
        try {
          for (_iterator326.s(); !(_step326 = _iterator326.n()).done;) {
            var _t260 = _step326.value;
            r.set(_t260, _i112 + _l7.length);
          }
        } catch (err) {
          _iterator326.e(err);
        } finally {
          _iterator326.f();
        }
        (_t259 = t).splice.apply(_t259, [a, 1].concat(_toConsumableArray(_c11)));
        (_e238 = e).splice.apply(_e238, [_i112, 1].concat(_toConsumableArray(_l7)));
      }
      if (n.padWithNoOps) {
        var _n209 = t.length - s.originalOperationsACount;
        var _o136 = e.length - s.originalOperationsBCount;
        My(t, _o136 - _n209);
        My(e, _n209 - _o136);
      }
      Ey(t, s.nextBaseVersionB);
      Ey(e, s.nextBaseVersionA);
      return {
        operationsA: t,
        operationsB: e,
        originalOperations: i
      };
    }
    var Dy = /*#__PURE__*/function () {
      function Dy(t, e) {
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        _classCallCheck(this, Dy);
        this.originalOperations = new Map();
        this._history = t.history;
        this._useRelations = e;
        this._forceWeakRemove = !!n;
        this._relations = new Map();
      }
      _createClass(Dy, [{
        key: "setOriginalOperations",
        value: function setOriginalOperations(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var n = e ? this.originalOperations.get(e) : null;
          var _iterator327 = _createForOfIteratorHelper(t),
            _step327;
          try {
            for (_iterator327.s(); !(_step327 = _iterator327.n()).done;) {
              var _e240 = _step327.value;
              this.originalOperations.set(_e240, n || _e240);
            }
          } catch (err) {
            _iterator327.e(err);
          } finally {
            _iterator327.f();
          }
        }
      }, {
        key: "updateRelation",
        value: function updateRelation(t, e) {
          switch (t.constructor) {
            case vg:
              {
                switch (e.constructor) {
                  case Mg:
                    {
                      if (t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition)) {
                        this._setRelation(t, e, "insertAtSource");
                      } else if (t.targetPosition.isEqual(e.deletionPosition)) {
                        this._setRelation(t, e, "insertBetween");
                      } else if (t.targetPosition.isAfter(e.sourcePosition)) {
                        this._setRelation(t, e, "moveTargetAfter");
                      }
                      break;
                    }
                  case vg:
                    {
                      if (t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition)) {
                        this._setRelation(t, e, "insertBefore");
                      } else {
                        this._setRelation(t, e, "insertAfter");
                      }
                      break;
                    }
                }
                break;
              }
            case Sg:
              {
                switch (e.constructor) {
                  case Mg:
                    {
                      if (t.splitPosition.isBefore(e.sourcePosition)) {
                        this._setRelation(t, e, "splitBefore");
                      }
                      break;
                    }
                  case vg:
                    {
                      if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) {
                        this._setRelation(t, e, "splitBefore");
                      }
                      break;
                    }
                }
                break;
              }
            case Mg:
              {
                switch (e.constructor) {
                  case Mg:
                    {
                      if (!t.targetPosition.isEqual(e.sourcePosition)) {
                        this._setRelation(t, e, "mergeTargetNotMoved");
                      }
                      if (t.sourcePosition.isEqual(e.targetPosition)) {
                        this._setRelation(t, e, "mergeSourceNotMoved");
                      }
                      if (t.sourcePosition.isEqual(e.sourcePosition)) {
                        this._setRelation(t, e, "mergeSameElement");
                      }
                      break;
                    }
                  case Sg:
                    {
                      if (t.sourcePosition.isEqual(e.splitPosition)) {
                        this._setRelation(t, e, "splitAtSource");
                      }
                    }
                }
                break;
              }
            case xg:
              {
                var _n210 = t.newRange;
                if (!_n210) {
                  return;
                }
                switch (e.constructor) {
                  case vg:
                    {
                      var _o137 = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
                      var _i113 = _o137.containsPosition(_n210.start) || _o137.start.isEqual(_n210.start);
                      var _r40 = _o137.containsPosition(_n210.end) || _o137.end.isEqual(_n210.end);
                      if ((_i113 || _r40) && !_o137.containsRange(_n210)) {
                        this._setRelation(t, e, {
                          side: _i113 ? "left" : "right",
                          path: _i113 ? _n210.start.path.slice() : _n210.end.path.slice()
                        });
                      }
                      break;
                    }
                  case Mg:
                    {
                      var _o138 = _n210.start.isEqual(e.targetPosition);
                      var _i114 = _n210.start.isEqual(e.deletionPosition);
                      var _r41 = _n210.end.isEqual(e.deletionPosition);
                      var _s29 = _n210.end.isEqual(e.sourcePosition);
                      if (_o138 || _i114 || _r41 || _s29) {
                        this._setRelation(t, e, {
                          wasInLeftElement: _o138,
                          wasStartBeforeMergedElement: _i114,
                          wasEndBeforeMergedElement: _r41,
                          wasInRightElement: _s29
                        });
                      }
                      break;
                    }
                }
                break;
              }
          }
        }
      }, {
        key: "getContext",
        value: function getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          };
        }
      }, {
        key: "_wasUndone",
        value: function _wasUndone(t) {
          var e = this.originalOperations.get(t);
          return e.wasUndone || this._history.isUndoneOperation(e);
        }
      }, {
        key: "_getRelation",
        value: function _getRelation(t, e) {
          var n = this.originalOperations.get(e);
          var o = this._history.getUndoneOperation(n);
          if (!o) {
            return null;
          }
          var i = this.originalOperations.get(t);
          var r = this._relations.get(i);
          if (r) {
            return r.get(o) || null;
          }
          return null;
        }
      }, {
        key: "_setRelation",
        value: function _setRelation(t, e, n) {
          var o = this.originalOperations.get(t);
          var i = this.originalOperations.get(e);
          var r = this._relations.get(o);
          if (!r) {
            r = new Map();
            this._relations.set(o, r);
          }
          r.set(i, n);
        }
      }]);
      return Dy;
    }();
    function Ey(t, e) {
      var _iterator328 = _createForOfIteratorHelper(t),
        _step328;
      try {
        for (_iterator328.s(); !(_step328 = _iterator328.n()).done;) {
          var _n211 = _step328.value;
          _n211.baseVersion = e++;
        }
      } catch (err) {
        _iterator328.e(err);
      } finally {
        _iterator328.f();
      }
    }
    function My(t, e) {
      for (var _n212 = 0; _n212 < e; _n212++) {
        t.push(new Jg(0));
      }
    }
    Ay(Ag, Ag, function (t, e, n) {
      if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
        var _o139 = t.range.getDifference(e.range).map(function (e) {
          return new Ag(e, t.key, t.oldValue, t.newValue, 0);
        });
        var _i115 = t.range.getIntersection(e.range);
        if (_i115) {
          if (n.aIsStrong) {
            _o139.push(new Ag(_i115, e.key, e.newValue, t.newValue, 0));
          }
        }
        if (_o139.length == 0) {
          return [new Jg(0)];
        }
        return _o139;
      } else {
        return [t];
      }
    });
    Ay(Ag, yg, function (t, e) {
      if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
        var _n213 = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes);
        var _o140 = _n213.map(function (e) {
          return new Ag(e, t.key, t.oldValue, t.newValue, t.baseVersion);
        });
        if (e.shouldReceiveAttributes) {
          var _n214 = Sy(e, t.key, t.oldValue);
          if (_n214) {
            _o140.unshift(_n214);
          }
        }
        return _o140;
      }
      t.range = t.range._getTransformedByInsertion(e.position, e.howMany, false)[0];
      return [t];
    });
    function Sy(t, e, n) {
      var o = t.nodes;
      var i = o.getNode(0).getAttribute(e);
      if (i == n) {
        return null;
      }
      var r = new ef(t.position, t.position.getShiftedBy(t.howMany));
      return new Ag(r, e, i, n, 0);
    }
    Ay(Ag, Mg, function (t, e) {
      var n = [];
      if (t.range.start.hasSameParentAs(e.deletionPosition)) {
        if (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) {
          n.push(ef._createFromPositionAndShift(e.graveyardPosition, 1));
        }
      }
      var o = t.range._getTransformedByMergeOperation(e);
      if (!o.isCollapsed) {
        n.push(o);
      }
      return n.map(function (e) {
        return new Ag(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    });
    Ay(Ag, vg, function (t, e) {
      var n = Ty(t.range, e);
      return n.map(function (e) {
        return new Ag(e, t.key, t.oldValue, t.newValue, t.baseVersion);
      });
    });
    function Ty(t, e) {
      var n = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
      var o = null;
      var i = [];
      if (n.containsRange(t, true)) {
        o = t;
      } else if (t.start.hasSameParentAs(n.start)) {
        i = t.getDifference(n);
        o = t.getIntersection(n);
      } else {
        i = [t];
      }
      var r = [];
      var _iterator329 = _createForOfIteratorHelper(i),
        _step329;
      try {
        for (_iterator329.s(); !(_step329 = _iterator329.n()).done;) {
          var _t261 = _step329.value;
          _t261 = _t261._getTransformedByDeletion(e.sourcePosition, e.howMany);
          var _n215 = e.getMovedRangeStart();
          var _o141 = _t261.start.hasSameParentAs(_n215);
          _t261 = _t261._getTransformedByInsertion(_n215, e.howMany, _o141);
          r.push.apply(r, _toConsumableArray(_t261));
        }
      } catch (err) {
        _iterator329.e(err);
      } finally {
        _iterator329.f();
      }
      if (o) {
        r.push(o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, false)[0]);
      }
      return r;
    }
    Ay(Ag, Sg, function (t, e) {
      if (t.range.end.isEqual(e.insertionPosition)) {
        if (!e.graveyardPosition) {
          t.range.end.offset++;
        }
        return [t];
      }
      if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
        var _n216 = t.clone();
        _n216.range = new ef(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition));
        t.range.end = e.splitPosition.clone();
        t.range.end.stickiness = "toPrevious";
        return [t, _n216];
      }
      t.range = t.range._getTransformedBySplitOperation(e);
      return [t];
    });
    Ay(yg, Ag, function (t, e) {
      var n = [t];
      if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
        var _o142 = Sy(t, e.key, e.newValue);
        if (_o142) {
          n.push(_o142);
        }
      }
      return n;
    });
    Ay(yg, yg, function (t, e, n) {
      if (t.position.isEqual(e.position) && n.aIsStrong) {
        return [t];
      }
      t.position = t.position._getTransformedByInsertOperation(e);
      return [t];
    });
    Ay(yg, vg, function (t, e) {
      t.position = t.position._getTransformedByMoveOperation(e);
      return [t];
    });
    Ay(yg, Sg, function (t, e) {
      t.position = t.position._getTransformedBySplitOperation(e);
      return [t];
    });
    Ay(yg, Mg, function (t, e) {
      t.position = t.position._getTransformedByMergeOperation(e);
      return [t];
    });
    Ay(xg, yg, function (t, e) {
      if (t.oldRange) {
        t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0];
      }
      if (t.newRange) {
        t.newRange = t.newRange._getTransformedByInsertOperation(e)[0];
      }
      return [t];
    });
    Ay(xg, xg, function (t, e, n) {
      if (t.name == e.name) {
        if (n.aIsStrong) {
          t.oldRange = e.newRange ? e.newRange.clone() : null;
        } else {
          return [new Jg(0)];
        }
      }
      return [t];
    });
    Ay(xg, Mg, function (t, e) {
      if (t.oldRange) {
        t.oldRange = t.oldRange._getTransformedByMergeOperation(e);
      }
      if (t.newRange) {
        t.newRange = t.newRange._getTransformedByMergeOperation(e);
      }
      return [t];
    });
    Ay(xg, vg, function (t, e, n) {
      if (t.oldRange) {
        t.oldRange = ef._createFromRanges(t.oldRange._getTransformedByMoveOperation(e));
      }
      if (t.newRange) {
        if (n.abRelation) {
          var _o143 = ef._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
          if (n.abRelation.side == "left" && e.targetPosition.isEqual(t.newRange.start)) {
            t.newRange.start.path = n.abRelation.path;
            t.newRange.end = _o143.end;
            return [t];
          } else if (n.abRelation.side == "right" && e.targetPosition.isEqual(t.newRange.end)) {
            t.newRange.start = _o143.start;
            t.newRange.end.path = n.abRelation.path;
            return [t];
          }
        }
        t.newRange = ef._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
      }
      return [t];
    });
    Ay(xg, Sg, function (t, e, n) {
      if (t.oldRange) {
        t.oldRange = t.oldRange._getTransformedBySplitOperation(e);
      }
      if (t.newRange) {
        if (n.abRelation) {
          var _o144 = t.newRange._getTransformedBySplitOperation(e);
          if (t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement) {
            t.newRange.start = Zh._createAt(e.insertionPosition);
          } else if (t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement) {
            t.newRange.start = Zh._createAt(e.moveTargetPosition);
          }
          if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement) {
            t.newRange.end = Zh._createAt(e.moveTargetPosition);
          } else if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement) {
            t.newRange.end = Zh._createAt(e.insertionPosition);
          } else {
            t.newRange.end = _o144.end;
          }
          return [t];
        }
        t.newRange = t.newRange._getTransformedBySplitOperation(e);
      }
      return [t];
    });
    Ay(Mg, yg, function (t, e) {
      if (t.sourcePosition.hasSameParentAs(e.position)) {
        t.howMany += e.howMany;
      }
      t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e);
      t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e);
      return [t];
    });
    Ay(Mg, Mg, function (t, e, n) {
      if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
        if (!n.bWasUndone) {
          return [new Jg(0)];
        } else {
          var _n217 = e.graveyardPosition.path.slice();
          _n217.push(0);
          t.sourcePosition = new Zh(e.graveyardPosition.root, _n217);
          t.howMany = 0;
          return [t];
        }
      }
      if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && n.abRelation != "splitAtSource") {
        var _o145 = t.targetPosition.root.rootName == "$graveyard";
        var _i116 = e.targetPosition.root.rootName == "$graveyard";
        var _r42 = _o145 && !_i116;
        var _s30 = _i116 && !_o145;
        var _a20 = _s30 || !_r42 && n.aIsStrong;
        if (_a20) {
          var _n218 = e.targetPosition._getTransformedByMergeOperation(e);
          var _o146 = t.targetPosition._getTransformedByMergeOperation(e);
          return [new vg(_n218, t.howMany, _o146, 0)];
        } else {
          return [new Jg(0)];
        }
      }
      if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
        t.howMany += e.howMany;
      }
      t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e);
      t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
      if (!t.graveyardPosition.isEqual(e.graveyardPosition) || !n.aIsStrong) {
        t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
      }
      return [t];
    });
    Ay(Mg, vg, function (t, e, n) {
      var o = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) {
        if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition)) {
          return [new Jg(0)];
        }
      }
      if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
        t.howMany += e.howMany;
      }
      if (t.sourcePosition.hasSameParentAs(e.sourcePosition)) {
        t.howMany -= e.howMany;
      }
      t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e);
      t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e);
      if (!t.graveyardPosition.isEqual(e.targetPosition)) {
        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }
      return [t];
    });
    Ay(Mg, Sg, function (t, e, n) {
      if (e.graveyardPosition) {
        t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1);
        if (t.deletionPosition.isEqual(e.graveyardPosition)) {
          t.howMany = e.howMany;
        }
      }
      if (t.targetPosition.isEqual(e.splitPosition)) {
        var _o147 = e.howMany != 0;
        var _i117 = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
        if (_o147 || _i117 || n.abRelation == "mergeTargetNotMoved") {
          t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e);
          return [t];
        }
      }
      if (t.sourcePosition.isEqual(e.splitPosition)) {
        if (n.abRelation == "mergeSourceNotMoved") {
          t.howMany = 0;
          t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
          return [t];
        }
        if (n.abRelation == "mergeSameElement" || t.sourcePosition.offset > 0) {
          t.sourcePosition = e.moveTargetPosition.clone();
          t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
          return [t];
        }
      }
      if (t.sourcePosition.hasSameParentAs(e.splitPosition)) {
        t.howMany = e.splitPosition.offset;
      }
      t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e);
      t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
      return [t];
    });
    Ay(vg, yg, function (t, e) {
      var n = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
      var o = n._getTransformedByInsertOperation(e, false)[0];
      t.sourcePosition = o.start;
      t.howMany = o.end.offset - o.start.offset;
      if (!t.targetPosition.isEqual(e.position)) {
        t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e);
      }
      return [t];
    });
    Ay(vg, vg, function (t, e, n) {
      var o = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
      var i = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
      var r = n.aIsStrong;
      var s = !n.aIsStrong;
      if (n.abRelation == "insertBefore" || n.baRelation == "insertAfter") {
        s = true;
      } else if (n.abRelation == "insertAfter" || n.baRelation == "insertBefore") {
        s = false;
      }
      var a;
      if (t.targetPosition.isEqual(e.targetPosition) && s) {
        a = t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
      } else {
        a = t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
      }
      if (Iy(t, e) && Iy(e, t)) {
        return [e.getReversed()];
      }
      var c = o.containsPosition(e.targetPosition);
      if (c && o.containsRange(i, true)) {
        o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        return Ny([o], a);
      }
      var l = i.containsPosition(t.targetPosition);
      if (l && i.containsRange(o, true)) {
        o.start = o.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
        o.end = o.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
        return Ny([o], a);
      }
      var d = Ls(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
      if (d == "prefix" || d == "extension") {
        o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
        return Ny([o], a);
      }
      if (t.type == "remove" && e.type != "remove" && !n.aWasUndone && !n.forceWeakRemove) {
        r = true;
      } else if (t.type != "remove" && e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) {
        r = false;
      }
      var u = [];
      var h = o.getDifference(i);
      var _iterator330 = _createForOfIteratorHelper(h),
        _step330;
      try {
        for (_iterator330.s(); !(_step330 = _iterator330.n()).done;) {
          var _t262 = _step330.value;
          _t262.start = _t262.start._getTransformedByDeletion(e.sourcePosition, e.howMany);
          _t262.end = _t262.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
          var _n219 = Ls(_t262.start.getParentPath(), e.getMovedRangeStart().getParentPath()) == "same";
          var _o148 = _t262._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, _n219);
          u.push.apply(u, _toConsumableArray(_o148));
        }
      } catch (err) {
        _iterator330.e(err);
      } finally {
        _iterator330.f();
      }
      var f = o.getIntersection(i);
      if (f !== null && r) {
        f.start = f.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
        f.end = f.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
        if (u.length === 0) {
          u.push(f);
        } else if (u.length == 1) {
          if (i.start.isBefore(o.start) || i.start.isEqual(o.start)) {
            u.unshift(f);
          } else {
            u.push(f);
          }
        } else {
          u.splice(1, 0, f);
        }
      }
      if (u.length === 0) {
        return [new Jg(t.baseVersion)];
      }
      return Ny(u, a);
    });
    Ay(vg, Sg, function (t, e, n) {
      var o = t.targetPosition.clone();
      if (!t.targetPosition.isEqual(e.insertionPosition) || !e.graveyardPosition || n.abRelation == "moveTargetAfter") {
        o = t.targetPosition._getTransformedBySplitOperation(e);
      }
      var i = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (i.end.isEqual(e.insertionPosition)) {
        if (!e.graveyardPosition) {
          t.howMany++;
        }
        t.targetPosition = o;
        return [t];
      }
      if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
        var _t263 = new ef(e.splitPosition, i.end);
        _t263 = _t263._getTransformedBySplitOperation(e);
        var _n220 = [new ef(i.start, e.splitPosition), _t263];
        return Ny(_n220, o);
      }
      if (t.targetPosition.isEqual(e.splitPosition) && n.abRelation == "insertAtSource") {
        o = e.moveTargetPosition;
      }
      if (t.targetPosition.isEqual(e.insertionPosition) && n.abRelation == "insertBetween") {
        o = t.targetPosition;
      }
      var r = i._getTransformedBySplitOperation(e);
      var s = [r];
      if (e.graveyardPosition) {
        var _o149 = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
        if (t.howMany > 1 && _o149 && !n.aWasUndone) {
          s.push(ef._createFromPositionAndShift(e.insertionPosition, 1));
        }
      }
      return Ny(s, o);
    });
    Ay(vg, Mg, function (t, e, n) {
      var o = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
      if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition)) {
        if (t.type == "remove" && !n.forceWeakRemove) {
          if (!n.aWasUndone) {
            var _n221 = [];
            var _o150 = e.graveyardPosition.clone();
            var _i118 = e.targetPosition._getTransformedByMergeOperation(e);
            if (t.howMany > 1) {
              _n221.push(new vg(t.sourcePosition, t.howMany - 1, t.targetPosition, 0));
              _o150 = _o150._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
              _i118 = _i118._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
            }
            var _r43 = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition);
            var _s31 = new vg(_o150, 1, _r43, 0);
            var _a21 = _s31.getMovedRangeStart().path.slice();
            _a21.push(0);
            var _c12 = new Zh(_s31.targetPosition.root, _a21);
            _i118 = _i118._getTransformedByMove(_o150, _r43, 1);
            var _l8 = new vg(_i118, e.howMany, _c12, 0);
            _n221.push(_s31);
            _n221.push(_l8);
            return _n221;
          }
        } else {
          if (t.howMany == 1) {
            if (!n.bWasUndone) {
              return [new Jg(0)];
            } else {
              t.sourcePosition = e.graveyardPosition.clone();
              t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
              return [t];
            }
          }
        }
      }
      var i = ef._createFromPositionAndShift(t.sourcePosition, t.howMany);
      var r = i._getTransformedByMergeOperation(e);
      t.sourcePosition = r.start;
      t.howMany = r.end.offset - r.start.offset;
      t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
      return [t];
    });
    Ay(Dg, yg, function (t, e) {
      t.position = t.position._getTransformedByInsertOperation(e);
      return [t];
    });
    Ay(Dg, Mg, function (t, e) {
      if (t.position.isEqual(e.deletionPosition)) {
        t.position = e.graveyardPosition.clone();
        t.position.stickiness = "toNext";
        return [t];
      }
      t.position = t.position._getTransformedByMergeOperation(e);
      return [t];
    });
    Ay(Dg, vg, function (t, e) {
      t.position = t.position._getTransformedByMoveOperation(e);
      return [t];
    });
    Ay(Dg, Dg, function (t, e, n) {
      if (t.position.isEqual(e.position)) {
        if (n.aIsStrong) {
          t.oldName = e.newName;
        } else {
          return [new Jg(0)];
        }
      }
      return [t];
    });
    Ay(Dg, Sg, function (t, e) {
      var n = t.position.path;
      var o = e.splitPosition.getParentPath();
      if (Ls(n, o) == "same" && !e.graveyardPosition) {
        var _e241 = new Dg(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
        return [t, _e241];
      }
      t.position = t.position._getTransformedBySplitOperation(e);
      return [t];
    });
    Ay(Eg, Eg, function (t, e, n) {
      if (t.root === e.root && t.key === e.key) {
        if (!n.aIsStrong || t.newValue === e.newValue) {
          return [new Jg(0)];
        } else {
          t.oldValue = e.newValue;
        }
      }
      return [t];
    });
    Ay(Sg, yg, function (t, e) {
      if (t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset) {
        t.howMany += e.howMany;
      }
      t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e);
      t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
      return [t];
    });
    Ay(Sg, Mg, function (t, e, n) {
      if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
        var _n222 = e.graveyardPosition.path.slice();
        _n222.push(0);
        var _o151 = new Zh(e.graveyardPosition.root, _n222);
        var _i119 = Sg.getInsertionPosition(new Zh(e.graveyardPosition.root, _n222));
        var _r44 = new Sg(_o151, 0, null, 0);
        _r44.insertionPosition = _i119;
        t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e);
        t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
        t.graveyardPosition = _r44.insertionPosition.clone();
        t.graveyardPosition.stickiness = "toNext";
        return [_r44, t];
      }
      if (t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition)) {
        t.howMany--;
      }
      if (t.splitPosition.hasSameParentAs(e.targetPosition)) {
        t.howMany += e.howMany;
      }
      t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e);
      t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
      if (t.graveyardPosition) {
        t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
      }
      return [t];
    });
    Ay(Sg, vg, function (t, e, n) {
      var o = ef._createFromPositionAndShift(e.sourcePosition, e.howMany);
      if (t.graveyardPosition) {
        var _i120 = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
        if (!n.bWasUndone && _i120) {
          var _n223 = t.splitPosition._getTransformedByMoveOperation(e);
          var _o152 = t.graveyardPosition._getTransformedByMoveOperation(e);
          var _i121 = _o152.path.slice();
          _i121.push(0);
          var _r45 = new Zh(_o152.root, _i121);
          var _s32 = new vg(_n223, t.howMany, _r45, 0);
          return [_s32];
        }
        t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
      }
      if (t.splitPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.splitPosition)) {
        var _n224 = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
        t.howMany -= _n224;
        if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) {
          t.howMany += e.howMany;
        }
        t.splitPosition = e.sourcePosition.clone();
        t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
        return [t];
      }
      var i = t.splitPosition.isEqual(e.targetPosition);
      if (i && (n.baRelation == "insertAtSource" || n.abRelation == "splitBefore")) {
        t.howMany += e.howMany;
        t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
        t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
        return [t];
      }
      if (!e.sourcePosition.isEqual(e.targetPosition)) {
        if (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset) {
          t.howMany -= e.howMany;
        }
        if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) {
          t.howMany += e.howMany;
        }
      }
      t.splitPosition.stickiness = "toNone";
      t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e);
      t.splitPosition.stickiness = "toNext";
      if (t.graveyardPosition) {
        t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e);
      } else {
        t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
      }
      return [t];
    });
    Ay(Sg, Sg, function (t, e, n) {
      if (t.splitPosition.isEqual(e.splitPosition)) {
        if (!t.graveyardPosition && !e.graveyardPosition) {
          return [new Jg(0)];
        }
        if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
          return [new Jg(0)];
        }
        if (n.abRelation == "splitBefore") {
          t.howMany = 0;
          t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
          return [t];
        }
      }
      if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
        var _o153 = t.splitPosition.root.rootName == "$graveyard";
        var _i122 = e.splitPosition.root.rootName == "$graveyard";
        var _r46 = _o153 && !_i122;
        var _s33 = _i122 && !_o153;
        var _a22 = _s33 || !_r46 && n.aIsStrong;
        if (_a22) {
          var _n225 = [];
          if (e.howMany) {
            _n225.push(new vg(e.moveTargetPosition, e.howMany, e.splitPosition, 0));
          }
          if (t.howMany) {
            _n225.push(new vg(t.splitPosition, t.howMany, t.moveTargetPosition, 0));
          }
          return _n225;
        } else {
          return [new Jg(0)];
        }
      }
      if (t.graveyardPosition) {
        t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
      }
      if (t.splitPosition.isEqual(e.insertionPosition) && n.abRelation == "splitBefore") {
        t.howMany++;
        return [t];
      }
      if (e.splitPosition.isEqual(t.insertionPosition) && n.baRelation == "splitBefore") {
        var _n226 = e.insertionPosition.path.slice();
        _n226.push(0);
        var _o154 = new Zh(e.insertionPosition.root, _n226);
        var _i123 = new vg(t.insertionPosition, 1, _o154, 0);
        return [t, _i123];
      }
      if (t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset) {
        t.howMany -= e.howMany;
      }
      t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e);
      t.insertionPosition = Sg.getInsertionPosition(t.splitPosition);
      return [t];
    });
    function Iy(t, e) {
      return t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) === null;
    }
    function Ny(t, e) {
      var n = [];
      for (var _o155 = 0; _o155 < t.length; _o155++) {
        var _i124 = t[_o155];
        var _r47 = new vg(_i124.start, _i124.end.offset - _i124.start.offset, e, 0);
        n.push(_r47);
        for (var _e242 = _o155 + 1; _e242 < t.length; _e242++) {
          t[_e242] = t[_e242]._getTransformedByMove(_r47.sourcePosition, _r47.targetPosition, _r47.howMany)[0];
        }
        e = e._getTransformedByMove(_r47.sourcePosition, _r47.targetPosition, _r47.howMany);
      }
      return n;
    }
    var Py = /*#__PURE__*/function (_uC12) {
      _inherits(Py, _uC12);
      function Py(t) {
        var _this174;
        _classCallCheck(this, Py);
        _this174 = _possibleConstructorReturn(this, _getPrototypeOf(Py).call(this, t));
        _this174._stack = [];
        _this174._createdBatches = new WeakSet();
        _this174.refresh();
        _this174.listenTo(t.data, "set", function () {
          return _this174.clearStack();
        });
        return _this174;
      }
      _createClass(Py, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._stack.length > 0;
        }
      }, {
        key: "addBatch",
        value: function addBatch(t) {
          var e = this.editor.model.document.selection;
          var n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          };
          this._stack.push({
            batch: t,
            selection: n
          });
          this.refresh();
        }
      }, {
        key: "clearStack",
        value: function clearStack() {
          this._stack = [];
          this.refresh();
        }
      }, {
        key: "_restoreSelection",
        value: function _restoreSelection(t, e, n) {
          var o = this.editor.model;
          var i = o.document;
          var r = [];
          var s = t.map(function (t) {
            return t.getTransformedByOperations(n);
          });
          var a = s.flat();
          var _iterator331 = _createForOfIteratorHelper(s),
            _step331;
          try {
            for (_iterator331.s(); !(_step331 = _iterator331.n()).done;) {
              var _t264 = _step331.value;
              var _e243 = _t264.filter(function (t) {
                return t.root != i.graveyard;
              }).filter(function (t) {
                return !zy(t, a);
              });
              if (!_e243.length) {
                continue;
              }
              By(_e243);
              r.push(_e243[0]);
            }
          } catch (err) {
            _iterator331.e(err);
          } finally {
            _iterator331.f();
          }
          if (r.length) {
            o.change(function (t) {
              t.setSelection(r, {
                backward: e
              });
            });
          }
        }
      }, {
        key: "_undo",
        value: function _undo(t, e) {
          var n = this.editor.model;
          var o = n.document;
          this._createdBatches.add(e);
          var i = t.operations.slice().filter(function (t) {
            return t.isDocumentOperation;
          });
          i.reverse();
          var _iterator332 = _createForOfIteratorHelper(i),
            _step332;
          try {
            for (_iterator332.s(); !(_step332 = _iterator332.n()).done;) {
              var _t265 = _step332.value;
              var _i125 = _t265.baseVersion + 1;
              var _r48 = Array.from(o.history.getOperations(_i125));
              var _s34 = xy([_t265.getReversed()], _r48, {
                useRelations: true,
                document: this.editor.model.document,
                padWithNoOps: false,
                forceWeakRemove: true
              });
              var _a23 = _s34.operationsA;
              var _iterator333 = _createForOfIteratorHelper(_a23),
                _step333;
              try {
                for (_iterator333.s(); !(_step333 = _iterator333.n()).done;) {
                  var _i126 = _step333.value;
                  e.addOperation(_i126);
                  n.applyOperation(_i126);
                  o.history.setOperationAsUndone(_t265, _i126);
                }
              } catch (err) {
                _iterator333.e(err);
              } finally {
                _iterator333.f();
              }
            }
          } catch (err) {
            _iterator332.e(err);
          } finally {
            _iterator332.f();
          }
        }
      }]);
      return Py;
    }(uC);
    function By(t) {
      t.sort(function (t, e) {
        return t.start.isBefore(e.start) ? -1 : 1;
      });
      for (var _e244 = 1; _e244 < t.length; _e244++) {
        var _n227 = t[_e244 - 1];
        var _o156 = _n227.getJoined(t[_e244], true);
        if (_o156) {
          _e244--;
          t.splice(_e244, 2, _o156);
        }
      }
    }
    function zy(t, e) {
      return e.some(function (e) {
        return e !== t && e.containsRange(t, true);
      });
    }
    var Ly = /*#__PURE__*/function (_Py) {
      _inherits(Ly, _Py);
      function Ly() {
        _classCallCheck(this, Ly);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ly).apply(this, arguments));
      }
      _createClass(Ly, [{
        key: "execute",
        value: function execute() {
          var _this175 = this;
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var e = t ? this._stack.findIndex(function (e) {
            return e.batch == t;
          }) : this._stack.length - 1;
          var n = this._stack.splice(e, 1)[0];
          var o = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(o, function () {
            _this175._undo(n.batch, o);
            var t = _this175.editor.model.document.history.getOperations(n.batch.baseVersion);
            _this175._restoreSelection(n.selection.ranges, n.selection.isBackward, t);
            _this175.fire("revert", n.batch, o);
          });
          this.refresh();
        }
      }]);
      return Ly;
    }(Py);
    var Oy = /*#__PURE__*/function (_Py2) {
      _inherits(Oy, _Py2);
      function Oy() {
        _classCallCheck(this, Oy);
        return _possibleConstructorReturn(this, _getPrototypeOf(Oy).apply(this, arguments));
      }
      _createClass(Oy, [{
        key: "execute",
        value: function execute() {
          var _this176 = this;
          var t = this._stack.pop();
          var e = this.editor.model.createBatch("transparent");
          this.editor.model.enqueueChange(e, function () {
            var n = t.batch.operations[t.batch.operations.length - 1];
            var o = n.baseVersion + 1;
            var i = _this176.editor.model.document.history.getOperations(o);
            _this176._restoreSelection(t.selection.ranges, t.selection.isBackward, i);
            _this176._undo(t.batch, e);
          });
          this.refresh();
        }
      }]);
      return Oy;
    }(Py);
    var Ry = /*#__PURE__*/function (_aC26) {
      _inherits(Ry, _aC26);
      _createClass(Ry, null, [{
        key: "pluginName",
        get: function get() {
          return "UndoEditing";
        }
      }]);
      function Ry(t) {
        var _this177;
        _classCallCheck(this, Ry);
        _this177 = _possibleConstructorReturn(this, _getPrototypeOf(Ry).call(this, t));
        _this177._batchRegistry = new WeakSet();
        return _this177;
      }
      _createClass(Ry, [{
        key: "init",
        value: function init() {
          var _this178 = this;
          var t = this.editor;
          this._undoCommand = new Ly(t);
          this._redoCommand = new Oy(t);
          t.commands.add("undo", this._undoCommand);
          t.commands.add("redo", this._redoCommand);
          this.listenTo(t.model, "applyOperation", function (t, e) {
            var n = e[0];
            if (!n.isDocumentOperation) {
              return;
            }
            var o = n.batch;
            var i = _this178._redoCommand._createdBatches.has(o);
            var r = _this178._undoCommand._createdBatches.has(o);
            var s = _this178._batchRegistry.has(o);
            if (s || o.type == "transparent" && !i && !r) {
              return;
            } else {
              if (i) {
                _this178._undoCommand.addBatch(o);
              } else if (!r) {
                _this178._undoCommand.addBatch(o);
                _this178._redoCommand.clearStack();
              }
            }
            _this178._batchRegistry.add(o);
          }, {
            priority: "highest"
          });
          this.listenTo(this._undoCommand, "revert", function (t, e, n) {
            _this178._redoCommand.addBatch(n);
          });
          t.keystrokes.set("CTRL+Z", "undo");
          t.keystrokes.set("CTRL+Y", "redo");
          t.keystrokes.set("CTRL+SHIFT+Z", "redo");
        }
      }]);
      return Ry;
    }(aC);
    var jy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.042 9.367l2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>';
    var Fy = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M14.958 9.367l-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
    var Vy = /*#__PURE__*/function (_aC27) {
      _inherits(Vy, _aC27);
      function Vy() {
        _classCallCheck(this, Vy);
        return _possibleConstructorReturn(this, _getPrototypeOf(Vy).apply(this, arguments));
      }
      _createClass(Vy, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.locale;
          var n = t.t;
          var o = e.uiLanguageDirection == "ltr" ? jy : Fy;
          var i = e.uiLanguageDirection == "ltr" ? Fy : jy;
          this._addButton("undo", n("Undo"), "CTRL+Z", o);
          this._addButton("redo", n("Redo"), "CTRL+Y", i);
        }
      }, {
        key: "_addButton",
        value: function _addButton(t, e, n, o) {
          var _this179 = this;
          var i = this.editor;
          i.ui.componentFactory.add(t, function (r) {
            var s = i.commands.get(t);
            var a = new cw(r);
            a.set({
              label: e,
              icon: o,
              keystroke: n,
              tooltip: true
            });
            a.bind("isEnabled").to(s, "isEnabled");
            _this179.listenTo(a, "execute", function () {
              i.execute(t);
              i.editing.view.focus();
            });
            return a;
          });
        }
      }]);
      return Vy;
    }(aC);
    var Uy = /*#__PURE__*/function (_aC28) {
      _inherits(Uy, _aC28);
      function Uy() {
        _classCallCheck(this, Uy);
        return _possibleConstructorReturn(this, _getPrototypeOf(Uy).apply(this, arguments));
      }
      _createClass(Uy, null, [{
        key: "requires",
        get: function get() {
          return [Ry, Vy];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Undo";
        }
      }]);
      return Uy;
    }(aC);
    var Hy = /*#__PURE__*/function (_aC29) {
      _inherits(Hy, _aC29);
      function Hy() {
        _classCallCheck(this, Hy);
        return _possibleConstructorReturn(this, _getPrototypeOf(Hy).apply(this, arguments));
      }
      _createClass(Hy, null, [{
        key: "requires",
        get: function get() {
          return [h_, ny, gy, cy, wy, Uy];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Essentials";
        }
      }]);
      return Hy;
    }(aC);
    var Gy = /*#__PURE__*/function (_uC13) {
      _inherits(Gy, _uC13);
      function Gy() {
        _classCallCheck(this, Gy);
        return _possibleConstructorReturn(this, _getPrototypeOf(Gy).apply(this, arguments));
      }
      _createClass(Gy, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document;
          var n = nC(e.selection.getSelectedBlocks());
          this.value = !!n && n.is("element", "paragraph");
          this.isEnabled = !!n && Wy(n, t.schema);
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.document;
          e.change(function (o) {
            var i = (t.selection || n.selection).getSelectedBlocks();
            var _iterator334 = _createForOfIteratorHelper(i),
              _step334;
            try {
              for (_iterator334.s(); !(_step334 = _iterator334.n()).done;) {
                var _t266 = _step334.value;
                if (!_t266.is("element", "paragraph") && Wy(_t266, e.schema)) {
                  o.rename(_t266, "paragraph");
                }
              }
            } catch (err) {
              _iterator334.e(err);
            } finally {
              _iterator334.f();
            }
          });
        }
      }]);
      return Gy;
    }(uC);
    function Wy(t, e) {
      return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
    }
    var Ky = /*#__PURE__*/function (_uC14) {
      _inherits(Ky, _uC14);
      function Ky() {
        _classCallCheck(this, Ky);
        return _possibleConstructorReturn(this, _getPrototypeOf(Ky).apply(this, arguments));
      }
      _createClass(Ky, [{
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = t.position;
          e.change(function (t) {
            var o = t.createElement("paragraph");
            if (!e.schema.checkChild(n.parent, o)) {
              var _i127 = e.schema.findAllowedParent(n, o);
              if (!_i127) {
                return;
              }
              n = t.split(n, _i127).position;
            }
            e.insertContent(o, n);
            t.setSelection(o, "in");
          });
        }
      }]);
      return Ky;
    }(uC);
    var qy = /*#__PURE__*/function (_aC30) {
      _inherits(qy, _aC30);
      function qy() {
        _classCallCheck(this, qy);
        return _possibleConstructorReturn(this, _getPrototypeOf(qy).apply(this, arguments));
      }
      _createClass(qy, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model;
          t.commands.add("paragraph", new Gy(t));
          t.commands.add("insertParagraph", new Ky(t));
          e.schema.register("paragraph", {
            inheritAllFrom: "$block"
          });
          t.conversion.elementToElement({
            model: "paragraph",
            view: "p"
          });
          t.conversion.for("upcast").elementToElement({
            model: function model(t, _ref39) {
              var e = _ref39.writer;
              if (!qy.paragraphLikeElements.has(t.name)) {
                return null;
              }
              if (t.isEmpty) {
                return null;
              }
              return e.createElement("paragraph");
            },
            view: /.+/,
            converterPriority: "low"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Paragraph";
        }
      }]);
      return qy;
    }(aC);
    qy.paragraphLikeElements = new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
    var Yy = /*#__PURE__*/function (_uC15) {
      _inherits(Yy, _uC15);
      function Yy(t, e) {
        var _this180;
        _classCallCheck(this, Yy);
        _this180 = _possibleConstructorReturn(this, _getPrototypeOf(Yy).call(this, t));
        _this180.modelElements = e;
        return _this180;
      }
      _createClass(Yy, [{
        key: "refresh",
        value: function refresh() {
          var _this181 = this;
          var t = nC(this.editor.model.document.selection.getSelectedBlocks());
          this.value = !!t && this.modelElements.includes(t.name) && t.name;
          this.isEnabled = !!t && this.modelElements.some(function (e) {
            return Qy(t, e, _this181.editor.model.schema);
          });
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = e.document;
          var o = t.value;
          e.change(function (t) {
            var i = Array.from(n.selection.getSelectedBlocks()).filter(function (t) {
              return Qy(t, o, e.schema);
            });
            var _iterator335 = _createForOfIteratorHelper(i),
              _step335;
            try {
              for (_iterator335.s(); !(_step335 = _iterator335.n()).done;) {
                var _e245 = _step335.value;
                if (!_e245.is("element", o)) {
                  t.rename(_e245, o);
                }
              }
            } catch (err) {
              _iterator335.e(err);
            } finally {
              _iterator335.f();
            }
          });
        }
      }]);
      return Yy;
    }(uC);
    function Qy(t, e, n) {
      return n.checkChild(t.parent, e) && !n.isObject(t);
    }
    var $y = "paragraph";
    var Zy = /*#__PURE__*/function (_aC31) {
      _inherits(Zy, _aC31);
      _createClass(Zy, null, [{
        key: "pluginName",
        get: function get() {
          return "HeadingEditing";
        }
      }]);
      function Zy(t) {
        var _this182;
        _classCallCheck(this, Zy);
        _this182 = _possibleConstructorReturn(this, _getPrototypeOf(Zy).call(this, t));
        t.config.define("heading", {
          options: [{
            model: "paragraph",
            title: "Paragraph",
            class: "ck-heading_paragraph"
          }, {
            model: "heading1",
            view: "h2",
            title: "Heading 1",
            class: "ck-heading_heading1"
          }, {
            model: "heading2",
            view: "h3",
            title: "Heading 2",
            class: "ck-heading_heading2"
          }, {
            model: "heading3",
            view: "h4",
            title: "Heading 3",
            class: "ck-heading_heading3"
          }]
        });
        return _this182;
      }
      _createClass(Zy, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.config.get("heading.options");
          var n = [];
          var _iterator336 = _createForOfIteratorHelper(e),
            _step336;
          try {
            for (_iterator336.s(); !(_step336 = _iterator336.n()).done;) {
              var _o157 = _step336.value;
              if (_o157.model !== $y) {
                t.model.schema.register(_o157.model, {
                  inheritAllFrom: "$block"
                });
                t.conversion.elementToElement(_o157);
                n.push(_o157.model);
              }
            }
          } catch (err) {
            _iterator336.e(err);
          } finally {
            _iterator336.f();
          }
          this._addDefaultH1Conversion(t);
          t.commands.add("heading", new Yy(t, n));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor;
          var e = t.commands.get("enter");
          var n = t.config.get("heading.options");
          if (e) {
            this.listenTo(e, "afterExecute", function (e, o) {
              var i = t.model.document.selection.getFirstPosition().parent;
              var r = n.some(function (t) {
                return i.is("element", t.model);
              });
              if (r && !i.is("element", $y) && i.childCount === 0) {
                o.writer.rename(i, $y);
              }
            });
          }
        }
      }, {
        key: "_addDefaultH1Conversion",
        value: function _addDefaultH1Conversion(t) {
          t.conversion.for("upcast").elementToElement({
            model: "heading1",
            view: "h1",
            converterPriority: is.get("low") + 1
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [qy];
        }
      }]);
      return Zy;
    }(aC);
    var Jy = function Jy(t, e) {
      _classCallCheck(this, Jy);
      if (e) {
        Kc(this, e);
      }
      if (t) {
        this.set(t);
      }
    };
    _s(Jy, Zc);
    function Xy(t) {
      var e = t.t;
      var n = {
        Paragraph: e("Paragraph"),
        "Heading 1": e("Heading 1"),
        "Heading 2": e("Heading 2"),
        "Heading 3": e("Heading 3"),
        "Heading 4": e("Heading 4"),
        "Heading 5": e("Heading 5"),
        "Heading 6": e("Heading 6")
      };
      return t.config.get("heading.options").map(function (t) {
        var e = n[t.title];
        if (e && e != t.title) {
          t.title = e;
        }
        return t;
      });
    }
    var tx = n(30);
    var ex = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    ex.insert = "head";
    ex.singleton = true;
    var nx = rk()(tx["a"], ex);
    var ox = tx["a"].locals || {};
    var ix = /*#__PURE__*/function (_aC32) {
      _inherits(ix, _aC32);
      function ix() {
        _classCallCheck(this, ix);
        return _possibleConstructorReturn(this, _getPrototypeOf(ix).apply(this, arguments));
      }
      _createClass(ix, [{
        key: "init",
        value: function init() {
          var _this183 = this;
          var t = this.editor;
          var e = t.t;
          var n = Xy(t);
          var o = e("Choose heading");
          var i = e("Heading");
          t.ui.componentFactory.add("heading", function (e) {
            var r = {};
            var s = new vs();
            var a = t.commands.get("heading");
            var c = t.commands.get("paragraph");
            var l = [a];
            var _iterator337 = _createForOfIteratorHelper(n),
              _step337;
            try {
              var _loop7 = function _loop7() {
                var t = _step337.value;
                var e = {
                  type: "button",
                  model: new Jy({
                    label: t.title,
                    class: t.class,
                    withText: true
                  })
                };
                if (t.model === "paragraph") {
                  e.model.bind("isOn").to(c, "value");
                  e.model.set("commandName", "paragraph");
                  l.push(c);
                } else {
                  e.model.bind("isOn").to(a, "value", function (e) {
                    return e === t.model;
                  });
                  e.model.set({
                    commandName: "heading",
                    commandValue: t.model
                  });
                }
                s.add(e);
                r[t.model] = t.title;
              };
              for (_iterator337.s(); !(_step337 = _iterator337.n()).done;) {
                _loop7();
              }
            } catch (err) {
              _iterator337.e(err);
            } finally {
              _iterator337.f();
            }
            var d = Nw(e);
            Bw(d, s);
            d.buttonView.set({
              isOn: false,
              withText: true,
              tooltip: i
            });
            d.extendTemplate({
              attributes: {
                class: ["ck-heading-dropdown"]
              }
            });
            d.bind("isEnabled").toMany(l, "isEnabled", function () {
              for (var _len18 = arguments.length, t = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
                t[_key18] = arguments[_key18];
              }
              return t.some(function (t) {
                return t;
              });
            });
            d.buttonView.bind("label").to(a, "value", c, "value", function (t, e) {
              var n = t || e && "paragraph";
              return r[n] ? r[n] : o;
            });
            _this183.listenTo(d, "execute", function (e) {
              t.execute(e.source.commandName, e.source.commandValue ? {
                value: e.source.commandValue
              } : undefined);
              t.editing.view.focus();
            });
            return d;
          });
        }
      }]);
      return ix;
    }(aC);
    var rx = /*#__PURE__*/function (_aC33) {
      _inherits(rx, _aC33);
      function rx() {
        _classCallCheck(this, rx);
        return _possibleConstructorReturn(this, _getPrototypeOf(rx).apply(this, arguments));
      }
      _createClass(rx, null, [{
        key: "requires",
        get: function get() {
          return [Zy, ix];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Heading";
        }
      }]);
      return rx;
    }(aC);
    var sx = '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2l2 2.038"/></svg>';
    var ax = n(31);
    var cx = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    cx.insert = "head";
    cx.singleton = true;
    var lx = rk()(ax["a"], cx);
    var dx = ax["a"].locals || {};
    var ux = ["before", "after"];
    var hx = new DOMParser().parseFromString(sx, "image/svg+xml").firstChild;
    var fx = "ck-widget__type-around_disabled";
    var mx = /*#__PURE__*/function (_aC34) {
      _inherits(mx, _aC34);
      _createClass(mx, null, [{
        key: "pluginName",
        get: function get() {
          return "WidgetTypeAround";
        }
      }]);
      function mx(t) {
        var _this184;
        _classCallCheck(this, mx);
        _this184 = _possibleConstructorReturn(this, _getPrototypeOf(mx).call(this, t));
        _this184._currentFakeCaretModelElement = null;
        return _this184;
      }
      _createClass(mx, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.editing.view;
          this.on("change:isEnabled", function (n, o, i) {
            e.change(function (t) {
              var _iterator338 = _createForOfIteratorHelper(e.document.roots),
                _step338;
              try {
                for (_iterator338.s(); !(_step338 = _iterator338.n()).done;) {
                  var _n228 = _step338.value;
                  if (i) {
                    t.removeClass(fx, _n228);
                  } else {
                    t.addClass(fx, _n228);
                  }
                }
              } catch (err) {
                _iterator338.e(err);
              } finally {
                _iterator338.f();
              }
            });
            if (!i) {
              t.model.change(function (t) {
                t.removeSelectionAttribute($C);
              });
            }
          });
          this._enableTypeAroundUIInjection();
          this._enableInsertingParagraphsOnButtonClick();
          this._enableInsertingParagraphsOnEnterKeypress();
          this._enableInsertingParagraphsOnTypingKeystroke();
          this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows();
          this._enableDeleteIntegration();
          this._enableInsertContentIntegration();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._currentFakeCaretModelElement = null;
        }
      }, {
        key: "_insertParagraph",
        value: function _insertParagraph(t, e) {
          var n = this.editor;
          var o = n.editing.view;
          n.execute("insertParagraph", {
            position: n.model.createPositionAt(t, e)
          });
          o.focus();
          o.scrollToTheSelection();
        }
      }, {
        key: "_listenToIfEnabled",
        value: function _listenToIfEnabled(t, e, n, o) {
          var _this185 = this;
          this.listenTo(t, e, function () {
            if (_this185.isEnabled) {
              n.apply(void 0, arguments);
            }
          }, o);
        }
      }, {
        key: "_insertParagraphAccordingToFakeCaretPosition",
        value: function _insertParagraphAccordingToFakeCaretPosition() {
          var t = this.editor;
          var e = t.model;
          var n = e.document.selection;
          var o = eA(n);
          if (!o) {
            return false;
          }
          var i = n.getSelectedElement();
          this._insertParagraph(i, o);
          return true;
        }
      }, {
        key: "_enableTypeAroundUIInjection",
        value: function _enableTypeAroundUIInjection() {
          var t = this.editor;
          var e = t.model.schema;
          var n = t.locale.t;
          var o = {
            before: n("Insert paragraph before block"),
            after: n("Insert paragraph after block")
          };
          t.editing.downcastDispatcher.on("insert", function (t, n, i) {
            var r = i.mapper.toViewElement(n.item);
            if (ZC(r, n.item, e)) {
              gx(i.writer, o, r);
            }
          }, {
            priority: "low"
          });
        }
      }, {
        key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
        value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          var _this186 = this;
          var t = this.editor;
          var e = t.model;
          var n = e.document.selection;
          var o = e.schema;
          var i = t.editing.view;
          this._listenToIfEnabled(i.document, "keydown", function (t, e) {
            if (Fl(e.keyCode)) {
              _this186._handleArrowKeyPress(t, e);
            }
          }, {
            priority: is.get("high") + 10
          });
          this._listenToIfEnabled(n, "change:range", function (e, n) {
            if (!n.directChange) {
              return;
            }
            t.model.change(function (t) {
              t.removeSelectionAttribute($C);
            });
          });
          this._listenToIfEnabled(e.document, "change:data", function () {
            var e = n.getSelectedElement();
            if (e) {
              var _n229 = t.editing.mapper.toViewElement(e);
              if (ZC(_n229, e, o)) {
                return;
              }
            }
            t.model.change(function (t) {
              t.removeSelectionAttribute($C);
            });
          });
          this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", function (t, e, n) {
            var i = n.writer;
            if (_this186._currentFakeCaretModelElement) {
              var _t267 = n.mapper.toViewElement(_this186._currentFakeCaretModelElement);
              if (_t267) {
                i.removeClass(ux.map(r), _t267);
                _this186._currentFakeCaretModelElement = null;
              }
            }
            var s = e.selection.getSelectedElement();
            if (!s) {
              return;
            }
            var a = n.mapper.toViewElement(s);
            if (!ZC(a, s, o)) {
              return;
            }
            var c = eA(e.selection);
            if (!c) {
              return;
            }
            i.addClass(r(c), a);
            _this186._currentFakeCaretModelElement = s;
          });
          this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", function (e, n, o) {
            if (!o) {
              t.model.change(function (t) {
                t.removeSelectionAttribute($C);
              });
            }
          });
          function r(t) {
            return "ck-widget_type-around_show-fake-caret_".concat(t);
          }
        }
      }, {
        key: "_handleArrowKeyPress",
        value: function _handleArrowKeyPress(t, e) {
          var n = this.editor;
          var o = n.model;
          var i = o.document.selection;
          var r = o.schema;
          var s = n.editing.view;
          var a = e.keyCode;
          var c = Ul(a, n.locale.contentLanguageDirection);
          var l = s.document.selection.getSelectedElement();
          var d = n.editing.mapper.toModelElement(l);
          var u;
          if (ZC(l, d, r)) {
            u = this._handleArrowKeyPressOnSelectedWidget(c);
          } else if (i.isCollapsed) {
            u = this._handleArrowKeyPressWhenSelectionNextToAWidget(c);
          }
          if (u) {
            e.preventDefault();
            t.stop();
          }
        }
      }, {
        key: "_handleArrowKeyPressOnSelectedWidget",
        value: function _handleArrowKeyPressOnSelectedWidget(t) {
          var e = this.editor;
          var n = e.model;
          var o = n.document.selection;
          var i = eA(o);
          return n.change(function (e) {
            if (i) {
              var _n230 = i === (t ? "after" : "before");
              if (!_n230) {
                e.removeSelectionAttribute($C);
                return true;
              }
            } else {
              e.setSelectionAttribute($C, t ? "after" : "before");
              return true;
            }
            return false;
          });
        }
      }, {
        key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
        value: function _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
          var e = this.editor;
          var n = e.model;
          var o = n.schema;
          var i = e.plugins.get("Widget");
          var r = i._getObjectElementNextToSelection(t);
          var s = e.editing.mapper.toViewElement(r);
          if (ZC(s, r, o)) {
            n.change(function (e) {
              i._setSelectionOverElement(r);
              e.setSelectionAttribute($C, t ? "before" : "after");
            });
            return true;
          }
          return false;
        }
      }, {
        key: "_enableInsertingParagraphsOnButtonClick",
        value: function _enableInsertingParagraphsOnButtonClick() {
          var _this187 = this;
          var t = this.editor;
          var e = t.editing.view;
          this._listenToIfEnabled(e.document, "mousedown", function (n, o) {
            var i = JC(o.domTarget);
            if (!i) {
              return;
            }
            var r = XC(i);
            var s = tA(i, e.domConverter);
            var a = t.editing.mapper.toModelElement(s);
            _this187._insertParagraph(a, r);
            o.preventDefault();
            n.stop();
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnEnterKeypress",
        value: function _enableInsertingParagraphsOnEnterKeypress() {
          var _this188 = this;
          var t = this.editor;
          var e = t.editing.view;
          this._listenToIfEnabled(e.document, "enter", function (n, o) {
            var i = e.document.selection.getSelectedElement();
            var r = t.editing.mapper.toModelElement(i);
            var s = t.model.schema;
            var a;
            if (_this188._insertParagraphAccordingToFakeCaretPosition()) {
              a = true;
            } else if (ZC(i, r, s)) {
              _this188._insertParagraph(r, o.isSoft ? "before" : "after");
              a = true;
            }
            if (a) {
              o.preventDefault();
              n.stop();
            }
          });
        }
      }, {
        key: "_enableInsertingParagraphsOnTypingKeystroke",
        value: function _enableInsertingParagraphsOnTypingKeystroke() {
          var _this189 = this;
          var t = this.editor;
          var e = t.editing.view;
          var n = [Ll.enter, Ll.delete, Ll.backspace];
          this._listenToIfEnabled(e.document, "keydown", function (t, e) {
            if (!n.includes(e.keyCode) && !KA(e)) {
              _this189._insertParagraphAccordingToFakeCaretPosition();
            }
          }, {
            priority: is.get("high") + 1
          });
        }
      }, {
        key: "_enableDeleteIntegration",
        value: function _enableDeleteIntegration() {
          var t = this.editor;
          var e = t.editing.view;
          var n = t.model;
          var o = n.schema;
          this._listenToIfEnabled(e.document, "delete", function (e, i) {
            var r = eA(n.document.selection);
            if (!r) {
              return;
            }
            var s = i.direction;
            var a = n.document.selection.getSelectedElement();
            var c = r === "before";
            var l = s == "forward";
            var d = c === l;
            if (d) {
              t.execute("delete", {
                selection: n.createSelection(a, "on")
              });
            } else {
              var _e246 = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
              if (_e246) {
                if (!_e246.isCollapsed) {
                  n.change(function (n) {
                    n.setSelection(_e246);
                    t.execute(l ? "forwardDelete" : "delete");
                  });
                } else {
                  var _i128 = n.createSelection(_e246.start);
                  n.modifySelection(_i128, {
                    direction: s
                  });
                  if (!_i128.focus.isEqual(_e246.start)) {
                    n.change(function (n) {
                      n.setSelection(_e246);
                      t.execute(l ? "forwardDelete" : "delete");
                    });
                  } else {
                    var _t268 = bx(o, _e246.start.parent);
                    n.deleteContent(n.createSelection(_t268, "on"), {
                      doNotAutoparagraph: true
                    });
                  }
                }
              }
            }
            i.preventDefault();
            e.stop();
          }, {
            priority: is.get("high") + 1
          });
        }
      }, {
        key: "_enableInsertContentIntegration",
        value: function _enableInsertContentIntegration() {
          var t = this.editor;
          var e = this.editor.model;
          var n = e.document.selection;
          this._listenToIfEnabled(t.model, "insertContent", function (t, _ref40) {
            var _ref41 = _slicedToArray(_ref40, 2),
              o = _ref41[0],
              i = _ref41[1];
            if (i && !i.is("documentSelection")) {
              return;
            }
            var r = eA(n);
            if (!r) {
              return;
            }
            t.stop();
            return e.change(function (t) {
              var i = n.getSelectedElement();
              var s = e.createPositionAt(i, r);
              var a = t.createSelection(s);
              var c = e.insertContent(o, a);
              t.setSelection(a);
              return c;
            });
          }, {
            priority: "high"
          });
        }
      }]);
      return mx;
    }(aC);
    function gx(t, e, n) {
      var o = t.createUIElement("div", {
        class: "ck ck-reset_all ck-widget__type-around"
      }, function (t) {
        var n = this.toDomElement(t);
        px(n, e);
        kx(n);
        return n;
      });
      t.insert(t.createPositionAt(n, "end"), o);
    }
    function px(t, e) {
      for (var _i129 = 0, _ux = ux; _i129 < _ux.length; _i129++) {
        var _n231 = _ux[_i129];
        var _o158 = new yk({
          tag: "div",
          attributes: {
            class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(_n231)],
            title: e[_n231]
          },
          children: [t.ownerDocument.importNode(hx, true)]
        });
        t.appendChild(_o158.render());
      }
    }
    function kx(t) {
      var e = new yk({
        tag: "div",
        attributes: {
          class: ["ck", "ck-widget__type-around__fake-caret"]
        }
      });
      t.appendChild(e.render());
    }
    function bx(t, e) {
      var n = e;
      var _iterator339 = _createForOfIteratorHelper(e.getAncestors({
          parentFirst: true
        })),
        _step339;
      try {
        for (_iterator339.s(); !(_step339 = _iterator339.n()).done;) {
          var _o159 = _step339.value;
          if (_o159.childCount > 1 || t.isLimit(_o159)) {
            break;
          }
          n = _o159;
        }
      } catch (err) {
        _iterator339.e(err);
      } finally {
        _iterator339.f();
      }
      return n;
    }
    var wx = n(32);
    var Cx = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Cx.insert = "head";
    Cx.singleton = true;
    var Ax = rk()(wx["a"], Cx);
    var _x = wx["a"].locals || {};
    function vx(t) {
      var e = t.model;
      return function (n, o) {
        var i = o.keyCode == Ll.arrowup;
        var r = o.keyCode == Ll.arrowdown;
        var s = o.shiftKey;
        var a = e.document.selection;
        if (!i && !r) {
          return;
        }
        var c = r;
        if (s && Mx(a, c)) {
          return;
        }
        var l = yx(t, a, c);
        if (!l || l.isCollapsed) {
          return;
        }
        if (Ex(t, l, c)) {
          e.change(function (t) {
            var n = c ? l.end : l.start;
            if (s) {
              var _o160 = e.createSelection(a.anchor);
              _o160.setFocus(n);
              t.setSelection(_o160);
            } else {
              t.setSelection(n);
            }
          });
          n.stop();
          o.preventDefault();
          o.stopPropagation();
        }
      };
    }
    function yx(t, e, n) {
      var o = t.model;
      if (n) {
        var _t269 = e.isCollapsed ? e.focus : e.getLastPosition();
        var _n232 = xx(o, _t269, "forward");
        if (!_n232) {
          return null;
        }
        var _i130 = o.createRange(_t269, _n232);
        var _r49 = Dx(o.schema, _i130, "backward");
        if (_r49 && _t269.isBefore(_r49)) {
          return o.createRange(_t269, _r49);
        }
        return null;
      } else {
        var _t270 = e.isCollapsed ? e.focus : e.getFirstPosition();
        var _n233 = xx(o, _t270, "backward");
        if (!_n233) {
          return null;
        }
        var _i131 = o.createRange(_n233, _t270);
        var _r50 = Dx(o.schema, _i131, "forward");
        if (_r50 && _t270.isAfter(_r50)) {
          return o.createRange(_r50, _t270);
        }
        return null;
      }
    }
    function xx(t, e, n) {
      var o = t.schema;
      var i = t.createRangeIn(e.root);
      var r = n == "forward" ? "elementStart" : "elementEnd";
      var _iterator340 = _createForOfIteratorHelper(i.getWalker({
          startPosition: e,
          direction: n
        })),
        _step340;
      try {
        for (_iterator340.s(); !(_step340 = _iterator340.n()).done;) {
          var _step340$value = _step340.value,
            _t271 = _step340$value.previousPosition,
            _s35 = _step340$value.item,
            _a24 = _step340$value.type;
          if (o.isLimit(_s35) && !o.isInline(_s35)) {
            return _t271;
          }
          if (_a24 == r && o.isBlock(_s35)) {
            return null;
          }
        }
      } catch (err) {
        _iterator340.e(err);
      } finally {
        _iterator340.f();
      }
      return null;
    }
    function Dx(t, e, n) {
      var o = n == "backward" ? e.end : e.start;
      if (t.checkChild(o, "$text")) {
        return o;
      }
      var _iterator341 = _createForOfIteratorHelper(e.getWalker({
          direction: n
        })),
        _step341;
      try {
        for (_iterator341.s(); !(_step341 = _iterator341.n()).done;) {
          var _o161 = _step341.value.nextPosition;
          if (t.checkChild(_o161, "$text")) {
            return _o161;
          }
        }
      } catch (err) {
        _iterator341.e(err);
      } finally {
        _iterator341.f();
      }
    }
    function Ex(t, e, n) {
      var o = t.model;
      var i = t.view.domConverter;
      if (n) {
        var _t272 = o.createSelection(e.start);
        o.modifySelection(_t272);
        if (!_t272.focus.isAtEnd && !e.start.isEqual(_t272.focus)) {
          e = o.createRange(_t272.focus, e.end);
        }
      }
      var r = t.mapper.toViewRange(e);
      var s = i.viewRangeToDom(r);
      var a = Eh.getDomRangeRects(s);
      var c;
      var _iterator342 = _createForOfIteratorHelper(a),
        _step342;
      try {
        for (_iterator342.s(); !(_step342 = _iterator342.n()).done;) {
          var _t273 = _step342.value;
          if (c === undefined) {
            c = Math.round(_t273.bottom);
            continue;
          }
          if (Math.round(_t273.top) >= c) {
            return false;
          }
          c = Math.max(c, Math.round(_t273.bottom));
        }
      } catch (err) {
        _iterator342.e(err);
      } finally {
        _iterator342.f();
      }
      return true;
    }
    function Mx(t, e) {
      return !t.isCollapsed && t.isBackward == e;
    }
    var Sx = /*#__PURE__*/function (_aC35) {
      _inherits(Sx, _aC35);
      function Sx() {
        _classCallCheck(this, Sx);
        return _possibleConstructorReturn(this, _getPrototypeOf(Sx).apply(this, arguments));
      }
      _createClass(Sx, [{
        key: "init",
        value: function init() {
          var _this190 = this;
          var t = this.editor.editing.view;
          var e = t.document;
          this._previouslySelected = new Set();
          this.editor.editing.downcastDispatcher.on("selection", function (t, e, n) {
            _this190._clearPreviouslySelectedWidgets(n.writer);
            var o = n.writer;
            var i = o.document.selection;
            var r = i.getSelectedElement();
            var s = null;
            var _iterator343 = _createForOfIteratorHelper(i.getRanges()),
              _step343;
            try {
              for (_iterator343.s(); !(_step343 = _iterator343.n()).done;) {
                var _t274 = _step343.value;
                var _iterator344 = _createForOfIteratorHelper(_t274),
                  _step344;
                try {
                  for (_iterator344.s(); !(_step344 = _iterator344.n()).done;) {
                    var _e247 = _step344.value;
                    var _t275 = _e247.item;
                    if (iA(_t275) && !Ix(_t275, s)) {
                      o.addClass(oA, _t275);
                      _this190._previouslySelected.add(_t275);
                      s = _t275;
                      if (_t275 == r) {
                        o.setSelection(i.getRanges(), {
                          fake: true,
                          label: cA(r)
                        });
                      }
                    }
                  }
                } catch (err) {
                  _iterator344.e(err);
                } finally {
                  _iterator344.f();
                }
              }
            } catch (err) {
              _iterator343.e(err);
            } finally {
              _iterator343.f();
            }
          }, {
            priority: "low"
          });
          t.addObserver(NA);
          this.listenTo(e, "mousedown", function () {
            return _this190._onMousedown.apply(_this190, arguments);
          });
          this.listenTo(e, "keydown", function () {
            _this190._handleSelectionChangeOnArrowKeyPress.apply(_this190, arguments);
          }, {
            priority: "high"
          });
          this.listenTo(e, "keydown", function () {
            _this190._preventDefaultOnArrowKeyPress.apply(_this190, arguments);
          }, {
            priority: is.get("high") - 20
          });
          this.listenTo(e, "keydown", vx(this.editor.editing));
          this.listenTo(e, "delete", function (t, e) {
            if (_this190._handleDelete(e.direction == "forward")) {
              e.preventDefault();
              t.stop();
            }
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_onMousedown",
        value: function _onMousedown(t, e) {
          var n = this.editor;
          var o = n.editing.view;
          var i = o.document;
          var r = e.target;
          if (Tx(r)) {
            if ((El.isSafari || El.isGecko) && e.domEvent.detail >= 3) {
              var _t276 = n.editing.mapper;
              var _o162 = r.is("attributeElement") ? r.findAncestor(function (t) {
                return !t.is("attributeElement");
              }) : r;
              var _i132 = _t276.toModelElement(_o162);
              e.preventDefault();
              this.editor.model.change(function (t) {
                t.setSelection(_i132, "in");
              });
            }
            return;
          }
          if (!iA(r)) {
            r = r.findAncestor(iA);
            if (!r) {
              return;
            }
          }
          e.preventDefault();
          if (!i.isFocused) {
            o.focus();
          }
          var s = n.editing.mapper.toModelElement(r);
          this._setSelectionOverElement(s);
        }
      }, {
        key: "_handleSelectionChangeOnArrowKeyPress",
        value: function _handleSelectionChangeOnArrowKeyPress(t, e) {
          var n = e.keyCode;
          if (!Fl(n)) {
            return;
          }
          var o = this.editor.model;
          var i = o.schema;
          var r = o.document.selection;
          var s = r.getSelectedElement();
          var a = Ul(n, this.editor.locale.contentLanguageDirection);
          if (s && i.isObject(s)) {
            var _n234 = a ? r.getLastPosition() : r.getFirstPosition();
            var _s36 = i.getNearestSelectionRange(_n234, a ? "forward" : "backward");
            if (_s36) {
              o.change(function (t) {
                t.setSelection(_s36);
              });
              e.preventDefault();
              t.stop();
            }
            return;
          }
          if (!r.isCollapsed) {
            return;
          }
          var c = this._getObjectElementNextToSelection(a);
          if (c && i.isObject(c)) {
            this._setSelectionOverElement(c);
            e.preventDefault();
            t.stop();
          }
        }
      }, {
        key: "_preventDefaultOnArrowKeyPress",
        value: function _preventDefaultOnArrowKeyPress(t, e) {
          var n = e.keyCode;
          if (!Fl(n)) {
            return;
          }
          var o = this.editor.model;
          var i = o.schema;
          var r = o.document.selection.getSelectedElement();
          if (r && i.isObject(r)) {
            e.preventDefault();
            t.stop();
          }
        }
      }, {
        key: "_handleDelete",
        value: function _handleDelete(t) {
          var _this191 = this;
          if (this.editor.isReadOnly) {
            return;
          }
          var e = this.editor.model.document;
          var n = e.selection;
          if (!n.isCollapsed) {
            return;
          }
          var o = this._getObjectElementNextToSelection(t);
          if (o) {
            this.editor.model.change(function (t) {
              var e = n.anchor.parent;
              while (e.isEmpty) {
                var _n235 = e;
                e = _n235.parent;
                t.remove(_n235);
              }
              _this191._setSelectionOverElement(o);
            });
            return true;
          }
        }
      }, {
        key: "_setSelectionOverElement",
        value: function _setSelectionOverElement(t) {
          this.editor.model.change(function (e) {
            e.setSelection(e.createRangeOn(t));
          });
        }
      }, {
        key: "_getObjectElementNextToSelection",
        value: function _getObjectElementNextToSelection(t) {
          var e = this.editor.model;
          var n = e.schema;
          var o = e.document.selection;
          var i = e.createSelection(o);
          e.modifySelection(i, {
            direction: t ? "forward" : "backward"
          });
          var r = t ? i.focus.nodeBefore : i.focus.nodeAfter;
          if (!!r && n.isObject(r)) {
            return r;
          }
          return null;
        }
      }, {
        key: "_clearPreviouslySelectedWidgets",
        value: function _clearPreviouslySelectedWidgets(t) {
          var _iterator345 = _createForOfIteratorHelper(this._previouslySelected),
            _step345;
          try {
            for (_iterator345.s(); !(_step345 = _iterator345.n()).done;) {
              var _e248 = _step345.value;
              t.removeClass(oA, _e248);
            }
          } catch (err) {
            _iterator345.e(err);
          } finally {
            _iterator345.f();
          }
          this._previouslySelected.clear();
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "Widget";
        }
      }, {
        key: "requires",
        get: function get() {
          return [mx];
        }
      }]);
      return Sx;
    }(aC);
    function Tx(t) {
      while (t) {
        if (t.is("editableElement") && !t.is("rootElement")) {
          return true;
        }
        if (iA(t)) {
          return false;
        }
        t = t.parent;
      }
      return false;
    }
    function Ix(t, e) {
      if (!e) {
        return false;
      }
      return Array.from(t.getAncestors()).includes(e);
    }
    var Nx = /*#__PURE__*/function (_uC16) {
      _inherits(Nx, _uC16);
      function Nx() {
        _classCallCheck(this, Nx);
        return _possibleConstructorReturn(this, _getPrototypeOf(Nx).apply(this, arguments));
      }
      _createClass(Nx, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = bA(t);
          if (bA(t) && t.hasAttribute("alt")) {
            this.value = t.getAttribute("alt");
          } else {
            this.value = false;
          }
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = e.document.selection.getSelectedElement();
          e.change(function (e) {
            e.setAttribute("alt", t.newValue, n);
          });
        }
      }]);
      return Nx;
    }(uC);
    var Px = /*#__PURE__*/function (_aC36) {
      _inherits(Px, _aC36);
      function Px() {
        _classCallCheck(this, Px);
        return _possibleConstructorReturn(this, _getPrototypeOf(Px).apply(this, arguments));
      }
      _createClass(Px, [{
        key: "init",
        value: function init() {
          this.editor.commands.add("imageTextAlternative", new Nx(this.editor));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeEditing";
        }
      }]);
      return Px;
    }(aC);
    var Bx = n(33);
    var zx = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    zx.insert = "head";
    zx.singleton = true;
    var Lx = rk()(Bx["a"], zx);
    var Ox = Bx["a"].locals || {};
    var Rx = /*#__PURE__*/function (_tb18) {
      _inherits(Rx, _tb18);
      function Rx(t, e) {
        var _this192;
        _classCallCheck(this, Rx);
        _this192 = _possibleConstructorReturn(this, _getPrototypeOf(Rx).call(this, t));
        var n = "ck-labeled-field-view-".concat(ns());
        var o = "ck-labeled-field-view-status-".concat(ns());
        _this192.fieldView = e(_assertThisInitialized(_assertThisInitialized(_this192)), n, o);
        _this192.set("label");
        _this192.set("isEnabled", true);
        _this192.set("isEmpty", true);
        _this192.set("isFocused", false);
        _this192.set("errorText", null);
        _this192.set("infoText", null);
        _this192.set("class");
        _this192.set("placeholder");
        _this192.labelView = _this192._createLabelView(n);
        _this192.statusView = _this192._createStatusView(o);
        _this192.bind("_statusText").to(_assertThisInitialized(_assertThisInitialized(_this192)), "errorText", _assertThisInitialized(_assertThisInitialized(_this192)), "infoText", function (t, e) {
          return t || e;
        });
        var i = _this192.bindTemplate;
        _this192.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-labeled-field-view", i.to("class"), i.if("isEnabled", "ck-disabled", function (t) {
              return !t;
            }), i.if("isEmpty", "ck-labeled-field-view_empty"), i.if("isFocused", "ck-labeled-field-view_focused"), i.if("placeholder", "ck-labeled-field-view_placeholder"), i.if("errorText", "ck-error")]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__input-wrapper"]
            },
            children: [_this192.fieldView, _this192.labelView]
          }, _this192.statusView]
        });
        return _this192;
      }
      _createClass(Rx, [{
        key: "_createLabelView",
        value: function _createLabelView(t) {
          var e = new gb(this.locale);
          e.for = t;
          e.bind("text").to(this, "label");
          return e;
        }
      }, {
        key: "_createStatusView",
        value: function _createStatusView(t) {
          var e = new tb(this.locale);
          var n = this.bindTemplate;
          e.setTemplate({
            tag: "div",
            attributes: {
              class: ["ck", "ck-labeled-field-view__status", n.if("errorText", "ck-labeled-field-view__status_error"), n.if("_statusText", "ck-hidden", function (t) {
                return !t;
              })],
              id: t,
              role: n.if("errorText", "alert")
            },
            children: [{
              text: n.to("_statusText")
            }]
          });
          return e;
        }
      }, {
        key: "focus",
        value: function focus() {
          this.fieldView.focus();
        }
      }]);
      return Rx;
    }(tb);
    var jx = n(34);
    var Fx = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Fx.insert = "head";
    Fx.singleton = true;
    var Vx = rk()(jx["a"], Fx);
    var Ux = jx["a"].locals || {};
    var Hx = /*#__PURE__*/function (_tb19) {
      _inherits(Hx, _tb19);
      function Hx(t) {
        var _this193;
        _classCallCheck(this, Hx);
        _this193 = _possibleConstructorReturn(this, _getPrototypeOf(Hx).call(this, t));
        _this193.set("value");
        _this193.set("id");
        _this193.set("placeholder");
        _this193.set("isReadOnly", false);
        _this193.set("hasError", false);
        _this193.set("ariaDescribedById");
        _this193.focusTracker = new tk();
        _this193.bind("isFocused").to(_this193.focusTracker);
        _this193.set("isEmpty", true);
        var e = _this193.bindTemplate;
        _this193.setTemplate({
          tag: "input",
          attributes: {
            type: "text",
            class: ["ck", "ck-input", "ck-input-text", e.if("isFocused", "ck-input_focused"), e.if("isEmpty", "ck-input-text_empty"), e.if("hasError", "ck-error")],
            id: e.to("id"),
            placeholder: e.to("placeholder"),
            readonly: e.to("isReadOnly"),
            "aria-invalid": e.if("hasError", true),
            "aria-describedby": e.to("ariaDescribedById")
          },
          on: {
            input: e.to("input"),
            change: e.to(_this193._updateIsEmpty.bind(_assertThisInitialized(_assertThisInitialized(_this193))))
          }
        });
        return _this193;
      }
      _createClass(Hx, [{
        key: "render",
        value: function render() {
          var _this194 = this;
          _get(_getPrototypeOf(Hx.prototype), "render", this).call(this);
          this.focusTracker.add(this.element);
          this._setDomElementValue(this.value);
          this._updateIsEmpty();
          this.on("change:value", function (t, e, n) {
            _this194._setDomElementValue(n);
            _this194._updateIsEmpty();
          });
        }
      }, {
        key: "select",
        value: function select() {
          this.element.select();
        }
      }, {
        key: "focus",
        value: function focus() {
          this.element.focus();
        }
      }, {
        key: "_updateIsEmpty",
        value: function _updateIsEmpty() {
          this.isEmpty = Gx(this.element);
        }
      }, {
        key: "_setDomElementValue",
        value: function _setDomElementValue(t) {
          this.element.value = !t && t !== 0 ? "" : t;
        }
      }]);
      return Hx;
    }(tb);
    function Gx(t) {
      return !t.value;
    }
    function Wx(t, e, n) {
      var o = new Hx(t.locale);
      o.set({
        id: e,
        ariaDescribedById: n
      });
      o.bind("isReadOnly").to(t, "isEnabled", function (t) {
        return !t;
      });
      o.bind("hasError").to(t, "errorText", function (t) {
        return !!t;
      });
      o.on("input", function () {
        t.errorText = null;
      });
      t.bind("isEmpty", "isFocused", "placeholder").to(o);
      return o;
    }
    function Kx(t, e, n) {
      var o = Nw(t.locale);
      o.set({
        id: e,
        ariaDescribedById: n
      });
      o.bind("isEnabled").to(t);
      return o;
    }
    function qx(t) {
      t.set("_isCssTransitionsDisabled", false);
      t.disableCssTransitions = function () {
        t._isCssTransitionsDisabled = true;
      };
      t.enableCssTransitions = function () {
        t._isCssTransitionsDisabled = false;
      };
      t.extendTemplate({
        attributes: {
          class: [t.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")]
        }
      });
    }
    function Yx(_ref42) {
      var t = _ref42.view;
      t.listenTo(t.element, "submit", function (e, n) {
        n.preventDefault();
        t.fire("submit");
      }, {
        useCapture: true
      });
    }
    var Qx = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>';
    var $x = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.591 10.177l4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
    var Zx = n(35);
    var Jx = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    Jx.insert = "head";
    Jx.singleton = true;
    var Xx = rk()(Zx["a"], Jx);
    var tD = Zx["a"].locals || {};
    var eD = n(36);
    var nD = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    nD.insert = "head";
    nD.singleton = true;
    var oD = rk()(eD["a"], nD);
    var iD = eD["a"].locals || {};
    var rD = /*#__PURE__*/function (_tb20) {
      _inherits(rD, _tb20);
      function rD(t) {
        var _this195;
        _classCallCheck(this, rD);
        _this195 = _possibleConstructorReturn(this, _getPrototypeOf(rD).call(this, t));
        var e = _this195.locale.t;
        _this195.focusTracker = new tk();
        _this195.keystrokes = new Vp();
        _this195.labeledInput = _this195._createLabeledInputView();
        _this195.saveButtonView = _this195._createButton(e("Save"), Qx, "ck-button-save");
        _this195.saveButtonView.type = "submit";
        _this195.cancelButtonView = _this195._createButton(e("Cancel"), $x, "ck-button-cancel", "cancel");
        _this195._focusables = new Ak();
        _this195._focusCycler = new Db({
          focusables: _this195._focusables,
          focusTracker: _this195.focusTracker,
          keystrokeHandler: _this195.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        _this195.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-text-alternative-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this195.labeledInput, _this195.saveButtonView, _this195.cancelButtonView]
        });
        qx(_assertThisInitialized(_assertThisInitialized(_this195)));
        return _this195;
      }
      _createClass(rD, [{
        key: "render",
        value: function render() {
          var _this196 = this;
          _get(_getPrototypeOf(rD.prototype), "render", this).call(this);
          this.keystrokes.listenTo(this.element);
          Yx({
            view: this
          });
          [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach(function (t) {
            _this196._focusables.add(t);
            _this196.focusTracker.add(t.element);
          });
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new cw(this.locale);
          i.set({
            label: t,
            icon: e,
            tooltip: true
          });
          i.extendTemplate({
            attributes: {
              class: n
            }
          });
          if (o) {
            i.delegate("execute").to(this, o);
          }
          return i;
        }
      }, {
        key: "_createLabeledInputView",
        value: function _createLabeledInputView() {
          var t = this.locale.t;
          var e = new Rx(this.locale, Wx);
          e.label = t("Text alternative");
          return e;
        }
      }]);
      return rD;
    }(tb);
    var sD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>';
    var aD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>';
    var cD = n(37);
    var lD = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    lD.insert = "head";
    lD.singleton = true;
    var dD = rk()(cD["a"], lD);
    var uD = cD["a"].locals || {};
    var hD = n(38);
    var fD = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    fD.insert = "head";
    fD.singleton = true;
    var mD = rk()(hD["a"], fD);
    var gD = hD["a"].locals || {};
    var pD = wb("px");
    var kD = /*#__PURE__*/function (_aC37) {
      _inherits(kD, _aC37);
      _createClass(kD, null, [{
        key: "pluginName",
        get: function get() {
          return "ContextualBalloon";
        }
      }]);
      function kD(t) {
        var _this197;
        _classCallCheck(this, kD);
        _this197 = _possibleConstructorReturn(this, _getPrototypeOf(kD).call(this, t));
        _this197.positionLimiter = function () {
          var t = _this197.editor.editing.view;
          var e = t.document;
          var n = e.selection.editableElement;
          if (n) {
            return t.domConverter.mapViewToDom(n.root);
          }
          return null;
        };
        _this197.set("visibleView", null);
        _this197.view = new WC(t.locale);
        t.ui.view.body.add(_this197.view);
        t.ui.focusTracker.add(_this197.view.element);
        _this197._viewToStack = new Map();
        _this197._idToStack = new Map();
        _this197.set("_numberOfStacks", 0);
        _this197.set("_singleViewMode", false);
        _this197._rotatorView = _this197._createRotatorView();
        _this197._fakePanelsView = _this197._createFakePanelsView();
        return _this197;
      }
      _createClass(kD, [{
        key: "hasView",
        value: function hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t);
        }
      }, {
        key: "add",
        value: function add(t) {
          if (this.hasView(t.view)) {
            throw new ss["a"]("contextualballoon-add-view-exist", [this, t]);
          }
          var e = t.stackId || "main";
          if (!this._idToStack.has(e)) {
            this._idToStack.set(e, new Map([[t.view, t]]));
            this._viewToStack.set(t.view, this._idToStack.get(e));
            this._numberOfStacks = this._idToStack.size;
            if (!this._visibleStack || t.singleViewMode) {
              this.showStack(e);
            }
            return;
          }
          var n = this._idToStack.get(e);
          if (t.singleViewMode) {
            this.showStack(e);
          }
          n.set(t.view, t);
          this._viewToStack.set(t.view, n);
          if (n === this._visibleStack) {
            this._showView(t);
          }
        }
      }, {
        key: "remove",
        value: function remove(t) {
          if (!this.hasView(t)) {
            throw new ss["a"]("contextualballoon-remove-view-not-exist", [this, t]);
          }
          var e = this._viewToStack.get(t);
          if (this._singleViewMode && this.visibleView === t) {
            this._singleViewMode = false;
          }
          if (this.visibleView === t) {
            if (e.size === 1) {
              if (this._idToStack.size > 1) {
                this._showNextStack();
              } else {
                this.view.hide();
                this.visibleView = null;
                this._rotatorView.hideView();
              }
            } else {
              this._showView(Array.from(e.values())[e.size - 2]);
            }
          }
          if (e.size === 1) {
            this._idToStack.delete(this._getStackId(e));
            this._numberOfStacks = this._idToStack.size;
          } else {
            e.delete(t);
          }
          this._viewToStack.delete(t);
        }
      }, {
        key: "updatePosition",
        value: function updatePosition(t) {
          if (t) {
            this._visibleStack.get(this.visibleView).position = t;
          }
          this.view.pin(this._getBalloonPosition());
          this._fakePanelsView.updatePosition();
        }
      }, {
        key: "showStack",
        value: function showStack(t) {
          this.visibleStack = t;
          var e = this._idToStack.get(t);
          if (!e) {
            throw new ss["a"]("contextualballoon-showstack-stack-not-exist", this);
          }
          if (this._visibleStack === e) {
            return;
          }
          this._showView(Array.from(e.values()).pop());
        }
      }, {
        key: "_getStackId",
        value: function _getStackId(t) {
          var e = Array.from(this._idToStack.entries()).find(function (e) {
            return e[1] === t;
          });
          return e[0];
        }
      }, {
        key: "_showNextStack",
        value: function _showNextStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) + 1;
          if (!t[e]) {
            e = 0;
          }
          this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_showPrevStack",
        value: function _showPrevStack() {
          var t = Array.from(this._idToStack.values());
          var e = t.indexOf(this._visibleStack) - 1;
          if (!t[e]) {
            e = t.length - 1;
          }
          this.showStack(this._getStackId(t[e]));
        }
      }, {
        key: "_createRotatorView",
        value: function _createRotatorView() {
          var _this198 = this;
          var t = new bD(this.editor.locale);
          var e = this.editor.locale.t;
          this.view.content.add(t);
          t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            return !e && t > 1;
          });
          t.on("change:isNavigationVisible", function () {
            return _this198.updatePosition();
          }, {
            priority: "low"
          });
          t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", function (t, n) {
            if (n < 2) {
              return "";
            }
            var o = Array.from(_this198._idToStack.values()).indexOf(_this198._visibleStack) + 1;
            return e("%0 of %1", [o, n]);
          });
          t.buttonNextView.on("execute", function () {
            if (t.focusTracker.isFocused) {
              _this198.editor.editing.view.focus();
            }
            _this198._showNextStack();
          });
          t.buttonPrevView.on("execute", function () {
            if (t.focusTracker.isFocused) {
              _this198.editor.editing.view.focus();
            }
            _this198._showPrevStack();
          });
          return t;
        }
      }, {
        key: "_createFakePanelsView",
        value: function _createFakePanelsView() {
          var t = new wD(this.editor.locale, this.view);
          t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", function (t, e) {
            var n = !e && t >= 2;
            return n ? Math.min(t - 1, 2) : 0;
          });
          t.listenTo(this.view, "change:top", function () {
            return t.updatePosition();
          });
          t.listenTo(this.view, "change:left", function () {
            return t.updatePosition();
          });
          this.editor.ui.view.body.add(t);
          return t;
        }
      }, {
        key: "_showView",
        value: function _showView(_ref43) {
          var t = _ref43.view,
            _ref43$balloonClassNa = _ref43.balloonClassName,
            e = _ref43$balloonClassNa === void 0 ? "" : _ref43$balloonClassNa,
            _ref43$withArrow = _ref43.withArrow,
            n = _ref43$withArrow === void 0 ? true : _ref43$withArrow,
            _ref43$singleViewMode = _ref43.singleViewMode,
            o = _ref43$singleViewMode === void 0 ? false : _ref43$singleViewMode;
          this.view.class = e;
          this.view.withArrow = n;
          this._rotatorView.showView(t);
          this.visibleView = t;
          this.view.pin(this._getBalloonPosition());
          this._fakePanelsView.updatePosition();
          if (o) {
            this._singleViewMode = true;
          }
        }
      }, {
        key: "_getBalloonPosition",
        value: function _getBalloonPosition() {
          var t = Array.from(this._visibleStack.values()).pop().position;
          if (t && !t.limiter) {
            t = Object.assign({}, t, {
              limiter: this.positionLimiter
            });
          }
          return t;
        }
      }, {
        key: "_visibleStack",
        get: function get() {
          return this._viewToStack.get(this.visibleView);
        }
      }]);
      return kD;
    }(aC);
    var bD = /*#__PURE__*/function (_tb21) {
      _inherits(bD, _tb21);
      function bD(t) {
        var _this199;
        _classCallCheck(this, bD);
        _this199 = _possibleConstructorReturn(this, _getPrototypeOf(bD).call(this, t));
        var e = t.t;
        var n = _this199.bindTemplate;
        _this199.set("isNavigationVisible", true);
        _this199.focusTracker = new tk();
        _this199.buttonPrevView = _this199._createButtonView(e("Previous"), sD);
        _this199.buttonNextView = _this199._createButtonView(e("Next"), aD);
        _this199.content = _this199.createCollection();
        _this199.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-balloon-rotator"],
            "z-index": "-1"
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-balloon-rotator__navigation", n.to("isNavigationVisible", function (t) {
                return t ? "" : "ck-hidden";
              })]
            },
            children: [_this199.buttonPrevView, {
              tag: "span",
              attributes: {
                class: ["ck-balloon-rotator__counter"]
              },
              children: [{
                text: n.to("counter")
              }]
            }, _this199.buttonNextView]
          }, {
            tag: "div",
            attributes: {
              class: "ck-balloon-rotator__content"
            },
            children: _this199.content
          }]
        });
        return _this199;
      }
      _createClass(bD, [{
        key: "render",
        value: function render() {
          _get(_getPrototypeOf(bD.prototype), "render", this).call(this);
          this.focusTracker.add(this.element);
        }
      }, {
        key: "showView",
        value: function showView(t) {
          this.hideView();
          this.content.add(t);
        }
      }, {
        key: "hideView",
        value: function hideView() {
          this.content.clear();
        }
      }, {
        key: "_createButtonView",
        value: function _createButtonView(t, e) {
          var n = new cw(this.locale);
          n.set({
            label: t,
            icon: e,
            tooltip: true
          });
          return n;
        }
      }]);
      return bD;
    }(tb);
    var wD = /*#__PURE__*/function (_tb22) {
      _inherits(wD, _tb22);
      function wD(t, e) {
        var _this200;
        _classCallCheck(this, wD);
        _this200 = _possibleConstructorReturn(this, _getPrototypeOf(wD).call(this, t));
        var n = _this200.bindTemplate;
        _this200.set("top", 0);
        _this200.set("left", 0);
        _this200.set("height", 0);
        _this200.set("width", 0);
        _this200.set("numberOfPanels", 0);
        _this200.content = _this200.createCollection();
        _this200._balloonPanelView = e;
        _this200.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-fake-panel", n.to("numberOfPanels", function (t) {
              return t ? "" : "ck-hidden";
            })],
            style: {
              top: n.to("top", pD),
              left: n.to("left", pD),
              width: n.to("width", pD),
              height: n.to("height", pD)
            }
          },
          children: _this200.content
        });
        _this200.on("change:numberOfPanels", function (t, e, n, o) {
          if (n > o) {
            _this200._addPanels(n - o);
          } else {
            _this200._removePanels(o - n);
          }
          _this200.updatePosition();
        });
        return _this200;
      }
      _createClass(wD, [{
        key: "_addPanels",
        value: function _addPanels(t) {
          while (t--) {
            var _t277 = new tb();
            _t277.setTemplate({
              tag: "div"
            });
            this.content.add(_t277);
            this.registerChild(_t277);
          }
        }
      }, {
        key: "_removePanels",
        value: function _removePanels(t) {
          while (t--) {
            var _t278 = this.content.last;
            this.content.remove(_t278);
            this.deregisterChild(_t278);
            _t278.destroy();
          }
        }
      }, {
        key: "updatePosition",
        value: function updatePosition() {
          if (this.numberOfPanels) {
            var _this$_balloonPanelVi = this._balloonPanelView,
              _t279 = _this$_balloonPanelVi.top,
              _e249 = _this$_balloonPanelVi.left;
            var _Eh = new Eh(this._balloonPanelView.element),
              _n236 = _Eh.width,
              _o163 = _Eh.height;
            Object.assign(this, {
              top: _t279,
              left: _e249,
              width: _n236,
              height: _o163
            });
          }
        }
      }]);
      return wD;
    }(tb);
    var CD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22L2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21l-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
    function AD(t) {
      var e = t.plugins.get("ContextualBalloon");
      if (kA(t.editing.view.document.selection)) {
        var _n237 = _D(t);
        e.updatePosition(_n237);
      }
    }
    function _D(t) {
      var e = t.editing.view;
      var n = WC.defaultPositions;
      return {
        target: e.domConverter.viewToDom(e.document.selection.getSelectedElement()),
        positions: [n.northArrowSouth, n.northArrowSouthWest, n.northArrowSouthEast, n.southArrowNorth, n.southArrowNorthWest, n.southArrowNorthEast]
      };
    }
    var vD = /*#__PURE__*/function (_aC38) {
      _inherits(vD, _aC38);
      function vD() {
        _classCallCheck(this, vD);
        return _possibleConstructorReturn(this, _getPrototypeOf(vD).apply(this, arguments));
      }
      _createClass(vD, [{
        key: "init",
        value: function init() {
          this._createButton();
          this._createForm();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(vD.prototype), "destroy", this).call(this);
          this._form.destroy();
        }
      }, {
        key: "_createButton",
        value: function _createButton() {
          var _this201 = this;
          var t = this.editor;
          var e = t.t;
          t.ui.componentFactory.add("imageTextAlternative", function (n) {
            var o = t.commands.get("imageTextAlternative");
            var i = new cw(n);
            i.set({
              label: e("Change image text alternative"),
              icon: CD,
              tooltip: true
            });
            i.bind("isEnabled").to(o, "isEnabled");
            _this201.listenTo(i, "execute", function () {
              _this201._showForm();
            });
            return i;
          });
        }
      }, {
        key: "_createForm",
        value: function _createForm() {
          var _this202 = this;
          var t = this.editor;
          var e = t.editing.view;
          var n = e.document;
          this._balloon = this.editor.plugins.get("ContextualBalloon");
          this._form = new rD(t.locale);
          this._form.render();
          this.listenTo(this._form, "submit", function () {
            t.execute("imageTextAlternative", {
              newValue: _this202._form.labeledInput.fieldView.element.value
            });
            _this202._hideForm(true);
          });
          this.listenTo(this._form, "cancel", function () {
            _this202._hideForm(true);
          });
          this._form.keystrokes.set("Esc", function (t, e) {
            _this202._hideForm(true);
            e();
          });
          this.listenTo(t.ui, "update", function () {
            if (!kA(n.selection)) {
              _this202._hideForm(true);
            } else if (_this202._isVisible) {
              AD(t);
            }
          });
          vw({
            emitter: this._form,
            activator: function activator() {
              return _this202._isVisible;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this202._hideForm();
            }
          });
        }
      }, {
        key: "_showForm",
        value: function _showForm() {
          if (this._isVisible) {
            return;
          }
          var t = this.editor;
          var e = t.commands.get("imageTextAlternative");
          var n = this._form.labeledInput;
          this._form.disableCssTransitions();
          if (!this._isInBalloon) {
            this._balloon.add({
              view: this._form,
              position: _D(t)
            });
          }
          n.fieldView.value = n.fieldView.element.value = e.value || "";
          this._form.labeledInput.fieldView.select();
          this._form.enableCssTransitions();
        }
      }, {
        key: "_hideForm",
        value: function _hideForm(t) {
          if (!this._isInBalloon) {
            return;
          }
          if (this._form.focusTracker.isFocused) {
            this._form.saveButtonView.focus();
          }
          this._balloon.remove(this._form);
          if (t) {
            this.editor.editing.view.focus();
          }
        }
      }, {
        key: "_isVisible",
        get: function get() {
          return this._balloon.visibleView === this._form;
        }
      }, {
        key: "_isInBalloon",
        get: function get() {
          return this._balloon.hasView(this._form);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [kD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternativeUI";
        }
      }]);
      return vD;
    }(aC);
    var yD = /*#__PURE__*/function (_aC39) {
      _inherits(yD, _aC39);
      function yD() {
        _classCallCheck(this, yD);
        return _possibleConstructorReturn(this, _getPrototypeOf(yD).apply(this, arguments));
      }
      _createClass(yD, null, [{
        key: "requires",
        get: function get() {
          return [Px, vD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageTextAlternative";
        }
      }]);
      return yD;
    }(aC);
    var xD = n(39);
    var DD = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    DD.insert = "head";
    DD.singleton = true;
    var ED = rk()(xD["a"], DD);
    var MD = xD["a"].locals || {};
    var SD = /*#__PURE__*/function (_aC40) {
      _inherits(SD, _aC40);
      function SD() {
        _classCallCheck(this, SD);
        return _possibleConstructorReturn(this, _getPrototypeOf(SD).apply(this, arguments));
      }
      _createClass(SD, null, [{
        key: "requires",
        get: function get() {
          return [TA, Sx, yD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Image";
        }
      }]);
      return SD;
    }(aC);
    function TD(t, e) {
      return function (n) {
        var o = n.createEditableElement("figcaption");
        n.setCustomProperty("imageCaption", true, o);
        uk({
          view: t,
          element: o,
          text: e
        });
        return lA(o, n);
      };
    }
    function ID(t) {
      return !!t.getCustomProperty("imageCaption");
    }
    function ND(t) {
      var _iterator346 = _createForOfIteratorHelper(t.getChildren()),
        _step346;
      try {
        for (_iterator346.s(); !(_step346 = _iterator346.n()).done;) {
          var _e250 = _step346.value;
          if (!!_e250 && _e250.is("element", "caption")) {
            return _e250;
          }
        }
      } catch (err) {
        _iterator346.e(err);
      } finally {
        _iterator346.f();
      }
      return null;
    }
    function PD(t) {
      var e = t.parent;
      if (t.name == "figcaption" && e && e.name == "figure" && e.hasClass("image")) {
        return {
          name: true
        };
      }
      return null;
    }
    var BD = /*#__PURE__*/function (_aC41) {
      _inherits(BD, _aC41);
      function BD() {
        _classCallCheck(this, BD);
        return _possibleConstructorReturn(this, _getPrototypeOf(BD).apply(this, arguments));
      }
      _createClass(BD, [{
        key: "init",
        value: function init() {
          var _this203 = this;
          var t = this.editor;
          var e = t.editing.view;
          var n = t.model.schema;
          var o = t.data;
          var i = t.editing;
          var r = t.t;
          n.register("caption", {
            allowIn: "image",
            allowContentOf: "$block",
            isLimit: true
          });
          t.model.document.registerPostFixer(function (t) {
            return _this203._insertMissingModelCaptionElement(t);
          });
          t.conversion.for("upcast").elementToElement({
            view: PD,
            model: "caption"
          });
          var s = function s(t) {
            return t.createContainerElement("figcaption");
          };
          o.downcastDispatcher.on("insert:caption", zD(s, false));
          var a = TD(e, r("Enter image caption"));
          i.downcastDispatcher.on("insert:caption", zD(a));
          i.downcastDispatcher.on("insert", this._fixCaptionVisibility(function (t) {
            return t.item;
          }), {
            priority: "high"
          });
          i.downcastDispatcher.on("remove", this._fixCaptionVisibility(function (t) {
            return t.position.parent;
          }), {
            priority: "high"
          });
          e.document.registerPostFixer(function (t) {
            return _this203._updateCaptionVisibility(t);
          });
        }
      }, {
        key: "_updateCaptionVisibility",
        value: function _updateCaptionVisibility(t) {
          var e = this.editor.editing.mapper;
          var n = this._lastSelectedCaption;
          var o;
          var i = this.editor.model.document.selection;
          var r = i.getSelectedElement();
          if (r && r.is("element", "image")) {
            var _t280 = ND(r);
            o = e.toViewElement(_t280);
          }
          var s = i.getFirstPosition();
          var a = OD(s.parent);
          if (a) {
            o = e.toViewElement(a);
          }
          if (o) {
            if (n) {
              if (n === o) {
                return jD(o, t);
              } else {
                RD(n, t);
                this._lastSelectedCaption = o;
                return jD(o, t);
              }
            } else {
              this._lastSelectedCaption = o;
              return jD(o, t);
            }
          } else {
            if (n) {
              var _e251 = RD(n, t);
              this._lastSelectedCaption = null;
              return _e251;
            } else {
              return false;
            }
          }
        }
      }, {
        key: "_fixCaptionVisibility",
        value: function _fixCaptionVisibility(t) {
          var _this204 = this;
          return function (e, n, o) {
            var i = t(n);
            var r = OD(i);
            var s = _this204.editor.editing.mapper;
            var a = o.writer;
            if (r) {
              var _t281 = s.toViewElement(r);
              if (_t281) {
                if (r.childCount) {
                  a.removeClass("ck-hidden", _t281);
                } else {
                  a.addClass("ck-hidden", _t281);
                }
              }
            }
          };
        }
      }, {
        key: "_insertMissingModelCaptionElement",
        value: function _insertMissingModelCaptionElement(t) {
          var e = this.editor.model;
          var n = e.document.differ.getChanges();
          var o = [];
          var _iterator347 = _createForOfIteratorHelper(n),
            _step347;
          try {
            for (_iterator347.s(); !(_step347 = _iterator347.n()).done;) {
              var _t282 = _step347.value;
              if (_t282.type == "insert" && _t282.name != "$text") {
                var _n238 = _t282.position.nodeAfter;
                if (_n238.is("element", "image") && !ND(_n238)) {
                  o.push(_n238);
                }
                if (!_n238.is("element", "image") && _n238.childCount) {
                  var _iterator348 = _createForOfIteratorHelper(e.createRangeIn(_n238).getItems()),
                    _step348;
                  try {
                    for (_iterator348.s(); !(_step348 = _iterator348.n()).done;) {
                      var _t283 = _step348.value;
                      if (_t283.is("element", "image") && !ND(_t283)) {
                        o.push(_t283);
                      }
                    }
                  } catch (err) {
                    _iterator348.e(err);
                  } finally {
                    _iterator348.f();
                  }
                }
              }
            }
          } catch (err) {
            _iterator347.e(err);
          } finally {
            _iterator347.f();
          }
          for (var _i133 = 0, _o164 = o; _i133 < _o164.length; _i133++) {
            var _e252 = _o164[_i133];
            t.appendElement("caption", _e252);
          }
          return !!o.length;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageCaptionEditing";
        }
      }]);
      return BD;
    }(aC);
    function zD(t) {
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return function (n, o, i) {
        var r = o.item;
        if (!r.childCount && !e) {
          return;
        }
        if (bA(r.parent)) {
          if (!i.consumable.consume(o.item, "insert")) {
            return;
          }
          var _e253 = i.mapper.toViewElement(o.range.start.parent);
          var _n239 = t(i.writer);
          var _s37 = i.writer;
          if (!r.childCount) {
            _s37.addClass("ck-hidden", _n239);
          }
          LD(_n239, o.item, _e253, i);
        }
      };
    }
    function LD(t, e, n, o) {
      var i = o.writer.createPositionAt(n, "end");
      o.writer.insert(i, t);
      o.mapper.bindElements(e, t);
    }
    function OD(t) {
      var e = t.getAncestors({
        includeSelf: true
      });
      var n = e.find(function (t) {
        return t.name == "caption";
      });
      if (n && n.parent && n.parent.name == "image") {
        return n;
      }
      return null;
    }
    function RD(t, e) {
      if (!t.childCount && !t.hasClass("ck-hidden")) {
        e.addClass("ck-hidden", t);
        return true;
      }
      return false;
    }
    function jD(t, e) {
      if (t.hasClass("ck-hidden")) {
        e.removeClass("ck-hidden", t);
        return true;
      }
      return false;
    }
    var FD = n(40);
    var VD = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    VD.insert = "head";
    VD.singleton = true;
    var UD = rk()(FD["a"], VD);
    var HD = FD["a"].locals || {};
    var GD = /*#__PURE__*/function (_aC42) {
      _inherits(GD, _aC42);
      function GD() {
        _classCallCheck(this, GD);
        return _possibleConstructorReturn(this, _getPrototypeOf(GD).apply(this, arguments));
      }
      _createClass(GD, null, [{
        key: "requires",
        get: function get() {
          return [BD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageCaption";
        }
      }]);
      return GD;
    }(aC);
    var WD = /*#__PURE__*/function (_uC17) {
      _inherits(WD, _uC17);
      function WD() {
        _classCallCheck(this, WD);
        return _possibleConstructorReturn(this, _getPrototypeOf(WD).apply(this, arguments));
      }
      _createClass(WD, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = bA(t);
          if (!t || !t.hasAttribute("width")) {
            this.value = null;
          } else {
            this.value = {
              width: t.getAttribute("width"),
              height: null
            };
          }
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = e.document.selection.getSelectedElement();
          this.value = {
            width: t.width,
            height: null
          };
          if (n) {
            e.change(function (e) {
              e.setAttribute("width", t.width, n);
            });
          }
        }
      }]);
      return WD;
    }(uC);
    var KD = /*#__PURE__*/function (_aC43) {
      _inherits(KD, _aC43);
      _createClass(KD, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageResizeEditing";
        }
      }]);
      function KD(t) {
        var _this205;
        _classCallCheck(this, KD);
        _this205 = _possibleConstructorReturn(this, _getPrototypeOf(KD).call(this, t));
        t.config.define("image", {
          resizeUnit: "%",
          resizeOptions: [{
            name: "imageResize:original",
            value: null,
            icon: "original"
          }, {
            name: "imageResize:25",
            value: "25",
            icon: "small"
          }, {
            name: "imageResize:50",
            value: "50",
            icon: "medium"
          }, {
            name: "imageResize:75",
            value: "75",
            icon: "large"
          }]
        });
        return _this205;
      }
      _createClass(KD, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = new WD(t);
          this._registerSchema();
          this._registerConverters();
          t.commands.add("imageResize", e);
        }
      }, {
        key: "_registerSchema",
        value: function _registerSchema() {
          this.editor.model.schema.extend("image", {
            allowAttributes: "width"
          });
          this.editor.model.schema.setAttributeProperties("width", {
            isFormatting: true
          });
        }
      }, {
        key: "_registerConverters",
        value: function _registerConverters() {
          var t = this.editor;
          t.conversion.for("downcast").add(function (t) {
            return t.on("attribute:width:image", function (t, e, n) {
              if (!n.consumable.consume(e.item, t.name)) {
                return;
              }
              var o = n.writer;
              var i = n.mapper.toViewElement(e.item);
              if (e.attributeNewValue !== null) {
                o.setStyle("width", e.attributeNewValue, i);
                o.addClass("image_resized", i);
              } else {
                o.removeStyle("width", i);
                o.removeClass("image_resized", i);
              }
            });
          });
          t.conversion.for("upcast").attributeToAttribute({
            view: {
              name: "figure",
              styles: {
                width: /.+/
              }
            },
            model: {
              key: "width",
              value: function value(t) {
                return t.getStyle("width");
              }
            }
          });
        }
      }]);
      return KD;
    }(aC);
    var qD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>';
    var YD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>';
    var QD = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>';
    var $D = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>';
    var ZD = {
      small: qD,
      medium: YD,
      large: QD,
      original: $D
    };
    var JD = /*#__PURE__*/function (_aC44) {
      _inherits(JD, _aC44);
      _createClass(JD, null, [{
        key: "requires",
        get: function get() {
          return [KD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageResizeButtons";
        }
      }]);
      function JD(t) {
        var _this206;
        _classCallCheck(this, JD);
        _this206 = _possibleConstructorReturn(this, _getPrototypeOf(JD).call(this, t));
        _this206._resizeUnit = t.config.get("image.resizeUnit");
        return _this206;
      }
      _createClass(JD, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.config.get("image.resizeOptions");
          var n = t.commands.get("imageResize");
          this.bind("isEnabled").to(n);
          var _iterator349 = _createForOfIteratorHelper(e),
            _step349;
          try {
            for (_iterator349.s(); !(_step349 = _iterator349.n()).done;) {
              var _t284 = _step349.value;
              this._registerImageResizeButton(_t284);
            }
          } catch (err) {
            _iterator349.e(err);
          } finally {
            _iterator349.f();
          }
          this._registerImageResizeDropdown(e);
        }
      }, {
        key: "_registerImageResizeButton",
        value: function _registerImageResizeButton(t) {
          var _this207 = this;
          var e = this.editor;
          var n = t.name,
            o = t.value,
            i = t.icon;
          var r = o ? o + this._resizeUnit : null;
          e.ui.componentFactory.add(n, function (n) {
            var o = new cw(n);
            var s = e.commands.get("imageResize");
            var a = _this207._getOptionLabelValue(t, true);
            if (!ZD[i]) {
              throw new ss["a"]("imageresizebuttons-missing-icon", e, t);
            }
            o.set({
              label: a,
              icon: ZD[i],
              tooltip: a,
              isToggleable: true
            });
            o.bind("isEnabled").to(_this207);
            o.bind("isOn").to(s, "value", XD(r));
            _this207.listenTo(o, "execute", function () {
              e.execute("imageResize", {
                width: r
              });
            });
            return o;
          });
        }
      }, {
        key: "_registerImageResizeDropdown",
        value: function _registerImageResizeDropdown(t) {
          var _this208 = this;
          var e = this.editor;
          var n = e.t;
          var o = t.find(function (t) {
            return !t.value;
          });
          e.ui.componentFactory.add("imageResize", function (i) {
            var r = e.commands.get("imageResize");
            var s = Nw(i, dw);
            var a = s.buttonView;
            a.set({
              tooltip: n("Resize image"),
              commandValue: o.value,
              icon: YD,
              isToggleable: true,
              label: _this208._getOptionLabelValue(o),
              withText: true,
              class: "ck-resize-image-button"
            });
            a.bind("label").to(r, "value", function (t) {
              if (t && t.width) {
                return t.width;
              } else {
                return _this208._getOptionLabelValue(o);
              }
            });
            s.bind("isOn").to(r);
            s.bind("isEnabled").to(_this208);
            Bw(s, _this208._getResizeDropdownListItemDefinitions(t, r));
            s.listView.ariaLabel = n("Image resize list");
            _this208.listenTo(s, "execute", function (t) {
              e.execute(t.source.commandName, {
                width: t.source.commandValue
              });
              e.editing.view.focus();
            });
            return s;
          });
        }
      }, {
        key: "_getOptionLabelValue",
        value: function _getOptionLabelValue(t, e) {
          var n = this.editor.t;
          if (t.label) {
            return t.label;
          } else if (e) {
            if (t.value) {
              return n("Resize image to %0", t.value + this._resizeUnit);
            } else {
              return n("Resize image to the original size");
            }
          } else {
            if (t.value) {
              return t.value + this._resizeUnit;
            } else {
              return n("Original");
            }
          }
        }
      }, {
        key: "_getResizeDropdownListItemDefinitions",
        value: function _getResizeDropdownListItemDefinitions(t, e) {
          var _this209 = this;
          var n = new vs();
          t.map(function (t) {
            var o = t.value ? t.value + _this209._resizeUnit : null;
            var i = {
              type: "button",
              model: new Jy({
                commandName: "imageResize",
                commandValue: o,
                label: _this209._getOptionLabelValue(t),
                withText: true,
                icon: null
              })
            };
            i.model.bind("isOn").to(e, "value", XD(o));
            n.add(i);
          });
          return n;
        }
      }]);
      return JD;
    }(aC);
    function XD(t) {
      return function (e) {
        if (t === null && e === t) {
          return true;
        }
        return e && e.width === t;
      };
    }
    var tE = /*#__PURE__*/function () {
      function tE(t) {
        _classCallCheck(this, tE);
        this.set("activeHandlePosition", null);
        this.set("proposedWidthPercents", null);
        this.set("proposedWidth", null);
        this.set("proposedHeight", null);
        this.set("proposedHandleHostWidth", null);
        this.set("proposedHandleHostHeight", null);
        this._options = t;
        this._referenceCoordinates = null;
      }
      _createClass(tE, [{
        key: "begin",
        value: function begin(t, e, n) {
          var o = new Eh(e);
          this.activeHandlePosition = iE(t);
          this._referenceCoordinates = nE(e, rE(this.activeHandlePosition));
          this.originalWidth = o.width;
          this.originalHeight = o.height;
          this.aspectRatio = o.width / o.height;
          var i = n.style.width;
          if (i && i.match(/^\d+\.?\d*%$/)) {
            this.originalWidthPercents = parseFloat(i);
          } else {
            this.originalWidthPercents = eE(n, o);
          }
        }
      }, {
        key: "update",
        value: function update(t) {
          this.proposedWidth = t.width;
          this.proposedHeight = t.height;
          this.proposedWidthPercents = t.widthPercents;
          this.proposedHandleHostWidth = t.handleHostWidth;
          this.proposedHandleHostHeight = t.handleHostHeight;
        }
      }]);
      return tE;
    }();
    _s(tE, Zc);
    function eE(t, e) {
      var n = t.parentElement;
      var o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width);
      return e.width / o * 100;
    }
    function nE(t, e) {
      var n = new Eh(t);
      var o = e.split("-");
      var i = {
        x: o[1] == "right" ? n.right : n.left,
        y: o[0] == "bottom" ? n.bottom : n.top
      };
      i.x += t.ownerDocument.defaultView.scrollX;
      i.y += t.ownerDocument.defaultView.scrollY;
      return i;
    }
    function oE(t) {
      return "ck-widget__resizer__handle-".concat(t);
    }
    function iE(t) {
      var e = ["top-left", "top-right", "bottom-right", "bottom-left"];
      for (var _i134 = 0, _e254 = e; _i134 < _e254.length; _i134++) {
        var _n240 = _e254[_i134];
        if (t.classList.contains(oE(_n240))) {
          return _n240;
        }
      }
    }
    function rE(t) {
      var e = t.split("-");
      var n = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      };
      return "".concat(n[e[0]], "-").concat(n[e[1]]);
    }
    var sE = /*#__PURE__*/function () {
      function sE(t) {
        var _this210 = this;
        _classCallCheck(this, sE);
        this._options = t;
        this._domResizerWrapper = null;
        this._viewResizerWrapper = null;
        this.set("isEnabled", true);
        this.decorate("begin");
        this.decorate("cancel");
        this.decorate("commit");
        this.decorate("updateSize");
        this.on("commit", function (t) {
          if (!_this210.state.proposedWidth && !_this210.state.proposedWidthPercents) {
            _this210._cleanup();
            t.stop();
          }
        }, {
          priority: "high"
        });
        this.on("change:isEnabled", function () {
          if (_this210.isEnabled) {
            _this210.redraw();
          }
        });
      }
      _createClass(sE, [{
        key: "attach",
        value: function attach() {
          var _this211 = this;
          var t = this;
          var e = this._options.viewElement;
          var n = this._options.editor.editing.view;
          n.change(function (n) {
            var o = n.createUIElement("div", {
              class: "ck ck-reset_all ck-widget__resizer"
            }, function (e) {
              var n = this.toDomElement(e);
              t._appendHandles(n);
              t._appendSizeUI(n);
              t._domResizerWrapper = n;
              t.on("change:isEnabled", function (t, e, o) {
                n.style.display = o ? "" : "none";
              });
              n.style.display = t.isEnabled ? "" : "none";
              return n;
            });
            n.insert(n.createPositionAt(e, "end"), o);
            n.addClass("ck-widget_with-resizer", e);
            _this211._viewResizerWrapper = o;
          });
        }
      }, {
        key: "begin",
        value: function begin(t) {
          this.state = new tE(this._options);
          this._sizeUI.bindToState(this._options, this.state);
          this._initialViewWidth = this._options.viewElement.getStyle("width");
          this.state.begin(t, this._getHandleHost(), this._getResizeHost());
        }
      }, {
        key: "updateSize",
        value: function updateSize(t) {
          var _this212 = this;
          var e = this._proposeNewSize(t);
          var n = this._options.editor.editing.view;
          n.change(function (t) {
            var n = _this212._options.unit || "%";
            var o = (n === "%" ? e.widthPercents : e.width) + n;
            t.setStyle("width", o, _this212._options.viewElement);
          });
          var o = this._getHandleHost();
          var i = new Eh(o);
          e.handleHostWidth = Math.round(i.width);
          e.handleHostHeight = Math.round(i.height);
          var r = new Eh(o);
          e.width = Math.round(r.width);
          e.height = Math.round(r.height);
          this.redraw(i);
          this.state.update(e);
        }
      }, {
        key: "commit",
        value: function commit() {
          var _this213 = this;
          var t = this._options.unit || "%";
          var e = (t === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + t;
          this._options.editor.editing.view.change(function () {
            _this213._cleanup();
            _this213._options.onCommit(e);
          });
        }
      }, {
        key: "cancel",
        value: function cancel() {
          this._cleanup();
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this.cancel();
        }
      }, {
        key: "redraw",
        value: function redraw(t) {
          var e = this._domResizerWrapper;
          if (!dE(e)) {
            return;
          }
          var n = e.parentElement;
          var o = this._getHandleHost();
          var i = this._viewResizerWrapper;
          var r = [i.getStyle("width"), i.getStyle("height"), i.getStyle("left"), i.getStyle("top")];
          var s;
          if (n.isSameNode(o)) {
            var _e255 = t || new Eh(o);
            s = [_e255.width + "px", _e255.height + "px", undefined, undefined];
          } else {
            s = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];
          }
          if (Ls(r, s) !== "same") {
            this._options.editor.editing.view.change(function (t) {
              t.setStyle({
                width: s[0],
                height: s[1],
                left: s[2],
                top: s[3]
              }, i);
            });
          }
        }
      }, {
        key: "containsHandle",
        value: function containsHandle(t) {
          return this._domResizerWrapper.contains(t);
        }
      }, {
        key: "_cleanup",
        value: function _cleanup() {
          var _this214 = this;
          this._sizeUI.dismiss();
          this._sizeUI.isVisible = false;
          var t = this._options.editor.editing.view;
          t.change(function (t) {
            t.setStyle("width", _this214._initialViewWidth, _this214._options.viewElement);
          });
        }
      }, {
        key: "_proposeNewSize",
        value: function _proposeNewSize(t) {
          var e = this.state;
          var n = lE(t);
          var o = this._options.isCentered ? this._options.isCentered(this) : true;
          var i = {
            x: e._referenceCoordinates.x - (n.x + e.originalWidth),
            y: n.y - e.originalHeight - e._referenceCoordinates.y
          };
          if (o && e.activeHandlePosition.endsWith("-right")) {
            i.x = n.x - (e._referenceCoordinates.x + e.originalWidth);
          }
          if (o) {
            i.x *= 2;
          }
          var r = {
            width: Math.abs(e.originalWidth + i.x),
            height: Math.abs(e.originalHeight + i.y)
          };
          r.dominant = r.width / e.aspectRatio > r.height ? "width" : "height";
          r.max = r[r.dominant];
          var s = {
            width: r.width,
            height: r.height
          };
          if (r.dominant == "width") {
            s.height = s.width / e.aspectRatio;
          } else {
            s.width = s.height * e.aspectRatio;
          }
          return {
            width: Math.round(s.width),
            height: Math.round(s.height),
            widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * s.width * 100) / 100, 100)
          };
        }
      }, {
        key: "_getResizeHost",
        value: function _getResizeHost() {
          var t = this._domResizerWrapper.parentElement;
          return this._options.getResizeHost(t);
        }
      }, {
        key: "_getHandleHost",
        value: function _getHandleHost() {
          var t = this._domResizerWrapper.parentElement;
          return this._options.getHandleHost(t);
        }
      }, {
        key: "_appendHandles",
        value: function _appendHandles(t) {
          var e = ["top-left", "top-right", "bottom-right", "bottom-left"];
          for (var _i135 = 0, _e256 = e; _i135 < _e256.length; _i135++) {
            var _n241 = _e256[_i135];
            t.appendChild(new yk({
              tag: "div",
              attributes: {
                class: "ck-widget__resizer__handle ".concat(cE(_n241))
              }
            }).render());
          }
        }
      }, {
        key: "_appendSizeUI",
        value: function _appendSizeUI(t) {
          var e = new aE();
          e.render();
          this._sizeUI = e;
          t.appendChild(e.element);
        }
      }], [{
        key: "isResizeHandle",
        value: function isResizeHandle(t) {
          return t.classList.contains("ck-widget__resizer__handle");
        }
      }]);
      return sE;
    }();
    _s(sE, Zc);
    var aE = /*#__PURE__*/function (_tb23) {
      _inherits(aE, _tb23);
      function aE() {
        var _this215;
        _classCallCheck(this, aE);
        _this215 = _possibleConstructorReturn(this, _getPrototypeOf(aE).call(this));
        var t = _this215.bindTemplate;
        _this215.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-size-view", t.to("activeHandlePosition", function (t) {
              return t ? "ck-orientation-".concat(t) : "";
            })],
            style: {
              display: t.if("isVisible", "none", function (t) {
                return !t;
              })
            }
          },
          children: [{
            text: t.to("label")
          }]
        });
        return _this215;
      }
      _createClass(aE, [{
        key: "bindToState",
        value: function bindToState(t, e) {
          this.bind("isVisible").to(e, "proposedWidth", e, "proposedHeight", function (t, e) {
            return t !== null && e !== null;
          });
          this.bind("label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", function (e, n, o) {
            if (t.unit === "px") {
              return "".concat(e, "\xD7").concat(n);
            } else {
              return "".concat(o, "%");
            }
          });
          this.bind("activeHandlePosition").to(e);
        }
      }, {
        key: "dismiss",
        value: function dismiss() {
          this.unbind();
          this.isVisible = false;
        }
      }]);
      return aE;
    }(tb);
    function cE(t) {
      return "ck-widget__resizer__handle-".concat(t);
    }
    function lE(t) {
      return {
        x: t.pageX,
        y: t.pageY
      };
    }
    function dE(t) {
      return t && t.ownerDocument && t.ownerDocument.contains(t);
    }
    var uE = "Expected a function";
    function hE(t, e, n) {
      var o = true,
        i = true;
      if (typeof t != "function") {
        throw new TypeError(uE);
      }
      if (ct(n)) {
        o = "leading" in n ? !!n.leading : o;
        i = "trailing" in n ? !!n.trailing : i;
      }
      return bh(t, e, {
        leading: o,
        maxWait: e,
        trailing: i
      });
    }
    var fE = hE;
    var mE = n(41);
    var gE = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    gE.insert = "head";
    gE.singleton = true;
    var pE = rk()(mE["a"], gE);
    var kE = mE["a"].locals || {};
    var bE = /*#__PURE__*/function (_aC45) {
      _inherits(bE, _aC45);
      function bE() {
        _classCallCheck(this, bE);
        return _possibleConstructorReturn(this, _getPrototypeOf(bE).apply(this, arguments));
      }
      _createClass(bE, [{
        key: "init",
        value: function init() {
          var _this216 = this;
          this.set("visibleResizer", null);
          this.set("_activeResizer", null);
          this._resizers = new Map();
          var t = jd.window.document;
          this.editor.model.schema.setAttributeProperties("width", {
            isFormatting: true
          });
          this.editor.editing.view.addObserver(NA);
          this._observer = Object.create(Zd);
          this.listenTo(this.editor.editing.view.document, "mousedown", this._mouseDownListener.bind(this), {
            priority: "high"
          });
          this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this));
          this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this));
          var e = function e() {
            if (_this216.visibleResizer) {
              _this216.visibleResizer.redraw();
            }
          };
          var n = fE(e, 200);
          this.on("change:visibleResizer", e);
          this.editor.ui.on("update", n);
          this._observer.listenTo(jd.window, "resize", n);
          var o = this.editor.editing.view.document.selection;
          o.on("change", function () {
            var t = o.getSelectedElement();
            _this216.visibleResizer = _this216.getResizerByViewElement(t) || null;
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          this._observer.stopListening();
          var _iterator350 = _createForOfIteratorHelper(this._resizers.values()),
            _step350;
          try {
            for (_iterator350.s(); !(_step350 = _iterator350.n()).done;) {
              var _t285 = _step350.value;
              _t285.destroy();
            }
          } catch (err) {
            _iterator350.e(err);
          } finally {
            _iterator350.f();
          }
        }
      }, {
        key: "attachTo",
        value: function attachTo(t) {
          var e = new sE(t);
          var n = this.editor.plugins;
          e.attach();
          if (n.has("WidgetToolbarRepository")) {
            var _t286 = n.get("WidgetToolbarRepository");
            e.on("begin", function () {
              _t286.forceDisabled("resize");
            }, {
              priority: "lowest"
            });
            e.on("cancel", function () {
              _t286.clearForceDisabled("resize");
            }, {
              priority: "highest"
            });
            e.on("commit", function () {
              _t286.clearForceDisabled("resize");
            }, {
              priority: "highest"
            });
          }
          this._resizers.set(t.viewElement, e);
          var o = this.editor.editing.view.document.selection;
          var i = o.getSelectedElement();
          if (this.getResizerByViewElement(i) == e) {
            this.visibleResizer = e;
          }
          return e;
        }
      }, {
        key: "getResizerByViewElement",
        value: function getResizerByViewElement(t) {
          return this._resizers.get(t);
        }
      }, {
        key: "_getResizerByHandle",
        value: function _getResizerByHandle(t) {
          var _iterator351 = _createForOfIteratorHelper(this._resizers.values()),
            _step351;
          try {
            for (_iterator351.s(); !(_step351 = _iterator351.n()).done;) {
              var _e257 = _step351.value;
              if (_e257.containsHandle(t)) {
                return _e257;
              }
            }
          } catch (err) {
            _iterator351.e(err);
          } finally {
            _iterator351.f();
          }
        }
      }, {
        key: "_mouseDownListener",
        value: function _mouseDownListener(t, e) {
          var n = e.domTarget;
          if (!sE.isResizeHandle(n)) {
            return;
          }
          this._activeResizer = this._getResizerByHandle(n);
          if (this._activeResizer) {
            this._activeResizer.begin(n);
            t.stop();
            e.preventDefault();
          }
        }
      }, {
        key: "_mouseMoveListener",
        value: function _mouseMoveListener(t, e) {
          if (this._activeResizer) {
            this._activeResizer.updateSize(e);
          }
        }
      }, {
        key: "_mouseUpListener",
        value: function _mouseUpListener() {
          if (this._activeResizer) {
            this._activeResizer.commit();
            this._activeResizer = null;
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "WidgetResize";
        }
      }]);
      return bE;
    }(aC);
    _s(bE, Zc);
    var wE = /*#__PURE__*/function (_aC46) {
      _inherits(wE, _aC46);
      function wE() {
        _classCallCheck(this, wE);
        return _possibleConstructorReturn(this, _getPrototypeOf(wE).apply(this, arguments));
      }
      _createClass(wE, [{
        key: "init",
        value: function init() {
          var t = this.editor.commands.get("imageResize");
          this.bind("isEnabled").to(t);
          this._setupResizerCreator();
        }
      }, {
        key: "_setupResizerCreator",
        value: function _setupResizerCreator() {
          var _this217 = this;
          var t = this.editor;
          var e = t.editing.view;
          e.addObserver(BC);
          this.listenTo(e.document, "imageLoaded", function (n, o) {
            if (!o.target.matches("figure.image.ck-widget > img")) {
              return;
            }
            var i = t.editing.view.domConverter.domToView(o.target);
            var r = i.findAncestor("figure");
            var s = _this217.editor.plugins.get(bE).getResizerByViewElement(r);
            if (s) {
              s.redraw();
              return;
            }
            var a = t.editing.mapper;
            var c = a.toModelElement(r);
            s = t.plugins.get(bE).attachTo({
              unit: t.config.get("image.resizeUnit"),
              modelElement: c,
              viewElement: r,
              editor: t,
              getHandleHost: function getHandleHost(t) {
                return t.querySelector("img");
              },
              getResizeHost: function getResizeHost(t) {
                return t;
              },
              isCentered: function isCentered() {
                var t = c.getAttribute("imageStyle");
                return !t || t == "full" || t == "alignCenter";
              },
              onCommit: function onCommit(e) {
                t.execute("imageResize", {
                  width: e
                });
              }
            });
            s.on("updateSize", function () {
              if (!r.hasClass("image_resized")) {
                e.change(function (t) {
                  t.addClass("image_resized", r);
                });
              }
            });
            s.bind("isEnabled").to(_this217);
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [bE];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageResizeHandles";
        }
      }]);
      return wE;
    }(aC);
    var CE = n(42);
    var AE = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    AE.insert = "head";
    AE.singleton = true;
    var _E = rk()(CE["a"], AE);
    var vE = CE["a"].locals || {};
    var yE = /*#__PURE__*/function (_aC47) {
      _inherits(yE, _aC47);
      function yE() {
        _classCallCheck(this, yE);
        return _possibleConstructorReturn(this, _getPrototypeOf(yE).apply(this, arguments));
      }
      _createClass(yE, null, [{
        key: "requires",
        get: function get() {
          return [KD, wE, JD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageResize";
        }
      }]);
      return yE;
    }(aC);
    var xE = /*#__PURE__*/function (_uC18) {
      _inherits(xE, _uC18);
      function xE(t, e) {
        var _this218;
        _classCallCheck(this, xE);
        _this218 = _possibleConstructorReturn(this, _getPrototypeOf(xE).call(this, t));
        _this218.defaultStyle = false;
        _this218.styles = e.reduce(function (t, e) {
          t[e.name] = e;
          if (e.isDefault) {
            _this218.defaultStyle = e.name;
          }
          return t;
        }, {});
        return _this218;
      }
      _createClass(xE, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          this.isEnabled = bA(t);
          if (!t) {
            this.value = false;
          } else if (t.hasAttribute("imageStyle")) {
            var _e258 = t.getAttribute("imageStyle");
            this.value = this.styles[_e258] ? _e258 : false;
          } else {
            this.value = this.defaultStyle;
          }
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _this219 = this;
          var e = t.value;
          var n = this.editor.model;
          var o = n.document.selection.getSelectedElement();
          n.change(function (t) {
            if (_this219.styles[e].isDefault) {
              t.removeAttribute("imageStyle", o);
            } else {
              t.setAttribute("imageStyle", e, o);
            }
          });
        }
      }]);
      return xE;
    }(uC);
    function DE(t) {
      return function (e, n, o) {
        if (!o.consumable.consume(n.item, e.name)) {
          return;
        }
        var i = ME(n.attributeNewValue, t);
        var r = ME(n.attributeOldValue, t);
        var s = o.mapper.toViewElement(n.item);
        var a = o.writer;
        if (r) {
          a.removeClass(r.className, s);
        }
        if (i) {
          a.addClass(i.className, s);
        }
      };
    }
    function EE(t) {
      var e = t.filter(function (t) {
        return !t.isDefault;
      });
      return function (t, n, o) {
        if (!n.modelRange) {
          return;
        }
        var i = n.viewItem;
        var r = nC(n.modelRange.getItems());
        if (!o.schema.checkAttribute(r, "imageStyle")) {
          return;
        }
        var _iterator352 = _createForOfIteratorHelper(e),
          _step352;
        try {
          for (_iterator352.s(); !(_step352 = _iterator352.n()).done;) {
            var _t287 = _step352.value;
            if (o.consumable.consume(i, {
              classes: _t287.className
            })) {
              o.writer.setAttribute("imageStyle", _t287.name, r);
            }
          }
        } catch (err) {
          _iterator352.e(err);
        } finally {
          _iterator352.f();
        }
      };
    }
    function ME(t, e) {
      var _iterator353 = _createForOfIteratorHelper(e),
        _step353;
      try {
        for (_iterator353.s(); !(_step353 = _iterator353.n()).done;) {
          var _n242 = _step353.value;
          if (_n242.name === t) {
            return _n242;
          }
        }
      } catch (err) {
        _iterator353.e(err);
      } finally {
        _iterator353.f();
      }
    }
    var SE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm2.5 3V12h11V7.5h-11zM4.061 6H15.94c.586 0 1.061.407 1.061.91v5.68c0 .503-.475.91-1.061.91H4.06c-.585 0-1.06-.407-1.06-.91V6.91C3 6.406 3.475 6 4.061 6zM2 16.5V15h16v1.5z"/></svg>';
    var TE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path d="M18 4.5V3H2v1.5h16zm0 3V6h-5.674v1.5H18zm0 3V9h-5.674v1.5H18zm0 3V12h-5.674v1.5H18zm-8.5-6V12h-6V7.5h6zm.818-1.5H2.682C2.305 6 2 6.407 2 6.91v5.68c0 .503.305.91.682.91h7.636c.377 0 .682-.407.682-.91V6.91c0-.503-.305-.91-.682-.91zM18 16.5V15H2v1.5h16z"/></svg>';
    var IE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm4.5 3V12h7V7.5h-7zM5.758 6h8.484c.419 0 .758.407.758.91v5.681c0 .502-.34.909-.758.909H5.758c-.419 0-.758-.407-.758-.91V6.91c0-.503.34-.91.758-.91zM2 16.5V15h16v1.5z"/></svg>';
    var NE = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 4.5V3h16v1.5zm0 3V6h5.674v1.5zm0 3V9h5.674v1.5zm0 3V12h5.674v1.5zm8.5-6V12h6V7.5h-6zM9.682 6h7.636c.377 0 .682.407.682.91v5.68c0 .503-.305.91-.682.91H9.682c-.377 0-.682-.407-.682-.91V6.91c0-.503.305-.91.682-.91zM2 16.5V15h16v1.5z"/></svg>';
    var PE = {
      full: {
        name: "full",
        title: "Full size image",
        icon: SE,
        isDefault: true
      },
      side: {
        name: "side",
        title: "Side image",
        icon: NE,
        className: "image-style-side"
      },
      alignLeft: {
        name: "alignLeft",
        title: "Left aligned image",
        icon: TE,
        className: "image-style-align-left"
      },
      alignCenter: {
        name: "alignCenter",
        title: "Centered image",
        icon: IE,
        className: "image-style-align-center"
      },
      alignRight: {
        name: "alignRight",
        title: "Right aligned image",
        icon: NE,
        className: "image-style-align-right"
      }
    };
    var BE = {
      full: SE,
      left: TE,
      right: NE,
      center: IE
    };
    function zE() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return t.map(LE);
    }
    function LE(t) {
      if (typeof t == "string") {
        var _e259 = t;
        if (PE[_e259]) {
          t = Object.assign({}, PE[_e259]);
        } else {
          Object(ss["c"])("image-style-not-found", {
            name: _e259
          });
          t = {
            name: _e259
          };
        }
      } else if (PE[t.name]) {
        var _e260 = PE[t.name];
        var _n243 = Object.assign({}, t);
        for (var _o165 in _e260) {
          if (!Object.prototype.hasOwnProperty.call(t, _o165)) {
            _n243[_o165] = _e260[_o165];
          }
        }
        t = _n243;
      }
      if (typeof t.icon == "string" && BE[t.icon]) {
        t.icon = BE[t.icon];
      }
      return t;
    }
    var OE = /*#__PURE__*/function (_aC48) {
      _inherits(OE, _aC48);
      function OE() {
        _classCallCheck(this, OE);
        return _possibleConstructorReturn(this, _getPrototypeOf(OE).apply(this, arguments));
      }
      _createClass(OE, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model.schema;
          var n = t.data;
          var o = t.editing;
          t.config.define("image.styles", ["full", "side"]);
          var i = zE(t.config.get("image.styles"));
          e.extend("image", {
            allowAttributes: "imageStyle"
          });
          var r = DE(i);
          o.downcastDispatcher.on("attribute:imageStyle:image", r);
          n.downcastDispatcher.on("attribute:imageStyle:image", r);
          n.upcastDispatcher.on("element:figure", EE(i), {
            priority: "low"
          });
          t.commands.add("imageStyle", new xE(t, i));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleEditing";
        }
      }]);
      return OE;
    }(aC);
    var RE = n(43);
    var jE = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    jE.insert = "head";
    jE.singleton = true;
    var FE = rk()(RE["a"], jE);
    var VE = RE["a"].locals || {};
    var UE = /*#__PURE__*/function (_aC49) {
      _inherits(UE, _aC49);
      function UE() {
        _classCallCheck(this, UE);
        return _possibleConstructorReturn(this, _getPrototypeOf(UE).apply(this, arguments));
      }
      _createClass(UE, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.config.get("image.styles");
          var n = HE(zE(e), this.localizedDefaultStylesTitles);
          var _iterator354 = _createForOfIteratorHelper(n),
            _step354;
          try {
            for (_iterator354.s(); !(_step354 = _iterator354.n()).done;) {
              var _t288 = _step354.value;
              this._createButton(_t288);
            }
          } catch (err) {
            _iterator354.e(err);
          } finally {
            _iterator354.f();
          }
        }
      }, {
        key: "_createButton",
        value: function _createButton(t) {
          var _this220 = this;
          var e = this.editor;
          var n = "imageStyle:".concat(t.name);
          e.ui.componentFactory.add(n, function (n) {
            var o = e.commands.get("imageStyle");
            var i = new cw(n);
            i.set({
              label: t.title,
              icon: t.icon,
              tooltip: true,
              isToggleable: true
            });
            i.bind("isEnabled").to(o, "isEnabled");
            i.bind("isOn").to(o, "value", function (e) {
              return e === t.name;
            });
            _this220.listenTo(i, "execute", function () {
              e.execute("imageStyle", {
                value: t.name
              });
              e.editing.view.focus();
            });
            return i;
          });
        }
      }, {
        key: "localizedDefaultStylesTitles",
        get: function get() {
          var t = this.editor.t;
          return {
            "Full size image": t("Full size image"),
            "Side image": t("Side image"),
            "Left aligned image": t("Left aligned image"),
            "Centered image": t("Centered image"),
            "Right aligned image": t("Right aligned image")
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageStyleUI";
        }
      }]);
      return UE;
    }(aC);
    function HE(t, e) {
      var _iterator355 = _createForOfIteratorHelper(t),
        _step355;
      try {
        for (_iterator355.s(); !(_step355 = _iterator355.n()).done;) {
          var _n244 = _step355.value;
          if (e[_n244.title]) {
            _n244.title = e[_n244.title];
          }
        }
      } catch (err) {
        _iterator355.e(err);
      } finally {
        _iterator355.f();
      }
      return t;
    }
    var GE = /*#__PURE__*/function (_aC50) {
      _inherits(GE, _aC50);
      function GE() {
        _classCallCheck(this, GE);
        return _possibleConstructorReturn(this, _getPrototypeOf(GE).apply(this, arguments));
      }
      _createClass(GE, null, [{
        key: "requires",
        get: function get() {
          return [OE, UE];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageStyle";
        }
      }]);
      return GE;
    }(aC);
    var WE = /*#__PURE__*/function (_aC51) {
      _inherits(WE, _aC51);
      function WE() {
        _classCallCheck(this, WE);
        return _possibleConstructorReturn(this, _getPrototypeOf(WE).apply(this, arguments));
      }
      _createClass(WE, [{
        key: "init",
        value: function init() {
          var _this221 = this;
          var t = this.editor;
          if (t.plugins.has("BalloonToolbar")) {
            var _e261 = t.plugins.get("BalloonToolbar");
            this.listenTo(_e261, "show", function (e) {
              if (YE(t.editing.view.document.selection)) {
                e.stop();
              }
            }, {
              priority: "high"
            });
          }
          this._toolbarDefinitions = new Map();
          this._balloon = this.editor.plugins.get("ContextualBalloon");
          this.on("change:isEnabled", function () {
            _this221._updateToolbarsVisibility();
          });
          this.listenTo(t.ui, "update", function () {
            _this221._updateToolbarsVisibility();
          });
          this.listenTo(t.ui.focusTracker, "change:isFocused", function () {
            _this221._updateToolbarsVisibility();
          }, {
            priority: "low"
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(WE.prototype), "destroy", this).call(this);
          var _iterator356 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
            _step356;
          try {
            for (_iterator356.s(); !(_step356 = _iterator356.n()).done;) {
              var _t289 = _step356.value;
              _t289.view.destroy();
            }
          } catch (err) {
            _iterator356.e(err);
          } finally {
            _iterator356.f();
          }
        }
      }, {
        key: "register",
        value: function register(t, _ref44) {
          var e = _ref44.ariaLabel,
            n = _ref44.items,
            o = _ref44.getRelatedElement,
            _ref44$balloonClassNa = _ref44.balloonClassName,
            i = _ref44$balloonClassNa === void 0 ? "ck-toolbar-container" : _ref44$balloonClassNa;
          if (!n.length) {
            Object(ss["c"])("widget-toolbar-no-items", {
              toolbarId: t
            });
            return;
          }
          var r = this.editor;
          var s = r.t;
          var a = new Gw(r.locale);
          a.ariaLabel = e || s("Widget toolbar");
          if (this._toolbarDefinitions.has(t)) {
            throw new ss["a"]("widget-toolbar-duplicated", this, {
              toolbarId: t
            });
          }
          a.fillFromConfig(n, r.ui.componentFactory);
          this._toolbarDefinitions.set(t, {
            view: a,
            getRelatedElement: o,
            balloonClassName: i
          });
        }
      }, {
        key: "_updateToolbarsVisibility",
        value: function _updateToolbarsVisibility() {
          var t = 0;
          var e = null;
          var n = null;
          var _iterator357 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
            _step357;
          try {
            for (_iterator357.s(); !(_step357 = _iterator357.n()).done;) {
              var _o166 = _step357.value;
              var _i136 = _o166.getRelatedElement(this.editor.editing.view.document.selection);
              if (!this.isEnabled || !_i136) {
                if (this._isToolbarInBalloon(_o166)) {
                  this._hideToolbar(_o166);
                }
              } else if (!this.editor.ui.focusTracker.isFocused) {
                if (this._isToolbarVisible(_o166)) {
                  this._hideToolbar(_o166);
                }
              } else {
                var _r51 = _i136.getAncestors().length;
                if (_r51 > t) {
                  t = _r51;
                  e = _i136;
                  n = _o166;
                }
              }
            }
          } catch (err) {
            _iterator357.e(err);
          } finally {
            _iterator357.f();
          }
          if (n) {
            this._showToolbar(n, e);
          }
        }
      }, {
        key: "_hideToolbar",
        value: function _hideToolbar(t) {
          this._balloon.remove(t.view);
          this.stopListening(this._balloon, "change:visibleView");
        }
      }, {
        key: "_showToolbar",
        value: function _showToolbar(t, e) {
          var _this222 = this;
          if (this._isToolbarVisible(t)) {
            KE(this.editor, e);
          } else if (!this._isToolbarInBalloon(t)) {
            this._balloon.add({
              view: t.view,
              position: qE(this.editor, e),
              balloonClassName: t.balloonClassName
            });
            this.listenTo(this._balloon, "change:visibleView", function () {
              var _iterator358 = _createForOfIteratorHelper(_this222._toolbarDefinitions.values()),
                _step358;
              try {
                for (_iterator358.s(); !(_step358 = _iterator358.n()).done;) {
                  var _t290 = _step358.value;
                  if (_this222._isToolbarVisible(_t290)) {
                    var _e262 = _t290.getRelatedElement(_this222.editor.editing.view.document.selection);
                    KE(_this222.editor, _e262);
                  }
                }
              } catch (err) {
                _iterator358.e(err);
              } finally {
                _iterator358.f();
              }
            });
          }
        }
      }, {
        key: "_isToolbarVisible",
        value: function _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view;
        }
      }, {
        key: "_isToolbarInBalloon",
        value: function _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view);
        }
      }], [{
        key: "requires",
        get: function get() {
          return [kD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "WidgetToolbarRepository";
        }
      }]);
      return WE;
    }(aC);
    function KE(t, e) {
      var n = t.plugins.get("ContextualBalloon");
      var o = qE(t, e);
      n.updatePosition(o);
    }
    function qE(t, e) {
      var n = t.editing.view;
      var o = WC.defaultPositions;
      return {
        target: n.domConverter.mapViewToDom(e),
        positions: [o.northArrowSouth, o.northArrowSouthWest, o.northArrowSouthEast, o.southArrowNorth, o.southArrowNorthWest, o.southArrowNorthEast, hA]
      };
    }
    function YE(t) {
      var e = t.getSelectedElement();
      return !!(e && iA(e));
    }
    var QE = /*#__PURE__*/function (_aC52) {
      _inherits(QE, _aC52);
      function QE() {
        _classCallCheck(this, QE);
        return _possibleConstructorReturn(this, _getPrototypeOf(QE).apply(this, arguments));
      }
      _createClass(QE, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor;
          var e = t.t;
          var n = t.plugins.get(WE);
          n.register("image", {
            ariaLabel: e("Image toolbar"),
            items: t.config.get("image.toolbar") || [],
            getRelatedElement: kA
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [WE];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageToolbar";
        }
      }]);
      return QE;
    }(aC);
    var $E = /*#__PURE__*/function (_tb24) {
      _inherits($E, _tb24);
      function $E(t) {
        var _this223;
        _classCallCheck(this, $E);
        _this223 = _possibleConstructorReturn(this, _getPrototypeOf($E).call(this, t));
        _this223.buttonView = new cw(t);
        _this223._fileInputView = new ZE(t);
        _this223._fileInputView.bind("acceptedType").to(_assertThisInitialized(_assertThisInitialized(_this223)));
        _this223._fileInputView.bind("allowMultipleFiles").to(_assertThisInitialized(_assertThisInitialized(_this223)));
        _this223._fileInputView.delegate("done").to(_assertThisInitialized(_assertThisInitialized(_this223)));
        _this223.setTemplate({
          tag: "span",
          attributes: {
            class: "ck-file-dialog-button"
          },
          children: [_this223.buttonView, _this223._fileInputView]
        });
        _this223.buttonView.on("execute", function () {
          _this223._fileInputView.open();
        });
        return _this223;
      }
      _createClass($E, [{
        key: "focus",
        value: function focus() {
          this.buttonView.focus();
        }
      }]);
      return $E;
    }(tb);
    var ZE = /*#__PURE__*/function (_tb25) {
      _inherits(ZE, _tb25);
      function ZE(t) {
        var _this224;
        _classCallCheck(this, ZE);
        _this224 = _possibleConstructorReturn(this, _getPrototypeOf(ZE).call(this, t));
        _this224.set("acceptedType");
        _this224.set("allowMultipleFiles", false);
        var e = _this224.bindTemplate;
        _this224.setTemplate({
          tag: "input",
          attributes: {
            class: ["ck-hidden"],
            type: "file",
            tabindex: "-1",
            accept: e.to("acceptedType"),
            multiple: e.to("allowMultipleFiles")
          },
          on: {
            change: e.to(function () {
              if (_this224.element && _this224.element.files && _this224.element.files.length) {
                _this224.fire("done", _this224.element.files);
              }
              _this224.element.value = "";
            })
          }
        });
        return _this224;
      }
      _createClass(ZE, [{
        key: "open",
        value: function open() {
          this.element.click();
        }
      }]);
      return ZE;
    }(tb);
    function JE(t) {
      var e = t.map(function (t) {
        return t.replace("+", "\\+");
      });
      return new RegExp("^image\\/(".concat(e.join("|"), ")$"));
    }
    function XE(t) {
      return new Promise(function (e, n) {
        var o = t.getAttribute("src");
        fetch(o).then(function (t) {
          return t.blob();
        }).then(function (t) {
          var n = eM(t, o);
          var i = n.replace("image/", "");
          var r = "image.".concat(i);
          var s = new File([t], r, {
            type: n
          });
          e(s);
        }).catch(n);
      });
    }
    function tM(t) {
      if (!t.is("element", "img") || !t.getAttribute("src")) {
        return false;
      }
      return t.getAttribute("src").match(/^data:image\/\w+;base64,/g) || t.getAttribute("src").match(/^blob:/g);
    }
    function eM(t, e) {
      if (t.type) {
        return t.type;
      } else if (e.match(/data:(image\/\w+);base64/)) {
        return e.match(/data:(image\/\w+);base64/)[1].toLowerCase();
      } else {
        return "image/jpeg";
      }
    }
    var nM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
    var oM = /*#__PURE__*/function (_aC53) {
      _inherits(oM, _aC53);
      function oM() {
        _classCallCheck(this, oM);
        return _possibleConstructorReturn(this, _getPrototypeOf(oM).apply(this, arguments));
      }
      _createClass(oM, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.t;
          t.ui.componentFactory.add("imageUpload", function (n) {
            var o = new $E(n);
            var i = t.commands.get("imageUpload");
            var r = t.config.get("image.upload.types");
            var s = JE(r);
            o.set({
              acceptedType: r.map(function (t) {
                return "image/".concat(t);
              }).join(","),
              allowMultipleFiles: true
            });
            o.buttonView.set({
              label: e("Insert image"),
              icon: nM,
              tooltip: true
            });
            o.buttonView.bind("isEnabled").to(i);
            o.on("done", function (e, n) {
              var o = Array.from(n).filter(function (t) {
                return s.test(t.type);
              });
              if (o.length) {
                t.execute("imageUpload", {
                  file: o
                });
              }
            });
            return o;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ImageUploadUI";
        }
      }]);
      return oM;
    }(aC);
    var iM = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 250"><rect rx="4"/></svg>';
    var rM = n(44);
    var sM = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    sM.insert = "head";
    sM.singleton = true;
    var aM = rk()(rM["a"], sM);
    var cM = rM["a"].locals || {};
    var lM = n(45);
    var dM = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    dM.insert = "head";
    dM.singleton = true;
    var uM = rk()(lM["a"], dM);
    var hM = lM["a"].locals || {};
    var fM = n(46);
    var mM = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    mM.insert = "head";
    mM.singleton = true;
    var gM = rk()(fM["a"], mM);
    var pM = fM["a"].locals || {};
    var kM = /*#__PURE__*/function (_aC54) {
      _inherits(kM, _aC54);
      function kM(t) {
        var _this225;
        _classCallCheck(this, kM);
        _this225 = _possibleConstructorReturn(this, _getPrototypeOf(kM).call(this, t));
        _this225.placeholder = "data:image/svg+xml;utf8," + encodeURIComponent(iM);
        return _this225;
      }
      _createClass(kM, [{
        key: "init",
        value: function init() {
          var _this226 = this;
          var t = this.editor;
          t.editing.downcastDispatcher.on("attribute:uploadStatus:image", function () {
            return _this226.uploadStatusChange.apply(_this226, arguments);
          });
        }
      }, {
        key: "uploadStatusChange",
        value: function uploadStatusChange(t, e, n) {
          var o = this.editor;
          var i = e.item;
          var r = i.getAttribute("uploadId");
          if (!n.consumable.consume(e.item, t.name)) {
            return;
          }
          var s = o.plugins.get(jv);
          var a = r ? e.attributeNewValue : null;
          var c = this.placeholder;
          var l = o.editing.mapper.toViewElement(i);
          var d = n.writer;
          if (a == "reading") {
            bM(l, d);
            CM(c, l, d);
            return;
          }
          if (a == "uploading") {
            var _t291 = s.loaders.get(r);
            bM(l, d);
            if (!_t291) {
              CM(c, l, d);
            } else {
              AM(l, d);
              _M(l, d, _t291, o.editing.view);
              SM(l, d, _t291);
            }
            return;
          }
          if (a == "complete" && s.loaders.get(r)) {
            yM(l, d, o.editing.view);
          }
          vM(l, d);
          AM(l, d);
          wM(l, d);
        }
      }]);
      return kM;
    }(aC);
    function bM(t, e) {
      if (!t.hasClass("ck-appear")) {
        e.addClass("ck-appear", t);
      }
    }
    function wM(t, e) {
      e.removeClass("ck-appear", t);
    }
    function CM(t, e, n) {
      if (!e.hasClass("ck-image-upload-placeholder")) {
        n.addClass("ck-image-upload-placeholder", e);
      }
      var o = AA(e);
      if (o.getAttribute("src") !== t) {
        n.setAttribute("src", t, o);
      }
      if (!EM(e, "placeholder")) {
        n.insert(n.createPositionAfter(o), DM(n));
      }
    }
    function AM(t, e) {
      if (t.hasClass("ck-image-upload-placeholder")) {
        e.removeClass("ck-image-upload-placeholder", t);
      }
      MM(t, e, "placeholder");
    }
    function _M(t, e, n, o) {
      var i = xM(e);
      e.insert(e.createPositionAt(t, "end"), i);
      n.on("change:uploadedPercent", function (t, e, n) {
        o.change(function (t) {
          t.setStyle("width", n + "%", i);
        });
      });
    }
    function vM(t, e) {
      MM(t, e, "progressBar");
    }
    function yM(t, e, n) {
      var o = e.createUIElement("div", {
        class: "ck-image-upload-complete-icon"
      });
      e.insert(e.createPositionAt(t, "end"), o);
      setTimeout(function () {
        n.change(function (t) {
          return t.remove(t.createRangeOn(o));
        });
      }, 3e3);
    }
    function xM(t) {
      var e = t.createUIElement("div", {
        class: "ck-progress-bar"
      });
      t.setCustomProperty("progressBar", true, e);
      return e;
    }
    function DM(t) {
      var e = t.createUIElement("div", {
        class: "ck-upload-placeholder-loader"
      });
      t.setCustomProperty("placeholder", true, e);
      return e;
    }
    function EM(t, e) {
      var _iterator359 = _createForOfIteratorHelper(t.getChildren()),
        _step359;
      try {
        for (_iterator359.s(); !(_step359 = _iterator359.n()).done;) {
          var _n245 = _step359.value;
          if (_n245.getCustomProperty(e)) {
            return _n245;
          }
        }
      } catch (err) {
        _iterator359.e(err);
      } finally {
        _iterator359.f();
      }
    }
    function MM(t, e, n) {
      var o = EM(t, n);
      if (o) {
        e.remove(e.createRangeOn(o));
      }
    }
    function SM(t, e, n) {
      if (n.data) {
        var _o167 = AA(t);
        e.setAttribute("src", n.data, _o167);
      }
    }
    var TM = /*#__PURE__*/function () {
      function TM(t) {
        _classCallCheck(this, TM);
        this.document = t;
      }
      _createClass(TM, [{
        key: "createDocumentFragment",
        value: function createDocumentFragment(t) {
          return new Zl(this.document, t);
        }
      }, {
        key: "createElement",
        value: function createElement(t, e, n) {
          return new jc(this.document, t, e, n);
        }
      }, {
        key: "createText",
        value: function createText(t) {
          return new Vs(this.document, t);
        }
      }, {
        key: "clone",
        value: function clone(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          return t._clone(e);
        }
      }, {
        key: "appendChild",
        value: function appendChild(t, e) {
          return e._appendChild(t);
        }
      }, {
        key: "insertChild",
        value: function insertChild(t, e, n) {
          return n._insertChild(t, e);
        }
      }, {
        key: "removeChildren",
        value: function removeChildren(t, e, n) {
          return n._removeChildren(t, e);
        }
      }, {
        key: "remove",
        value: function remove(t) {
          var e = t.parent;
          if (e) {
            return this.removeChildren(e.getChildIndex(t), 1, e);
          }
          return [];
        }
      }, {
        key: "replace",
        value: function replace(t, e) {
          var n = t.parent;
          if (n) {
            var _o168 = n.getChildIndex(t);
            this.removeChildren(_o168, 1, n);
            this.insertChild(_o168, e, n);
            return true;
          }
          return false;
        }
      }, {
        key: "unwrapElement",
        value: function unwrapElement(t) {
          var e = t.parent;
          if (e) {
            var _n246 = e.getChildIndex(t);
            this.remove(t);
            this.insertChild(_n246, t.getChildren(), e);
          }
        }
      }, {
        key: "rename",
        value: function rename(t, e) {
          var n = new jc(this.document, t, e.getAttributes(), e.getChildren());
          return this.replace(e, n) ? n : null;
        }
      }, {
        key: "setAttribute",
        value: function setAttribute(t, e, n) {
          n._setAttribute(t, e);
        }
      }, {
        key: "removeAttribute",
        value: function removeAttribute(t, e) {
          e._removeAttribute(t);
        }
      }, {
        key: "addClass",
        value: function addClass(t, e) {
          e._addClass(t);
        }
      }, {
        key: "removeClass",
        value: function removeClass(t, e) {
          e._removeClass(t);
        }
      }, {
        key: "setStyle",
        value: function setStyle(t, e, n) {
          if (B(t) && n === undefined) {
            n = e;
          }
          n._setStyle(t, e);
        }
      }, {
        key: "removeStyle",
        value: function removeStyle(t, e) {
          e._removeStyle(t);
        }
      }, {
        key: "setCustomProperty",
        value: function setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e);
        }
      }, {
        key: "removeCustomProperty",
        value: function removeCustomProperty(t, e) {
          return e._removeCustomProperty(t);
        }
      }, {
        key: "createPositionAt",
        value: function createPositionAt(t, e) {
          return hl._createAt(t, e);
        }
      }, {
        key: "createPositionAfter",
        value: function createPositionAfter(t) {
          return hl._createAfter(t);
        }
      }, {
        key: "createPositionBefore",
        value: function createPositionBefore(t) {
          return hl._createBefore(t);
        }
      }, {
        key: "createRange",
        value: function createRange(t, e) {
          return new fl(t, e);
        }
      }, {
        key: "createRangeOn",
        value: function createRangeOn(t) {
          return fl._createOn(t);
        }
      }, {
        key: "createRangeIn",
        value: function createRangeIn(t) {
          return fl._createIn(t);
        }
      }, {
        key: "createSelection",
        value: function createSelection(t, e, n) {
          return new pl(t, e, n);
        }
      }]);
      return TM;
    }();
    var IM = /*#__PURE__*/function (_uC19) {
      _inherits(IM, _uC19);
      function IM() {
        _classCallCheck(this, IM);
        return _possibleConstructorReturn(this, _getPrototypeOf(IM).apply(this, arguments));
      }
      _createClass(IM, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection.getSelectedElement();
          var e = t && t.name === "image" || false;
          this.isEnabled = CA(this.editor.model) || e;
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor;
          var n = e.model;
          var o = e.plugins.get(jv);
          var _iterator360 = _createForOfIteratorHelper(xs(t.file)),
            _step360;
          try {
            for (_iterator360.s(); !(_step360 = _iterator360.n()).done;) {
              var _e263 = _step360.value;
              NM(n, o, _e263);
            }
          } catch (err) {
            _iterator360.e(err);
          } finally {
            _iterator360.f();
          }
        }
      }]);
      return IM;
    }(uC);
    function NM(t, e, n) {
      var o = e.createLoader(n);
      if (!o) {
        return;
      }
      wA(t, {
        uploadId: o.id
      });
    }
    var PM = /*#__PURE__*/function (_aC55) {
      _inherits(PM, _aC55);
      _createClass(PM, null, [{
        key: "requires",
        get: function get() {
          return [jv, Pv, h_];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "ImageUploadEditing";
        }
      }]);
      function PM(t) {
        var _this227;
        _classCallCheck(this, PM);
        _this227 = _possibleConstructorReturn(this, _getPrototypeOf(PM).call(this, t));
        t.config.define("image", {
          upload: {
            types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"]
          }
        });
        return _this227;
      }
      _createClass(PM, [{
        key: "init",
        value: function init() {
          var _this228 = this;
          var t = this.editor;
          var e = t.model.document;
          var n = t.model.schema;
          var o = t.conversion;
          var i = t.plugins.get(jv);
          var r = JE(t.config.get("image.upload.types"));
          n.extend("image", {
            allowAttributes: ["uploadId", "uploadStatus"]
          });
          t.commands.add("imageUpload", new IM(t));
          o.for("upcast").attributeToAttribute({
            view: {
              name: "img",
              key: "uploadId"
            },
            model: "uploadId"
          });
          this.listenTo(t.editing.view.document, "clipboardInput", function (e, n) {
            if (BM(n.dataTransfer)) {
              return;
            }
            var o = Array.from(n.dataTransfer.files).filter(function (t) {
              if (!t) {
                return false;
              }
              return r.test(t.type);
            });
            var i = n.targetRanges.map(function (e) {
              return t.editing.mapper.toModelRange(e);
            });
            t.model.change(function (n) {
              n.setSelection(i);
              if (o.length) {
                e.stop();
                t.model.enqueueChange("default", function () {
                  t.execute("imageUpload", {
                    file: o
                  });
                });
              }
            });
          });
          this.listenTo(t.plugins.get(h_), "inputTransformation", function (e, n) {
            var o = Array.from(t.editing.view.createRangeIn(n.content)).filter(function (t) {
              return tM(t.item) && !t.item.getAttribute("uploadProcessed");
            }).map(function (t) {
              return {
                promise: XE(t.item),
                imageElement: t.item
              };
            });
            if (!o.length) {
              return;
            }
            var r = new TM(t.editing.view.document);
            var _iterator361 = _createForOfIteratorHelper(o),
              _step361;
            try {
              for (_iterator361.s(); !(_step361 = _iterator361.n()).done;) {
                var _t292 = _step361.value;
                r.setAttribute("uploadProcessed", true, _t292.imageElement);
                var _e264 = i.createLoader(_t292.promise);
                if (_e264) {
                  r.setAttribute("src", "", _t292.imageElement);
                  r.setAttribute("uploadId", _e264.id, _t292.imageElement);
                }
              }
            } catch (err) {
              _iterator361.e(err);
            } finally {
              _iterator361.f();
            }
          });
          t.editing.view.document.on("dragover", function (t, e) {
            e.preventDefault();
          });
          e.on("change", function () {
            var n = e.differ.getChanges({
              includeChangesInGraveyard: true
            });
            var _iterator362 = _createForOfIteratorHelper(n),
              _step362;
            try {
              for (_iterator362.s(); !(_step362 = _iterator362.n()).done;) {
                var _e265 = _step362.value;
                if (_e265.type == "insert" && _e265.name != "$text") {
                  var _n247 = _e265.position.nodeAfter;
                  var _o169 = _e265.position.root.rootName == "$graveyard";
                  var _iterator363 = _createForOfIteratorHelper(zM(t, _n247)),
                    _step363;
                  try {
                    for (_iterator363.s(); !(_step363 = _iterator363.n()).done;) {
                      var _e266 = _step363.value;
                      var _t293 = _e266.getAttribute("uploadId");
                      if (!_t293) {
                        continue;
                      }
                      var _n248 = i.loaders.get(_t293);
                      if (!_n248) {
                        continue;
                      }
                      if (_o169) {
                        _n248.abort();
                      } else if (_n248.status == "idle") {
                        _this228._readAndUpload(_n248, _e266);
                      }
                    }
                  } catch (err) {
                    _iterator363.e(err);
                  } finally {
                    _iterator363.f();
                  }
                }
              }
            } catch (err) {
              _iterator362.e(err);
            } finally {
              _iterator362.f();
            }
          });
        }
      }, {
        key: "_readAndUpload",
        value: function _readAndUpload(t, e) {
          var _this229 = this;
          var n = this.editor;
          var o = n.model;
          var i = n.locale.t;
          var r = n.plugins.get(jv);
          var s = n.plugins.get(Pv);
          o.enqueueChange("transparent", function (t) {
            t.setAttribute("uploadStatus", "reading", e);
          });
          return t.read().then(function () {
            var i = t.upload();
            if (El.isSafari) {
              var _t294 = n.editing.mapper.toViewElement(e);
              var _o170 = AA(_t294);
              n.editing.view.once("render", function () {
                if (!_o170.parent) {
                  return;
                }
                var t = n.editing.view.domConverter.mapViewToDom(_o170.parent);
                if (!t) {
                  return;
                }
                var e = t.style.display;
                t.style.display = "none";
                t._ckHack = t.offsetHeight;
                t.style.display = e;
              });
            }
            o.enqueueChange("transparent", function (t) {
              t.setAttribute("uploadStatus", "uploading", e);
            });
            return i;
          }).then(function (t) {
            o.enqueueChange("transparent", function (n) {
              n.setAttributes({
                uploadStatus: "complete",
                src: t.default
              }, e);
              _this229._parseAndSetSrcsetAttributeOnImage(t, e, n);
            });
            a();
          }).catch(function (n) {
            if (t.status !== "error" && t.status !== "aborted") {
              throw n;
            }
            if (t.status == "error" && n) {
              s.showWarning(n, {
                title: i("Upload failed"),
                namespace: "upload"
              });
            }
            a();
            o.enqueueChange("transparent", function (t) {
              t.remove(e);
            });
          });
          function a() {
            o.enqueueChange("transparent", function (t) {
              t.removeAttribute("uploadId", e);
              t.removeAttribute("uploadStatus", e);
            });
            r.destroyLoader(t);
          }
        }
      }, {
        key: "_parseAndSetSrcsetAttributeOnImage",
        value: function _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          var o = 0;
          var i = Object.keys(t).filter(function (t) {
            var e = parseInt(t, 10);
            if (!isNaN(e)) {
              o = Math.max(o, e);
              return true;
            }
          }).map(function (e) {
            return "".concat(t[e], " ").concat(e, "w");
          }).join(", ");
          if (i != "") {
            n.setAttribute("srcset", {
              data: i,
              width: o
            }, e);
          }
        }
      }]);
      return PM;
    }(aC);
    function BM(t) {
      return Array.from(t.types).includes("text/html") && t.getData("text/html") !== "";
    }
    function zM(t, e) {
      return Array.from(t.model.createRangeOn(e)).filter(function (t) {
        return t.item.is("element", "image");
      }).map(function (t) {
        return t.item;
      });
    }
    var LM = /*#__PURE__*/function (_aC56) {
      _inherits(LM, _aC56);
      function LM() {
        _classCallCheck(this, LM);
        return _possibleConstructorReturn(this, _getPrototypeOf(LM).apply(this, arguments));
      }
      _createClass(LM, null, [{
        key: "pluginName",
        get: function get() {
          return "ImageUpload";
        }
      }, {
        key: "requires",
        get: function get() {
          return [PM, oM, kM];
        }
      }]);
      return LM;
    }(aC);
    var OM = /*#__PURE__*/function (_uC20) {
      _inherits(OM, _uC20);
      function OM(t) {
        var _this230;
        _classCallCheck(this, OM);
        _this230 = _possibleConstructorReturn(this, _getPrototypeOf(OM).call(this, t));
        _this230._childCommands = [];
        return _this230;
      }
      _createClass(OM, [{
        key: "refresh",
        value: function refresh() {}
      }, {
        key: "execute",
        value: function execute() {
          var e = this._getFirstEnabledCommand();
          for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
            t[_key19] = arguments[_key19];
          }
          return e.execute(t);
        }
      }, {
        key: "registerChildCommand",
        value: function registerChildCommand(t) {
          var _this231 = this;
          this._childCommands.push(t);
          t.on("change:isEnabled", function () {
            return _this231._checkEnabled();
          });
          this._checkEnabled();
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand();
        }
      }, {
        key: "_getFirstEnabledCommand",
        value: function _getFirstEnabledCommand() {
          return this._childCommands.find(function (t) {
            return t.isEnabled;
          });
        }
      }]);
      return OM;
    }(uC);
    var RM = /*#__PURE__*/function (_aC57) {
      _inherits(RM, _aC57);
      function RM() {
        _classCallCheck(this, RM);
        return _possibleConstructorReturn(this, _getPrototypeOf(RM).apply(this, arguments));
      }
      _createClass(RM, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.commands.add("indent", new OM(t));
          t.commands.add("outdent", new OM(t));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentEditing";
        }
      }]);
      return RM;
    }(aC);
    var jM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95L5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>';
    var FM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
    var VM = /*#__PURE__*/function (_aC58) {
      _inherits(VM, _aC58);
      function VM() {
        _classCallCheck(this, VM);
        return _possibleConstructorReturn(this, _getPrototypeOf(VM).apply(this, arguments));
      }
      _createClass(VM, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.locale;
          var n = t.t;
          var o = e.uiLanguageDirection == "ltr" ? jM : FM;
          var i = e.uiLanguageDirection == "ltr" ? FM : jM;
          this._defineButton("indent", n("Increase indent"), o);
          this._defineButton("outdent", n("Decrease indent"), i);
        }
      }, {
        key: "_defineButton",
        value: function _defineButton(t, e, n) {
          var _this232 = this;
          var o = this.editor;
          o.ui.componentFactory.add(t, function (i) {
            var r = o.commands.get(t);
            var s = new cw(i);
            s.set({
              label: e,
              icon: n,
              tooltip: true
            });
            s.bind("isOn", "isEnabled").to(r, "value", "isEnabled");
            _this232.listenTo(s, "execute", function () {
              o.execute(t);
              o.editing.view.focus();
            });
            return s;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentUI";
        }
      }]);
      return VM;
    }(aC);
    var UM = /*#__PURE__*/function (_aC59) {
      _inherits(UM, _aC59);
      function UM() {
        _classCallCheck(this, UM);
        return _possibleConstructorReturn(this, _getPrototypeOf(UM).apply(this, arguments));
      }
      _createClass(UM, null, [{
        key: "pluginName",
        get: function get() {
          return "Indent";
        }
      }, {
        key: "requires",
        get: function get() {
          return [RM, VM];
        }
      }]);
      return UM;
    }(aC);
    var HM = "italic";
    var GM = /*#__PURE__*/function (_aC60) {
      _inherits(GM, _aC60);
      function GM() {
        _classCallCheck(this, GM);
        return _possibleConstructorReturn(this, _getPrototypeOf(GM).apply(this, arguments));
      }
      _createClass(GM, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.model.schema.extend("$text", {
            allowAttributes: HM
          });
          t.model.schema.setAttributeProperties(HM, {
            isFormatting: true,
            copyOnEnter: true
          });
          t.conversion.attributeToElement({
            model: HM,
            view: "i",
            upcastAlso: ["em", {
              styles: {
                "font-style": "italic"
              }
            }]
          });
          t.commands.add(HM, new xC(t, HM));
          t.keystrokes.set("CTRL+I", HM);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ItalicEditing";
        }
      }]);
      return GM;
    }(aC);
    var WM = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.586 14.633l.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
    var KM = "italic";
    var qM = /*#__PURE__*/function (_aC61) {
      _inherits(qM, _aC61);
      function qM() {
        _classCallCheck(this, qM);
        return _possibleConstructorReturn(this, _getPrototypeOf(qM).apply(this, arguments));
      }
      _createClass(qM, [{
        key: "init",
        value: function init() {
          var _this233 = this;
          var t = this.editor;
          var e = t.t;
          t.ui.componentFactory.add(KM, function (n) {
            var o = t.commands.get(KM);
            var i = new cw(n);
            i.set({
              label: e("Italic"),
              icon: WM,
              keystroke: "CTRL+I",
              tooltip: true,
              isToggleable: true
            });
            i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
            _this233.listenTo(i, "execute", function () {
              t.execute(KM);
              t.editing.view.focus();
            });
            return i;
          });
        }
      }]);
      return qM;
    }(aC);
    var YM = /*#__PURE__*/function (_aC62) {
      _inherits(YM, _aC62);
      function YM() {
        _classCallCheck(this, YM);
        return _possibleConstructorReturn(this, _getPrototypeOf(YM).apply(this, arguments));
      }
      _createClass(YM, null, [{
        key: "requires",
        get: function get() {
          return [GM, qM];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Italic";
        }
      }]);
      return YM;
    }(aC);
    var QM = /*#__PURE__*/function (_nh7) {
      _inherits(QM, _nh7);
      function QM(t) {
        var _this234;
        _classCallCheck(this, QM);
        _this234 = _possibleConstructorReturn(this, _getPrototypeOf(QM).call(this, t));
        _this234.domEventType = "click";
        return _this234;
      }
      _createClass(QM, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return QM;
    }(nh);
    var $M = n(47);
    var ZM = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    ZM.insert = "head";
    ZM.singleton = true;
    var JM = rk()($M["a"], ZM);
    var XM = $M["a"].locals || {};
    var tS = /*#__PURE__*/function (_tb26) {
      _inherits(tS, _tb26);
      function tS(t, e) {
        var _this235;
        _classCallCheck(this, tS);
        _this235 = _possibleConstructorReturn(this, _getPrototypeOf(tS).call(this, t));
        var n = t.t;
        _this235.focusTracker = new tk();
        _this235.keystrokes = new Vp();
        _this235.urlInputView = _this235._createUrlInput();
        _this235.saveButtonView = _this235._createButton(n("Save"), Qx, "ck-button-save");
        _this235.saveButtonView.type = "submit";
        _this235.cancelButtonView = _this235._createButton(n("Cancel"), $x, "ck-button-cancel", "cancel");
        _this235._manualDecoratorSwitches = _this235._createManualDecoratorSwitches(e);
        _this235.children = _this235._createFormChildren(e.manualDecorators);
        _this235._focusables = new Ak();
        _this235._focusCycler = new Db({
          focusables: _this235._focusables,
          focusTracker: _this235.focusTracker,
          keystrokeHandler: _this235.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        var o = ["ck", "ck-link-form", "ck-responsive-form"];
        if (e.manualDecorators.length) {
          o.push("ck-link-form_layout-vertical", "ck-vertical-form");
        }
        _this235.setTemplate({
          tag: "form",
          attributes: {
            class: o,
            tabindex: "-1"
          },
          children: _this235.children
        });
        qx(_assertThisInitialized(_assertThisInitialized(_this235)));
        return _this235;
      }
      _createClass(tS, [{
        key: "getDecoratorSwitchesState",
        value: function getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce(function (t, e) {
            t[e.name] = e.isOn;
            return t;
          }, {});
        }
      }, {
        key: "render",
        value: function render() {
          var _this236 = this;
          _get(_getPrototypeOf(tS.prototype), "render", this).call(this);
          Yx({
            view: this
          });
          var t = [this.urlInputView].concat(_toConsumableArray(this._manualDecoratorSwitches), [this.saveButtonView, this.cancelButtonView]);
          t.forEach(function (t) {
            _this236._focusables.add(t);
            _this236.focusTracker.add(t.element);
          });
          this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var t = this.locale.t;
          var e = new Rx(this.locale, Wx);
          e.label = t("Link URL");
          return e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new cw(this.locale);
          i.set({
            label: t,
            icon: e,
            tooltip: true
          });
          i.extendTemplate({
            attributes: {
              class: n
            }
          });
          if (o) {
            i.delegate("execute").to(this, o);
          }
          return i;
        }
      }, {
        key: "_createManualDecoratorSwitches",
        value: function _createManualDecoratorSwitches(t) {
          var _this237 = this;
          var e = this.createCollection();
          var _iterator364 = _createForOfIteratorHelper(t.manualDecorators),
            _step364;
          try {
            var _loop8 = function _loop8() {
              var n = _step364.value;
              var o = new _w(_this237.locale);
              o.set({
                name: n.id,
                label: n.label,
                withText: true
              });
              o.bind("isOn").toMany([n, t], "value", function (t, e) {
                return e === undefined && t === undefined ? n.defaultValue : t;
              });
              o.on("execute", function () {
                n.set("value", !o.isOn);
              });
              e.add(o);
            };
            for (_iterator364.s(); !(_step364 = _iterator364.n()).done;) {
              _loop8();
            }
          } catch (err) {
            _iterator364.e(err);
          } finally {
            _iterator364.f();
          }
          return e;
        }
      }, {
        key: "_createFormChildren",
        value: function _createFormChildren(t) {
          var e = this.createCollection();
          e.add(this.urlInputView);
          if (t.length) {
            var _t295 = new tb();
            _t295.setTemplate({
              tag: "ul",
              children: this._manualDecoratorSwitches.map(function (t) {
                return {
                  tag: "li",
                  children: [t],
                  attributes: {
                    class: ["ck", "ck-list__item"]
                  }
                };
              }),
              attributes: {
                class: ["ck", "ck-reset", "ck-list"]
              }
            });
            e.add(_t295);
          }
          e.add(this.saveButtonView);
          e.add(this.cancelButtonView);
          return e;
        }
      }]);
      return tS;
    }(tb);
    var eS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562l-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
    var nS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7.3 17.37l-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506L13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5L9.375 17H19v1.5H8z"/></svg>';
    var oS = n(48);
    var iS = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    iS.insert = "head";
    iS.singleton = true;
    var rS = rk()(oS["a"], iS);
    var sS = oS["a"].locals || {};
    var aS = /*#__PURE__*/function (_tb27) {
      _inherits(aS, _tb27);
      function aS(t) {
        var _this238;
        _classCallCheck(this, aS);
        _this238 = _possibleConstructorReturn(this, _getPrototypeOf(aS).call(this, t));
        var e = t.t;
        _this238.focusTracker = new tk();
        _this238.keystrokes = new Vp();
        _this238.previewButtonView = _this238._createPreviewButton();
        _this238.unlinkButtonView = _this238._createButton(e("Unlink"), eS, "unlink");
        _this238.editButtonView = _this238._createButton(e("Edit link"), nS, "edit");
        _this238.set("href");
        _this238._focusables = new Ak();
        _this238._focusCycler = new Db({
          focusables: _this238._focusables,
          focusTracker: _this238.focusTracker,
          keystrokeHandler: _this238.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        _this238.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-link-actions", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this238.previewButtonView, _this238.editButtonView, _this238.unlinkButtonView]
        });
        return _this238;
      }
      _createClass(aS, [{
        key: "render",
        value: function render() {
          var _this239 = this;
          _get(_getPrototypeOf(aS.prototype), "render", this).call(this);
          var t = [this.previewButtonView, this.editButtonView, this.unlinkButtonView];
          t.forEach(function (t) {
            _this239._focusables.add(t);
            _this239.focusTracker.add(t.element);
          });
          this.keystrokes.listenTo(this.element);
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n) {
          var o = new cw(this.locale);
          o.set({
            label: t,
            icon: e,
            tooltip: true
          });
          o.delegate("execute").to(this, n);
          return o;
        }
      }, {
        key: "_createPreviewButton",
        value: function _createPreviewButton() {
          var t = new cw(this.locale);
          var e = this.bindTemplate;
          var n = this.t;
          t.set({
            withText: true,
            tooltip: n("Open link in new tab")
          });
          t.extendTemplate({
            attributes: {
              class: ["ck", "ck-link-actions__preview"],
              href: e.to("href", function (t) {
                return t && dv(t);
              }),
              target: "_blank",
              rel: "noopener noreferrer"
            }
          });
          t.bind("label").to(this, "href", function (t) {
            return t || n("This link has no URL");
          });
          t.bind("isEnabled").to(this, "href", function (t) {
            return !!t;
          });
          t.template.tag = "a";
          t.template.eventListeners = {};
          return t;
        }
      }]);
      return aS;
    }(tb);
    var cS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.077 15l.991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
    var lS = "link-ui";
    var dS = /*#__PURE__*/function (_aC63) {
      _inherits(dS, _aC63);
      function dS() {
        _classCallCheck(this, dS);
        return _possibleConstructorReturn(this, _getPrototypeOf(dS).apply(this, arguments));
      }
      _createClass(dS, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(QM);
          this.actionsView = this._createActionsView();
          this.formView = this._createFormView();
          this._balloon = t.plugins.get(kD);
          this._createToolbarLinkButton();
          this._enableUserBalloonInteractions();
          t.conversion.for("editingDowncast").markerToHighlight({
            model: lS,
            view: {
              classes: ["ck-fake-link-selection"]
            }
          });
          t.conversion.for("editingDowncast").markerToElement({
            model: lS,
            view: {
              name: "span",
              classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"]
            }
          });
        }
      }, {
        key: "destroy",
        value: function destroy() {
          _get(_getPrototypeOf(dS.prototype), "destroy", this).call(this);
          this.formView.destroy();
        }
      }, {
        key: "_createActionsView",
        value: function _createActionsView() {
          var _this240 = this;
          var t = this.editor;
          var e = new aS(t.locale);
          var n = t.commands.get("link");
          var o = t.commands.get("unlink");
          e.bind("href").to(n, "value");
          e.editButtonView.bind("isEnabled").to(n);
          e.unlinkButtonView.bind("isEnabled").to(o);
          this.listenTo(e, "edit", function () {
            _this240._addFormView();
          });
          this.listenTo(e, "unlink", function () {
            t.execute("unlink");
            _this240._hideUI();
          });
          e.keystrokes.set("Esc", function (t, e) {
            _this240._hideUI();
            e();
          });
          e.keystrokes.set(av, function (t, e) {
            _this240._addFormView();
            e();
          });
          return e;
        }
      }, {
        key: "_createFormView",
        value: function _createFormView() {
          var _this241 = this;
          var t = this.editor;
          var e = t.commands.get("link");
          var n = t.config.get("link.defaultProtocol");
          var o = new tS(t.locale, e);
          o.urlInputView.fieldView.bind("value").to(e, "value");
          o.urlInputView.bind("isReadOnly").to(e, "isEnabled", function (t) {
            return !t;
          });
          o.saveButtonView.bind("isEnabled").to(e);
          this.listenTo(o, "submit", function () {
            var e = o.urlInputView.fieldView.element.value;
            var i = pv(e, n);
            t.execute("link", i, o.getDecoratorSwitchesState());
            _this241._closeFormView();
          });
          this.listenTo(o, "cancel", function () {
            _this241._closeFormView();
          });
          o.keystrokes.set("Esc", function (t, e) {
            _this241._closeFormView();
            e();
          });
          return o;
        }
      }, {
        key: "_createToolbarLinkButton",
        value: function _createToolbarLinkButton() {
          var _this242 = this;
          var t = this.editor;
          var e = t.commands.get("link");
          var n = t.t;
          t.keystrokes.set(av, function (t, n) {
            n();
            if (e.isEnabled) {
              _this242._showUI(true);
            }
          });
          t.ui.componentFactory.add("link", function (t) {
            var o = new cw(t);
            o.isEnabled = true;
            o.label = n("Link");
            o.icon = cS;
            o.keystroke = av;
            o.tooltip = true;
            o.isToggleable = true;
            o.bind("isEnabled").to(e, "isEnabled");
            o.bind("isOn").to(e, "value", function (t) {
              return !!t;
            });
            _this242.listenTo(o, "execute", function () {
              return _this242._showUI(true);
            });
            return o;
          });
        }
      }, {
        key: "_enableUserBalloonInteractions",
        value: function _enableUserBalloonInteractions() {
          var _this243 = this;
          var t = this.editor.editing.view.document;
          this.listenTo(t, "click", function () {
            var t = _this243._getSelectedLinkElement();
            if (t) {
              _this243._showUI();
            }
          });
          this.editor.keystrokes.set("Tab", function (t, e) {
            if (_this243._areActionsVisible && !_this243.actionsView.focusTracker.isFocused) {
              _this243.actionsView.focus();
              e();
            }
          }, {
            priority: "high"
          });
          this.editor.keystrokes.set("Esc", function (t, e) {
            if (_this243._isUIVisible) {
              _this243._hideUI();
              e();
            }
          });
          vw({
            emitter: this.formView,
            activator: function activator() {
              return _this243._isUIInPanel;
            },
            contextElements: [this._balloon.view.element],
            callback: function callback() {
              return _this243._hideUI();
            }
          });
        }
      }, {
        key: "_addActionsView",
        value: function _addActionsView() {
          if (this._areActionsInPanel) {
            return;
          }
          this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          });
        }
      }, {
        key: "_addFormView",
        value: function _addFormView() {
          if (this._isFormInPanel) {
            return;
          }
          var t = this.editor;
          var e = t.commands.get("link");
          this.formView.disableCssTransitions();
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          });
          if (this._balloon.visibleView === this.formView) {
            this.formView.urlInputView.fieldView.select();
          }
          this.formView.enableCssTransitions();
          this.formView.urlInputView.fieldView.element.value = e.value || "";
        }
      }, {
        key: "_closeFormView",
        value: function _closeFormView() {
          var t = this.editor.commands.get("link");
          t.restoreManualDecoratorStates();
          if (t.value !== undefined) {
            this._removeFormView();
          } else {
            this._hideUI();
          }
        }
      }, {
        key: "_removeFormView",
        value: function _removeFormView() {
          if (this._isFormInPanel) {
            this.formView.saveButtonView.focus();
            this._balloon.remove(this.formView);
            this.editor.editing.view.focus();
            this._hideFakeVisualSelection();
          }
        }
      }, {
        key: "_showUI",
        value: function _showUI() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          if (!this._getSelectedLinkElement()) {
            this._showFakeVisualSelection();
            this._addActionsView();
            if (t) {
              this._balloon.showStack("main");
            }
            this._addFormView();
          } else {
            if (this._areActionsVisible) {
              this._addFormView();
            } else {
              this._addActionsView();
            }
            if (t) {
              this._balloon.showStack("main");
            }
          }
          this._startUpdatingUI();
        }
      }, {
        key: "_hideUI",
        value: function _hideUI() {
          if (!this._isUIInPanel) {
            return;
          }
          var t = this.editor;
          this.stopListening(t.ui, "update");
          this.stopListening(this._balloon, "change:visibleView");
          t.editing.view.focus();
          this._removeFormView();
          this._balloon.remove(this.actionsView);
          this._hideFakeVisualSelection();
        }
      }, {
        key: "_startUpdatingUI",
        value: function _startUpdatingUI() {
          var _this244 = this;
          var t = this.editor;
          var e = t.editing.view.document;
          var n = this._getSelectedLinkElement();
          var o = r();
          var i = function i() {
            var t = _this244._getSelectedLinkElement();
            var e = r();
            if (n && !t || !n && e !== o) {
              _this244._hideUI();
            } else if (_this244._isUIVisible) {
              _this244._balloon.updatePosition(_this244._getBalloonPositionData());
            }
            n = t;
            o = e;
          };
          function r() {
            return e.selection.focus.getAncestors().reverse().find(function (t) {
              return t.is("element");
            });
          }
          this.listenTo(t.ui, "update", i);
          this.listenTo(this._balloon, "change:visibleView", i);
        }
      }, {
        key: "_getBalloonPositionData",
        value: function _getBalloonPositionData() {
          var t = this.editor.editing.view;
          var e = this.editor.model;
          var n = t.document;
          var o = null;
          if (e.markers.has(lS)) {
            var _e267 = Array.from(this.editor.editing.mapper.markerNameToElements(lS));
            var _n249 = t.createRange(t.createPositionBefore(_e267[0]), t.createPositionAfter(_e267[_e267.length - 1]));
            o = t.domConverter.viewRangeToDom(_n249);
          } else {
            var _e268 = this._getSelectedLinkElement();
            var _i137 = n.selection.getFirstRange();
            o = _e268 ? t.domConverter.mapViewToDom(_e268) : t.domConverter.viewRangeToDom(_i137);
          }
          return {
            target: o
          };
        }
      }, {
        key: "_getSelectedLinkElement",
        value: function _getSelectedLinkElement() {
          var t = this.editor.editing.view;
          var e = t.document.selection;
          if (e.isCollapsed) {
            return uS(e.getFirstPosition());
          } else {
            var _n250 = e.getFirstRange().getTrimmed();
            var _o171 = uS(_n250.start);
            var _i138 = uS(_n250.end);
            if (!_o171 || _o171 != _i138) {
              return null;
            }
            if (t.createRangeIn(_o171).getTrimmed().isEqual(_n250)) {
              return _o171;
            } else {
              return null;
            }
          }
        }
      }, {
        key: "_showFakeVisualSelection",
        value: function _showFakeVisualSelection() {
          var t = this.editor.model;
          t.change(function (e) {
            var n = t.document.selection.getFirstRange();
            if (t.markers.has(lS)) {
              e.updateMarker(lS, {
                range: n
              });
            } else {
              if (n.start.isAtEnd) {
                var _o172 = t.document.selection.focus;
                var _i139 = hS(n, _o172, e);
                e.addMarker(lS, {
                  usingOperation: false,
                  affectsData: false,
                  range: _i139
                });
              } else {
                e.addMarker(lS, {
                  usingOperation: false,
                  affectsData: false,
                  range: n
                });
              }
            }
          });
        }
      }, {
        key: "_hideFakeVisualSelection",
        value: function _hideFakeVisualSelection() {
          var t = this.editor.model;
          if (t.markers.has(lS)) {
            t.change(function (t) {
              t.removeMarker(lS);
            });
          }
        }
      }, {
        key: "_isFormInPanel",
        get: function get() {
          return this._balloon.hasView(this.formView);
        }
      }, {
        key: "_areActionsInPanel",
        get: function get() {
          return this._balloon.hasView(this.actionsView);
        }
      }, {
        key: "_areActionsVisible",
        get: function get() {
          return this._balloon.visibleView === this.actionsView;
        }
      }, {
        key: "_isUIInPanel",
        get: function get() {
          return this._isFormInPanel || this._areActionsInPanel;
        }
      }, {
        key: "_isUIVisible",
        get: function get() {
          var t = this._balloon.visibleView;
          return t == this.formView || this._areActionsVisible;
        }
      }], [{
        key: "requires",
        get: function get() {
          return [kD];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "LinkUI";
        }
      }]);
      return dS;
    }(aC);
    function uS(t) {
      return t.getAncestors().find(function (t) {
        return cv(t);
      });
    }
    function hS(t, e, n) {
      var o = [t.start.path[0] + 1, 0];
      var i = n.createPositionFromPath(t.start.root, o, "toNext");
      var r = n.createRange(i, t.end);
      if (r.start.path[0] > t.end.path[0]) {
        return n.createRange(e);
      }
      if (i.isAtStart && i.isAtEnd) {
        return hS(r, e, n);
      }
      return r;
    }
    function fS(t, e) {
      var n = t.start;
      var o = Array.from(t.getItems()).reduce(function (t, o) {
        if (!(o.is("$text") || o.is("$textProxy"))) {
          n = e.createPositionAfter(o);
          return "";
        }
        return t + o.data;
      }, "");
      return {
        text: o,
        range: e.createRange(n, t.end)
      };
    }
    var mS = /*#__PURE__*/function () {
      function mS(t, e) {
        var _this245 = this;
        _classCallCheck(this, mS);
        this.model = t;
        this.testCallback = e;
        this.hasMatch = false;
        this.set("isEnabled", true);
        this.on("change:isEnabled", function () {
          if (_this245.isEnabled) {
            _this245._startListening();
          } else {
            _this245.stopListening(t.document.selection);
            _this245.stopListening(t.document);
          }
        });
        this._startListening();
      }
      _createClass(mS, [{
        key: "_startListening",
        value: function _startListening() {
          var _this246 = this;
          var t = this.model;
          var e = t.document;
          this.listenTo(e.selection, "change:range", function (t, _ref45) {
            var n = _ref45.directChange;
            if (!n) {
              return;
            }
            if (!e.selection.isCollapsed) {
              if (_this246.hasMatch) {
                _this246.fire("unmatched");
                _this246.hasMatch = false;
              }
              return;
            }
            _this246._evaluateTextBeforeSelection("selection");
          });
          this.listenTo(e, "change:data", function (t, e) {
            if (e.type == "transparent") {
              return;
            }
            _this246._evaluateTextBeforeSelection("data", {
              batch: e
            });
          });
        }
      }, {
        key: "_evaluateTextBeforeSelection",
        value: function _evaluateTextBeforeSelection(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.model;
          var o = n.document;
          var i = o.selection;
          var r = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus);
          var _fS = fS(r, n),
            s = _fS.text,
            a = _fS.range;
          var c = this.testCallback(s);
          if (!c && this.hasMatch) {
            this.fire("unmatched");
          }
          this.hasMatch = !!c;
          if (c) {
            var _n251 = Object.assign(e, {
              text: s,
              range: a
            });
            if (typeof c == "object") {
              Object.assign(_n251, c);
            }
            this.fire("matched:".concat(t), _n251);
          }
        }
      }]);
      return mS;
    }();
    _s(mS, Zc);
    var gS = 4;
    var pS = new RegExp("(^|\\s)" + "(" + "(" + "(?:(?:(?:https?|ftp):)?\\/\\/)" + "(?:\\S+(?::\\S*)?@)?" + "(?:" + "(?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+" + "(?:[a-z\\u00a1-\\uffff]{2,})" + ")" + "(?::\\d{2,5})?" + "(?:[/?#]\\S*)?" + ")" + "|" + "(" + "(www.|(\\S+@))" + "((?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.))+" + "(?:[a-z\\u00a1-\\uffff]{2,})" + ")" + ")$", "i");
    var kS = 2;
    var bS = /*#__PURE__*/function (_aC64) {
      _inherits(bS, _aC64);
      function bS() {
        _classCallCheck(this, bS);
        return _possibleConstructorReturn(this, _getPrototypeOf(bS).apply(this, arguments));
      }
      _createClass(bS, [{
        key: "init",
        value: function init() {
          var _this247 = this;
          var t = this.editor;
          var e = t.model.document.selection;
          e.on("change:range", function () {
            _this247.isEnabled = !e.anchor.parent.is("element", "codeBlock");
          });
          this._enableTypingHandling();
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          this._enableEnterHandling();
          this._enableShiftEnterHandling();
        }
      }, {
        key: "_enableTypingHandling",
        value: function _enableTypingHandling() {
          var _this248 = this;
          var t = this.editor;
          var e = new mS(t.model, function (t) {
            if (!wS(t)) {
              return;
            }
            var e = CS(t.substr(0, t.length - 1));
            if (e) {
              return {
                url: e
              };
            }
          });
          var n = t.plugins.get("Input");
          e.on("matched:data", function (e, o) {
            var i = o.batch,
              r = o.range,
              s = o.url;
            if (!n.isInput(i)) {
              return;
            }
            var a = r.end.getShiftedBy(-1);
            var c = a.getShiftedBy(-s.length);
            var l = t.model.createRange(c, a);
            _this248._applyAutoLink(s, l);
          });
          e.bind("isEnabled").to(this);
        }
      }, {
        key: "_enableEnterHandling",
        value: function _enableEnterHandling() {
          var _this249 = this;
          var t = this.editor;
          var e = t.model;
          var n = t.commands.get("enter");
          if (!n) {
            return;
          }
          n.on("execute", function () {
            var t = e.document.selection.getFirstPosition();
            if (!t.parent.previousSibling) {
              return;
            }
            var n = e.createRangeIn(t.parent.previousSibling);
            _this249._checkAndApplyAutoLinkOnRange(n);
          });
        }
      }, {
        key: "_enableShiftEnterHandling",
        value: function _enableShiftEnterHandling() {
          var _this250 = this;
          var t = this.editor;
          var e = t.model;
          var n = t.commands.get("shiftEnter");
          if (!n) {
            return;
          }
          n.on("execute", function () {
            var t = e.document.selection.getFirstPosition();
            var n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));
            _this250._checkAndApplyAutoLinkOnRange(n);
          });
        }
      }, {
        key: "_checkAndApplyAutoLinkOnRange",
        value: function _checkAndApplyAutoLinkOnRange(t) {
          var e = this.editor.model;
          var _fS2 = fS(t, e),
            n = _fS2.text,
            o = _fS2.range;
          var i = CS(n);
          if (i) {
            var _t296 = e.createRange(o.end.getShiftedBy(-i.length), o.end);
            this._applyAutoLink(i, _t296);
          }
        }
      }, {
        key: "_applyAutoLink",
        value: function _applyAutoLink(t, e) {
          var _this251 = this;
          var n = this.editor.model;
          if (!this.isEnabled || !AS(e, n)) {
            return;
          }
          n.enqueueChange(function (n) {
            var o = _this251.editor.config.get("link.defaultProtocol");
            var i = pv(t, o);
            n.setAttribute("linkHref", i, e);
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "AutoLink";
        }
      }]);
      return bS;
    }(aC);
    function wS(t) {
      return t.length > gS && t[t.length - 1] === " " && t[t.length - 2] !== " ";
    }
    function CS(t) {
      var e = pS.exec(t);
      return e ? e[kS] : null;
    }
    function AS(t, e) {
      return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
    }
    var _S = /*#__PURE__*/function (_aC65) {
      _inherits(_S, _aC65);
      function _S() {
        _classCallCheck(this, _S);
        return _possibleConstructorReturn(this, _getPrototypeOf(_S).apply(this, arguments));
      }
      _createClass(_S, null, [{
        key: "requires",
        get: function get() {
          return [Mv, dS, bS];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Link";
        }
      }]);
      return _S;
    }(aC);
    var vS = /*#__PURE__*/function (_uC21) {
      _inherits(vS, _uC21);
      function vS(t, e) {
        var _this252;
        _classCallCheck(this, vS);
        _this252 = _possibleConstructorReturn(this, _getPrototypeOf(vS).call(this, t));
        _this252.type = e;
        return _this252;
      }
      _createClass(vS, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue();
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this253 = this;
          var t = this.editor.model;
          var e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks()).filter(function (e) {
            return xS(e, t.schema);
          });
          var o = this.value === true;
          t.change(function (t) {
            if (o) {
              var _e269 = n[n.length - 1].nextSibling;
              var _o173 = Number.POSITIVE_INFINITY;
              var _i140 = [];
              while (_e269 && _e269.name == "listItem" && _e269.getAttribute("listIndent") !== 0) {
                var _t297 = _e269.getAttribute("listIndent");
                if (_t297 < _o173) {
                  _o173 = _t297;
                }
                var _n252 = _t297 - _o173;
                _i140.push({
                  element: _e269,
                  listIndent: _n252
                });
                _e269 = _e269.nextSibling;
              }
              _i140 = _i140.reverse();
              var _iterator365 = _createForOfIteratorHelper(_i140),
                _step365;
              try {
                for (_iterator365.s(); !(_step365 = _iterator365.n()).done;) {
                  var _e270 = _step365.value;
                  t.setAttribute("listIndent", _e270.listIndent, _e270.element);
                }
              } catch (err) {
                _iterator365.e(err);
              } finally {
                _iterator365.f();
              }
            }
            if (!o) {
              var _t298 = Number.POSITIVE_INFINITY;
              var _iterator366 = _createForOfIteratorHelper(n),
                _step366;
              try {
                for (_iterator366.s(); !(_step366 = _iterator366.n()).done;) {
                  var _e271 = _step366.value;
                  if (_e271.is("element", "listItem") && _e271.getAttribute("listIndent") < _t298) {
                    _t298 = _e271.getAttribute("listIndent");
                  }
                }
              } catch (err) {
                _iterator366.e(err);
              } finally {
                _iterator366.f();
              }
              _t298 = _t298 === 0 ? 1 : _t298;
              yS(n, true, _t298);
              yS(n, false, _t298);
            }
            var _iterator367 = _createForOfIteratorHelper(n.reverse()),
              _step367;
            try {
              for (_iterator367.s(); !(_step367 = _iterator367.n()).done;) {
                var _e272 = _step367.value;
                if (o && _e272.name == "listItem") {
                  t.rename(_e272, "paragraph");
                } else if (!o && _e272.name != "listItem") {
                  t.setAttributes({
                    listType: _this253.type,
                    listIndent: 0
                  }, _e272);
                  t.rename(_e272, "listItem");
                } else if (!o && _e272.name == "listItem" && _e272.getAttribute("listType") != _this253.type) {
                  t.setAttribute("listType", _this253.type, _e272);
                }
              }
            } catch (err) {
              _iterator367.e(err);
            } finally {
              _iterator367.f();
            }
            _this253.fire("_executeCleanup", n);
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var t = nC(this.editor.model.document.selection.getSelectedBlocks());
          return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type;
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) {
            return true;
          }
          var t = this.editor.model.document.selection;
          var e = this.editor.model.schema;
          var n = nC(t.getSelectedBlocks());
          if (!n) {
            return false;
          }
          return xS(n, e);
        }
      }]);
      return vS;
    }(uC);
    function yS(t, e, n) {
      var o = e ? t[0] : t[t.length - 1];
      if (o.is("element", "listItem")) {
        var _i141 = o[e ? "previousSibling" : "nextSibling"];
        var _r52 = o.getAttribute("listIndent");
        while (_i141 && _i141.is("element", "listItem") && _i141.getAttribute("listIndent") >= n) {
          if (_r52 > _i141.getAttribute("listIndent")) {
            _r52 = _i141.getAttribute("listIndent");
          }
          if (_i141.getAttribute("listIndent") == _r52) {
            t[e ? "unshift" : "push"](_i141);
          }
          _i141 = _i141[e ? "previousSibling" : "nextSibling"];
        }
      }
    }
    function xS(t, e) {
      return e.checkChild(t.parent, "listItem") && !e.isObject(t);
    }
    var DS = /*#__PURE__*/function (_uC22) {
      _inherits(DS, _uC22);
      function DS(t, e) {
        var _this254;
        _classCallCheck(this, DS);
        _this254 = _possibleConstructorReturn(this, _getPrototypeOf(DS).call(this, t));
        _this254._indentBy = e == "forward" ? 1 : -1;
        return _this254;
      }
      _createClass(DS, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this255 = this;
          var t = this.editor.model;
          var e = t.document;
          var n = Array.from(e.selection.getSelectedBlocks());
          t.change(function (t) {
            var e = n[n.length - 1];
            var o = e.nextSibling;
            while (o && o.name == "listItem" && o.getAttribute("listIndent") > e.getAttribute("listIndent")) {
              n.push(o);
              o = o.nextSibling;
            }
            if (_this255._indentBy < 0) {
              n = n.reverse();
            }
            var _iterator368 = _createForOfIteratorHelper(n),
              _step368;
            try {
              for (_iterator368.s(); !(_step368 = _iterator368.n()).done;) {
                var _e273 = _step368.value;
                var _n253 = _e273.getAttribute("listIndent") + _this255._indentBy;
                if (_n253 < 0) {
                  t.rename(_e273, "paragraph");
                } else {
                  t.setAttribute("listIndent", _n253, _e273);
                }
              }
            } catch (err) {
              _iterator368.e(err);
            } finally {
              _iterator368.f();
            }
            _this255.fire("_executeCleanup", n);
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var t = nC(this.editor.model.document.selection.getSelectedBlocks());
          if (!t || !t.is("element", "listItem")) {
            return false;
          }
          if (this._indentBy > 0) {
            var _e274 = t.getAttribute("listIndent");
            var _n254 = t.getAttribute("listType");
            var _o174 = t.previousSibling;
            while (_o174 && _o174.is("element", "listItem") && _o174.getAttribute("listIndent") >= _e274) {
              if (_o174.getAttribute("listIndent") == _e274) {
                return _o174.getAttribute("listType") == _n254;
              }
              _o174 = _o174.previousSibling;
            }
            return false;
          }
          return true;
        }
      }]);
      return DS;
    }(uC);
    function ES(t) {
      var e = t.createContainerElement("li");
      e.getFillerOffset = LS;
      return e;
    }
    function MS(t, e) {
      var n = e.mapper;
      var o = e.writer;
      var i = t.getAttribute("listType") == "numbered" ? "ol" : "ul";
      var r = ES(o);
      var s = o.createContainerElement(i, null);
      o.insert(o.createPositionAt(s, 0), r);
      n.bindElements(t, r);
      return r;
    }
    function SS(t, e, n, o) {
      var i = e.parent;
      var r = n.mapper;
      var s = n.writer;
      var a = r.toViewPosition(o.createPositionBefore(t));
      var c = NS(t.previousSibling, {
        sameIndent: true,
        smallerIndent: true,
        listIndent: t.getAttribute("listIndent")
      });
      var l = t.previousSibling;
      if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
        var _t299 = r.toViewElement(c);
        a = s.breakContainer(s.createPositionAfter(_t299));
      } else {
        if (l && l.name == "listItem") {
          a = r.toViewPosition(o.createPositionAt(l, "end"));
          var _t300 = r.findMappedViewAncestor(a);
          var _e275 = BS(_t300);
          if (_e275) {
            a = s.createPositionBefore(_e275);
          } else {
            a = s.createPositionAt(_t300, "end");
          }
        } else {
          a = r.toViewPosition(o.createPositionBefore(t));
        }
      }
      a = IS(a);
      s.insert(a, i);
      if (l && l.name == "listItem") {
        var _t301 = r.toViewElement(l);
        var _n255 = s.createRange(s.createPositionAt(_t301, 0), a);
        var _o175 = _n255.getWalker({
          ignoreElementEnd: true
        });
        var _iterator369 = _createForOfIteratorHelper(_o175),
          _step369;
        try {
          for (_iterator369.s(); !(_step369 = _iterator369.n()).done;) {
            var _t302 = _step369.value;
            if (_t302.item.is("element", "li")) {
              var _n256 = s.breakContainer(s.createPositionBefore(_t302.item));
              var _i142 = _t302.item.parent;
              var _r53 = s.createPositionAt(e, "end");
              TS(s, _r53.nodeBefore, _r53.nodeAfter);
              s.move(s.createRangeOn(_i142), _r53);
              _o175.position = _n256;
            }
          }
        } catch (err) {
          _iterator369.e(err);
        } finally {
          _iterator369.f();
        }
      } else {
        var _n257 = i.nextSibling;
        if (_n257 && (_n257.is("element", "ul") || _n257.is("element", "ol"))) {
          var _o176 = null;
          var _iterator370 = _createForOfIteratorHelper(_n257.getChildren()),
            _step370;
          try {
            for (_iterator370.s(); !(_step370 = _iterator370.n()).done;) {
              var _e276 = _step370.value;
              var _n258 = r.toModelElement(_e276);
              if (_n258 && _n258.getAttribute("listIndent") > t.getAttribute("listIndent")) {
                _o176 = _e276;
              } else {
                break;
              }
            }
          } catch (err) {
            _iterator370.e(err);
          } finally {
            _iterator370.f();
          }
          if (_o176) {
            s.breakContainer(s.createPositionAfter(_o176));
            s.move(s.createRangeOn(_o176.parent), s.createPositionAt(e, "end"));
          }
        }
      }
      TS(s, i, i.nextSibling);
      TS(s, i.previousSibling, i);
    }
    function TS(t, e, n) {
      if (!e || !n || e.name != "ul" && e.name != "ol") {
        return null;
      }
      if (e.name != n.name || e.getAttribute("class") !== n.getAttribute("class")) {
        return null;
      }
      return t.mergeContainers(t.createPositionAfter(e));
    }
    function IS(t) {
      return t.getLastMatchingPosition(function (t) {
        return t.item.is("uiElement");
      });
    }
    function NS(t, e) {
      var n = !!e.sameIndent;
      var o = !!e.smallerIndent;
      var i = e.listIndent;
      var r = t;
      while (r && r.name == "listItem") {
        var _t303 = r.getAttribute("listIndent");
        if (n && i == _t303 || o && i > _t303) {
          return r;
        }
        if (e.direction === "forward") {
          r = r.nextSibling;
        } else {
          r = r.previousSibling;
        }
      }
      return null;
    }
    function PS(t, e, n, o) {
      t.ui.componentFactory.add(e, function (i) {
        var r = t.commands.get(e);
        var s = new cw(i);
        s.set({
          label: n,
          icon: o,
          tooltip: true,
          isToggleable: true
        });
        s.bind("isOn", "isEnabled").to(r, "value", "isEnabled");
        s.on("execute", function () {
          t.execute(e);
          t.editing.view.focus();
        });
        return s;
      });
    }
    function BS(t) {
      var _iterator371 = _createForOfIteratorHelper(t.getChildren()),
        _step371;
      try {
        for (_iterator371.s(); !(_step371 = _iterator371.n()).done;) {
          var _e277 = _step371.value;
          if (_e277.name == "ul" || _e277.name == "ol") {
            return _e277;
          }
        }
      } catch (err) {
        _iterator371.e(err);
      } finally {
        _iterator371.f();
      }
      return null;
    }
    function zS(t, e) {
      var n = [];
      var o = t.parent;
      var i = {
        ignoreElementEnd: true,
        startPosition: t,
        shallow: true,
        direction: e
      };
      var r = o.getAttribute("listIndent");
      var s = _toConsumableArray(new Qh(i)).filter(function (t) {
        return t.item.is("element");
      }).map(function (t) {
        return t.item;
      });
      var _iterator372 = _createForOfIteratorHelper(s),
        _step372;
      try {
        for (_iterator372.s(); !(_step372 = _iterator372.n()).done;) {
          var _t304 = _step372.value;
          if (!_t304.is("element", "listItem")) {
            break;
          }
          if (_t304.getAttribute("listIndent") < r) {
            break;
          }
          if (_t304.getAttribute("listIndent") > r) {
            continue;
          }
          if (_t304.getAttribute("listType") !== o.getAttribute("listType")) {
            break;
          }
          if (_t304.getAttribute("listStyle") !== o.getAttribute("listStyle")) {
            break;
          }
          if (e === "backward") {
            n.unshift(_t304);
          } else {
            n.push(_t304);
          }
        }
      } catch (err) {
        _iterator372.e(err);
      } finally {
        _iterator372.f();
      }
      return n;
    }
    function LS() {
      var t = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol");
      if (this.isEmpty || t) {
        return 0;
      }
      return Gc.call(this);
    }
    function OS(t) {
      return function (e, n, o) {
        var i = o.consumable;
        if (!i.test(n.item, "insert") || !i.test(n.item, "attribute:listType") || !i.test(n.item, "attribute:listIndent")) {
          return;
        }
        i.consume(n.item, "insert");
        i.consume(n.item, "attribute:listType");
        i.consume(n.item, "attribute:listIndent");
        var r = n.item;
        var s = MS(r, o);
        SS(r, s, o, t);
      };
    }
    function RS(t) {
      return function (e, n, o) {
        var i = o.mapper.toViewPosition(n.position);
        var r = i.getLastMatchingPosition(function (t) {
          return !t.item.is("element", "li");
        });
        var s = r.nodeAfter;
        var a = o.writer;
        a.breakContainer(a.createPositionBefore(s));
        a.breakContainer(a.createPositionAfter(s));
        var c = s.parent;
        var l = c.previousSibling;
        var d = a.createRangeOn(c);
        var u = a.remove(d);
        if (l && l.nextSibling) {
          TS(a, l, l.nextSibling);
        }
        var h = o.mapper.toModelElement(s);
        XS(h.getAttribute("listIndent") + 1, n.position, d.start, s, o, t);
        var _iterator373 = _createForOfIteratorHelper(a.createRangeIn(u).getItems()),
          _step373;
        try {
          for (_iterator373.s(); !(_step373 = _iterator373.n()).done;) {
            var _t305 = _step373.value;
            o.mapper.unbindViewElement(_t305);
          }
        } catch (err) {
          _iterator373.e(err);
        } finally {
          _iterator373.f();
        }
        e.stop();
      };
    }
    function jS(t, e, n) {
      if (!n.consumable.consume(e.item, "attribute:listType")) {
        return;
      }
      var o = n.mapper.toViewElement(e.item);
      var i = n.writer;
      i.breakContainer(i.createPositionBefore(o));
      i.breakContainer(i.createPositionAfter(o));
      var r = o.parent;
      var s = e.attributeNewValue == "numbered" ? "ol" : "ul";
      i.rename(s, r);
    }
    function FS(t, e, n) {
      var o = n.mapper.toViewElement(e.item);
      var i = o.parent;
      var r = n.writer;
      TS(r, i, i.nextSibling);
      TS(r, i.previousSibling, i);
      var _iterator374 = _createForOfIteratorHelper(e.item.getChildren()),
        _step374;
      try {
        for (_iterator374.s(); !(_step374 = _iterator374.n()).done;) {
          var _t306 = _step374.value;
          n.consumable.consume(_t306, "insert");
        }
      } catch (err) {
        _iterator374.e(err);
      } finally {
        _iterator374.f();
      }
    }
    function VS(t) {
      return function (e, n, o) {
        if (!o.consumable.consume(n.item, "attribute:listIndent")) {
          return;
        }
        var i = o.mapper.toViewElement(n.item);
        var r = o.writer;
        r.breakContainer(r.createPositionBefore(i));
        r.breakContainer(r.createPositionAfter(i));
        var s = i.parent;
        var a = s.previousSibling;
        var c = r.createRangeOn(s);
        r.remove(c);
        if (a && a.nextSibling) {
          TS(r, a, a.nextSibling);
        }
        XS(n.attributeOldValue + 1, n.range.start, c.start, i, o, t);
        SS(n.item, i, o, t);
        var _iterator375 = _createForOfIteratorHelper(n.item.getChildren()),
          _step375;
        try {
          for (_iterator375.s(); !(_step375 = _iterator375.n()).done;) {
            var _t307 = _step375.value;
            o.consumable.consume(_t307, "insert");
          }
        } catch (err) {
          _iterator375.e(err);
        } finally {
          _iterator375.f();
        }
      };
    }
    function US(t, e, n) {
      if (e.item.name != "listItem") {
        var _t308 = n.mapper.toViewPosition(e.range.start);
        var _o177 = n.writer;
        var _i143 = [];
        while (_t308.parent.name == "ul" || _t308.parent.name == "ol") {
          _t308 = _o177.breakContainer(_t308);
          if (_t308.parent.name != "li") {
            break;
          }
          var _e278 = _t308;
          var _n259 = _o177.createPositionAt(_t308.parent, "end");
          if (!_e278.isEqual(_n259)) {
            var _t309 = _o177.remove(_o177.createRange(_e278, _n259));
            _i143.push(_t309);
          }
          _t308 = _o177.createPositionAfter(_t308.parent);
        }
        if (_i143.length > 0) {
          for (var _e279 = 0; _e279 < _i143.length; _e279++) {
            var _n260 = _t308.nodeBefore;
            var _r54 = _o177.insert(_t308, _i143[_e279]);
            _t308 = _r54.end;
            if (_e279 > 0) {
              var _e280 = TS(_o177, _n260, _n260.nextSibling);
              if (_e280 && _e280.parent == _n260) {
                _t308.offset--;
              }
            }
          }
          TS(_o177, _t308.nodeBefore, _t308.nodeAfter);
        }
      }
    }
    function HS(t, e, n) {
      var o = n.mapper.toViewPosition(e.position);
      var i = o.nodeBefore;
      var r = o.nodeAfter;
      TS(n.writer, i, r);
    }
    function GS(t, e, n) {
      if (n.consumable.consume(e.viewItem, {
        name: true
      })) {
        var _t310 = n.writer;
        var _o178 = _t310.createElement("listItem");
        var _i144 = eT(e.viewItem);
        _t310.setAttribute("listIndent", _i144, _o178);
        var _r55 = e.viewItem.parent && e.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
        _t310.setAttribute("listType", _r55, _o178);
        if (!n.safeInsert(_o178, e.modelCursor)) {
          return;
        }
        var _s38 = ZS(_o178, e.viewItem.getChildren(), n);
        e.modelRange = _t310.createRange(e.modelCursor, _s38);
        n.updateConversionResult(_o178, e);
      }
    }
    function WS(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: true
      })) {
        var _t311 = Array.from(e.viewItem.getChildren());
        for (var _i145 = 0, _t312 = _t311; _i145 < _t312.length; _i145++) {
          var _e281 = _t312[_i145];
          var _t313 = !(_e281.is("element", "li") || tT(_e281));
          if (_t313) {
            _e281._remove();
          }
        }
      }
    }
    function KS(t, e, n) {
      if (n.consumable.test(e.viewItem, {
        name: true
      })) {
        if (e.viewItem.childCount === 0) {
          return;
        }
        var _t314 = _toConsumableArray(e.viewItem.getChildren());
        var _n261 = false;
        var _o179 = true;
        var _iterator376 = _createForOfIteratorHelper(_t314),
          _step376;
        try {
          for (_iterator376.s(); !(_step376 = _iterator376.n()).done;) {
            var _e282 = _step376.value;
            if (_n261 && !tT(_e282)) {
              _e282._remove();
            }
            if (_e282.is("$text")) {
              if (_o179) {
                _e282._data = _e282.data.replace(/^\s+/, "");
              }
              if (!_e282.nextSibling || tT(_e282.nextSibling)) {
                _e282._data = _e282.data.replace(/\s+$/, "");
              }
            } else if (tT(_e282)) {
              _n261 = true;
            }
            _o179 = false;
          }
        } catch (err) {
          _iterator376.e(err);
        } finally {
          _iterator376.f();
        }
      }
    }
    function qS(t) {
      return function (e, n) {
        if (n.isPhantom) {
          return;
        }
        var o = n.modelPosition.nodeBefore;
        if (o && o.is("element", "listItem")) {
          var _e283 = n.mapper.toViewElement(o);
          var _i146 = _e283.getAncestors().find(tT);
          var _r56 = t.createPositionAt(_e283, 0).getWalker();
          var _iterator377 = _createForOfIteratorHelper(_r56),
            _step377;
          try {
            for (_iterator377.s(); !(_step377 = _iterator377.n()).done;) {
              var _t315 = _step377.value;
              if (_t315.type == "elementStart" && _t315.item.is("element", "li")) {
                n.viewPosition = _t315.previousPosition;
                break;
              } else if (_t315.type == "elementEnd" && _t315.item == _i146) {
                n.viewPosition = _t315.nextPosition;
                break;
              }
            }
          } catch (err) {
            _iterator377.e(err);
          } finally {
            _iterator377.f();
          }
        }
      };
    }
    function YS(t) {
      return function (e, n) {
        var o = n.viewPosition;
        var i = o.parent;
        var r = n.mapper;
        if (i.name == "ul" || i.name == "ol") {
          if (!o.isAtEnd) {
            var _e284 = r.toModelElement(o.nodeAfter);
            n.modelPosition = t.createPositionBefore(_e284);
          } else {
            var _e285 = r.toModelElement(o.nodeBefore);
            var _i147 = r.getModelLength(o.nodeBefore);
            n.modelPosition = t.createPositionBefore(_e285).getShiftedBy(_i147);
          }
          e.stop();
        } else if (i.name == "li" && o.nodeBefore && (o.nodeBefore.name == "ul" || o.nodeBefore.name == "ol")) {
          var _s39 = r.toModelElement(i);
          var _a25 = 1;
          var _c13 = o.nodeBefore;
          while (_c13 && tT(_c13)) {
            _a25 += r.getModelLength(_c13);
            _c13 = _c13.previousSibling;
          }
          n.modelPosition = t.createPositionBefore(_s39).getShiftedBy(_a25);
          e.stop();
        }
      };
    }
    function QS(t, e) {
      var n = t.document.differ.getChanges();
      var o = new Map();
      var i = false;
      var _iterator378 = _createForOfIteratorHelper(n),
        _step378;
      try {
        for (_iterator378.s(); !(_step378 = _iterator378.n()).done;) {
          var _o181 = _step378.value;
          if (_o181.type == "insert" && _o181.name == "listItem") {
            r(_o181.position);
          } else if (_o181.type == "insert" && _o181.name != "listItem") {
            if (_o181.name != "$text") {
              var _n262 = _o181.position.nodeAfter;
              if (_n262.hasAttribute("listIndent")) {
                e.removeAttribute("listIndent", _n262);
                i = true;
              }
              if (_n262.hasAttribute("listType")) {
                e.removeAttribute("listType", _n262);
                i = true;
              }
              if (_n262.hasAttribute("listStyle")) {
                e.removeAttribute("listStyle", _n262);
                i = true;
              }
              var _iterator380 = _createForOfIteratorHelper(Array.from(t.createRangeIn(_n262)).filter(function (t) {
                  return t.item.is("element", "listItem");
                })),
                _step380;
              try {
                for (_iterator380.s(); !(_step380 = _iterator380.n()).done;) {
                  var _e288 = _step380.value;
                  r(_e288.previousPosition);
                }
              } catch (err) {
                _iterator380.e(err);
              } finally {
                _iterator380.f();
              }
            }
            var _n263 = _o181.position.getShiftedBy(_o181.length);
            r(_n263);
          } else if (_o181.type == "remove" && _o181.name == "listItem") {
            r(_o181.position);
          } else if (_o181.type == "attribute" && _o181.attributeKey == "listIndent") {
            r(_o181.range.start);
          } else if (_o181.type == "attribute" && _o181.attributeKey == "listType") {
            r(_o181.range.start);
          }
        }
      } catch (err) {
        _iterator378.e(err);
      } finally {
        _iterator378.f();
      }
      var _iterator379 = _createForOfIteratorHelper(o.values()),
        _step379;
      try {
        for (_iterator379.s(); !(_step379 = _iterator379.n()).done;) {
          var _t317 = _step379.value;
          s(_t317);
          a(_t317);
        }
      } catch (err) {
        _iterator379.e(err);
      } finally {
        _iterator379.f();
      }
      return i;
      function r(t) {
        var e = t.nodeBefore;
        if (!e || !e.is("element", "listItem")) {
          var _e286 = t.nodeAfter;
          if (_e286 && _e286.is("element", "listItem")) {
            o.set(_e286, _e286);
          }
        } else {
          var _t316 = e;
          if (o.has(_t316)) {
            return;
          }
          for (var _e287 = _t316.previousSibling; _e287 && _e287.is("element", "listItem"); _e287 = _t316.previousSibling) {
            _t316 = _e287;
            if (o.has(_t316)) {
              return;
            }
          }
          o.set(e, _t316);
        }
      }
      function s(t) {
        var n = 0;
        var o = null;
        while (t && t.is("element", "listItem")) {
          var _r57 = t.getAttribute("listIndent");
          if (_r57 > n) {
            var _s40 = void 0;
            if (o === null) {
              o = _r57 - n;
              _s40 = n;
            } else {
              if (o > _r57) {
                o = _r57;
              }
              _s40 = _r57 - o;
            }
            e.setAttribute("listIndent", _s40, t);
            i = true;
          } else {
            o = null;
            n = t.getAttribute("listIndent") + 1;
          }
          t = t.nextSibling;
        }
      }
      function a(t) {
        var n = [];
        var o = null;
        while (t && t.is("element", "listItem")) {
          var _r58 = t.getAttribute("listIndent");
          if (o && o.getAttribute("listIndent") > _r58) {
            n = n.slice(0, _r58 + 1);
          }
          if (_r58 != 0) {
            if (n[_r58]) {
              var _o180 = n[_r58];
              if (t.getAttribute("listType") != _o180) {
                e.setAttribute("listType", _o180, t);
                i = true;
              }
            } else {
              n[_r58] = t.getAttribute("listType");
            }
          }
          o = t;
          t = t.nextSibling;
        }
      }
    }
    function $S(t, _ref46) {
      var _ref47 = _slicedToArray(_ref46, 2),
        e = _ref47[0],
        n = _ref47[1];
      var o = e.is("documentFragment") ? e.getChild(0) : e;
      var i;
      if (!n) {
        i = this.document.selection;
      } else {
        i = this.createSelection(n);
      }
      if (o && o.is("element", "listItem")) {
        var _t318 = i.getFirstPosition();
        var _e289 = null;
        if (_t318.parent.is("element", "listItem")) {
          _e289 = _t318.parent;
        } else if (_t318.nodeBefore && _t318.nodeBefore.is("element", "listItem")) {
          _e289 = _t318.nodeBefore;
        }
        if (_e289) {
          var _t319 = _e289.getAttribute("listIndent");
          if (_t319 > 0) {
            while (o && o.is("element", "listItem")) {
              o._setAttribute("listIndent", o.getAttribute("listIndent") + _t319);
              o = o.nextSibling;
            }
          }
        }
      }
    }
    function ZS(t, e, n) {
      var o = n.writer,
        i = n.schema;
      var r = o.createPositionAfter(t);
      var _iterator381 = _createForOfIteratorHelper(e),
        _step381;
      try {
        for (_iterator381.s(); !(_step381 = _iterator381.n()).done;) {
          var _s41 = _step381.value;
          if (_s41.name == "ul" || _s41.name == "ol") {
            r = n.convertItem(_s41, r).modelCursor;
          } else {
            var _e290 = n.convertItem(_s41, o.createPositionAt(t, "end"));
            var _a26 = _e290.modelRange.start.nodeAfter;
            var _c14 = _a26 && _a26.is("element") && !i.checkChild(t, _a26.name);
            if (_c14) {
              if (_e290.modelCursor.parent.is("element", "listItem")) {
                t = _e290.modelCursor.parent;
              } else {
                t = JS(_e290.modelCursor);
              }
              r = o.createPositionAfter(t);
            }
          }
        }
      } catch (err) {
        _iterator381.e(err);
      } finally {
        _iterator381.f();
      }
      return r;
    }
    function JS(t) {
      var e = new Qh({
        startPosition: t
      });
      var n;
      do {
        n = e.next();
      } while (!n.value.item.is("element", "listItem"));
      return n.value.item;
    }
    function XS(t, e, n, o, i, r) {
      var s = NS(e.nodeBefore, {
        sameIndent: true,
        smallerIndent: true,
        listIndent: t,
        foo: "b"
      });
      var a = i.mapper;
      var c = i.writer;
      var l = s ? s.getAttribute("listIndent") : null;
      var d;
      if (!s) {
        d = n;
      } else if (l == t) {
        var _t320 = a.toViewElement(s).parent;
        d = c.createPositionAfter(_t320);
      } else {
        var _t321 = r.createPositionAt(s, "end");
        d = a.toViewPosition(_t321);
      }
      d = IS(d);
      for (var _i148 = 0, _arr = _toConsumableArray(o.getChildren()); _i148 < _arr.length; _i148++) {
        var _t322 = _arr[_i148];
        if (tT(_t322)) {
          d = c.move(c.createRangeOn(_t322), d).end;
          TS(c, _t322, _t322.nextSibling);
          TS(c, _t322.previousSibling, _t322);
        }
      }
    }
    function tT(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function eT(t) {
      var e = 0;
      var n = t.parent;
      while (n) {
        if (n.is("element", "li")) {
          e++;
        } else {
          var _t323 = n.previousSibling;
          if (_t323 && _t323.is("element", "li")) {
            e++;
          }
        }
        n = n.parent;
      }
      return e;
    }
    var nT = /*#__PURE__*/function (_aC66) {
      _inherits(nT, _aC66);
      function nT() {
        _classCallCheck(this, nT);
        return _possibleConstructorReturn(this, _getPrototypeOf(nT).apply(this, arguments));
      }
      _createClass(nT, [{
        key: "init",
        value: function init() {
          var _this256 = this;
          var t = this.editor;
          t.model.schema.register("listItem", {
            inheritAllFrom: "$block",
            allowAttributes: ["listType", "listIndent"]
          });
          var e = t.data;
          var n = t.editing;
          t.model.document.registerPostFixer(function (e) {
            return QS(t.model, e);
          });
          n.mapper.registerViewToModelLength("li", oT);
          e.mapper.registerViewToModelLength("li", oT);
          n.mapper.on("modelToViewPosition", qS(n.view));
          n.mapper.on("viewToModelPosition", YS(t.model));
          e.mapper.on("modelToViewPosition", qS(n.view));
          t.conversion.for("editingDowncast").add(function (e) {
            e.on("insert", US, {
              priority: "high"
            });
            e.on("insert:listItem", OS(t.model));
            e.on("attribute:listType:listItem", jS, {
              priority: "high"
            });
            e.on("attribute:listType:listItem", FS, {
              priority: "low"
            });
            e.on("attribute:listIndent:listItem", VS(t.model));
            e.on("remove:listItem", RS(t.model));
            e.on("remove", HS, {
              priority: "low"
            });
          });
          t.conversion.for("dataDowncast").add(function (e) {
            e.on("insert", US, {
              priority: "high"
            });
            e.on("insert:listItem", OS(t.model));
          });
          t.conversion.for("upcast").add(function (t) {
            t.on("element:ul", WS, {
              priority: "high"
            });
            t.on("element:ol", WS, {
              priority: "high"
            });
            t.on("element:li", KS, {
              priority: "high"
            });
            t.on("element:li", GS);
          });
          t.model.on("insertContent", $S, {
            priority: "high"
          });
          t.commands.add("numberedList", new vS(t, "numbered"));
          t.commands.add("bulletedList", new vS(t, "bulleted"));
          t.commands.add("indentList", new DS(t, "forward"));
          t.commands.add("outdentList", new DS(t, "backward"));
          var o = n.view.document;
          this.listenTo(o, "enter", function (t, e) {
            var n = _this256.editor.model.document;
            var o = n.selection.getLastPosition().parent;
            if (n.selection.isCollapsed && o.name == "listItem" && o.isEmpty) {
              _this256.editor.execute("outdentList");
              e.preventDefault();
              t.stop();
            }
          });
          this.listenTo(o, "delete", function (t, e) {
            if (e.direction !== "backward") {
              return;
            }
            var n = _this256.editor.model.document.selection;
            if (!n.isCollapsed) {
              return;
            }
            var o = n.getFirstPosition();
            if (!o.isAtStart) {
              return;
            }
            var i = o.parent;
            if (i.name !== "listItem") {
              return;
            }
            var r = i.previousSibling && i.previousSibling.name === "listItem";
            if (r) {
              return;
            }
            _this256.editor.execute("outdentList");
            e.preventDefault();
            t.stop();
          }, {
            priority: "high"
          });
          var i = function i(t) {
            return function (e, n) {
              var o = _this256.editor.commands.get(t);
              if (o.isEnabled) {
                _this256.editor.execute(t);
                n();
              }
            };
          };
          t.keystrokes.set("Tab", i("indentList"));
          t.keystrokes.set("Shift+Tab", i("outdentList"));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor.commands;
          var e = t.get("indent");
          var n = t.get("outdent");
          if (e) {
            e.registerChildCommand(t.get("indentList"));
          }
          if (n) {
            n.registerChildCommand(t.get("outdentList"));
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "ListEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [qy];
        }
      }]);
      return nT;
    }(aC);
    function oT(t) {
      var e = 1;
      var _iterator382 = _createForOfIteratorHelper(t.getChildren()),
        _step382;
      try {
        for (_iterator382.s(); !(_step382 = _iterator382.n()).done;) {
          var _n264 = _step382.value;
          if (_n264.name == "ul" || _n264.name == "ol") {
            var _iterator383 = _createForOfIteratorHelper(_n264.getChildren()),
              _step383;
            try {
              for (_iterator383.s(); !(_step383 = _iterator383.n()).done;) {
                var _t324 = _step383.value;
                e += oT(_t324);
              }
            } catch (err) {
              _iterator383.e(err);
            } finally {
              _iterator383.f();
            }
          }
        }
      } catch (err) {
        _iterator382.e(err);
      } finally {
        _iterator382.f();
      }
      return e;
    }
    var iT = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
    var rT = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
    var sT = /*#__PURE__*/function (_aC67) {
      _inherits(sT, _aC67);
      function sT() {
        _classCallCheck(this, sT);
        return _possibleConstructorReturn(this, _getPrototypeOf(sT).apply(this, arguments));
      }
      _createClass(sT, [{
        key: "init",
        value: function init() {
          var t = this.editor.t;
          PS(this.editor, "numberedList", t("Numbered List"), iT);
          PS(this.editor, "bulletedList", t("Bulleted List"), rT);
        }
      }]);
      return sT;
    }(aC);
    var aT = /*#__PURE__*/function (_aC68) {
      _inherits(aT, _aC68);
      function aT() {
        _classCallCheck(this, aT);
        return _possibleConstructorReturn(this, _getPrototypeOf(aT).apply(this, arguments));
      }
      _createClass(aT, null, [{
        key: "requires",
        get: function get() {
          return [nT, sT];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "List";
        }
      }]);
      return aT;
    }(aC);
    function cT(t, e) {
      return function (t) {
        t.on("attribute:url:media", n);
      };
      function n(n, o, i) {
        if (!i.consumable.consume(o.item, n.name)) {
          return;
        }
        var r = o.attributeNewValue;
        var s = i.writer;
        var a = i.mapper.toViewElement(o.item);
        var c = _toConsumableArray(a.getChildren()).find(function (t) {
          return t.getCustomProperty("media-content");
        });
        s.remove(c);
        var l = t.getMediaViewElement(s, r, e);
        s.insert(s.createPositionAt(a, 0), l);
      }
    }
    function lT(t, e, n) {
      e.setCustomProperty("media", true, t);
      return rA(t, e, {
        label: n
      });
    }
    function dT(t) {
      var e = t.getSelectedElement();
      if (e && uT(e)) {
        return e;
      }
      return null;
    }
    function uT(t) {
      return !!t.getCustomProperty("media") && iA(t);
    }
    function hT(t, e, n, o) {
      var i = t.createContainerElement("figure", {
        class: "media"
      });
      t.insert(t.createPositionAt(i, 0), e.getMediaViewElement(t, n, o));
      return i;
    }
    function fT(t) {
      var e = t.getSelectedElement();
      if (e && e.is("element", "media")) {
        return e;
      }
      return null;
    }
    function mT(t, e, n) {
      t.change(function (o) {
        var i = o.createElement("media", {
          url: e
        });
        t.insertContent(i, n);
        o.setSelection(i, "on");
      });
    }
    var gT = /*#__PURE__*/function (_uC23) {
      _inherits(gT, _uC23);
      function gT() {
        _classCallCheck(this, gT);
        return _possibleConstructorReturn(this, _getPrototypeOf(gT).apply(this, arguments));
      }
      _createClass(gT, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document.selection;
          var n = t.schema;
          var o = dA(e, t);
          var i = fT(e);
          var r = o.parent;
          if (r.isEmpty && !t.schema.isLimit(r)) {
            r = r.parent;
          }
          this.value = i ? i.getAttribute("url") : null;
          this.isEnabled = n.checkChild(r, "media");
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = this.editor.model;
          var n = e.document.selection;
          var o = fT(n);
          if (o) {
            e.change(function (e) {
              e.setAttribute("url", t, o);
            });
          } else {
            var _o182 = dA(n, e);
            mT(e, t, _o182);
          }
        }
      }]);
      return gT;
    }(uC);
    var pT = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>';
    var kT = "0 0 64 42";
    var bT = /*#__PURE__*/function () {
      function bT(t, e) {
        _classCallCheck(this, bT);
        var n = e.providers;
        var o = e.extraProviders || [];
        var i = new Set(e.removeProviders);
        var r = n.concat(o).filter(function (t) {
          var e = t.name;
          if (!e) {
            Object(ss["c"])("media-embed-no-provider-name", {
              provider: t
            });
            return false;
          }
          return !i.has(e);
        });
        this.locale = t;
        this.providerDefinitions = r;
      }
      _createClass(bT, [{
        key: "hasMedia",
        value: function hasMedia(t) {
          return !!this._getMedia(t);
        }
      }, {
        key: "getMediaViewElement",
        value: function getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n);
        }
      }, {
        key: "_getMedia",
        value: function _getMedia(t) {
          if (!t) {
            return new wT(this.locale);
          }
          t = t.trim();
          var _iterator384 = _createForOfIteratorHelper(this.providerDefinitions),
            _step384;
          try {
            for (_iterator384.s(); !(_step384 = _iterator384.n()).done;) {
              var _e291 = _step384.value;
              var _n265 = _e291.html;
              var _o183 = xs(_e291.url);
              var _iterator385 = _createForOfIteratorHelper(_o183),
                _step385;
              try {
                for (_iterator385.s(); !(_step385 = _iterator385.n()).done;) {
                  var _e292 = _step385.value;
                  var _o184 = this._getUrlMatches(t, _e292);
                  if (_o184) {
                    return new wT(this.locale, t, _o184, _n265);
                  }
                }
              } catch (err) {
                _iterator385.e(err);
              } finally {
                _iterator385.f();
              }
            }
          } catch (err) {
            _iterator384.e(err);
          } finally {
            _iterator384.f();
          }
          return null;
        }
      }, {
        key: "_getUrlMatches",
        value: function _getUrlMatches(t, e) {
          var n = t.match(e);
          if (n) {
            return n;
          }
          var o = t.replace(/^https?:\/\//, "");
          n = o.match(e);
          if (n) {
            return n;
          }
          o = o.replace(/^www\./, "");
          n = o.match(e);
          if (n) {
            return n;
          }
          return null;
        }
      }]);
      return bT;
    }();
    var wT = /*#__PURE__*/function () {
      function wT(t, e, n, o) {
        _classCallCheck(this, wT);
        this.url = this._getValidUrl(e);
        this._t = t.t;
        this._match = n;
        this._previewRenderer = o;
      }
      _createClass(wT, [{
        key: "getViewElement",
        value: function getViewElement(t, e) {
          var n = {};
          var o;
          if (e.renderForEditingView || e.renderMediaPreview && this.url && this._previewRenderer) {
            if (this.url) {
              n["data-oembed-url"] = this.url;
            }
            if (e.renderForEditingView) {
              n.class = "ck-media__wrapper";
            }
            var _i149 = this._getPreviewHtml(e);
            o = t.createRawElement("div", n, function (t) {
              t.innerHTML = _i149;
            });
          } else {
            if (this.url) {
              n.url = this.url;
            }
            o = t.createEmptyElement("oembed", n);
          }
          t.setCustomProperty("media-content", true, o);
          return o;
        }
      }, {
        key: "_getPreviewHtml",
        value: function _getPreviewHtml(t) {
          if (this._previewRenderer) {
            return this._previewRenderer(this._match);
          } else {
            if (this.url && t.renderForEditingView) {
              return this._getPlaceholderHtml();
            }
            return "";
          }
        }
      }, {
        key: "_getPlaceholderHtml",
        value: function _getPlaceholderHtml() {
          var t = new ow();
          var e = new Jb();
          t.text = this._t("Open media in new tab");
          e.content = pT;
          e.viewBox = kT;
          var n = new yk({
            tag: "div",
            attributes: {
              class: "ck ck-reset_all ck-media__placeholder"
            },
            children: [{
              tag: "div",
              attributes: {
                class: "ck-media__placeholder__icon"
              },
              children: [e]
            }, {
              tag: "a",
              attributes: {
                class: "ck-media__placeholder__url",
                target: "_blank",
                rel: "noopener noreferrer",
                href: this.url
              },
              children: [{
                tag: "span",
                attributes: {
                  class: "ck-media__placeholder__url__text"
                },
                children: [this.url]
              }, t]
            }]
          }).render();
          return n.outerHTML;
        }
      }, {
        key: "_getValidUrl",
        value: function _getValidUrl(t) {
          if (!t) {
            return null;
          }
          if (t.match(/^https?/)) {
            return t;
          }
          return "https://" + t;
        }
      }]);
      return wT;
    }();
    var CT = n(49);
    var AT = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    AT.insert = "head";
    AT.singleton = true;
    var _T = rk()(CT["a"], AT);
    var vT = CT["a"].locals || {};
    var yT = /*#__PURE__*/function (_aC69) {
      _inherits(yT, _aC69);
      _createClass(yT, null, [{
        key: "pluginName",
        get: function get() {
          return "MediaEmbedEditing";
        }
      }]);
      function yT(t) {
        var _this257;
        _classCallCheck(this, yT);
        _this257 = _possibleConstructorReturn(this, _getPrototypeOf(yT).call(this, t));
        t.config.define("mediaEmbed", {
          providers: [{
            name: "dailymotion",
            url: /^dailymotion\.com\/video\/(\w+)/,
            html: function html(t) {
              var e = t[1];
              return '<div style="position: relative; padding-bottom: 100%; height: 0; ">' + "<iframe src=\"https://www.dailymotion.com/embed/video/".concat(e, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" width="480" height="270" allowfullscreen allow="autoplay">' + "</iframe>" + "</div>";
            }
          }, {
            name: "spotify",
            url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
            html: function html(t) {
              var e = t[1];
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' + "<iframe src=\"https://open.spotify.com/embed/".concat(e, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" allowtransparency="true" allow="encrypted-media">' + "</iframe>" + "</div>";
            }
          }, {
            name: "youtube",
            url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
            html: function html(t) {
              var e = t[1];
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://www.youtube.com/embed/".concat(e, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' + "</iframe>" + "</div>";
            }
          }, {
            name: "vimeo",
            url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
            html: function html(t) {
              var e = t[1];
              return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://player.vimeo.com/video/".concat(e, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>' + "</iframe>" + "</div>";
            }
          }, {
            name: "instagram",
            url: /^instagram\.com\/p\/(\w+)/
          }, {
            name: "twitter",
            url: /^twitter\.com/
          }, {
            name: "googleMaps",
            url: /^google\.com\/maps/
          }, {
            name: "flickr",
            url: /^flickr\.com/
          }, {
            name: "facebook",
            url: /^facebook\.com/
          }]
        });
        _this257.registry = new bT(t.locale, t.config.get("mediaEmbed"));
        return _this257;
      }
      _createClass(yT, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model.schema;
          var n = t.t;
          var o = t.conversion;
          var i = t.config.get("mediaEmbed.previewsInData");
          var r = this.registry;
          t.commands.add("mediaEmbed", new gT(t));
          e.register("media", {
            isObject: true,
            isBlock: true,
            allowWhere: "$block",
            allowAttributes: ["url"]
          });
          o.for("dataDowncast").elementToElement({
            model: "media",
            view: function view(t, _ref48) {
              var e = _ref48.writer;
              var n = t.getAttribute("url");
              return hT(e, r, n, {
                renderMediaPreview: n && i
              });
            }
          });
          o.for("dataDowncast").add(cT(r, {
            renderMediaPreview: i
          }));
          o.for("editingDowncast").elementToElement({
            model: "media",
            view: function view(t, _ref49) {
              var e = _ref49.writer;
              var o = t.getAttribute("url");
              var i = hT(e, r, o, {
                renderForEditingView: true
              });
              return lT(i, e, n("media widget"));
            }
          });
          o.for("editingDowncast").add(cT(r, {
            renderForEditingView: true
          }));
          o.for("upcast").elementToElement({
            view: {
              name: "oembed",
              attributes: {
                url: true
              }
            },
            model: function model(t, _ref50) {
              var e = _ref50.writer;
              var n = t.getAttribute("url");
              if (r.hasMedia(n)) {
                return e.createElement("media", {
                  url: n
                });
              }
            }
          }).elementToElement({
            view: {
              name: "div",
              attributes: {
                "data-oembed-url": true
              }
            },
            model: function model(t, _ref51) {
              var e = _ref51.writer;
              var n = t.getAttribute("data-oembed-url");
              if (r.hasMedia(n)) {
                return e.createElement("media", {
                  url: n
                });
              }
            }
          });
        }
      }]);
      return yT;
    }(aC);
    var xT = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=%]+$/;
    var DT = /*#__PURE__*/function (_aC70) {
      _inherits(DT, _aC70);
      _createClass(DT, null, [{
        key: "requires",
        get: function get() {
          return [h_, Uy];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "AutoMediaEmbed";
        }
      }]);
      function DT(t) {
        var _this258;
        _classCallCheck(this, DT);
        _this258 = _possibleConstructorReturn(this, _getPrototypeOf(DT).call(this, t));
        _this258._timeoutId = null;
        _this258._positionToInsert = null;
        return _this258;
      }
      _createClass(DT, [{
        key: "init",
        value: function init() {
          var _this259 = this;
          var t = this.editor;
          var e = t.model.document;
          this.listenTo(t.plugins.get(h_), "inputTransformation", function () {
            var t = e.selection.getFirstRange();
            var n = ep.fromPosition(t.start);
            n.stickiness = "toPrevious";
            var o = ep.fromPosition(t.end);
            o.stickiness = "toNext";
            e.once("change:data", function () {
              _this259._embedMediaBetweenPositions(n, o);
              n.detach();
              o.detach();
            }, {
              priority: "high"
            });
          });
          t.commands.get("undo").on("execute", function () {
            if (_this259._timeoutId) {
              jd.window.clearTimeout(_this259._timeoutId);
              _this259._positionToInsert.detach();
              _this259._timeoutId = null;
              _this259._positionToInsert = null;
            }
          }, {
            priority: "high"
          });
        }
      }, {
        key: "_embedMediaBetweenPositions",
        value: function _embedMediaBetweenPositions(t, e) {
          var _this260 = this;
          var n = this.editor;
          var o = n.plugins.get(yT).registry;
          var i = new kf(t, e);
          var r = i.getWalker({
            ignoreElementEnd: true
          });
          var s = "";
          var _iterator386 = _createForOfIteratorHelper(r),
            _step386;
          try {
            for (_iterator386.s(); !(_step386 = _iterator386.n()).done;) {
              var _t325 = _step386.value;
              if (_t325.item.is("$textProxy")) {
                s += _t325.item.data;
              }
            }
          } catch (err) {
            _iterator386.e(err);
          } finally {
            _iterator386.f();
          }
          s = s.trim();
          if (!s.match(xT)) {
            i.detach();
            return;
          }
          if (!o.hasMedia(s)) {
            i.detach();
            return;
          }
          var a = n.commands.get("mediaEmbed");
          if (!a.isEnabled) {
            i.detach();
            return;
          }
          this._positionToInsert = ep.fromPosition(t);
          this._timeoutId = jd.window.setTimeout(function () {
            n.model.change(function (t) {
              _this260._timeoutId = null;
              t.remove(i);
              i.detach();
              var e;
              if (_this260._positionToInsert.root.rootName !== "$graveyard") {
                e = _this260._positionToInsert;
              }
              mT(n.model, s, e);
              _this260._positionToInsert.detach();
              _this260._positionToInsert = null;
            });
          }, 100);
        }
      }]);
      return DT;
    }(aC);
    var ET = n(50);
    var MT = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    MT.insert = "head";
    MT.singleton = true;
    var ST = rk()(ET["a"], MT);
    var TT = ET["a"].locals || {};
    var IT = /*#__PURE__*/function (_tb28) {
      _inherits(IT, _tb28);
      function IT(t, e) {
        var _this261;
        _classCallCheck(this, IT);
        _this261 = _possibleConstructorReturn(this, _getPrototypeOf(IT).call(this, e));
        var n = e.t;
        _this261.focusTracker = new tk();
        _this261.keystrokes = new Vp();
        _this261.set("mediaURLInputValue", "");
        _this261.urlInputView = _this261._createUrlInput();
        _this261.saveButtonView = _this261._createButton(n("Save"), Qx, "ck-button-save");
        _this261.saveButtonView.type = "submit";
        _this261.saveButtonView.bind("isEnabled").to(_assertThisInitialized(_assertThisInitialized(_this261)), "mediaURLInputValue", function (t) {
          return !!t;
        });
        _this261.cancelButtonView = _this261._createButton(n("Cancel"), $x, "ck-button-cancel", "cancel");
        _this261._focusables = new Ak();
        _this261._focusCycler = new Db({
          focusables: _this261._focusables,
          focusTracker: _this261.focusTracker,
          keystrokeHandler: _this261.keystrokes,
          actions: {
            focusPrevious: "shift + tab",
            focusNext: "tab"
          }
        });
        _this261._validators = t;
        _this261.setTemplate({
          tag: "form",
          attributes: {
            class: ["ck", "ck-media-form", "ck-responsive-form"],
            tabindex: "-1"
          },
          children: [_this261.urlInputView, _this261.saveButtonView, _this261.cancelButtonView]
        });
        qx(_assertThisInitialized(_assertThisInitialized(_this261)));
        return _this261;
      }
      _createClass(IT, [{
        key: "render",
        value: function render() {
          var _this262 = this;
          _get(_getPrototypeOf(IT.prototype), "render", this).call(this);
          Yx({
            view: this
          });
          var t = [this.urlInputView, this.saveButtonView, this.cancelButtonView];
          t.forEach(function (t) {
            _this262._focusables.add(t);
            _this262.focusTracker.add(t.element);
          });
          this.keystrokes.listenTo(this.element);
          var e = function e(t) {
            return t.stopPropagation();
          };
          this.keystrokes.set("arrowright", e);
          this.keystrokes.set("arrowleft", e);
          this.keystrokes.set("arrowup", e);
          this.keystrokes.set("arrowdown", e);
          this.listenTo(this.urlInputView.element, "selectstart", function (t, e) {
            e.stopPropagation();
          }, {
            priority: "high"
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this._focusCycler.focusFirst();
        }
      }, {
        key: "isValid",
        value: function isValid() {
          this.resetFormStatus();
          var _iterator387 = _createForOfIteratorHelper(this._validators),
            _step387;
          try {
            for (_iterator387.s(); !(_step387 = _iterator387.n()).done;) {
              var _t326 = _step387.value;
              var _e293 = _t326(this);
              if (_e293) {
                this.urlInputView.errorText = _e293;
                return false;
              }
            }
          } catch (err) {
            _iterator387.e(err);
          } finally {
            _iterator387.f();
          }
          return true;
        }
      }, {
        key: "resetFormStatus",
        value: function resetFormStatus() {
          this.urlInputView.errorText = null;
          this.urlInputView.infoText = this._urlInputViewInfoDefault;
        }
      }, {
        key: "_createUrlInput",
        value: function _createUrlInput() {
          var _this263 = this;
          var t = this.locale.t;
          var e = new Rx(this.locale, Wx);
          var n = e.fieldView;
          this._urlInputViewInfoDefault = t("Paste the media URL in the input.");
          this._urlInputViewInfoTip = t("Tip: Paste the URL into the content to embed faster.");
          e.label = t("Media URL");
          e.infoText = this._urlInputViewInfoDefault;
          n.on("input", function () {
            e.infoText = n.element.value ? _this263._urlInputViewInfoTip : _this263._urlInputViewInfoDefault;
            _this263.mediaURLInputValue = n.element.value.trim();
          });
          return e;
        }
      }, {
        key: "_createButton",
        value: function _createButton(t, e, n, o) {
          var i = new cw(this.locale);
          i.set({
            label: t,
            icon: e,
            tooltip: true
          });
          i.extendTemplate({
            attributes: {
              class: n
            }
          });
          if (o) {
            i.delegate("execute").to(this, o);
          }
          return i;
        }
      }, {
        key: "url",
        get: function get() {
          return this.urlInputView.fieldView.element.value.trim();
        },
        set: function set(t) {
          this.urlInputView.fieldView.element.value = t.trim();
        }
      }]);
      return IT;
    }(tb);
    var NT = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>';
    var PT = /*#__PURE__*/function (_aC71) {
      _inherits(PT, _aC71);
      function PT() {
        _classCallCheck(this, PT);
        return _possibleConstructorReturn(this, _getPrototypeOf(PT).apply(this, arguments));
      }
      _createClass(PT, [{
        key: "init",
        value: function init() {
          var _this264 = this;
          var t = this.editor;
          var e = t.commands.get("mediaEmbed");
          var n = t.plugins.get(yT).registry;
          t.ui.componentFactory.add("mediaEmbed", function (o) {
            var i = Nw(o);
            var r = new IT(BT(t.t, n), t.locale);
            _this264._setUpDropdown(i, r, e, t);
            _this264._setUpForm(i, r, e);
            return i;
          });
        }
      }, {
        key: "_setUpDropdown",
        value: function _setUpDropdown(t, e, n) {
          var o = this.editor;
          var i = o.t;
          var r = t.buttonView;
          t.bind("isEnabled").to(n);
          t.panelView.children.add(e);
          r.set({
            label: i("Insert media"),
            icon: NT,
            tooltip: true
          });
          r.on("open", function () {
            e.disableCssTransitions();
            e.url = n.value || "";
            e.urlInputView.fieldView.select();
            e.focus();
            e.enableCssTransitions();
          }, {
            priority: "low"
          });
          t.on("submit", function () {
            if (e.isValid()) {
              o.execute("mediaEmbed", e.url);
              s();
            }
          });
          t.on("change:isOpen", function () {
            return e.resetFormStatus();
          });
          t.on("cancel", function () {
            return s();
          });
          function s() {
            o.editing.view.focus();
            t.isOpen = false;
          }
        }
      }, {
        key: "_setUpForm",
        value: function _setUpForm(t, e, n) {
          e.delegate("submit", "cancel").to(t);
          e.urlInputView.bind("value").to(n, "value");
          e.urlInputView.bind("isReadOnly").to(n, "isEnabled", function (t) {
            return !t;
          });
        }
      }], [{
        key: "requires",
        get: function get() {
          return [yT];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbedUI";
        }
      }]);
      return PT;
    }(aC);
    function BT(t, e) {
      return [function (e) {
        if (!e.url.length) {
          return t("The URL must not be empty.");
        }
      }, function (n) {
        if (!e.hasMedia(n.url)) {
          return t("This media URL is not supported.");
        }
      }];
    }
    var zT = n(51);
    var LT = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    LT.insert = "head";
    LT.singleton = true;
    var OT = rk()(zT["a"], LT);
    var RT = zT["a"].locals || {};
    var jT = /*#__PURE__*/function (_aC72) {
      _inherits(jT, _aC72);
      function jT() {
        _classCallCheck(this, jT);
        return _possibleConstructorReturn(this, _getPrototypeOf(jT).apply(this, arguments));
      }
      _createClass(jT, null, [{
        key: "requires",
        get: function get() {
          return [yT, PT, DT, Sx];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "MediaEmbed";
        }
      }]);
      return jT;
    }(aC);
    function FT(t, e) {
      var _iterator388 = _createForOfIteratorHelper(t.getChildren()),
        _step388;
      try {
        for (_iterator388.s(); !(_step388 = _iterator388.n()).done;) {
          var _n266 = _step388.value;
          if (_n266.is("element", "b") && _n266.getStyle("font-weight") === "normal") {
            var _o185 = t.getChildIndex(_n266);
            e.remove(_n266);
            e.insertChild(_o185, _n266.getChildren(), t);
          }
        }
      } catch (err) {
        _iterator388.e(err);
      } finally {
        _iterator388.f();
      }
    }
    function VT(t, e) {
      if (!t.childCount) {
        return;
      }
      var n = new TM(t.document);
      var o = HT(t, n);
      if (!o.length) {
        return;
      }
      var i = null;
      var r = 1;
      o.forEach(function (t, s) {
        var a = JT(o[s - 1], t);
        var c = a ? null : o[s - 1];
        var l = tI(c, t);
        if (a) {
          i = null;
          r = 1;
        }
        if (!i || l !== 0) {
          var _o186 = GT(t, e);
          if (!i) {
            i = YT(_o186, t.element, n);
          } else if (t.indent > r) {
            var _t327 = i.getChild(i.childCount - 1);
            var _e294 = _t327.getChild(_t327.childCount - 1);
            i = YT(_o186, _e294, n);
            r += 1;
          } else if (t.indent < r) {
            var _e295 = r - t.indent;
            i = eI(i, _e295);
            r = parseInt(t.indent);
          }
          if (t.indent <= r) {
            if (!i.is("element", _o186.type)) {
              i = n.rename(_o186.type, i);
            }
          }
        }
        var d = QT(t.element, n);
        n.appendChild(d, i);
      });
    }
    function UT(t, e) {
      var _iterator389 = _createForOfIteratorHelper(e.createRangeIn(t)),
        _step389;
      try {
        for (_iterator389.s(); !(_step389 = _iterator389.n()).done;) {
          var _n267 = _step389.value;
          var _t328 = _n267.item;
          if (_t328.is("element", "li")) {
            var _n268 = _t328.getChild(0);
            if (_n268 && _n268.is("element", "p")) {
              e.unwrapElement(_n268);
            }
          }
        }
      } catch (err) {
        _iterator389.e(err);
      } finally {
        _iterator389.f();
      }
    }
    function HT(t, e) {
      var n = e.createRangeIn(t);
      var o = new Ws({
        name: /^p|h\d+$/,
        styles: {
          "mso-list": /.*/
        }
      });
      var i = [];
      var _iterator390 = _createForOfIteratorHelper(n),
        _step390;
      try {
        for (_iterator390.s(); !(_step390 = _iterator390.n()).done;) {
          var _t329 = _step390.value;
          if (_t329.type === "elementStart" && o.match(_t329.item)) {
            var _e296 = $T(_t329.item);
            i.push({
              element: _t329.item,
              id: _e296.id,
              order: _e296.order,
              indent: _e296.indent
            });
          }
        }
      } catch (err) {
        _iterator390.e(err);
      } finally {
        _iterator390.f();
      }
      return i;
    }
    function GT(t, e) {
      var n = new RegExp("@list l".concat(t.id, ":level").concat(t.indent, "\\s*({[^}]*)"), "gi");
      var o = /mso-level-number-format:([^;]*);/gi;
      var i = n.exec(e);
      var r = "decimal";
      var s = "ol";
      if (i && i[1]) {
        var _e297 = o.exec(i[1]);
        if (_e297 && _e297[1]) {
          r = _e297[1].trim();
          s = r !== "bullet" && r !== "image" ? "ol" : "ul";
        }
        if (r === "bullet") {
          var _e298 = WT(t.element);
          if (_e298) {
            r = _e298;
          }
        }
      }
      return {
        type: s,
        style: qT(r)
      };
    }
    function WT(t) {
      var e = KT(t);
      if (!e) {
        return null;
      }
      var n = e._data;
      if (n === "o") {
        return "circle";
      } else if (n === "·") {
        return "disc";
      } else if (n === "§") {
        return "square";
      }
      return null;
    }
    function KT(t) {
      if (t.getChild(0).is("$text")) {
        return null;
      }
      var e = t.getChild(0).getChild(0);
      if (e.is("$text")) {
        return e;
      }
      return e.getChild(0);
    }
    function qT(t) {
      switch (t) {
        case "arabic-leading-zero":
          return "decimal-leading-zero";
        case "alpha-upper":
          return "upper-alpha";
        case "alpha-lower":
          return "lower-alpha";
        case "roman-upper":
          return "upper-roman";
        case "roman-lower":
          return "lower-roman";
        case "circle":
        case "disc":
        case "square":
          return t;
        default:
          return null;
      }
    }
    function YT(t, e, n) {
      var o = e.parent;
      var i = n.createElement(t.type);
      var r = o.getChildIndex(e) + 1;
      n.insertChild(r, i, o);
      if (t.style) {
        n.setStyle("list-style-type", t.style, i);
      }
      return i;
    }
    function QT(t, e) {
      ZT(t, e);
      return e.rename("li", t);
    }
    function $T(t) {
      var e = {};
      var n = t.getStyle("mso-list");
      if (n) {
        var _t330 = n.match(/(^|\s+)l(\d+)/i);
        var _o187 = n.match(/\s*lfo(\d+)/i);
        var _i150 = n.match(/\s*level(\d+)/i);
        if (_t330 && _o187 && _i150) {
          e.id = _t330[2];
          e.order = _o187[1];
          e.indent = _i150[1];
        }
      }
      return e;
    }
    function ZT(t, e) {
      var n = new Ws({
        name: "span",
        styles: {
          "mso-list": "Ignore"
        }
      });
      var o = e.createRangeIn(t);
      var _iterator391 = _createForOfIteratorHelper(o),
        _step391;
      try {
        for (_iterator391.s(); !(_step391 = _iterator391.n()).done;) {
          var _t331 = _step391.value;
          if (_t331.type === "elementStart" && n.match(_t331.item)) {
            e.remove(_t331.item);
          }
        }
      } catch (err) {
        _iterator391.e(err);
      } finally {
        _iterator391.f();
      }
    }
    function JT(t, e) {
      if (!t) {
        return true;
      }
      if (t.id !== e.id) {
        if (e.indent - t.indent === 1) {
          return false;
        }
        return true;
      }
      var n = e.element.previousSibling;
      if (!n) {
        return true;
      }
      return !XT(n);
    }
    function XT(t) {
      return t.is("element", "ol") || t.is("element", "ul");
    }
    function tI(t, e) {
      return t ? e.indent - t.indent : e.indent - 1;
    }
    function eI(t, e) {
      var n = t.getAncestors({
        parentFirst: true
      });
      var o = null;
      var i = 0;
      var _iterator392 = _createForOfIteratorHelper(n),
        _step392;
      try {
        for (_iterator392.s(); !(_step392 = _iterator392.n()).done;) {
          var _t332 = _step392.value;
          if (_t332.name === "ul" || _t332.name === "ol") {
            i++;
          }
          if (i === e) {
            o = _t332;
            break;
          }
        }
      } catch (err) {
        _iterator392.e(err);
      } finally {
        _iterator392.f();
      }
      return o;
    }
    var nI = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
    var oI = /*#__PURE__*/function () {
      function oI(t) {
        _classCallCheck(this, oI);
        this.document = t;
      }
      _createClass(oI, [{
        key: "isActive",
        value: function isActive(t) {
          return nI.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var e = new TM(this.document);
          FT(t.content, e);
          UT(t.content, e);
        }
      }]);
      return oI;
    }();
    function iI(t) {
      return sI(sI(t)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[\s]*?)[\r\n]+(\s*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/ <\//g, " </").replace(/ <o:p><\/o:p>/g, " <o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>(\s*[\r\n]\s*)</g, "><");
    }
    function rI(t) {
      t.querySelectorAll("span[style*=spacerun]").forEach(function (t) {
        var e = t.innerText.length || 0;
        t.innerHTML = Array(e + 1).join("  ").substr(0, e);
      });
    }
    function sI(t) {
      return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, function (t, e) {
        return e.length === 1 ? " " : Array(e.length + 1).join("  ").substr(0, e.length);
      });
    }
    function aI(t, e) {
      var n = new DOMParser();
      t = t.replace(/<!--\[if gte vml 1]>/g, "");
      var o = iI(dI(t));
      var i = n.parseFromString(o, "text/html");
      rI(i);
      var r = i.body.innerHTML;
      var s = cI(i, e);
      var a = lI(i);
      return {
        body: s,
        bodyString: r,
        styles: a.styles,
        stylesString: a.stylesString
      };
    }
    function cI(t, e) {
      var n = new bl(e);
      var o = new Gd(n, {
        blockFillerMode: "nbsp"
      });
      var i = t.createDocumentFragment();
      var r = t.body.childNodes;
      while (r.length > 0) {
        i.appendChild(r[0]);
      }
      return o.domToView(i);
    }
    function lI(t) {
      var e = [];
      var n = [];
      var o = Array.from(t.getElementsByTagName("style"));
      for (var _i151 = 0, _o188 = o; _i151 < _o188.length; _i151++) {
        var _t333 = _o188[_i151];
        if (_t333.sheet && _t333.sheet.cssRules && _t333.sheet.cssRules.length) {
          e.push(_t333.sheet);
          n.push(_t333.innerHTML);
        }
      }
      return {
        styles: e,
        stylesString: n.join(" ")
      };
    }
    function dI(t) {
      var e = /<\/body>(.*?)(<\/html>|$)/;
      var n = t.match(e);
      if (n && n[1]) {
        t = t.slice(0, n.index) + t.slice(n.index).replace(n[1], "");
      }
      return t;
    }
    function uI(t, e) {
      if (!t.childCount) {
        return;
      }
      var n = new TM();
      var o = fI(t, n);
      mI(o, t, n);
      gI(t, n);
      var i = pI(t, n);
      if (i.length) {
        bI(i, kI(e), n);
      }
    }
    function hI(t) {
      return btoa(t.match(/\w{2}/g).map(function (t) {
        return String.fromCharCode(parseInt(t, 16));
      }).join(""));
    }
    function fI(t, e) {
      var n = e.createRangeIn(t);
      var o = new Ws({
        name: /v:(.+)/
      });
      var i = [];
      var _iterator393 = _createForOfIteratorHelper(n),
        _step393;
      try {
        for (_iterator393.s(); !(_step393 = _iterator393.n()).done;) {
          var _t334 = _step393.value;
          var _e299 = _t334.item;
          var _n269 = _e299.previousSibling && _e299.previousSibling.name || null;
          if (o.match(_e299) && _e299.getAttribute("o:gfxdata") && _n269 !== "v:shapetype") {
            i.push(_t334.item.getAttribute("id"));
          }
        }
      } catch (err) {
        _iterator393.e(err);
      } finally {
        _iterator393.f();
      }
      return i;
    }
    function mI(t, e, n) {
      var o = n.createRangeIn(e);
      var i = new Ws({
        name: "img"
      });
      var r = [];
      var _iterator394 = _createForOfIteratorHelper(o),
        _step394;
      try {
        for (_iterator394.s(); !(_step394 = _iterator394.n()).done;) {
          var _e300 = _step394.value;
          if (i.match(_e300.item)) {
            var _n270 = _e300.item;
            var _o189 = _n270.getAttribute("v:shapes") ? _n270.getAttribute("v:shapes").split(" ") : [];
            if (_o189.length && _o189.every(function (e) {
              return t.indexOf(e) > -1;
            })) {
              r.push(_n270);
            } else if (!_n270.getAttribute("src")) {
              r.push(_n270);
            }
          }
        }
      } catch (err) {
        _iterator394.e(err);
      } finally {
        _iterator394.f();
      }
      for (var _i152 = 0, _r59 = r; _i152 < _r59.length; _i152++) {
        var _t335 = _r59[_i152];
        n.remove(_t335);
      }
    }
    function gI(t, e) {
      var n = e.createRangeIn(t);
      var o = new Ws({
        name: /v:(.+)/
      });
      var i = [];
      var _iterator395 = _createForOfIteratorHelper(n),
        _step395;
      try {
        for (_iterator395.s(); !(_step395 = _iterator395.n()).done;) {
          var _t337 = _step395.value;
          if (o.match(_t337.item)) {
            i.push(_t337.item);
          }
        }
      } catch (err) {
        _iterator395.e(err);
      } finally {
        _iterator395.f();
      }
      for (var _i154 = 0, _i153 = i; _i154 < _i153.length; _i154++) {
        var _t336 = _i153[_i154];
        e.remove(_t336);
      }
    }
    function pI(t, e) {
      var n = e.createRangeIn(t);
      var o = new Ws({
        name: "img"
      });
      var i = [];
      var _iterator396 = _createForOfIteratorHelper(n),
        _step396;
      try {
        for (_iterator396.s(); !(_step396 = _iterator396.n()).done;) {
          var _t338 = _step396.value;
          if (o.match(_t338.item)) {
            if (_t338.item.getAttribute("src").startsWith("file://")) {
              i.push(_t338.item);
            }
          }
        }
      } catch (err) {
        _iterator396.e(err);
      } finally {
        _iterator396.f();
      }
      return i;
    }
    function kI(t) {
      if (!t) {
        return [];
      }
      var e = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/;
      var n = new RegExp("(?:(" + e.source + "))([\\da-fA-F\\s]+)\\}", "g");
      var o = t.match(n);
      var i = [];
      if (o) {
        var _iterator397 = _createForOfIteratorHelper(o),
          _step397;
        try {
          for (_iterator397.s(); !(_step397 = _iterator397.n()).done;) {
            var _t339 = _step397.value;
            var _n271 = false;
            if (_t339.includes("\\pngblip")) {
              _n271 = "image/png";
            } else if (_t339.includes("\\jpegblip")) {
              _n271 = "image/jpeg";
            }
            if (_n271) {
              i.push({
                hex: _t339.replace(e, "").replace(/[^\da-fA-F]/g, ""),
                type: _n271
              });
            }
          }
        } catch (err) {
          _iterator397.e(err);
        } finally {
          _iterator397.f();
        }
      }
      return i;
    }
    function bI(t, e, n) {
      if (t.length === e.length) {
        for (var _o190 = 0; _o190 < t.length; _o190++) {
          var _i155 = "data:".concat(e[_o190].type, ";base64,").concat(hI(e[_o190].hex));
          n.setAttribute("src", _i155, t[_o190]);
        }
      }
    }
    var wI = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i;
    var CI = /xmlns:o="urn:schemas-microsoft-com/i;
    var AI = /*#__PURE__*/function () {
      function AI(t) {
        _classCallCheck(this, AI);
        this.document = t;
      }
      _createClass(AI, [{
        key: "isActive",
        value: function isActive(t) {
          return wI.test(t) || CI.test(t);
        }
      }, {
        key: "execute",
        value: function execute(t) {
          var _aI = aI(t.dataTransfer.getData("text/html"), this.document.stylesProcessor),
            e = _aI.body,
            n = _aI.stylesString;
          VT(e, n);
          uI(e, t.dataTransfer.getData("text/rtf"));
          t.content = e;
        }
      }]);
      return AI;
    }();
    var _I = /*#__PURE__*/function (_aC73) {
      _inherits(_I, _aC73);
      function _I() {
        _classCallCheck(this, _I);
        return _possibleConstructorReturn(this, _getPrototypeOf(_I).apply(this, arguments));
      }
      _createClass(_I, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.editing.view.document;
          var n = [];
          n.push(new AI(e));
          n.push(new oI(e));
          t.plugins.get("Clipboard").on("inputTransformation", function (t, e) {
            if (e.isTransformedWithPasteFromOffice) {
              return;
            }
            var o = e.dataTransfer.getData("text/html");
            var i = n.find(function (t) {
              return t.isActive(o);
            });
            if (i) {
              i.execute(e);
              e.isTransformedWithPasteFromOffice = true;
            }
          }, {
            priority: "high"
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "PasteFromOffice";
        }
      }, {
        key: "requires",
        get: function get() {
          return [h_];
        }
      }]);
      return _I;
    }(aC);
    function vI(t, e, n, o) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
      if (e > i) {
        o.setAttribute(t, e, n);
      } else {
        o.removeAttribute(t, n);
      }
    }
    function yI(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o = t.createElement("tableCell", n);
      t.insertElement("paragraph", o);
      t.insert(o, e);
      return o;
    }
    function xI(t, e) {
      var n = e.parent.parent;
      var o = parseInt(n.getAttribute("headingColumns") || 0);
      var _t$getCellLocation = t.getCellLocation(e),
        i = _t$getCellLocation.column;
      return !!o && i < o;
    }
    function DI() {
      return function (t) {
        t.on("element:table", function (t, e, n) {
          var o = e.viewItem;
          if (!n.consumable.test(o, {
            name: true
          })) {
            return;
          }
          var _MI = MI(o),
            i = _MI.rows,
            r = _MI.headingRows,
            s = _MI.headingColumns;
          var a = {};
          if (s) {
            a.headingColumns = s;
          }
          if (r) {
            a.headingRows = r;
          }
          var c = n.writer.createElement("table", a);
          if (!n.safeInsert(c, e.modelCursor)) {
            return;
          }
          n.consumable.consume(o, {
            name: true
          });
          i.forEach(function (t) {
            return n.convertItem(t, n.writer.createPositionAt(c, "end"));
          });
          if (c.isEmpty) {
            var _t340 = n.writer.createElement("tableRow");
            n.writer.insert(_t340, n.writer.createPositionAt(c, "end"));
            yI(n.writer, n.writer.createPositionAt(_t340, "end"));
          }
          n.updateConversionResult(c, e);
        });
      };
    }
    function EI() {
      return function (t) {
        t.on("element:tr", function (t, e) {
          if (e.viewItem.isEmpty && e.modelCursor.index == 0) {
            t.stop();
          }
        }, {
          priority: "high"
        });
      };
    }
    function MI(t) {
      var e = {
        headingRows: 0,
        headingColumns: 0
      };
      var n = [];
      var o = [];
      var i;
      for (var _i156 = 0, _Array$from6 = Array.from(t.getChildren()); _i156 < _Array$from6.length; _i156++) {
        var _r60 = _Array$from6[_i156];
        if (_r60.name === "tbody" || _r60.name === "thead" || _r60.name === "tfoot") {
          if (_r60.name === "thead" && !i) {
            i = _r60;
          }
          var _t341 = Array.from(_r60.getChildren()).filter(function (t) {
            return t.is("element", "tr");
          });
          var _iterator398 = _createForOfIteratorHelper(_t341),
            _step398;
          try {
            for (_iterator398.s(); !(_step398 = _iterator398.n()).done;) {
              var _r61 = _step398.value;
              if (_r61.parent.name === "thead" && _r61.parent === i) {
                e.headingRows++;
                n.push(_r61);
              } else {
                o.push(_r61);
                var _t342 = SI(_r61, e, i);
                if (_t342 > e.headingColumns) {
                  e.headingColumns = _t342;
                }
              }
            }
          } catch (err) {
            _iterator398.e(err);
          } finally {
            _iterator398.f();
          }
        }
      }
      e.rows = [].concat(n, o);
      return e;
    }
    function SI(t) {
      var e = 0;
      var n = 0;
      var o = Array.from(t.getChildren()).filter(function (t) {
        return t.name === "th" || t.name === "td";
      });
      while (n < o.length && o[n].name === "th") {
        var _t343 = o[n];
        var _i157 = parseInt(_t343.getAttribute("colspan") || 1);
        e = e + _i157;
        n++;
      }
      return e;
    }
    var TI = /*#__PURE__*/function () {
      function TI(t) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, TI);
        this._table = t;
        this._startRow = e.row !== undefined ? e.row : e.startRow || 0;
        this._endRow = e.row !== undefined ? e.row : e.endRow;
        this._startColumn = e.column !== undefined ? e.column : e.startColumn || 0;
        this._endColumn = e.column !== undefined ? e.column : e.endColumn;
        this._includeAllSlots = !!e.includeAllSlots;
        this._skipRows = new Set();
        this._row = 0;
        this._column = 0;
        this._cellIndex = 0;
        this._spannedCells = new Map();
        this._nextCellAtColumn = -1;
      }
      _createClass(TI, [{
        key: Symbol.iterator,
        value: function value() {
          return this;
        }
      }, {
        key: "next",
        value: function next() {
          var t = this._table.getChild(this._row);
          if (!t || this._isOverEndRow()) {
            return {
              done: true
            };
          }
          if (this._isOverEndColumn()) {
            return this._advanceToNextRow();
          }
          var e = null;
          var n = this._getSpanned();
          if (n) {
            if (this._includeAllSlots && !this._shouldSkipSlot()) {
              e = this._formatOutValue(n.cell, n.row, n.column);
            }
          } else {
            var _n272 = t.getChild(this._cellIndex);
            if (!_n272) {
              return this._advanceToNextRow();
            }
            var _o191 = parseInt(_n272.getAttribute("colspan") || 1);
            var _i158 = parseInt(_n272.getAttribute("rowspan") || 1);
            if (_o191 > 1 || _i158 > 1) {
              this._recordSpans(_n272, _i158, _o191);
            }
            if (!this._shouldSkipSlot()) {
              e = this._formatOutValue(_n272);
            }
            this._nextCellAtColumn = this._column + _o191;
          }
          this._column++;
          if (this._column == this._nextCellAtColumn) {
            this._cellIndex++;
          }
          return e || this.next();
        }
      }, {
        key: "skipRow",
        value: function skipRow(t) {
          this._skipRows.add(t);
        }
      }, {
        key: "_advanceToNextRow",
        value: function _advanceToNextRow() {
          this._row++;
          this._column = 0;
          this._cellIndex = 0;
          this._nextCellAtColumn = -1;
          return this.next();
        }
      }, {
        key: "_isOverEndRow",
        value: function _isOverEndRow() {
          return this._endRow !== undefined && this._row > this._endRow;
        }
      }, {
        key: "_isOverEndColumn",
        value: function _isOverEndColumn() {
          return this._endColumn !== undefined && this._column > this._endColumn;
        }
      }, {
        key: "_formatOutValue",
        value: function _formatOutValue(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._row;
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._column;
          return {
            done: false,
            value: new II(this, t, e, n)
          };
        }
      }, {
        key: "_shouldSkipSlot",
        value: function _shouldSkipSlot() {
          var t = this._skipRows.has(this._row);
          var e = this._row < this._startRow;
          var n = this._column < this._startColumn;
          var o = this._endColumn !== undefined && this._column > this._endColumn;
          return t || e || n || o;
        }
      }, {
        key: "_getSpanned",
        value: function _getSpanned() {
          var t = this._spannedCells.get(this._row);
          if (!t) {
            return null;
          }
          return t.get(this._column) || null;
        }
      }, {
        key: "_recordSpans",
        value: function _recordSpans(t, e, n) {
          var o = {
            cell: t,
            row: this._row,
            column: this._column
          };
          for (var _t344 = this._row; _t344 < this._row + e; _t344++) {
            for (var _e301 = this._column; _e301 < this._column + n; _e301++) {
              if (_t344 != this._row || _e301 != this._column) {
                this._markSpannedCell(_t344, _e301, o);
              }
            }
          }
        }
      }, {
        key: "_markSpannedCell",
        value: function _markSpannedCell(t, e, n) {
          if (!this._spannedCells.has(t)) {
            this._spannedCells.set(t, new Map());
          }
          var o = this._spannedCells.get(t);
          o.set(e, n);
        }
      }]);
      return TI;
    }();
    var II = /*#__PURE__*/function () {
      function II(t, e, n, o) {
        _classCallCheck(this, II);
        this.cell = e;
        this.row = t._row;
        this.column = t._column;
        this.cellAnchorRow = n;
        this.cellAnchorColumn = o;
        this._cellIndex = t._cellIndex;
        this._table = t._table;
      }
      _createClass(II, [{
        key: "getPositionBefore",
        value: function getPositionBefore() {
          var t = this._table.root.document.model;
          return t.createPositionAt(this._table.getChild(this.row), this._cellIndex);
        }
      }, {
        key: "isAnchor",
        get: function get() {
          return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
        }
      }, {
        key: "cellWidth",
        get: function get() {
          return parseInt(this.cell.getAttribute("colspan") || 1);
        }
      }, {
        key: "cellHeight",
        get: function get() {
          return parseInt(this.cell.getAttribute("rowspan") || 1);
        }
      }]);
      return II;
    }();
    function NI() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return function (e) {
        return e.on("insert:table", function (e, n, o) {
          var i = n.item;
          if (!o.consumable.consume(i, "insert")) {
            return;
          }
          o.consumable.consume(i, "attribute:headingRows:table");
          o.consumable.consume(i, "attribute:headingColumns:table");
          var r = t && t.asWidget;
          var s = o.writer.createContainerElement("figure", {
            class: "table"
          });
          var a = o.writer.createContainerElement("table");
          o.writer.insert(o.writer.createPositionAt(s, 0), a);
          var c;
          if (r) {
            c = jI(s, o.writer);
          }
          var l = new TI(i);
          var d = {
            headingRows: i.getAttribute("headingRows") || 0,
            headingColumns: i.getAttribute("headingColumns") || 0
          };
          var u = new Map();
          var _iterator399 = _createForOfIteratorHelper(l),
            _step399;
          try {
            for (_iterator399.s(); !(_step399 = _iterator399.n()).done;) {
              var _e302 = _step399.value;
              var _n273 = _e302.row,
                _r62 = _e302.cell;
              var _s42 = i.getChild(_n273);
              var _c15 = u.get(_n273) || HI(a, _s42, _n273, d, o);
              u.set(_n273, _c15);
              o.consumable.consume(_r62, "insert");
              var _l9 = o.writer.createPositionAt(_c15, "end");
              UI(_e302, d, _l9, o, t);
            }
          } catch (err) {
            _iterator399.e(err);
          } finally {
            _iterator399.f();
          }
          var _iterator400 = _createForOfIteratorHelper(i.getChildren()),
            _step400;
          try {
            for (_iterator400.s(); !(_step400 = _iterator400.n()).done;) {
              var _t345 = _step400.value;
              var _e303 = _t345.index;
              if (!u.has(_e303)) {
                u.set(_e303, HI(a, _t345, _e303, d, o));
              }
            }
          } catch (err) {
            _iterator400.e(err);
          } finally {
            _iterator400.f();
          }
          var h = o.mapper.toViewPosition(n.range.start);
          o.mapper.bindElements(i, r ? c : s);
          o.writer.insert(h, r ? c : s);
        });
      };
    }
    function PI() {
      return function (t) {
        return t.on("insert:tableRow", function (t, e, n) {
          var o = e.item;
          if (!n.consumable.consume(o, "insert")) {
            return;
          }
          var i = o.parent;
          var r = n.mapper.toViewElement(i);
          var s = $I(r);
          var a = i.getChildIndex(o);
          var c = new TI(i, {
            row: a
          });
          var l = {
            headingRows: i.getAttribute("headingRows") || 0,
            headingColumns: i.getAttribute("headingColumns") || 0
          };
          var d = new Map();
          var _iterator401 = _createForOfIteratorHelper(c),
            _step401;
          try {
            for (_iterator401.s(); !(_step401 = _iterator401.n()).done;) {
              var _t346 = _step401.value;
              var _e304 = d.get(a) || HI(s, o, a, l, n);
              d.set(a, _e304);
              n.consumable.consume(_t346.cell, "insert");
              var _i159 = n.writer.createPositionAt(_e304, "end");
              UI(_t346, l, _i159, n, {
                asWidget: true
              });
            }
          } catch (err) {
            _iterator401.e(err);
          } finally {
            _iterator401.f();
          }
        });
      };
    }
    function BI() {
      return function (t) {
        return t.on("insert:tableCell", function (t, e, n) {
          var o = e.item;
          if (!n.consumable.consume(o, "insert")) {
            return;
          }
          var i = o.parent;
          var r = i.parent;
          var s = r.getChildIndex(i);
          var a = new TI(r, {
            row: s
          });
          var c = {
            headingRows: r.getAttribute("headingRows") || 0,
            headingColumns: r.getAttribute("headingColumns") || 0
          };
          var _iterator402 = _createForOfIteratorHelper(a),
            _step402;
          try {
            for (_iterator402.s(); !(_step402 = _iterator402.n()).done;) {
              var _t347 = _step402.value;
              if (_t347.cell === o) {
                var _e305 = n.mapper.toViewElement(i);
                var _r63 = n.writer.createPositionAt(_e305, i.getChildIndex(o));
                UI(_t347, c, _r63, n, {
                  asWidget: true
                });
                return;
              }
            }
          } catch (err) {
            _iterator402.e(err);
          } finally {
            _iterator402.f();
          }
        });
      };
    }
    function zI() {
      return function (t) {
        return t.on("attribute:headingColumns:table", function (t, e, n) {
          var o = e.item;
          if (!n.consumable.consume(e.item, t.name)) {
            return;
          }
          var i = {
            headingRows: o.getAttribute("headingRows") || 0,
            headingColumns: o.getAttribute("headingColumns") || 0
          };
          var r = e.attributeOldValue;
          var s = e.attributeNewValue;
          var a = (r > s ? r : s) - 1;
          var _iterator403 = _createForOfIteratorHelper(new TI(o, {
              endColumn: a
            })),
            _step403;
          try {
            for (_iterator403.s(); !(_step403 = _iterator403.n()).done;) {
              var _t348 = _step403.value;
              VI(_t348, i, n);
            }
          } catch (err) {
            _iterator403.e(err);
          } finally {
            _iterator403.f();
          }
        });
      };
    }
    function LI() {
      return function (t) {
        return t.on("remove:tableRow", function (t, e, n) {
          t.stop();
          var o = n.writer;
          var i = n.mapper;
          var r = i.toViewPosition(e.position).getLastMatchingPosition(function (t) {
            return !t.item.is("element", "tr");
          });
          var s = r.nodeAfter;
          var a = s.parent;
          var c = a.parent;
          var l = o.createRangeOn(s);
          var d = o.remove(l);
          var _iterator404 = _createForOfIteratorHelper(o.createRangeIn(d).getItems()),
            _step404;
          try {
            for (_iterator404.s(); !(_step404 = _iterator404.n()).done;) {
              var _t349 = _step404.value;
              i.unbindViewElement(_t349);
            }
          } catch (err) {
            _iterator404.e(err);
          } finally {
            _iterator404.f();
          }
          QI("thead", c, n);
          QI("tbody", c, n);
        }, {
          priority: "higher"
        });
      };
    }
    function OI(t, e) {
      var n = e.writer;
      if (!t.parent.is("element", "tableCell")) {
        return;
      }
      if (RI(t)) {
        return n.createContainerElement("span", {
          style: "display:inline-block"
        });
      } else {
        return n.createContainerElement("p");
      }
    }
    function RI(t) {
      var e = t.parent;
      var n = e.childCount === 1;
      return n && !ZI(t);
    }
    function jI(t, e) {
      e.setCustomProperty("table", true, t);
      return rA(t, e, {
        hasSelectionHandle: true
      });
    }
    function FI(t, e, n) {
      var o = n.writer;
      var i = n.mapper.toViewElement(t);
      var r = o.createEditableElement(e, i.getAttributes());
      var s = lA(r, o);
      sA(s, o, function (t, e, n) {
        return n.addClass(xs(e.classes), t);
      }, function (t, e, n) {
        return n.removeClass(xs(e.classes), t);
      });
      o.insert(o.createPositionAfter(i), s);
      o.move(o.createRangeIn(i), o.createPositionAt(s, 0));
      o.remove(o.createRangeOn(i));
      n.mapper.unbindViewElement(i);
      n.mapper.bindElements(t, s);
    }
    function VI(t, e, n) {
      var o = t.cell;
      var i = GI(t, e);
      var r = n.mapper.toViewElement(o);
      if (r && r.name !== i) {
        FI(o, i, n);
      }
    }
    function UI(t, e, n, o, i) {
      var r = i && i.asWidget;
      var s = GI(t, e);
      var a = r ? lA(o.writer.createEditableElement(s), o.writer) : o.writer.createContainerElement(s);
      if (r) {
        sA(a, o.writer, function (t, e, n) {
          return n.addClass(xs(e.classes), t);
        }, function (t, e, n) {
          return n.removeClass(xs(e.classes), t);
        });
      }
      var c = t.cell;
      var l = c.getChild(0);
      var d = c.childCount === 1 && l.name === "paragraph";
      o.writer.insert(n, a);
      o.mapper.bindElements(c, a);
      if (!r && !ZI(l) && d) {
        var _t350 = c.getChild(0);
        o.consumable.consume(_t350, "insert");
        o.mapper.bindElements(_t350, a);
      }
    }
    function HI(t, e, n, o, i) {
      i.consumable.consume(e, "insert");
      var r = e.isEmpty ? i.writer.createEmptyElement("tr") : i.writer.createContainerElement("tr");
      i.mapper.bindElements(e, r);
      var s = o.headingRows;
      var a = KI(WI(n, o), t, i);
      var c = s > 0 && n >= s ? n - s : n;
      var l = i.writer.createPositionAt(a, c);
      i.writer.insert(l, r);
      return r;
    }
    function GI(t, e) {
      var n = t.row,
        o = t.column;
      var i = e.headingColumns,
        r = e.headingRows;
      var s = r && r > n;
      if (s) {
        return "th";
      }
      var a = i && i > o;
      return a ? "th" : "td";
    }
    function WI(t, e) {
      return t < e.headingRows ? "thead" : "tbody";
    }
    function KI(t, e, n) {
      var o = qI(t, e);
      return o ? o : YI(t, e, n);
    }
    function qI(t, e) {
      var _iterator405 = _createForOfIteratorHelper(e.getChildren()),
        _step405;
      try {
        for (_iterator405.s(); !(_step405 = _iterator405.n()).done;) {
          var _n274 = _step405.value;
          if (_n274.name == t) {
            return _n274;
          }
        }
      } catch (err) {
        _iterator405.e(err);
      } finally {
        _iterator405.f();
      }
    }
    function YI(t, e, n) {
      var o = n.writer.createContainerElement(t);
      var i = n.writer.createPositionAt(e, t == "tbody" ? "end" : 0);
      n.writer.insert(i, o);
      return o;
    }
    function QI(t, e, n) {
      var o = qI(t, e);
      if (o && o.childCount === 0) {
        n.writer.remove(n.writer.createRangeOn(o));
      }
    }
    function $I(t) {
      var _iterator406 = _createForOfIteratorHelper(t.getChildren()),
        _step406;
      try {
        for (_iterator406.s(); !(_step406 = _iterator406.n()).done;) {
          var _e306 = _step406.value;
          if (_e306.name === "table") {
            return _e306;
          }
        }
      } catch (err) {
        _iterator406.e(err);
      } finally {
        _iterator406.f();
      }
    }
    function ZI(t) {
      return !!_toConsumableArray(t.getAttributeKeys()).length;
    }
    var JI = /*#__PURE__*/function (_uC24) {
      _inherits(JI, _uC24);
      function JI() {
        _classCallCheck(this, JI);
        return _possibleConstructorReturn(this, _getPrototypeOf(JI).apply(this, arguments));
      }
      _createClass(JI, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = t.document.selection;
          var n = t.schema;
          var o = XI(e.getFirstPosition());
          this.isEnabled = n.checkChild(o, "table");
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var e = this.editor.model;
          var n = e.document.selection;
          var o = this.editor.plugins.get("TableUtils");
          var i = dA(n, e);
          e.change(function (n) {
            var r = o.createTable(n, t);
            e.insertContent(r, i);
            n.setSelection(n.createPositionAt(r.getNodeByPath([0, 0, 0]), 0));
          });
        }
      }]);
      return JI;
    }(uC);
    function XI(t) {
      var e = t.parent;
      return e === e.root ? e : e.parent;
    }
    function tN(t) {
      var e = [];
      var _iterator407 = _createForOfIteratorHelper(sN(t.getRanges())),
        _step407;
      try {
        for (_iterator407.s(); !(_step407 = _iterator407.n()).done;) {
          var _n275 = _step407.value;
          var _t351 = _n275.getContainedElement();
          if (_t351 && _t351.is("element", "tableCell")) {
            e.push(_t351);
          }
        }
      } catch (err) {
        _iterator407.e(err);
      } finally {
        _iterator407.f();
      }
      return e;
    }
    function eN(t) {
      var e = [];
      var _iterator408 = _createForOfIteratorHelper(t.getRanges()),
        _step408;
      try {
        for (_iterator408.s(); !(_step408 = _iterator408.n()).done;) {
          var _n276 = _step408.value;
          var _t352 = _n276.start.findAncestor("tableCell");
          if (_t352) {
            e.push(_t352);
          }
        }
      } catch (err) {
        _iterator408.e(err);
      } finally {
        _iterator408.f();
      }
      return e;
    }
    function nN(t) {
      var e = tN(t);
      if (e.length) {
        return e;
      }
      return eN(t);
    }
    function oN(t) {
      var e = t.map(function (t) {
        return t.parent.index;
      });
      return aN(e);
    }
    function iN(t) {
      var e = t[0].findAncestor("table");
      var n = _toConsumableArray(new TI(e));
      var o = n.filter(function (e) {
        return t.includes(e.cell);
      }).map(function (t) {
        return t.column;
      });
      return aN(o);
    }
    function rN(t, e) {
      if (t.length < 2 || !dN(t)) {
        return false;
      }
      var n = new Set();
      var o = new Set();
      var i = 0;
      var _iterator409 = _createForOfIteratorHelper(t),
        _step409;
      try {
        for (_iterator409.s(); !(_step409 = _iterator409.n()).done;) {
          var _r64 = _step409.value;
          var _e$getCellLocation = e.getCellLocation(_r64),
            _t353 = _e$getCellLocation.row,
            _s43 = _e$getCellLocation.column;
          var _a27 = parseInt(_r64.getAttribute("rowspan") || 1);
          var _c16 = parseInt(_r64.getAttribute("colspan") || 1);
          n.add(_t353);
          o.add(_s43);
          if (_a27 > 1) {
            n.add(_t353 + _a27 - 1);
          }
          if (_c16 > 1) {
            o.add(_s43 + _c16 - 1);
          }
          i += _a27 * _c16;
        }
      } catch (err) {
        _iterator409.e(err);
      } finally {
        _iterator409.f();
      }
      var r = lN(n, o);
      return r == i;
    }
    function sN(t) {
      return Array.from(t).sort(cN);
    }
    function aN(t) {
      var e = t.sort(function (t, e) {
        return t - e;
      });
      var n = e[0];
      var o = e[e.length - 1];
      return {
        first: n,
        last: o
      };
    }
    function cN(t, e) {
      var n = t.start;
      var o = e.start;
      return n.isBefore(o) ? -1 : 1;
    }
    function lN(t, e) {
      var n = Array.from(t.values());
      var o = Array.from(e.values());
      var i = Math.max.apply(Math, n);
      var r = Math.min.apply(Math, n);
      var s = Math.max.apply(Math, o);
      var a = Math.min.apply(Math, o);
      return (i - r + 1) * (s - a + 1);
    }
    function dN(t) {
      var e = t[0].findAncestor("table");
      var n = oN(t);
      var o = parseInt(e.getAttribute("headingRows") || 0);
      if (!uN(n, o)) {
        return false;
      }
      var i = parseInt(e.getAttribute("headingColumns") || 0);
      var r = iN(t);
      return uN(r, i);
    }
    function uN(_ref52, n) {
      var t = _ref52.first,
        e = _ref52.last;
      var o = t < n;
      var i = e < n;
      return o === i;
    }
    var hN = /*#__PURE__*/function (_uC25) {
      _inherits(hN, _uC25);
      function hN(t) {
        var _this265;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, hN);
        _this265 = _possibleConstructorReturn(this, _getPrototypeOf(hN).call(this, t));
        _this265.order = e.order || "below";
        return _this265;
      }
      _createClass(hN, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection;
          var e = t.getFirstPosition().findAncestor("table");
          this.isEnabled = !!e;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor;
          var e = t.model.document.selection;
          var n = t.plugins.get("TableUtils");
          var o = this.order === "above";
          var i = nN(e);
          var r = oN(i);
          var s = o ? r.first : r.last;
          var a = i[0].findAncestor("table");
          n.insertRows(a, {
            at: o ? s : s + 1,
            copyStructureFromAbove: !o
          });
        }
      }]);
      return hN;
    }(uC);
    var fN = /*#__PURE__*/function (_uC26) {
      _inherits(fN, _uC26);
      function fN(t) {
        var _this266;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, fN);
        _this266 = _possibleConstructorReturn(this, _getPrototypeOf(fN).call(this, t));
        _this266.order = e.order || "right";
        return _this266;
      }
      _createClass(fN, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model.document.selection;
          var e = t.getFirstPosition().findAncestor("table");
          this.isEnabled = !!e;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor;
          var e = t.model.document.selection;
          var n = t.plugins.get("TableUtils");
          var o = this.order === "left";
          var i = nN(e);
          var r = iN(i);
          var s = o ? r.first : r.last;
          var a = i[0].findAncestor("table");
          n.insertColumns(a, {
            columns: 1,
            at: o ? s : s + 1
          });
        }
      }]);
      return fN;
    }(uC);
    var mN = /*#__PURE__*/function (_uC27) {
      _inherits(mN, _uC27);
      function mN(t) {
        var _this267;
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        _classCallCheck(this, mN);
        _this267 = _possibleConstructorReturn(this, _getPrototypeOf(mN).call(this, t));
        _this267.direction = e.direction || "horizontally";
        return _this267;
      }
      _createClass(mN, [{
        key: "refresh",
        value: function refresh() {
          var t = nN(this.editor.model.document.selection);
          this.isEnabled = t.length === 1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = nN(this.editor.model.document.selection)[0];
          var e = this.direction === "horizontally";
          var n = this.editor.plugins.get("TableUtils");
          if (e) {
            n.splitCellHorizontally(t, 2);
          } else {
            n.splitCellVertically(t, 2);
          }
        }
      }]);
      return mN;
    }(uC);
    function gN(t, e, n) {
      var o = e.startRow,
        i = e.startColumn,
        r = e.endRow,
        s = e.endColumn;
      var a = n.createElement("table");
      var c = r - o + 1;
      for (var _t354 = 0; _t354 < c; _t354++) {
        n.insertElement("tableRow", a, "end");
      }
      var l = _toConsumableArray(new TI(t, {
        startRow: o,
        endRow: r,
        startColumn: i,
        endColumn: s,
        includeAllSlots: true
      }));
      var _iterator410 = _createForOfIteratorHelper(l),
        _step410;
      try {
        for (_iterator410.s(); !(_step410 = _iterator410.n()).done;) {
          var _step410$value = _step410.value,
            _t355 = _step410$value.row,
            _e307 = _step410$value.column,
            _c17 = _step410$value.cell,
            _d4 = _step410$value.isAnchor,
            _u4 = _step410$value.cellAnchorRow,
            _h3 = _step410$value.cellAnchorColumn;
          var _l10 = _t355 - o;
          var _f2 = a.getChild(_l10);
          if (!_d4) {
            if (_u4 < o || _h3 < i) {
              yI(n, n.createPositionAt(_f2, "end"));
            }
          } else {
            var _o192 = n.cloneElement(_c17);
            n.append(_o192, _f2);
            CN(_o192, _t355, _e307, r, s, n);
          }
        }
      } catch (err) {
        _iterator410.e(err);
      } finally {
        _iterator410.f();
      }
      AN(a, t, o, i, n);
      return a;
    }
    function pN(t, e) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var o = [];
      var i = new TI(t, {
        startRow: n,
        endRow: e - 1
      });
      var _iterator411 = _createForOfIteratorHelper(i),
        _step411;
      try {
        for (_iterator411.s(); !(_step411 = _iterator411.n()).done;) {
          var _t356 = _step411.value;
          var _n277 = _t356.row,
            _i160 = _t356.cellHeight;
          var _r65 = _n277 + _i160 - 1;
          if (_n277 < e && e <= _r65) {
            o.push(_t356);
          }
        }
      } catch (err) {
        _iterator411.e(err);
      } finally {
        _iterator411.f();
      }
      return o;
    }
    function kN(t, e, n) {
      var o = t.parent;
      var i = o.parent;
      var r = o.index;
      var s = parseInt(t.getAttribute("rowspan"));
      var a = e - r;
      var c = {};
      var l = s - a;
      if (l > 1) {
        c.rowspan = l;
      }
      var d = parseInt(t.getAttribute("colspan") || 1);
      if (d > 1) {
        c.colspan = d;
      }
      var u = r;
      var h = u + a;
      var f = _toConsumableArray(new TI(i, {
        startRow: u,
        endRow: h,
        includeAllSlots: true
      }));
      var m = null;
      var g;
      var _iterator412 = _createForOfIteratorHelper(f),
        _step412;
      try {
        for (_iterator412.s(); !(_step412 = _iterator412.n()).done;) {
          var _e308 = _step412.value;
          var _o193 = _e308.row,
            _i161 = _e308.column,
            _r66 = _e308.cell;
          if (_r66 === t && g === undefined) {
            g = _i161;
          }
          if (g !== undefined && g === _i161 && _o193 === h) {
            m = yI(n, _e308.getPositionBefore(), c);
          }
        }
      } catch (err) {
        _iterator412.e(err);
      } finally {
        _iterator412.f();
      }
      vI("rowspan", a, t, n);
      return m;
    }
    function bN(t, e) {
      var n = [];
      var o = new TI(t);
      var _iterator413 = _createForOfIteratorHelper(o),
        _step413;
      try {
        for (_iterator413.s(); !(_step413 = _iterator413.n()).done;) {
          var _t357 = _step413.value;
          var _o194 = _t357.column,
            _i162 = _t357.cellWidth;
          var _r67 = _o194 + _i162 - 1;
          if (_o194 < e && e <= _r67) {
            n.push(_t357);
          }
        }
      } catch (err) {
        _iterator413.e(err);
      } finally {
        _iterator413.f();
      }
      return n;
    }
    function wN(t, e, n, o) {
      var i = parseInt(t.getAttribute("colspan"));
      var r = n - e;
      var s = {};
      var a = i - r;
      if (a > 1) {
        s.colspan = a;
      }
      var c = parseInt(t.getAttribute("rowspan") || 1);
      if (c > 1) {
        s.rowspan = c;
      }
      var l = yI(o, o.createPositionAfter(t), s);
      vI("colspan", r, t, o);
      return l;
    }
    function CN(t, e, n, o, i, r) {
      var s = parseInt(t.getAttribute("colspan") || 1);
      var a = parseInt(t.getAttribute("rowspan") || 1);
      var c = n + s - 1;
      if (c > i) {
        var _e309 = i - n + 1;
        vI("colspan", _e309, t, r, 1);
      }
      var l = e + a - 1;
      if (l > o) {
        var _n278 = o - e + 1;
        vI("rowspan", _n278, t, r, 1);
      }
    }
    function AN(t, e, n, o, i) {
      var r = parseInt(e.getAttribute("headingRows") || 0);
      if (r > 0) {
        var _e310 = r - n;
        vI("headingRows", _e310, t, i, 0);
      }
      var s = parseInt(e.getAttribute("headingColumns") || 0);
      if (s > 0) {
        var _e311 = s - o;
        vI("headingColumns", _e311, t, i, 0);
      }
    }
    function _N(t, e) {
      var n = e.getColumns(t);
      var o = new Array(n).fill(0);
      var _iterator414 = _createForOfIteratorHelper(new TI(t)),
        _step414;
      try {
        for (_iterator414.s(); !(_step414 = _iterator414.n()).done;) {
          var _e312 = _step414.value.column;
          o[_e312]++;
        }
      } catch (err) {
        _iterator414.e(err);
      } finally {
        _iterator414.f();
      }
      var i = o.reduce(function (t, e, n) {
        return e ? t : [].concat(_toConsumableArray(t), [n]);
      }, []);
      if (i.length > 0) {
        var _n279 = i[i.length - 1];
        e.removeColumns(t, {
          at: _n279
        });
        return true;
      }
      return false;
    }
    function vN(t, e) {
      var n = [];
      for (var _e313 = 0; _e313 < t.childCount; _e313++) {
        var _o195 = t.getChild(_e313);
        if (_o195.isEmpty) {
          n.push(_e313);
        }
      }
      if (n.length > 0) {
        var _o196 = n[n.length - 1];
        e.removeRows(t, {
          at: _o196
        });
        return true;
      }
      return false;
    }
    function yN(t, e) {
      var n = _N(t, e);
      if (!n) {
        vN(t, e);
      }
    }
    function xN(t, e) {
      var n = Array.from(new TI(t, {
        startColumn: e.firstColumn,
        endColumn: e.lastColumn,
        row: e.lastRow
      }));
      var o = n.every(function (_ref53) {
        var t = _ref53.cellHeight;
        return t === 1;
      });
      if (o) {
        return e.lastRow;
      }
      var i = n[0].cellHeight - 1;
      return e.lastRow + i;
    }
    function DN(t, e) {
      var n = Array.from(new TI(t, {
        startRow: e.firstRow,
        endRow: e.lastRow,
        column: e.lastColumn
      }));
      var o = n.every(function (_ref54) {
        var t = _ref54.cellWidth;
        return t === 1;
      });
      if (o) {
        return e.lastColumn;
      }
      var i = n[0].cellWidth - 1;
      return e.lastColumn + i;
    }
    var EN = /*#__PURE__*/function (_uC28) {
      _inherits(EN, _uC28);
      function EN(t, e) {
        var _this268;
        _classCallCheck(this, EN);
        _this268 = _possibleConstructorReturn(this, _getPrototypeOf(EN).call(this, t));
        _this268.direction = e.direction;
        _this268.isHorizontal = _this268.direction == "right" || _this268.direction == "left";
        return _this268;
      }
      _createClass(EN, [{
        key: "refresh",
        value: function refresh() {
          var t = this._getMergeableCell();
          this.value = t;
          this.isEnabled = !!t;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this269 = this;
          var t = this.editor.model;
          var e = t.document;
          var n = eN(e.selection)[0];
          var o = this.value;
          var i = this.direction;
          t.change(function (t) {
            var e = i == "right" || i == "down";
            var r = e ? n : o;
            var s = e ? o : n;
            var a = s.parent;
            TN(s, r, t);
            var c = _this269.isHorizontal ? "colspan" : "rowspan";
            var l = parseInt(n.getAttribute(c) || 1);
            var d = parseInt(o.getAttribute(c) || 1);
            t.setAttribute(c, l + d, r);
            t.setSelection(t.createRangeIn(r));
            var u = _this269.editor.plugins.get("TableUtils");
            var h = a.findAncestor("table");
            yN(h, u);
          });
        }
      }, {
        key: "_getMergeableCell",
        value: function _getMergeableCell() {
          var t = this.editor.model;
          var e = t.document;
          var n = eN(e.selection)[0];
          if (!n) {
            return;
          }
          var o = this.editor.plugins.get("TableUtils");
          var i = this.isHorizontal ? MN(n, this.direction, o) : SN(n, this.direction);
          if (!i) {
            return;
          }
          var r = this.isHorizontal ? "rowspan" : "colspan";
          var s = parseInt(n.getAttribute(r) || 1);
          var a = parseInt(i.getAttribute(r) || 1);
          if (a === s) {
            return i;
          }
        }
      }]);
      return EN;
    }(uC);
    function MN(t, e, n) {
      var o = t.parent;
      var i = o.parent;
      var r = e == "right" ? t.nextSibling : t.previousSibling;
      var s = (i.getAttribute("headingColumns") || 0) > 0;
      if (!r) {
        return;
      }
      var a = e == "right" ? t : r;
      var c = e == "right" ? r : t;
      var _n$getCellLocation = n.getCellLocation(a),
        l = _n$getCellLocation.column;
      var _n$getCellLocation2 = n.getCellLocation(c),
        d = _n$getCellLocation2.column;
      var u = parseInt(a.getAttribute("colspan") || 1);
      var h = xI(n, a, i);
      var f = xI(n, c, i);
      if (s && h != f) {
        return;
      }
      var m = l + u === d;
      return m ? r : undefined;
    }
    function SN(t, e) {
      var n = t.parent;
      var o = n.parent;
      var i = o.getChildIndex(n);
      if (e == "down" && i === o.childCount - 1 || e == "up" && i === 0) {
        return;
      }
      var r = parseInt(t.getAttribute("rowspan") || 1);
      var s = o.getAttribute("headingRows") || 0;
      var a = e == "down" && i + r === s;
      var c = e == "up" && i === s;
      if (s && (a || c)) {
        return;
      }
      var l = parseInt(t.getAttribute("rowspan") || 1);
      var d = e == "down" ? i + l : i;
      var u = _toConsumableArray(new TI(o, {
        endRow: d
      }));
      var h = u.find(function (e) {
        return e.cell === t;
      });
      var f = h.column;
      var m = u.find(function (_ref55) {
        var t = _ref55.row,
          n = _ref55.cellHeight,
          o = _ref55.column;
        if (o !== f) {
          return false;
        }
        if (e == "down") {
          return t === d;
        } else {
          return d === t + n;
        }
      });
      return m && m.cell;
    }
    function TN(t, e, n) {
      if (!IN(t)) {
        if (IN(e)) {
          n.remove(n.createRangeIn(e));
        }
        n.move(n.createRangeIn(t), n.createPositionAt(e, "end"));
      }
      n.remove(t);
    }
    function IN(t) {
      return t.childCount == 1 && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
    }
    var NN = /*#__PURE__*/function (_uC29) {
      _inherits(NN, _uC29);
      function NN() {
        _classCallCheck(this, NN);
        return _possibleConstructorReturn(this, _getPrototypeOf(NN).apply(this, arguments));
      }
      _createClass(NN, [{
        key: "refresh",
        value: function refresh() {
          var t = nN(this.editor.model.document.selection);
          var e = t[0];
          if (e) {
            var _n280 = e.findAncestor("table");
            var _o197 = this.editor.plugins.get("TableUtils").getRows(_n280);
            var _i163 = _o197 - 1;
            var _r68 = oN(t);
            var _s44 = _r68.first === 0 && _r68.last === _i163;
            this.isEnabled = !_s44;
          } else {
            this.isEnabled = false;
          }
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this270 = this;
          var t = this.editor.model;
          var e = nN(t.document.selection);
          var n = oN(e);
          var o = e[0];
          var i = o.findAncestor("table");
          var r = this.editor.plugins.get("TableUtils").getCellLocation(o).column;
          t.change(function (t) {
            var e = n.last - n.first + 1;
            _this270.editor.plugins.get("TableUtils").removeRows(i, {
              at: n.first,
              rows: e
            });
            var o = PN(i, n.first, r);
            t.setSelection(t.createPositionAt(o, 0));
          });
        }
      }]);
      return NN;
    }(uC);
    function PN(t, e, n) {
      var o = t.getChild(e) || t.getChild(t.childCount - 1);
      var i = o.getChild(0);
      var r = 0;
      var _iterator415 = _createForOfIteratorHelper(o.getChildren()),
        _step415;
      try {
        for (_iterator415.s(); !(_step415 = _iterator415.n()).done;) {
          var _t358 = _step415.value;
          if (r > n) {
            return i;
          }
          i = _t358;
          r += parseInt(_t358.getAttribute("colspan") || 1);
        }
      } catch (err) {
        _iterator415.e(err);
      } finally {
        _iterator415.f();
      }
      return i;
    }
    var BN = /*#__PURE__*/function (_uC30) {
      _inherits(BN, _uC30);
      function BN() {
        _classCallCheck(this, BN);
        return _possibleConstructorReturn(this, _getPrototypeOf(BN).apply(this, arguments));
      }
      _createClass(BN, [{
        key: "refresh",
        value: function refresh() {
          var t = nN(this.editor.model.document.selection);
          var e = t[0];
          if (e) {
            var _n281 = e.findAncestor("table");
            var _o198 = this.editor.plugins.get("TableUtils").getColumns(_n281);
            var _iN = iN(t),
              _i164 = _iN.first,
              _r69 = _iN.last;
            this.isEnabled = _r69 - _i164 < _o198 - 1;
          } else {
            this.isEnabled = false;
          }
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this271 = this;
          var _LN = LN(this.editor.model.document.selection),
            _LN2 = _slicedToArray(_LN, 2),
            t = _LN2[0],
            e = _LN2[1];
          var n = t.parent.parent;
          var o = _toConsumableArray(new TI(n));
          var i = {
            first: o.find(function (e) {
              return e.cell === t;
            }).column,
            last: o.find(function (t) {
              return t.cell === e;
            }).column
          };
          var r = zN(o, t, e, i);
          this.editor.model.change(function (t) {
            var e = i.last - i.first + 1;
            _this271.editor.plugins.get("TableUtils").removeColumns(n, {
              at: i.first,
              columns: e
            });
            t.setSelection(t.createPositionAt(r, 0));
          });
        }
      }]);
      return BN;
    }(uC);
    function zN(t, e, n, o) {
      var i = parseInt(n.getAttribute("colspan") || 1);
      if (i > 1) {
        return n;
      } else if (e.previousSibling || n.nextSibling) {
        return n.nextSibling || e.previousSibling;
      } else {
        if (o.first) {
          return t.reverse().find(function (_ref56) {
            var t = _ref56.column;
            return t < o.first;
          }).cell;
        } else {
          return t.reverse().find(function (_ref57) {
            var t = _ref57.column;
            return t > o.last;
          }).cell;
        }
      }
    }
    function LN(t) {
      var e = nN(t);
      var n = e[0];
      var o = e.pop();
      var i = [n, o];
      return n.isBefore(o) ? i : i.reverse();
    }
    var ON = /*#__PURE__*/function (_uC31) {
      _inherits(ON, _uC31);
      function ON() {
        _classCallCheck(this, ON);
        return _possibleConstructorReturn(this, _getPrototypeOf(ON).apply(this, arguments));
      }
      _createClass(ON, [{
        key: "refresh",
        value: function refresh() {
          var _this272 = this;
          var t = this.editor.model;
          var e = nN(t.document.selection);
          var n = e.length > 0;
          this.isEnabled = n;
          this.value = n && e.every(function (t) {
            return _this272._isInHeading(t, t.parent.parent);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (t.forceValue === this.value) {
            return;
          }
          var e = this.editor.model;
          var n = nN(e.document.selection);
          var o = n[0].findAncestor("table");
          var _oN = oN(n),
            i = _oN.first,
            r = _oN.last;
          var s = this.value ? i : r + 1;
          var a = o.getAttribute("headingRows") || 0;
          e.change(function (t) {
            if (s) {
              var _e314 = s > a ? a : 0;
              var _n282 = pN(o, s, _e314);
              var _iterator416 = _createForOfIteratorHelper(_n282),
                _step416;
              try {
                for (_iterator416.s(); !(_step416 = _iterator416.n()).done;) {
                  var _e315 = _step416.value.cell;
                  kN(_e315, s, t);
                }
              } catch (err) {
                _iterator416.e(err);
              } finally {
                _iterator416.f();
              }
            }
            vI("headingRows", s, o, t, 0);
          });
        }
      }, {
        key: "_isInHeading",
        value: function _isInHeading(t, e) {
          var n = parseInt(e.getAttribute("headingRows") || 0);
          return !!n && t.parent.index < n;
        }
      }]);
      return ON;
    }(uC);
    var RN = /*#__PURE__*/function (_uC32) {
      _inherits(RN, _uC32);
      function RN() {
        _classCallCheck(this, RN);
        return _possibleConstructorReturn(this, _getPrototypeOf(RN).apply(this, arguments));
      }
      _createClass(RN, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model;
          var e = nN(t.document.selection);
          var n = this.editor.plugins.get("TableUtils");
          var o = e.length > 0;
          this.isEnabled = o;
          this.value = o && e.every(function (t) {
            return xI(n, t);
          });
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          if (t.forceValue === this.value) {
            return;
          }
          var e = this.editor.model;
          var n = nN(e.document.selection);
          var o = n[0].findAncestor("table");
          var _iN2 = iN(n),
            i = _iN2.first,
            r = _iN2.last;
          var s = this.value ? i : r + 1;
          e.change(function (t) {
            if (s) {
              var _e316 = bN(o, s);
              var _iterator417 = _createForOfIteratorHelper(_e316),
                _step417;
              try {
                for (_iterator417.s(); !(_step417 = _iterator417.n()).done;) {
                  var _step417$value = _step417.value,
                    _n283 = _step417$value.cell,
                    _o199 = _step417$value.column;
                  wN(_n283, _o199, s, t);
                }
              } catch (err) {
                _iterator417.e(err);
              } finally {
                _iterator417.f();
              }
            }
            vI("headingColumns", s, o, t, 0);
          });
        }
      }]);
      return RN;
    }(uC);
    var jN = /*#__PURE__*/function (_aC74) {
      _inherits(jN, _aC74);
      function jN() {
        _classCallCheck(this, jN);
        return _possibleConstructorReturn(this, _getPrototypeOf(jN).apply(this, arguments));
      }
      _createClass(jN, [{
        key: "init",
        value: function init() {
          this.decorate("insertColumns");
          this.decorate("insertRows");
        }
      }, {
        key: "getCellLocation",
        value: function getCellLocation(t) {
          var e = t.parent;
          var n = e.parent;
          var o = n.getChildIndex(e);
          var i = new TI(n, {
            row: o
          });
          var _iterator418 = _createForOfIteratorHelper(i),
            _step418;
          try {
            for (_iterator418.s(); !(_step418 = _iterator418.n()).done;) {
              var _step418$value = _step418.value,
                _e317 = _step418$value.cell,
                _n284 = _step418$value.row,
                _o200 = _step418$value.column;
              if (_e317 === t) {
                return {
                  row: _n284,
                  column: _o200
                };
              }
            }
          } catch (err) {
            _iterator418.e(err);
          } finally {
            _iterator418.f();
          }
        }
      }, {
        key: "createTable",
        value: function createTable(t, e) {
          var n = t.createElement("table");
          var o = parseInt(e.rows) || 2;
          var i = parseInt(e.columns) || 2;
          FN(t, n, 0, o, i);
          if (e.headingRows) {
            vI("headingRows", e.headingRows, n, t, 0);
          }
          if (e.headingColumns) {
            vI("headingColumns", e.headingColumns, n, t, 0);
          }
          return n;
        }
      }, {
        key: "insertRows",
        value: function insertRows(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model;
          var o = e.at || 0;
          var i = e.rows || 1;
          var r = e.copyStructureFromAbove !== undefined;
          var s = e.copyStructureFromAbove ? o - 1 : o;
          var a = this.getRows(t);
          var c = this.getColumns(t);
          n.change(function (e) {
            var n = t.getAttribute("headingRows") || 0;
            if (n > o) {
              vI("headingRows", n + i, t, e, 0);
            }
            if (!r && (o === 0 || o === a)) {
              FN(e, t, o, i, c);
              return;
            }
            var l = r ? Math.max(o, s) : o;
            var d = new TI(t, {
              endRow: l
            });
            var u = new Array(c).fill(1);
            var _iterator419 = _createForOfIteratorHelper(d),
              _step419;
            try {
              for (_iterator419.s(); !(_step419 = _iterator419.n()).done;) {
                var _step419$value = _step419.value,
                  _t360 = _step419$value.row,
                  _n287 = _step419$value.column,
                  _a28 = _step419$value.cellHeight,
                  _c18 = _step419$value.cellWidth,
                  _l11 = _step419$value.cell;
                var _d5 = _t360 + _a28 - 1;
                var _h4 = _t360 < o && o <= _d5;
                var _f3 = _t360 <= s && s <= _d5;
                if (_h4) {
                  e.setAttribute("rowspan", _a28 + i, _l11);
                  u[_n287] = -_c18;
                } else if (r && _f3) {
                  u[_n287] = _c18;
                }
              }
            } catch (err) {
              _iterator419.e(err);
            } finally {
              _iterator419.f();
            }
            for (var _n285 = 0; _n285 < i; _n285++) {
              var _n286 = e.createElement("tableRow");
              e.insert(_n286, t, o);
              for (var _t359 = 0; _t359 < u.length; _t359++) {
                var _o201 = u[_t359];
                var _i165 = e.createPositionAt(_n286, "end");
                if (_o201 > 0) {
                  yI(e, _i165, _o201 > 1 ? {
                    colspan: _o201
                  } : null);
                }
                _t359 += Math.abs(_o201) - 1;
              }
            }
          });
        }
      }, {
        key: "insertColumns",
        value: function insertColumns(t) {
          var _this273 = this;
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var n = this.editor.model;
          var o = e.at || 0;
          var i = e.columns || 1;
          n.change(function (e) {
            var n = t.getAttribute("headingColumns");
            if (o < n) {
              e.setAttribute("headingColumns", n + i, t);
            }
            var r = _this273.getColumns(t);
            if (o === 0 || r === o) {
              var _iterator420 = _createForOfIteratorHelper(t.getChildren()),
                _step420;
              try {
                for (_iterator420.s(); !(_step420 = _iterator420.n()).done;) {
                  var _n288 = _step420.value;
                  VN(i, e, e.createPositionAt(_n288, o ? "end" : 0));
                }
              } catch (err) {
                _iterator420.e(err);
              } finally {
                _iterator420.f();
              }
              return;
            }
            var s = new TI(t, {
              column: o,
              includeAllSlots: true
            });
            var _iterator421 = _createForOfIteratorHelper(s),
              _step421;
            try {
              for (_iterator421.s(); !(_step421 = _iterator421.n()).done;) {
                var _t361 = _step421.value;
                var _n289 = _t361.row,
                  _r70 = _t361.cell,
                  _a29 = _t361.cellAnchorColumn,
                  _c19 = _t361.cellAnchorRow,
                  _l12 = _t361.cellWidth,
                  _d6 = _t361.cellHeight;
                if (_a29 < o) {
                  e.setAttribute("colspan", _l12 + i, _r70);
                  var _t362 = _c19 + _d6 - 1;
                  for (var _e318 = _n289; _e318 <= _t362; _e318++) {
                    s.skipRow(_e318);
                  }
                } else {
                  VN(i, e, _t361.getPositionBefore());
                }
              }
            } catch (err) {
              _iterator421.e(err);
            } finally {
              _iterator421.f();
            }
          });
        }
      }, {
        key: "removeRows",
        value: function removeRows(t, e) {
          var _this274 = this;
          var n = this.editor.model;
          var o = e.rows || 1;
          var i = e.at;
          var r = i + o - 1;
          n.change(function (e) {
            var _WN = WN(t, i, r),
              n = _WN.cellsToMove,
              o = _WN.cellsToTrim;
            if (n.size) {
              var _o202 = r + 1;
              KN(t, _o202, n, e);
            }
            for (var _n290 = r; _n290 >= i; _n290--) {
              e.remove(t.getChild(_n290));
            }
            var _iterator422 = _createForOfIteratorHelper(o),
              _step422;
            try {
              for (_iterator422.s(); !(_step422 = _iterator422.n()).done;) {
                var _step422$value = _step422.value,
                  _t363 = _step422$value.rowspan,
                  _n291 = _step422$value.cell;
                vI("rowspan", _t363, _n291, e);
              }
            } catch (err) {
              _iterator422.e(err);
            } finally {
              _iterator422.f();
            }
            GN(t, i, r, e);
            if (!_N(t, _this274)) {
              vN(t, _this274);
            }
          });
        }
      }, {
        key: "removeColumns",
        value: function removeColumns(t, e) {
          var _this275 = this;
          var n = this.editor.model;
          var o = e.at;
          var i = e.columns || 1;
          var r = e.at + i - 1;
          n.change(function (e) {
            HN(t, {
              first: o,
              last: r
            }, e);
            for (var _n292 = r; _n292 >= o; _n292--) {
              for (var _i166 = 0, _arr2 = _toConsumableArray(new TI(t)); _i166 < _arr2.length; _i166++) {
                var _arr2$_i = _arr2[_i166],
                  _o203 = _arr2$_i.cell,
                  _i167 = _arr2$_i.column,
                  _r71 = _arr2$_i.cellWidth;
                if (_i167 <= _n292 && _r71 > 1 && _i167 + _r71 > _n292) {
                  vI("colspan", _r71 - 1, _o203, e);
                } else if (_i167 === _n292) {
                  e.remove(_o203);
                }
              }
            }
            if (!vN(t, _this275)) {
              _N(t, _this275);
            }
          });
        }
      }, {
        key: "splitCellVertically",
        value: function splitCellVertically(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model;
          var o = t.parent;
          var i = o.parent;
          var r = parseInt(t.getAttribute("rowspan") || 1);
          var s = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _UN = UN(s, e),
                _o204 = _UN.newCellsSpan,
                _i168 = _UN.updatedSpan;
              vI("colspan", _i168, t, n);
              var _a30 = {};
              if (_o204 > 1) {
                _a30.colspan = _o204;
              }
              if (r > 1) {
                _a30.rowspan = r;
              }
              var _c20 = s > e ? e - 1 : s - 1;
              VN(_c20, n, n.createPositionAfter(t), _a30);
            }
            if (s < e) {
              var _o205 = e - s;
              var _a31 = _toConsumableArray(new TI(i));
              var _a31$find = _a31.find(function (_ref58) {
                  var e = _ref58.cell;
                  return e === t;
                }),
                _c21 = _a31$find.column;
              var _l13 = _a31.filter(function (_ref59) {
                var e = _ref59.cell,
                  n = _ref59.cellWidth,
                  o = _ref59.column;
                var i = e !== t && o === _c21;
                var r = o < _c21 && o + n > _c21;
                return i || r;
              });
              var _iterator423 = _createForOfIteratorHelper(_l13),
                _step423;
              try {
                for (_iterator423.s(); !(_step423 = _iterator423.n()).done;) {
                  var _step423$value = _step423.value,
                    _t364 = _step423$value.cell,
                    _e319 = _step423$value.cellWidth;
                  n.setAttribute("colspan", _e319 + _o205, _t364);
                }
              } catch (err) {
                _iterator423.e(err);
              } finally {
                _iterator423.f();
              }
              var _d7 = {};
              if (r > 1) {
                _d7.rowspan = r;
              }
              VN(_o205, n, n.createPositionAfter(t), _d7);
              var _u5 = i.getAttribute("headingColumns") || 0;
              if (_u5 > _c21) {
                vI("headingColumns", _u5 + _o205, i, n);
              }
            }
          });
        }
      }, {
        key: "splitCellHorizontally",
        value: function splitCellHorizontally(t) {
          var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
          var n = this.editor.model;
          var o = t.parent;
          var i = o.parent;
          var r = i.getChildIndex(o);
          var s = parseInt(t.getAttribute("rowspan") || 1);
          var a = parseInt(t.getAttribute("colspan") || 1);
          n.change(function (n) {
            if (s > 1) {
              var _o206 = _toConsumableArray(new TI(i, {
                startRow: r,
                endRow: r + s - 1,
                includeAllSlots: true
              }));
              var _UN2 = UN(s, e),
                _c22 = _UN2.newCellsSpan,
                _l14 = _UN2.updatedSpan;
              vI("rowspan", _l14, t, n);
              var _o206$find = _o206.find(function (_ref60) {
                  var e = _ref60.cell;
                  return e === t;
                }),
                _d8 = _o206$find.column;
              var _u6 = {};
              if (_c22 > 1) {
                _u6.rowspan = _c22;
              }
              if (a > 1) {
                _u6.colspan = a;
              }
              var _iterator424 = _createForOfIteratorHelper(_o206),
                _step424;
              try {
                for (_iterator424.s(); !(_step424 = _iterator424.n()).done;) {
                  var _t365 = _step424.value;
                  var _e320 = _t365.column,
                    _o207 = _t365.row;
                  var _i169 = _o207 >= r + _l14;
                  var _s45 = _e320 === _d8;
                  var _a32 = (_o207 + r + _l14) % _c22 === 0;
                  if (_i169 && _s45 && _a32) {
                    VN(1, n, _t365.getPositionBefore(), _u6);
                  }
                }
              } catch (err) {
                _iterator424.e(err);
              } finally {
                _iterator424.f();
              }
            }
            if (s < e) {
              var _o208 = e - s;
              var _c23 = _toConsumableArray(new TI(i, {
                startRow: 0,
                endRow: r
              }));
              var _iterator425 = _createForOfIteratorHelper(_c23),
                _step425;
              try {
                for (_iterator425.s(); !(_step425 = _iterator425.n()).done;) {
                  var _step425$value = _step425.value,
                    _e321 = _step425$value.cell,
                    _i170 = _step425$value.cellHeight,
                    _s46 = _step425$value.row;
                  if (_e321 !== t && _s46 + _i170 > r) {
                    var _t366 = _i170 + _o208;
                    n.setAttribute("rowspan", _t366, _e321);
                  }
                }
              } catch (err) {
                _iterator425.e(err);
              } finally {
                _iterator425.f();
              }
              var _l15 = {};
              if (a > 1) {
                _l15.colspan = a;
              }
              FN(n, i, r + 1, _o208, 1, _l15);
              var _d9 = i.getAttribute("headingRows") || 0;
              if (_d9 > r) {
                vI("headingRows", _d9 + _o208, i, n);
              }
            }
          });
        }
      }, {
        key: "getColumns",
        value: function getColumns(t) {
          var e = t.getChild(0);
          return _toConsumableArray(e.getChildren()).reduce(function (t, e) {
            var n = parseInt(e.getAttribute("colspan") || 1);
            return t + n;
          }, 0);
        }
      }, {
        key: "getRows",
        value: function getRows(t) {
          return t.childCount;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableUtils";
        }
      }]);
      return jN;
    }(aC);
    function FN(t, e, n, o, i) {
      var r = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      for (var _s47 = 0; _s47 < o; _s47++) {
        var _o209 = t.createElement("tableRow");
        t.insert(_o209, e, n);
        VN(i, t, t.createPositionAt(_o209, "end"), r);
      }
    }
    function VN(t, e, n) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      for (var _i171 = 0; _i171 < t; _i171++) {
        yI(e, n, o);
      }
    }
    function UN(t, e) {
      if (t < e) {
        return {
          newCellsSpan: 1,
          updatedSpan: 1
        };
      }
      var n = Math.floor(t / e);
      var o = t - n * e + n;
      return {
        newCellsSpan: n,
        updatedSpan: o
      };
    }
    function HN(t, e, n) {
      var o = t.getAttribute("headingColumns") || 0;
      if (o && e.first < o) {
        var _i172 = Math.min(o - 1, e.last) - e.first + 1;
        n.setAttribute("headingColumns", o - _i172, t);
      }
    }
    function GN(t, e, n, o) {
      var i = t.getAttribute("headingRows") || 0;
      if (e < i) {
        var _r72 = n < i ? i - (n - e + 1) : e;
        vI("headingRows", _r72, t, o, 0);
      }
    }
    function WN(t, e, n) {
      var o = new Map();
      var i = [];
      var _iterator426 = _createForOfIteratorHelper(new TI(t, {
          endRow: n
        })),
        _step426;
      try {
        for (_iterator426.s(); !(_step426 = _iterator426.n()).done;) {
          var _step426$value = _step426.value,
            _r73 = _step426$value.row,
            _s48 = _step426$value.column,
            _a33 = _step426$value.cellHeight,
            _c24 = _step426$value.cell;
          var _t367 = _r73 + _a33 - 1;
          var _l16 = _r73 >= e && _r73 <= n && _t367 > n;
          if (_l16) {
            var _t368 = n - _r73 + 1;
            var _e322 = _a33 - _t368;
            o.set(_s48, {
              cell: _c24,
              rowspan: _e322
            });
          }
          var _d10 = _r73 < e && _t367 >= e;
          if (_d10) {
            var _o210 = void 0;
            if (_t367 >= n) {
              _o210 = n - e + 1;
            } else {
              _o210 = _t367 - e + 1;
            }
            i.push({
              cell: _c24,
              rowspan: _a33 - _o210
            });
          }
        }
      } catch (err) {
        _iterator426.e(err);
      } finally {
        _iterator426.f();
      }
      return {
        cellsToMove: o,
        cellsToTrim: i
      };
    }
    function KN(t, e, n, o) {
      var i = new TI(t, {
        includeAllSlots: true,
        row: e
      });
      var r = _toConsumableArray(i);
      var s = t.getChild(e);
      var a;
      var _iterator427 = _createForOfIteratorHelper(r),
        _step427;
      try {
        for (_iterator427.s(); !(_step427 = _iterator427.n()).done;) {
          var _step427$value = _step427.value,
            _t369 = _step427$value.column,
            _e323 = _step427$value.cell,
            _i173 = _step427$value.isAnchor;
          if (n.has(_t369)) {
            var _n$get = n.get(_t369),
              _e324 = _n$get.cell,
              _i174 = _n$get.rowspan;
            var _r74 = a ? o.createPositionAfter(a) : o.createPositionAt(s, 0);
            o.move(o.createRangeOn(_e324), _r74);
            vI("rowspan", _i174, _e324, o);
            a = _e324;
          } else if (_i173) {
            a = _e323;
          }
        }
      } catch (err) {
        _iterator427.e(err);
      } finally {
        _iterator427.f();
      }
    }
    var qN = /*#__PURE__*/function (_uC33) {
      _inherits(qN, _uC33);
      function qN() {
        _classCallCheck(this, qN);
        return _possibleConstructorReturn(this, _getPrototypeOf(qN).apply(this, arguments));
      }
      _createClass(qN, [{
        key: "refresh",
        value: function refresh() {
          var t = tN(this.editor.model.document.selection);
          this.isEnabled = rN(t, this.editor.plugins.get(jN));
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model;
          var e = this.editor.plugins.get(jN);
          t.change(function (n) {
            var o = tN(t.document.selection);
            var i = o.shift();
            var _$N = $N(i, o, e),
              r = _$N.mergeWidth,
              s = _$N.mergeHeight;
            vI("colspan", r, i, n);
            vI("rowspan", s, i, n);
            var _iterator428 = _createForOfIteratorHelper(o),
              _step428;
            try {
              for (_iterator428.s(); !(_step428 = _iterator428.n()).done;) {
                var _t370 = _step428.value;
                YN(_t370, i, n);
              }
            } catch (err) {
              _iterator428.e(err);
            } finally {
              _iterator428.f();
            }
            var a = i.findAncestor("table");
            yN(a, e);
            n.setSelection(i, "in");
          });
        }
      }]);
      return qN;
    }(uC);
    function YN(t, e, n) {
      if (!QN(t)) {
        if (QN(e)) {
          n.remove(n.createRangeIn(e));
        }
        n.move(n.createRangeIn(t), n.createPositionAt(e, "end"));
      }
      n.remove(t);
    }
    function QN(t) {
      return t.childCount == 1 && t.getChild(0).is("element", "paragraph") && t.getChild(0).isEmpty;
    }
    function $N(t, e, n) {
      var o = 0;
      var i = 0;
      var _iterator429 = _createForOfIteratorHelper(e),
        _step429;
      try {
        for (_iterator429.s(); !(_step429 = _iterator429.n()).done;) {
          var _t371 = _step429.value;
          var _n$getCellLocation4 = n.getCellLocation(_t371),
            _e325 = _n$getCellLocation4.row,
            _r75 = _n$getCellLocation4.column;
          o = ZN(_t371, _r75, o, "colspan");
          i = ZN(_t371, _e325, i, "rowspan");
        }
      } catch (err) {
        _iterator429.e(err);
      } finally {
        _iterator429.f();
      }
      var _n$getCellLocation3 = n.getCellLocation(t),
        r = _n$getCellLocation3.row,
        s = _n$getCellLocation3.column;
      var a = o - s;
      var c = i - r;
      return {
        mergeWidth: a,
        mergeHeight: c
      };
    }
    function ZN(t, e, n, o) {
      var i = parseInt(t.getAttribute(o) || 1);
      return Math.max(n, e + i);
    }
    var JN = /*#__PURE__*/function (_uC34) {
      _inherits(JN, _uC34);
      function JN() {
        _classCallCheck(this, JN);
        return _possibleConstructorReturn(this, _getPrototypeOf(JN).apply(this, arguments));
      }
      _createClass(JN, [{
        key: "refresh",
        value: function refresh() {
          var t = nN(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model;
          var e = nN(t.document.selection);
          var n = oN(e);
          var o = e[0].findAncestor("table");
          var i = [];
          for (var _e326 = n.first; _e326 <= n.last; _e326++) {
            var _iterator430 = _createForOfIteratorHelper(o.getChild(_e326).getChildren()),
              _step430;
            try {
              for (_iterator430.s(); !(_step430 = _iterator430.n()).done;) {
                var _n293 = _step430.value;
                i.push(t.createRangeOn(_n293));
              }
            } catch (err) {
              _iterator430.e(err);
            } finally {
              _iterator430.f();
            }
          }
          t.change(function (t) {
            t.setSelection(i);
          });
        }
      }]);
      return JN;
    }(uC);
    var XN = /*#__PURE__*/function (_uC35) {
      _inherits(XN, _uC35);
      function XN() {
        _classCallCheck(this, XN);
        return _possibleConstructorReturn(this, _getPrototypeOf(XN).apply(this, arguments));
      }
      _createClass(XN, [{
        key: "refresh",
        value: function refresh() {
          var t = nN(this.editor.model.document.selection);
          this.isEnabled = t.length > 0;
        }
      }, {
        key: "execute",
        value: function execute() {
          var t = this.editor.model;
          var e = nN(t.document.selection);
          var n = e[0];
          var o = e.pop();
          var i = n.findAncestor("table");
          var r = this.editor.plugins.get("TableUtils");
          var s = r.getCellLocation(n);
          var a = r.getCellLocation(o);
          var c = Math.min(s.column, a.column);
          var l = Math.max(s.column, a.column);
          var d = [];
          var _iterator431 = _createForOfIteratorHelper(new TI(i, {
              startColumn: c,
              endColumn: l
            })),
            _step431;
          try {
            for (_iterator431.s(); !(_step431 = _iterator431.n()).done;) {
              var _e327 = _step431.value;
              d.push(t.createRangeOn(_e327.cell));
            }
          } catch (err) {
            _iterator431.e(err);
          } finally {
            _iterator431.f();
          }
          t.change(function (t) {
            t.setSelection(d);
          });
        }
      }]);
      return XN;
    }(uC);
    function tP(t) {
      t.document.registerPostFixer(function (e) {
        return eP(e, t);
      });
    }
    function eP(t, e) {
      var n = e.document.differ.getChanges();
      var o = false;
      var i = new Set();
      var _iterator432 = _createForOfIteratorHelper(n),
        _step432;
      try {
        for (_iterator432.s(); !(_step432 = _iterator432.n()).done;) {
          var _e328 = _step432.value;
          var _n294 = void 0;
          if (_e328.name == "table" && _e328.type == "insert") {
            _n294 = _e328.position.nodeAfter;
          }
          if (_e328.name == "tableRow" || _e328.name == "tableCell") {
            _n294 = _e328.position.findAncestor("table");
          }
          if (sP(_e328)) {
            _n294 = _e328.range.start.findAncestor("table");
          }
          if (_n294 && !i.has(_n294)) {
            o = nP(_n294, t) || o;
            o = oP(_n294, t) || o;
            i.add(_n294);
          }
        }
      } catch (err) {
        _iterator432.e(err);
      } finally {
        _iterator432.f();
      }
      return o;
    }
    function nP(t, e) {
      var n = false;
      var o = iP(t);
      if (o.length) {
        n = true;
        var _iterator433 = _createForOfIteratorHelper(o),
          _step433;
        try {
          for (_iterator433.s(); !(_step433 = _iterator433.n()).done;) {
            var _t372 = _step433.value;
            vI("rowspan", _t372.rowspan, _t372.cell, e, 1);
          }
        } catch (err) {
          _iterator433.e(err);
        } finally {
          _iterator433.f();
        }
      }
      return n;
    }
    function oP(t, e) {
      var n = false;
      var o = rP(t);
      var i = [];
      var _iterator434 = _createForOfIteratorHelper(o.entries()),
        _step434;
      try {
        for (_iterator434.s(); !(_step434 = _iterator434.n()).done;) {
          var _step434$value = _slicedToArray(_step434.value, 2),
            _t373 = _step434$value[0],
            _e329 = _step434$value[1];
          if (!_e329) {
            i.push(_t373);
          }
        }
      } catch (err) {
        _iterator434.e(err);
      } finally {
        _iterator434.f();
      }
      if (i.length) {
        n = true;
        var _iterator435 = _createForOfIteratorHelper(i.reverse()),
          _step435;
        try {
          for (_iterator435.s(); !(_step435 = _iterator435.n()).done;) {
            var _n295 = _step435.value;
            e.remove(t.getChild(_n295));
            o.splice(_n295, 1);
          }
        } catch (err) {
          _iterator435.e(err);
        } finally {
          _iterator435.f();
        }
      }
      var r = o[0];
      var s = o.every(function (t) {
        return t === r;
      });
      if (!s) {
        var _i175 = o.reduce(function (t, e) {
          return e > t ? e : t;
        }, 0);
        var _iterator436 = _createForOfIteratorHelper(o.entries()),
          _step436;
        try {
          for (_iterator436.s(); !(_step436 = _iterator436.n()).done;) {
            var _step436$value = _slicedToArray(_step436.value, 2),
              _r76 = _step436$value[0],
              _s49 = _step436$value[1];
            var _o211 = _i175 - _s49;
            if (_o211) {
              for (var _n296 = 0; _n296 < _o211; _n296++) {
                yI(e, e.createPositionAt(t.getChild(_r76), "end"));
              }
              n = true;
            }
          }
        } catch (err) {
          _iterator436.e(err);
        } finally {
          _iterator436.f();
        }
      }
      return n;
    }
    function iP(t) {
      var e = parseInt(t.getAttribute("headingRows") || 0);
      var n = t.childCount;
      var o = [];
      var _iterator437 = _createForOfIteratorHelper(new TI(t)),
        _step437;
      try {
        for (_iterator437.s(); !(_step437 = _iterator437.n()).done;) {
          var _step437$value = _step437.value,
            _i176 = _step437$value.row,
            _r77 = _step437$value.cell,
            _s50 = _step437$value.cellHeight;
          if (_s50 < 2) {
            continue;
          }
          var _t374 = _i176 < e;
          var _a34 = _t374 ? e : n;
          if (_i176 + _s50 > _a34) {
            var _t375 = _a34 - _i176;
            o.push({
              cell: _r77,
              rowspan: _t375
            });
          }
        }
      } catch (err) {
        _iterator437.e(err);
      } finally {
        _iterator437.f();
      }
      return o;
    }
    function rP(t) {
      var e = new Array(t.childCount).fill(0);
      var _iterator438 = _createForOfIteratorHelper(new TI(t, {
          includeAllSlots: true
        })),
        _step438;
      try {
        for (_iterator438.s(); !(_step438 = _iterator438.n()).done;) {
          var _n297 = _step438.value.row;
          e[_n297]++;
        }
      } catch (err) {
        _iterator438.e(err);
      } finally {
        _iterator438.f();
      }
      return e;
    }
    function sP(t) {
      var e = t.type === "attribute";
      var n = t.attributeKey;
      return e && (n === "headingRows" || n === "colspan" || n === "rowspan");
    }
    function aP(t) {
      t.document.registerPostFixer(function (e) {
        return cP(e, t);
      });
    }
    function cP(t, e) {
      var n = e.document.differ.getChanges();
      var o = false;
      var _iterator439 = _createForOfIteratorHelper(n),
        _step439;
      try {
        for (_iterator439.s(); !(_step439 = _iterator439.n()).done;) {
          var _e330 = _step439.value;
          if (_e330.type == "insert" && _e330.name == "table") {
            o = lP(_e330.position.nodeAfter, t) || o;
          }
          if (_e330.type == "insert" && _e330.name == "tableRow") {
            o = dP(_e330.position.nodeAfter, t) || o;
          }
          if (_e330.type == "insert" && _e330.name == "tableCell") {
            o = uP(_e330.position.nodeAfter, t) || o;
          }
          if (hP(_e330)) {
            o = uP(_e330.position.parent, t) || o;
          }
        }
      } catch (err) {
        _iterator439.e(err);
      } finally {
        _iterator439.f();
      }
      return o;
    }
    function lP(t, e) {
      var n = false;
      var _iterator440 = _createForOfIteratorHelper(t.getChildren()),
        _step440;
      try {
        for (_iterator440.s(); !(_step440 = _iterator440.n()).done;) {
          var _o212 = _step440.value;
          n = dP(_o212, e) || n;
        }
      } catch (err) {
        _iterator440.e(err);
      } finally {
        _iterator440.f();
      }
      return n;
    }
    function dP(t, e) {
      var n = false;
      var _iterator441 = _createForOfIteratorHelper(t.getChildren()),
        _step441;
      try {
        for (_iterator441.s(); !(_step441 = _iterator441.n()).done;) {
          var _o213 = _step441.value;
          n = uP(_o213, e) || n;
        }
      } catch (err) {
        _iterator441.e(err);
      } finally {
        _iterator441.f();
      }
      return n;
    }
    function uP(t, e) {
      if (t.childCount == 0) {
        e.insertElement("paragraph", t);
        return true;
      }
      var n = Array.from(t.getChildren()).filter(function (t) {
        return t.is("$text");
      });
      var _iterator442 = _createForOfIteratorHelper(n),
        _step442;
      try {
        for (_iterator442.s(); !(_step442 = _iterator442.n()).done;) {
          var _t376 = _step442.value;
          e.wrap(e.createRangeOn(_t376), "paragraph");
        }
      } catch (err) {
        _iterator442.e(err);
      } finally {
        _iterator442.f();
      }
      return !!n.length;
    }
    function hP(t) {
      if (!t.position || !t.position.parent.is("element", "tableCell")) {
        return false;
      }
      return t.type == "insert" && t.name == "$text" || t.type == "remove";
    }
    function fP(t, e) {
      t.document.registerPostFixer(function () {
        return mP(t.document.differ, e);
      });
    }
    function mP(t, e) {
      var n = new Set();
      var _iterator443 = _createForOfIteratorHelper(t.getChanges()),
        _step443;
      try {
        for (_iterator443.s(); !(_step443 = _iterator443.n()).done;) {
          var _e331 = _step443.value;
          var _t377 = _e331.type == "attribute" ? _e331.range.start.parent : _e331.position.parent;
          if (_t377.is("element", "tableCell")) {
            n.add(_t377);
          }
        }
      } catch (err) {
        _iterator443.e(err);
      } finally {
        _iterator443.f();
      }
      var _iterator444 = _createForOfIteratorHelper(n.values()),
        _step444;
      try {
        for (_iterator444.s(); !(_step444 = _iterator444.n()).done;) {
          var _o214 = _step444.value;
          var _iterator445 = _createForOfIteratorHelper(_toConsumableArray(_o214.getChildren()).filter(function (t) {
              return gP(t, e);
            })),
            _step445;
          try {
            for (_iterator445.s(); !(_step445 = _iterator445.n()).done;) {
              var _n298 = _step445.value;
              t.refreshItem(_n298);
            }
          } catch (err) {
            _iterator445.e(err);
          } finally {
            _iterator445.f();
          }
        }
      } catch (err) {
        _iterator444.e(err);
      } finally {
        _iterator444.f();
      }
      return false;
    }
    function gP(t, e) {
      if (!t.is("element", "paragraph")) {
        return false;
      }
      var n = e.toViewElement(t);
      if (!n) {
        return false;
      }
      return RI(t) !== n.is("element", "span");
    }
    function pP(t) {
      t.document.registerPostFixer(function () {
        return kP(t);
      });
    }
    function kP(t) {
      var e = t.document.differ;
      var n = new Set();
      var _iterator446 = _createForOfIteratorHelper(e.getChanges()),
        _step446;
      try {
        for (_iterator446.s(); !(_step446 = _iterator446.n()).done;) {
          var _t379 = _step446.value;
          if (_t379.type != "attribute") {
            continue;
          }
          var _e332 = _t379.range.start.nodeAfter;
          if (_e332 && _e332.is("element", "table") && _t379.attributeKey == "headingRows") {
            n.add(_e332);
          }
        }
      } catch (err) {
        _iterator446.e(err);
      } finally {
        _iterator446.f();
      }
      if (n.size) {
        var _iterator447 = _createForOfIteratorHelper(n.values()),
          _step447;
        try {
          for (_iterator447.s(); !(_step447 = _iterator447.n()).done;) {
            var _t378 = _step447.value;
            e.refreshItem(_t378);
          }
        } catch (err) {
          _iterator447.e(err);
        } finally {
          _iterator447.f();
        }
        return true;
      }
      return false;
    }
    var bP = n(52);
    var wP = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    wP.insert = "head";
    wP.singleton = true;
    var CP = rk()(bP["a"], wP);
    var AP = bP["a"].locals || {};
    var _P = /*#__PURE__*/function (_aC75) {
      _inherits(_P, _aC75);
      function _P() {
        _classCallCheck(this, _P);
        return _possibleConstructorReturn(this, _getPrototypeOf(_P).apply(this, arguments));
      }
      _createClass(_P, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          var e = t.model;
          var n = e.schema;
          var o = t.conversion;
          n.register("table", {
            allowWhere: "$block",
            allowAttributes: ["headingRows", "headingColumns"],
            isObject: true,
            isBlock: true
          });
          n.register("tableRow", {
            allowIn: "table",
            isLimit: true
          });
          n.register("tableCell", {
            allowIn: "tableRow",
            allowAttributes: ["colspan", "rowspan"],
            isLimit: true,
            isSelectable: true
          });
          n.extend("$block", {
            allowIn: "tableCell"
          });
          n.addChildCheck(function (t, e) {
            if (e.name == "table" && Array.from(t.getNames()).includes("table")) {
              return false;
            }
          });
          o.for("upcast").add(DI());
          o.for("editingDowncast").add(NI({
            asWidget: true
          }));
          o.for("dataDowncast").add(NI());
          o.for("upcast").elementToElement({
            model: "tableRow",
            view: "tr"
          });
          o.for("upcast").add(EI());
          o.for("editingDowncast").add(PI());
          o.for("editingDowncast").add(LI());
          o.for("upcast").elementToElement({
            model: "tableCell",
            view: "td"
          });
          o.for("upcast").elementToElement({
            model: "tableCell",
            view: "th"
          });
          o.for("editingDowncast").add(BI());
          t.conversion.for("editingDowncast").elementToElement({
            model: "paragraph",
            view: OI,
            converterPriority: "high"
          });
          o.attributeToAttribute({
            model: "colspan",
            view: "colspan"
          });
          o.attributeToAttribute({
            model: "rowspan",
            view: "rowspan"
          });
          o.for("editingDowncast").add(zI());
          t.commands.add("insertTable", new JI(t));
          t.commands.add("insertTableRowAbove", new hN(t, {
            order: "above"
          }));
          t.commands.add("insertTableRowBelow", new hN(t, {
            order: "below"
          }));
          t.commands.add("insertTableColumnLeft", new fN(t, {
            order: "left"
          }));
          t.commands.add("insertTableColumnRight", new fN(t, {
            order: "right"
          }));
          t.commands.add("removeTableRow", new NN(t));
          t.commands.add("removeTableColumn", new BN(t));
          t.commands.add("splitTableCellVertically", new mN(t, {
            direction: "vertically"
          }));
          t.commands.add("splitTableCellHorizontally", new mN(t, {
            direction: "horizontally"
          }));
          t.commands.add("mergeTableCells", new qN(t));
          t.commands.add("mergeTableCellRight", new EN(t, {
            direction: "right"
          }));
          t.commands.add("mergeTableCellLeft", new EN(t, {
            direction: "left"
          }));
          t.commands.add("mergeTableCellDown", new EN(t, {
            direction: "down"
          }));
          t.commands.add("mergeTableCellUp", new EN(t, {
            direction: "up"
          }));
          t.commands.add("setTableColumnHeader", new RN(t));
          t.commands.add("setTableRowHeader", new ON(t));
          t.commands.add("selectTableRow", new JN(t));
          t.commands.add("selectTableColumn", new XN(t));
          pP(e);
          tP(e);
          fP(e, t.editing.mapper);
          aP(e);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [jN];
        }
      }]);
      return _P;
    }(aC);
    var vP = n(53);
    var yP = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    yP.insert = "head";
    yP.singleton = true;
    var xP = rk()(vP["a"], yP);
    var DP = vP["a"].locals || {};
    var EP = /*#__PURE__*/function (_tb29) {
      _inherits(EP, _tb29);
      function EP(t) {
        var _this276;
        _classCallCheck(this, EP);
        _this276 = _possibleConstructorReturn(this, _getPrototypeOf(EP).call(this, t));
        var e = _this276.bindTemplate;
        _this276.set("icon");
        _this276.set("isEnabled", true);
        _this276.set("isOn", false);
        _this276.set("isToggleable", false);
        _this276.set("isVisible", true);
        _this276.set("keystroke");
        _this276.set("label");
        _this276.set("tabindex", -1);
        _this276.set("tooltip");
        _this276.set("tooltipPosition", "s");
        _this276.set("type", "button");
        _this276.set("withText", false);
        _this276.children = _this276.createCollection();
        _this276.actionView = _this276._createActionView();
        _this276.arrowView = _this276._createArrowView();
        _this276.keystrokes = new Vp();
        _this276.focusTracker = new tk();
        _this276.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck", "ck-splitbutton", e.if("isVisible", "ck-hidden", function (t) {
              return !t;
            }), _this276.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")]
          },
          children: _this276.children
        });
        return _this276;
      }
      _createClass(EP, [{
        key: "render",
        value: function render() {
          var _this277 = this;
          _get(_getPrototypeOf(EP.prototype), "render", this).call(this);
          this.children.add(this.actionView);
          this.children.add(this.arrowView);
          this.focusTracker.add(this.actionView.element);
          this.focusTracker.add(this.arrowView.element);
          this.keystrokes.listenTo(this.element);
          this.keystrokes.set("arrowright", function (t, e) {
            if (_this277.focusTracker.focusedElement === _this277.actionView.element) {
              _this277.arrowView.focus();
              e();
            }
          });
          this.keystrokes.set("arrowleft", function (t, e) {
            if (_this277.focusTracker.focusedElement === _this277.arrowView.element) {
              _this277.actionView.focus();
              e();
            }
          });
        }
      }, {
        key: "focus",
        value: function focus() {
          this.actionView.focus();
        }
      }, {
        key: "_createActionView",
        value: function _createActionView() {
          var t = new cw();
          t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this);
          t.extendTemplate({
            attributes: {
              class: "ck-splitbutton__action"
            }
          });
          t.delegate("execute").to(this);
          return t;
        }
      }, {
        key: "_createArrowView",
        value: function _createArrowView() {
          var t = new cw();
          var e = t.bindTemplate;
          t.icon = lw;
          t.extendTemplate({
            attributes: {
              class: "ck-splitbutton__arrow",
              "aria-haspopup": true,
              "aria-expanded": e.to("isOn", function (t) {
                return String(t);
              })
            }
          });
          t.bind("isEnabled").to(this);
          t.delegate("execute").to(this, "open");
          return t;
        }
      }]);
      return EP;
    }(tb);
    var MP = n(54);
    var SP = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    SP.insert = "head";
    SP.singleton = true;
    var TP = rk()(MP["a"], SP);
    var IP = MP["a"].locals || {};
    var NP = /*#__PURE__*/function (_tb30) {
      _inherits(NP, _tb30);
      function NP(t) {
        var _this278;
        _classCallCheck(this, NP);
        _this278 = _possibleConstructorReturn(this, _getPrototypeOf(NP).call(this, t));
        var e = _this278.bindTemplate;
        _this278.items = _this278._createGridCollection();
        _this278.set("rows", 0);
        _this278.set("columns", 0);
        _this278.bind("label").to(_assertThisInitialized(_assertThisInitialized(_this278)), "columns", _assertThisInitialized(_assertThisInitialized(_this278)), "rows", function (t, e) {
          return "".concat(e, " \xD7 ").concat(t);
        });
        _this278.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck"]
          },
          children: [{
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__grid"]
            },
            on: {
              "mouseover@.ck-insert-table-dropdown-grid-box": e.to("boxover")
            },
            children: _this278.items
          }, {
            tag: "div",
            attributes: {
              class: ["ck-insert-table-dropdown__label"]
            },
            children: [{
              text: e.to("label")
            }]
          }],
          on: {
            mousedown: e.to(function (t) {
              t.preventDefault();
            }),
            click: e.to(function () {
              _this278.fire("execute");
            })
          }
        });
        _this278.on("boxover", function (t, e) {
          var _e$target$dataset = e.target.dataset,
            n = _e$target$dataset.row,
            o = _e$target$dataset.column;
          _this278.set({
            rows: parseInt(n),
            columns: parseInt(o)
          });
        });
        _this278.on("change:columns", function () {
          _this278._highlightGridBoxes();
        });
        _this278.on("change:rows", function () {
          _this278._highlightGridBoxes();
        });
        return _this278;
      }
      _createClass(NP, [{
        key: "focus",
        value: function focus() {}
      }, {
        key: "focusLast",
        value: function focusLast() {}
      }, {
        key: "_highlightGridBoxes",
        value: function _highlightGridBoxes() {
          var t = this.rows;
          var e = this.columns;
          this.items.map(function (n, o) {
            var i = Math.floor(o / 10);
            var r = o % 10;
            var s = i < t && r < e;
            n.set("isOn", s);
          });
        }
      }, {
        key: "_createGridCollection",
        value: function _createGridCollection() {
          var t = [];
          for (var _e333 = 0; _e333 < 100; _e333++) {
            var _n299 = Math.floor(_e333 / 10);
            var _o215 = _e333 % 10;
            t.push(new PP(this.locale, _n299 + 1, _o215 + 1));
          }
          return this.createCollection(t);
        }
      }]);
      return NP;
    }(tb);
    var PP = /*#__PURE__*/function (_tb31) {
      _inherits(PP, _tb31);
      function PP(t, e, n) {
        var _this279;
        _classCallCheck(this, PP);
        _this279 = _possibleConstructorReturn(this, _getPrototypeOf(PP).call(this, t));
        var o = _this279.bindTemplate;
        _this279.set("isOn", false);
        _this279.setTemplate({
          tag: "div",
          attributes: {
            class: ["ck-insert-table-dropdown-grid-box", o.if("isOn", "ck-on")],
            "data-row": e,
            "data-column": n
          }
        });
        return _this279;
      }
      return PP;
    }(tb);
    var BP = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>';
    var zP = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>';
    var LP = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>';
    var OP = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>';
    var RP = /*#__PURE__*/function (_aC76) {
      _inherits(RP, _aC76);
      function RP() {
        _classCallCheck(this, RP);
        return _possibleConstructorReturn(this, _getPrototypeOf(RP).apply(this, arguments));
      }
      _createClass(RP, [{
        key: "init",
        value: function init() {
          var _this280 = this;
          var t = this.editor;
          var e = this.editor.t;
          var n = t.locale.contentLanguageDirection;
          var o = n === "ltr";
          t.ui.componentFactory.add("insertTable", function (n) {
            var o = t.commands.get("insertTable");
            var i = Nw(n);
            i.bind("isEnabled").to(o);
            i.buttonView.set({
              icon: BP,
              label: e("Insert table"),
              tooltip: true
            });
            var r;
            i.on("change:isOpen", function () {
              if (r) {
                return;
              }
              r = new NP(n);
              i.panelView.children.add(r);
              r.delegate("execute").to(i);
              i.buttonView.on("open", function () {
                r.rows = 0;
                r.columns = 0;
              });
              i.on("execute", function () {
                t.execute("insertTable", {
                  rows: r.rows,
                  columns: r.columns
                });
                t.editing.view.focus();
              });
            });
            return i;
          });
          t.ui.componentFactory.add("tableColumn", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableColumnHeader",
                label: e("Header column"),
                bindIsOn: true
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: o ? "insertTableColumnLeft" : "insertTableColumnRight",
                label: e("Insert column left")
              }
            }, {
              type: "button",
              model: {
                commandName: o ? "insertTableColumnRight" : "insertTableColumnLeft",
                label: e("Insert column right")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableColumn",
                label: e("Delete column")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableColumn",
                label: e("Select column")
              }
            }];
            return _this280._prepareDropdown(e("Column"), zP, n, t);
          });
          t.ui.componentFactory.add("tableRow", function (t) {
            var n = [{
              type: "switchbutton",
              model: {
                commandName: "setTableRowHeader",
                label: e("Header row"),
                bindIsOn: true
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowAbove",
                label: e("Insert row above")
              }
            }, {
              type: "button",
              model: {
                commandName: "insertTableRowBelow",
                label: e("Insert row below")
              }
            }, {
              type: "button",
              model: {
                commandName: "removeTableRow",
                label: e("Delete row")
              }
            }, {
              type: "button",
              model: {
                commandName: "selectTableRow",
                label: e("Select row")
              }
            }];
            return _this280._prepareDropdown(e("Row"), LP, n, t);
          });
          t.ui.componentFactory.add("mergeTableCells", function (t) {
            var n = [{
              type: "button",
              model: {
                commandName: "mergeTableCellUp",
                label: e("Merge cell up")
              }
            }, {
              type: "button",
              model: {
                commandName: o ? "mergeTableCellRight" : "mergeTableCellLeft",
                label: e("Merge cell right")
              }
            }, {
              type: "button",
              model: {
                commandName: "mergeTableCellDown",
                label: e("Merge cell down")
              }
            }, {
              type: "button",
              model: {
                commandName: o ? "mergeTableCellLeft" : "mergeTableCellRight",
                label: e("Merge cell left")
              }
            }, {
              type: "separator"
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellVertically",
                label: e("Split cell vertically")
              }
            }, {
              type: "button",
              model: {
                commandName: "splitTableCellHorizontally",
                label: e("Split cell horizontally")
              }
            }];
            return _this280._prepareMergeSplitButtonDropdown(e("Merge cells"), OP, n, t);
          });
        }
      }, {
        key: "_prepareDropdown",
        value: function _prepareDropdown(t, e, n, o) {
          var i = this.editor;
          var r = Nw(o);
          var s = this._fillDropdownWithListOptions(r, n);
          r.buttonView.set({
            label: t,
            icon: e,
            tooltip: true
          });
          r.bind("isEnabled").toMany(s, "isEnabled", function () {
            for (var _len20 = arguments.length, t = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
              t[_key20] = arguments[_key20];
            }
            return t.some(function (t) {
              return t;
            });
          });
          this.listenTo(r, "execute", function (t) {
            i.execute(t.source.commandName);
            i.editing.view.focus();
          });
          return r;
        }
      }, {
        key: "_prepareMergeSplitButtonDropdown",
        value: function _prepareMergeSplitButtonDropdown(t, e, n, o) {
          var i = this.editor;
          var r = Nw(o, EP);
          var s = "mergeTableCells";
          this._fillDropdownWithListOptions(r, n);
          r.buttonView.set({
            label: t,
            icon: e,
            tooltip: true,
            isEnabled: true
          });
          this.listenTo(r.buttonView, "execute", function () {
            i.execute(s);
            i.editing.view.focus();
          });
          this.listenTo(r, "execute", function (t) {
            i.execute(t.source.commandName);
            i.editing.view.focus();
          });
          return r;
        }
      }, {
        key: "_fillDropdownWithListOptions",
        value: function _fillDropdownWithListOptions(t, e) {
          var n = this.editor;
          var o = [];
          var i = new vs();
          var _iterator448 = _createForOfIteratorHelper(e),
            _step448;
          try {
            for (_iterator448.s(); !(_step448 = _iterator448.n()).done;) {
              var _t380 = _step448.value;
              jP(_t380, n, o, i);
            }
          } catch (err) {
            _iterator448.e(err);
          } finally {
            _iterator448.f();
          }
          Bw(t, i, n.ui.componentFactory);
          return o;
        }
      }]);
      return RP;
    }(aC);
    function jP(t, e, n, o) {
      var i = t.model = new Jy(t.model);
      var _t$model2 = t.model,
        r = _t$model2.commandName,
        s = _t$model2.bindIsOn;
      if (t.type === "button" || t.type === "switchbutton") {
        var _t381 = e.commands.get(r);
        n.push(_t381);
        i.set({
          commandName: r
        });
        i.bind("isEnabled").to(_t381);
        if (s) {
          i.bind("isOn").to(_t381, "value");
        }
      }
      i.set({
        withText: true
      });
      o.add(t);
    }
    var FP = n(55);
    var VP = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    VP.insert = "head";
    VP.singleton = true;
    var UP = rk()(FP["a"], VP);
    var HP = FP["a"].locals || {};
    var GP = /*#__PURE__*/function (_aC77) {
      _inherits(GP, _aC77);
      function GP() {
        _classCallCheck(this, GP);
        return _possibleConstructorReturn(this, _getPrototypeOf(GP).apply(this, arguments));
      }
      _createClass(GP, [{
        key: "init",
        value: function init() {
          var _this281 = this;
          var t = this.editor;
          var e = t.model;
          this.listenTo(e, "deleteContent", function (t, e) {
            return _this281._handleDeleteContent(t, e);
          }, {
            priority: "high"
          });
          this._defineSelectionConverter();
          this._enablePluginDisabling();
        }
      }, {
        key: "getSelectedTableCells",
        value: function getSelectedTableCells() {
          var t = this.editor.model.document.selection;
          var e = tN(t);
          if (e.length == 0) {
            return null;
          }
          return e;
        }
      }, {
        key: "getSelectionAsFragment",
        value: function getSelectionAsFragment() {
          var _this282 = this;
          var t = this.getSelectedTableCells();
          if (!t) {
            return null;
          }
          return this.editor.model.change(function (e) {
            var n = e.createDocumentFragment();
            var o = _this282.editor.plugins.get("TableUtils");
            var _iN3 = iN(t),
              i = _iN3.first,
              r = _iN3.last;
            var _oN2 = oN(t),
              s = _oN2.first,
              a = _oN2.last;
            var c = t[0].findAncestor("table");
            var l = a;
            var d = r;
            if (rN(t, o)) {
              var _t382 = {
                firstColumn: i,
                lastColumn: r,
                firstRow: s,
                lastRow: a
              };
              l = xN(c, _t382);
              d = DN(c, _t382);
            }
            var u = {
              startRow: s,
              startColumn: i,
              endRow: l,
              endColumn: d
            };
            var h = gN(c, u, e);
            e.insert(h, n, 0);
            return n;
          });
        }
      }, {
        key: "setCellSelection",
        value: function setCellSelection(t, e) {
          var n = this._getCellsToSelect(t, e);
          this.editor.model.change(function (t) {
            t.setSelection(n.cells.map(function (e) {
              return t.createRangeOn(e);
            }), {
              backward: n.backward
            });
          });
        }
      }, {
        key: "getFocusCell",
        value: function getFocusCell() {
          var t = this.editor.model.document.selection;
          var e = _toConsumableArray(t.getRanges()).pop();
          var n = e.getContainedElement();
          if (n && n.is("element", "tableCell")) {
            return n;
          }
          return null;
        }
      }, {
        key: "getAnchorCell",
        value: function getAnchorCell() {
          var t = this.editor.model.document.selection;
          var e = nC(t.getRanges());
          var n = e.getContainedElement();
          if (n && n.is("element", "tableCell")) {
            return n;
          }
          return null;
        }
      }, {
        key: "_defineSelectionConverter",
        value: function _defineSelectionConverter() {
          var _this283 = this;
          var t = this.editor;
          var e = new Set();
          t.conversion.for("editingDowncast").add(function (t) {
            return t.on("selection", function (t, o, i) {
              var r = i.writer;
              n(r);
              var s = _this283.getSelectedTableCells();
              if (!s) {
                return;
              }
              var _iterator449 = _createForOfIteratorHelper(s),
                _step449;
              try {
                for (_iterator449.s(); !(_step449 = _iterator449.n()).done;) {
                  var _t383 = _step449.value;
                  var _n300 = i.mapper.toViewElement(_t383);
                  r.addClass("ck-editor__editable_selected", _n300);
                  e.add(_n300);
                }
              } catch (err) {
                _iterator449.e(err);
              } finally {
                _iterator449.f();
              }
              var a = i.mapper.toViewElement(s[s.length - 1]);
              r.setSelection(a, 0);
            }, {
              priority: "lowest"
            });
          });
          function n(t) {
            var _iterator450 = _createForOfIteratorHelper(e),
              _step450;
            try {
              for (_iterator450.s(); !(_step450 = _iterator450.n()).done;) {
                var _n301 = _step450.value;
                t.removeClass("ck-editor__editable_selected", _n301);
              }
            } catch (err) {
              _iterator450.e(err);
            } finally {
              _iterator450.f();
            }
            e.clear();
          }
        }
      }, {
        key: "_enablePluginDisabling",
        value: function _enablePluginDisabling() {
          var _this284 = this;
          var t = this.editor;
          this.on("change:isEnabled", function () {
            if (!_this284.isEnabled) {
              var _e334 = _this284.getSelectedTableCells();
              if (!_e334) {
                return;
              }
              t.model.change(function (n) {
                var o = n.createPositionAt(_e334[0], 0);
                var i = t.model.schema.getNearestSelectionRange(o);
                n.setSelection(i);
              });
            }
          });
        }
      }, {
        key: "_handleDeleteContent",
        value: function _handleDeleteContent(t, e) {
          var _e335 = _slicedToArray(e, 2),
            n = _e335[0],
            o = _e335[1];
          var i = this.editor.model;
          var r = !o || o.direction == "backward";
          var s = tN(n);
          if (!s.length) {
            return;
          }
          t.stop();
          i.change(function (t) {
            var e = s[r ? s.length - 1 : 0];
            i.change(function (t) {
              var _iterator451 = _createForOfIteratorHelper(s),
                _step451;
              try {
                for (_iterator451.s(); !(_step451 = _iterator451.n()).done;) {
                  var _e336 = _step451.value;
                  i.deleteContent(t.createSelection(_e336, "in"));
                }
              } catch (err) {
                _iterator451.e(err);
              } finally {
                _iterator451.f();
              }
            });
            var o = i.schema.getNearestSelectionRange(t.createPositionAt(e, 0));
            if (n.is("documentSelection")) {
              t.setSelection(o);
            } else {
              n.setTo(o);
            }
          });
        }
      }, {
        key: "_getCellsToSelect",
        value: function _getCellsToSelect(t, e) {
          var n = this.editor.plugins.get("TableUtils");
          var o = n.getCellLocation(t);
          var i = n.getCellLocation(e);
          var r = Math.min(o.row, i.row);
          var s = Math.max(o.row, i.row);
          var a = Math.min(o.column, i.column);
          var c = Math.max(o.column, i.column);
          var l = new Array(s - r + 1).fill(null).map(function () {
            return [];
          });
          var d = {
            startRow: r,
            endRow: s,
            startColumn: a,
            endColumn: c
          };
          var _iterator452 = _createForOfIteratorHelper(new TI(t.findAncestor("table"), d)),
            _step452;
          try {
            for (_iterator452.s(); !(_step452 = _iterator452.n()).done;) {
              var _step452$value = _step452.value,
                _e337 = _step452$value.row,
                _n302 = _step452$value.cell;
              l[_e337 - r].push(_n302);
            }
          } catch (err) {
            _iterator452.e(err);
          } finally {
            _iterator452.f();
          }
          var u = i.row < o.row;
          var h = i.column < o.column;
          if (u) {
            l.reverse();
          }
          if (h) {
            l.forEach(function (t) {
              return t.reverse();
            });
          }
          return {
            cells: l.flat(),
            backward: u || h
          };
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableSelection";
        }
      }, {
        key: "requires",
        get: function get() {
          return [jN];
        }
      }]);
      return GP;
    }(aC);
    var WP = /*#__PURE__*/function (_aC78) {
      _inherits(WP, _aC78);
      function WP() {
        _classCallCheck(this, WP);
        return _possibleConstructorReturn(this, _getPrototypeOf(WP).apply(this, arguments));
      }
      _createClass(WP, [{
        key: "init",
        value: function init() {
          var _this285 = this;
          var t = this.editor;
          var e = t.editing.view.document;
          this.listenTo(e, "copy", function (t, e) {
            return _this285._onCopyCut(t, e);
          });
          this.listenTo(e, "cut", function (t, e) {
            return _this285._onCopyCut(t, e);
          });
          this.listenTo(t.model, "insertContent", function (t, e) {
            return _this285._onInsertContent.apply(_this285, [t].concat(_toConsumableArray(e)));
          }, {
            priority: "high"
          });
          this.decorate("_replaceTableSlotCell");
        }
      }, {
        key: "_onCopyCut",
        value: function _onCopyCut(t, e) {
          var n = this.editor.plugins.get(GP);
          if (!n.getSelectedTableCells()) {
            return;
          }
          if (t.name == "cut" && this.editor.isReadOnly) {
            return;
          }
          e.preventDefault();
          t.stop();
          var o = this.editor.data;
          var i = this.editor.editing.view.document;
          var r = o.toView(n.getSelectionAsFragment());
          i.fire("clipboardOutput", {
            dataTransfer: e.dataTransfer,
            content: r,
            method: t.name
          });
        }
      }, {
        key: "_onInsertContent",
        value: function _onInsertContent(t, e, n) {
          var _this286 = this;
          if (n && !n.is("documentSelection")) {
            return;
          }
          var o = this.editor.model;
          var i = this.editor.plugins.get(jN);
          var r = KP(e, o);
          if (!r) {
            return;
          }
          var s = nN(o.document.selection);
          if (!s.length) {
            yN(r, i);
            return;
          }
          t.stop();
          o.change(function (t) {
            var e = {
              width: i.getColumns(r),
              height: i.getRows(r)
            };
            var n = qP(s, e, t, i);
            var o = n.lastRow - n.firstRow + 1;
            var a = n.lastColumn - n.firstColumn + 1;
            var c = {
              startRow: 0,
              startColumn: 0,
              endRow: Math.min(o, e.height) - 1,
              endColumn: Math.min(a, e.width) - 1
            };
            r = gN(r, c, t);
            var l = s[0].findAncestor("table");
            var d = _this286._replaceSelectedCellsWithPasted(r, e, l, n, t);
            if (_this286.editor.plugins.get("TableSelection").isEnabled) {
              var _e338 = sN(d.map(function (e) {
                return t.createRangeOn(e);
              }));
              t.setSelection(_e338);
            } else {
              t.setSelection(d[0], 0);
            }
          });
        }
      }, {
        key: "_replaceSelectedCellsWithPasted",
        value: function _replaceSelectedCellsWithPasted(t, e, n, o, i) {
          var r = e.width,
            s = e.height;
          var a = QP(t, r, s);
          var c = _toConsumableArray(new TI(n, {
            startRow: o.firstRow,
            endRow: o.lastRow,
            startColumn: o.firstColumn,
            endColumn: o.lastColumn,
            includeAllSlots: true
          }));
          var l = [];
          var d;
          var _iterator453 = _createForOfIteratorHelper(c),
            _step453;
          try {
            for (_iterator453.s(); !(_step453 = _iterator453.n()).done;) {
              var _t386 = _step453.value;
              var _e341 = _t386.row,
                _n303 = _t386.column;
              if (_n303 === o.firstColumn) {
                d = _t386.getPositionBefore();
              }
              var _c25 = _e341 - o.firstRow;
              var _u7 = _n303 - o.firstColumn;
              var _h5 = a[_c25 % s][_u7 % r];
              var _f4 = _h5 ? i.cloneElement(_h5) : null;
              var _m2 = this._replaceTableSlotCell(_t386, _f4, d, i);
              if (!_m2) {
                continue;
              }
              CN(_m2, _e341, _n303, o.lastRow, o.lastColumn, i);
              l.push(_m2);
              d = i.createPositionAfter(_m2);
            }
          } catch (err) {
            _iterator453.e(err);
          } finally {
            _iterator453.f();
          }
          var u = parseInt(n.getAttribute("headingRows") || 0);
          var h = parseInt(n.getAttribute("headingColumns") || 0);
          var f = o.firstRow < u && u <= o.lastRow;
          var m = o.firstColumn < h && h <= o.lastColumn;
          if (f) {
            var _t384 = {
              first: o.firstColumn,
              last: o.lastColumn
            };
            var _e339 = ZP(n, u, _t384, i, o.firstRow);
            l.push.apply(l, _toConsumableArray(_e339));
          }
          if (m) {
            var _t385 = {
              first: o.firstRow,
              last: o.lastRow
            };
            var _e340 = JP(n, h, _t385, i);
            l.push.apply(l, _toConsumableArray(_e340));
          }
          return l;
        }
      }, {
        key: "_replaceTableSlotCell",
        value: function _replaceTableSlotCell(t, e, n, o) {
          var i = t.cell,
            r = t.isAnchor;
          if (r) {
            o.remove(i);
          }
          if (!e) {
            return null;
          }
          o.insert(e, n);
          return e;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableClipboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [GP, jN];
        }
      }]);
      return WP;
    }(aC);
    function KP(t, e) {
      if (!t.is("documentFragment") && !t.is("element")) {
        return null;
      }
      if (t.is("element", "table")) {
        return t;
      }
      if (t.childCount == 1 && t.getChild(0).is("element", "table")) {
        return t.getChild(0);
      }
      var n = e.createRangeIn(t);
      var _iterator454 = _createForOfIteratorHelper(n.getItems()),
        _step454;
      try {
        for (_iterator454.s(); !(_step454 = _iterator454.n()).done;) {
          var _t387 = _step454.value;
          if (_t387.is("element", "table")) {
            var _o216 = e.createRange(n.start, e.createPositionBefore(_t387));
            if (e.hasContent(_o216, {
              ignoreWhitespaces: true
            })) {
              return null;
            }
            var _i177 = e.createRange(e.createPositionAfter(_t387), n.end);
            if (e.hasContent(_i177, {
              ignoreWhitespaces: true
            })) {
              return null;
            }
            return _t387;
          }
        }
      } catch (err) {
        _iterator454.e(err);
      } finally {
        _iterator454.f();
      }
      return null;
    }
    function qP(t, e, n, o) {
      var i = t[0].findAncestor("table");
      var r = iN(t);
      var s = oN(t);
      var a = {
        firstColumn: r.first,
        lastColumn: r.last,
        firstRow: s.first,
        lastRow: s.last
      };
      var c = t.length === 1;
      if (c) {
        a.lastRow += e.height - 1;
        a.lastColumn += e.width - 1;
        YP(i, a.lastRow + 1, a.lastColumn + 1, o);
      }
      if (c || !rN(t, o)) {
        $P(i, a, n);
      } else {
        a.lastRow = xN(i, a);
        a.lastColumn = DN(i, a);
      }
      return a;
    }
    function YP(t, e, n, o) {
      var i = o.getColumns(t);
      var r = o.getRows(t);
      if (n > i) {
        o.insertColumns(t, {
          at: i,
          columns: n - i
        });
      }
      if (e > r) {
        o.insertRows(t, {
          at: r,
          rows: e - r
        });
      }
    }
    function QP(t, e, n) {
      var o = new Array(n).fill(null).map(function () {
        return new Array(e).fill(null);
      });
      var _iterator455 = _createForOfIteratorHelper(new TI(t)),
        _step455;
      try {
        for (_iterator455.s(); !(_step455 = _iterator455.n()).done;) {
          var _step455$value = _step455.value,
            _e342 = _step455$value.column,
            _n304 = _step455$value.row,
            _i178 = _step455$value.cell;
          o[_n304][_e342] = _i178;
        }
      } catch (err) {
        _iterator455.e(err);
      } finally {
        _iterator455.f();
      }
      return o;
    }
    function $P(t, e, n) {
      var o = e.firstRow,
        i = e.lastRow,
        r = e.firstColumn,
        s = e.lastColumn;
      var a = {
        first: o,
        last: i
      };
      var c = {
        first: r,
        last: s
      };
      JP(t, r, a, n);
      JP(t, s + 1, a, n);
      ZP(t, o, c, n);
      ZP(t, i + 1, c, n, o);
    }
    function ZP(t, e, n, o) {
      var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      if (e < 1) {
        return;
      }
      var r = pN(t, e, i);
      var s = r.filter(function (_ref61) {
        var t = _ref61.column,
          e = _ref61.cellWidth;
        return XP(t, e, n);
      });
      return s.map(function (_ref62) {
        var t = _ref62.cell;
        return kN(t, e, o);
      });
    }
    function JP(t, e, n, o) {
      if (e < 1) {
        return;
      }
      var i = bN(t, e);
      var r = i.filter(function (_ref63) {
        var t = _ref63.row,
          e = _ref63.cellHeight;
        return XP(t, e, n);
      });
      return r.map(function (_ref64) {
        var t = _ref64.cell,
          n = _ref64.column;
        return wN(t, n, e, o);
      });
    }
    function XP(t, e, n) {
      var o = t + e - 1;
      var i = n.first,
        r = n.last;
      var s = t >= i && t <= r;
      var a = t < i && o >= i;
      return s || a;
    }
    var tB = /*#__PURE__*/function (_aC79) {
      _inherits(tB, _aC79);
      function tB() {
        _classCallCheck(this, tB);
        return _possibleConstructorReturn(this, _getPrototypeOf(tB).apply(this, arguments));
      }
      _createClass(tB, [{
        key: "init",
        value: function init() {
          var _this287 = this;
          var t = this.editor.editing.view;
          var e = t.document;
          this.editor.keystrokes.set("Tab", function () {
            return _this287._handleTabOnSelectedTable.apply(_this287, arguments);
          }, {
            priority: "low"
          });
          this.editor.keystrokes.set("Tab", this._getTabHandler(true), {
            priority: "low"
          });
          this.editor.keystrokes.set("Shift+Tab", this._getTabHandler(false), {
            priority: "low"
          });
          this.listenTo(e, "keydown", function () {
            return _this287._onKeydown.apply(_this287, arguments);
          }, {
            priority: is.get("high") - 10
          });
        }
      }, {
        key: "_handleTabOnSelectedTable",
        value: function _handleTabOnSelectedTable(t, e) {
          var n = this.editor;
          var o = n.model.document.selection;
          var i = o.getSelectedElement();
          if (!i || !i.is("element", "table")) {
            return;
          }
          e();
          n.model.change(function (t) {
            t.setSelection(t.createRangeIn(i.getChild(0).getChild(0)));
          });
        }
      }, {
        key: "_getTabHandler",
        value: function _getTabHandler(t) {
          var _this288 = this;
          var e = this.editor;
          return function (n, o) {
            var i = e.model.document.selection;
            var r = eN(i)[0];
            if (!r) {
              r = _this288.editor.plugins.get("TableSelection").getFocusCell();
            }
            if (!r) {
              return;
            }
            o();
            var s = r.parent;
            var a = s.parent;
            var c = a.getChildIndex(s);
            var l = s.getChildIndex(r);
            var d = l === 0;
            if (!t && d && c === 0) {
              e.model.change(function (t) {
                t.setSelection(t.createRangeOn(a));
              });
              return;
            }
            var u = l === s.childCount - 1;
            var h = c === a.childCount - 1;
            if (t && h && u) {
              e.execute("insertTableRowBelow");
              if (c === a.childCount - 1) {
                e.model.change(function (t) {
                  t.setSelection(t.createRangeOn(a));
                });
                return;
              }
            }
            var f;
            if (t && u) {
              var _t388 = a.getChild(c + 1);
              f = _t388.getChild(0);
            } else if (!t && d) {
              var _t389 = a.getChild(c - 1);
              f = _t389.getChild(_t389.childCount - 1);
            } else {
              f = s.getChild(l + (t ? 1 : -1));
            }
            e.model.change(function (t) {
              t.setSelection(t.createRangeIn(f));
            });
          };
        }
      }, {
        key: "_onKeydown",
        value: function _onKeydown(t, e) {
          var n = this.editor;
          var o = e.keyCode;
          if (!Fl(o)) {
            return;
          }
          var i = Vl(o, n.locale.contentLanguageDirection);
          var r = this._handleArrowKeys(i, e.shiftKey);
          if (r) {
            e.preventDefault();
            e.stopPropagation();
            t.stop();
          }
        }
      }, {
        key: "_handleArrowKeys",
        value: function _handleArrowKeys(t, e) {
          var n = this.editor.model;
          var o = n.document.selection;
          var i = ["right", "down"].includes(t);
          var r = tN(o);
          if (r.length) {
            var _n305;
            if (e) {
              _n305 = this.editor.plugins.get("TableSelection").getFocusCell();
            } else {
              _n305 = i ? r[r.length - 1] : r[0];
            }
            this._navigateFromCellInDirection(_n305, t, e);
            return true;
          }
          var s = o.focus.findAncestor("tableCell");
          if (!s) {
            return false;
          }
          if (e && !o.isCollapsed && o.isBackward == i) {
            return false;
          }
          if (this._isSelectionAtCellEdge(o, s, i)) {
            this._navigateFromCellInDirection(s, t, e);
            return true;
          }
          return false;
        }
      }, {
        key: "_isSelectionAtCellEdge",
        value: function _isSelectionAtCellEdge(t, e, n) {
          var o = this.editor.model;
          var i = this.editor.model.schema;
          var r = n ? t.getLastPosition() : t.getFirstPosition();
          if (!i.getLimitElement(r).is("element", "tableCell")) {
            var _t390 = o.createPositionAt(e, n ? "end" : 0);
            return _t390.isTouching(r);
          }
          var s = o.createSelection(r);
          o.modifySelection(s, {
            direction: n ? "forward" : "backward"
          });
          return r.isEqual(s.focus);
        }
      }, {
        key: "_navigateFromCellInDirection",
        value: function _navigateFromCellInDirection(t, e) {
          var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var o = this.editor.model;
          var i = t.findAncestor("table");
          var r = _toConsumableArray(new TI(i, {
            includeAllSlots: true
          }));
          var _r78 = r[r.length - 1],
            s = _r78.row,
            a = _r78.column;
          var c = r.find(function (_ref65) {
            var e = _ref65.cell;
            return e == t;
          });
          var l = c.row,
            d = c.column;
          switch (e) {
            case "left":
              d--;
              break;
            case "up":
              l--;
              break;
            case "right":
              d += c.cellWidth;
              break;
            case "down":
              l += c.cellHeight;
              break;
          }
          var u = l < 0 || l > s;
          var h = d < 0 && l <= 0;
          var f = d > a && l >= s;
          if (u || h || f) {
            o.change(function (t) {
              t.setSelection(t.createRangeOn(i));
            });
            return;
          }
          if (d < 0) {
            d = n ? 0 : a;
            l--;
          } else if (d > a) {
            d = n ? a : 0;
            l++;
          }
          var m = r.find(function (t) {
            return t.row == l && t.column == d;
          }).cell;
          var g = ["right", "down"].includes(e);
          var p = this.editor.plugins.get("TableSelection");
          if (n && p.isEnabled) {
            var _e343 = p.getAnchorCell() || t;
            p.setCellSelection(_e343, m);
          } else {
            var _t391 = o.createPositionAt(m, g ? 0 : "end");
            o.change(function (e) {
              e.setSelection(_t391);
            });
          }
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableKeyboard";
        }
      }, {
        key: "requires",
        get: function get() {
          return [GP];
        }
      }]);
      return tB;
    }(aC);
    var eB = /*#__PURE__*/function (_nh8) {
      _inherits(eB, _nh8);
      function eB(t) {
        var _this289;
        _classCallCheck(this, eB);
        _this289 = _possibleConstructorReturn(this, _getPrototypeOf(eB).call(this, t));
        _this289.domEventType = ["mousemove", "mouseup", "mouseleave"];
        return _this289;
      }
      _createClass(eB, [{
        key: "onDomEvent",
        value: function onDomEvent(t) {
          this.fire(t.type, t);
        }
      }]);
      return eB;
    }(nh);
    var nB = /*#__PURE__*/function (_aC80) {
      _inherits(nB, _aC80);
      function nB() {
        _classCallCheck(this, nB);
        return _possibleConstructorReturn(this, _getPrototypeOf(nB).apply(this, arguments));
      }
      _createClass(nB, [{
        key: "init",
        value: function init() {
          var t = this.editor;
          t.editing.view.addObserver(eB);
          this._enableShiftClickSelection();
          this._enableMouseDragSelection();
        }
      }, {
        key: "_enableShiftClickSelection",
        value: function _enableShiftClickSelection() {
          var _this290 = this;
          var t = this.editor;
          var e = false;
          var n = t.plugins.get(GP);
          this.listenTo(t.editing.view.document, "mousedown", function (o, i) {
            if (!_this290.isEnabled || !n.isEnabled) {
              return;
            }
            if (!i.domEvent.shiftKey) {
              return;
            }
            var r = n.getAnchorCell() || eN(t.model.document.selection)[0];
            if (!r) {
              return;
            }
            var s = _this290._getModelTableCellFromDomEvent(i);
            if (s && oB(r, s)) {
              e = true;
              n.setCellSelection(r, s);
              i.preventDefault();
            }
          });
          this.listenTo(t.editing.view.document, "mouseup", function () {
            e = false;
          });
          this.listenTo(t.editing.view.document, "selectionChange", function (t) {
            if (e) {
              t.stop();
            }
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_enableMouseDragSelection",
        value: function _enableMouseDragSelection() {
          var _this291 = this;
          var t = this.editor;
          var e, n;
          var o = false;
          var i = false;
          var r = t.plugins.get(GP);
          this.listenTo(t.editing.view.document, "mousedown", function (t, n) {
            if (!_this291.isEnabled || !r.isEnabled) {
              return;
            }
            if (n.domEvent.shiftKey || n.domEvent.ctrlKey || n.domEvent.altKey) {
              return;
            }
            e = _this291._getModelTableCellFromDomEvent(n);
          });
          this.listenTo(t.editing.view.document, "mousemove", function (t, s) {
            if (!s.domEvent.buttons) {
              return;
            }
            if (!e) {
              return;
            }
            var a = _this291._getModelTableCellFromDomEvent(s);
            if (a && oB(e, a)) {
              n = a;
              if (!o && n != e) {
                o = true;
              }
            }
            if (!o) {
              return;
            }
            i = true;
            r.setCellSelection(e, n);
            s.preventDefault();
          });
          this.listenTo(t.editing.view.document, "mouseup", function () {
            o = false;
            i = false;
            e = null;
            n = null;
          });
          this.listenTo(t.editing.view.document, "selectionChange", function (t) {
            if (i) {
              t.stop();
            }
          }, {
            priority: "highest"
          });
        }
      }, {
        key: "_getModelTableCellFromDomEvent",
        value: function _getModelTableCellFromDomEvent(t) {
          var e = t.target;
          var n = this.editor.editing.view.createPositionAt(e, 0);
          var o = this.editor.editing.mapper.toModelPosition(n);
          var i = o.parent;
          return i.findAncestor("tableCell", {
            includeSelf: true
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "TableMouse";
        }
      }, {
        key: "requires",
        get: function get() {
          return [GP];
        }
      }]);
      return nB;
    }(aC);
    function oB(t, e) {
      return t.parent.parent == e.parent.parent;
    }
    var iB = n(56);
    var rB = {
      injectType: "singletonStyleTag",
      attributes: {
        "data-cke": true
      }
    };
    rB.insert = "head";
    rB.singleton = true;
    var sB = rk()(iB["a"], rB);
    var aB = iB["a"].locals || {};
    var cB = /*#__PURE__*/function (_aC81) {
      _inherits(cB, _aC81);
      function cB() {
        _classCallCheck(this, cB);
        return _possibleConstructorReturn(this, _getPrototypeOf(cB).apply(this, arguments));
      }
      _createClass(cB, null, [{
        key: "requires",
        get: function get() {
          return [_P, RP, GP, nB, tB, WP, Sx];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Table";
        }
      }]);
      return cB;
    }(aC);
    function lB(t) {
      var e = t.getSelectedElement();
      if (e && uB(e)) {
        return e;
      }
      return null;
    }
    function dB(t) {
      var e = hB("table", t.getFirstPosition());
      if (e && uB(e.parent)) {
        return e.parent;
      }
      return null;
    }
    function uB(t) {
      return !!t.getCustomProperty("table") && iA(t);
    }
    function hB(t, e) {
      var n = e.parent;
      while (n) {
        if (n.name === t) {
          return n;
        }
        n = n.parent;
      }
    }
    var fB = /*#__PURE__*/function (_aC82) {
      _inherits(fB, _aC82);
      function fB() {
        _classCallCheck(this, fB);
        return _possibleConstructorReturn(this, _getPrototypeOf(fB).apply(this, arguments));
      }
      _createClass(fB, [{
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor;
          var e = t.t;
          var n = t.plugins.get(WE);
          var o = t.config.get("table.contentToolbar");
          var i = t.config.get("table.tableToolbar");
          if (o) {
            n.register("tableContent", {
              ariaLabel: e("Table toolbar"),
              items: o,
              getRelatedElement: dB
            });
          }
          if (i) {
            n.register("table", {
              ariaLabel: e("Table toolbar"),
              items: i,
              getRelatedElement: lB
            });
          }
        }
      }], [{
        key: "requires",
        get: function get() {
          return [WE];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "TableToolbar";
        }
      }]);
      return fB;
    }(aC);
    var mB = /[\\^$.*+?()[\]{}|]/g,
      gB = RegExp(mB.source);
    function pB(t) {
      t = _a(t);
      return t && gB.test(t) ? t.replace(mB, "\\$&") : t;
    }
    var kB = pB;
    var bB = {
      copyright: {
        from: "(c)",
        to: "©"
      },
      registeredTrademark: {
        from: "(r)",
        to: "®"
      },
      trademark: {
        from: "(tm)",
        to: "™"
      },
      oneHalf: {
        from: "1/2",
        to: "½"
      },
      oneThird: {
        from: "1/3",
        to: "⅓"
      },
      twoThirds: {
        from: "2/3",
        to: "⅔"
      },
      oneForth: {
        from: "1/4",
        to: "¼"
      },
      threeQuarters: {
        from: "3/4",
        to: "¾"
      },
      lessThanOrEqual: {
        from: "<=",
        to: "≤"
      },
      greaterThanOrEqual: {
        from: ">=",
        to: "≥"
      },
      notEqual: {
        from: "!=",
        to: "≠"
      },
      arrowLeft: {
        from: "<-",
        to: "←"
      },
      arrowRight: {
        from: "->",
        to: "→"
      },
      horizontalEllipsis: {
        from: "...",
        to: "…"
      },
      enDash: {
        from: /(^| )(--)( )$/,
        to: [null, "–", null]
      },
      emDash: {
        from: /(^| )(---)( )$/,
        to: [null, "—", null]
      },
      quotesPrimary: {
        from: xB('"'),
        to: [null, "“", null, "”"]
      },
      quotesSecondary: {
        from: xB("'"),
        to: [null, "‘", null, "’"]
      },
      quotesPrimaryEnGb: {
        from: xB("'"),
        to: [null, "‘", null, "’"]
      },
      quotesSecondaryEnGb: {
        from: xB('"'),
        to: [null, "“", null, "”"]
      },
      quotesPrimaryPl: {
        from: xB('"'),
        to: [null, "„", null, "”"]
      },
      quotesSecondaryPl: {
        from: xB("'"),
        to: [null, "‚", null, "’"]
      }
    };
    var wB = {
      symbols: ["copyright", "registeredTrademark", "trademark"],
      mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"],
      typography: ["horizontalEllipsis", "enDash", "emDash"],
      quotes: ["quotesPrimary", "quotesSecondary"]
    };
    var CB = ["symbols", "mathematical", "typography", "quotes"];
    var AB = /*#__PURE__*/function (_aC83) {
      _inherits(AB, _aC83);
      _createClass(AB, null, [{
        key: "pluginName",
        get: function get() {
          return "TextTransformation";
        }
      }]);
      function AB(t) {
        var _this292;
        _classCallCheck(this, AB);
        _this292 = _possibleConstructorReturn(this, _getPrototypeOf(AB).call(this, t));
        t.config.define("typing", {
          transformations: {
            include: CB
          }
        });
        return _this292;
      }
      _createClass(AB, [{
        key: "init",
        value: function init() {
          var _this293 = this;
          var t = this.editor.model;
          var e = t.document.selection;
          e.on("change:range", function () {
            _this293.isEnabled = !e.anchor.parent.is("element", "codeBlock");
          });
          this._enableTransformationWatchers();
        }
      }, {
        key: "_enableTransformationWatchers",
        value: function _enableTransformationWatchers() {
          var t = this.editor;
          var e = t.model;
          var n = t.plugins.get("Input");
          var o = DB(t.config.get("typing.transformations"));
          var i = function i(t) {
            var _iterator456 = _createForOfIteratorHelper(o),
              _step456;
            try {
              for (_iterator456.s(); !(_step456 = _iterator456.n()).done;) {
                var _e344 = _step456.value;
                var _n306 = _e344.from;
                var _o217 = _n306.test(t);
                if (_o217) {
                  return {
                    normalizedTransformation: _e344
                  };
                }
              }
            } catch (err) {
              _iterator456.e(err);
            } finally {
              _iterator456.f();
            }
          };
          var r = function r(t, o) {
            if (!n.isInput(o.batch)) {
              return;
            }
            var _o$normalizedTransfor = o.normalizedTransformation,
              i = _o$normalizedTransfor.from,
              r = _o$normalizedTransfor.to;
            var s = i.exec(o.text);
            var a = r(s.slice(1));
            var c = o.range;
            var l = s.index;
            e.enqueueChange(function (t) {
              for (var _n307 = 1; _n307 < s.length; _n307++) {
                var _o218 = s[_n307];
                var _i179 = a[_n307 - 1];
                if (_i179 == null) {
                  l += _o218.length;
                  continue;
                }
                var _r79 = c.start.getShiftedBy(l);
                var _d11 = e.createRange(_r79, _r79.getShiftedBy(_o218.length));
                var _u8 = yB(_r79);
                e.insertContent(t.createText(_i179, _u8), _d11);
                l += _i179.length;
              }
            });
          };
          var s = new mS(t.model, i);
          s.on("matched:data", r);
          s.bind("isEnabled").to(this);
        }
      }]);
      return AB;
    }(aC);
    function _B(t) {
      if (typeof t == "string") {
        return new RegExp("(".concat(kB(t), ")$"));
      }
      return t;
    }
    function vB(t) {
      if (typeof t == "string") {
        return function () {
          return [t];
        };
      } else if (t instanceof Array) {
        return function () {
          return t;
        };
      }
      return t;
    }
    function yB(t) {
      var e = t.textNode ? t.textNode : t.nodeAfter;
      return e.getAttributes();
    }
    function xB(t) {
      return new RegExp("(^|\\s)(".concat(t, ")([^").concat(t, "]*)(").concat(t, ")$"));
    }
    function DB(t) {
      var e = t.extra || [];
      var n = t.remove || [];
      var o = function o(t) {
        return !n.includes(t);
      };
      var i = t.include.concat(e).filter(o);
      return EB(i).filter(o).map(function (t) {
        return bB[t] || t;
      }).map(function (t) {
        return {
          from: _B(t.from),
          to: vB(t.to)
        };
      });
    }
    function EB(t) {
      var e = new Set();
      var _iterator457 = _createForOfIteratorHelper(t),
        _step457;
      try {
        for (_iterator457.s(); !(_step457 = _iterator457.n()).done;) {
          var _n308 = _step457.value;
          if (wB[_n308]) {
            var _iterator458 = _createForOfIteratorHelper(wB[_n308]),
              _step458;
            try {
              for (_iterator458.s(); !(_step458 = _iterator458.n()).done;) {
                var _t392 = _step458.value;
                e.add(_t392);
              }
            } catch (err) {
              _iterator458.e(err);
            } finally {
              _iterator458.f();
            }
          } else {
            e.add(_n308);
          }
        }
      } catch (err) {
        _iterator457.e(err);
      } finally {
        _iterator457.f();
      }
      return Array.from(e);
    }
    var MB = /*#__PURE__*/function (_tC) {
      _inherits(MB, _tC);
      function MB() {
        _classCallCheck(this, MB);
        return _possibleConstructorReturn(this, _getPrototypeOf(MB).apply(this, arguments));
      }
      return MB;
    }(tC);
    MB.builtinPlugins = [lC, yC, IC, $v, Yv, Hy, rx, SD, GD, yE, GE, QE, LM, UM, YM, _S, aT, jT, qy, _I, cB, fB, AB];
    var SB = e["default"] = MB;
  }])["default"];
});